import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetchData } from '../graphQLRequestServer';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
};

export type GQLAdnetworkTrackingSettings = {
  __typename?: 'AdnetworkTrackingSettings';
  adNetworkId?: Maybe<Scalars['Int']>;
  category?: Maybe<GQLCategories>;
  categoryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  crossNetworkEventsEnabled?: Maybe<Scalars['Boolean']>;
  domainIds?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  network?: Maybe<GQLAdvertisingNetworks>;
  settings?: Maybe<Scalars['JSON']>;
  ts?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
};


export type GQLAdnetworkTrackingSettingsCategoryArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLAdnetworkTrackingSettingsNetworkArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAdvertisingNetworksPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAdvertisingNetworksPropertiesEnum>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLAdnetworkTrackingSettingsPropertiesEnum {
  AdNetworkId = 'adNetworkId',
  CategoryId = 'categoryId',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  CrossNetworkEventsEnabled = 'crossNetworkEventsEnabled',
  DomainIds = 'domainIds',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  Settings = 'settings',
  Ts = 'ts',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy'
}

export type GQLAdvertisingNetworks = {
  __typename?: 'AdvertisingNetworks';
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export enum GQLAdvertisingNetworksPropertiesEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  Name = 'name',
  Slug = 'slug',
  UpdatedAt = 'updatedAt'
}

export type GQLAffiliateLinks = {
  __typename?: 'AffiliateLinks';
  affiliateProviderOfferId?: Maybe<Scalars['String']>;
  buyerAffiliateProviderId?: Maybe<Scalars['Int']>;
  buyerId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  defaultOffer?: Maybe<GQLOffers>;
  defaultPayout?: Maybe<Scalars['Float']>;
  factors?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  link?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  offer?: Maybe<GQLOffers>;
  offerId?: Maybe<Scalars['Int']>;
  oldPrice?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  userCreated?: Maybe<GQLUsers>;
  userUpdated?: Maybe<GQLUsers>;
  weight?: Maybe<Scalars['Int']>;
};


export type GQLAffiliateLinksDefaultOfferArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checkWallet?: InputMaybe<Scalars['Boolean']>;
  checkWalletAny?: InputMaybe<Scalars['Boolean']>;
  checkWalletContain?: InputMaybe<Scalars['Boolean']>;
  checkWalletEq?: InputMaybe<Scalars['Boolean']>;
  checkWalletGt?: InputMaybe<Scalars['Boolean']>;
  checkWalletGte?: InputMaybe<Scalars['Boolean']>;
  checkWalletIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  checkWalletIsNull?: InputMaybe<Scalars['Boolean']>;
  checkWalletLike?: InputMaybe<Scalars['Boolean']>;
  checkWalletLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  checkWalletLt?: InputMaybe<Scalars['Boolean']>;
  checkWalletLte?: InputMaybe<Scalars['Boolean']>;
  checkWalletNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultAffiliateLinkId?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdAny?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdContain?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdEq?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  defaultAffiliateLinkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultAffiliateLinkIdLike?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrl?: InputMaybe<Scalars['String']>;
  displayUrlAny?: InputMaybe<Scalars['String']>;
  displayUrlContain?: InputMaybe<Scalars['String']>;
  displayUrlEq?: InputMaybe<Scalars['String']>;
  displayUrlGt?: InputMaybe<Scalars['String']>;
  displayUrlGte?: InputMaybe<Scalars['String']>;
  displayUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  displayUrlLike?: InputMaybe<Scalars['String']>;
  displayUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  displayUrlLt?: InputMaybe<Scalars['String']>;
  displayUrlLte?: InputMaybe<Scalars['String']>;
  displayUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalData?: InputMaybe<Scalars['JSON']>;
  externalDataAny?: InputMaybe<Scalars['JSON']>;
  externalDataContain?: InputMaybe<Scalars['JSON']>;
  externalDataEq?: InputMaybe<Scalars['JSON']>;
  externalDataGt?: InputMaybe<Scalars['JSON']>;
  externalDataGte?: InputMaybe<Scalars['JSON']>;
  externalDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  externalDataIsNull?: InputMaybe<Scalars['Boolean']>;
  externalDataLike?: InputMaybe<Scalars['JSON']>;
  externalDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  externalDataLt?: InputMaybe<Scalars['JSON']>;
  externalDataLte?: InputMaybe<Scalars['JSON']>;
  externalDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  featuresListTitle?: InputMaybe<Scalars['String']>;
  featuresListTitleAny?: InputMaybe<Scalars['String']>;
  featuresListTitleContain?: InputMaybe<Scalars['String']>;
  featuresListTitleEq?: InputMaybe<Scalars['String']>;
  featuresListTitleGt?: InputMaybe<Scalars['String']>;
  featuresListTitleGte?: InputMaybe<Scalars['String']>;
  featuresListTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuresListTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  featuresListTitleLike?: InputMaybe<Scalars['String']>;
  featuresListTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  featuresListTitleLt?: InputMaybe<Scalars['String']>;
  featuresListTitleLte?: InputMaybe<Scalars['String']>;
  featuresListTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  isPausedAny?: InputMaybe<Scalars['Boolean']>;
  isPausedContain?: InputMaybe<Scalars['Boolean']>;
  isPausedEq?: InputMaybe<Scalars['Boolean']>;
  isPausedGt?: InputMaybe<Scalars['Boolean']>;
  isPausedGte?: InputMaybe<Scalars['Boolean']>;
  isPausedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPausedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPausedLike?: InputMaybe<Scalars['Boolean']>;
  isPausedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPausedLt?: InputMaybe<Scalars['Boolean']>;
  isPausedLte?: InputMaybe<Scalars['Boolean']>;
  isPausedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldOverview?: InputMaybe<Scalars['String']>;
  oldOverviewAny?: InputMaybe<Scalars['String']>;
  oldOverviewContain?: InputMaybe<Scalars['String']>;
  oldOverviewEq?: InputMaybe<Scalars['String']>;
  oldOverviewGt?: InputMaybe<Scalars['String']>;
  oldOverviewGte?: InputMaybe<Scalars['String']>;
  oldOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  oldOverviewLike?: InputMaybe<Scalars['String']>;
  oldOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  oldOverviewLt?: InputMaybe<Scalars['String']>;
  oldOverviewLte?: InputMaybe<Scalars['String']>;
  oldOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOffersPropertiesEnum>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescription?: InputMaybe<Scalars['String']>;
  previewDescriptionAny?: InputMaybe<Scalars['String']>;
  previewDescriptionContain?: InputMaybe<Scalars['String']>;
  previewDescriptionEq?: InputMaybe<Scalars['String']>;
  previewDescriptionGt?: InputMaybe<Scalars['String']>;
  previewDescriptionGte?: InputMaybe<Scalars['String']>;
  previewDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  previewDescriptionLike?: InputMaybe<Scalars['String']>;
  previewDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  previewDescriptionLt?: InputMaybe<Scalars['String']>;
  previewDescriptionLte?: InputMaybe<Scalars['String']>;
  previewDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverview?: InputMaybe<Scalars['String']>;
  quickOverviewAny?: InputMaybe<Scalars['String']>;
  quickOverviewContain?: InputMaybe<Scalars['String']>;
  quickOverviewEq?: InputMaybe<Scalars['String']>;
  quickOverviewGt?: InputMaybe<Scalars['String']>;
  quickOverviewGte?: InputMaybe<Scalars['String']>;
  quickOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  quickOverviewLike?: InputMaybe<Scalars['String']>;
  quickOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  quickOverviewLt?: InputMaybe<Scalars['String']>;
  quickOverviewLte?: InputMaybe<Scalars['String']>;
  quickOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  score?: InputMaybe<Scalars['Float']>;
  scoreAny?: InputMaybe<Scalars['Float']>;
  scoreContain?: InputMaybe<Scalars['Float']>;
  scoreEq?: InputMaybe<Scalars['Float']>;
  scoreGt?: InputMaybe<Scalars['Float']>;
  scoreGte?: InputMaybe<Scalars['Float']>;
  scoreIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  scoreIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreLike?: InputMaybe<Scalars['Float']>;
  scoreLikeNoCase?: InputMaybe<Scalars['Float']>;
  scoreLt?: InputMaybe<Scalars['Float']>;
  scoreLte?: InputMaybe<Scalars['Float']>;
  scoreMessage?: InputMaybe<Scalars['String']>;
  scoreMessageAny?: InputMaybe<Scalars['String']>;
  scoreMessageContain?: InputMaybe<Scalars['String']>;
  scoreMessageEq?: InputMaybe<Scalars['String']>;
  scoreMessageGt?: InputMaybe<Scalars['String']>;
  scoreMessageGte?: InputMaybe<Scalars['String']>;
  scoreMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreMessageLike?: InputMaybe<Scalars['String']>;
  scoreMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  scoreMessageLt?: InputMaybe<Scalars['String']>;
  scoreMessageLte?: InputMaybe<Scalars['String']>;
  scoreMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleAny?: InputMaybe<Scalars['String']>;
  subTitleContain?: InputMaybe<Scalars['String']>;
  subTitleEq?: InputMaybe<Scalars['String']>;
  subTitleGt?: InputMaybe<Scalars['String']>;
  subTitleGte?: InputMaybe<Scalars['String']>;
  subTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subTitleLike?: InputMaybe<Scalars['String']>;
  subTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subTitleLt?: InputMaybe<Scalars['String']>;
  subTitleLte?: InputMaybe<Scalars['String']>;
  subTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescription?: InputMaybe<Scalars['String']>;
  summaryDescriptionAny?: InputMaybe<Scalars['String']>;
  summaryDescriptionContain?: InputMaybe<Scalars['String']>;
  summaryDescriptionEq?: InputMaybe<Scalars['String']>;
  summaryDescriptionGt?: InputMaybe<Scalars['String']>;
  summaryDescriptionGte?: InputMaybe<Scalars['String']>;
  summaryDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryDescriptionLike?: InputMaybe<Scalars['String']>;
  summaryDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryDescriptionLt?: InputMaybe<Scalars['String']>;
  summaryDescriptionLte?: InputMaybe<Scalars['String']>;
  summaryDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitle?: InputMaybe<Scalars['String']>;
  summaryTitleAny?: InputMaybe<Scalars['String']>;
  summaryTitleContain?: InputMaybe<Scalars['String']>;
  summaryTitleEq?: InputMaybe<Scalars['String']>;
  summaryTitleGt?: InputMaybe<Scalars['String']>;
  summaryTitleGte?: InputMaybe<Scalars['String']>;
  summaryTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryTitleLike?: InputMaybe<Scalars['String']>;
  summaryTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryTitleLt?: InputMaybe<Scalars['String']>;
  summaryTitleLte?: InputMaybe<Scalars['String']>;
  summaryTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLAffiliateLinksOfferArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checkWallet?: InputMaybe<Scalars['Boolean']>;
  checkWalletAny?: InputMaybe<Scalars['Boolean']>;
  checkWalletContain?: InputMaybe<Scalars['Boolean']>;
  checkWalletEq?: InputMaybe<Scalars['Boolean']>;
  checkWalletGt?: InputMaybe<Scalars['Boolean']>;
  checkWalletGte?: InputMaybe<Scalars['Boolean']>;
  checkWalletIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  checkWalletIsNull?: InputMaybe<Scalars['Boolean']>;
  checkWalletLike?: InputMaybe<Scalars['Boolean']>;
  checkWalletLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  checkWalletLt?: InputMaybe<Scalars['Boolean']>;
  checkWalletLte?: InputMaybe<Scalars['Boolean']>;
  checkWalletNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultAffiliateLinkId?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdAny?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdContain?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdEq?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  defaultAffiliateLinkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultAffiliateLinkIdLike?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrl?: InputMaybe<Scalars['String']>;
  displayUrlAny?: InputMaybe<Scalars['String']>;
  displayUrlContain?: InputMaybe<Scalars['String']>;
  displayUrlEq?: InputMaybe<Scalars['String']>;
  displayUrlGt?: InputMaybe<Scalars['String']>;
  displayUrlGte?: InputMaybe<Scalars['String']>;
  displayUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  displayUrlLike?: InputMaybe<Scalars['String']>;
  displayUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  displayUrlLt?: InputMaybe<Scalars['String']>;
  displayUrlLte?: InputMaybe<Scalars['String']>;
  displayUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalData?: InputMaybe<Scalars['JSON']>;
  externalDataAny?: InputMaybe<Scalars['JSON']>;
  externalDataContain?: InputMaybe<Scalars['JSON']>;
  externalDataEq?: InputMaybe<Scalars['JSON']>;
  externalDataGt?: InputMaybe<Scalars['JSON']>;
  externalDataGte?: InputMaybe<Scalars['JSON']>;
  externalDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  externalDataIsNull?: InputMaybe<Scalars['Boolean']>;
  externalDataLike?: InputMaybe<Scalars['JSON']>;
  externalDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  externalDataLt?: InputMaybe<Scalars['JSON']>;
  externalDataLte?: InputMaybe<Scalars['JSON']>;
  externalDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  featuresListTitle?: InputMaybe<Scalars['String']>;
  featuresListTitleAny?: InputMaybe<Scalars['String']>;
  featuresListTitleContain?: InputMaybe<Scalars['String']>;
  featuresListTitleEq?: InputMaybe<Scalars['String']>;
  featuresListTitleGt?: InputMaybe<Scalars['String']>;
  featuresListTitleGte?: InputMaybe<Scalars['String']>;
  featuresListTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuresListTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  featuresListTitleLike?: InputMaybe<Scalars['String']>;
  featuresListTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  featuresListTitleLt?: InputMaybe<Scalars['String']>;
  featuresListTitleLte?: InputMaybe<Scalars['String']>;
  featuresListTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  isPausedAny?: InputMaybe<Scalars['Boolean']>;
  isPausedContain?: InputMaybe<Scalars['Boolean']>;
  isPausedEq?: InputMaybe<Scalars['Boolean']>;
  isPausedGt?: InputMaybe<Scalars['Boolean']>;
  isPausedGte?: InputMaybe<Scalars['Boolean']>;
  isPausedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPausedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPausedLike?: InputMaybe<Scalars['Boolean']>;
  isPausedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPausedLt?: InputMaybe<Scalars['Boolean']>;
  isPausedLte?: InputMaybe<Scalars['Boolean']>;
  isPausedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldOverview?: InputMaybe<Scalars['String']>;
  oldOverviewAny?: InputMaybe<Scalars['String']>;
  oldOverviewContain?: InputMaybe<Scalars['String']>;
  oldOverviewEq?: InputMaybe<Scalars['String']>;
  oldOverviewGt?: InputMaybe<Scalars['String']>;
  oldOverviewGte?: InputMaybe<Scalars['String']>;
  oldOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  oldOverviewLike?: InputMaybe<Scalars['String']>;
  oldOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  oldOverviewLt?: InputMaybe<Scalars['String']>;
  oldOverviewLte?: InputMaybe<Scalars['String']>;
  oldOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOffersPropertiesEnum>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescription?: InputMaybe<Scalars['String']>;
  previewDescriptionAny?: InputMaybe<Scalars['String']>;
  previewDescriptionContain?: InputMaybe<Scalars['String']>;
  previewDescriptionEq?: InputMaybe<Scalars['String']>;
  previewDescriptionGt?: InputMaybe<Scalars['String']>;
  previewDescriptionGte?: InputMaybe<Scalars['String']>;
  previewDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  previewDescriptionLike?: InputMaybe<Scalars['String']>;
  previewDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  previewDescriptionLt?: InputMaybe<Scalars['String']>;
  previewDescriptionLte?: InputMaybe<Scalars['String']>;
  previewDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverview?: InputMaybe<Scalars['String']>;
  quickOverviewAny?: InputMaybe<Scalars['String']>;
  quickOverviewContain?: InputMaybe<Scalars['String']>;
  quickOverviewEq?: InputMaybe<Scalars['String']>;
  quickOverviewGt?: InputMaybe<Scalars['String']>;
  quickOverviewGte?: InputMaybe<Scalars['String']>;
  quickOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  quickOverviewLike?: InputMaybe<Scalars['String']>;
  quickOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  quickOverviewLt?: InputMaybe<Scalars['String']>;
  quickOverviewLte?: InputMaybe<Scalars['String']>;
  quickOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  score?: InputMaybe<Scalars['Float']>;
  scoreAny?: InputMaybe<Scalars['Float']>;
  scoreContain?: InputMaybe<Scalars['Float']>;
  scoreEq?: InputMaybe<Scalars['Float']>;
  scoreGt?: InputMaybe<Scalars['Float']>;
  scoreGte?: InputMaybe<Scalars['Float']>;
  scoreIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  scoreIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreLike?: InputMaybe<Scalars['Float']>;
  scoreLikeNoCase?: InputMaybe<Scalars['Float']>;
  scoreLt?: InputMaybe<Scalars['Float']>;
  scoreLte?: InputMaybe<Scalars['Float']>;
  scoreMessage?: InputMaybe<Scalars['String']>;
  scoreMessageAny?: InputMaybe<Scalars['String']>;
  scoreMessageContain?: InputMaybe<Scalars['String']>;
  scoreMessageEq?: InputMaybe<Scalars['String']>;
  scoreMessageGt?: InputMaybe<Scalars['String']>;
  scoreMessageGte?: InputMaybe<Scalars['String']>;
  scoreMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreMessageLike?: InputMaybe<Scalars['String']>;
  scoreMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  scoreMessageLt?: InputMaybe<Scalars['String']>;
  scoreMessageLte?: InputMaybe<Scalars['String']>;
  scoreMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleAny?: InputMaybe<Scalars['String']>;
  subTitleContain?: InputMaybe<Scalars['String']>;
  subTitleEq?: InputMaybe<Scalars['String']>;
  subTitleGt?: InputMaybe<Scalars['String']>;
  subTitleGte?: InputMaybe<Scalars['String']>;
  subTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subTitleLike?: InputMaybe<Scalars['String']>;
  subTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subTitleLt?: InputMaybe<Scalars['String']>;
  subTitleLte?: InputMaybe<Scalars['String']>;
  subTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescription?: InputMaybe<Scalars['String']>;
  summaryDescriptionAny?: InputMaybe<Scalars['String']>;
  summaryDescriptionContain?: InputMaybe<Scalars['String']>;
  summaryDescriptionEq?: InputMaybe<Scalars['String']>;
  summaryDescriptionGt?: InputMaybe<Scalars['String']>;
  summaryDescriptionGte?: InputMaybe<Scalars['String']>;
  summaryDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryDescriptionLike?: InputMaybe<Scalars['String']>;
  summaryDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryDescriptionLt?: InputMaybe<Scalars['String']>;
  summaryDescriptionLte?: InputMaybe<Scalars['String']>;
  summaryDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitle?: InputMaybe<Scalars['String']>;
  summaryTitleAny?: InputMaybe<Scalars['String']>;
  summaryTitleContain?: InputMaybe<Scalars['String']>;
  summaryTitleEq?: InputMaybe<Scalars['String']>;
  summaryTitleGt?: InputMaybe<Scalars['String']>;
  summaryTitleGte?: InputMaybe<Scalars['String']>;
  summaryTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryTitleLike?: InputMaybe<Scalars['String']>;
  summaryTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryTitleLt?: InputMaybe<Scalars['String']>;
  summaryTitleLte?: InputMaybe<Scalars['String']>;
  summaryTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLAffiliateLinksUserCreatedArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLAffiliateLinksUserUpdatedArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLAffiliateLinksPropertiesEnum {
  AffiliateProviderOfferId = 'affiliateProviderOfferId',
  BuyerAffiliateProviderId = 'buyerAffiliateProviderId',
  BuyerId = 'buyerId',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Currency = 'currency',
  DefaultPayout = 'defaultPayout',
  Factors = 'factors',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  Link = 'link',
  Method = 'method',
  OfferId = 'offerId',
  OldPrice = 'oldPrice',
  Price = 'price',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy',
  Weight = 'weight'
}

export type GQLAttachments = {
  __typename?: 'Attachments';
  access?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  category?: Maybe<GQLCategories>;
  categoryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  fullPath?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  mimeType?: Maybe<Scalars['String']>;
  originalName?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<Maybe<GQLTags>>>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};


export type GQLAttachmentsCategoryArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLAttachmentsTagsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLTagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTagsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLAttachmentsPropertiesEnum {
  Access = 'access',
  Alt = 'alt',
  Caption = 'caption',
  CategoryId = 'categoryId',
  CreatedAt = 'createdAt',
  FullPath = 'fullPath',
  Id = 'id',
  IsDeleted = 'isDeleted',
  MimeType = 'mimeType',
  OriginalName = 'originalName',
  Path = 'path',
  Size = 'size',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type GQLBuyerIntegrations = {
  __typename?: 'BuyerIntegrations';
  authIntegrationId?: Maybe<Scalars['Int']>;
  buyerId?: Maybe<Scalars['Int']>;
  buyerIntegrationId?: Maybe<Scalars['Int']>;
  category?: Maybe<GQLCategories>;
  categoryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  criteria?: Maybe<Scalars['JSON']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  log?: Maybe<Scalars['JSON']>;
  method?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  notQualified?: Maybe<Scalars['Boolean']>;
  notificationIntegrations?: Maybe<Scalars['JSON']>;
  oldVersion?: Maybe<Scalars['Float']>;
  relatedIntegrations?: Maybe<Scalars['JSON']>;
  secondRound?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  valueRule?: Maybe<Scalars['JSON']>;
  version?: Maybe<Scalars['Float']>;
  versionStatus?: Maybe<Scalars['String']>;
};


export type GQLBuyerIntegrationsCategoryArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLBuyerIntegrationsPropertiesEnum {
  AuthIntegrationId = 'authIntegrationId',
  BuyerId = 'buyerId',
  BuyerIntegrationId = 'buyerIntegrationId',
  CategoryId = 'categoryId',
  CreatedAt = 'createdAt',
  Criteria = 'criteria',
  DeletedAt = 'deletedAt',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  Language = 'language',
  Log = 'log',
  Method = 'method',
  ModifiedBy = 'modifiedBy',
  NotQualified = 'notQualified',
  NotificationIntegrations = 'notificationIntegrations',
  OldVersion = 'oldVersion',
  RelatedIntegrations = 'relatedIntegrations',
  SecondRound = 'secondRound',
  Title = 'title',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  Uuid = 'uuid',
  ValueRule = 'valueRule',
  Version = 'version',
  VersionStatus = 'versionStatus'
}

export type GQLCallCenter = {
  __typename?: 'CallCenter';
  categoryId?: Maybe<Scalars['Int']>;
  categoryName?: Maybe<Scalars['String']>;
  categorySlug?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  offerId?: Maybe<Scalars['Int']>;
  offerSlug?: Maybe<Scalars['String']>;
  offerTitle?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  ts?: Maybe<Scalars['String']>;
};

export type GQLCategories = {
  __typename?: 'Categories';
  TCPAMessage?: Maybe<Scalars['String']>;
  appetite?: Maybe<Scalars['String']>;
  attributes?: Maybe<Array<Maybe<GQLCategoryAttributes>>>;
  autoListing?: Maybe<Scalars['Boolean']>;
  bestMatchCount?: Maybe<Scalars['Int']>;
  buyerIntegrations?: Maybe<Array<Maybe<GQLBuyerIntegrations>>>;
  categoryChilds?: Maybe<Array<Maybe<GQLCategories>>>;
  config?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  domains?: Maybe<Array<Maybe<GQLDomains>>>;
  faqs?: Maybe<Array<Maybe<GQLFaqs>>>;
  fetchedBuyersCount?: Maybe<Scalars['Int']>;
  headline?: Maybe<Scalars['String']>;
  icon?: Maybe<GQLAttachments>;
  iconId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<GQLAttachments>;
  imageId?: Maybe<Scalars['String']>;
  isBestMatch?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOneToOneConsent?: Maybe<Scalars['Boolean']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  languages?: Maybe<Scalars['JSON']>;
  mainImage?: Maybe<GQLAttachments>;
  mainImageId?: Maybe<Scalars['String']>;
  metatags?: Maybe<Array<Maybe<GQLMetatags>>>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  offers?: Maybe<Array<Maybe<GQLOffers>>>;
  order?: Maybe<Scalars['Int']>;
  overview?: Maybe<Scalars['String']>;
  parentCategory?: Maybe<GQLCategories>;
  parentId?: Maybe<Scalars['Int']>;
  posts?: Maybe<Array<Maybe<GQLPosts>>>;
  requiresConsent?: Maybe<Scalars['Boolean']>;
  sharedBuyersGroupSize?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  slugAlias?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  supportedCountries?: Maybe<Scalars['JSON']>;
  taxonomies?: Maybe<Array<Maybe<GQLTaxonomies>>>;
  textBlocks?: Maybe<Array<Maybe<GQLTextBlocks>>>;
  title?: Maybe<Scalars['String']>;
  topics?: Maybe<Array<Maybe<GQLPosts>>>;
  trafficSourcesMap?: Maybe<Array<Maybe<GQLTrafficSourceMap>>>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  updatedAt?: Maybe<Scalars['String']>;
  url?: Maybe<GQLUrls>;
  urls?: Maybe<Array<Maybe<GQLUrls>>>;
  userId?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<GQLUsers>>>;
};


export type GQLCategoriesAttributesArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  comparison?: InputMaybe<Scalars['Boolean']>;
  comparisonAny?: InputMaybe<Scalars['Boolean']>;
  comparisonContain?: InputMaybe<Scalars['Boolean']>;
  comparisonEq?: InputMaybe<Scalars['Boolean']>;
  comparisonGt?: InputMaybe<Scalars['Boolean']>;
  comparisonGte?: InputMaybe<Scalars['Boolean']>;
  comparisonIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  comparisonIsNull?: InputMaybe<Scalars['Boolean']>;
  comparisonLike?: InputMaybe<Scalars['Boolean']>;
  comparisonLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  comparisonLt?: InputMaybe<Scalars['Boolean']>;
  comparisonLte?: InputMaybe<Scalars['Boolean']>;
  comparisonNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  forceComparisonsDisplay?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayAny?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayContain?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayEq?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayGt?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayGte?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  forceComparisonsDisplayIsNull?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLike?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLt?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLte?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  group?: InputMaybe<Scalars['String']>;
  groupAny?: InputMaybe<Scalars['String']>;
  groupContain?: InputMaybe<Scalars['String']>;
  groupEq?: InputMaybe<Scalars['String']>;
  groupGt?: InputMaybe<Scalars['String']>;
  groupGte?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['Int']>;
  groupIdAny?: InputMaybe<Scalars['Int']>;
  groupIdContain?: InputMaybe<Scalars['Int']>;
  groupIdEq?: InputMaybe<Scalars['Int']>;
  groupIdGt?: InputMaybe<Scalars['Int']>;
  groupIdGte?: InputMaybe<Scalars['Int']>;
  groupIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  groupIdIsNull?: InputMaybe<Scalars['Boolean']>;
  groupIdLike?: InputMaybe<Scalars['Int']>;
  groupIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  groupIdLt?: InputMaybe<Scalars['Int']>;
  groupIdLte?: InputMaybe<Scalars['Int']>;
  groupIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  groupIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupIsNull?: InputMaybe<Scalars['Boolean']>;
  groupLike?: InputMaybe<Scalars['String']>;
  groupLikeNoCase?: InputMaybe<Scalars['String']>;
  groupLt?: InputMaybe<Scalars['String']>;
  groupLte?: InputMaybe<Scalars['String']>;
  groupNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupSlug?: InputMaybe<Scalars['String']>;
  groupSlugAny?: InputMaybe<Scalars['String']>;
  groupSlugContain?: InputMaybe<Scalars['String']>;
  groupSlugEq?: InputMaybe<Scalars['String']>;
  groupSlugGt?: InputMaybe<Scalars['String']>;
  groupSlugGte?: InputMaybe<Scalars['String']>;
  groupSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  groupSlugLike?: InputMaybe<Scalars['String']>;
  groupSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  groupSlugLt?: InputMaybe<Scalars['String']>;
  groupSlugLte?: InputMaybe<Scalars['String']>;
  groupSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  hiddenAny?: InputMaybe<Scalars['Boolean']>;
  hiddenContain?: InputMaybe<Scalars['Boolean']>;
  hiddenEq?: InputMaybe<Scalars['Boolean']>;
  hiddenGt?: InputMaybe<Scalars['Boolean']>;
  hiddenGte?: InputMaybe<Scalars['Boolean']>;
  hiddenIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  hiddenIsNull?: InputMaybe<Scalars['Boolean']>;
  hiddenLike?: InputMaybe<Scalars['Boolean']>;
  hiddenLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  hiddenLt?: InputMaybe<Scalars['Boolean']>;
  hiddenLte?: InputMaybe<Scalars['Boolean']>;
  hiddenNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLCategoryAttributesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoryAttributesPropertiesEnum>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLCategoriesBuyerIntegrationsArgs = {
  authIntegrationId?: InputMaybe<Scalars['Int']>;
  authIntegrationIdAny?: InputMaybe<Scalars['Int']>;
  authIntegrationIdContain?: InputMaybe<Scalars['Int']>;
  authIntegrationIdEq?: InputMaybe<Scalars['Int']>;
  authIntegrationIdGt?: InputMaybe<Scalars['Int']>;
  authIntegrationIdGte?: InputMaybe<Scalars['Int']>;
  authIntegrationIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  authIntegrationIdIsNull?: InputMaybe<Scalars['Boolean']>;
  authIntegrationIdLike?: InputMaybe<Scalars['Int']>;
  authIntegrationIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  authIntegrationIdLt?: InputMaybe<Scalars['Int']>;
  authIntegrationIdLte?: InputMaybe<Scalars['Int']>;
  authIntegrationIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerId?: InputMaybe<Scalars['Int']>;
  buyerIdAny?: InputMaybe<Scalars['Int']>;
  buyerIdContain?: InputMaybe<Scalars['Int']>;
  buyerIdEq?: InputMaybe<Scalars['Int']>;
  buyerIdGt?: InputMaybe<Scalars['Int']>;
  buyerIdGte?: InputMaybe<Scalars['Int']>;
  buyerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  buyerIdLike?: InputMaybe<Scalars['Int']>;
  buyerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  buyerIdLt?: InputMaybe<Scalars['Int']>;
  buyerIdLte?: InputMaybe<Scalars['Int']>;
  buyerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerIntegrationId?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdAny?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdContain?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdEq?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdGt?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdGte?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerIntegrationIdIsNull?: InputMaybe<Scalars['Boolean']>;
  buyerIntegrationIdLike?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdLt?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdLte?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  criteria?: InputMaybe<Scalars['JSON']>;
  criteriaAny?: InputMaybe<Scalars['JSON']>;
  criteriaContain?: InputMaybe<Scalars['JSON']>;
  criteriaEq?: InputMaybe<Scalars['JSON']>;
  criteriaGt?: InputMaybe<Scalars['JSON']>;
  criteriaGte?: InputMaybe<Scalars['JSON']>;
  criteriaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  criteriaIsNull?: InputMaybe<Scalars['Boolean']>;
  criteriaLike?: InputMaybe<Scalars['JSON']>;
  criteriaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  criteriaLt?: InputMaybe<Scalars['JSON']>;
  criteriaLte?: InputMaybe<Scalars['JSON']>;
  criteriaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  log?: InputMaybe<Scalars['JSON']>;
  logAny?: InputMaybe<Scalars['JSON']>;
  logContain?: InputMaybe<Scalars['JSON']>;
  logEq?: InputMaybe<Scalars['JSON']>;
  logGt?: InputMaybe<Scalars['JSON']>;
  logGte?: InputMaybe<Scalars['JSON']>;
  logIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  logIsNull?: InputMaybe<Scalars['Boolean']>;
  logLike?: InputMaybe<Scalars['JSON']>;
  logLikeNoCase?: InputMaybe<Scalars['JSON']>;
  logLt?: InputMaybe<Scalars['JSON']>;
  logLte?: InputMaybe<Scalars['JSON']>;
  logNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  method?: InputMaybe<Scalars['String']>;
  methodAny?: InputMaybe<Scalars['String']>;
  methodContain?: InputMaybe<Scalars['String']>;
  methodEq?: InputMaybe<Scalars['String']>;
  methodGt?: InputMaybe<Scalars['String']>;
  methodGte?: InputMaybe<Scalars['String']>;
  methodIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  methodIsNull?: InputMaybe<Scalars['Boolean']>;
  methodLike?: InputMaybe<Scalars['String']>;
  methodLikeNoCase?: InputMaybe<Scalars['String']>;
  methodLt?: InputMaybe<Scalars['String']>;
  methodLte?: InputMaybe<Scalars['String']>;
  methodNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notQualified?: InputMaybe<Scalars['Boolean']>;
  notQualifiedAny?: InputMaybe<Scalars['Boolean']>;
  notQualifiedContain?: InputMaybe<Scalars['Boolean']>;
  notQualifiedEq?: InputMaybe<Scalars['Boolean']>;
  notQualifiedGt?: InputMaybe<Scalars['Boolean']>;
  notQualifiedGte?: InputMaybe<Scalars['Boolean']>;
  notQualifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  notQualifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  notQualifiedLike?: InputMaybe<Scalars['Boolean']>;
  notQualifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  notQualifiedLt?: InputMaybe<Scalars['Boolean']>;
  notQualifiedLte?: InputMaybe<Scalars['Boolean']>;
  notQualifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  notificationIntegrations?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsAny?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsContain?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsEq?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsGt?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsGte?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  notificationIntegrationsIsNull?: InputMaybe<Scalars['Boolean']>;
  notificationIntegrationsLike?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsLt?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsLte?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldVersion?: InputMaybe<Scalars['Float']>;
  oldVersionAny?: InputMaybe<Scalars['Float']>;
  oldVersionContain?: InputMaybe<Scalars['Float']>;
  oldVersionEq?: InputMaybe<Scalars['Float']>;
  oldVersionGt?: InputMaybe<Scalars['Float']>;
  oldVersionGte?: InputMaybe<Scalars['Float']>;
  oldVersionIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  oldVersionIsNull?: InputMaybe<Scalars['Boolean']>;
  oldVersionLike?: InputMaybe<Scalars['Float']>;
  oldVersionLikeNoCase?: InputMaybe<Scalars['Float']>;
  oldVersionLt?: InputMaybe<Scalars['Float']>;
  oldVersionLte?: InputMaybe<Scalars['Float']>;
  oldVersionNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  orderBy?: InputMaybe<GQLBuyerIntegrationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLBuyerIntegrationsPropertiesEnum>;
  relatedIntegrations?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsAny?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsContain?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsEq?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsGt?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsGte?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  relatedIntegrationsIsNull?: InputMaybe<Scalars['Boolean']>;
  relatedIntegrationsLike?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsLt?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsLte?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  secondRound?: InputMaybe<Scalars['Boolean']>;
  secondRoundAny?: InputMaybe<Scalars['Boolean']>;
  secondRoundContain?: InputMaybe<Scalars['Boolean']>;
  secondRoundEq?: InputMaybe<Scalars['Boolean']>;
  secondRoundGt?: InputMaybe<Scalars['Boolean']>;
  secondRoundGte?: InputMaybe<Scalars['Boolean']>;
  secondRoundIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  secondRoundIsNull?: InputMaybe<Scalars['Boolean']>;
  secondRoundLike?: InputMaybe<Scalars['Boolean']>;
  secondRoundLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  secondRoundLt?: InputMaybe<Scalars['Boolean']>;
  secondRoundLte?: InputMaybe<Scalars['Boolean']>;
  secondRoundNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uuid?: InputMaybe<Scalars['String']>;
  uuidAny?: InputMaybe<Scalars['String']>;
  uuidContain?: InputMaybe<Scalars['String']>;
  uuidEq?: InputMaybe<Scalars['String']>;
  uuidGt?: InputMaybe<Scalars['String']>;
  uuidGte?: InputMaybe<Scalars['String']>;
  uuidIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uuidIsNull?: InputMaybe<Scalars['Boolean']>;
  uuidLike?: InputMaybe<Scalars['String']>;
  uuidLikeNoCase?: InputMaybe<Scalars['String']>;
  uuidLt?: InputMaybe<Scalars['String']>;
  uuidLte?: InputMaybe<Scalars['String']>;
  uuidNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueRule?: InputMaybe<Scalars['JSON']>;
  valueRuleAny?: InputMaybe<Scalars['JSON']>;
  valueRuleContain?: InputMaybe<Scalars['JSON']>;
  valueRuleEq?: InputMaybe<Scalars['JSON']>;
  valueRuleGt?: InputMaybe<Scalars['JSON']>;
  valueRuleGte?: InputMaybe<Scalars['JSON']>;
  valueRuleIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueRuleIsNull?: InputMaybe<Scalars['Boolean']>;
  valueRuleLike?: InputMaybe<Scalars['JSON']>;
  valueRuleLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueRuleLt?: InputMaybe<Scalars['JSON']>;
  valueRuleLte?: InputMaybe<Scalars['JSON']>;
  valueRuleNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  version?: InputMaybe<Scalars['Float']>;
  versionAny?: InputMaybe<Scalars['Float']>;
  versionContain?: InputMaybe<Scalars['Float']>;
  versionEq?: InputMaybe<Scalars['Float']>;
  versionGt?: InputMaybe<Scalars['Float']>;
  versionGte?: InputMaybe<Scalars['Float']>;
  versionIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  versionIsNull?: InputMaybe<Scalars['Boolean']>;
  versionLike?: InputMaybe<Scalars['Float']>;
  versionLikeNoCase?: InputMaybe<Scalars['Float']>;
  versionLt?: InputMaybe<Scalars['Float']>;
  versionLte?: InputMaybe<Scalars['Float']>;
  versionNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  versionStatus?: InputMaybe<Scalars['String']>;
  versionStatusAny?: InputMaybe<Scalars['String']>;
  versionStatusContain?: InputMaybe<Scalars['String']>;
  versionStatusEq?: InputMaybe<Scalars['String']>;
  versionStatusGt?: InputMaybe<Scalars['String']>;
  versionStatusGte?: InputMaybe<Scalars['String']>;
  versionStatusIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  versionStatusIsNull?: InputMaybe<Scalars['Boolean']>;
  versionStatusLike?: InputMaybe<Scalars['String']>;
  versionStatusLikeNoCase?: InputMaybe<Scalars['String']>;
  versionStatusLt?: InputMaybe<Scalars['String']>;
  versionStatusLte?: InputMaybe<Scalars['String']>;
  versionStatusNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoriesCategoryChildsArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoriesDomainsArgs = {
  allowedLanguages?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesAny?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesContain?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesEq?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  allowedLanguagesIsNull?: InputMaybe<Scalars['Boolean']>;
  allowedLanguagesLike?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  analyticsCodeId?: InputMaybe<Scalars['String']>;
  analyticsCodeIdAny?: InputMaybe<Scalars['String']>;
  analyticsCodeIdContain?: InputMaybe<Scalars['String']>;
  analyticsCodeIdEq?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  analyticsCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  analyticsCodeIdLike?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cacheSettings?: InputMaybe<Scalars['JSON']>;
  cacheSettingsAny?: InputMaybe<Scalars['JSON']>;
  cacheSettingsContain?: InputMaybe<Scalars['JSON']>;
  cacheSettingsEq?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  cacheSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  cacheSettingsLike?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  clickyCodeId?: InputMaybe<Scalars['String']>;
  clickyCodeIdAny?: InputMaybe<Scalars['String']>;
  clickyCodeIdContain?: InputMaybe<Scalars['String']>;
  clickyCodeIdEq?: InputMaybe<Scalars['String']>;
  clickyCodeIdGt?: InputMaybe<Scalars['String']>;
  clickyCodeIdGte?: InputMaybe<Scalars['String']>;
  clickyCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clickyCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  clickyCodeIdLike?: InputMaybe<Scalars['String']>;
  clickyCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  clickyCodeIdLt?: InputMaybe<Scalars['String']>;
  clickyCodeIdLte?: InputMaybe<Scalars['String']>;
  clickyCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  enableChatWidget?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetAny?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetContain?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetEq?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableChatWidgetIsNull?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLike?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaId?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdAny?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdContain?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdEq?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLike?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedForm?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormAny?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormContain?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormEq?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedFormIsNull?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLike?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  facebookConversionAPISettings?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsAny?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsContain?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsEq?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookConversionAPISettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookConversionAPISettingsLike?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookSiteVerificationCode?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fallbackSettings?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsAny?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsContain?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsEq?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  fallbackSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  fallbackSettingsLike?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  faviconId?: InputMaybe<Scalars['String']>;
  faviconIdAny?: InputMaybe<Scalars['String']>;
  faviconIdContain?: InputMaybe<Scalars['String']>;
  faviconIdEq?: InputMaybe<Scalars['String']>;
  faviconIdGt?: InputMaybe<Scalars['String']>;
  faviconIdGte?: InputMaybe<Scalars['String']>;
  faviconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  faviconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  faviconIdLike?: InputMaybe<Scalars['String']>;
  faviconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  faviconIdLt?: InputMaybe<Scalars['String']>;
  faviconIdLte?: InputMaybe<Scalars['String']>;
  faviconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCode?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  googleSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmId?: InputMaybe<Scalars['String']>;
  gtmIdAny?: InputMaybe<Scalars['String']>;
  gtmIdContain?: InputMaybe<Scalars['String']>;
  gtmIdEq?: InputMaybe<Scalars['String']>;
  gtmIdGt?: InputMaybe<Scalars['String']>;
  gtmIdGte?: InputMaybe<Scalars['String']>;
  gtmIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmIdIsNull?: InputMaybe<Scalars['Boolean']>;
  gtmIdLike?: InputMaybe<Scalars['String']>;
  gtmIdLikeNoCase?: InputMaybe<Scalars['String']>;
  gtmIdLt?: InputMaybe<Scalars['String']>;
  gtmIdLte?: InputMaybe<Scalars['String']>;
  gtmIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  holdingRules?: InputMaybe<Scalars['JSON']>;
  holdingRulesAny?: InputMaybe<Scalars['JSON']>;
  holdingRulesContain?: InputMaybe<Scalars['JSON']>;
  holdingRulesEq?: InputMaybe<Scalars['JSON']>;
  holdingRulesGt?: InputMaybe<Scalars['JSON']>;
  holdingRulesGte?: InputMaybe<Scalars['JSON']>;
  holdingRulesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  holdingRulesIsNull?: InputMaybe<Scalars['Boolean']>;
  holdingRulesLike?: InputMaybe<Scalars['JSON']>;
  holdingRulesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  holdingRulesLt?: InputMaybe<Scalars['JSON']>;
  holdingRulesLte?: InputMaybe<Scalars['JSON']>;
  holdingRulesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabled?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledAny?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledContain?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledEq?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabledIsNull?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLike?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainsPropertiesEnum>;
  otpVerificationCriteria?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaAny?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaContain?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaEq?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  otpVerificationCriteriaIsNull?: InputMaybe<Scalars['Boolean']>;
  otpVerificationCriteriaLike?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfig?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigAny?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigContain?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigEq?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  recaptchaConfigLike?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  secondaryLogoId?: InputMaybe<Scalars['String']>;
  secondaryLogoIdAny?: InputMaybe<Scalars['String']>;
  secondaryLogoIdContain?: InputMaybe<Scalars['String']>;
  secondaryLogoIdEq?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondaryLogoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  secondaryLogoIdLike?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sendNotifications?: InputMaybe<Scalars['JSON']>;
  sendNotificationsAny?: InputMaybe<Scalars['JSON']>;
  sendNotificationsContain?: InputMaybe<Scalars['JSON']>;
  sendNotificationsEq?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  sendNotificationsIsNull?: InputMaybe<Scalars['Boolean']>;
  sendNotificationsLike?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settings?: InputMaybe<Scalars['JSON']>;
  settingsAny?: InputMaybe<Scalars['JSON']>;
  settingsContain?: InputMaybe<Scalars['JSON']>;
  settingsEq?: InputMaybe<Scalars['JSON']>;
  settingsGt?: InputMaybe<Scalars['JSON']>;
  settingsGte?: InputMaybe<Scalars['JSON']>;
  settingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settingsIsNull?: InputMaybe<Scalars['Boolean']>;
  settingsLike?: InputMaybe<Scalars['JSON']>;
  settingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  settingsLt?: InputMaybe<Scalars['JSON']>;
  settingsLte?: InputMaybe<Scalars['JSON']>;
  settingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  slogan?: InputMaybe<Scalars['String']>;
  sloganAny?: InputMaybe<Scalars['String']>;
  sloganContain?: InputMaybe<Scalars['String']>;
  sloganEq?: InputMaybe<Scalars['String']>;
  sloganGt?: InputMaybe<Scalars['String']>;
  sloganGte?: InputMaybe<Scalars['String']>;
  sloganIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sloganIsNull?: InputMaybe<Scalars['Boolean']>;
  sloganLike?: InputMaybe<Scalars['String']>;
  sloganLikeNoCase?: InputMaybe<Scalars['String']>;
  sloganLt?: InputMaybe<Scalars['String']>;
  sloganLte?: InputMaybe<Scalars['String']>;
  sloganNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateConfig?: InputMaybe<Scalars['JSON']>;
  templateConfigAny?: InputMaybe<Scalars['JSON']>;
  templateConfigContain?: InputMaybe<Scalars['JSON']>;
  templateConfigEq?: InputMaybe<Scalars['JSON']>;
  templateConfigGt?: InputMaybe<Scalars['JSON']>;
  templateConfigGte?: InputMaybe<Scalars['JSON']>;
  templateConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  templateConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  templateConfigLike?: InputMaybe<Scalars['JSON']>;
  templateConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  templateConfigLt?: InputMaybe<Scalars['JSON']>;
  templateConfigLte?: InputMaybe<Scalars['JSON']>;
  templateConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixel?: InputMaybe<Scalars['String']>;
  twitterPixelAny?: InputMaybe<Scalars['String']>;
  twitterPixelContain?: InputMaybe<Scalars['String']>;
  twitterPixelEq?: InputMaybe<Scalars['String']>;
  twitterPixelGt?: InputMaybe<Scalars['String']>;
  twitterPixelGte?: InputMaybe<Scalars['String']>;
  twitterPixelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixelIsNull?: InputMaybe<Scalars['Boolean']>;
  twitterPixelLike?: InputMaybe<Scalars['String']>;
  twitterPixelLikeNoCase?: InputMaybe<Scalars['String']>;
  twitterPixelLt?: InputMaybe<Scalars['String']>;
  twitterPixelLte?: InputMaybe<Scalars['String']>;
  twitterPixelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoriesFaqsArgs = {
  answer?: InputMaybe<Scalars['String']>;
  answerAny?: InputMaybe<Scalars['String']>;
  answerContain?: InputMaybe<Scalars['String']>;
  answerEq?: InputMaybe<Scalars['String']>;
  answerGt?: InputMaybe<Scalars['String']>;
  answerGte?: InputMaybe<Scalars['String']>;
  answerIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  answerIsNull?: InputMaybe<Scalars['Boolean']>;
  answerLike?: InputMaybe<Scalars['String']>;
  answerLikeNoCase?: InputMaybe<Scalars['String']>;
  answerLt?: InputMaybe<Scalars['String']>;
  answerLte?: InputMaybe<Scalars['String']>;
  answerNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedByAny?: InputMaybe<Scalars['String']>;
  deletedByContain?: InputMaybe<Scalars['String']>;
  deletedByEq?: InputMaybe<Scalars['String']>;
  deletedByGt?: InputMaybe<Scalars['String']>;
  deletedByGte?: InputMaybe<Scalars['String']>;
  deletedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedByIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedByLike?: InputMaybe<Scalars['String']>;
  deletedByLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedByLt?: InputMaybe<Scalars['String']>;
  deletedByLte?: InputMaybe<Scalars['String']>;
  deletedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLFaqsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLFaqsPropertiesEnum>;
  question?: InputMaybe<Scalars['String']>;
  questionAny?: InputMaybe<Scalars['String']>;
  questionContain?: InputMaybe<Scalars['String']>;
  questionEq?: InputMaybe<Scalars['String']>;
  questionGt?: InputMaybe<Scalars['String']>;
  questionGte?: InputMaybe<Scalars['String']>;
  questionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionIsNull?: InputMaybe<Scalars['Boolean']>;
  questionLike?: InputMaybe<Scalars['String']>;
  questionLikeNoCase?: InputMaybe<Scalars['String']>;
  questionLt?: InputMaybe<Scalars['String']>;
  questionLte?: InputMaybe<Scalars['String']>;
  questionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoriesIconArgs = {
  access?: InputMaybe<Scalars['String']>;
  accessAny?: InputMaybe<Scalars['String']>;
  accessContain?: InputMaybe<Scalars['String']>;
  accessEq?: InputMaybe<Scalars['String']>;
  accessGt?: InputMaybe<Scalars['String']>;
  accessGte?: InputMaybe<Scalars['String']>;
  accessIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accessIsNull?: InputMaybe<Scalars['Boolean']>;
  accessLike?: InputMaybe<Scalars['String']>;
  accessLikeNoCase?: InputMaybe<Scalars['String']>;
  accessLt?: InputMaybe<Scalars['String']>;
  accessLte?: InputMaybe<Scalars['String']>;
  accessNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alt?: InputMaybe<Scalars['String']>;
  altAny?: InputMaybe<Scalars['String']>;
  altContain?: InputMaybe<Scalars['String']>;
  altEq?: InputMaybe<Scalars['String']>;
  altGt?: InputMaybe<Scalars['String']>;
  altGte?: InputMaybe<Scalars['String']>;
  altIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  altIsNull?: InputMaybe<Scalars['Boolean']>;
  altLike?: InputMaybe<Scalars['String']>;
  altLikeNoCase?: InputMaybe<Scalars['String']>;
  altLt?: InputMaybe<Scalars['String']>;
  altLte?: InputMaybe<Scalars['String']>;
  altNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caption?: InputMaybe<Scalars['String']>;
  captionAny?: InputMaybe<Scalars['String']>;
  captionContain?: InputMaybe<Scalars['String']>;
  captionEq?: InputMaybe<Scalars['String']>;
  captionGt?: InputMaybe<Scalars['String']>;
  captionGte?: InputMaybe<Scalars['String']>;
  captionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  captionIsNull?: InputMaybe<Scalars['Boolean']>;
  captionLike?: InputMaybe<Scalars['String']>;
  captionLikeNoCase?: InputMaybe<Scalars['String']>;
  captionLt?: InputMaybe<Scalars['String']>;
  captionLte?: InputMaybe<Scalars['String']>;
  captionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fullPath?: InputMaybe<Scalars['String']>;
  fullPathAny?: InputMaybe<Scalars['String']>;
  fullPathContain?: InputMaybe<Scalars['String']>;
  fullPathEq?: InputMaybe<Scalars['String']>;
  fullPathGt?: InputMaybe<Scalars['String']>;
  fullPathGte?: InputMaybe<Scalars['String']>;
  fullPathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullPathIsNull?: InputMaybe<Scalars['Boolean']>;
  fullPathLike?: InputMaybe<Scalars['String']>;
  fullPathLikeNoCase?: InputMaybe<Scalars['String']>;
  fullPathLt?: InputMaybe<Scalars['String']>;
  fullPathLte?: InputMaybe<Scalars['String']>;
  fullPathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mimeType?: InputMaybe<Scalars['String']>;
  mimeTypeAny?: InputMaybe<Scalars['String']>;
  mimeTypeContain?: InputMaybe<Scalars['String']>;
  mimeTypeEq?: InputMaybe<Scalars['String']>;
  mimeTypeGt?: InputMaybe<Scalars['String']>;
  mimeTypeGte?: InputMaybe<Scalars['String']>;
  mimeTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mimeTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  mimeTypeLike?: InputMaybe<Scalars['String']>;
  mimeTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  mimeTypeLt?: InputMaybe<Scalars['String']>;
  mimeTypeLte?: InputMaybe<Scalars['String']>;
  mimeTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  originalName?: InputMaybe<Scalars['String']>;
  originalNameAny?: InputMaybe<Scalars['String']>;
  originalNameContain?: InputMaybe<Scalars['String']>;
  originalNameEq?: InputMaybe<Scalars['String']>;
  originalNameGt?: InputMaybe<Scalars['String']>;
  originalNameGte?: InputMaybe<Scalars['String']>;
  originalNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  originalNameIsNull?: InputMaybe<Scalars['Boolean']>;
  originalNameLike?: InputMaybe<Scalars['String']>;
  originalNameLikeNoCase?: InputMaybe<Scalars['String']>;
  originalNameLt?: InputMaybe<Scalars['String']>;
  originalNameLte?: InputMaybe<Scalars['String']>;
  originalNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  path?: InputMaybe<Scalars['String']>;
  pathAny?: InputMaybe<Scalars['String']>;
  pathContain?: InputMaybe<Scalars['String']>;
  pathEq?: InputMaybe<Scalars['String']>;
  pathGt?: InputMaybe<Scalars['String']>;
  pathGte?: InputMaybe<Scalars['String']>;
  pathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pathIsNull?: InputMaybe<Scalars['Boolean']>;
  pathLike?: InputMaybe<Scalars['String']>;
  pathLikeNoCase?: InputMaybe<Scalars['String']>;
  pathLt?: InputMaybe<Scalars['String']>;
  pathLte?: InputMaybe<Scalars['String']>;
  pathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  size?: InputMaybe<Scalars['Int']>;
  sizeAny?: InputMaybe<Scalars['Int']>;
  sizeContain?: InputMaybe<Scalars['Int']>;
  sizeEq?: InputMaybe<Scalars['Int']>;
  sizeGt?: InputMaybe<Scalars['Int']>;
  sizeGte?: InputMaybe<Scalars['Int']>;
  sizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sizeLike?: InputMaybe<Scalars['Int']>;
  sizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sizeLt?: InputMaybe<Scalars['Int']>;
  sizeLte?: InputMaybe<Scalars['Int']>;
  sizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoriesImageArgs = {
  access?: InputMaybe<Scalars['String']>;
  accessAny?: InputMaybe<Scalars['String']>;
  accessContain?: InputMaybe<Scalars['String']>;
  accessEq?: InputMaybe<Scalars['String']>;
  accessGt?: InputMaybe<Scalars['String']>;
  accessGte?: InputMaybe<Scalars['String']>;
  accessIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accessIsNull?: InputMaybe<Scalars['Boolean']>;
  accessLike?: InputMaybe<Scalars['String']>;
  accessLikeNoCase?: InputMaybe<Scalars['String']>;
  accessLt?: InputMaybe<Scalars['String']>;
  accessLte?: InputMaybe<Scalars['String']>;
  accessNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alt?: InputMaybe<Scalars['String']>;
  altAny?: InputMaybe<Scalars['String']>;
  altContain?: InputMaybe<Scalars['String']>;
  altEq?: InputMaybe<Scalars['String']>;
  altGt?: InputMaybe<Scalars['String']>;
  altGte?: InputMaybe<Scalars['String']>;
  altIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  altIsNull?: InputMaybe<Scalars['Boolean']>;
  altLike?: InputMaybe<Scalars['String']>;
  altLikeNoCase?: InputMaybe<Scalars['String']>;
  altLt?: InputMaybe<Scalars['String']>;
  altLte?: InputMaybe<Scalars['String']>;
  altNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caption?: InputMaybe<Scalars['String']>;
  captionAny?: InputMaybe<Scalars['String']>;
  captionContain?: InputMaybe<Scalars['String']>;
  captionEq?: InputMaybe<Scalars['String']>;
  captionGt?: InputMaybe<Scalars['String']>;
  captionGte?: InputMaybe<Scalars['String']>;
  captionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  captionIsNull?: InputMaybe<Scalars['Boolean']>;
  captionLike?: InputMaybe<Scalars['String']>;
  captionLikeNoCase?: InputMaybe<Scalars['String']>;
  captionLt?: InputMaybe<Scalars['String']>;
  captionLte?: InputMaybe<Scalars['String']>;
  captionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fullPath?: InputMaybe<Scalars['String']>;
  fullPathAny?: InputMaybe<Scalars['String']>;
  fullPathContain?: InputMaybe<Scalars['String']>;
  fullPathEq?: InputMaybe<Scalars['String']>;
  fullPathGt?: InputMaybe<Scalars['String']>;
  fullPathGte?: InputMaybe<Scalars['String']>;
  fullPathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullPathIsNull?: InputMaybe<Scalars['Boolean']>;
  fullPathLike?: InputMaybe<Scalars['String']>;
  fullPathLikeNoCase?: InputMaybe<Scalars['String']>;
  fullPathLt?: InputMaybe<Scalars['String']>;
  fullPathLte?: InputMaybe<Scalars['String']>;
  fullPathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mimeType?: InputMaybe<Scalars['String']>;
  mimeTypeAny?: InputMaybe<Scalars['String']>;
  mimeTypeContain?: InputMaybe<Scalars['String']>;
  mimeTypeEq?: InputMaybe<Scalars['String']>;
  mimeTypeGt?: InputMaybe<Scalars['String']>;
  mimeTypeGte?: InputMaybe<Scalars['String']>;
  mimeTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mimeTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  mimeTypeLike?: InputMaybe<Scalars['String']>;
  mimeTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  mimeTypeLt?: InputMaybe<Scalars['String']>;
  mimeTypeLte?: InputMaybe<Scalars['String']>;
  mimeTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  originalName?: InputMaybe<Scalars['String']>;
  originalNameAny?: InputMaybe<Scalars['String']>;
  originalNameContain?: InputMaybe<Scalars['String']>;
  originalNameEq?: InputMaybe<Scalars['String']>;
  originalNameGt?: InputMaybe<Scalars['String']>;
  originalNameGte?: InputMaybe<Scalars['String']>;
  originalNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  originalNameIsNull?: InputMaybe<Scalars['Boolean']>;
  originalNameLike?: InputMaybe<Scalars['String']>;
  originalNameLikeNoCase?: InputMaybe<Scalars['String']>;
  originalNameLt?: InputMaybe<Scalars['String']>;
  originalNameLte?: InputMaybe<Scalars['String']>;
  originalNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  path?: InputMaybe<Scalars['String']>;
  pathAny?: InputMaybe<Scalars['String']>;
  pathContain?: InputMaybe<Scalars['String']>;
  pathEq?: InputMaybe<Scalars['String']>;
  pathGt?: InputMaybe<Scalars['String']>;
  pathGte?: InputMaybe<Scalars['String']>;
  pathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pathIsNull?: InputMaybe<Scalars['Boolean']>;
  pathLike?: InputMaybe<Scalars['String']>;
  pathLikeNoCase?: InputMaybe<Scalars['String']>;
  pathLt?: InputMaybe<Scalars['String']>;
  pathLte?: InputMaybe<Scalars['String']>;
  pathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  size?: InputMaybe<Scalars['Int']>;
  sizeAny?: InputMaybe<Scalars['Int']>;
  sizeContain?: InputMaybe<Scalars['Int']>;
  sizeEq?: InputMaybe<Scalars['Int']>;
  sizeGt?: InputMaybe<Scalars['Int']>;
  sizeGte?: InputMaybe<Scalars['Int']>;
  sizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sizeLike?: InputMaybe<Scalars['Int']>;
  sizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sizeLt?: InputMaybe<Scalars['Int']>;
  sizeLte?: InputMaybe<Scalars['Int']>;
  sizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoriesMainImageArgs = {
  access?: InputMaybe<Scalars['String']>;
  accessAny?: InputMaybe<Scalars['String']>;
  accessContain?: InputMaybe<Scalars['String']>;
  accessEq?: InputMaybe<Scalars['String']>;
  accessGt?: InputMaybe<Scalars['String']>;
  accessGte?: InputMaybe<Scalars['String']>;
  accessIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accessIsNull?: InputMaybe<Scalars['Boolean']>;
  accessLike?: InputMaybe<Scalars['String']>;
  accessLikeNoCase?: InputMaybe<Scalars['String']>;
  accessLt?: InputMaybe<Scalars['String']>;
  accessLte?: InputMaybe<Scalars['String']>;
  accessNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alt?: InputMaybe<Scalars['String']>;
  altAny?: InputMaybe<Scalars['String']>;
  altContain?: InputMaybe<Scalars['String']>;
  altEq?: InputMaybe<Scalars['String']>;
  altGt?: InputMaybe<Scalars['String']>;
  altGte?: InputMaybe<Scalars['String']>;
  altIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  altIsNull?: InputMaybe<Scalars['Boolean']>;
  altLike?: InputMaybe<Scalars['String']>;
  altLikeNoCase?: InputMaybe<Scalars['String']>;
  altLt?: InputMaybe<Scalars['String']>;
  altLte?: InputMaybe<Scalars['String']>;
  altNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caption?: InputMaybe<Scalars['String']>;
  captionAny?: InputMaybe<Scalars['String']>;
  captionContain?: InputMaybe<Scalars['String']>;
  captionEq?: InputMaybe<Scalars['String']>;
  captionGt?: InputMaybe<Scalars['String']>;
  captionGte?: InputMaybe<Scalars['String']>;
  captionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  captionIsNull?: InputMaybe<Scalars['Boolean']>;
  captionLike?: InputMaybe<Scalars['String']>;
  captionLikeNoCase?: InputMaybe<Scalars['String']>;
  captionLt?: InputMaybe<Scalars['String']>;
  captionLte?: InputMaybe<Scalars['String']>;
  captionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fullPath?: InputMaybe<Scalars['String']>;
  fullPathAny?: InputMaybe<Scalars['String']>;
  fullPathContain?: InputMaybe<Scalars['String']>;
  fullPathEq?: InputMaybe<Scalars['String']>;
  fullPathGt?: InputMaybe<Scalars['String']>;
  fullPathGte?: InputMaybe<Scalars['String']>;
  fullPathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullPathIsNull?: InputMaybe<Scalars['Boolean']>;
  fullPathLike?: InputMaybe<Scalars['String']>;
  fullPathLikeNoCase?: InputMaybe<Scalars['String']>;
  fullPathLt?: InputMaybe<Scalars['String']>;
  fullPathLte?: InputMaybe<Scalars['String']>;
  fullPathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mimeType?: InputMaybe<Scalars['String']>;
  mimeTypeAny?: InputMaybe<Scalars['String']>;
  mimeTypeContain?: InputMaybe<Scalars['String']>;
  mimeTypeEq?: InputMaybe<Scalars['String']>;
  mimeTypeGt?: InputMaybe<Scalars['String']>;
  mimeTypeGte?: InputMaybe<Scalars['String']>;
  mimeTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mimeTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  mimeTypeLike?: InputMaybe<Scalars['String']>;
  mimeTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  mimeTypeLt?: InputMaybe<Scalars['String']>;
  mimeTypeLte?: InputMaybe<Scalars['String']>;
  mimeTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  originalName?: InputMaybe<Scalars['String']>;
  originalNameAny?: InputMaybe<Scalars['String']>;
  originalNameContain?: InputMaybe<Scalars['String']>;
  originalNameEq?: InputMaybe<Scalars['String']>;
  originalNameGt?: InputMaybe<Scalars['String']>;
  originalNameGte?: InputMaybe<Scalars['String']>;
  originalNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  originalNameIsNull?: InputMaybe<Scalars['Boolean']>;
  originalNameLike?: InputMaybe<Scalars['String']>;
  originalNameLikeNoCase?: InputMaybe<Scalars['String']>;
  originalNameLt?: InputMaybe<Scalars['String']>;
  originalNameLte?: InputMaybe<Scalars['String']>;
  originalNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  path?: InputMaybe<Scalars['String']>;
  pathAny?: InputMaybe<Scalars['String']>;
  pathContain?: InputMaybe<Scalars['String']>;
  pathEq?: InputMaybe<Scalars['String']>;
  pathGt?: InputMaybe<Scalars['String']>;
  pathGte?: InputMaybe<Scalars['String']>;
  pathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pathIsNull?: InputMaybe<Scalars['Boolean']>;
  pathLike?: InputMaybe<Scalars['String']>;
  pathLikeNoCase?: InputMaybe<Scalars['String']>;
  pathLt?: InputMaybe<Scalars['String']>;
  pathLte?: InputMaybe<Scalars['String']>;
  pathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  size?: InputMaybe<Scalars['Int']>;
  sizeAny?: InputMaybe<Scalars['Int']>;
  sizeContain?: InputMaybe<Scalars['Int']>;
  sizeEq?: InputMaybe<Scalars['Int']>;
  sizeGt?: InputMaybe<Scalars['Int']>;
  sizeGte?: InputMaybe<Scalars['Int']>;
  sizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sizeLike?: InputMaybe<Scalars['Int']>;
  sizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sizeLt?: InputMaybe<Scalars['Int']>;
  sizeLte?: InputMaybe<Scalars['Int']>;
  sizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoriesMetatagsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  model?: InputMaybe<Scalars['String']>;
  modelAny?: InputMaybe<Scalars['String']>;
  modelContain?: InputMaybe<Scalars['String']>;
  modelEq?: InputMaybe<Scalars['String']>;
  modelGt?: InputMaybe<Scalars['String']>;
  modelGte?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIsNull?: InputMaybe<Scalars['Boolean']>;
  modelLike?: InputMaybe<Scalars['String']>;
  modelLikeNoCase?: InputMaybe<Scalars['String']>;
  modelLt?: InputMaybe<Scalars['String']>;
  modelLte?: InputMaybe<Scalars['String']>;
  modelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLMetatagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLMetatagsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoriesOffersArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checkWallet?: InputMaybe<Scalars['Boolean']>;
  checkWalletAny?: InputMaybe<Scalars['Boolean']>;
  checkWalletContain?: InputMaybe<Scalars['Boolean']>;
  checkWalletEq?: InputMaybe<Scalars['Boolean']>;
  checkWalletGt?: InputMaybe<Scalars['Boolean']>;
  checkWalletGte?: InputMaybe<Scalars['Boolean']>;
  checkWalletIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  checkWalletIsNull?: InputMaybe<Scalars['Boolean']>;
  checkWalletLike?: InputMaybe<Scalars['Boolean']>;
  checkWalletLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  checkWalletLt?: InputMaybe<Scalars['Boolean']>;
  checkWalletLte?: InputMaybe<Scalars['Boolean']>;
  checkWalletNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultAffiliateLinkId?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdAny?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdContain?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdEq?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  defaultAffiliateLinkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultAffiliateLinkIdLike?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrl?: InputMaybe<Scalars['String']>;
  displayUrlAny?: InputMaybe<Scalars['String']>;
  displayUrlContain?: InputMaybe<Scalars['String']>;
  displayUrlEq?: InputMaybe<Scalars['String']>;
  displayUrlGt?: InputMaybe<Scalars['String']>;
  displayUrlGte?: InputMaybe<Scalars['String']>;
  displayUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  displayUrlLike?: InputMaybe<Scalars['String']>;
  displayUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  displayUrlLt?: InputMaybe<Scalars['String']>;
  displayUrlLte?: InputMaybe<Scalars['String']>;
  displayUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalData?: InputMaybe<Scalars['JSON']>;
  externalDataAny?: InputMaybe<Scalars['JSON']>;
  externalDataContain?: InputMaybe<Scalars['JSON']>;
  externalDataEq?: InputMaybe<Scalars['JSON']>;
  externalDataGt?: InputMaybe<Scalars['JSON']>;
  externalDataGte?: InputMaybe<Scalars['JSON']>;
  externalDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  externalDataIsNull?: InputMaybe<Scalars['Boolean']>;
  externalDataLike?: InputMaybe<Scalars['JSON']>;
  externalDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  externalDataLt?: InputMaybe<Scalars['JSON']>;
  externalDataLte?: InputMaybe<Scalars['JSON']>;
  externalDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  featuresListTitle?: InputMaybe<Scalars['String']>;
  featuresListTitleAny?: InputMaybe<Scalars['String']>;
  featuresListTitleContain?: InputMaybe<Scalars['String']>;
  featuresListTitleEq?: InputMaybe<Scalars['String']>;
  featuresListTitleGt?: InputMaybe<Scalars['String']>;
  featuresListTitleGte?: InputMaybe<Scalars['String']>;
  featuresListTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuresListTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  featuresListTitleLike?: InputMaybe<Scalars['String']>;
  featuresListTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  featuresListTitleLt?: InputMaybe<Scalars['String']>;
  featuresListTitleLte?: InputMaybe<Scalars['String']>;
  featuresListTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  isPausedAny?: InputMaybe<Scalars['Boolean']>;
  isPausedContain?: InputMaybe<Scalars['Boolean']>;
  isPausedEq?: InputMaybe<Scalars['Boolean']>;
  isPausedGt?: InputMaybe<Scalars['Boolean']>;
  isPausedGte?: InputMaybe<Scalars['Boolean']>;
  isPausedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPausedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPausedLike?: InputMaybe<Scalars['Boolean']>;
  isPausedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPausedLt?: InputMaybe<Scalars['Boolean']>;
  isPausedLte?: InputMaybe<Scalars['Boolean']>;
  isPausedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldOverview?: InputMaybe<Scalars['String']>;
  oldOverviewAny?: InputMaybe<Scalars['String']>;
  oldOverviewContain?: InputMaybe<Scalars['String']>;
  oldOverviewEq?: InputMaybe<Scalars['String']>;
  oldOverviewGt?: InputMaybe<Scalars['String']>;
  oldOverviewGte?: InputMaybe<Scalars['String']>;
  oldOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  oldOverviewLike?: InputMaybe<Scalars['String']>;
  oldOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  oldOverviewLt?: InputMaybe<Scalars['String']>;
  oldOverviewLte?: InputMaybe<Scalars['String']>;
  oldOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOffersPropertiesEnum>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescription?: InputMaybe<Scalars['String']>;
  previewDescriptionAny?: InputMaybe<Scalars['String']>;
  previewDescriptionContain?: InputMaybe<Scalars['String']>;
  previewDescriptionEq?: InputMaybe<Scalars['String']>;
  previewDescriptionGt?: InputMaybe<Scalars['String']>;
  previewDescriptionGte?: InputMaybe<Scalars['String']>;
  previewDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  previewDescriptionLike?: InputMaybe<Scalars['String']>;
  previewDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  previewDescriptionLt?: InputMaybe<Scalars['String']>;
  previewDescriptionLte?: InputMaybe<Scalars['String']>;
  previewDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverview?: InputMaybe<Scalars['String']>;
  quickOverviewAny?: InputMaybe<Scalars['String']>;
  quickOverviewContain?: InputMaybe<Scalars['String']>;
  quickOverviewEq?: InputMaybe<Scalars['String']>;
  quickOverviewGt?: InputMaybe<Scalars['String']>;
  quickOverviewGte?: InputMaybe<Scalars['String']>;
  quickOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  quickOverviewLike?: InputMaybe<Scalars['String']>;
  quickOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  quickOverviewLt?: InputMaybe<Scalars['String']>;
  quickOverviewLte?: InputMaybe<Scalars['String']>;
  quickOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  score?: InputMaybe<Scalars['Float']>;
  scoreAny?: InputMaybe<Scalars['Float']>;
  scoreContain?: InputMaybe<Scalars['Float']>;
  scoreEq?: InputMaybe<Scalars['Float']>;
  scoreGt?: InputMaybe<Scalars['Float']>;
  scoreGte?: InputMaybe<Scalars['Float']>;
  scoreIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  scoreIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreLike?: InputMaybe<Scalars['Float']>;
  scoreLikeNoCase?: InputMaybe<Scalars['Float']>;
  scoreLt?: InputMaybe<Scalars['Float']>;
  scoreLte?: InputMaybe<Scalars['Float']>;
  scoreMessage?: InputMaybe<Scalars['String']>;
  scoreMessageAny?: InputMaybe<Scalars['String']>;
  scoreMessageContain?: InputMaybe<Scalars['String']>;
  scoreMessageEq?: InputMaybe<Scalars['String']>;
  scoreMessageGt?: InputMaybe<Scalars['String']>;
  scoreMessageGte?: InputMaybe<Scalars['String']>;
  scoreMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreMessageLike?: InputMaybe<Scalars['String']>;
  scoreMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  scoreMessageLt?: InputMaybe<Scalars['String']>;
  scoreMessageLte?: InputMaybe<Scalars['String']>;
  scoreMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleAny?: InputMaybe<Scalars['String']>;
  subTitleContain?: InputMaybe<Scalars['String']>;
  subTitleEq?: InputMaybe<Scalars['String']>;
  subTitleGt?: InputMaybe<Scalars['String']>;
  subTitleGte?: InputMaybe<Scalars['String']>;
  subTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subTitleLike?: InputMaybe<Scalars['String']>;
  subTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subTitleLt?: InputMaybe<Scalars['String']>;
  subTitleLte?: InputMaybe<Scalars['String']>;
  subTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescription?: InputMaybe<Scalars['String']>;
  summaryDescriptionAny?: InputMaybe<Scalars['String']>;
  summaryDescriptionContain?: InputMaybe<Scalars['String']>;
  summaryDescriptionEq?: InputMaybe<Scalars['String']>;
  summaryDescriptionGt?: InputMaybe<Scalars['String']>;
  summaryDescriptionGte?: InputMaybe<Scalars['String']>;
  summaryDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryDescriptionLike?: InputMaybe<Scalars['String']>;
  summaryDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryDescriptionLt?: InputMaybe<Scalars['String']>;
  summaryDescriptionLte?: InputMaybe<Scalars['String']>;
  summaryDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitle?: InputMaybe<Scalars['String']>;
  summaryTitleAny?: InputMaybe<Scalars['String']>;
  summaryTitleContain?: InputMaybe<Scalars['String']>;
  summaryTitleEq?: InputMaybe<Scalars['String']>;
  summaryTitleGt?: InputMaybe<Scalars['String']>;
  summaryTitleGte?: InputMaybe<Scalars['String']>;
  summaryTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryTitleLike?: InputMaybe<Scalars['String']>;
  summaryTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryTitleLt?: InputMaybe<Scalars['String']>;
  summaryTitleLte?: InputMaybe<Scalars['String']>;
  summaryTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoriesParentCategoryArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoriesPostsArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerpt?: InputMaybe<Scalars['String']>;
  excerptAny?: InputMaybe<Scalars['String']>;
  excerptContain?: InputMaybe<Scalars['String']>;
  excerptEq?: InputMaybe<Scalars['String']>;
  excerptGt?: InputMaybe<Scalars['String']>;
  excerptGte?: InputMaybe<Scalars['String']>;
  excerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerptIsNull?: InputMaybe<Scalars['Boolean']>;
  excerptLike?: InputMaybe<Scalars['String']>;
  excerptLikeNoCase?: InputMaybe<Scalars['String']>;
  excerptLt?: InputMaybe<Scalars['String']>;
  excerptLte?: InputMaybe<Scalars['String']>;
  excerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featured?: InputMaybe<Scalars['Boolean']>;
  featuredAny?: InputMaybe<Scalars['Boolean']>;
  featuredContain?: InputMaybe<Scalars['Boolean']>;
  featuredEq?: InputMaybe<Scalars['Boolean']>;
  featuredGt?: InputMaybe<Scalars['Boolean']>;
  featuredGte?: InputMaybe<Scalars['Boolean']>;
  featuredIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  featuredIsNull?: InputMaybe<Scalars['Boolean']>;
  featuredLike?: InputMaybe<Scalars['Boolean']>;
  featuredLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  featuredLt?: InputMaybe<Scalars['Boolean']>;
  featuredLte?: InputMaybe<Scalars['Boolean']>;
  featuredNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  fullBody?: InputMaybe<Scalars['String']>;
  fullBodyAny?: InputMaybe<Scalars['String']>;
  fullBodyContain?: InputMaybe<Scalars['String']>;
  fullBodyEq?: InputMaybe<Scalars['String']>;
  fullBodyGt?: InputMaybe<Scalars['String']>;
  fullBodyGte?: InputMaybe<Scalars['String']>;
  fullBodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullBodyIsNull?: InputMaybe<Scalars['Boolean']>;
  fullBodyLike?: InputMaybe<Scalars['String']>;
  fullBodyLikeNoCase?: InputMaybe<Scalars['String']>;
  fullBodyLt?: InputMaybe<Scalars['String']>;
  fullBodyLte?: InputMaybe<Scalars['String']>;
  fullBodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldExcerpt?: InputMaybe<Scalars['String']>;
  oldExcerptAny?: InputMaybe<Scalars['String']>;
  oldExcerptContain?: InputMaybe<Scalars['String']>;
  oldExcerptEq?: InputMaybe<Scalars['String']>;
  oldExcerptGt?: InputMaybe<Scalars['String']>;
  oldExcerptGte?: InputMaybe<Scalars['String']>;
  oldExcerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldExcerptIsNull?: InputMaybe<Scalars['Boolean']>;
  oldExcerptLike?: InputMaybe<Scalars['String']>;
  oldExcerptLikeNoCase?: InputMaybe<Scalars['String']>;
  oldExcerptLt?: InputMaybe<Scalars['String']>;
  oldExcerptLte?: InputMaybe<Scalars['String']>;
  oldExcerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLPostsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLPostsPropertiesEnum>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedAny?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['String']>;
  publishedAtAny?: InputMaybe<Scalars['String']>;
  publishedAtContain?: InputMaybe<Scalars['String']>;
  publishedAtEq?: InputMaybe<Scalars['String']>;
  publishedAtGt?: InputMaybe<Scalars['String']>;
  publishedAtGte?: InputMaybe<Scalars['String']>;
  publishedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedAtLike?: InputMaybe<Scalars['String']>;
  publishedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  publishedAtLt?: InputMaybe<Scalars['String']>;
  publishedAtLte?: InputMaybe<Scalars['String']>;
  publishedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedContain?: InputMaybe<Scalars['Boolean']>;
  publishedEq?: InputMaybe<Scalars['Boolean']>;
  publishedGt?: InputMaybe<Scalars['Boolean']>;
  publishedGte?: InputMaybe<Scalars['Boolean']>;
  publishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  publishedIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedLike?: InputMaybe<Scalars['Boolean']>;
  publishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  publishedLt?: InputMaybe<Scalars['Boolean']>;
  publishedLte?: InputMaybe<Scalars['Boolean']>;
  publishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Scalars['Int']>;
  typeIdAny?: InputMaybe<Scalars['Int']>;
  typeIdContain?: InputMaybe<Scalars['Int']>;
  typeIdEq?: InputMaybe<Scalars['Int']>;
  typeIdGt?: InputMaybe<Scalars['Int']>;
  typeIdGte?: InputMaybe<Scalars['Int']>;
  typeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  typeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  typeIdLike?: InputMaybe<Scalars['Int']>;
  typeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  typeIdLt?: InputMaybe<Scalars['Int']>;
  typeIdLte?: InputMaybe<Scalars['Int']>;
  typeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoriesTaxonomiesArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedByAny?: InputMaybe<Scalars['String']>;
  deletedByContain?: InputMaybe<Scalars['String']>;
  deletedByEq?: InputMaybe<Scalars['String']>;
  deletedByGt?: InputMaybe<Scalars['String']>;
  deletedByGte?: InputMaybe<Scalars['String']>;
  deletedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedByIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedByLike?: InputMaybe<Scalars['String']>;
  deletedByLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedByLt?: InputMaybe<Scalars['String']>;
  deletedByLte?: InputMaybe<Scalars['String']>;
  deletedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTaxonomiesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTaxonomiesPropertiesEnum>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetModel?: InputMaybe<Scalars['String']>;
  targetModelAny?: InputMaybe<Scalars['String']>;
  targetModelContain?: InputMaybe<Scalars['String']>;
  targetModelEq?: InputMaybe<Scalars['String']>;
  targetModelGt?: InputMaybe<Scalars['String']>;
  targetModelGte?: InputMaybe<Scalars['String']>;
  targetModelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetModelIsNull?: InputMaybe<Scalars['Boolean']>;
  targetModelLike?: InputMaybe<Scalars['String']>;
  targetModelLikeNoCase?: InputMaybe<Scalars['String']>;
  targetModelLt?: InputMaybe<Scalars['String']>;
  targetModelLte?: InputMaybe<Scalars['String']>;
  targetModelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCase?: InputMaybe<Scalars['String']>;
  useCaseAny?: InputMaybe<Scalars['String']>;
  useCaseContain?: InputMaybe<Scalars['String']>;
  useCaseEq?: InputMaybe<Scalars['String']>;
  useCaseGt?: InputMaybe<Scalars['String']>;
  useCaseGte?: InputMaybe<Scalars['String']>;
  useCaseIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCaseIsNull?: InputMaybe<Scalars['Boolean']>;
  useCaseLike?: InputMaybe<Scalars['String']>;
  useCaseLikeNoCase?: InputMaybe<Scalars['String']>;
  useCaseLt?: InputMaybe<Scalars['String']>;
  useCaseLte?: InputMaybe<Scalars['String']>;
  useCaseNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoriesTextBlocksArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedByAny?: InputMaybe<Scalars['String']>;
  deletedByContain?: InputMaybe<Scalars['String']>;
  deletedByEq?: InputMaybe<Scalars['String']>;
  deletedByGt?: InputMaybe<Scalars['String']>;
  deletedByGte?: InputMaybe<Scalars['String']>;
  deletedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedByIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedByLike?: InputMaybe<Scalars['String']>;
  deletedByLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedByLt?: InputMaybe<Scalars['String']>;
  deletedByLte?: InputMaybe<Scalars['String']>;
  deletedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIds?: InputMaybe<Scalars['JSON']>;
  offerIdsAny?: InputMaybe<Scalars['JSON']>;
  offerIdsContain?: InputMaybe<Scalars['JSON']>;
  offerIdsEq?: InputMaybe<Scalars['JSON']>;
  offerIdsGt?: InputMaybe<Scalars['JSON']>;
  offerIdsGte?: InputMaybe<Scalars['JSON']>;
  offerIdsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  offerIdsIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdsLike?: InputMaybe<Scalars['JSON']>;
  offerIdsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  offerIdsLt?: InputMaybe<Scalars['JSON']>;
  offerIdsLte?: InputMaybe<Scalars['JSON']>;
  offerIdsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTextBlocksPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTextBlocksPropertiesEnum>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  queryString?: InputMaybe<Scalars['JSON']>;
  queryStringAny?: InputMaybe<Scalars['JSON']>;
  queryStringContain?: InputMaybe<Scalars['JSON']>;
  queryStringEq?: InputMaybe<Scalars['JSON']>;
  queryStringGt?: InputMaybe<Scalars['JSON']>;
  queryStringGte?: InputMaybe<Scalars['JSON']>;
  queryStringIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  queryStringIsNull?: InputMaybe<Scalars['Boolean']>;
  queryStringLike?: InputMaybe<Scalars['JSON']>;
  queryStringLikeNoCase?: InputMaybe<Scalars['JSON']>;
  queryStringLt?: InputMaybe<Scalars['JSON']>;
  queryStringLte?: InputMaybe<Scalars['JSON']>;
  queryStringNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  text?: InputMaybe<Scalars['String']>;
  textAny?: InputMaybe<Scalars['String']>;
  textContain?: InputMaybe<Scalars['String']>;
  textEq?: InputMaybe<Scalars['String']>;
  textGt?: InputMaybe<Scalars['String']>;
  textGte?: InputMaybe<Scalars['String']>;
  textIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textIsNull?: InputMaybe<Scalars['Boolean']>;
  textLike?: InputMaybe<Scalars['String']>;
  textLikeNoCase?: InputMaybe<Scalars['String']>;
  textLt?: InputMaybe<Scalars['String']>;
  textLte?: InputMaybe<Scalars['String']>;
  textNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoriesTopicsArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerpt?: InputMaybe<Scalars['String']>;
  excerptAny?: InputMaybe<Scalars['String']>;
  excerptContain?: InputMaybe<Scalars['String']>;
  excerptEq?: InputMaybe<Scalars['String']>;
  excerptGt?: InputMaybe<Scalars['String']>;
  excerptGte?: InputMaybe<Scalars['String']>;
  excerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerptIsNull?: InputMaybe<Scalars['Boolean']>;
  excerptLike?: InputMaybe<Scalars['String']>;
  excerptLikeNoCase?: InputMaybe<Scalars['String']>;
  excerptLt?: InputMaybe<Scalars['String']>;
  excerptLte?: InputMaybe<Scalars['String']>;
  excerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featured?: InputMaybe<Scalars['Boolean']>;
  featuredAny?: InputMaybe<Scalars['Boolean']>;
  featuredContain?: InputMaybe<Scalars['Boolean']>;
  featuredEq?: InputMaybe<Scalars['Boolean']>;
  featuredGt?: InputMaybe<Scalars['Boolean']>;
  featuredGte?: InputMaybe<Scalars['Boolean']>;
  featuredIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  featuredIsNull?: InputMaybe<Scalars['Boolean']>;
  featuredLike?: InputMaybe<Scalars['Boolean']>;
  featuredLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  featuredLt?: InputMaybe<Scalars['Boolean']>;
  featuredLte?: InputMaybe<Scalars['Boolean']>;
  featuredNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  fullBody?: InputMaybe<Scalars['String']>;
  fullBodyAny?: InputMaybe<Scalars['String']>;
  fullBodyContain?: InputMaybe<Scalars['String']>;
  fullBodyEq?: InputMaybe<Scalars['String']>;
  fullBodyGt?: InputMaybe<Scalars['String']>;
  fullBodyGte?: InputMaybe<Scalars['String']>;
  fullBodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullBodyIsNull?: InputMaybe<Scalars['Boolean']>;
  fullBodyLike?: InputMaybe<Scalars['String']>;
  fullBodyLikeNoCase?: InputMaybe<Scalars['String']>;
  fullBodyLt?: InputMaybe<Scalars['String']>;
  fullBodyLte?: InputMaybe<Scalars['String']>;
  fullBodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldExcerpt?: InputMaybe<Scalars['String']>;
  oldExcerptAny?: InputMaybe<Scalars['String']>;
  oldExcerptContain?: InputMaybe<Scalars['String']>;
  oldExcerptEq?: InputMaybe<Scalars['String']>;
  oldExcerptGt?: InputMaybe<Scalars['String']>;
  oldExcerptGte?: InputMaybe<Scalars['String']>;
  oldExcerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldExcerptIsNull?: InputMaybe<Scalars['Boolean']>;
  oldExcerptLike?: InputMaybe<Scalars['String']>;
  oldExcerptLikeNoCase?: InputMaybe<Scalars['String']>;
  oldExcerptLt?: InputMaybe<Scalars['String']>;
  oldExcerptLte?: InputMaybe<Scalars['String']>;
  oldExcerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLPostsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLPostsPropertiesEnum>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedAny?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['String']>;
  publishedAtAny?: InputMaybe<Scalars['String']>;
  publishedAtContain?: InputMaybe<Scalars['String']>;
  publishedAtEq?: InputMaybe<Scalars['String']>;
  publishedAtGt?: InputMaybe<Scalars['String']>;
  publishedAtGte?: InputMaybe<Scalars['String']>;
  publishedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedAtLike?: InputMaybe<Scalars['String']>;
  publishedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  publishedAtLt?: InputMaybe<Scalars['String']>;
  publishedAtLte?: InputMaybe<Scalars['String']>;
  publishedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedContain?: InputMaybe<Scalars['Boolean']>;
  publishedEq?: InputMaybe<Scalars['Boolean']>;
  publishedGt?: InputMaybe<Scalars['Boolean']>;
  publishedGte?: InputMaybe<Scalars['Boolean']>;
  publishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  publishedIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedLike?: InputMaybe<Scalars['Boolean']>;
  publishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  publishedLt?: InputMaybe<Scalars['Boolean']>;
  publishedLte?: InputMaybe<Scalars['Boolean']>;
  publishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Scalars['Int']>;
  typeIdAny?: InputMaybe<Scalars['Int']>;
  typeIdContain?: InputMaybe<Scalars['Int']>;
  typeIdEq?: InputMaybe<Scalars['Int']>;
  typeIdGt?: InputMaybe<Scalars['Int']>;
  typeIdGte?: InputMaybe<Scalars['Int']>;
  typeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  typeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  typeIdLike?: InputMaybe<Scalars['Int']>;
  typeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  typeIdLt?: InputMaybe<Scalars['Int']>;
  typeIdLte?: InputMaybe<Scalars['Int']>;
  typeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoriesTrafficSourcesMapArgs = {
  accountId?: InputMaybe<Scalars['Int']>;
  accountIdAny?: InputMaybe<Scalars['Int']>;
  accountIdContain?: InputMaybe<Scalars['Int']>;
  accountIdEq?: InputMaybe<Scalars['Int']>;
  accountIdGt?: InputMaybe<Scalars['Int']>;
  accountIdGte?: InputMaybe<Scalars['Int']>;
  accountIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  accountIdIsNull?: InputMaybe<Scalars['Boolean']>;
  accountIdLike?: InputMaybe<Scalars['Int']>;
  accountIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  accountIdLt?: InputMaybe<Scalars['Int']>;
  accountIdLte?: InputMaybe<Scalars['Int']>;
  accountIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  excludeFromDailyPL?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLAny?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLContain?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLEq?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLGt?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLGte?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  excludeFromDailyPLIsNull?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLike?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLt?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLte?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  networkId?: InputMaybe<Scalars['Int']>;
  networkIdAny?: InputMaybe<Scalars['Int']>;
  networkIdContain?: InputMaybe<Scalars['Int']>;
  networkIdEq?: InputMaybe<Scalars['Int']>;
  networkIdGt?: InputMaybe<Scalars['Int']>;
  networkIdGte?: InputMaybe<Scalars['Int']>;
  networkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  networkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  networkIdLike?: InputMaybe<Scalars['Int']>;
  networkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  networkIdLt?: InputMaybe<Scalars['Int']>;
  networkIdLte?: InputMaybe<Scalars['Int']>;
  networkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTrafficSourceMapPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTrafficSourceMapPropertiesEnum>;
  trafficSource?: InputMaybe<Scalars['String']>;
  trafficSourceAny?: InputMaybe<Scalars['String']>;
  trafficSourceContain?: InputMaybe<Scalars['String']>;
  trafficSourceEq?: InputMaybe<Scalars['String']>;
  trafficSourceGt?: InputMaybe<Scalars['String']>;
  trafficSourceGte?: InputMaybe<Scalars['String']>;
  trafficSourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficSourceIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficSourceLike?: InputMaybe<Scalars['String']>;
  trafficSourceLikeNoCase?: InputMaybe<Scalars['String']>;
  trafficSourceLt?: InputMaybe<Scalars['String']>;
  trafficSourceLte?: InputMaybe<Scalars['String']>;
  trafficSourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficTypeId?: InputMaybe<Scalars['Int']>;
  trafficTypeIdAny?: InputMaybe<Scalars['Int']>;
  trafficTypeIdContain?: InputMaybe<Scalars['Int']>;
  trafficTypeIdEq?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  trafficTypeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficTypeIdLike?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoriesTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};


export type GQLCategoriesUrlArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMain?: InputMaybe<Scalars['Boolean']>;
  isMainAny?: InputMaybe<Scalars['Boolean']>;
  isMainContain?: InputMaybe<Scalars['Boolean']>;
  isMainEq?: InputMaybe<Scalars['Boolean']>;
  isMainGt?: InputMaybe<Scalars['Boolean']>;
  isMainGte?: InputMaybe<Scalars['Boolean']>;
  isMainIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMainIsNull?: InputMaybe<Scalars['Boolean']>;
  isMainLike?: InputMaybe<Scalars['Boolean']>;
  isMainLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isMainLt?: InputMaybe<Scalars['Boolean']>;
  isMainLte?: InputMaybe<Scalars['Boolean']>;
  isMainNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  meta?: InputMaybe<Scalars['JSON']>;
  metaAny?: InputMaybe<Scalars['JSON']>;
  metaContain?: InputMaybe<Scalars['JSON']>;
  metaEq?: InputMaybe<Scalars['JSON']>;
  metaGt?: InputMaybe<Scalars['JSON']>;
  metaGte?: InputMaybe<Scalars['JSON']>;
  metaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  metaIsNull?: InputMaybe<Scalars['Boolean']>;
  metaLike?: InputMaybe<Scalars['JSON']>;
  metaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  metaLt?: InputMaybe<Scalars['JSON']>;
  metaLte?: InputMaybe<Scalars['JSON']>;
  metaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  model?: InputMaybe<Scalars['String']>;
  modelAny?: InputMaybe<Scalars['String']>;
  modelContain?: InputMaybe<Scalars['String']>;
  modelEq?: InputMaybe<Scalars['String']>;
  modelGt?: InputMaybe<Scalars['String']>;
  modelGte?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['String']>;
  modelIdAny?: InputMaybe<Scalars['String']>;
  modelIdContain?: InputMaybe<Scalars['String']>;
  modelIdEq?: InputMaybe<Scalars['String']>;
  modelIdGt?: InputMaybe<Scalars['String']>;
  modelIdGte?: InputMaybe<Scalars['String']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['String']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['String']>;
  modelIdLt?: InputMaybe<Scalars['String']>;
  modelIdLte?: InputMaybe<Scalars['String']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIsNull?: InputMaybe<Scalars['Boolean']>;
  modelLike?: InputMaybe<Scalars['String']>;
  modelLikeNoCase?: InputMaybe<Scalars['String']>;
  modelLt?: InputMaybe<Scalars['String']>;
  modelLte?: InputMaybe<Scalars['String']>;
  modelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUrlsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUrlsPropertiesEnum>;
  redirectionStatusCode?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeAny?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeContain?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeEq?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  redirectionStatusCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  redirectionStatusCodeLike?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLikeNoCase?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  urlAny?: InputMaybe<Scalars['String']>;
  urlContain?: InputMaybe<Scalars['String']>;
  urlEq?: InputMaybe<Scalars['String']>;
  urlGt?: InputMaybe<Scalars['String']>;
  urlGte?: InputMaybe<Scalars['String']>;
  urlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlIsNull?: InputMaybe<Scalars['Boolean']>;
  urlLike?: InputMaybe<Scalars['String']>;
  urlLikeNoCase?: InputMaybe<Scalars['String']>;
  urlLt?: InputMaybe<Scalars['String']>;
  urlLte?: InputMaybe<Scalars['String']>;
  urlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoriesUrlsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMain?: InputMaybe<Scalars['Boolean']>;
  isMainAny?: InputMaybe<Scalars['Boolean']>;
  isMainContain?: InputMaybe<Scalars['Boolean']>;
  isMainEq?: InputMaybe<Scalars['Boolean']>;
  isMainGt?: InputMaybe<Scalars['Boolean']>;
  isMainGte?: InputMaybe<Scalars['Boolean']>;
  isMainIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMainIsNull?: InputMaybe<Scalars['Boolean']>;
  isMainLike?: InputMaybe<Scalars['Boolean']>;
  isMainLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isMainLt?: InputMaybe<Scalars['Boolean']>;
  isMainLte?: InputMaybe<Scalars['Boolean']>;
  isMainNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  meta?: InputMaybe<Scalars['JSON']>;
  metaAny?: InputMaybe<Scalars['JSON']>;
  metaContain?: InputMaybe<Scalars['JSON']>;
  metaEq?: InputMaybe<Scalars['JSON']>;
  metaGt?: InputMaybe<Scalars['JSON']>;
  metaGte?: InputMaybe<Scalars['JSON']>;
  metaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  metaIsNull?: InputMaybe<Scalars['Boolean']>;
  metaLike?: InputMaybe<Scalars['JSON']>;
  metaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  metaLt?: InputMaybe<Scalars['JSON']>;
  metaLte?: InputMaybe<Scalars['JSON']>;
  metaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  model?: InputMaybe<Scalars['String']>;
  modelAny?: InputMaybe<Scalars['String']>;
  modelContain?: InputMaybe<Scalars['String']>;
  modelEq?: InputMaybe<Scalars['String']>;
  modelGt?: InputMaybe<Scalars['String']>;
  modelGte?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['String']>;
  modelIdAny?: InputMaybe<Scalars['String']>;
  modelIdContain?: InputMaybe<Scalars['String']>;
  modelIdEq?: InputMaybe<Scalars['String']>;
  modelIdGt?: InputMaybe<Scalars['String']>;
  modelIdGte?: InputMaybe<Scalars['String']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['String']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['String']>;
  modelIdLt?: InputMaybe<Scalars['String']>;
  modelIdLte?: InputMaybe<Scalars['String']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIsNull?: InputMaybe<Scalars['Boolean']>;
  modelLike?: InputMaybe<Scalars['String']>;
  modelLikeNoCase?: InputMaybe<Scalars['String']>;
  modelLt?: InputMaybe<Scalars['String']>;
  modelLte?: InputMaybe<Scalars['String']>;
  modelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUrlsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUrlsPropertiesEnum>;
  redirectionStatusCode?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeAny?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeContain?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeEq?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  redirectionStatusCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  redirectionStatusCodeLike?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLikeNoCase?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  urlAny?: InputMaybe<Scalars['String']>;
  urlContain?: InputMaybe<Scalars['String']>;
  urlEq?: InputMaybe<Scalars['String']>;
  urlGt?: InputMaybe<Scalars['String']>;
  urlGte?: InputMaybe<Scalars['String']>;
  urlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlIsNull?: InputMaybe<Scalars['Boolean']>;
  urlLike?: InputMaybe<Scalars['String']>;
  urlLikeNoCase?: InputMaybe<Scalars['String']>;
  urlLt?: InputMaybe<Scalars['String']>;
  urlLte?: InputMaybe<Scalars['String']>;
  urlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoriesUsersArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLCategoriesPropertiesEnum {
  TcpaMessage = 'TCPAMessage',
  Appetite = 'appetite',
  AutoListing = 'autoListing',
  BestMatchCount = 'bestMatchCount',
  Config = 'config',
  CreatedAt = 'createdAt',
  Description = 'description',
  FetchedBuyersCount = 'fetchedBuyersCount',
  Headline = 'headline',
  IconId = 'iconId',
  Id = 'id',
  ImageId = 'imageId',
  IsBestMatch = 'isBestMatch',
  IsDeleted = 'isDeleted',
  IsOneToOneConsent = 'isOneToOneConsent',
  IsPublished = 'isPublished',
  Label = 'label',
  Languages = 'languages',
  MainImageId = 'mainImageId',
  Name = 'name',
  Notes = 'notes',
  Order = 'order',
  Overview = 'overview',
  ParentId = 'parentId',
  RequiresConsent = 'requiresConsent',
  SharedBuyersGroupSize = 'sharedBuyersGroupSize',
  Slug = 'slug',
  SlugAlias = 'slugAlias',
  Subtitle = 'subtitle',
  SupportedCountries = 'supportedCountries',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type GQLCategoryAttributes = {
  __typename?: 'CategoryAttributes';
  attributesGroup?: Maybe<GQLCategoryAttributesGroups>;
  category?: Maybe<GQLCategories>;
  categoryId?: Maybe<Scalars['Int']>;
  comparison?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  forceComparisonsDisplay?: Maybe<Scalars['Boolean']>;
  group?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['Int']>;
  groupSlug?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
  weight?: Maybe<Scalars['Int']>;
};


export type GQLCategoryAttributesAttributesGroupArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoryAttributesGroupsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoryAttributesGroupsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoryAttributesCategoryArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoryAttributesTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type GQLCategoryAttributesGroups = {
  __typename?: 'CategoryAttributesGroups';
  categoryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  updatedAt?: Maybe<Scalars['String']>;
};


export type GQLCategoryAttributesGroupsTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export enum GQLCategoryAttributesGroupsPropertiesEnum {
  CategoryId = 'categoryId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  Name = 'name',
  Order = 'order',
  Slug = 'slug',
  UpdatedAt = 'updatedAt'
}

export enum GQLCategoryAttributesPropertiesEnum {
  CategoryId = 'categoryId',
  Comparison = 'comparison',
  CreatedAt = 'createdAt',
  ForceComparisonsDisplay = 'forceComparisonsDisplay',
  Group = 'group',
  GroupId = 'groupId',
  GroupSlug = 'groupSlug',
  Hidden = 'hidden',
  Id = 'id',
  IsDeleted = 'isDeleted',
  Label = 'label',
  Name = 'name',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  Value = 'value',
  Weight = 'weight'
}

export type GQLCategoryAttributesValues = {
  __typename?: 'CategoryAttributesValues';
  attributeId?: Maybe<Scalars['Int']>;
  attributes?: Maybe<GQLCategoryAttributes>;
  baseAttribute?: Maybe<GQLCategoryAttributes>;
  createdAt?: Maybe<Scalars['String']>;
  hiddenAttributes?: Maybe<GQLCategoryAttributes>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  offer?: Maybe<GQLOffers>;
  offerId?: Maybe<Scalars['Int']>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  updatedAt?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  webAttributes?: Maybe<GQLCategoryAttributes>;
};


export type GQLCategoryAttributesValuesAttributesArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  comparison?: InputMaybe<Scalars['Boolean']>;
  comparisonAny?: InputMaybe<Scalars['Boolean']>;
  comparisonContain?: InputMaybe<Scalars['Boolean']>;
  comparisonEq?: InputMaybe<Scalars['Boolean']>;
  comparisonGt?: InputMaybe<Scalars['Boolean']>;
  comparisonGte?: InputMaybe<Scalars['Boolean']>;
  comparisonIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  comparisonIsNull?: InputMaybe<Scalars['Boolean']>;
  comparisonLike?: InputMaybe<Scalars['Boolean']>;
  comparisonLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  comparisonLt?: InputMaybe<Scalars['Boolean']>;
  comparisonLte?: InputMaybe<Scalars['Boolean']>;
  comparisonNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  forceComparisonsDisplay?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayAny?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayContain?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayEq?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayGt?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayGte?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  forceComparisonsDisplayIsNull?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLike?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLt?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLte?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  group?: InputMaybe<Scalars['String']>;
  groupAny?: InputMaybe<Scalars['String']>;
  groupContain?: InputMaybe<Scalars['String']>;
  groupEq?: InputMaybe<Scalars['String']>;
  groupGt?: InputMaybe<Scalars['String']>;
  groupGte?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['Int']>;
  groupIdAny?: InputMaybe<Scalars['Int']>;
  groupIdContain?: InputMaybe<Scalars['Int']>;
  groupIdEq?: InputMaybe<Scalars['Int']>;
  groupIdGt?: InputMaybe<Scalars['Int']>;
  groupIdGte?: InputMaybe<Scalars['Int']>;
  groupIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  groupIdIsNull?: InputMaybe<Scalars['Boolean']>;
  groupIdLike?: InputMaybe<Scalars['Int']>;
  groupIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  groupIdLt?: InputMaybe<Scalars['Int']>;
  groupIdLte?: InputMaybe<Scalars['Int']>;
  groupIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  groupIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupIsNull?: InputMaybe<Scalars['Boolean']>;
  groupLike?: InputMaybe<Scalars['String']>;
  groupLikeNoCase?: InputMaybe<Scalars['String']>;
  groupLt?: InputMaybe<Scalars['String']>;
  groupLte?: InputMaybe<Scalars['String']>;
  groupNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupSlug?: InputMaybe<Scalars['String']>;
  groupSlugAny?: InputMaybe<Scalars['String']>;
  groupSlugContain?: InputMaybe<Scalars['String']>;
  groupSlugEq?: InputMaybe<Scalars['String']>;
  groupSlugGt?: InputMaybe<Scalars['String']>;
  groupSlugGte?: InputMaybe<Scalars['String']>;
  groupSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  groupSlugLike?: InputMaybe<Scalars['String']>;
  groupSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  groupSlugLt?: InputMaybe<Scalars['String']>;
  groupSlugLte?: InputMaybe<Scalars['String']>;
  groupSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  hiddenAny?: InputMaybe<Scalars['Boolean']>;
  hiddenContain?: InputMaybe<Scalars['Boolean']>;
  hiddenEq?: InputMaybe<Scalars['Boolean']>;
  hiddenGt?: InputMaybe<Scalars['Boolean']>;
  hiddenGte?: InputMaybe<Scalars['Boolean']>;
  hiddenIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  hiddenIsNull?: InputMaybe<Scalars['Boolean']>;
  hiddenLike?: InputMaybe<Scalars['Boolean']>;
  hiddenLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  hiddenLt?: InputMaybe<Scalars['Boolean']>;
  hiddenLte?: InputMaybe<Scalars['Boolean']>;
  hiddenNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLCategoryAttributesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoryAttributesPropertiesEnum>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLCategoryAttributesValuesBaseAttributeArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  comparison?: InputMaybe<Scalars['Boolean']>;
  comparisonAny?: InputMaybe<Scalars['Boolean']>;
  comparisonContain?: InputMaybe<Scalars['Boolean']>;
  comparisonEq?: InputMaybe<Scalars['Boolean']>;
  comparisonGt?: InputMaybe<Scalars['Boolean']>;
  comparisonGte?: InputMaybe<Scalars['Boolean']>;
  comparisonIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  comparisonIsNull?: InputMaybe<Scalars['Boolean']>;
  comparisonLike?: InputMaybe<Scalars['Boolean']>;
  comparisonLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  comparisonLt?: InputMaybe<Scalars['Boolean']>;
  comparisonLte?: InputMaybe<Scalars['Boolean']>;
  comparisonNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  forceComparisonsDisplay?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayAny?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayContain?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayEq?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayGt?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayGte?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  forceComparisonsDisplayIsNull?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLike?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLt?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLte?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  group?: InputMaybe<Scalars['String']>;
  groupAny?: InputMaybe<Scalars['String']>;
  groupContain?: InputMaybe<Scalars['String']>;
  groupEq?: InputMaybe<Scalars['String']>;
  groupGt?: InputMaybe<Scalars['String']>;
  groupGte?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['Int']>;
  groupIdAny?: InputMaybe<Scalars['Int']>;
  groupIdContain?: InputMaybe<Scalars['Int']>;
  groupIdEq?: InputMaybe<Scalars['Int']>;
  groupIdGt?: InputMaybe<Scalars['Int']>;
  groupIdGte?: InputMaybe<Scalars['Int']>;
  groupIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  groupIdIsNull?: InputMaybe<Scalars['Boolean']>;
  groupIdLike?: InputMaybe<Scalars['Int']>;
  groupIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  groupIdLt?: InputMaybe<Scalars['Int']>;
  groupIdLte?: InputMaybe<Scalars['Int']>;
  groupIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  groupIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupIsNull?: InputMaybe<Scalars['Boolean']>;
  groupLike?: InputMaybe<Scalars['String']>;
  groupLikeNoCase?: InputMaybe<Scalars['String']>;
  groupLt?: InputMaybe<Scalars['String']>;
  groupLte?: InputMaybe<Scalars['String']>;
  groupNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupSlug?: InputMaybe<Scalars['String']>;
  groupSlugAny?: InputMaybe<Scalars['String']>;
  groupSlugContain?: InputMaybe<Scalars['String']>;
  groupSlugEq?: InputMaybe<Scalars['String']>;
  groupSlugGt?: InputMaybe<Scalars['String']>;
  groupSlugGte?: InputMaybe<Scalars['String']>;
  groupSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  groupSlugLike?: InputMaybe<Scalars['String']>;
  groupSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  groupSlugLt?: InputMaybe<Scalars['String']>;
  groupSlugLte?: InputMaybe<Scalars['String']>;
  groupSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  hiddenAny?: InputMaybe<Scalars['Boolean']>;
  hiddenContain?: InputMaybe<Scalars['Boolean']>;
  hiddenEq?: InputMaybe<Scalars['Boolean']>;
  hiddenGt?: InputMaybe<Scalars['Boolean']>;
  hiddenGte?: InputMaybe<Scalars['Boolean']>;
  hiddenIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  hiddenIsNull?: InputMaybe<Scalars['Boolean']>;
  hiddenLike?: InputMaybe<Scalars['Boolean']>;
  hiddenLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  hiddenLt?: InputMaybe<Scalars['Boolean']>;
  hiddenLte?: InputMaybe<Scalars['Boolean']>;
  hiddenNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLCategoryAttributesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoryAttributesPropertiesEnum>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLCategoryAttributesValuesHiddenAttributesArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  comparison?: InputMaybe<Scalars['Boolean']>;
  comparisonAny?: InputMaybe<Scalars['Boolean']>;
  comparisonContain?: InputMaybe<Scalars['Boolean']>;
  comparisonEq?: InputMaybe<Scalars['Boolean']>;
  comparisonGt?: InputMaybe<Scalars['Boolean']>;
  comparisonGte?: InputMaybe<Scalars['Boolean']>;
  comparisonIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  comparisonIsNull?: InputMaybe<Scalars['Boolean']>;
  comparisonLike?: InputMaybe<Scalars['Boolean']>;
  comparisonLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  comparisonLt?: InputMaybe<Scalars['Boolean']>;
  comparisonLte?: InputMaybe<Scalars['Boolean']>;
  comparisonNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  forceComparisonsDisplay?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayAny?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayContain?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayEq?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayGt?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayGte?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  forceComparisonsDisplayIsNull?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLike?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLt?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLte?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  group?: InputMaybe<Scalars['String']>;
  groupAny?: InputMaybe<Scalars['String']>;
  groupContain?: InputMaybe<Scalars['String']>;
  groupEq?: InputMaybe<Scalars['String']>;
  groupGt?: InputMaybe<Scalars['String']>;
  groupGte?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['Int']>;
  groupIdAny?: InputMaybe<Scalars['Int']>;
  groupIdContain?: InputMaybe<Scalars['Int']>;
  groupIdEq?: InputMaybe<Scalars['Int']>;
  groupIdGt?: InputMaybe<Scalars['Int']>;
  groupIdGte?: InputMaybe<Scalars['Int']>;
  groupIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  groupIdIsNull?: InputMaybe<Scalars['Boolean']>;
  groupIdLike?: InputMaybe<Scalars['Int']>;
  groupIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  groupIdLt?: InputMaybe<Scalars['Int']>;
  groupIdLte?: InputMaybe<Scalars['Int']>;
  groupIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  groupIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupIsNull?: InputMaybe<Scalars['Boolean']>;
  groupLike?: InputMaybe<Scalars['String']>;
  groupLikeNoCase?: InputMaybe<Scalars['String']>;
  groupLt?: InputMaybe<Scalars['String']>;
  groupLte?: InputMaybe<Scalars['String']>;
  groupNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupSlug?: InputMaybe<Scalars['String']>;
  groupSlugAny?: InputMaybe<Scalars['String']>;
  groupSlugContain?: InputMaybe<Scalars['String']>;
  groupSlugEq?: InputMaybe<Scalars['String']>;
  groupSlugGt?: InputMaybe<Scalars['String']>;
  groupSlugGte?: InputMaybe<Scalars['String']>;
  groupSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  groupSlugLike?: InputMaybe<Scalars['String']>;
  groupSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  groupSlugLt?: InputMaybe<Scalars['String']>;
  groupSlugLte?: InputMaybe<Scalars['String']>;
  groupSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  hiddenAny?: InputMaybe<Scalars['Boolean']>;
  hiddenContain?: InputMaybe<Scalars['Boolean']>;
  hiddenEq?: InputMaybe<Scalars['Boolean']>;
  hiddenGt?: InputMaybe<Scalars['Boolean']>;
  hiddenGte?: InputMaybe<Scalars['Boolean']>;
  hiddenIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  hiddenIsNull?: InputMaybe<Scalars['Boolean']>;
  hiddenLike?: InputMaybe<Scalars['Boolean']>;
  hiddenLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  hiddenLt?: InputMaybe<Scalars['Boolean']>;
  hiddenLte?: InputMaybe<Scalars['Boolean']>;
  hiddenNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLCategoryAttributesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoryAttributesPropertiesEnum>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLCategoryAttributesValuesOfferArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checkWallet?: InputMaybe<Scalars['Boolean']>;
  checkWalletAny?: InputMaybe<Scalars['Boolean']>;
  checkWalletContain?: InputMaybe<Scalars['Boolean']>;
  checkWalletEq?: InputMaybe<Scalars['Boolean']>;
  checkWalletGt?: InputMaybe<Scalars['Boolean']>;
  checkWalletGte?: InputMaybe<Scalars['Boolean']>;
  checkWalletIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  checkWalletIsNull?: InputMaybe<Scalars['Boolean']>;
  checkWalletLike?: InputMaybe<Scalars['Boolean']>;
  checkWalletLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  checkWalletLt?: InputMaybe<Scalars['Boolean']>;
  checkWalletLte?: InputMaybe<Scalars['Boolean']>;
  checkWalletNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultAffiliateLinkId?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdAny?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdContain?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdEq?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  defaultAffiliateLinkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultAffiliateLinkIdLike?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrl?: InputMaybe<Scalars['String']>;
  displayUrlAny?: InputMaybe<Scalars['String']>;
  displayUrlContain?: InputMaybe<Scalars['String']>;
  displayUrlEq?: InputMaybe<Scalars['String']>;
  displayUrlGt?: InputMaybe<Scalars['String']>;
  displayUrlGte?: InputMaybe<Scalars['String']>;
  displayUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  displayUrlLike?: InputMaybe<Scalars['String']>;
  displayUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  displayUrlLt?: InputMaybe<Scalars['String']>;
  displayUrlLte?: InputMaybe<Scalars['String']>;
  displayUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalData?: InputMaybe<Scalars['JSON']>;
  externalDataAny?: InputMaybe<Scalars['JSON']>;
  externalDataContain?: InputMaybe<Scalars['JSON']>;
  externalDataEq?: InputMaybe<Scalars['JSON']>;
  externalDataGt?: InputMaybe<Scalars['JSON']>;
  externalDataGte?: InputMaybe<Scalars['JSON']>;
  externalDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  externalDataIsNull?: InputMaybe<Scalars['Boolean']>;
  externalDataLike?: InputMaybe<Scalars['JSON']>;
  externalDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  externalDataLt?: InputMaybe<Scalars['JSON']>;
  externalDataLte?: InputMaybe<Scalars['JSON']>;
  externalDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  featuresListTitle?: InputMaybe<Scalars['String']>;
  featuresListTitleAny?: InputMaybe<Scalars['String']>;
  featuresListTitleContain?: InputMaybe<Scalars['String']>;
  featuresListTitleEq?: InputMaybe<Scalars['String']>;
  featuresListTitleGt?: InputMaybe<Scalars['String']>;
  featuresListTitleGte?: InputMaybe<Scalars['String']>;
  featuresListTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuresListTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  featuresListTitleLike?: InputMaybe<Scalars['String']>;
  featuresListTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  featuresListTitleLt?: InputMaybe<Scalars['String']>;
  featuresListTitleLte?: InputMaybe<Scalars['String']>;
  featuresListTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  isPausedAny?: InputMaybe<Scalars['Boolean']>;
  isPausedContain?: InputMaybe<Scalars['Boolean']>;
  isPausedEq?: InputMaybe<Scalars['Boolean']>;
  isPausedGt?: InputMaybe<Scalars['Boolean']>;
  isPausedGte?: InputMaybe<Scalars['Boolean']>;
  isPausedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPausedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPausedLike?: InputMaybe<Scalars['Boolean']>;
  isPausedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPausedLt?: InputMaybe<Scalars['Boolean']>;
  isPausedLte?: InputMaybe<Scalars['Boolean']>;
  isPausedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldOverview?: InputMaybe<Scalars['String']>;
  oldOverviewAny?: InputMaybe<Scalars['String']>;
  oldOverviewContain?: InputMaybe<Scalars['String']>;
  oldOverviewEq?: InputMaybe<Scalars['String']>;
  oldOverviewGt?: InputMaybe<Scalars['String']>;
  oldOverviewGte?: InputMaybe<Scalars['String']>;
  oldOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  oldOverviewLike?: InputMaybe<Scalars['String']>;
  oldOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  oldOverviewLt?: InputMaybe<Scalars['String']>;
  oldOverviewLte?: InputMaybe<Scalars['String']>;
  oldOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOffersPropertiesEnum>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescription?: InputMaybe<Scalars['String']>;
  previewDescriptionAny?: InputMaybe<Scalars['String']>;
  previewDescriptionContain?: InputMaybe<Scalars['String']>;
  previewDescriptionEq?: InputMaybe<Scalars['String']>;
  previewDescriptionGt?: InputMaybe<Scalars['String']>;
  previewDescriptionGte?: InputMaybe<Scalars['String']>;
  previewDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  previewDescriptionLike?: InputMaybe<Scalars['String']>;
  previewDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  previewDescriptionLt?: InputMaybe<Scalars['String']>;
  previewDescriptionLte?: InputMaybe<Scalars['String']>;
  previewDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverview?: InputMaybe<Scalars['String']>;
  quickOverviewAny?: InputMaybe<Scalars['String']>;
  quickOverviewContain?: InputMaybe<Scalars['String']>;
  quickOverviewEq?: InputMaybe<Scalars['String']>;
  quickOverviewGt?: InputMaybe<Scalars['String']>;
  quickOverviewGte?: InputMaybe<Scalars['String']>;
  quickOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  quickOverviewLike?: InputMaybe<Scalars['String']>;
  quickOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  quickOverviewLt?: InputMaybe<Scalars['String']>;
  quickOverviewLte?: InputMaybe<Scalars['String']>;
  quickOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  score?: InputMaybe<Scalars['Float']>;
  scoreAny?: InputMaybe<Scalars['Float']>;
  scoreContain?: InputMaybe<Scalars['Float']>;
  scoreEq?: InputMaybe<Scalars['Float']>;
  scoreGt?: InputMaybe<Scalars['Float']>;
  scoreGte?: InputMaybe<Scalars['Float']>;
  scoreIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  scoreIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreLike?: InputMaybe<Scalars['Float']>;
  scoreLikeNoCase?: InputMaybe<Scalars['Float']>;
  scoreLt?: InputMaybe<Scalars['Float']>;
  scoreLte?: InputMaybe<Scalars['Float']>;
  scoreMessage?: InputMaybe<Scalars['String']>;
  scoreMessageAny?: InputMaybe<Scalars['String']>;
  scoreMessageContain?: InputMaybe<Scalars['String']>;
  scoreMessageEq?: InputMaybe<Scalars['String']>;
  scoreMessageGt?: InputMaybe<Scalars['String']>;
  scoreMessageGte?: InputMaybe<Scalars['String']>;
  scoreMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreMessageLike?: InputMaybe<Scalars['String']>;
  scoreMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  scoreMessageLt?: InputMaybe<Scalars['String']>;
  scoreMessageLte?: InputMaybe<Scalars['String']>;
  scoreMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleAny?: InputMaybe<Scalars['String']>;
  subTitleContain?: InputMaybe<Scalars['String']>;
  subTitleEq?: InputMaybe<Scalars['String']>;
  subTitleGt?: InputMaybe<Scalars['String']>;
  subTitleGte?: InputMaybe<Scalars['String']>;
  subTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subTitleLike?: InputMaybe<Scalars['String']>;
  subTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subTitleLt?: InputMaybe<Scalars['String']>;
  subTitleLte?: InputMaybe<Scalars['String']>;
  subTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescription?: InputMaybe<Scalars['String']>;
  summaryDescriptionAny?: InputMaybe<Scalars['String']>;
  summaryDescriptionContain?: InputMaybe<Scalars['String']>;
  summaryDescriptionEq?: InputMaybe<Scalars['String']>;
  summaryDescriptionGt?: InputMaybe<Scalars['String']>;
  summaryDescriptionGte?: InputMaybe<Scalars['String']>;
  summaryDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryDescriptionLike?: InputMaybe<Scalars['String']>;
  summaryDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryDescriptionLt?: InputMaybe<Scalars['String']>;
  summaryDescriptionLte?: InputMaybe<Scalars['String']>;
  summaryDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitle?: InputMaybe<Scalars['String']>;
  summaryTitleAny?: InputMaybe<Scalars['String']>;
  summaryTitleContain?: InputMaybe<Scalars['String']>;
  summaryTitleEq?: InputMaybe<Scalars['String']>;
  summaryTitleGt?: InputMaybe<Scalars['String']>;
  summaryTitleGte?: InputMaybe<Scalars['String']>;
  summaryTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryTitleLike?: InputMaybe<Scalars['String']>;
  summaryTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryTitleLt?: InputMaybe<Scalars['String']>;
  summaryTitleLte?: InputMaybe<Scalars['String']>;
  summaryTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCategoryAttributesValuesTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};


export type GQLCategoryAttributesValuesWebAttributesArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  comparison?: InputMaybe<Scalars['Boolean']>;
  comparisonAny?: InputMaybe<Scalars['Boolean']>;
  comparisonContain?: InputMaybe<Scalars['Boolean']>;
  comparisonEq?: InputMaybe<Scalars['Boolean']>;
  comparisonGt?: InputMaybe<Scalars['Boolean']>;
  comparisonGte?: InputMaybe<Scalars['Boolean']>;
  comparisonIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  comparisonIsNull?: InputMaybe<Scalars['Boolean']>;
  comparisonLike?: InputMaybe<Scalars['Boolean']>;
  comparisonLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  comparisonLt?: InputMaybe<Scalars['Boolean']>;
  comparisonLte?: InputMaybe<Scalars['Boolean']>;
  comparisonNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  forceComparisonsDisplay?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayAny?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayContain?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayEq?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayGt?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayGte?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  forceComparisonsDisplayIsNull?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLike?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLt?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLte?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  group?: InputMaybe<Scalars['String']>;
  groupAny?: InputMaybe<Scalars['String']>;
  groupContain?: InputMaybe<Scalars['String']>;
  groupEq?: InputMaybe<Scalars['String']>;
  groupGt?: InputMaybe<Scalars['String']>;
  groupGte?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['Int']>;
  groupIdAny?: InputMaybe<Scalars['Int']>;
  groupIdContain?: InputMaybe<Scalars['Int']>;
  groupIdEq?: InputMaybe<Scalars['Int']>;
  groupIdGt?: InputMaybe<Scalars['Int']>;
  groupIdGte?: InputMaybe<Scalars['Int']>;
  groupIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  groupIdIsNull?: InputMaybe<Scalars['Boolean']>;
  groupIdLike?: InputMaybe<Scalars['Int']>;
  groupIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  groupIdLt?: InputMaybe<Scalars['Int']>;
  groupIdLte?: InputMaybe<Scalars['Int']>;
  groupIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  groupIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupIsNull?: InputMaybe<Scalars['Boolean']>;
  groupLike?: InputMaybe<Scalars['String']>;
  groupLikeNoCase?: InputMaybe<Scalars['String']>;
  groupLt?: InputMaybe<Scalars['String']>;
  groupLte?: InputMaybe<Scalars['String']>;
  groupNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupSlug?: InputMaybe<Scalars['String']>;
  groupSlugAny?: InputMaybe<Scalars['String']>;
  groupSlugContain?: InputMaybe<Scalars['String']>;
  groupSlugEq?: InputMaybe<Scalars['String']>;
  groupSlugGt?: InputMaybe<Scalars['String']>;
  groupSlugGte?: InputMaybe<Scalars['String']>;
  groupSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  groupSlugLike?: InputMaybe<Scalars['String']>;
  groupSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  groupSlugLt?: InputMaybe<Scalars['String']>;
  groupSlugLte?: InputMaybe<Scalars['String']>;
  groupSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  hiddenAny?: InputMaybe<Scalars['Boolean']>;
  hiddenContain?: InputMaybe<Scalars['Boolean']>;
  hiddenEq?: InputMaybe<Scalars['Boolean']>;
  hiddenGt?: InputMaybe<Scalars['Boolean']>;
  hiddenGte?: InputMaybe<Scalars['Boolean']>;
  hiddenIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  hiddenIsNull?: InputMaybe<Scalars['Boolean']>;
  hiddenLike?: InputMaybe<Scalars['Boolean']>;
  hiddenLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  hiddenLt?: InputMaybe<Scalars['Boolean']>;
  hiddenLte?: InputMaybe<Scalars['Boolean']>;
  hiddenNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLCategoryAttributesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoryAttributesPropertiesEnum>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export enum GQLCategoryAttributesValuesPropertiesEnum {
  AttributeId = 'attributeId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsDeleted = 'isDeleted',
  OfferId = 'offerId',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

export type GQLCustomTextBlocksPositions = {
  __typename?: 'CustomTextBlocksPositions';
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  deletedBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  textBlocks?: Maybe<Array<Maybe<GQLTextBlocks>>>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  user?: Maybe<GQLUsers>;
};


export type GQLCustomTextBlocksPositionsTextBlocksArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedByAny?: InputMaybe<Scalars['String']>;
  deletedByContain?: InputMaybe<Scalars['String']>;
  deletedByEq?: InputMaybe<Scalars['String']>;
  deletedByGt?: InputMaybe<Scalars['String']>;
  deletedByGte?: InputMaybe<Scalars['String']>;
  deletedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedByIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedByLike?: InputMaybe<Scalars['String']>;
  deletedByLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedByLt?: InputMaybe<Scalars['String']>;
  deletedByLte?: InputMaybe<Scalars['String']>;
  deletedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIds?: InputMaybe<Scalars['JSON']>;
  offerIdsAny?: InputMaybe<Scalars['JSON']>;
  offerIdsContain?: InputMaybe<Scalars['JSON']>;
  offerIdsEq?: InputMaybe<Scalars['JSON']>;
  offerIdsGt?: InputMaybe<Scalars['JSON']>;
  offerIdsGte?: InputMaybe<Scalars['JSON']>;
  offerIdsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  offerIdsIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdsLike?: InputMaybe<Scalars['JSON']>;
  offerIdsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  offerIdsLt?: InputMaybe<Scalars['JSON']>;
  offerIdsLte?: InputMaybe<Scalars['JSON']>;
  offerIdsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTextBlocksPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTextBlocksPropertiesEnum>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  queryString?: InputMaybe<Scalars['JSON']>;
  queryStringAny?: InputMaybe<Scalars['JSON']>;
  queryStringContain?: InputMaybe<Scalars['JSON']>;
  queryStringEq?: InputMaybe<Scalars['JSON']>;
  queryStringGt?: InputMaybe<Scalars['JSON']>;
  queryStringGte?: InputMaybe<Scalars['JSON']>;
  queryStringIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  queryStringIsNull?: InputMaybe<Scalars['Boolean']>;
  queryStringLike?: InputMaybe<Scalars['JSON']>;
  queryStringLikeNoCase?: InputMaybe<Scalars['JSON']>;
  queryStringLt?: InputMaybe<Scalars['JSON']>;
  queryStringLte?: InputMaybe<Scalars['JSON']>;
  queryStringNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  text?: InputMaybe<Scalars['String']>;
  textAny?: InputMaybe<Scalars['String']>;
  textContain?: InputMaybe<Scalars['String']>;
  textEq?: InputMaybe<Scalars['String']>;
  textGt?: InputMaybe<Scalars['String']>;
  textGte?: InputMaybe<Scalars['String']>;
  textIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textIsNull?: InputMaybe<Scalars['Boolean']>;
  textLike?: InputMaybe<Scalars['String']>;
  textLikeNoCase?: InputMaybe<Scalars['String']>;
  textLt?: InputMaybe<Scalars['String']>;
  textLte?: InputMaybe<Scalars['String']>;
  textNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLCustomTextBlocksPositionsUserArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLCustomTextBlocksPositionsPropertiesEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  Label = 'label',
  Position = 'position',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy'
}

export type GQLDkis = {
  __typename?: 'Dkis';
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export enum GQLDkisPropertiesEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  Name = 'name',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type GQLDomainCategories = {
  __typename?: 'DomainCategories';
  category?: Maybe<GQLCategories>;
  categoryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  crossSellingDomainFormId?: Maybe<Scalars['Int']>;
  domainId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['String']>;
};


export type GQLDomainCategoriesCategoryArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLDomainCategoriesPropertiesEnum {
  CategoryId = 'categoryId',
  CreatedAt = 'createdAt',
  CrossSellingDomainFormId = 'crossSellingDomainFormId',
  DomainId = 'domainId',
  Order = 'order',
  UpdatedAt = 'updatedAt'
}

export type GQLDomainForms = {
  __typename?: 'DomainForms';
  category?: Maybe<GQLCategories>;
  categoryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  domain?: Maybe<GQLDomains>;
  domainId?: Maybe<Scalars['Int']>;
  form?: Maybe<GQLForms>;
  formId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  integrations?: Maybe<Scalars['JSON']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['String']>;
};


export type GQLDomainFormsCategoryArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainFormsDomainArgs = {
  allowedLanguages?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesAny?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesContain?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesEq?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  allowedLanguagesIsNull?: InputMaybe<Scalars['Boolean']>;
  allowedLanguagesLike?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  analyticsCodeId?: InputMaybe<Scalars['String']>;
  analyticsCodeIdAny?: InputMaybe<Scalars['String']>;
  analyticsCodeIdContain?: InputMaybe<Scalars['String']>;
  analyticsCodeIdEq?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  analyticsCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  analyticsCodeIdLike?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cacheSettings?: InputMaybe<Scalars['JSON']>;
  cacheSettingsAny?: InputMaybe<Scalars['JSON']>;
  cacheSettingsContain?: InputMaybe<Scalars['JSON']>;
  cacheSettingsEq?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  cacheSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  cacheSettingsLike?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  clickyCodeId?: InputMaybe<Scalars['String']>;
  clickyCodeIdAny?: InputMaybe<Scalars['String']>;
  clickyCodeIdContain?: InputMaybe<Scalars['String']>;
  clickyCodeIdEq?: InputMaybe<Scalars['String']>;
  clickyCodeIdGt?: InputMaybe<Scalars['String']>;
  clickyCodeIdGte?: InputMaybe<Scalars['String']>;
  clickyCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clickyCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  clickyCodeIdLike?: InputMaybe<Scalars['String']>;
  clickyCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  clickyCodeIdLt?: InputMaybe<Scalars['String']>;
  clickyCodeIdLte?: InputMaybe<Scalars['String']>;
  clickyCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  enableChatWidget?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetAny?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetContain?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetEq?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableChatWidgetIsNull?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLike?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaId?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdAny?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdContain?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdEq?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLike?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedForm?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormAny?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormContain?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormEq?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedFormIsNull?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLike?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  facebookConversionAPISettings?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsAny?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsContain?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsEq?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookConversionAPISettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookConversionAPISettingsLike?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookSiteVerificationCode?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fallbackSettings?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsAny?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsContain?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsEq?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  fallbackSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  fallbackSettingsLike?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  faviconId?: InputMaybe<Scalars['String']>;
  faviconIdAny?: InputMaybe<Scalars['String']>;
  faviconIdContain?: InputMaybe<Scalars['String']>;
  faviconIdEq?: InputMaybe<Scalars['String']>;
  faviconIdGt?: InputMaybe<Scalars['String']>;
  faviconIdGte?: InputMaybe<Scalars['String']>;
  faviconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  faviconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  faviconIdLike?: InputMaybe<Scalars['String']>;
  faviconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  faviconIdLt?: InputMaybe<Scalars['String']>;
  faviconIdLte?: InputMaybe<Scalars['String']>;
  faviconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCode?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  googleSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmId?: InputMaybe<Scalars['String']>;
  gtmIdAny?: InputMaybe<Scalars['String']>;
  gtmIdContain?: InputMaybe<Scalars['String']>;
  gtmIdEq?: InputMaybe<Scalars['String']>;
  gtmIdGt?: InputMaybe<Scalars['String']>;
  gtmIdGte?: InputMaybe<Scalars['String']>;
  gtmIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmIdIsNull?: InputMaybe<Scalars['Boolean']>;
  gtmIdLike?: InputMaybe<Scalars['String']>;
  gtmIdLikeNoCase?: InputMaybe<Scalars['String']>;
  gtmIdLt?: InputMaybe<Scalars['String']>;
  gtmIdLte?: InputMaybe<Scalars['String']>;
  gtmIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  holdingRules?: InputMaybe<Scalars['JSON']>;
  holdingRulesAny?: InputMaybe<Scalars['JSON']>;
  holdingRulesContain?: InputMaybe<Scalars['JSON']>;
  holdingRulesEq?: InputMaybe<Scalars['JSON']>;
  holdingRulesGt?: InputMaybe<Scalars['JSON']>;
  holdingRulesGte?: InputMaybe<Scalars['JSON']>;
  holdingRulesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  holdingRulesIsNull?: InputMaybe<Scalars['Boolean']>;
  holdingRulesLike?: InputMaybe<Scalars['JSON']>;
  holdingRulesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  holdingRulesLt?: InputMaybe<Scalars['JSON']>;
  holdingRulesLte?: InputMaybe<Scalars['JSON']>;
  holdingRulesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabled?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledAny?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledContain?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledEq?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabledIsNull?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLike?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainsPropertiesEnum>;
  otpVerificationCriteria?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaAny?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaContain?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaEq?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  otpVerificationCriteriaIsNull?: InputMaybe<Scalars['Boolean']>;
  otpVerificationCriteriaLike?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfig?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigAny?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigContain?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigEq?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  recaptchaConfigLike?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  secondaryLogoId?: InputMaybe<Scalars['String']>;
  secondaryLogoIdAny?: InputMaybe<Scalars['String']>;
  secondaryLogoIdContain?: InputMaybe<Scalars['String']>;
  secondaryLogoIdEq?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondaryLogoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  secondaryLogoIdLike?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sendNotifications?: InputMaybe<Scalars['JSON']>;
  sendNotificationsAny?: InputMaybe<Scalars['JSON']>;
  sendNotificationsContain?: InputMaybe<Scalars['JSON']>;
  sendNotificationsEq?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  sendNotificationsIsNull?: InputMaybe<Scalars['Boolean']>;
  sendNotificationsLike?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settings?: InputMaybe<Scalars['JSON']>;
  settingsAny?: InputMaybe<Scalars['JSON']>;
  settingsContain?: InputMaybe<Scalars['JSON']>;
  settingsEq?: InputMaybe<Scalars['JSON']>;
  settingsGt?: InputMaybe<Scalars['JSON']>;
  settingsGte?: InputMaybe<Scalars['JSON']>;
  settingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settingsIsNull?: InputMaybe<Scalars['Boolean']>;
  settingsLike?: InputMaybe<Scalars['JSON']>;
  settingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  settingsLt?: InputMaybe<Scalars['JSON']>;
  settingsLte?: InputMaybe<Scalars['JSON']>;
  settingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  slogan?: InputMaybe<Scalars['String']>;
  sloganAny?: InputMaybe<Scalars['String']>;
  sloganContain?: InputMaybe<Scalars['String']>;
  sloganEq?: InputMaybe<Scalars['String']>;
  sloganGt?: InputMaybe<Scalars['String']>;
  sloganGte?: InputMaybe<Scalars['String']>;
  sloganIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sloganIsNull?: InputMaybe<Scalars['Boolean']>;
  sloganLike?: InputMaybe<Scalars['String']>;
  sloganLikeNoCase?: InputMaybe<Scalars['String']>;
  sloganLt?: InputMaybe<Scalars['String']>;
  sloganLte?: InputMaybe<Scalars['String']>;
  sloganNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateConfig?: InputMaybe<Scalars['JSON']>;
  templateConfigAny?: InputMaybe<Scalars['JSON']>;
  templateConfigContain?: InputMaybe<Scalars['JSON']>;
  templateConfigEq?: InputMaybe<Scalars['JSON']>;
  templateConfigGt?: InputMaybe<Scalars['JSON']>;
  templateConfigGte?: InputMaybe<Scalars['JSON']>;
  templateConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  templateConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  templateConfigLike?: InputMaybe<Scalars['JSON']>;
  templateConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  templateConfigLt?: InputMaybe<Scalars['JSON']>;
  templateConfigLte?: InputMaybe<Scalars['JSON']>;
  templateConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixel?: InputMaybe<Scalars['String']>;
  twitterPixelAny?: InputMaybe<Scalars['String']>;
  twitterPixelContain?: InputMaybe<Scalars['String']>;
  twitterPixelEq?: InputMaybe<Scalars['String']>;
  twitterPixelGt?: InputMaybe<Scalars['String']>;
  twitterPixelGte?: InputMaybe<Scalars['String']>;
  twitterPixelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixelIsNull?: InputMaybe<Scalars['Boolean']>;
  twitterPixelLike?: InputMaybe<Scalars['String']>;
  twitterPixelLikeNoCase?: InputMaybe<Scalars['String']>;
  twitterPixelLt?: InputMaybe<Scalars['String']>;
  twitterPixelLte?: InputMaybe<Scalars['String']>;
  twitterPixelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainFormsFormArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorMessageAny?: InputMaybe<Scalars['String']>;
  errorMessageContain?: InputMaybe<Scalars['String']>;
  errorMessageEq?: InputMaybe<Scalars['String']>;
  errorMessageGt?: InputMaybe<Scalars['String']>;
  errorMessageGte?: InputMaybe<Scalars['String']>;
  errorMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  errorMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  errorMessageLike?: InputMaybe<Scalars['String']>;
  errorMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  errorMessageLt?: InputMaybe<Scalars['String']>;
  errorMessageLte?: InputMaybe<Scalars['String']>;
  errorMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVariant?: InputMaybe<Scalars['Boolean']>;
  isVariantAny?: InputMaybe<Scalars['Boolean']>;
  isVariantContain?: InputMaybe<Scalars['Boolean']>;
  isVariantEq?: InputMaybe<Scalars['Boolean']>;
  isVariantGt?: InputMaybe<Scalars['Boolean']>;
  isVariantGte?: InputMaybe<Scalars['Boolean']>;
  isVariantIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVariantIsNull?: InputMaybe<Scalars['Boolean']>;
  isVariantLike?: InputMaybe<Scalars['Boolean']>;
  isVariantLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVariantLt?: InputMaybe<Scalars['Boolean']>;
  isVariantLte?: InputMaybe<Scalars['Boolean']>;
  isVariantNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingId?: InputMaybe<Scalars['Int']>;
  listingIdAny?: InputMaybe<Scalars['Int']>;
  listingIdContain?: InputMaybe<Scalars['Int']>;
  listingIdEq?: InputMaybe<Scalars['Int']>;
  listingIdGt?: InputMaybe<Scalars['Int']>;
  listingIdGte?: InputMaybe<Scalars['Int']>;
  listingIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingIdIsNull?: InputMaybe<Scalars['Boolean']>;
  listingIdLike?: InputMaybe<Scalars['Int']>;
  listingIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  listingIdLt?: InputMaybe<Scalars['Int']>;
  listingIdLte?: InputMaybe<Scalars['Int']>;
  listingIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modifiedAt?: InputMaybe<Scalars['String']>;
  modifiedAtAny?: InputMaybe<Scalars['String']>;
  modifiedAtContain?: InputMaybe<Scalars['String']>;
  modifiedAtEq?: InputMaybe<Scalars['String']>;
  modifiedAtGt?: InputMaybe<Scalars['String']>;
  modifiedAtGte?: InputMaybe<Scalars['String']>;
  modifiedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedAtLike?: InputMaybe<Scalars['String']>;
  modifiedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedAtLt?: InputMaybe<Scalars['String']>;
  modifiedAtLte?: InputMaybe<Scalars['String']>;
  modifiedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLFormsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLFormsPropertiesEnum>;
  stepToFetchBuyers?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersAny?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersContain?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersEq?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersGt?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersGte?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToFetchBuyersIsNull?: InputMaybe<Scalars['Boolean']>;
  stepToFetchBuyersLike?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersLikeNoCase?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersLt?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersLte?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToSendingData?: InputMaybe<Scalars['Int']>;
  stepToSendingDataAny?: InputMaybe<Scalars['Int']>;
  stepToSendingDataContain?: InputMaybe<Scalars['Int']>;
  stepToSendingDataEq?: InputMaybe<Scalars['Int']>;
  stepToSendingDataGt?: InputMaybe<Scalars['Int']>;
  stepToSendingDataGte?: InputMaybe<Scalars['Int']>;
  stepToSendingDataIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToSendingDataIsNull?: InputMaybe<Scalars['Boolean']>;
  stepToSendingDataLike?: InputMaybe<Scalars['Int']>;
  stepToSendingDataLikeNoCase?: InputMaybe<Scalars['Int']>;
  stepToSendingDataLt?: InputMaybe<Scalars['Int']>;
  stepToSendingDataLte?: InputMaybe<Scalars['Int']>;
  stepToSendingDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  successMessage?: InputMaybe<Scalars['String']>;
  successMessageAny?: InputMaybe<Scalars['String']>;
  successMessageContain?: InputMaybe<Scalars['String']>;
  successMessageEq?: InputMaybe<Scalars['String']>;
  successMessageGt?: InputMaybe<Scalars['String']>;
  successMessageGte?: InputMaybe<Scalars['String']>;
  successMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  successMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  successMessageLike?: InputMaybe<Scalars['String']>;
  successMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  successMessageLt?: InputMaybe<Scalars['String']>;
  successMessageLte?: InputMaybe<Scalars['String']>;
  successMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  variantParentId?: InputMaybe<Scalars['Int']>;
  variantParentIdAny?: InputMaybe<Scalars['Int']>;
  variantParentIdContain?: InputMaybe<Scalars['Int']>;
  variantParentIdEq?: InputMaybe<Scalars['Int']>;
  variantParentIdGt?: InputMaybe<Scalars['Int']>;
  variantParentIdGte?: InputMaybe<Scalars['Int']>;
  variantParentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  variantParentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  variantParentIdLike?: InputMaybe<Scalars['Int']>;
  variantParentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  variantParentIdLt?: InputMaybe<Scalars['Int']>;
  variantParentIdLte?: InputMaybe<Scalars['Int']>;
  variantParentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export enum GQLDomainFormsPropertiesEnum {
  CategoryId = 'categoryId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  DomainId = 'domainId',
  FormId = 'formId',
  Id = 'id',
  Integrations = 'integrations',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  UpdatedAt = 'updatedAt'
}

export type GQLDomainListings = {
  __typename?: 'DomainListings';
  createdAt?: Maybe<Scalars['String']>;
  domainId?: Maybe<Scalars['Int']>;
  isComparison?: Maybe<Scalars['Boolean']>;
  listingId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
};

export enum GQLDomainListingsPropertiesEnum {
  CreatedAt = 'createdAt',
  DomainId = 'domainId',
  IsComparison = 'isComparison',
  ListingId = 'listingId',
  UpdatedAt = 'updatedAt',
  Weight = 'weight'
}

export type GQLDomainMetatags = {
  __typename?: 'DomainMetatags';
  createdAt?: Maybe<Scalars['String']>;
  domain?: Maybe<Array<Maybe<GQLDomains>>>;
  domainId?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};


export type GQLDomainMetatagsDomainArgs = {
  allowedLanguages?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesAny?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesContain?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesEq?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  allowedLanguagesIsNull?: InputMaybe<Scalars['Boolean']>;
  allowedLanguagesLike?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  analyticsCodeId?: InputMaybe<Scalars['String']>;
  analyticsCodeIdAny?: InputMaybe<Scalars['String']>;
  analyticsCodeIdContain?: InputMaybe<Scalars['String']>;
  analyticsCodeIdEq?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  analyticsCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  analyticsCodeIdLike?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cacheSettings?: InputMaybe<Scalars['JSON']>;
  cacheSettingsAny?: InputMaybe<Scalars['JSON']>;
  cacheSettingsContain?: InputMaybe<Scalars['JSON']>;
  cacheSettingsEq?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  cacheSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  cacheSettingsLike?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  clickyCodeId?: InputMaybe<Scalars['String']>;
  clickyCodeIdAny?: InputMaybe<Scalars['String']>;
  clickyCodeIdContain?: InputMaybe<Scalars['String']>;
  clickyCodeIdEq?: InputMaybe<Scalars['String']>;
  clickyCodeIdGt?: InputMaybe<Scalars['String']>;
  clickyCodeIdGte?: InputMaybe<Scalars['String']>;
  clickyCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clickyCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  clickyCodeIdLike?: InputMaybe<Scalars['String']>;
  clickyCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  clickyCodeIdLt?: InputMaybe<Scalars['String']>;
  clickyCodeIdLte?: InputMaybe<Scalars['String']>;
  clickyCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  enableChatWidget?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetAny?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetContain?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetEq?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableChatWidgetIsNull?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLike?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaId?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdAny?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdContain?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdEq?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLike?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedForm?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormAny?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormContain?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormEq?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedFormIsNull?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLike?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  facebookConversionAPISettings?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsAny?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsContain?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsEq?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookConversionAPISettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookConversionAPISettingsLike?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookSiteVerificationCode?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fallbackSettings?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsAny?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsContain?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsEq?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  fallbackSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  fallbackSettingsLike?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  faviconId?: InputMaybe<Scalars['String']>;
  faviconIdAny?: InputMaybe<Scalars['String']>;
  faviconIdContain?: InputMaybe<Scalars['String']>;
  faviconIdEq?: InputMaybe<Scalars['String']>;
  faviconIdGt?: InputMaybe<Scalars['String']>;
  faviconIdGte?: InputMaybe<Scalars['String']>;
  faviconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  faviconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  faviconIdLike?: InputMaybe<Scalars['String']>;
  faviconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  faviconIdLt?: InputMaybe<Scalars['String']>;
  faviconIdLte?: InputMaybe<Scalars['String']>;
  faviconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCode?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  googleSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmId?: InputMaybe<Scalars['String']>;
  gtmIdAny?: InputMaybe<Scalars['String']>;
  gtmIdContain?: InputMaybe<Scalars['String']>;
  gtmIdEq?: InputMaybe<Scalars['String']>;
  gtmIdGt?: InputMaybe<Scalars['String']>;
  gtmIdGte?: InputMaybe<Scalars['String']>;
  gtmIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmIdIsNull?: InputMaybe<Scalars['Boolean']>;
  gtmIdLike?: InputMaybe<Scalars['String']>;
  gtmIdLikeNoCase?: InputMaybe<Scalars['String']>;
  gtmIdLt?: InputMaybe<Scalars['String']>;
  gtmIdLte?: InputMaybe<Scalars['String']>;
  gtmIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  holdingRules?: InputMaybe<Scalars['JSON']>;
  holdingRulesAny?: InputMaybe<Scalars['JSON']>;
  holdingRulesContain?: InputMaybe<Scalars['JSON']>;
  holdingRulesEq?: InputMaybe<Scalars['JSON']>;
  holdingRulesGt?: InputMaybe<Scalars['JSON']>;
  holdingRulesGte?: InputMaybe<Scalars['JSON']>;
  holdingRulesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  holdingRulesIsNull?: InputMaybe<Scalars['Boolean']>;
  holdingRulesLike?: InputMaybe<Scalars['JSON']>;
  holdingRulesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  holdingRulesLt?: InputMaybe<Scalars['JSON']>;
  holdingRulesLte?: InputMaybe<Scalars['JSON']>;
  holdingRulesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabled?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledAny?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledContain?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledEq?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabledIsNull?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLike?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainsPropertiesEnum>;
  otpVerificationCriteria?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaAny?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaContain?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaEq?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  otpVerificationCriteriaIsNull?: InputMaybe<Scalars['Boolean']>;
  otpVerificationCriteriaLike?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfig?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigAny?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigContain?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigEq?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  recaptchaConfigLike?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  secondaryLogoId?: InputMaybe<Scalars['String']>;
  secondaryLogoIdAny?: InputMaybe<Scalars['String']>;
  secondaryLogoIdContain?: InputMaybe<Scalars['String']>;
  secondaryLogoIdEq?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondaryLogoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  secondaryLogoIdLike?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sendNotifications?: InputMaybe<Scalars['JSON']>;
  sendNotificationsAny?: InputMaybe<Scalars['JSON']>;
  sendNotificationsContain?: InputMaybe<Scalars['JSON']>;
  sendNotificationsEq?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  sendNotificationsIsNull?: InputMaybe<Scalars['Boolean']>;
  sendNotificationsLike?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settings?: InputMaybe<Scalars['JSON']>;
  settingsAny?: InputMaybe<Scalars['JSON']>;
  settingsContain?: InputMaybe<Scalars['JSON']>;
  settingsEq?: InputMaybe<Scalars['JSON']>;
  settingsGt?: InputMaybe<Scalars['JSON']>;
  settingsGte?: InputMaybe<Scalars['JSON']>;
  settingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settingsIsNull?: InputMaybe<Scalars['Boolean']>;
  settingsLike?: InputMaybe<Scalars['JSON']>;
  settingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  settingsLt?: InputMaybe<Scalars['JSON']>;
  settingsLte?: InputMaybe<Scalars['JSON']>;
  settingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  slogan?: InputMaybe<Scalars['String']>;
  sloganAny?: InputMaybe<Scalars['String']>;
  sloganContain?: InputMaybe<Scalars['String']>;
  sloganEq?: InputMaybe<Scalars['String']>;
  sloganGt?: InputMaybe<Scalars['String']>;
  sloganGte?: InputMaybe<Scalars['String']>;
  sloganIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sloganIsNull?: InputMaybe<Scalars['Boolean']>;
  sloganLike?: InputMaybe<Scalars['String']>;
  sloganLikeNoCase?: InputMaybe<Scalars['String']>;
  sloganLt?: InputMaybe<Scalars['String']>;
  sloganLte?: InputMaybe<Scalars['String']>;
  sloganNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateConfig?: InputMaybe<Scalars['JSON']>;
  templateConfigAny?: InputMaybe<Scalars['JSON']>;
  templateConfigContain?: InputMaybe<Scalars['JSON']>;
  templateConfigEq?: InputMaybe<Scalars['JSON']>;
  templateConfigGt?: InputMaybe<Scalars['JSON']>;
  templateConfigGte?: InputMaybe<Scalars['JSON']>;
  templateConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  templateConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  templateConfigLike?: InputMaybe<Scalars['JSON']>;
  templateConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  templateConfigLt?: InputMaybe<Scalars['JSON']>;
  templateConfigLte?: InputMaybe<Scalars['JSON']>;
  templateConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixel?: InputMaybe<Scalars['String']>;
  twitterPixelAny?: InputMaybe<Scalars['String']>;
  twitterPixelContain?: InputMaybe<Scalars['String']>;
  twitterPixelEq?: InputMaybe<Scalars['String']>;
  twitterPixelGt?: InputMaybe<Scalars['String']>;
  twitterPixelGte?: InputMaybe<Scalars['String']>;
  twitterPixelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixelIsNull?: InputMaybe<Scalars['Boolean']>;
  twitterPixelLike?: InputMaybe<Scalars['String']>;
  twitterPixelLikeNoCase?: InputMaybe<Scalars['String']>;
  twitterPixelLt?: InputMaybe<Scalars['String']>;
  twitterPixelLte?: InputMaybe<Scalars['String']>;
  twitterPixelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLDomainMetatagsPropertiesEnum {
  CreatedAt = 'createdAt',
  DomainId = 'domainId',
  IsDeleted = 'isDeleted',
  Key = 'key',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

export type GQLDomainOffers = {
  __typename?: 'DomainOffers';
  categoryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  domain?: Maybe<GQLDomains>;
  domainId?: Maybe<Scalars['Int']>;
  domains?: Maybe<Array<Maybe<GQLDomains>>>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  offer?: Maybe<GQLOffers>;
  offerId?: Maybe<Scalars['Int']>;
  offers?: Maybe<Array<Maybe<GQLOffers>>>;
  placements?: Maybe<Scalars['JSON']>;
  sticky?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
};


export type GQLDomainOffersDomainArgs = {
  allowedLanguages?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesAny?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesContain?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesEq?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  allowedLanguagesIsNull?: InputMaybe<Scalars['Boolean']>;
  allowedLanguagesLike?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  analyticsCodeId?: InputMaybe<Scalars['String']>;
  analyticsCodeIdAny?: InputMaybe<Scalars['String']>;
  analyticsCodeIdContain?: InputMaybe<Scalars['String']>;
  analyticsCodeIdEq?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  analyticsCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  analyticsCodeIdLike?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cacheSettings?: InputMaybe<Scalars['JSON']>;
  cacheSettingsAny?: InputMaybe<Scalars['JSON']>;
  cacheSettingsContain?: InputMaybe<Scalars['JSON']>;
  cacheSettingsEq?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  cacheSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  cacheSettingsLike?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  clickyCodeId?: InputMaybe<Scalars['String']>;
  clickyCodeIdAny?: InputMaybe<Scalars['String']>;
  clickyCodeIdContain?: InputMaybe<Scalars['String']>;
  clickyCodeIdEq?: InputMaybe<Scalars['String']>;
  clickyCodeIdGt?: InputMaybe<Scalars['String']>;
  clickyCodeIdGte?: InputMaybe<Scalars['String']>;
  clickyCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clickyCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  clickyCodeIdLike?: InputMaybe<Scalars['String']>;
  clickyCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  clickyCodeIdLt?: InputMaybe<Scalars['String']>;
  clickyCodeIdLte?: InputMaybe<Scalars['String']>;
  clickyCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  enableChatWidget?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetAny?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetContain?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetEq?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableChatWidgetIsNull?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLike?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaId?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdAny?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdContain?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdEq?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLike?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedForm?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormAny?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormContain?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormEq?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedFormIsNull?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLike?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  facebookConversionAPISettings?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsAny?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsContain?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsEq?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookConversionAPISettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookConversionAPISettingsLike?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookSiteVerificationCode?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fallbackSettings?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsAny?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsContain?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsEq?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  fallbackSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  fallbackSettingsLike?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  faviconId?: InputMaybe<Scalars['String']>;
  faviconIdAny?: InputMaybe<Scalars['String']>;
  faviconIdContain?: InputMaybe<Scalars['String']>;
  faviconIdEq?: InputMaybe<Scalars['String']>;
  faviconIdGt?: InputMaybe<Scalars['String']>;
  faviconIdGte?: InputMaybe<Scalars['String']>;
  faviconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  faviconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  faviconIdLike?: InputMaybe<Scalars['String']>;
  faviconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  faviconIdLt?: InputMaybe<Scalars['String']>;
  faviconIdLte?: InputMaybe<Scalars['String']>;
  faviconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCode?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  googleSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmId?: InputMaybe<Scalars['String']>;
  gtmIdAny?: InputMaybe<Scalars['String']>;
  gtmIdContain?: InputMaybe<Scalars['String']>;
  gtmIdEq?: InputMaybe<Scalars['String']>;
  gtmIdGt?: InputMaybe<Scalars['String']>;
  gtmIdGte?: InputMaybe<Scalars['String']>;
  gtmIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmIdIsNull?: InputMaybe<Scalars['Boolean']>;
  gtmIdLike?: InputMaybe<Scalars['String']>;
  gtmIdLikeNoCase?: InputMaybe<Scalars['String']>;
  gtmIdLt?: InputMaybe<Scalars['String']>;
  gtmIdLte?: InputMaybe<Scalars['String']>;
  gtmIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  holdingRules?: InputMaybe<Scalars['JSON']>;
  holdingRulesAny?: InputMaybe<Scalars['JSON']>;
  holdingRulesContain?: InputMaybe<Scalars['JSON']>;
  holdingRulesEq?: InputMaybe<Scalars['JSON']>;
  holdingRulesGt?: InputMaybe<Scalars['JSON']>;
  holdingRulesGte?: InputMaybe<Scalars['JSON']>;
  holdingRulesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  holdingRulesIsNull?: InputMaybe<Scalars['Boolean']>;
  holdingRulesLike?: InputMaybe<Scalars['JSON']>;
  holdingRulesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  holdingRulesLt?: InputMaybe<Scalars['JSON']>;
  holdingRulesLte?: InputMaybe<Scalars['JSON']>;
  holdingRulesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabled?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledAny?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledContain?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledEq?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabledIsNull?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLike?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainsPropertiesEnum>;
  otpVerificationCriteria?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaAny?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaContain?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaEq?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  otpVerificationCriteriaIsNull?: InputMaybe<Scalars['Boolean']>;
  otpVerificationCriteriaLike?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfig?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigAny?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigContain?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigEq?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  recaptchaConfigLike?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  secondaryLogoId?: InputMaybe<Scalars['String']>;
  secondaryLogoIdAny?: InputMaybe<Scalars['String']>;
  secondaryLogoIdContain?: InputMaybe<Scalars['String']>;
  secondaryLogoIdEq?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondaryLogoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  secondaryLogoIdLike?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sendNotifications?: InputMaybe<Scalars['JSON']>;
  sendNotificationsAny?: InputMaybe<Scalars['JSON']>;
  sendNotificationsContain?: InputMaybe<Scalars['JSON']>;
  sendNotificationsEq?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  sendNotificationsIsNull?: InputMaybe<Scalars['Boolean']>;
  sendNotificationsLike?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settings?: InputMaybe<Scalars['JSON']>;
  settingsAny?: InputMaybe<Scalars['JSON']>;
  settingsContain?: InputMaybe<Scalars['JSON']>;
  settingsEq?: InputMaybe<Scalars['JSON']>;
  settingsGt?: InputMaybe<Scalars['JSON']>;
  settingsGte?: InputMaybe<Scalars['JSON']>;
  settingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settingsIsNull?: InputMaybe<Scalars['Boolean']>;
  settingsLike?: InputMaybe<Scalars['JSON']>;
  settingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  settingsLt?: InputMaybe<Scalars['JSON']>;
  settingsLte?: InputMaybe<Scalars['JSON']>;
  settingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  slogan?: InputMaybe<Scalars['String']>;
  sloganAny?: InputMaybe<Scalars['String']>;
  sloganContain?: InputMaybe<Scalars['String']>;
  sloganEq?: InputMaybe<Scalars['String']>;
  sloganGt?: InputMaybe<Scalars['String']>;
  sloganGte?: InputMaybe<Scalars['String']>;
  sloganIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sloganIsNull?: InputMaybe<Scalars['Boolean']>;
  sloganLike?: InputMaybe<Scalars['String']>;
  sloganLikeNoCase?: InputMaybe<Scalars['String']>;
  sloganLt?: InputMaybe<Scalars['String']>;
  sloganLte?: InputMaybe<Scalars['String']>;
  sloganNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateConfig?: InputMaybe<Scalars['JSON']>;
  templateConfigAny?: InputMaybe<Scalars['JSON']>;
  templateConfigContain?: InputMaybe<Scalars['JSON']>;
  templateConfigEq?: InputMaybe<Scalars['JSON']>;
  templateConfigGt?: InputMaybe<Scalars['JSON']>;
  templateConfigGte?: InputMaybe<Scalars['JSON']>;
  templateConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  templateConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  templateConfigLike?: InputMaybe<Scalars['JSON']>;
  templateConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  templateConfigLt?: InputMaybe<Scalars['JSON']>;
  templateConfigLte?: InputMaybe<Scalars['JSON']>;
  templateConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixel?: InputMaybe<Scalars['String']>;
  twitterPixelAny?: InputMaybe<Scalars['String']>;
  twitterPixelContain?: InputMaybe<Scalars['String']>;
  twitterPixelEq?: InputMaybe<Scalars['String']>;
  twitterPixelGt?: InputMaybe<Scalars['String']>;
  twitterPixelGte?: InputMaybe<Scalars['String']>;
  twitterPixelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixelIsNull?: InputMaybe<Scalars['Boolean']>;
  twitterPixelLike?: InputMaybe<Scalars['String']>;
  twitterPixelLikeNoCase?: InputMaybe<Scalars['String']>;
  twitterPixelLt?: InputMaybe<Scalars['String']>;
  twitterPixelLte?: InputMaybe<Scalars['String']>;
  twitterPixelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainOffersDomainsArgs = {
  allowedLanguages?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesAny?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesContain?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesEq?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  allowedLanguagesIsNull?: InputMaybe<Scalars['Boolean']>;
  allowedLanguagesLike?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  analyticsCodeId?: InputMaybe<Scalars['String']>;
  analyticsCodeIdAny?: InputMaybe<Scalars['String']>;
  analyticsCodeIdContain?: InputMaybe<Scalars['String']>;
  analyticsCodeIdEq?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  analyticsCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  analyticsCodeIdLike?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cacheSettings?: InputMaybe<Scalars['JSON']>;
  cacheSettingsAny?: InputMaybe<Scalars['JSON']>;
  cacheSettingsContain?: InputMaybe<Scalars['JSON']>;
  cacheSettingsEq?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  cacheSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  cacheSettingsLike?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  clickyCodeId?: InputMaybe<Scalars['String']>;
  clickyCodeIdAny?: InputMaybe<Scalars['String']>;
  clickyCodeIdContain?: InputMaybe<Scalars['String']>;
  clickyCodeIdEq?: InputMaybe<Scalars['String']>;
  clickyCodeIdGt?: InputMaybe<Scalars['String']>;
  clickyCodeIdGte?: InputMaybe<Scalars['String']>;
  clickyCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clickyCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  clickyCodeIdLike?: InputMaybe<Scalars['String']>;
  clickyCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  clickyCodeIdLt?: InputMaybe<Scalars['String']>;
  clickyCodeIdLte?: InputMaybe<Scalars['String']>;
  clickyCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  enableChatWidget?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetAny?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetContain?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetEq?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableChatWidgetIsNull?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLike?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaId?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdAny?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdContain?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdEq?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLike?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedForm?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormAny?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormContain?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormEq?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedFormIsNull?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLike?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  facebookConversionAPISettings?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsAny?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsContain?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsEq?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookConversionAPISettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookConversionAPISettingsLike?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookSiteVerificationCode?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fallbackSettings?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsAny?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsContain?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsEq?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  fallbackSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  fallbackSettingsLike?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  faviconId?: InputMaybe<Scalars['String']>;
  faviconIdAny?: InputMaybe<Scalars['String']>;
  faviconIdContain?: InputMaybe<Scalars['String']>;
  faviconIdEq?: InputMaybe<Scalars['String']>;
  faviconIdGt?: InputMaybe<Scalars['String']>;
  faviconIdGte?: InputMaybe<Scalars['String']>;
  faviconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  faviconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  faviconIdLike?: InputMaybe<Scalars['String']>;
  faviconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  faviconIdLt?: InputMaybe<Scalars['String']>;
  faviconIdLte?: InputMaybe<Scalars['String']>;
  faviconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCode?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  googleSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmId?: InputMaybe<Scalars['String']>;
  gtmIdAny?: InputMaybe<Scalars['String']>;
  gtmIdContain?: InputMaybe<Scalars['String']>;
  gtmIdEq?: InputMaybe<Scalars['String']>;
  gtmIdGt?: InputMaybe<Scalars['String']>;
  gtmIdGte?: InputMaybe<Scalars['String']>;
  gtmIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmIdIsNull?: InputMaybe<Scalars['Boolean']>;
  gtmIdLike?: InputMaybe<Scalars['String']>;
  gtmIdLikeNoCase?: InputMaybe<Scalars['String']>;
  gtmIdLt?: InputMaybe<Scalars['String']>;
  gtmIdLte?: InputMaybe<Scalars['String']>;
  gtmIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  holdingRules?: InputMaybe<Scalars['JSON']>;
  holdingRulesAny?: InputMaybe<Scalars['JSON']>;
  holdingRulesContain?: InputMaybe<Scalars['JSON']>;
  holdingRulesEq?: InputMaybe<Scalars['JSON']>;
  holdingRulesGt?: InputMaybe<Scalars['JSON']>;
  holdingRulesGte?: InputMaybe<Scalars['JSON']>;
  holdingRulesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  holdingRulesIsNull?: InputMaybe<Scalars['Boolean']>;
  holdingRulesLike?: InputMaybe<Scalars['JSON']>;
  holdingRulesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  holdingRulesLt?: InputMaybe<Scalars['JSON']>;
  holdingRulesLte?: InputMaybe<Scalars['JSON']>;
  holdingRulesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabled?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledAny?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledContain?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledEq?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabledIsNull?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLike?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainsPropertiesEnum>;
  otpVerificationCriteria?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaAny?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaContain?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaEq?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  otpVerificationCriteriaIsNull?: InputMaybe<Scalars['Boolean']>;
  otpVerificationCriteriaLike?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfig?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigAny?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigContain?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigEq?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  recaptchaConfigLike?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  secondaryLogoId?: InputMaybe<Scalars['String']>;
  secondaryLogoIdAny?: InputMaybe<Scalars['String']>;
  secondaryLogoIdContain?: InputMaybe<Scalars['String']>;
  secondaryLogoIdEq?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondaryLogoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  secondaryLogoIdLike?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sendNotifications?: InputMaybe<Scalars['JSON']>;
  sendNotificationsAny?: InputMaybe<Scalars['JSON']>;
  sendNotificationsContain?: InputMaybe<Scalars['JSON']>;
  sendNotificationsEq?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  sendNotificationsIsNull?: InputMaybe<Scalars['Boolean']>;
  sendNotificationsLike?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settings?: InputMaybe<Scalars['JSON']>;
  settingsAny?: InputMaybe<Scalars['JSON']>;
  settingsContain?: InputMaybe<Scalars['JSON']>;
  settingsEq?: InputMaybe<Scalars['JSON']>;
  settingsGt?: InputMaybe<Scalars['JSON']>;
  settingsGte?: InputMaybe<Scalars['JSON']>;
  settingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settingsIsNull?: InputMaybe<Scalars['Boolean']>;
  settingsLike?: InputMaybe<Scalars['JSON']>;
  settingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  settingsLt?: InputMaybe<Scalars['JSON']>;
  settingsLte?: InputMaybe<Scalars['JSON']>;
  settingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  slogan?: InputMaybe<Scalars['String']>;
  sloganAny?: InputMaybe<Scalars['String']>;
  sloganContain?: InputMaybe<Scalars['String']>;
  sloganEq?: InputMaybe<Scalars['String']>;
  sloganGt?: InputMaybe<Scalars['String']>;
  sloganGte?: InputMaybe<Scalars['String']>;
  sloganIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sloganIsNull?: InputMaybe<Scalars['Boolean']>;
  sloganLike?: InputMaybe<Scalars['String']>;
  sloganLikeNoCase?: InputMaybe<Scalars['String']>;
  sloganLt?: InputMaybe<Scalars['String']>;
  sloganLte?: InputMaybe<Scalars['String']>;
  sloganNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateConfig?: InputMaybe<Scalars['JSON']>;
  templateConfigAny?: InputMaybe<Scalars['JSON']>;
  templateConfigContain?: InputMaybe<Scalars['JSON']>;
  templateConfigEq?: InputMaybe<Scalars['JSON']>;
  templateConfigGt?: InputMaybe<Scalars['JSON']>;
  templateConfigGte?: InputMaybe<Scalars['JSON']>;
  templateConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  templateConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  templateConfigLike?: InputMaybe<Scalars['JSON']>;
  templateConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  templateConfigLt?: InputMaybe<Scalars['JSON']>;
  templateConfigLte?: InputMaybe<Scalars['JSON']>;
  templateConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixel?: InputMaybe<Scalars['String']>;
  twitterPixelAny?: InputMaybe<Scalars['String']>;
  twitterPixelContain?: InputMaybe<Scalars['String']>;
  twitterPixelEq?: InputMaybe<Scalars['String']>;
  twitterPixelGt?: InputMaybe<Scalars['String']>;
  twitterPixelGte?: InputMaybe<Scalars['String']>;
  twitterPixelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixelIsNull?: InputMaybe<Scalars['Boolean']>;
  twitterPixelLike?: InputMaybe<Scalars['String']>;
  twitterPixelLikeNoCase?: InputMaybe<Scalars['String']>;
  twitterPixelLt?: InputMaybe<Scalars['String']>;
  twitterPixelLte?: InputMaybe<Scalars['String']>;
  twitterPixelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainOffersOfferArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checkWallet?: InputMaybe<Scalars['Boolean']>;
  checkWalletAny?: InputMaybe<Scalars['Boolean']>;
  checkWalletContain?: InputMaybe<Scalars['Boolean']>;
  checkWalletEq?: InputMaybe<Scalars['Boolean']>;
  checkWalletGt?: InputMaybe<Scalars['Boolean']>;
  checkWalletGte?: InputMaybe<Scalars['Boolean']>;
  checkWalletIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  checkWalletIsNull?: InputMaybe<Scalars['Boolean']>;
  checkWalletLike?: InputMaybe<Scalars['Boolean']>;
  checkWalletLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  checkWalletLt?: InputMaybe<Scalars['Boolean']>;
  checkWalletLte?: InputMaybe<Scalars['Boolean']>;
  checkWalletNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultAffiliateLinkId?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdAny?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdContain?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdEq?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  defaultAffiliateLinkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultAffiliateLinkIdLike?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrl?: InputMaybe<Scalars['String']>;
  displayUrlAny?: InputMaybe<Scalars['String']>;
  displayUrlContain?: InputMaybe<Scalars['String']>;
  displayUrlEq?: InputMaybe<Scalars['String']>;
  displayUrlGt?: InputMaybe<Scalars['String']>;
  displayUrlGte?: InputMaybe<Scalars['String']>;
  displayUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  displayUrlLike?: InputMaybe<Scalars['String']>;
  displayUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  displayUrlLt?: InputMaybe<Scalars['String']>;
  displayUrlLte?: InputMaybe<Scalars['String']>;
  displayUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalData?: InputMaybe<Scalars['JSON']>;
  externalDataAny?: InputMaybe<Scalars['JSON']>;
  externalDataContain?: InputMaybe<Scalars['JSON']>;
  externalDataEq?: InputMaybe<Scalars['JSON']>;
  externalDataGt?: InputMaybe<Scalars['JSON']>;
  externalDataGte?: InputMaybe<Scalars['JSON']>;
  externalDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  externalDataIsNull?: InputMaybe<Scalars['Boolean']>;
  externalDataLike?: InputMaybe<Scalars['JSON']>;
  externalDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  externalDataLt?: InputMaybe<Scalars['JSON']>;
  externalDataLte?: InputMaybe<Scalars['JSON']>;
  externalDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  featuresListTitle?: InputMaybe<Scalars['String']>;
  featuresListTitleAny?: InputMaybe<Scalars['String']>;
  featuresListTitleContain?: InputMaybe<Scalars['String']>;
  featuresListTitleEq?: InputMaybe<Scalars['String']>;
  featuresListTitleGt?: InputMaybe<Scalars['String']>;
  featuresListTitleGte?: InputMaybe<Scalars['String']>;
  featuresListTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuresListTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  featuresListTitleLike?: InputMaybe<Scalars['String']>;
  featuresListTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  featuresListTitleLt?: InputMaybe<Scalars['String']>;
  featuresListTitleLte?: InputMaybe<Scalars['String']>;
  featuresListTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  isPausedAny?: InputMaybe<Scalars['Boolean']>;
  isPausedContain?: InputMaybe<Scalars['Boolean']>;
  isPausedEq?: InputMaybe<Scalars['Boolean']>;
  isPausedGt?: InputMaybe<Scalars['Boolean']>;
  isPausedGte?: InputMaybe<Scalars['Boolean']>;
  isPausedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPausedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPausedLike?: InputMaybe<Scalars['Boolean']>;
  isPausedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPausedLt?: InputMaybe<Scalars['Boolean']>;
  isPausedLte?: InputMaybe<Scalars['Boolean']>;
  isPausedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldOverview?: InputMaybe<Scalars['String']>;
  oldOverviewAny?: InputMaybe<Scalars['String']>;
  oldOverviewContain?: InputMaybe<Scalars['String']>;
  oldOverviewEq?: InputMaybe<Scalars['String']>;
  oldOverviewGt?: InputMaybe<Scalars['String']>;
  oldOverviewGte?: InputMaybe<Scalars['String']>;
  oldOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  oldOverviewLike?: InputMaybe<Scalars['String']>;
  oldOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  oldOverviewLt?: InputMaybe<Scalars['String']>;
  oldOverviewLte?: InputMaybe<Scalars['String']>;
  oldOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOffersPropertiesEnum>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescription?: InputMaybe<Scalars['String']>;
  previewDescriptionAny?: InputMaybe<Scalars['String']>;
  previewDescriptionContain?: InputMaybe<Scalars['String']>;
  previewDescriptionEq?: InputMaybe<Scalars['String']>;
  previewDescriptionGt?: InputMaybe<Scalars['String']>;
  previewDescriptionGte?: InputMaybe<Scalars['String']>;
  previewDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  previewDescriptionLike?: InputMaybe<Scalars['String']>;
  previewDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  previewDescriptionLt?: InputMaybe<Scalars['String']>;
  previewDescriptionLte?: InputMaybe<Scalars['String']>;
  previewDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverview?: InputMaybe<Scalars['String']>;
  quickOverviewAny?: InputMaybe<Scalars['String']>;
  quickOverviewContain?: InputMaybe<Scalars['String']>;
  quickOverviewEq?: InputMaybe<Scalars['String']>;
  quickOverviewGt?: InputMaybe<Scalars['String']>;
  quickOverviewGte?: InputMaybe<Scalars['String']>;
  quickOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  quickOverviewLike?: InputMaybe<Scalars['String']>;
  quickOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  quickOverviewLt?: InputMaybe<Scalars['String']>;
  quickOverviewLte?: InputMaybe<Scalars['String']>;
  quickOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  score?: InputMaybe<Scalars['Float']>;
  scoreAny?: InputMaybe<Scalars['Float']>;
  scoreContain?: InputMaybe<Scalars['Float']>;
  scoreEq?: InputMaybe<Scalars['Float']>;
  scoreGt?: InputMaybe<Scalars['Float']>;
  scoreGte?: InputMaybe<Scalars['Float']>;
  scoreIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  scoreIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreLike?: InputMaybe<Scalars['Float']>;
  scoreLikeNoCase?: InputMaybe<Scalars['Float']>;
  scoreLt?: InputMaybe<Scalars['Float']>;
  scoreLte?: InputMaybe<Scalars['Float']>;
  scoreMessage?: InputMaybe<Scalars['String']>;
  scoreMessageAny?: InputMaybe<Scalars['String']>;
  scoreMessageContain?: InputMaybe<Scalars['String']>;
  scoreMessageEq?: InputMaybe<Scalars['String']>;
  scoreMessageGt?: InputMaybe<Scalars['String']>;
  scoreMessageGte?: InputMaybe<Scalars['String']>;
  scoreMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreMessageLike?: InputMaybe<Scalars['String']>;
  scoreMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  scoreMessageLt?: InputMaybe<Scalars['String']>;
  scoreMessageLte?: InputMaybe<Scalars['String']>;
  scoreMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleAny?: InputMaybe<Scalars['String']>;
  subTitleContain?: InputMaybe<Scalars['String']>;
  subTitleEq?: InputMaybe<Scalars['String']>;
  subTitleGt?: InputMaybe<Scalars['String']>;
  subTitleGte?: InputMaybe<Scalars['String']>;
  subTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subTitleLike?: InputMaybe<Scalars['String']>;
  subTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subTitleLt?: InputMaybe<Scalars['String']>;
  subTitleLte?: InputMaybe<Scalars['String']>;
  subTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescription?: InputMaybe<Scalars['String']>;
  summaryDescriptionAny?: InputMaybe<Scalars['String']>;
  summaryDescriptionContain?: InputMaybe<Scalars['String']>;
  summaryDescriptionEq?: InputMaybe<Scalars['String']>;
  summaryDescriptionGt?: InputMaybe<Scalars['String']>;
  summaryDescriptionGte?: InputMaybe<Scalars['String']>;
  summaryDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryDescriptionLike?: InputMaybe<Scalars['String']>;
  summaryDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryDescriptionLt?: InputMaybe<Scalars['String']>;
  summaryDescriptionLte?: InputMaybe<Scalars['String']>;
  summaryDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitle?: InputMaybe<Scalars['String']>;
  summaryTitleAny?: InputMaybe<Scalars['String']>;
  summaryTitleContain?: InputMaybe<Scalars['String']>;
  summaryTitleEq?: InputMaybe<Scalars['String']>;
  summaryTitleGt?: InputMaybe<Scalars['String']>;
  summaryTitleGte?: InputMaybe<Scalars['String']>;
  summaryTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryTitleLike?: InputMaybe<Scalars['String']>;
  summaryTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryTitleLt?: InputMaybe<Scalars['String']>;
  summaryTitleLte?: InputMaybe<Scalars['String']>;
  summaryTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainOffersOffersArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checkWallet?: InputMaybe<Scalars['Boolean']>;
  checkWalletAny?: InputMaybe<Scalars['Boolean']>;
  checkWalletContain?: InputMaybe<Scalars['Boolean']>;
  checkWalletEq?: InputMaybe<Scalars['Boolean']>;
  checkWalletGt?: InputMaybe<Scalars['Boolean']>;
  checkWalletGte?: InputMaybe<Scalars['Boolean']>;
  checkWalletIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  checkWalletIsNull?: InputMaybe<Scalars['Boolean']>;
  checkWalletLike?: InputMaybe<Scalars['Boolean']>;
  checkWalletLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  checkWalletLt?: InputMaybe<Scalars['Boolean']>;
  checkWalletLte?: InputMaybe<Scalars['Boolean']>;
  checkWalletNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultAffiliateLinkId?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdAny?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdContain?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdEq?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  defaultAffiliateLinkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultAffiliateLinkIdLike?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrl?: InputMaybe<Scalars['String']>;
  displayUrlAny?: InputMaybe<Scalars['String']>;
  displayUrlContain?: InputMaybe<Scalars['String']>;
  displayUrlEq?: InputMaybe<Scalars['String']>;
  displayUrlGt?: InputMaybe<Scalars['String']>;
  displayUrlGte?: InputMaybe<Scalars['String']>;
  displayUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  displayUrlLike?: InputMaybe<Scalars['String']>;
  displayUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  displayUrlLt?: InputMaybe<Scalars['String']>;
  displayUrlLte?: InputMaybe<Scalars['String']>;
  displayUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalData?: InputMaybe<Scalars['JSON']>;
  externalDataAny?: InputMaybe<Scalars['JSON']>;
  externalDataContain?: InputMaybe<Scalars['JSON']>;
  externalDataEq?: InputMaybe<Scalars['JSON']>;
  externalDataGt?: InputMaybe<Scalars['JSON']>;
  externalDataGte?: InputMaybe<Scalars['JSON']>;
  externalDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  externalDataIsNull?: InputMaybe<Scalars['Boolean']>;
  externalDataLike?: InputMaybe<Scalars['JSON']>;
  externalDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  externalDataLt?: InputMaybe<Scalars['JSON']>;
  externalDataLte?: InputMaybe<Scalars['JSON']>;
  externalDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  featuresListTitle?: InputMaybe<Scalars['String']>;
  featuresListTitleAny?: InputMaybe<Scalars['String']>;
  featuresListTitleContain?: InputMaybe<Scalars['String']>;
  featuresListTitleEq?: InputMaybe<Scalars['String']>;
  featuresListTitleGt?: InputMaybe<Scalars['String']>;
  featuresListTitleGte?: InputMaybe<Scalars['String']>;
  featuresListTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuresListTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  featuresListTitleLike?: InputMaybe<Scalars['String']>;
  featuresListTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  featuresListTitleLt?: InputMaybe<Scalars['String']>;
  featuresListTitleLte?: InputMaybe<Scalars['String']>;
  featuresListTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  isPausedAny?: InputMaybe<Scalars['Boolean']>;
  isPausedContain?: InputMaybe<Scalars['Boolean']>;
  isPausedEq?: InputMaybe<Scalars['Boolean']>;
  isPausedGt?: InputMaybe<Scalars['Boolean']>;
  isPausedGte?: InputMaybe<Scalars['Boolean']>;
  isPausedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPausedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPausedLike?: InputMaybe<Scalars['Boolean']>;
  isPausedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPausedLt?: InputMaybe<Scalars['Boolean']>;
  isPausedLte?: InputMaybe<Scalars['Boolean']>;
  isPausedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldOverview?: InputMaybe<Scalars['String']>;
  oldOverviewAny?: InputMaybe<Scalars['String']>;
  oldOverviewContain?: InputMaybe<Scalars['String']>;
  oldOverviewEq?: InputMaybe<Scalars['String']>;
  oldOverviewGt?: InputMaybe<Scalars['String']>;
  oldOverviewGte?: InputMaybe<Scalars['String']>;
  oldOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  oldOverviewLike?: InputMaybe<Scalars['String']>;
  oldOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  oldOverviewLt?: InputMaybe<Scalars['String']>;
  oldOverviewLte?: InputMaybe<Scalars['String']>;
  oldOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOffersPropertiesEnum>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescription?: InputMaybe<Scalars['String']>;
  previewDescriptionAny?: InputMaybe<Scalars['String']>;
  previewDescriptionContain?: InputMaybe<Scalars['String']>;
  previewDescriptionEq?: InputMaybe<Scalars['String']>;
  previewDescriptionGt?: InputMaybe<Scalars['String']>;
  previewDescriptionGte?: InputMaybe<Scalars['String']>;
  previewDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  previewDescriptionLike?: InputMaybe<Scalars['String']>;
  previewDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  previewDescriptionLt?: InputMaybe<Scalars['String']>;
  previewDescriptionLte?: InputMaybe<Scalars['String']>;
  previewDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverview?: InputMaybe<Scalars['String']>;
  quickOverviewAny?: InputMaybe<Scalars['String']>;
  quickOverviewContain?: InputMaybe<Scalars['String']>;
  quickOverviewEq?: InputMaybe<Scalars['String']>;
  quickOverviewGt?: InputMaybe<Scalars['String']>;
  quickOverviewGte?: InputMaybe<Scalars['String']>;
  quickOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  quickOverviewLike?: InputMaybe<Scalars['String']>;
  quickOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  quickOverviewLt?: InputMaybe<Scalars['String']>;
  quickOverviewLte?: InputMaybe<Scalars['String']>;
  quickOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  score?: InputMaybe<Scalars['Float']>;
  scoreAny?: InputMaybe<Scalars['Float']>;
  scoreContain?: InputMaybe<Scalars['Float']>;
  scoreEq?: InputMaybe<Scalars['Float']>;
  scoreGt?: InputMaybe<Scalars['Float']>;
  scoreGte?: InputMaybe<Scalars['Float']>;
  scoreIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  scoreIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreLike?: InputMaybe<Scalars['Float']>;
  scoreLikeNoCase?: InputMaybe<Scalars['Float']>;
  scoreLt?: InputMaybe<Scalars['Float']>;
  scoreLte?: InputMaybe<Scalars['Float']>;
  scoreMessage?: InputMaybe<Scalars['String']>;
  scoreMessageAny?: InputMaybe<Scalars['String']>;
  scoreMessageContain?: InputMaybe<Scalars['String']>;
  scoreMessageEq?: InputMaybe<Scalars['String']>;
  scoreMessageGt?: InputMaybe<Scalars['String']>;
  scoreMessageGte?: InputMaybe<Scalars['String']>;
  scoreMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreMessageLike?: InputMaybe<Scalars['String']>;
  scoreMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  scoreMessageLt?: InputMaybe<Scalars['String']>;
  scoreMessageLte?: InputMaybe<Scalars['String']>;
  scoreMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleAny?: InputMaybe<Scalars['String']>;
  subTitleContain?: InputMaybe<Scalars['String']>;
  subTitleEq?: InputMaybe<Scalars['String']>;
  subTitleGt?: InputMaybe<Scalars['String']>;
  subTitleGte?: InputMaybe<Scalars['String']>;
  subTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subTitleLike?: InputMaybe<Scalars['String']>;
  subTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subTitleLt?: InputMaybe<Scalars['String']>;
  subTitleLte?: InputMaybe<Scalars['String']>;
  subTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescription?: InputMaybe<Scalars['String']>;
  summaryDescriptionAny?: InputMaybe<Scalars['String']>;
  summaryDescriptionContain?: InputMaybe<Scalars['String']>;
  summaryDescriptionEq?: InputMaybe<Scalars['String']>;
  summaryDescriptionGt?: InputMaybe<Scalars['String']>;
  summaryDescriptionGte?: InputMaybe<Scalars['String']>;
  summaryDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryDescriptionLike?: InputMaybe<Scalars['String']>;
  summaryDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryDescriptionLt?: InputMaybe<Scalars['String']>;
  summaryDescriptionLte?: InputMaybe<Scalars['String']>;
  summaryDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitle?: InputMaybe<Scalars['String']>;
  summaryTitleAny?: InputMaybe<Scalars['String']>;
  summaryTitleContain?: InputMaybe<Scalars['String']>;
  summaryTitleEq?: InputMaybe<Scalars['String']>;
  summaryTitleGt?: InputMaybe<Scalars['String']>;
  summaryTitleGte?: InputMaybe<Scalars['String']>;
  summaryTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryTitleLike?: InputMaybe<Scalars['String']>;
  summaryTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryTitleLt?: InputMaybe<Scalars['String']>;
  summaryTitleLte?: InputMaybe<Scalars['String']>;
  summaryTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLDomainOffersPropertiesEnum {
  CategoryId = 'categoryId',
  CreatedAt = 'createdAt',
  DomainId = 'domainId',
  IsDeleted = 'isDeleted',
  OfferId = 'offerId',
  Placements = 'placements',
  Sticky = 'sticky',
  UpdatedAt = 'updatedAt',
  Weight = 'weight'
}

export type GQLDomainRoutes = {
  __typename?: 'DomainRoutes';
  createdAt?: Maybe<Scalars['String']>;
  domain?: Maybe<GQLDomains>;
  domainId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  ignoreKeyword?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  route?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};


export type GQLDomainRoutesDomainArgs = {
  allowedLanguages?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesAny?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesContain?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesEq?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  allowedLanguagesIsNull?: InputMaybe<Scalars['Boolean']>;
  allowedLanguagesLike?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  analyticsCodeId?: InputMaybe<Scalars['String']>;
  analyticsCodeIdAny?: InputMaybe<Scalars['String']>;
  analyticsCodeIdContain?: InputMaybe<Scalars['String']>;
  analyticsCodeIdEq?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  analyticsCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  analyticsCodeIdLike?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cacheSettings?: InputMaybe<Scalars['JSON']>;
  cacheSettingsAny?: InputMaybe<Scalars['JSON']>;
  cacheSettingsContain?: InputMaybe<Scalars['JSON']>;
  cacheSettingsEq?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  cacheSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  cacheSettingsLike?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  clickyCodeId?: InputMaybe<Scalars['String']>;
  clickyCodeIdAny?: InputMaybe<Scalars['String']>;
  clickyCodeIdContain?: InputMaybe<Scalars['String']>;
  clickyCodeIdEq?: InputMaybe<Scalars['String']>;
  clickyCodeIdGt?: InputMaybe<Scalars['String']>;
  clickyCodeIdGte?: InputMaybe<Scalars['String']>;
  clickyCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clickyCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  clickyCodeIdLike?: InputMaybe<Scalars['String']>;
  clickyCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  clickyCodeIdLt?: InputMaybe<Scalars['String']>;
  clickyCodeIdLte?: InputMaybe<Scalars['String']>;
  clickyCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  enableChatWidget?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetAny?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetContain?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetEq?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableChatWidgetIsNull?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLike?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaId?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdAny?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdContain?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdEq?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLike?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedForm?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormAny?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormContain?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormEq?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedFormIsNull?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLike?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  facebookConversionAPISettings?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsAny?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsContain?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsEq?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookConversionAPISettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookConversionAPISettingsLike?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookSiteVerificationCode?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fallbackSettings?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsAny?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsContain?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsEq?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  fallbackSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  fallbackSettingsLike?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  faviconId?: InputMaybe<Scalars['String']>;
  faviconIdAny?: InputMaybe<Scalars['String']>;
  faviconIdContain?: InputMaybe<Scalars['String']>;
  faviconIdEq?: InputMaybe<Scalars['String']>;
  faviconIdGt?: InputMaybe<Scalars['String']>;
  faviconIdGte?: InputMaybe<Scalars['String']>;
  faviconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  faviconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  faviconIdLike?: InputMaybe<Scalars['String']>;
  faviconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  faviconIdLt?: InputMaybe<Scalars['String']>;
  faviconIdLte?: InputMaybe<Scalars['String']>;
  faviconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCode?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  googleSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmId?: InputMaybe<Scalars['String']>;
  gtmIdAny?: InputMaybe<Scalars['String']>;
  gtmIdContain?: InputMaybe<Scalars['String']>;
  gtmIdEq?: InputMaybe<Scalars['String']>;
  gtmIdGt?: InputMaybe<Scalars['String']>;
  gtmIdGte?: InputMaybe<Scalars['String']>;
  gtmIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmIdIsNull?: InputMaybe<Scalars['Boolean']>;
  gtmIdLike?: InputMaybe<Scalars['String']>;
  gtmIdLikeNoCase?: InputMaybe<Scalars['String']>;
  gtmIdLt?: InputMaybe<Scalars['String']>;
  gtmIdLte?: InputMaybe<Scalars['String']>;
  gtmIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  holdingRules?: InputMaybe<Scalars['JSON']>;
  holdingRulesAny?: InputMaybe<Scalars['JSON']>;
  holdingRulesContain?: InputMaybe<Scalars['JSON']>;
  holdingRulesEq?: InputMaybe<Scalars['JSON']>;
  holdingRulesGt?: InputMaybe<Scalars['JSON']>;
  holdingRulesGte?: InputMaybe<Scalars['JSON']>;
  holdingRulesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  holdingRulesIsNull?: InputMaybe<Scalars['Boolean']>;
  holdingRulesLike?: InputMaybe<Scalars['JSON']>;
  holdingRulesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  holdingRulesLt?: InputMaybe<Scalars['JSON']>;
  holdingRulesLte?: InputMaybe<Scalars['JSON']>;
  holdingRulesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabled?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledAny?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledContain?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledEq?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabledIsNull?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLike?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainsPropertiesEnum>;
  otpVerificationCriteria?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaAny?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaContain?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaEq?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  otpVerificationCriteriaIsNull?: InputMaybe<Scalars['Boolean']>;
  otpVerificationCriteriaLike?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfig?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigAny?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigContain?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigEq?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  recaptchaConfigLike?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  secondaryLogoId?: InputMaybe<Scalars['String']>;
  secondaryLogoIdAny?: InputMaybe<Scalars['String']>;
  secondaryLogoIdContain?: InputMaybe<Scalars['String']>;
  secondaryLogoIdEq?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondaryLogoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  secondaryLogoIdLike?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sendNotifications?: InputMaybe<Scalars['JSON']>;
  sendNotificationsAny?: InputMaybe<Scalars['JSON']>;
  sendNotificationsContain?: InputMaybe<Scalars['JSON']>;
  sendNotificationsEq?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  sendNotificationsIsNull?: InputMaybe<Scalars['Boolean']>;
  sendNotificationsLike?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settings?: InputMaybe<Scalars['JSON']>;
  settingsAny?: InputMaybe<Scalars['JSON']>;
  settingsContain?: InputMaybe<Scalars['JSON']>;
  settingsEq?: InputMaybe<Scalars['JSON']>;
  settingsGt?: InputMaybe<Scalars['JSON']>;
  settingsGte?: InputMaybe<Scalars['JSON']>;
  settingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settingsIsNull?: InputMaybe<Scalars['Boolean']>;
  settingsLike?: InputMaybe<Scalars['JSON']>;
  settingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  settingsLt?: InputMaybe<Scalars['JSON']>;
  settingsLte?: InputMaybe<Scalars['JSON']>;
  settingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  slogan?: InputMaybe<Scalars['String']>;
  sloganAny?: InputMaybe<Scalars['String']>;
  sloganContain?: InputMaybe<Scalars['String']>;
  sloganEq?: InputMaybe<Scalars['String']>;
  sloganGt?: InputMaybe<Scalars['String']>;
  sloganGte?: InputMaybe<Scalars['String']>;
  sloganIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sloganIsNull?: InputMaybe<Scalars['Boolean']>;
  sloganLike?: InputMaybe<Scalars['String']>;
  sloganLikeNoCase?: InputMaybe<Scalars['String']>;
  sloganLt?: InputMaybe<Scalars['String']>;
  sloganLte?: InputMaybe<Scalars['String']>;
  sloganNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateConfig?: InputMaybe<Scalars['JSON']>;
  templateConfigAny?: InputMaybe<Scalars['JSON']>;
  templateConfigContain?: InputMaybe<Scalars['JSON']>;
  templateConfigEq?: InputMaybe<Scalars['JSON']>;
  templateConfigGt?: InputMaybe<Scalars['JSON']>;
  templateConfigGte?: InputMaybe<Scalars['JSON']>;
  templateConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  templateConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  templateConfigLike?: InputMaybe<Scalars['JSON']>;
  templateConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  templateConfigLt?: InputMaybe<Scalars['JSON']>;
  templateConfigLte?: InputMaybe<Scalars['JSON']>;
  templateConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixel?: InputMaybe<Scalars['String']>;
  twitterPixelAny?: InputMaybe<Scalars['String']>;
  twitterPixelContain?: InputMaybe<Scalars['String']>;
  twitterPixelEq?: InputMaybe<Scalars['String']>;
  twitterPixelGt?: InputMaybe<Scalars['String']>;
  twitterPixelGte?: InputMaybe<Scalars['String']>;
  twitterPixelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixelIsNull?: InputMaybe<Scalars['Boolean']>;
  twitterPixelLike?: InputMaybe<Scalars['String']>;
  twitterPixelLikeNoCase?: InputMaybe<Scalars['String']>;
  twitterPixelLt?: InputMaybe<Scalars['String']>;
  twitterPixelLte?: InputMaybe<Scalars['String']>;
  twitterPixelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLDomainRoutesPropertiesEnum {
  CreatedAt = 'createdAt',
  DomainId = 'domainId',
  Id = 'id',
  IgnoreKeyword = 'ignoreKeyword',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  Route = 'route',
  UpdatedAt = 'updatedAt'
}

export type GQLDomains = {
  __typename?: 'Domains';
  allTranslations?: Maybe<Array<Maybe<GQLTranslations>>>;
  allowedLanguages?: Maybe<Scalars['JSON']>;
  analyticsCodeId?: Maybe<Scalars['String']>;
  cacheSettings?: Maybe<Scalars['JSON']>;
  categories?: Maybe<Array<Maybe<GQLCategories>>>;
  clickyCodeId?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['String']>;
  defaultOffers?: Maybe<Array<Maybe<GQLOffers>>>;
  description?: Maybe<Scalars['String']>;
  domainCategories?: Maybe<Array<Maybe<GQLDomainCategories>>>;
  domainForms?: Maybe<Array<Maybe<GQLDomainForms>>>;
  domainOffers?: Maybe<Array<Maybe<GQLDomainOffers>>>;
  emailSettings?: Maybe<GQLDomainsEmailSettings>;
  enableChatWidget?: Maybe<Scalars['Boolean']>;
  enableJornayaId?: Maybe<Scalars['Boolean']>;
  enableTrustedForm?: Maybe<Scalars['Boolean']>;
  facebookConversionAPISettings?: Maybe<Scalars['JSON']>;
  facebookSiteVerificationCode?: Maybe<Scalars['String']>;
  fallbackSettings?: Maybe<Scalars['JSON']>;
  favicon?: Maybe<GQLAttachments>;
  faviconId?: Maybe<Scalars['String']>;
  forms?: Maybe<Array<Maybe<GQLForms>>>;
  googleSiteVerificationCode?: Maybe<Scalars['String']>;
  gtmId?: Maybe<Scalars['String']>;
  holdingRules?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isInspectorEnabled?: Maybe<Scalars['Boolean']>;
  listings?: Maybe<Array<Maybe<GQLListings>>>;
  logo?: Maybe<GQLAttachments>;
  logoId?: Maybe<Scalars['String']>;
  menus?: Maybe<Array<Maybe<GQLMenus>>>;
  menusList?: Maybe<Array<Maybe<GQLMenus>>>;
  metatags?: Maybe<Array<Maybe<GQLDomainMetatags>>>;
  name?: Maybe<Scalars['String']>;
  niceName?: Maybe<Scalars['String']>;
  offers?: Maybe<Array<Maybe<GQLDomainOffers>>>;
  otpVerificationCriteria?: Maybe<Scalars['JSON']>;
  posts?: Maybe<Array<Maybe<GQLPosts>>>;
  recaptchaConfig?: Maybe<Scalars['JSON']>;
  routes?: Maybe<Array<Maybe<GQLDomainRoutes>>>;
  secondaryLogo?: Maybe<GQLAttachments>;
  secondaryLogoId?: Maybe<Scalars['String']>;
  sendNotifications?: Maybe<Scalars['JSON']>;
  settings?: Maybe<Scalars['JSON']>;
  slogan?: Maybe<Scalars['String']>;
  templateConfig?: Maybe<Scalars['JSON']>;
  textBlocks?: Maybe<Array<Maybe<GQLTextBlocks>>>;
  title?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  twitterPixel?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};


export type GQLDomainsAllTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};


export type GQLDomainsCategoriesArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainsDefaultOffersArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checkWallet?: InputMaybe<Scalars['Boolean']>;
  checkWalletAny?: InputMaybe<Scalars['Boolean']>;
  checkWalletContain?: InputMaybe<Scalars['Boolean']>;
  checkWalletEq?: InputMaybe<Scalars['Boolean']>;
  checkWalletGt?: InputMaybe<Scalars['Boolean']>;
  checkWalletGte?: InputMaybe<Scalars['Boolean']>;
  checkWalletIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  checkWalletIsNull?: InputMaybe<Scalars['Boolean']>;
  checkWalletLike?: InputMaybe<Scalars['Boolean']>;
  checkWalletLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  checkWalletLt?: InputMaybe<Scalars['Boolean']>;
  checkWalletLte?: InputMaybe<Scalars['Boolean']>;
  checkWalletNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultAffiliateLinkId?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdAny?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdContain?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdEq?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  defaultAffiliateLinkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultAffiliateLinkIdLike?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrl?: InputMaybe<Scalars['String']>;
  displayUrlAny?: InputMaybe<Scalars['String']>;
  displayUrlContain?: InputMaybe<Scalars['String']>;
  displayUrlEq?: InputMaybe<Scalars['String']>;
  displayUrlGt?: InputMaybe<Scalars['String']>;
  displayUrlGte?: InputMaybe<Scalars['String']>;
  displayUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  displayUrlLike?: InputMaybe<Scalars['String']>;
  displayUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  displayUrlLt?: InputMaybe<Scalars['String']>;
  displayUrlLte?: InputMaybe<Scalars['String']>;
  displayUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalData?: InputMaybe<Scalars['JSON']>;
  externalDataAny?: InputMaybe<Scalars['JSON']>;
  externalDataContain?: InputMaybe<Scalars['JSON']>;
  externalDataEq?: InputMaybe<Scalars['JSON']>;
  externalDataGt?: InputMaybe<Scalars['JSON']>;
  externalDataGte?: InputMaybe<Scalars['JSON']>;
  externalDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  externalDataIsNull?: InputMaybe<Scalars['Boolean']>;
  externalDataLike?: InputMaybe<Scalars['JSON']>;
  externalDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  externalDataLt?: InputMaybe<Scalars['JSON']>;
  externalDataLte?: InputMaybe<Scalars['JSON']>;
  externalDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  featuresListTitle?: InputMaybe<Scalars['String']>;
  featuresListTitleAny?: InputMaybe<Scalars['String']>;
  featuresListTitleContain?: InputMaybe<Scalars['String']>;
  featuresListTitleEq?: InputMaybe<Scalars['String']>;
  featuresListTitleGt?: InputMaybe<Scalars['String']>;
  featuresListTitleGte?: InputMaybe<Scalars['String']>;
  featuresListTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuresListTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  featuresListTitleLike?: InputMaybe<Scalars['String']>;
  featuresListTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  featuresListTitleLt?: InputMaybe<Scalars['String']>;
  featuresListTitleLte?: InputMaybe<Scalars['String']>;
  featuresListTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  isPausedAny?: InputMaybe<Scalars['Boolean']>;
  isPausedContain?: InputMaybe<Scalars['Boolean']>;
  isPausedEq?: InputMaybe<Scalars['Boolean']>;
  isPausedGt?: InputMaybe<Scalars['Boolean']>;
  isPausedGte?: InputMaybe<Scalars['Boolean']>;
  isPausedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPausedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPausedLike?: InputMaybe<Scalars['Boolean']>;
  isPausedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPausedLt?: InputMaybe<Scalars['Boolean']>;
  isPausedLte?: InputMaybe<Scalars['Boolean']>;
  isPausedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldOverview?: InputMaybe<Scalars['String']>;
  oldOverviewAny?: InputMaybe<Scalars['String']>;
  oldOverviewContain?: InputMaybe<Scalars['String']>;
  oldOverviewEq?: InputMaybe<Scalars['String']>;
  oldOverviewGt?: InputMaybe<Scalars['String']>;
  oldOverviewGte?: InputMaybe<Scalars['String']>;
  oldOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  oldOverviewLike?: InputMaybe<Scalars['String']>;
  oldOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  oldOverviewLt?: InputMaybe<Scalars['String']>;
  oldOverviewLte?: InputMaybe<Scalars['String']>;
  oldOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOffersPropertiesEnum>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescription?: InputMaybe<Scalars['String']>;
  previewDescriptionAny?: InputMaybe<Scalars['String']>;
  previewDescriptionContain?: InputMaybe<Scalars['String']>;
  previewDescriptionEq?: InputMaybe<Scalars['String']>;
  previewDescriptionGt?: InputMaybe<Scalars['String']>;
  previewDescriptionGte?: InputMaybe<Scalars['String']>;
  previewDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  previewDescriptionLike?: InputMaybe<Scalars['String']>;
  previewDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  previewDescriptionLt?: InputMaybe<Scalars['String']>;
  previewDescriptionLte?: InputMaybe<Scalars['String']>;
  previewDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverview?: InputMaybe<Scalars['String']>;
  quickOverviewAny?: InputMaybe<Scalars['String']>;
  quickOverviewContain?: InputMaybe<Scalars['String']>;
  quickOverviewEq?: InputMaybe<Scalars['String']>;
  quickOverviewGt?: InputMaybe<Scalars['String']>;
  quickOverviewGte?: InputMaybe<Scalars['String']>;
  quickOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  quickOverviewLike?: InputMaybe<Scalars['String']>;
  quickOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  quickOverviewLt?: InputMaybe<Scalars['String']>;
  quickOverviewLte?: InputMaybe<Scalars['String']>;
  quickOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  score?: InputMaybe<Scalars['Float']>;
  scoreAny?: InputMaybe<Scalars['Float']>;
  scoreContain?: InputMaybe<Scalars['Float']>;
  scoreEq?: InputMaybe<Scalars['Float']>;
  scoreGt?: InputMaybe<Scalars['Float']>;
  scoreGte?: InputMaybe<Scalars['Float']>;
  scoreIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  scoreIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreLike?: InputMaybe<Scalars['Float']>;
  scoreLikeNoCase?: InputMaybe<Scalars['Float']>;
  scoreLt?: InputMaybe<Scalars['Float']>;
  scoreLte?: InputMaybe<Scalars['Float']>;
  scoreMessage?: InputMaybe<Scalars['String']>;
  scoreMessageAny?: InputMaybe<Scalars['String']>;
  scoreMessageContain?: InputMaybe<Scalars['String']>;
  scoreMessageEq?: InputMaybe<Scalars['String']>;
  scoreMessageGt?: InputMaybe<Scalars['String']>;
  scoreMessageGte?: InputMaybe<Scalars['String']>;
  scoreMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreMessageLike?: InputMaybe<Scalars['String']>;
  scoreMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  scoreMessageLt?: InputMaybe<Scalars['String']>;
  scoreMessageLte?: InputMaybe<Scalars['String']>;
  scoreMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleAny?: InputMaybe<Scalars['String']>;
  subTitleContain?: InputMaybe<Scalars['String']>;
  subTitleEq?: InputMaybe<Scalars['String']>;
  subTitleGt?: InputMaybe<Scalars['String']>;
  subTitleGte?: InputMaybe<Scalars['String']>;
  subTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subTitleLike?: InputMaybe<Scalars['String']>;
  subTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subTitleLt?: InputMaybe<Scalars['String']>;
  subTitleLte?: InputMaybe<Scalars['String']>;
  subTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescription?: InputMaybe<Scalars['String']>;
  summaryDescriptionAny?: InputMaybe<Scalars['String']>;
  summaryDescriptionContain?: InputMaybe<Scalars['String']>;
  summaryDescriptionEq?: InputMaybe<Scalars['String']>;
  summaryDescriptionGt?: InputMaybe<Scalars['String']>;
  summaryDescriptionGte?: InputMaybe<Scalars['String']>;
  summaryDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryDescriptionLike?: InputMaybe<Scalars['String']>;
  summaryDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryDescriptionLt?: InputMaybe<Scalars['String']>;
  summaryDescriptionLte?: InputMaybe<Scalars['String']>;
  summaryDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitle?: InputMaybe<Scalars['String']>;
  summaryTitleAny?: InputMaybe<Scalars['String']>;
  summaryTitleContain?: InputMaybe<Scalars['String']>;
  summaryTitleEq?: InputMaybe<Scalars['String']>;
  summaryTitleGt?: InputMaybe<Scalars['String']>;
  summaryTitleGte?: InputMaybe<Scalars['String']>;
  summaryTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryTitleLike?: InputMaybe<Scalars['String']>;
  summaryTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryTitleLt?: InputMaybe<Scalars['String']>;
  summaryTitleLte?: InputMaybe<Scalars['String']>;
  summaryTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainsDomainCategoriesArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  crossSellingDomainFormId?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdAny?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdContain?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdEq?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdGt?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdGte?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  crossSellingDomainFormIdIsNull?: InputMaybe<Scalars['Boolean']>;
  crossSellingDomainFormIdLike?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdLt?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdLte?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLDomainCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainsDomainFormsArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formId?: InputMaybe<Scalars['Int']>;
  formIdAny?: InputMaybe<Scalars['Int']>;
  formIdContain?: InputMaybe<Scalars['Int']>;
  formIdEq?: InputMaybe<Scalars['Int']>;
  formIdGt?: InputMaybe<Scalars['Int']>;
  formIdGte?: InputMaybe<Scalars['Int']>;
  formIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formIdIsNull?: InputMaybe<Scalars['Boolean']>;
  formIdLike?: InputMaybe<Scalars['Int']>;
  formIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  formIdLt?: InputMaybe<Scalars['Int']>;
  formIdLte?: InputMaybe<Scalars['Int']>;
  formIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  integrations?: InputMaybe<Scalars['JSON']>;
  integrationsAny?: InputMaybe<Scalars['JSON']>;
  integrationsContain?: InputMaybe<Scalars['JSON']>;
  integrationsEq?: InputMaybe<Scalars['JSON']>;
  integrationsGt?: InputMaybe<Scalars['JSON']>;
  integrationsGte?: InputMaybe<Scalars['JSON']>;
  integrationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  integrationsIsNull?: InputMaybe<Scalars['Boolean']>;
  integrationsLike?: InputMaybe<Scalars['JSON']>;
  integrationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  integrationsLt?: InputMaybe<Scalars['JSON']>;
  integrationsLte?: InputMaybe<Scalars['JSON']>;
  integrationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainFormsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainFormsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainsDomainOffersArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainOffersPropertiesEnum>;
  placements?: InputMaybe<Scalars['JSON']>;
  placementsAny?: InputMaybe<Scalars['JSON']>;
  placementsContain?: InputMaybe<Scalars['JSON']>;
  placementsEq?: InputMaybe<Scalars['JSON']>;
  placementsGt?: InputMaybe<Scalars['JSON']>;
  placementsGte?: InputMaybe<Scalars['JSON']>;
  placementsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  placementsIsNull?: InputMaybe<Scalars['Boolean']>;
  placementsLike?: InputMaybe<Scalars['JSON']>;
  placementsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  placementsLt?: InputMaybe<Scalars['JSON']>;
  placementsLte?: InputMaybe<Scalars['JSON']>;
  placementsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  sticky?: InputMaybe<Scalars['Boolean']>;
  stickyAny?: InputMaybe<Scalars['Boolean']>;
  stickyContain?: InputMaybe<Scalars['Boolean']>;
  stickyEq?: InputMaybe<Scalars['Boolean']>;
  stickyGt?: InputMaybe<Scalars['Boolean']>;
  stickyGte?: InputMaybe<Scalars['Boolean']>;
  stickyIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  stickyIsNull?: InputMaybe<Scalars['Boolean']>;
  stickyLike?: InputMaybe<Scalars['Boolean']>;
  stickyLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  stickyLt?: InputMaybe<Scalars['Boolean']>;
  stickyLte?: InputMaybe<Scalars['Boolean']>;
  stickyNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLDomainsEmailSettingsArgs = {
  bccEmail?: InputMaybe<Scalars['String']>;
  bccEmailAny?: InputMaybe<Scalars['String']>;
  bccEmailContain?: InputMaybe<Scalars['String']>;
  bccEmailEq?: InputMaybe<Scalars['String']>;
  bccEmailGt?: InputMaybe<Scalars['String']>;
  bccEmailGte?: InputMaybe<Scalars['String']>;
  bccEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bccEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  bccEmailLike?: InputMaybe<Scalars['String']>;
  bccEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  bccEmailLt?: InputMaybe<Scalars['String']>;
  bccEmailLte?: InputMaybe<Scalars['String']>;
  bccEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainLogoId?: InputMaybe<Scalars['String']>;
  domainLogoIdAny?: InputMaybe<Scalars['String']>;
  domainLogoIdContain?: InputMaybe<Scalars['String']>;
  domainLogoIdEq?: InputMaybe<Scalars['String']>;
  domainLogoIdGt?: InputMaybe<Scalars['String']>;
  domainLogoIdGte?: InputMaybe<Scalars['String']>;
  domainLogoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domainLogoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainLogoIdLike?: InputMaybe<Scalars['String']>;
  domainLogoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  domainLogoIdLt?: InputMaybe<Scalars['String']>;
  domainLogoIdLte?: InputMaybe<Scalars['String']>;
  domainLogoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailPassword?: InputMaybe<Scalars['String']>;
  emailPasswordAny?: InputMaybe<Scalars['String']>;
  emailPasswordContain?: InputMaybe<Scalars['String']>;
  emailPasswordEq?: InputMaybe<Scalars['String']>;
  emailPasswordGt?: InputMaybe<Scalars['String']>;
  emailPasswordGte?: InputMaybe<Scalars['String']>;
  emailPasswordIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailPasswordIsNull?: InputMaybe<Scalars['Boolean']>;
  emailPasswordLike?: InputMaybe<Scalars['String']>;
  emailPasswordLikeNoCase?: InputMaybe<Scalars['String']>;
  emailPasswordLt?: InputMaybe<Scalars['String']>;
  emailPasswordLte?: InputMaybe<Scalars['String']>;
  emailPasswordNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailService?: InputMaybe<Scalars['String']>;
  emailServiceAny?: InputMaybe<Scalars['String']>;
  emailServiceContain?: InputMaybe<Scalars['String']>;
  emailServiceEq?: InputMaybe<Scalars['String']>;
  emailServiceGt?: InputMaybe<Scalars['String']>;
  emailServiceGte?: InputMaybe<Scalars['String']>;
  emailServiceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailServiceIsNull?: InputMaybe<Scalars['Boolean']>;
  emailServiceLike?: InputMaybe<Scalars['String']>;
  emailServiceLikeNoCase?: InputMaybe<Scalars['String']>;
  emailServiceLt?: InputMaybe<Scalars['String']>;
  emailServiceLte?: InputMaybe<Scalars['String']>;
  emailServiceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailUserName?: InputMaybe<Scalars['String']>;
  emailUserNameAny?: InputMaybe<Scalars['String']>;
  emailUserNameContain?: InputMaybe<Scalars['String']>;
  emailUserNameEq?: InputMaybe<Scalars['String']>;
  emailUserNameGt?: InputMaybe<Scalars['String']>;
  emailUserNameGte?: InputMaybe<Scalars['String']>;
  emailUserNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailUserNameIsNull?: InputMaybe<Scalars['Boolean']>;
  emailUserNameLike?: InputMaybe<Scalars['String']>;
  emailUserNameLikeNoCase?: InputMaybe<Scalars['String']>;
  emailUserNameLt?: InputMaybe<Scalars['String']>;
  emailUserNameLte?: InputMaybe<Scalars['String']>;
  emailUserNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fromEmail?: InputMaybe<Scalars['String']>;
  fromEmailAny?: InputMaybe<Scalars['String']>;
  fromEmailContain?: InputMaybe<Scalars['String']>;
  fromEmailEq?: InputMaybe<Scalars['String']>;
  fromEmailGt?: InputMaybe<Scalars['String']>;
  fromEmailGte?: InputMaybe<Scalars['String']>;
  fromEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fromEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  fromEmailLike?: InputMaybe<Scalars['String']>;
  fromEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  fromEmailLt?: InputMaybe<Scalars['String']>;
  fromEmailLte?: InputMaybe<Scalars['String']>;
  fromEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainsEmailSettingsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainsEmailSettingsPropertiesEnum>;
  providerAPIKey?: InputMaybe<Scalars['String']>;
  providerAPIKeyAny?: InputMaybe<Scalars['String']>;
  providerAPIKeyContain?: InputMaybe<Scalars['String']>;
  providerAPIKeyEq?: InputMaybe<Scalars['String']>;
  providerAPIKeyGt?: InputMaybe<Scalars['String']>;
  providerAPIKeyGte?: InputMaybe<Scalars['String']>;
  providerAPIKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  providerAPIKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  providerAPIKeyLike?: InputMaybe<Scalars['String']>;
  providerAPIKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  providerAPIKeyLt?: InputMaybe<Scalars['String']>;
  providerAPIKeyLte?: InputMaybe<Scalars['String']>;
  providerAPIKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainsFaviconArgs = {
  access?: InputMaybe<Scalars['String']>;
  accessAny?: InputMaybe<Scalars['String']>;
  accessContain?: InputMaybe<Scalars['String']>;
  accessEq?: InputMaybe<Scalars['String']>;
  accessGt?: InputMaybe<Scalars['String']>;
  accessGte?: InputMaybe<Scalars['String']>;
  accessIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accessIsNull?: InputMaybe<Scalars['Boolean']>;
  accessLike?: InputMaybe<Scalars['String']>;
  accessLikeNoCase?: InputMaybe<Scalars['String']>;
  accessLt?: InputMaybe<Scalars['String']>;
  accessLte?: InputMaybe<Scalars['String']>;
  accessNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alt?: InputMaybe<Scalars['String']>;
  altAny?: InputMaybe<Scalars['String']>;
  altContain?: InputMaybe<Scalars['String']>;
  altEq?: InputMaybe<Scalars['String']>;
  altGt?: InputMaybe<Scalars['String']>;
  altGte?: InputMaybe<Scalars['String']>;
  altIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  altIsNull?: InputMaybe<Scalars['Boolean']>;
  altLike?: InputMaybe<Scalars['String']>;
  altLikeNoCase?: InputMaybe<Scalars['String']>;
  altLt?: InputMaybe<Scalars['String']>;
  altLte?: InputMaybe<Scalars['String']>;
  altNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caption?: InputMaybe<Scalars['String']>;
  captionAny?: InputMaybe<Scalars['String']>;
  captionContain?: InputMaybe<Scalars['String']>;
  captionEq?: InputMaybe<Scalars['String']>;
  captionGt?: InputMaybe<Scalars['String']>;
  captionGte?: InputMaybe<Scalars['String']>;
  captionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  captionIsNull?: InputMaybe<Scalars['Boolean']>;
  captionLike?: InputMaybe<Scalars['String']>;
  captionLikeNoCase?: InputMaybe<Scalars['String']>;
  captionLt?: InputMaybe<Scalars['String']>;
  captionLte?: InputMaybe<Scalars['String']>;
  captionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fullPath?: InputMaybe<Scalars['String']>;
  fullPathAny?: InputMaybe<Scalars['String']>;
  fullPathContain?: InputMaybe<Scalars['String']>;
  fullPathEq?: InputMaybe<Scalars['String']>;
  fullPathGt?: InputMaybe<Scalars['String']>;
  fullPathGte?: InputMaybe<Scalars['String']>;
  fullPathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullPathIsNull?: InputMaybe<Scalars['Boolean']>;
  fullPathLike?: InputMaybe<Scalars['String']>;
  fullPathLikeNoCase?: InputMaybe<Scalars['String']>;
  fullPathLt?: InputMaybe<Scalars['String']>;
  fullPathLte?: InputMaybe<Scalars['String']>;
  fullPathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mimeType?: InputMaybe<Scalars['String']>;
  mimeTypeAny?: InputMaybe<Scalars['String']>;
  mimeTypeContain?: InputMaybe<Scalars['String']>;
  mimeTypeEq?: InputMaybe<Scalars['String']>;
  mimeTypeGt?: InputMaybe<Scalars['String']>;
  mimeTypeGte?: InputMaybe<Scalars['String']>;
  mimeTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mimeTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  mimeTypeLike?: InputMaybe<Scalars['String']>;
  mimeTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  mimeTypeLt?: InputMaybe<Scalars['String']>;
  mimeTypeLte?: InputMaybe<Scalars['String']>;
  mimeTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  originalName?: InputMaybe<Scalars['String']>;
  originalNameAny?: InputMaybe<Scalars['String']>;
  originalNameContain?: InputMaybe<Scalars['String']>;
  originalNameEq?: InputMaybe<Scalars['String']>;
  originalNameGt?: InputMaybe<Scalars['String']>;
  originalNameGte?: InputMaybe<Scalars['String']>;
  originalNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  originalNameIsNull?: InputMaybe<Scalars['Boolean']>;
  originalNameLike?: InputMaybe<Scalars['String']>;
  originalNameLikeNoCase?: InputMaybe<Scalars['String']>;
  originalNameLt?: InputMaybe<Scalars['String']>;
  originalNameLte?: InputMaybe<Scalars['String']>;
  originalNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  path?: InputMaybe<Scalars['String']>;
  pathAny?: InputMaybe<Scalars['String']>;
  pathContain?: InputMaybe<Scalars['String']>;
  pathEq?: InputMaybe<Scalars['String']>;
  pathGt?: InputMaybe<Scalars['String']>;
  pathGte?: InputMaybe<Scalars['String']>;
  pathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pathIsNull?: InputMaybe<Scalars['Boolean']>;
  pathLike?: InputMaybe<Scalars['String']>;
  pathLikeNoCase?: InputMaybe<Scalars['String']>;
  pathLt?: InputMaybe<Scalars['String']>;
  pathLte?: InputMaybe<Scalars['String']>;
  pathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  size?: InputMaybe<Scalars['Int']>;
  sizeAny?: InputMaybe<Scalars['Int']>;
  sizeContain?: InputMaybe<Scalars['Int']>;
  sizeEq?: InputMaybe<Scalars['Int']>;
  sizeGt?: InputMaybe<Scalars['Int']>;
  sizeGte?: InputMaybe<Scalars['Int']>;
  sizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sizeLike?: InputMaybe<Scalars['Int']>;
  sizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sizeLt?: InputMaybe<Scalars['Int']>;
  sizeLte?: InputMaybe<Scalars['Int']>;
  sizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainsFormsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorMessageAny?: InputMaybe<Scalars['String']>;
  errorMessageContain?: InputMaybe<Scalars['String']>;
  errorMessageEq?: InputMaybe<Scalars['String']>;
  errorMessageGt?: InputMaybe<Scalars['String']>;
  errorMessageGte?: InputMaybe<Scalars['String']>;
  errorMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  errorMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  errorMessageLike?: InputMaybe<Scalars['String']>;
  errorMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  errorMessageLt?: InputMaybe<Scalars['String']>;
  errorMessageLte?: InputMaybe<Scalars['String']>;
  errorMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVariant?: InputMaybe<Scalars['Boolean']>;
  isVariantAny?: InputMaybe<Scalars['Boolean']>;
  isVariantContain?: InputMaybe<Scalars['Boolean']>;
  isVariantEq?: InputMaybe<Scalars['Boolean']>;
  isVariantGt?: InputMaybe<Scalars['Boolean']>;
  isVariantGte?: InputMaybe<Scalars['Boolean']>;
  isVariantIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVariantIsNull?: InputMaybe<Scalars['Boolean']>;
  isVariantLike?: InputMaybe<Scalars['Boolean']>;
  isVariantLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVariantLt?: InputMaybe<Scalars['Boolean']>;
  isVariantLte?: InputMaybe<Scalars['Boolean']>;
  isVariantNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingId?: InputMaybe<Scalars['Int']>;
  listingIdAny?: InputMaybe<Scalars['Int']>;
  listingIdContain?: InputMaybe<Scalars['Int']>;
  listingIdEq?: InputMaybe<Scalars['Int']>;
  listingIdGt?: InputMaybe<Scalars['Int']>;
  listingIdGte?: InputMaybe<Scalars['Int']>;
  listingIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingIdIsNull?: InputMaybe<Scalars['Boolean']>;
  listingIdLike?: InputMaybe<Scalars['Int']>;
  listingIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  listingIdLt?: InputMaybe<Scalars['Int']>;
  listingIdLte?: InputMaybe<Scalars['Int']>;
  listingIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modifiedAt?: InputMaybe<Scalars['String']>;
  modifiedAtAny?: InputMaybe<Scalars['String']>;
  modifiedAtContain?: InputMaybe<Scalars['String']>;
  modifiedAtEq?: InputMaybe<Scalars['String']>;
  modifiedAtGt?: InputMaybe<Scalars['String']>;
  modifiedAtGte?: InputMaybe<Scalars['String']>;
  modifiedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedAtLike?: InputMaybe<Scalars['String']>;
  modifiedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedAtLt?: InputMaybe<Scalars['String']>;
  modifiedAtLte?: InputMaybe<Scalars['String']>;
  modifiedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLFormsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLFormsPropertiesEnum>;
  stepToFetchBuyers?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersAny?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersContain?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersEq?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersGt?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersGte?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToFetchBuyersIsNull?: InputMaybe<Scalars['Boolean']>;
  stepToFetchBuyersLike?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersLikeNoCase?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersLt?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersLte?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToSendingData?: InputMaybe<Scalars['Int']>;
  stepToSendingDataAny?: InputMaybe<Scalars['Int']>;
  stepToSendingDataContain?: InputMaybe<Scalars['Int']>;
  stepToSendingDataEq?: InputMaybe<Scalars['Int']>;
  stepToSendingDataGt?: InputMaybe<Scalars['Int']>;
  stepToSendingDataGte?: InputMaybe<Scalars['Int']>;
  stepToSendingDataIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToSendingDataIsNull?: InputMaybe<Scalars['Boolean']>;
  stepToSendingDataLike?: InputMaybe<Scalars['Int']>;
  stepToSendingDataLikeNoCase?: InputMaybe<Scalars['Int']>;
  stepToSendingDataLt?: InputMaybe<Scalars['Int']>;
  stepToSendingDataLte?: InputMaybe<Scalars['Int']>;
  stepToSendingDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  successMessage?: InputMaybe<Scalars['String']>;
  successMessageAny?: InputMaybe<Scalars['String']>;
  successMessageContain?: InputMaybe<Scalars['String']>;
  successMessageEq?: InputMaybe<Scalars['String']>;
  successMessageGt?: InputMaybe<Scalars['String']>;
  successMessageGte?: InputMaybe<Scalars['String']>;
  successMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  successMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  successMessageLike?: InputMaybe<Scalars['String']>;
  successMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  successMessageLt?: InputMaybe<Scalars['String']>;
  successMessageLte?: InputMaybe<Scalars['String']>;
  successMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  variantParentId?: InputMaybe<Scalars['Int']>;
  variantParentIdAny?: InputMaybe<Scalars['Int']>;
  variantParentIdContain?: InputMaybe<Scalars['Int']>;
  variantParentIdEq?: InputMaybe<Scalars['Int']>;
  variantParentIdGt?: InputMaybe<Scalars['Int']>;
  variantParentIdGte?: InputMaybe<Scalars['Int']>;
  variantParentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  variantParentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  variantParentIdLike?: InputMaybe<Scalars['Int']>;
  variantParentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  variantParentIdLt?: InputMaybe<Scalars['Int']>;
  variantParentIdLte?: InputMaybe<Scalars['Int']>;
  variantParentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLDomainsListingsArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLListingsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLListingsPropertiesEnum>;
  pageTitle?: InputMaybe<Scalars['String']>;
  pageTitleAny?: InputMaybe<Scalars['String']>;
  pageTitleContain?: InputMaybe<Scalars['String']>;
  pageTitleEq?: InputMaybe<Scalars['String']>;
  pageTitleGt?: InputMaybe<Scalars['String']>;
  pageTitleGte?: InputMaybe<Scalars['String']>;
  pageTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  pageTitleLike?: InputMaybe<Scalars['String']>;
  pageTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  pageTitleLt?: InputMaybe<Scalars['String']>;
  pageTitleLte?: InputMaybe<Scalars['String']>;
  pageTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainsLogoArgs = {
  access?: InputMaybe<Scalars['String']>;
  accessAny?: InputMaybe<Scalars['String']>;
  accessContain?: InputMaybe<Scalars['String']>;
  accessEq?: InputMaybe<Scalars['String']>;
  accessGt?: InputMaybe<Scalars['String']>;
  accessGte?: InputMaybe<Scalars['String']>;
  accessIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accessIsNull?: InputMaybe<Scalars['Boolean']>;
  accessLike?: InputMaybe<Scalars['String']>;
  accessLikeNoCase?: InputMaybe<Scalars['String']>;
  accessLt?: InputMaybe<Scalars['String']>;
  accessLte?: InputMaybe<Scalars['String']>;
  accessNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alt?: InputMaybe<Scalars['String']>;
  altAny?: InputMaybe<Scalars['String']>;
  altContain?: InputMaybe<Scalars['String']>;
  altEq?: InputMaybe<Scalars['String']>;
  altGt?: InputMaybe<Scalars['String']>;
  altGte?: InputMaybe<Scalars['String']>;
  altIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  altIsNull?: InputMaybe<Scalars['Boolean']>;
  altLike?: InputMaybe<Scalars['String']>;
  altLikeNoCase?: InputMaybe<Scalars['String']>;
  altLt?: InputMaybe<Scalars['String']>;
  altLte?: InputMaybe<Scalars['String']>;
  altNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caption?: InputMaybe<Scalars['String']>;
  captionAny?: InputMaybe<Scalars['String']>;
  captionContain?: InputMaybe<Scalars['String']>;
  captionEq?: InputMaybe<Scalars['String']>;
  captionGt?: InputMaybe<Scalars['String']>;
  captionGte?: InputMaybe<Scalars['String']>;
  captionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  captionIsNull?: InputMaybe<Scalars['Boolean']>;
  captionLike?: InputMaybe<Scalars['String']>;
  captionLikeNoCase?: InputMaybe<Scalars['String']>;
  captionLt?: InputMaybe<Scalars['String']>;
  captionLte?: InputMaybe<Scalars['String']>;
  captionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fullPath?: InputMaybe<Scalars['String']>;
  fullPathAny?: InputMaybe<Scalars['String']>;
  fullPathContain?: InputMaybe<Scalars['String']>;
  fullPathEq?: InputMaybe<Scalars['String']>;
  fullPathGt?: InputMaybe<Scalars['String']>;
  fullPathGte?: InputMaybe<Scalars['String']>;
  fullPathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullPathIsNull?: InputMaybe<Scalars['Boolean']>;
  fullPathLike?: InputMaybe<Scalars['String']>;
  fullPathLikeNoCase?: InputMaybe<Scalars['String']>;
  fullPathLt?: InputMaybe<Scalars['String']>;
  fullPathLte?: InputMaybe<Scalars['String']>;
  fullPathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mimeType?: InputMaybe<Scalars['String']>;
  mimeTypeAny?: InputMaybe<Scalars['String']>;
  mimeTypeContain?: InputMaybe<Scalars['String']>;
  mimeTypeEq?: InputMaybe<Scalars['String']>;
  mimeTypeGt?: InputMaybe<Scalars['String']>;
  mimeTypeGte?: InputMaybe<Scalars['String']>;
  mimeTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mimeTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  mimeTypeLike?: InputMaybe<Scalars['String']>;
  mimeTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  mimeTypeLt?: InputMaybe<Scalars['String']>;
  mimeTypeLte?: InputMaybe<Scalars['String']>;
  mimeTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  originalName?: InputMaybe<Scalars['String']>;
  originalNameAny?: InputMaybe<Scalars['String']>;
  originalNameContain?: InputMaybe<Scalars['String']>;
  originalNameEq?: InputMaybe<Scalars['String']>;
  originalNameGt?: InputMaybe<Scalars['String']>;
  originalNameGte?: InputMaybe<Scalars['String']>;
  originalNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  originalNameIsNull?: InputMaybe<Scalars['Boolean']>;
  originalNameLike?: InputMaybe<Scalars['String']>;
  originalNameLikeNoCase?: InputMaybe<Scalars['String']>;
  originalNameLt?: InputMaybe<Scalars['String']>;
  originalNameLte?: InputMaybe<Scalars['String']>;
  originalNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  path?: InputMaybe<Scalars['String']>;
  pathAny?: InputMaybe<Scalars['String']>;
  pathContain?: InputMaybe<Scalars['String']>;
  pathEq?: InputMaybe<Scalars['String']>;
  pathGt?: InputMaybe<Scalars['String']>;
  pathGte?: InputMaybe<Scalars['String']>;
  pathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pathIsNull?: InputMaybe<Scalars['Boolean']>;
  pathLike?: InputMaybe<Scalars['String']>;
  pathLikeNoCase?: InputMaybe<Scalars['String']>;
  pathLt?: InputMaybe<Scalars['String']>;
  pathLte?: InputMaybe<Scalars['String']>;
  pathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  size?: InputMaybe<Scalars['Int']>;
  sizeAny?: InputMaybe<Scalars['Int']>;
  sizeContain?: InputMaybe<Scalars['Int']>;
  sizeEq?: InputMaybe<Scalars['Int']>;
  sizeGt?: InputMaybe<Scalars['Int']>;
  sizeGte?: InputMaybe<Scalars['Int']>;
  sizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sizeLike?: InputMaybe<Scalars['Int']>;
  sizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sizeLt?: InputMaybe<Scalars['Int']>;
  sizeLte?: InputMaybe<Scalars['Int']>;
  sizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainsMenusArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLMenusPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLMenusPropertiesEnum>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainsMenusListArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLMenusPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLMenusPropertiesEnum>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainsMetatagsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainMetatagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainMetatagsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainsOffersArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainOffersPropertiesEnum>;
  placements?: InputMaybe<Scalars['JSON']>;
  placementsAny?: InputMaybe<Scalars['JSON']>;
  placementsContain?: InputMaybe<Scalars['JSON']>;
  placementsEq?: InputMaybe<Scalars['JSON']>;
  placementsGt?: InputMaybe<Scalars['JSON']>;
  placementsGte?: InputMaybe<Scalars['JSON']>;
  placementsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  placementsIsNull?: InputMaybe<Scalars['Boolean']>;
  placementsLike?: InputMaybe<Scalars['JSON']>;
  placementsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  placementsLt?: InputMaybe<Scalars['JSON']>;
  placementsLte?: InputMaybe<Scalars['JSON']>;
  placementsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  sticky?: InputMaybe<Scalars['Boolean']>;
  stickyAny?: InputMaybe<Scalars['Boolean']>;
  stickyContain?: InputMaybe<Scalars['Boolean']>;
  stickyEq?: InputMaybe<Scalars['Boolean']>;
  stickyGt?: InputMaybe<Scalars['Boolean']>;
  stickyGte?: InputMaybe<Scalars['Boolean']>;
  stickyIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  stickyIsNull?: InputMaybe<Scalars['Boolean']>;
  stickyLike?: InputMaybe<Scalars['Boolean']>;
  stickyLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  stickyLt?: InputMaybe<Scalars['Boolean']>;
  stickyLte?: InputMaybe<Scalars['Boolean']>;
  stickyNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLDomainsPostsArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerpt?: InputMaybe<Scalars['String']>;
  excerptAny?: InputMaybe<Scalars['String']>;
  excerptContain?: InputMaybe<Scalars['String']>;
  excerptEq?: InputMaybe<Scalars['String']>;
  excerptGt?: InputMaybe<Scalars['String']>;
  excerptGte?: InputMaybe<Scalars['String']>;
  excerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerptIsNull?: InputMaybe<Scalars['Boolean']>;
  excerptLike?: InputMaybe<Scalars['String']>;
  excerptLikeNoCase?: InputMaybe<Scalars['String']>;
  excerptLt?: InputMaybe<Scalars['String']>;
  excerptLte?: InputMaybe<Scalars['String']>;
  excerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featured?: InputMaybe<Scalars['Boolean']>;
  featuredAny?: InputMaybe<Scalars['Boolean']>;
  featuredContain?: InputMaybe<Scalars['Boolean']>;
  featuredEq?: InputMaybe<Scalars['Boolean']>;
  featuredGt?: InputMaybe<Scalars['Boolean']>;
  featuredGte?: InputMaybe<Scalars['Boolean']>;
  featuredIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  featuredIsNull?: InputMaybe<Scalars['Boolean']>;
  featuredLike?: InputMaybe<Scalars['Boolean']>;
  featuredLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  featuredLt?: InputMaybe<Scalars['Boolean']>;
  featuredLte?: InputMaybe<Scalars['Boolean']>;
  featuredNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  fullBody?: InputMaybe<Scalars['String']>;
  fullBodyAny?: InputMaybe<Scalars['String']>;
  fullBodyContain?: InputMaybe<Scalars['String']>;
  fullBodyEq?: InputMaybe<Scalars['String']>;
  fullBodyGt?: InputMaybe<Scalars['String']>;
  fullBodyGte?: InputMaybe<Scalars['String']>;
  fullBodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullBodyIsNull?: InputMaybe<Scalars['Boolean']>;
  fullBodyLike?: InputMaybe<Scalars['String']>;
  fullBodyLikeNoCase?: InputMaybe<Scalars['String']>;
  fullBodyLt?: InputMaybe<Scalars['String']>;
  fullBodyLte?: InputMaybe<Scalars['String']>;
  fullBodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldExcerpt?: InputMaybe<Scalars['String']>;
  oldExcerptAny?: InputMaybe<Scalars['String']>;
  oldExcerptContain?: InputMaybe<Scalars['String']>;
  oldExcerptEq?: InputMaybe<Scalars['String']>;
  oldExcerptGt?: InputMaybe<Scalars['String']>;
  oldExcerptGte?: InputMaybe<Scalars['String']>;
  oldExcerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldExcerptIsNull?: InputMaybe<Scalars['Boolean']>;
  oldExcerptLike?: InputMaybe<Scalars['String']>;
  oldExcerptLikeNoCase?: InputMaybe<Scalars['String']>;
  oldExcerptLt?: InputMaybe<Scalars['String']>;
  oldExcerptLte?: InputMaybe<Scalars['String']>;
  oldExcerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLPostsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLPostsPropertiesEnum>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedAny?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['String']>;
  publishedAtAny?: InputMaybe<Scalars['String']>;
  publishedAtContain?: InputMaybe<Scalars['String']>;
  publishedAtEq?: InputMaybe<Scalars['String']>;
  publishedAtGt?: InputMaybe<Scalars['String']>;
  publishedAtGte?: InputMaybe<Scalars['String']>;
  publishedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedAtLike?: InputMaybe<Scalars['String']>;
  publishedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  publishedAtLt?: InputMaybe<Scalars['String']>;
  publishedAtLte?: InputMaybe<Scalars['String']>;
  publishedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedContain?: InputMaybe<Scalars['Boolean']>;
  publishedEq?: InputMaybe<Scalars['Boolean']>;
  publishedGt?: InputMaybe<Scalars['Boolean']>;
  publishedGte?: InputMaybe<Scalars['Boolean']>;
  publishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  publishedIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedLike?: InputMaybe<Scalars['Boolean']>;
  publishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  publishedLt?: InputMaybe<Scalars['Boolean']>;
  publishedLte?: InputMaybe<Scalars['Boolean']>;
  publishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Scalars['Int']>;
  typeIdAny?: InputMaybe<Scalars['Int']>;
  typeIdContain?: InputMaybe<Scalars['Int']>;
  typeIdEq?: InputMaybe<Scalars['Int']>;
  typeIdGt?: InputMaybe<Scalars['Int']>;
  typeIdGte?: InputMaybe<Scalars['Int']>;
  typeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  typeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  typeIdLike?: InputMaybe<Scalars['Int']>;
  typeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  typeIdLt?: InputMaybe<Scalars['Int']>;
  typeIdLte?: InputMaybe<Scalars['Int']>;
  typeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainsRoutesArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ignoreKeyword?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordAny?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordContain?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordEq?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordGt?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordGte?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  ignoreKeywordIsNull?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordLike?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordLt?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordLte?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainRoutesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainRoutesPropertiesEnum>;
  route?: InputMaybe<Scalars['String']>;
  routeAny?: InputMaybe<Scalars['String']>;
  routeContain?: InputMaybe<Scalars['String']>;
  routeEq?: InputMaybe<Scalars['String']>;
  routeGt?: InputMaybe<Scalars['String']>;
  routeGte?: InputMaybe<Scalars['String']>;
  routeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  routeIsNull?: InputMaybe<Scalars['Boolean']>;
  routeLike?: InputMaybe<Scalars['String']>;
  routeLikeNoCase?: InputMaybe<Scalars['String']>;
  routeLt?: InputMaybe<Scalars['String']>;
  routeLte?: InputMaybe<Scalars['String']>;
  routeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainsSecondaryLogoArgs = {
  access?: InputMaybe<Scalars['String']>;
  accessAny?: InputMaybe<Scalars['String']>;
  accessContain?: InputMaybe<Scalars['String']>;
  accessEq?: InputMaybe<Scalars['String']>;
  accessGt?: InputMaybe<Scalars['String']>;
  accessGte?: InputMaybe<Scalars['String']>;
  accessIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accessIsNull?: InputMaybe<Scalars['Boolean']>;
  accessLike?: InputMaybe<Scalars['String']>;
  accessLikeNoCase?: InputMaybe<Scalars['String']>;
  accessLt?: InputMaybe<Scalars['String']>;
  accessLte?: InputMaybe<Scalars['String']>;
  accessNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alt?: InputMaybe<Scalars['String']>;
  altAny?: InputMaybe<Scalars['String']>;
  altContain?: InputMaybe<Scalars['String']>;
  altEq?: InputMaybe<Scalars['String']>;
  altGt?: InputMaybe<Scalars['String']>;
  altGte?: InputMaybe<Scalars['String']>;
  altIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  altIsNull?: InputMaybe<Scalars['Boolean']>;
  altLike?: InputMaybe<Scalars['String']>;
  altLikeNoCase?: InputMaybe<Scalars['String']>;
  altLt?: InputMaybe<Scalars['String']>;
  altLte?: InputMaybe<Scalars['String']>;
  altNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caption?: InputMaybe<Scalars['String']>;
  captionAny?: InputMaybe<Scalars['String']>;
  captionContain?: InputMaybe<Scalars['String']>;
  captionEq?: InputMaybe<Scalars['String']>;
  captionGt?: InputMaybe<Scalars['String']>;
  captionGte?: InputMaybe<Scalars['String']>;
  captionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  captionIsNull?: InputMaybe<Scalars['Boolean']>;
  captionLike?: InputMaybe<Scalars['String']>;
  captionLikeNoCase?: InputMaybe<Scalars['String']>;
  captionLt?: InputMaybe<Scalars['String']>;
  captionLte?: InputMaybe<Scalars['String']>;
  captionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fullPath?: InputMaybe<Scalars['String']>;
  fullPathAny?: InputMaybe<Scalars['String']>;
  fullPathContain?: InputMaybe<Scalars['String']>;
  fullPathEq?: InputMaybe<Scalars['String']>;
  fullPathGt?: InputMaybe<Scalars['String']>;
  fullPathGte?: InputMaybe<Scalars['String']>;
  fullPathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullPathIsNull?: InputMaybe<Scalars['Boolean']>;
  fullPathLike?: InputMaybe<Scalars['String']>;
  fullPathLikeNoCase?: InputMaybe<Scalars['String']>;
  fullPathLt?: InputMaybe<Scalars['String']>;
  fullPathLte?: InputMaybe<Scalars['String']>;
  fullPathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mimeType?: InputMaybe<Scalars['String']>;
  mimeTypeAny?: InputMaybe<Scalars['String']>;
  mimeTypeContain?: InputMaybe<Scalars['String']>;
  mimeTypeEq?: InputMaybe<Scalars['String']>;
  mimeTypeGt?: InputMaybe<Scalars['String']>;
  mimeTypeGte?: InputMaybe<Scalars['String']>;
  mimeTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mimeTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  mimeTypeLike?: InputMaybe<Scalars['String']>;
  mimeTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  mimeTypeLt?: InputMaybe<Scalars['String']>;
  mimeTypeLte?: InputMaybe<Scalars['String']>;
  mimeTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  originalName?: InputMaybe<Scalars['String']>;
  originalNameAny?: InputMaybe<Scalars['String']>;
  originalNameContain?: InputMaybe<Scalars['String']>;
  originalNameEq?: InputMaybe<Scalars['String']>;
  originalNameGt?: InputMaybe<Scalars['String']>;
  originalNameGte?: InputMaybe<Scalars['String']>;
  originalNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  originalNameIsNull?: InputMaybe<Scalars['Boolean']>;
  originalNameLike?: InputMaybe<Scalars['String']>;
  originalNameLikeNoCase?: InputMaybe<Scalars['String']>;
  originalNameLt?: InputMaybe<Scalars['String']>;
  originalNameLte?: InputMaybe<Scalars['String']>;
  originalNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  path?: InputMaybe<Scalars['String']>;
  pathAny?: InputMaybe<Scalars['String']>;
  pathContain?: InputMaybe<Scalars['String']>;
  pathEq?: InputMaybe<Scalars['String']>;
  pathGt?: InputMaybe<Scalars['String']>;
  pathGte?: InputMaybe<Scalars['String']>;
  pathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pathIsNull?: InputMaybe<Scalars['Boolean']>;
  pathLike?: InputMaybe<Scalars['String']>;
  pathLikeNoCase?: InputMaybe<Scalars['String']>;
  pathLt?: InputMaybe<Scalars['String']>;
  pathLte?: InputMaybe<Scalars['String']>;
  pathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  size?: InputMaybe<Scalars['Int']>;
  sizeAny?: InputMaybe<Scalars['Int']>;
  sizeContain?: InputMaybe<Scalars['Int']>;
  sizeEq?: InputMaybe<Scalars['Int']>;
  sizeGt?: InputMaybe<Scalars['Int']>;
  sizeGte?: InputMaybe<Scalars['Int']>;
  sizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sizeLike?: InputMaybe<Scalars['Int']>;
  sizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sizeLt?: InputMaybe<Scalars['Int']>;
  sizeLte?: InputMaybe<Scalars['Int']>;
  sizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainsTextBlocksArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedByAny?: InputMaybe<Scalars['String']>;
  deletedByContain?: InputMaybe<Scalars['String']>;
  deletedByEq?: InputMaybe<Scalars['String']>;
  deletedByGt?: InputMaybe<Scalars['String']>;
  deletedByGte?: InputMaybe<Scalars['String']>;
  deletedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedByIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedByLike?: InputMaybe<Scalars['String']>;
  deletedByLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedByLt?: InputMaybe<Scalars['String']>;
  deletedByLte?: InputMaybe<Scalars['String']>;
  deletedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIds?: InputMaybe<Scalars['JSON']>;
  offerIdsAny?: InputMaybe<Scalars['JSON']>;
  offerIdsContain?: InputMaybe<Scalars['JSON']>;
  offerIdsEq?: InputMaybe<Scalars['JSON']>;
  offerIdsGt?: InputMaybe<Scalars['JSON']>;
  offerIdsGte?: InputMaybe<Scalars['JSON']>;
  offerIdsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  offerIdsIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdsLike?: InputMaybe<Scalars['JSON']>;
  offerIdsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  offerIdsLt?: InputMaybe<Scalars['JSON']>;
  offerIdsLte?: InputMaybe<Scalars['JSON']>;
  offerIdsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTextBlocksPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTextBlocksPropertiesEnum>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  queryString?: InputMaybe<Scalars['JSON']>;
  queryStringAny?: InputMaybe<Scalars['JSON']>;
  queryStringContain?: InputMaybe<Scalars['JSON']>;
  queryStringEq?: InputMaybe<Scalars['JSON']>;
  queryStringGt?: InputMaybe<Scalars['JSON']>;
  queryStringGte?: InputMaybe<Scalars['JSON']>;
  queryStringIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  queryStringIsNull?: InputMaybe<Scalars['Boolean']>;
  queryStringLike?: InputMaybe<Scalars['JSON']>;
  queryStringLikeNoCase?: InputMaybe<Scalars['JSON']>;
  queryStringLt?: InputMaybe<Scalars['JSON']>;
  queryStringLte?: InputMaybe<Scalars['JSON']>;
  queryStringNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  text?: InputMaybe<Scalars['String']>;
  textAny?: InputMaybe<Scalars['String']>;
  textContain?: InputMaybe<Scalars['String']>;
  textEq?: InputMaybe<Scalars['String']>;
  textGt?: InputMaybe<Scalars['String']>;
  textGte?: InputMaybe<Scalars['String']>;
  textIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textIsNull?: InputMaybe<Scalars['Boolean']>;
  textLike?: InputMaybe<Scalars['String']>;
  textLikeNoCase?: InputMaybe<Scalars['String']>;
  textLt?: InputMaybe<Scalars['String']>;
  textLte?: InputMaybe<Scalars['String']>;
  textNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLDomainsTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type GQLDomainsEmailSettings = {
  __typename?: 'DomainsEmailSettings';
  bccEmail?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  domainId?: Maybe<Scalars['Int']>;
  domainLogo?: Maybe<GQLAttachments>;
  domainLogoId?: Maybe<Scalars['String']>;
  emailPassword?: Maybe<Scalars['String']>;
  emailService?: Maybe<Scalars['String']>;
  emailUserName?: Maybe<Scalars['String']>;
  fromEmail?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  providerAPIKey?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};


export type GQLDomainsEmailSettingsDomainLogoArgs = {
  access?: InputMaybe<Scalars['String']>;
  accessAny?: InputMaybe<Scalars['String']>;
  accessContain?: InputMaybe<Scalars['String']>;
  accessEq?: InputMaybe<Scalars['String']>;
  accessGt?: InputMaybe<Scalars['String']>;
  accessGte?: InputMaybe<Scalars['String']>;
  accessIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accessIsNull?: InputMaybe<Scalars['Boolean']>;
  accessLike?: InputMaybe<Scalars['String']>;
  accessLikeNoCase?: InputMaybe<Scalars['String']>;
  accessLt?: InputMaybe<Scalars['String']>;
  accessLte?: InputMaybe<Scalars['String']>;
  accessNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alt?: InputMaybe<Scalars['String']>;
  altAny?: InputMaybe<Scalars['String']>;
  altContain?: InputMaybe<Scalars['String']>;
  altEq?: InputMaybe<Scalars['String']>;
  altGt?: InputMaybe<Scalars['String']>;
  altGte?: InputMaybe<Scalars['String']>;
  altIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  altIsNull?: InputMaybe<Scalars['Boolean']>;
  altLike?: InputMaybe<Scalars['String']>;
  altLikeNoCase?: InputMaybe<Scalars['String']>;
  altLt?: InputMaybe<Scalars['String']>;
  altLte?: InputMaybe<Scalars['String']>;
  altNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caption?: InputMaybe<Scalars['String']>;
  captionAny?: InputMaybe<Scalars['String']>;
  captionContain?: InputMaybe<Scalars['String']>;
  captionEq?: InputMaybe<Scalars['String']>;
  captionGt?: InputMaybe<Scalars['String']>;
  captionGte?: InputMaybe<Scalars['String']>;
  captionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  captionIsNull?: InputMaybe<Scalars['Boolean']>;
  captionLike?: InputMaybe<Scalars['String']>;
  captionLikeNoCase?: InputMaybe<Scalars['String']>;
  captionLt?: InputMaybe<Scalars['String']>;
  captionLte?: InputMaybe<Scalars['String']>;
  captionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fullPath?: InputMaybe<Scalars['String']>;
  fullPathAny?: InputMaybe<Scalars['String']>;
  fullPathContain?: InputMaybe<Scalars['String']>;
  fullPathEq?: InputMaybe<Scalars['String']>;
  fullPathGt?: InputMaybe<Scalars['String']>;
  fullPathGte?: InputMaybe<Scalars['String']>;
  fullPathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullPathIsNull?: InputMaybe<Scalars['Boolean']>;
  fullPathLike?: InputMaybe<Scalars['String']>;
  fullPathLikeNoCase?: InputMaybe<Scalars['String']>;
  fullPathLt?: InputMaybe<Scalars['String']>;
  fullPathLte?: InputMaybe<Scalars['String']>;
  fullPathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mimeType?: InputMaybe<Scalars['String']>;
  mimeTypeAny?: InputMaybe<Scalars['String']>;
  mimeTypeContain?: InputMaybe<Scalars['String']>;
  mimeTypeEq?: InputMaybe<Scalars['String']>;
  mimeTypeGt?: InputMaybe<Scalars['String']>;
  mimeTypeGte?: InputMaybe<Scalars['String']>;
  mimeTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mimeTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  mimeTypeLike?: InputMaybe<Scalars['String']>;
  mimeTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  mimeTypeLt?: InputMaybe<Scalars['String']>;
  mimeTypeLte?: InputMaybe<Scalars['String']>;
  mimeTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  originalName?: InputMaybe<Scalars['String']>;
  originalNameAny?: InputMaybe<Scalars['String']>;
  originalNameContain?: InputMaybe<Scalars['String']>;
  originalNameEq?: InputMaybe<Scalars['String']>;
  originalNameGt?: InputMaybe<Scalars['String']>;
  originalNameGte?: InputMaybe<Scalars['String']>;
  originalNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  originalNameIsNull?: InputMaybe<Scalars['Boolean']>;
  originalNameLike?: InputMaybe<Scalars['String']>;
  originalNameLikeNoCase?: InputMaybe<Scalars['String']>;
  originalNameLt?: InputMaybe<Scalars['String']>;
  originalNameLte?: InputMaybe<Scalars['String']>;
  originalNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  path?: InputMaybe<Scalars['String']>;
  pathAny?: InputMaybe<Scalars['String']>;
  pathContain?: InputMaybe<Scalars['String']>;
  pathEq?: InputMaybe<Scalars['String']>;
  pathGt?: InputMaybe<Scalars['String']>;
  pathGte?: InputMaybe<Scalars['String']>;
  pathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pathIsNull?: InputMaybe<Scalars['Boolean']>;
  pathLike?: InputMaybe<Scalars['String']>;
  pathLikeNoCase?: InputMaybe<Scalars['String']>;
  pathLt?: InputMaybe<Scalars['String']>;
  pathLte?: InputMaybe<Scalars['String']>;
  pathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  size?: InputMaybe<Scalars['Int']>;
  sizeAny?: InputMaybe<Scalars['Int']>;
  sizeContain?: InputMaybe<Scalars['Int']>;
  sizeEq?: InputMaybe<Scalars['Int']>;
  sizeGt?: InputMaybe<Scalars['Int']>;
  sizeGte?: InputMaybe<Scalars['Int']>;
  sizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sizeLike?: InputMaybe<Scalars['Int']>;
  sizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sizeLt?: InputMaybe<Scalars['Int']>;
  sizeLte?: InputMaybe<Scalars['Int']>;
  sizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLDomainsEmailSettingsPropertiesEnum {
  BccEmail = 'bccEmail',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  DomainId = 'domainId',
  DomainLogoId = 'domainLogoId',
  EmailPassword = 'emailPassword',
  EmailService = 'emailService',
  EmailUserName = 'emailUserName',
  FromEmail = 'fromEmail',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  ProviderApiKey = 'providerAPIKey',
  UpdatedAt = 'updatedAt'
}

export enum GQLDomainsPropertiesEnum {
  AllowedLanguages = 'allowedLanguages',
  AnalyticsCodeId = 'analyticsCodeId',
  CacheSettings = 'cacheSettings',
  ClickyCodeId = 'clickyCodeId',
  Config = 'config',
  CreatedAt = 'createdAt',
  Description = 'description',
  EnableChatWidget = 'enableChatWidget',
  EnableJornayaId = 'enableJornayaId',
  EnableTrustedForm = 'enableTrustedForm',
  FacebookConversionApiSettings = 'facebookConversionAPISettings',
  FacebookSiteVerificationCode = 'facebookSiteVerificationCode',
  FallbackSettings = 'fallbackSettings',
  FaviconId = 'faviconId',
  GoogleSiteVerificationCode = 'googleSiteVerificationCode',
  GtmId = 'gtmId',
  HoldingRules = 'holdingRules',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  IsInspectorEnabled = 'isInspectorEnabled',
  LogoId = 'logoId',
  Name = 'name',
  NiceName = 'niceName',
  OtpVerificationCriteria = 'otpVerificationCriteria',
  RecaptchaConfig = 'recaptchaConfig',
  SecondaryLogoId = 'secondaryLogoId',
  SendNotifications = 'sendNotifications',
  Settings = 'settings',
  Slogan = 'slogan',
  TemplateConfig = 'templateConfig',
  Title = 'title',
  TwitterPixel = 'twitterPixel',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type GQLEnhancedRedirections = {
  __typename?: 'EnhancedRedirections';
  createdBy?: Maybe<Scalars['String']>;
  destinationURI?: Maybe<Scalars['String']>;
  domainId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  redirectionStatusCode?: Maybe<Scalars['Int']>;
  srcURI?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type GQLFacebookWebhookEvents = {
  __typename?: 'FacebookWebhookEvents';
  createdAt?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
  facebookFormId?: Maybe<Scalars['String']>;
  facebookPageId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lead?: Maybe<GQLLeads>;
  leadUuid?: Maybe<Scalars['String']>;
  leadgenId?: Maybe<Scalars['String']>;
  operation?: Maybe<Scalars['JSON']>;
  requestInfo?: Maybe<Scalars['JSON']>;
  result?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['String']>;
  webHookEventData?: Maybe<Scalars['JSON']>;
};


export type GQLFacebookWebhookEventsLeadArgs = {
  advertisingNetworkId?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdAny?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdContain?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdEq?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdGt?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdGte?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  advertisingNetworkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  advertisingNetworkIdLike?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdLt?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdLte?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainFormId?: InputMaybe<Scalars['Int']>;
  domainFormIdAny?: InputMaybe<Scalars['Int']>;
  domainFormIdContain?: InputMaybe<Scalars['Int']>;
  domainFormIdEq?: InputMaybe<Scalars['Int']>;
  domainFormIdGt?: InputMaybe<Scalars['Int']>;
  domainFormIdGte?: InputMaybe<Scalars['Int']>;
  domainFormIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainFormIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainFormIdLike?: InputMaybe<Scalars['Int']>;
  domainFormIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainFormIdLt?: InputMaybe<Scalars['Int']>;
  domainFormIdLte?: InputMaybe<Scalars['Int']>;
  domainFormIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  feedback?: InputMaybe<Scalars['JSON']>;
  feedbackAny?: InputMaybe<Scalars['JSON']>;
  feedbackContain?: InputMaybe<Scalars['JSON']>;
  feedbackEq?: InputMaybe<Scalars['JSON']>;
  feedbackGt?: InputMaybe<Scalars['JSON']>;
  feedbackGte?: InputMaybe<Scalars['JSON']>;
  feedbackIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  feedbackIsNull?: InputMaybe<Scalars['Boolean']>;
  feedbackLike?: InputMaybe<Scalars['JSON']>;
  feedbackLikeNoCase?: InputMaybe<Scalars['JSON']>;
  feedbackLt?: InputMaybe<Scalars['JSON']>;
  feedbackLte?: InputMaybe<Scalars['JSON']>;
  feedbackNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  hasAliasCalls?: InputMaybe<Scalars['String']>;
  hasAliasCallsAny?: InputMaybe<Scalars['String']>;
  hasAliasCallsContain?: InputMaybe<Scalars['String']>;
  hasAliasCallsEq?: InputMaybe<Scalars['String']>;
  hasAliasCallsGt?: InputMaybe<Scalars['String']>;
  hasAliasCallsGte?: InputMaybe<Scalars['String']>;
  hasAliasCallsIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hasAliasCallsIsNull?: InputMaybe<Scalars['Boolean']>;
  hasAliasCallsLike?: InputMaybe<Scalars['String']>;
  hasAliasCallsLikeNoCase?: InputMaybe<Scalars['String']>;
  hasAliasCallsLt?: InputMaybe<Scalars['String']>;
  hasAliasCallsLte?: InputMaybe<Scalars['String']>;
  hasAliasCallsNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOptedOut?: InputMaybe<Scalars['Boolean']>;
  isOptedOutAny?: InputMaybe<Scalars['Boolean']>;
  isOptedOutContain?: InputMaybe<Scalars['Boolean']>;
  isOptedOutEq?: InputMaybe<Scalars['Boolean']>;
  isOptedOutGt?: InputMaybe<Scalars['Boolean']>;
  isOptedOutGte?: InputMaybe<Scalars['Boolean']>;
  isOptedOutIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOptedOutIsNull?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLike?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLt?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLte?: InputMaybe<Scalars['Boolean']>;
  isOptedOutNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  jornayaId?: InputMaybe<Scalars['String']>;
  jornayaIdAny?: InputMaybe<Scalars['String']>;
  jornayaIdContain?: InputMaybe<Scalars['String']>;
  jornayaIdEq?: InputMaybe<Scalars['String']>;
  jornayaIdGt?: InputMaybe<Scalars['String']>;
  jornayaIdGte?: InputMaybe<Scalars['String']>;
  jornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  jornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  jornayaIdLike?: InputMaybe<Scalars['String']>;
  jornayaIdLikeNoCase?: InputMaybe<Scalars['String']>;
  jornayaIdLt?: InputMaybe<Scalars['String']>;
  jornayaIdLte?: InputMaybe<Scalars['String']>;
  jornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modifiedAt?: InputMaybe<Scalars['String']>;
  modifiedAtAny?: InputMaybe<Scalars['String']>;
  modifiedAtContain?: InputMaybe<Scalars['String']>;
  modifiedAtEq?: InputMaybe<Scalars['String']>;
  modifiedAtGt?: InputMaybe<Scalars['String']>;
  modifiedAtGte?: InputMaybe<Scalars['String']>;
  modifiedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedAtLike?: InputMaybe<Scalars['String']>;
  modifiedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedAtLt?: InputMaybe<Scalars['String']>;
  modifiedAtLte?: InputMaybe<Scalars['String']>;
  modifiedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLLeadsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLeadsPropertiesEnum>;
  piiId?: InputMaybe<Scalars['Int']>;
  piiIdAny?: InputMaybe<Scalars['Int']>;
  piiIdContain?: InputMaybe<Scalars['Int']>;
  piiIdEq?: InputMaybe<Scalars['Int']>;
  piiIdGt?: InputMaybe<Scalars['Int']>;
  piiIdGte?: InputMaybe<Scalars['Int']>;
  piiIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  piiIdIsNull?: InputMaybe<Scalars['Boolean']>;
  piiIdLike?: InputMaybe<Scalars['Int']>;
  piiIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  piiIdLt?: InputMaybe<Scalars['Int']>;
  piiIdLte?: InputMaybe<Scalars['Int']>;
  piiIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sales?: InputMaybe<Scalars['String']>;
  salesAny?: InputMaybe<Scalars['String']>;
  salesContain?: InputMaybe<Scalars['String']>;
  salesEq?: InputMaybe<Scalars['String']>;
  salesGt?: InputMaybe<Scalars['String']>;
  salesGte?: InputMaybe<Scalars['String']>;
  salesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  salesIsNull?: InputMaybe<Scalars['Boolean']>;
  salesLike?: InputMaybe<Scalars['String']>;
  salesLikeNoCase?: InputMaybe<Scalars['String']>;
  salesLt?: InputMaybe<Scalars['String']>;
  salesLte?: InputMaybe<Scalars['String']>;
  salesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Scalars['String']>;
  statusAny?: InputMaybe<Scalars['String']>;
  statusContain?: InputMaybe<Scalars['String']>;
  statusEq?: InputMaybe<Scalars['String']>;
  statusGt?: InputMaybe<Scalars['String']>;
  statusGte?: InputMaybe<Scalars['String']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statusIsNull?: InputMaybe<Scalars['Boolean']>;
  statusLike?: InputMaybe<Scalars['String']>;
  statusLikeNoCase?: InputMaybe<Scalars['String']>;
  statusLt?: InputMaybe<Scalars['String']>;
  statusLte?: InputMaybe<Scalars['String']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  submissionStatus?: InputMaybe<Scalars['String']>;
  submissionStatusAny?: InputMaybe<Scalars['String']>;
  submissionStatusContain?: InputMaybe<Scalars['String']>;
  submissionStatusEq?: InputMaybe<Scalars['String']>;
  submissionStatusGt?: InputMaybe<Scalars['String']>;
  submissionStatusGte?: InputMaybe<Scalars['String']>;
  submissionStatusIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  submissionStatusIsNull?: InputMaybe<Scalars['Boolean']>;
  submissionStatusLike?: InputMaybe<Scalars['String']>;
  submissionStatusLikeNoCase?: InputMaybe<Scalars['String']>;
  submissionStatusLt?: InputMaybe<Scalars['String']>;
  submissionStatusLte?: InputMaybe<Scalars['String']>;
  submissionStatusNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficSource?: InputMaybe<Scalars['String']>;
  trafficSourceAny?: InputMaybe<Scalars['String']>;
  trafficSourceContain?: InputMaybe<Scalars['String']>;
  trafficSourceEq?: InputMaybe<Scalars['String']>;
  trafficSourceGt?: InputMaybe<Scalars['String']>;
  trafficSourceGte?: InputMaybe<Scalars['String']>;
  trafficSourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficSourceIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficSourceLike?: InputMaybe<Scalars['String']>;
  trafficSourceLikeNoCase?: InputMaybe<Scalars['String']>;
  trafficSourceLt?: InputMaybe<Scalars['String']>;
  trafficSourceLte?: InputMaybe<Scalars['String']>;
  trafficSourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficTypeId?: InputMaybe<Scalars['Int']>;
  trafficTypeIdAny?: InputMaybe<Scalars['Int']>;
  trafficTypeIdContain?: InputMaybe<Scalars['Int']>;
  trafficTypeIdEq?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  trafficTypeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficTypeIdLike?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  trustedFormCertificateClaimed?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedAny?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedContain?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedEq?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedGt?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedGte?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  trustedFormCertificateClaimedIsNull?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLike?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLt?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLte?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  trustedFormCertificateUrl?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlAny?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlContain?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlEq?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlGt?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlGte?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trustedFormCertificateUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateUrlLike?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlLt?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlLte?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uuid?: InputMaybe<Scalars['String']>;
  uuidAny?: InputMaybe<Scalars['String']>;
  uuidContain?: InputMaybe<Scalars['String']>;
  uuidEq?: InputMaybe<Scalars['String']>;
  uuidGt?: InputMaybe<Scalars['String']>;
  uuidGte?: InputMaybe<Scalars['String']>;
  uuidIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uuidIsNull?: InputMaybe<Scalars['Boolean']>;
  uuidLike?: InputMaybe<Scalars['String']>;
  uuidLikeNoCase?: InputMaybe<Scalars['String']>;
  uuidLt?: InputMaybe<Scalars['String']>;
  uuidLte?: InputMaybe<Scalars['String']>;
  uuidNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitData?: InputMaybe<Scalars['JSON']>;
  visitDataAny?: InputMaybe<Scalars['JSON']>;
  visitDataContain?: InputMaybe<Scalars['JSON']>;
  visitDataEq?: InputMaybe<Scalars['JSON']>;
  visitDataGt?: InputMaybe<Scalars['JSON']>;
  visitDataGte?: InputMaybe<Scalars['JSON']>;
  visitDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  visitDataIsNull?: InputMaybe<Scalars['Boolean']>;
  visitDataLike?: InputMaybe<Scalars['JSON']>;
  visitDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  visitDataLt?: InputMaybe<Scalars['JSON']>;
  visitDataLte?: InputMaybe<Scalars['JSON']>;
  visitDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  visitId?: InputMaybe<Scalars['String']>;
  visitIdAny?: InputMaybe<Scalars['String']>;
  visitIdContain?: InputMaybe<Scalars['String']>;
  visitIdEq?: InputMaybe<Scalars['String']>;
  visitIdGt?: InputMaybe<Scalars['String']>;
  visitIdGte?: InputMaybe<Scalars['String']>;
  visitIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitIdIsNull?: InputMaybe<Scalars['Boolean']>;
  visitIdLike?: InputMaybe<Scalars['String']>;
  visitIdLikeNoCase?: InputMaybe<Scalars['String']>;
  visitIdLt?: InputMaybe<Scalars['String']>;
  visitIdLte?: InputMaybe<Scalars['String']>;
  visitIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitorId?: InputMaybe<Scalars['String']>;
  visitorIdAny?: InputMaybe<Scalars['String']>;
  visitorIdContain?: InputMaybe<Scalars['String']>;
  visitorIdEq?: InputMaybe<Scalars['String']>;
  visitorIdGt?: InputMaybe<Scalars['String']>;
  visitorIdGte?: InputMaybe<Scalars['String']>;
  visitorIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitorIdIsNull?: InputMaybe<Scalars['Boolean']>;
  visitorIdLike?: InputMaybe<Scalars['String']>;
  visitorIdLikeNoCase?: InputMaybe<Scalars['String']>;
  visitorIdLt?: InputMaybe<Scalars['String']>;
  visitorIdLte?: InputMaybe<Scalars['String']>;
  visitorIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLFacebookWebhookEventsPropertiesEnum {
  CreatedAt = 'createdAt',
  Data = 'data',
  FacebookFormId = 'facebookFormId',
  FacebookPageId = 'facebookPageId',
  Id = 'id',
  LeadUuid = 'leadUuid',
  LeadgenId = 'leadgenId',
  Operation = 'operation',
  RequestInfo = 'requestInfo',
  Result = 'result',
  UpdatedAt = 'updatedAt',
  WebHookEventData = 'webHookEventData'
}

export type GQLFaqs = {
  __typename?: 'Faqs';
  answer?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  deletedBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['Int']>;
  modelType?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export enum GQLFaqsPropertiesEnum {
  Answer = 'answer',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Id = 'id',
  IsDeleted = 'isDeleted',
  Language = 'language',
  ModelId = 'modelId',
  ModelType = 'modelType',
  Question = 'question',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy'
}

export type GQLFields = {
  __typename?: 'Fields';
  autocomplete?: Maybe<Scalars['String']>;
  codeName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  dataDependency?: Maybe<Scalars['JSON']>;
  defaultValue?: Maybe<Scalars['String']>;
  defaultValues?: Maybe<Scalars['JSON']>;
  deletedAt?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  fieldType?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['Int']>;
  iconId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isGlobal?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  mask?: Maybe<Scalars['String']>;
  maxValue?: Maybe<Scalars['JSON']>;
  meta?: Maybe<Scalars['JSON']>;
  minValue?: Maybe<Scalars['JSON']>;
  modifiedAt?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  niceName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  pattern?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  updatedAt?: Maybe<Scalars['String']>;
  useCase?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  validationType?: Maybe<Scalars['String']>;
};


export type GQLFieldsTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type GQLFieldsMeta = {
  __typename?: 'FieldsMeta';
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export enum GQLFieldsMetaPropertiesEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  IsDeleted = 'isDeleted',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export enum GQLFieldsPropertiesEnum {
  Autocomplete = 'autocomplete',
  CodeName = 'codeName',
  CreatedAt = 'createdAt',
  DataDependency = 'dataDependency',
  DefaultValue = 'defaultValue',
  DefaultValues = 'defaultValues',
  DeletedAt = 'deletedAt',
  ErrorMessage = 'errorMessage',
  FieldType = 'fieldType',
  FormId = 'formId',
  IconId = 'iconId',
  Id = 'id',
  IsDeleted = 'isDeleted',
  IsGlobal = 'isGlobal',
  Label = 'label',
  Mask = 'mask',
  MaxValue = 'maxValue',
  Meta = 'meta',
  MinValue = 'minValue',
  ModifiedAt = 'modifiedAt',
  ModifiedBy = 'modifiedBy',
  NiceName = 'niceName',
  Note = 'note',
  Pattern = 'pattern',
  Placeholder = 'placeholder',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  UseCase = 'useCase',
  UserId = 'userId',
  ValidationType = 'validationType'
}

export type GQLForms = {
  __typename?: 'Forms';
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  domainForm?: Maybe<Array<Maybe<GQLDomainForms>>>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isVariant?: Maybe<Scalars['Boolean']>;
  listing?: Maybe<GQLListings>;
  listingId?: Maybe<Scalars['Int']>;
  modifiedAt?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  stepToFetchBuyers?: Maybe<Scalars['Int']>;
  stepToSendingData?: Maybe<Scalars['Int']>;
  steps?: Maybe<Array<Maybe<GQLSteps>>>;
  successMessage?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  updatedAt?: Maybe<Scalars['String']>;
  variantParent?: Maybe<GQLForms>;
  variantParentId?: Maybe<Scalars['Int']>;
};


export type GQLFormsDomainFormArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formId?: InputMaybe<Scalars['Int']>;
  formIdAny?: InputMaybe<Scalars['Int']>;
  formIdContain?: InputMaybe<Scalars['Int']>;
  formIdEq?: InputMaybe<Scalars['Int']>;
  formIdGt?: InputMaybe<Scalars['Int']>;
  formIdGte?: InputMaybe<Scalars['Int']>;
  formIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formIdIsNull?: InputMaybe<Scalars['Boolean']>;
  formIdLike?: InputMaybe<Scalars['Int']>;
  formIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  formIdLt?: InputMaybe<Scalars['Int']>;
  formIdLte?: InputMaybe<Scalars['Int']>;
  formIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  integrations?: InputMaybe<Scalars['JSON']>;
  integrationsAny?: InputMaybe<Scalars['JSON']>;
  integrationsContain?: InputMaybe<Scalars['JSON']>;
  integrationsEq?: InputMaybe<Scalars['JSON']>;
  integrationsGt?: InputMaybe<Scalars['JSON']>;
  integrationsGte?: InputMaybe<Scalars['JSON']>;
  integrationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  integrationsIsNull?: InputMaybe<Scalars['Boolean']>;
  integrationsLike?: InputMaybe<Scalars['JSON']>;
  integrationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  integrationsLt?: InputMaybe<Scalars['JSON']>;
  integrationsLte?: InputMaybe<Scalars['JSON']>;
  integrationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainFormsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainFormsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLFormsListingArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLListingsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLListingsPropertiesEnum>;
  pageTitle?: InputMaybe<Scalars['String']>;
  pageTitleAny?: InputMaybe<Scalars['String']>;
  pageTitleContain?: InputMaybe<Scalars['String']>;
  pageTitleEq?: InputMaybe<Scalars['String']>;
  pageTitleGt?: InputMaybe<Scalars['String']>;
  pageTitleGte?: InputMaybe<Scalars['String']>;
  pageTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  pageTitleLike?: InputMaybe<Scalars['String']>;
  pageTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  pageTitleLt?: InputMaybe<Scalars['String']>;
  pageTitleLte?: InputMaybe<Scalars['String']>;
  pageTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLFormsStepsArgs = {
  adminTitle?: InputMaybe<Scalars['String']>;
  adminTitleAny?: InputMaybe<Scalars['String']>;
  adminTitleContain?: InputMaybe<Scalars['String']>;
  adminTitleEq?: InputMaybe<Scalars['String']>;
  adminTitleGt?: InputMaybe<Scalars['String']>;
  adminTitleGte?: InputMaybe<Scalars['String']>;
  adminTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adminTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  adminTitleLike?: InputMaybe<Scalars['String']>;
  adminTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  adminTitleLt?: InputMaybe<Scalars['String']>;
  adminTitleLte?: InputMaybe<Scalars['String']>;
  adminTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buttonText?: InputMaybe<Scalars['String']>;
  buttonTextAny?: InputMaybe<Scalars['String']>;
  buttonTextContain?: InputMaybe<Scalars['String']>;
  buttonTextEq?: InputMaybe<Scalars['String']>;
  buttonTextGt?: InputMaybe<Scalars['String']>;
  buttonTextGte?: InputMaybe<Scalars['String']>;
  buttonTextIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buttonTextIsNull?: InputMaybe<Scalars['Boolean']>;
  buttonTextLike?: InputMaybe<Scalars['String']>;
  buttonTextLikeNoCase?: InputMaybe<Scalars['String']>;
  buttonTextLt?: InputMaybe<Scalars['String']>;
  buttonTextLte?: InputMaybe<Scalars['String']>;
  buttonTextNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  formId?: InputMaybe<Scalars['Int']>;
  formIdAny?: InputMaybe<Scalars['Int']>;
  formIdContain?: InputMaybe<Scalars['Int']>;
  formIdEq?: InputMaybe<Scalars['Int']>;
  formIdGt?: InputMaybe<Scalars['Int']>;
  formIdGte?: InputMaybe<Scalars['Int']>;
  formIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formIdIsNull?: InputMaybe<Scalars['Boolean']>;
  formIdLike?: InputMaybe<Scalars['Int']>;
  formIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  formIdLt?: InputMaybe<Scalars['Int']>;
  formIdLte?: InputMaybe<Scalars['Int']>;
  formIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  includeTCPAMessage?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageAny?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageContain?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageEq?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageGt?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageGte?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  includeTCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageLike?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageLt?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageLte?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLStepsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLStepsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltipAny?: InputMaybe<Scalars['String']>;
  tooltipContain?: InputMaybe<Scalars['String']>;
  tooltipEq?: InputMaybe<Scalars['String']>;
  tooltipGt?: InputMaybe<Scalars['String']>;
  tooltipGte?: InputMaybe<Scalars['String']>;
  tooltipIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tooltipIsNull?: InputMaybe<Scalars['Boolean']>;
  tooltipLike?: InputMaybe<Scalars['String']>;
  tooltipLikeNoCase?: InputMaybe<Scalars['String']>;
  tooltipLt?: InputMaybe<Scalars['String']>;
  tooltipLte?: InputMaybe<Scalars['String']>;
  tooltipNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLFormsTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};


export type GQLFormsVariantParentArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorMessageAny?: InputMaybe<Scalars['String']>;
  errorMessageContain?: InputMaybe<Scalars['String']>;
  errorMessageEq?: InputMaybe<Scalars['String']>;
  errorMessageGt?: InputMaybe<Scalars['String']>;
  errorMessageGte?: InputMaybe<Scalars['String']>;
  errorMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  errorMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  errorMessageLike?: InputMaybe<Scalars['String']>;
  errorMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  errorMessageLt?: InputMaybe<Scalars['String']>;
  errorMessageLte?: InputMaybe<Scalars['String']>;
  errorMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVariant?: InputMaybe<Scalars['Boolean']>;
  isVariantAny?: InputMaybe<Scalars['Boolean']>;
  isVariantContain?: InputMaybe<Scalars['Boolean']>;
  isVariantEq?: InputMaybe<Scalars['Boolean']>;
  isVariantGt?: InputMaybe<Scalars['Boolean']>;
  isVariantGte?: InputMaybe<Scalars['Boolean']>;
  isVariantIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVariantIsNull?: InputMaybe<Scalars['Boolean']>;
  isVariantLike?: InputMaybe<Scalars['Boolean']>;
  isVariantLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVariantLt?: InputMaybe<Scalars['Boolean']>;
  isVariantLte?: InputMaybe<Scalars['Boolean']>;
  isVariantNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingId?: InputMaybe<Scalars['Int']>;
  listingIdAny?: InputMaybe<Scalars['Int']>;
  listingIdContain?: InputMaybe<Scalars['Int']>;
  listingIdEq?: InputMaybe<Scalars['Int']>;
  listingIdGt?: InputMaybe<Scalars['Int']>;
  listingIdGte?: InputMaybe<Scalars['Int']>;
  listingIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingIdIsNull?: InputMaybe<Scalars['Boolean']>;
  listingIdLike?: InputMaybe<Scalars['Int']>;
  listingIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  listingIdLt?: InputMaybe<Scalars['Int']>;
  listingIdLte?: InputMaybe<Scalars['Int']>;
  listingIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modifiedAt?: InputMaybe<Scalars['String']>;
  modifiedAtAny?: InputMaybe<Scalars['String']>;
  modifiedAtContain?: InputMaybe<Scalars['String']>;
  modifiedAtEq?: InputMaybe<Scalars['String']>;
  modifiedAtGt?: InputMaybe<Scalars['String']>;
  modifiedAtGte?: InputMaybe<Scalars['String']>;
  modifiedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedAtLike?: InputMaybe<Scalars['String']>;
  modifiedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedAtLt?: InputMaybe<Scalars['String']>;
  modifiedAtLte?: InputMaybe<Scalars['String']>;
  modifiedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLFormsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLFormsPropertiesEnum>;
  stepToFetchBuyers?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersAny?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersContain?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersEq?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersGt?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersGte?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToFetchBuyersIsNull?: InputMaybe<Scalars['Boolean']>;
  stepToFetchBuyersLike?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersLikeNoCase?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersLt?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersLte?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToSendingData?: InputMaybe<Scalars['Int']>;
  stepToSendingDataAny?: InputMaybe<Scalars['Int']>;
  stepToSendingDataContain?: InputMaybe<Scalars['Int']>;
  stepToSendingDataEq?: InputMaybe<Scalars['Int']>;
  stepToSendingDataGt?: InputMaybe<Scalars['Int']>;
  stepToSendingDataGte?: InputMaybe<Scalars['Int']>;
  stepToSendingDataIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToSendingDataIsNull?: InputMaybe<Scalars['Boolean']>;
  stepToSendingDataLike?: InputMaybe<Scalars['Int']>;
  stepToSendingDataLikeNoCase?: InputMaybe<Scalars['Int']>;
  stepToSendingDataLt?: InputMaybe<Scalars['Int']>;
  stepToSendingDataLte?: InputMaybe<Scalars['Int']>;
  stepToSendingDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  successMessage?: InputMaybe<Scalars['String']>;
  successMessageAny?: InputMaybe<Scalars['String']>;
  successMessageContain?: InputMaybe<Scalars['String']>;
  successMessageEq?: InputMaybe<Scalars['String']>;
  successMessageGt?: InputMaybe<Scalars['String']>;
  successMessageGte?: InputMaybe<Scalars['String']>;
  successMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  successMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  successMessageLike?: InputMaybe<Scalars['String']>;
  successMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  successMessageLt?: InputMaybe<Scalars['String']>;
  successMessageLte?: InputMaybe<Scalars['String']>;
  successMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  variantParentId?: InputMaybe<Scalars['Int']>;
  variantParentIdAny?: InputMaybe<Scalars['Int']>;
  variantParentIdContain?: InputMaybe<Scalars['Int']>;
  variantParentIdEq?: InputMaybe<Scalars['Int']>;
  variantParentIdGt?: InputMaybe<Scalars['Int']>;
  variantParentIdGte?: InputMaybe<Scalars['Int']>;
  variantParentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  variantParentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  variantParentIdLike?: InputMaybe<Scalars['Int']>;
  variantParentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  variantParentIdLt?: InputMaybe<Scalars['Int']>;
  variantParentIdLte?: InputMaybe<Scalars['Int']>;
  variantParentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export enum GQLFormsPropertiesEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  ErrorMessage = 'errorMessage',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  IsVariant = 'isVariant',
  ListingId = 'listingId',
  ModifiedAt = 'modifiedAt',
  ModifiedBy = 'modifiedBy',
  StepToFetchBuyers = 'stepToFetchBuyers',
  StepToSendingData = 'stepToSendingData',
  SuccessMessage = 'successMessage',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  VariantParentId = 'variantParentId'
}

export type GQLIpAddresses = {
  __typename?: 'IpAddresses';
  bannedAt?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  continent?: Maybe<Scalars['String']>;
  continentCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  expireAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  ip?: Maybe<Scalars['String']>;
  isBanned?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isp?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export enum GQLIpAddressesPropertiesEnum {
  BannedAt = 'bannedAt',
  City = 'city',
  Continent = 'continent',
  ContinentCode = 'continentCode',
  Country = 'country',
  CountryCode = 'countryCode',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  ExpireAt = 'expireAt',
  Id = 'id',
  Ip = 'ip',
  IsBanned = 'isBanned',
  IsDeleted = 'isDeleted',
  Isp = 'isp',
  Latitude = 'latitude',
  Longitude = 'longitude',
  PostalCode = 'postalCode',
  Provider = 'provider',
  State = 'state',
  StateCode = 'stateCode',
  UpdatedAt = 'updatedAt'
}

export type GQLIpFallbackProviderLog = {
  __typename?: 'IpFallbackProviderLog';
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  fallbackProvider?: Maybe<Scalars['String']>;
  fallbackProviderData?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['Int']>;
  ipAddress?: Maybe<Scalars['String']>;
  ipAddressId?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  mainProvider?: Maybe<Scalars['String']>;
  mainProviderData?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export enum GQLIpFallbackProviderLogPropertiesEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  FallbackProvider = 'fallbackProvider',
  FallbackProviderData = 'fallbackProviderData',
  Id = 'id',
  IpAddress = 'ipAddress',
  IpAddressId = 'ipAddressId',
  IsDeleted = 'isDeleted',
  MainProvider = 'mainProvider',
  MainProviderData = 'mainProviderData',
  UpdatedAt = 'updatedAt'
}

export type GQLLeadConversionEventLogs = {
  __typename?: 'LeadConversionEventLogs';
  adNetwork?: Maybe<GQLAdvertisingNetworks>;
  adNetworkId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  domainId?: Maybe<Scalars['Int']>;
  event?: Maybe<Scalars['String']>;
  form?: Maybe<GQLForms>;
  formId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lead?: Maybe<GQLLeads>;
  leadId?: Maybe<Scalars['Int']>;
  pixelId?: Maybe<Scalars['String']>;
  request?: Maybe<Scalars['JSON']>;
  response?: Maybe<Scalars['JSON']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};


export type GQLLeadConversionEventLogsAdNetworkArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAdvertisingNetworksPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAdvertisingNetworksPropertiesEnum>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLLeadConversionEventLogsFormArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorMessageAny?: InputMaybe<Scalars['String']>;
  errorMessageContain?: InputMaybe<Scalars['String']>;
  errorMessageEq?: InputMaybe<Scalars['String']>;
  errorMessageGt?: InputMaybe<Scalars['String']>;
  errorMessageGte?: InputMaybe<Scalars['String']>;
  errorMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  errorMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  errorMessageLike?: InputMaybe<Scalars['String']>;
  errorMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  errorMessageLt?: InputMaybe<Scalars['String']>;
  errorMessageLte?: InputMaybe<Scalars['String']>;
  errorMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVariant?: InputMaybe<Scalars['Boolean']>;
  isVariantAny?: InputMaybe<Scalars['Boolean']>;
  isVariantContain?: InputMaybe<Scalars['Boolean']>;
  isVariantEq?: InputMaybe<Scalars['Boolean']>;
  isVariantGt?: InputMaybe<Scalars['Boolean']>;
  isVariantGte?: InputMaybe<Scalars['Boolean']>;
  isVariantIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVariantIsNull?: InputMaybe<Scalars['Boolean']>;
  isVariantLike?: InputMaybe<Scalars['Boolean']>;
  isVariantLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVariantLt?: InputMaybe<Scalars['Boolean']>;
  isVariantLte?: InputMaybe<Scalars['Boolean']>;
  isVariantNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingId?: InputMaybe<Scalars['Int']>;
  listingIdAny?: InputMaybe<Scalars['Int']>;
  listingIdContain?: InputMaybe<Scalars['Int']>;
  listingIdEq?: InputMaybe<Scalars['Int']>;
  listingIdGt?: InputMaybe<Scalars['Int']>;
  listingIdGte?: InputMaybe<Scalars['Int']>;
  listingIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingIdIsNull?: InputMaybe<Scalars['Boolean']>;
  listingIdLike?: InputMaybe<Scalars['Int']>;
  listingIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  listingIdLt?: InputMaybe<Scalars['Int']>;
  listingIdLte?: InputMaybe<Scalars['Int']>;
  listingIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modifiedAt?: InputMaybe<Scalars['String']>;
  modifiedAtAny?: InputMaybe<Scalars['String']>;
  modifiedAtContain?: InputMaybe<Scalars['String']>;
  modifiedAtEq?: InputMaybe<Scalars['String']>;
  modifiedAtGt?: InputMaybe<Scalars['String']>;
  modifiedAtGte?: InputMaybe<Scalars['String']>;
  modifiedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedAtLike?: InputMaybe<Scalars['String']>;
  modifiedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedAtLt?: InputMaybe<Scalars['String']>;
  modifiedAtLte?: InputMaybe<Scalars['String']>;
  modifiedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLFormsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLFormsPropertiesEnum>;
  stepToFetchBuyers?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersAny?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersContain?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersEq?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersGt?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersGte?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToFetchBuyersIsNull?: InputMaybe<Scalars['Boolean']>;
  stepToFetchBuyersLike?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersLikeNoCase?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersLt?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersLte?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToSendingData?: InputMaybe<Scalars['Int']>;
  stepToSendingDataAny?: InputMaybe<Scalars['Int']>;
  stepToSendingDataContain?: InputMaybe<Scalars['Int']>;
  stepToSendingDataEq?: InputMaybe<Scalars['Int']>;
  stepToSendingDataGt?: InputMaybe<Scalars['Int']>;
  stepToSendingDataGte?: InputMaybe<Scalars['Int']>;
  stepToSendingDataIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToSendingDataIsNull?: InputMaybe<Scalars['Boolean']>;
  stepToSendingDataLike?: InputMaybe<Scalars['Int']>;
  stepToSendingDataLikeNoCase?: InputMaybe<Scalars['Int']>;
  stepToSendingDataLt?: InputMaybe<Scalars['Int']>;
  stepToSendingDataLte?: InputMaybe<Scalars['Int']>;
  stepToSendingDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  successMessage?: InputMaybe<Scalars['String']>;
  successMessageAny?: InputMaybe<Scalars['String']>;
  successMessageContain?: InputMaybe<Scalars['String']>;
  successMessageEq?: InputMaybe<Scalars['String']>;
  successMessageGt?: InputMaybe<Scalars['String']>;
  successMessageGte?: InputMaybe<Scalars['String']>;
  successMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  successMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  successMessageLike?: InputMaybe<Scalars['String']>;
  successMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  successMessageLt?: InputMaybe<Scalars['String']>;
  successMessageLte?: InputMaybe<Scalars['String']>;
  successMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  variantParentId?: InputMaybe<Scalars['Int']>;
  variantParentIdAny?: InputMaybe<Scalars['Int']>;
  variantParentIdContain?: InputMaybe<Scalars['Int']>;
  variantParentIdEq?: InputMaybe<Scalars['Int']>;
  variantParentIdGt?: InputMaybe<Scalars['Int']>;
  variantParentIdGte?: InputMaybe<Scalars['Int']>;
  variantParentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  variantParentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  variantParentIdLike?: InputMaybe<Scalars['Int']>;
  variantParentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  variantParentIdLt?: InputMaybe<Scalars['Int']>;
  variantParentIdLte?: InputMaybe<Scalars['Int']>;
  variantParentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLLeadConversionEventLogsLeadArgs = {
  advertisingNetworkId?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdAny?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdContain?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdEq?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdGt?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdGte?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  advertisingNetworkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  advertisingNetworkIdLike?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdLt?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdLte?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainFormId?: InputMaybe<Scalars['Int']>;
  domainFormIdAny?: InputMaybe<Scalars['Int']>;
  domainFormIdContain?: InputMaybe<Scalars['Int']>;
  domainFormIdEq?: InputMaybe<Scalars['Int']>;
  domainFormIdGt?: InputMaybe<Scalars['Int']>;
  domainFormIdGte?: InputMaybe<Scalars['Int']>;
  domainFormIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainFormIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainFormIdLike?: InputMaybe<Scalars['Int']>;
  domainFormIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainFormIdLt?: InputMaybe<Scalars['Int']>;
  domainFormIdLte?: InputMaybe<Scalars['Int']>;
  domainFormIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  feedback?: InputMaybe<Scalars['JSON']>;
  feedbackAny?: InputMaybe<Scalars['JSON']>;
  feedbackContain?: InputMaybe<Scalars['JSON']>;
  feedbackEq?: InputMaybe<Scalars['JSON']>;
  feedbackGt?: InputMaybe<Scalars['JSON']>;
  feedbackGte?: InputMaybe<Scalars['JSON']>;
  feedbackIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  feedbackIsNull?: InputMaybe<Scalars['Boolean']>;
  feedbackLike?: InputMaybe<Scalars['JSON']>;
  feedbackLikeNoCase?: InputMaybe<Scalars['JSON']>;
  feedbackLt?: InputMaybe<Scalars['JSON']>;
  feedbackLte?: InputMaybe<Scalars['JSON']>;
  feedbackNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  hasAliasCalls?: InputMaybe<Scalars['String']>;
  hasAliasCallsAny?: InputMaybe<Scalars['String']>;
  hasAliasCallsContain?: InputMaybe<Scalars['String']>;
  hasAliasCallsEq?: InputMaybe<Scalars['String']>;
  hasAliasCallsGt?: InputMaybe<Scalars['String']>;
  hasAliasCallsGte?: InputMaybe<Scalars['String']>;
  hasAliasCallsIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hasAliasCallsIsNull?: InputMaybe<Scalars['Boolean']>;
  hasAliasCallsLike?: InputMaybe<Scalars['String']>;
  hasAliasCallsLikeNoCase?: InputMaybe<Scalars['String']>;
  hasAliasCallsLt?: InputMaybe<Scalars['String']>;
  hasAliasCallsLte?: InputMaybe<Scalars['String']>;
  hasAliasCallsNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOptedOut?: InputMaybe<Scalars['Boolean']>;
  isOptedOutAny?: InputMaybe<Scalars['Boolean']>;
  isOptedOutContain?: InputMaybe<Scalars['Boolean']>;
  isOptedOutEq?: InputMaybe<Scalars['Boolean']>;
  isOptedOutGt?: InputMaybe<Scalars['Boolean']>;
  isOptedOutGte?: InputMaybe<Scalars['Boolean']>;
  isOptedOutIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOptedOutIsNull?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLike?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLt?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLte?: InputMaybe<Scalars['Boolean']>;
  isOptedOutNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  jornayaId?: InputMaybe<Scalars['String']>;
  jornayaIdAny?: InputMaybe<Scalars['String']>;
  jornayaIdContain?: InputMaybe<Scalars['String']>;
  jornayaIdEq?: InputMaybe<Scalars['String']>;
  jornayaIdGt?: InputMaybe<Scalars['String']>;
  jornayaIdGte?: InputMaybe<Scalars['String']>;
  jornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  jornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  jornayaIdLike?: InputMaybe<Scalars['String']>;
  jornayaIdLikeNoCase?: InputMaybe<Scalars['String']>;
  jornayaIdLt?: InputMaybe<Scalars['String']>;
  jornayaIdLte?: InputMaybe<Scalars['String']>;
  jornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modifiedAt?: InputMaybe<Scalars['String']>;
  modifiedAtAny?: InputMaybe<Scalars['String']>;
  modifiedAtContain?: InputMaybe<Scalars['String']>;
  modifiedAtEq?: InputMaybe<Scalars['String']>;
  modifiedAtGt?: InputMaybe<Scalars['String']>;
  modifiedAtGte?: InputMaybe<Scalars['String']>;
  modifiedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedAtLike?: InputMaybe<Scalars['String']>;
  modifiedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedAtLt?: InputMaybe<Scalars['String']>;
  modifiedAtLte?: InputMaybe<Scalars['String']>;
  modifiedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLLeadsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLeadsPropertiesEnum>;
  piiId?: InputMaybe<Scalars['Int']>;
  piiIdAny?: InputMaybe<Scalars['Int']>;
  piiIdContain?: InputMaybe<Scalars['Int']>;
  piiIdEq?: InputMaybe<Scalars['Int']>;
  piiIdGt?: InputMaybe<Scalars['Int']>;
  piiIdGte?: InputMaybe<Scalars['Int']>;
  piiIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  piiIdIsNull?: InputMaybe<Scalars['Boolean']>;
  piiIdLike?: InputMaybe<Scalars['Int']>;
  piiIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  piiIdLt?: InputMaybe<Scalars['Int']>;
  piiIdLte?: InputMaybe<Scalars['Int']>;
  piiIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sales?: InputMaybe<Scalars['String']>;
  salesAny?: InputMaybe<Scalars['String']>;
  salesContain?: InputMaybe<Scalars['String']>;
  salesEq?: InputMaybe<Scalars['String']>;
  salesGt?: InputMaybe<Scalars['String']>;
  salesGte?: InputMaybe<Scalars['String']>;
  salesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  salesIsNull?: InputMaybe<Scalars['Boolean']>;
  salesLike?: InputMaybe<Scalars['String']>;
  salesLikeNoCase?: InputMaybe<Scalars['String']>;
  salesLt?: InputMaybe<Scalars['String']>;
  salesLte?: InputMaybe<Scalars['String']>;
  salesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Scalars['String']>;
  statusAny?: InputMaybe<Scalars['String']>;
  statusContain?: InputMaybe<Scalars['String']>;
  statusEq?: InputMaybe<Scalars['String']>;
  statusGt?: InputMaybe<Scalars['String']>;
  statusGte?: InputMaybe<Scalars['String']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statusIsNull?: InputMaybe<Scalars['Boolean']>;
  statusLike?: InputMaybe<Scalars['String']>;
  statusLikeNoCase?: InputMaybe<Scalars['String']>;
  statusLt?: InputMaybe<Scalars['String']>;
  statusLte?: InputMaybe<Scalars['String']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  submissionStatus?: InputMaybe<Scalars['String']>;
  submissionStatusAny?: InputMaybe<Scalars['String']>;
  submissionStatusContain?: InputMaybe<Scalars['String']>;
  submissionStatusEq?: InputMaybe<Scalars['String']>;
  submissionStatusGt?: InputMaybe<Scalars['String']>;
  submissionStatusGte?: InputMaybe<Scalars['String']>;
  submissionStatusIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  submissionStatusIsNull?: InputMaybe<Scalars['Boolean']>;
  submissionStatusLike?: InputMaybe<Scalars['String']>;
  submissionStatusLikeNoCase?: InputMaybe<Scalars['String']>;
  submissionStatusLt?: InputMaybe<Scalars['String']>;
  submissionStatusLte?: InputMaybe<Scalars['String']>;
  submissionStatusNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficSource?: InputMaybe<Scalars['String']>;
  trafficSourceAny?: InputMaybe<Scalars['String']>;
  trafficSourceContain?: InputMaybe<Scalars['String']>;
  trafficSourceEq?: InputMaybe<Scalars['String']>;
  trafficSourceGt?: InputMaybe<Scalars['String']>;
  trafficSourceGte?: InputMaybe<Scalars['String']>;
  trafficSourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficSourceIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficSourceLike?: InputMaybe<Scalars['String']>;
  trafficSourceLikeNoCase?: InputMaybe<Scalars['String']>;
  trafficSourceLt?: InputMaybe<Scalars['String']>;
  trafficSourceLte?: InputMaybe<Scalars['String']>;
  trafficSourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficTypeId?: InputMaybe<Scalars['Int']>;
  trafficTypeIdAny?: InputMaybe<Scalars['Int']>;
  trafficTypeIdContain?: InputMaybe<Scalars['Int']>;
  trafficTypeIdEq?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  trafficTypeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficTypeIdLike?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  trustedFormCertificateClaimed?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedAny?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedContain?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedEq?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedGt?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedGte?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  trustedFormCertificateClaimedIsNull?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLike?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLt?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLte?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  trustedFormCertificateUrl?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlAny?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlContain?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlEq?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlGt?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlGte?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trustedFormCertificateUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateUrlLike?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlLt?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlLte?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uuid?: InputMaybe<Scalars['String']>;
  uuidAny?: InputMaybe<Scalars['String']>;
  uuidContain?: InputMaybe<Scalars['String']>;
  uuidEq?: InputMaybe<Scalars['String']>;
  uuidGt?: InputMaybe<Scalars['String']>;
  uuidGte?: InputMaybe<Scalars['String']>;
  uuidIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uuidIsNull?: InputMaybe<Scalars['Boolean']>;
  uuidLike?: InputMaybe<Scalars['String']>;
  uuidLikeNoCase?: InputMaybe<Scalars['String']>;
  uuidLt?: InputMaybe<Scalars['String']>;
  uuidLte?: InputMaybe<Scalars['String']>;
  uuidNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitData?: InputMaybe<Scalars['JSON']>;
  visitDataAny?: InputMaybe<Scalars['JSON']>;
  visitDataContain?: InputMaybe<Scalars['JSON']>;
  visitDataEq?: InputMaybe<Scalars['JSON']>;
  visitDataGt?: InputMaybe<Scalars['JSON']>;
  visitDataGte?: InputMaybe<Scalars['JSON']>;
  visitDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  visitDataIsNull?: InputMaybe<Scalars['Boolean']>;
  visitDataLike?: InputMaybe<Scalars['JSON']>;
  visitDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  visitDataLt?: InputMaybe<Scalars['JSON']>;
  visitDataLte?: InputMaybe<Scalars['JSON']>;
  visitDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  visitId?: InputMaybe<Scalars['String']>;
  visitIdAny?: InputMaybe<Scalars['String']>;
  visitIdContain?: InputMaybe<Scalars['String']>;
  visitIdEq?: InputMaybe<Scalars['String']>;
  visitIdGt?: InputMaybe<Scalars['String']>;
  visitIdGte?: InputMaybe<Scalars['String']>;
  visitIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitIdIsNull?: InputMaybe<Scalars['Boolean']>;
  visitIdLike?: InputMaybe<Scalars['String']>;
  visitIdLikeNoCase?: InputMaybe<Scalars['String']>;
  visitIdLt?: InputMaybe<Scalars['String']>;
  visitIdLte?: InputMaybe<Scalars['String']>;
  visitIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitorId?: InputMaybe<Scalars['String']>;
  visitorIdAny?: InputMaybe<Scalars['String']>;
  visitorIdContain?: InputMaybe<Scalars['String']>;
  visitorIdEq?: InputMaybe<Scalars['String']>;
  visitorIdGt?: InputMaybe<Scalars['String']>;
  visitorIdGte?: InputMaybe<Scalars['String']>;
  visitorIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitorIdIsNull?: InputMaybe<Scalars['Boolean']>;
  visitorIdLike?: InputMaybe<Scalars['String']>;
  visitorIdLikeNoCase?: InputMaybe<Scalars['String']>;
  visitorIdLt?: InputMaybe<Scalars['String']>;
  visitorIdLte?: InputMaybe<Scalars['String']>;
  visitorIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLLeadConversionEventLogsPropertiesEnum {
  AdNetworkId = 'adNetworkId',
  CreatedAt = 'createdAt',
  DomainId = 'domainId',
  Event = 'event',
  FormId = 'formId',
  Id = 'id',
  LeadId = 'leadId',
  PixelId = 'pixelId',
  Request = 'request',
  Response = 'response',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  VisitId = 'visitId'
}

export type GQLLeadTags = {
  __typename?: 'LeadTags';
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  leadId?: Maybe<Scalars['Int']>;
  tag?: Maybe<GQLTags>;
  tagId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['String']>;
};


export type GQLLeadTagsTagArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLTagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTagsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLLeadTagsPropertiesEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Id = 'id',
  LeadId = 'leadId',
  TagId = 'tagId',
  UpdatedAt = 'updatedAt'
}

export type GQLLeads = {
  __typename?: 'Leads';
  advertisingNetwork?: Maybe<GQLAdvertisingNetworks>;
  advertisingNetworkId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  domainForm?: Maybe<GQLDomainForms>;
  domainFormId?: Maybe<Scalars['Int']>;
  feedback?: Maybe<Scalars['JSON']>;
  hasAliasCalls?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isOptedOut?: Maybe<Scalars['Boolean']>;
  jornayaId?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  meta?: Maybe<Array<Maybe<GQLLeadsMetadata>>>;
  modifiedAt?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedByUser?: Maybe<GQLUsers>;
  pii?: Maybe<GQLPersonalIdentifiableInformation>;
  piiId?: Maybe<Scalars['Int']>;
  sales?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  submissionStatus?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<GQLTags>>>;
  trafficSource?: Maybe<Scalars['String']>;
  trafficType?: Maybe<GQLTrafficTypes>;
  trafficTypeId?: Maybe<Scalars['Int']>;
  trustedFormCertificateClaimed?: Maybe<Scalars['Boolean']>;
  trustedFormCertificateUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  visit?: Maybe<GQLVisits>;
  visitData?: Maybe<Scalars['JSON']>;
  visitId?: Maybe<Scalars['String']>;
  visitor?: Maybe<GQLVisitors>;
  visitorId?: Maybe<Scalars['String']>;
};


export type GQLLeadsAdvertisingNetworkArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAdvertisingNetworksPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAdvertisingNetworksPropertiesEnum>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLLeadsDomainFormArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formId?: InputMaybe<Scalars['Int']>;
  formIdAny?: InputMaybe<Scalars['Int']>;
  formIdContain?: InputMaybe<Scalars['Int']>;
  formIdEq?: InputMaybe<Scalars['Int']>;
  formIdGt?: InputMaybe<Scalars['Int']>;
  formIdGte?: InputMaybe<Scalars['Int']>;
  formIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formIdIsNull?: InputMaybe<Scalars['Boolean']>;
  formIdLike?: InputMaybe<Scalars['Int']>;
  formIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  formIdLt?: InputMaybe<Scalars['Int']>;
  formIdLte?: InputMaybe<Scalars['Int']>;
  formIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  integrations?: InputMaybe<Scalars['JSON']>;
  integrationsAny?: InputMaybe<Scalars['JSON']>;
  integrationsContain?: InputMaybe<Scalars['JSON']>;
  integrationsEq?: InputMaybe<Scalars['JSON']>;
  integrationsGt?: InputMaybe<Scalars['JSON']>;
  integrationsGte?: InputMaybe<Scalars['JSON']>;
  integrationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  integrationsIsNull?: InputMaybe<Scalars['Boolean']>;
  integrationsLike?: InputMaybe<Scalars['JSON']>;
  integrationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  integrationsLt?: InputMaybe<Scalars['JSON']>;
  integrationsLte?: InputMaybe<Scalars['JSON']>;
  integrationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainFormsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainFormsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLLeadsMetaArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leadId?: InputMaybe<Scalars['Int']>;
  leadIdAny?: InputMaybe<Scalars['Int']>;
  leadIdContain?: InputMaybe<Scalars['Int']>;
  leadIdEq?: InputMaybe<Scalars['Int']>;
  leadIdGt?: InputMaybe<Scalars['Int']>;
  leadIdGte?: InputMaybe<Scalars['Int']>;
  leadIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  leadIdIsNull?: InputMaybe<Scalars['Boolean']>;
  leadIdLike?: InputMaybe<Scalars['Int']>;
  leadIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  leadIdLt?: InputMaybe<Scalars['Int']>;
  leadIdLte?: InputMaybe<Scalars['Int']>;
  leadIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLLeadsMetadataPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLeadsMetadataPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLLeadsModifiedByUserArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLLeadsPiiArgs = {
  aliasPhoneNumber?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberAny?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberContain?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberEq?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberGt?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberGte?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  aliasPhoneNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  aliasPhoneNumberLike?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberLt?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberLte?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  birthdate?: InputMaybe<Scalars['String']>;
  birthdateAny?: InputMaybe<Scalars['String']>;
  birthdateContain?: InputMaybe<Scalars['String']>;
  birthdateEq?: InputMaybe<Scalars['String']>;
  birthdateGt?: InputMaybe<Scalars['String']>;
  birthdateGte?: InputMaybe<Scalars['String']>;
  birthdateIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  birthdateIsNull?: InputMaybe<Scalars['Boolean']>;
  birthdateLike?: InputMaybe<Scalars['String']>;
  birthdateLikeNoCase?: InputMaybe<Scalars['String']>;
  birthdateLt?: InputMaybe<Scalars['String']>;
  birthdateLte?: InputMaybe<Scalars['String']>;
  birthdateNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<Scalars['String']>;
  cityAny?: InputMaybe<Scalars['String']>;
  cityContain?: InputMaybe<Scalars['String']>;
  cityEq?: InputMaybe<Scalars['String']>;
  cityGt?: InputMaybe<Scalars['String']>;
  cityGte?: InputMaybe<Scalars['String']>;
  cityIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityIsNull?: InputMaybe<Scalars['Boolean']>;
  cityLike?: InputMaybe<Scalars['String']>;
  cityLikeNoCase?: InputMaybe<Scalars['String']>;
  cityLt?: InputMaybe<Scalars['String']>;
  cityLte?: InputMaybe<Scalars['String']>;
  cityNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  country?: InputMaybe<Scalars['String']>;
  countryAny?: InputMaybe<Scalars['String']>;
  countryContain?: InputMaybe<Scalars['String']>;
  countryEq?: InputMaybe<Scalars['String']>;
  countryGt?: InputMaybe<Scalars['String']>;
  countryGte?: InputMaybe<Scalars['String']>;
  countryIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryIsNull?: InputMaybe<Scalars['Boolean']>;
  countryLike?: InputMaybe<Scalars['String']>;
  countryLikeNoCase?: InputMaybe<Scalars['String']>;
  countryLt?: InputMaybe<Scalars['String']>;
  countryLte?: InputMaybe<Scalars['String']>;
  countryNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  county?: InputMaybe<Scalars['String']>;
  countyAny?: InputMaybe<Scalars['String']>;
  countyContain?: InputMaybe<Scalars['String']>;
  countyEq?: InputMaybe<Scalars['String']>;
  countyGt?: InputMaybe<Scalars['String']>;
  countyGte?: InputMaybe<Scalars['String']>;
  countyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countyIsNull?: InputMaybe<Scalars['Boolean']>;
  countyLike?: InputMaybe<Scalars['String']>;
  countyLikeNoCase?: InputMaybe<Scalars['String']>;
  countyLt?: InputMaybe<Scalars['String']>;
  countyLte?: InputMaybe<Scalars['String']>;
  countyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  dma?: InputMaybe<Scalars['Boolean']>;
  dmaAny?: InputMaybe<Scalars['Boolean']>;
  dmaContain?: InputMaybe<Scalars['Boolean']>;
  dmaEq?: InputMaybe<Scalars['Boolean']>;
  dmaGt?: InputMaybe<Scalars['Boolean']>;
  dmaGte?: InputMaybe<Scalars['Boolean']>;
  dmaIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  dmaIsNull?: InputMaybe<Scalars['Boolean']>;
  dmaLike?: InputMaybe<Scalars['Boolean']>;
  dmaLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  dmaLt?: InputMaybe<Scalars['Boolean']>;
  dmaLte?: InputMaybe<Scalars['Boolean']>;
  dmaNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  firstName?: InputMaybe<Scalars['String']>;
  firstNameAny?: InputMaybe<Scalars['String']>;
  firstNameContain?: InputMaybe<Scalars['String']>;
  firstNameEq?: InputMaybe<Scalars['String']>;
  firstNameGt?: InputMaybe<Scalars['String']>;
  firstNameGte?: InputMaybe<Scalars['String']>;
  firstNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  firstNameIsNull?: InputMaybe<Scalars['Boolean']>;
  firstNameLike?: InputMaybe<Scalars['String']>;
  firstNameLikeNoCase?: InputMaybe<Scalars['String']>;
  firstNameLt?: InputMaybe<Scalars['String']>;
  firstNameLte?: InputMaybe<Scalars['String']>;
  firstNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ipAddress?: InputMaybe<Scalars['String']>;
  ipAddressAny?: InputMaybe<Scalars['String']>;
  ipAddressContain?: InputMaybe<Scalars['String']>;
  ipAddressEq?: InputMaybe<Scalars['String']>;
  ipAddressGt?: InputMaybe<Scalars['String']>;
  ipAddressGte?: InputMaybe<Scalars['String']>;
  ipAddressIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ipAddressIsNull?: InputMaybe<Scalars['Boolean']>;
  ipAddressLike?: InputMaybe<Scalars['String']>;
  ipAddressLikeNoCase?: InputMaybe<Scalars['String']>;
  ipAddressLt?: InputMaybe<Scalars['String']>;
  ipAddressLte?: InputMaybe<Scalars['String']>;
  ipAddressNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBizEmail?: InputMaybe<Scalars['Boolean']>;
  isBizEmailAny?: InputMaybe<Scalars['Boolean']>;
  isBizEmailContain?: InputMaybe<Scalars['Boolean']>;
  isBizEmailEq?: InputMaybe<Scalars['Boolean']>;
  isBizEmailGt?: InputMaybe<Scalars['Boolean']>;
  isBizEmailGte?: InputMaybe<Scalars['Boolean']>;
  isBizEmailIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBizEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  isBizEmailLike?: InputMaybe<Scalars['Boolean']>;
  isBizEmailLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBizEmailLt?: InputMaybe<Scalars['Boolean']>;
  isBizEmailLte?: InputMaybe<Scalars['Boolean']>;
  isBizEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lastName?: InputMaybe<Scalars['String']>;
  lastNameAny?: InputMaybe<Scalars['String']>;
  lastNameContain?: InputMaybe<Scalars['String']>;
  lastNameEq?: InputMaybe<Scalars['String']>;
  lastNameGt?: InputMaybe<Scalars['String']>;
  lastNameGte?: InputMaybe<Scalars['String']>;
  lastNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lastNameIsNull?: InputMaybe<Scalars['Boolean']>;
  lastNameLike?: InputMaybe<Scalars['String']>;
  lastNameLikeNoCase?: InputMaybe<Scalars['String']>;
  lastNameLt?: InputMaybe<Scalars['String']>;
  lastNameLte?: InputMaybe<Scalars['String']>;
  lastNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  litigator?: InputMaybe<Scalars['Boolean']>;
  litigatorAny?: InputMaybe<Scalars['Boolean']>;
  litigatorContain?: InputMaybe<Scalars['Boolean']>;
  litigatorEq?: InputMaybe<Scalars['Boolean']>;
  litigatorGt?: InputMaybe<Scalars['Boolean']>;
  litigatorGte?: InputMaybe<Scalars['Boolean']>;
  litigatorIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  litigatorIsNull?: InputMaybe<Scalars['Boolean']>;
  litigatorLike?: InputMaybe<Scalars['Boolean']>;
  litigatorLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  litigatorLt?: InputMaybe<Scalars['Boolean']>;
  litigatorLte?: InputMaybe<Scalars['Boolean']>;
  litigatorNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  metaData?: InputMaybe<Scalars['String']>;
  metaDataAny?: InputMaybe<Scalars['String']>;
  metaDataContain?: InputMaybe<Scalars['String']>;
  metaDataEq?: InputMaybe<Scalars['String']>;
  metaDataGt?: InputMaybe<Scalars['String']>;
  metaDataGte?: InputMaybe<Scalars['String']>;
  metaDataIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  metaDataIsNull?: InputMaybe<Scalars['Boolean']>;
  metaDataLike?: InputMaybe<Scalars['String']>;
  metaDataLikeNoCase?: InputMaybe<Scalars['String']>;
  metaDataLt?: InputMaybe<Scalars['String']>;
  metaDataLte?: InputMaybe<Scalars['String']>;
  metaDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAt?: InputMaybe<Scalars['String']>;
  modifiedAtAny?: InputMaybe<Scalars['String']>;
  modifiedAtContain?: InputMaybe<Scalars['String']>;
  modifiedAtEq?: InputMaybe<Scalars['String']>;
  modifiedAtGt?: InputMaybe<Scalars['String']>;
  modifiedAtGte?: InputMaybe<Scalars['String']>;
  modifiedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedAtLike?: InputMaybe<Scalars['String']>;
  modifiedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedAtLt?: InputMaybe<Scalars['String']>;
  modifiedAtLte?: InputMaybe<Scalars['String']>;
  modifiedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nationalDnc?: InputMaybe<Scalars['Boolean']>;
  nationalDncAny?: InputMaybe<Scalars['Boolean']>;
  nationalDncContain?: InputMaybe<Scalars['Boolean']>;
  nationalDncEq?: InputMaybe<Scalars['Boolean']>;
  nationalDncGt?: InputMaybe<Scalars['Boolean']>;
  nationalDncGte?: InputMaybe<Scalars['Boolean']>;
  nationalDncIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  nationalDncIsNull?: InputMaybe<Scalars['Boolean']>;
  nationalDncLike?: InputMaybe<Scalars['Boolean']>;
  nationalDncLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  nationalDncLt?: InputMaybe<Scalars['Boolean']>;
  nationalDncLte?: InputMaybe<Scalars['Boolean']>;
  nationalDncNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldPhoneNumber?: InputMaybe<Scalars['String']>;
  oldPhoneNumberAny?: InputMaybe<Scalars['String']>;
  oldPhoneNumberContain?: InputMaybe<Scalars['String']>;
  oldPhoneNumberEq?: InputMaybe<Scalars['String']>;
  oldPhoneNumberGt?: InputMaybe<Scalars['String']>;
  oldPhoneNumberGte?: InputMaybe<Scalars['String']>;
  oldPhoneNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldPhoneNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  oldPhoneNumberLike?: InputMaybe<Scalars['String']>;
  oldPhoneNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  oldPhoneNumberLt?: InputMaybe<Scalars['String']>;
  oldPhoneNumberLte?: InputMaybe<Scalars['String']>;
  oldPhoneNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLPersonalIdentifiableInformationPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLPersonalIdentifiableInformationPropertiesEnum>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumberAny?: InputMaybe<Scalars['String']>;
  phoneNumberContain?: InputMaybe<Scalars['String']>;
  phoneNumberEq?: InputMaybe<Scalars['String']>;
  phoneNumberGt?: InputMaybe<Scalars['String']>;
  phoneNumberGte?: InputMaybe<Scalars['String']>;
  phoneNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  phoneNumberLike?: InputMaybe<Scalars['String']>;
  phoneNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  phoneNumberLt?: InputMaybe<Scalars['String']>;
  phoneNumberLte?: InputMaybe<Scalars['String']>;
  phoneNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneNumberType?: InputMaybe<Scalars['String']>;
  phoneNumberTypeAny?: InputMaybe<Scalars['String']>;
  phoneNumberTypeContain?: InputMaybe<Scalars['String']>;
  phoneNumberTypeEq?: InputMaybe<Scalars['String']>;
  phoneNumberTypeGt?: InputMaybe<Scalars['String']>;
  phoneNumberTypeGte?: InputMaybe<Scalars['String']>;
  phoneNumberTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneNumberTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  phoneNumberTypeLike?: InputMaybe<Scalars['String']>;
  phoneNumberTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  phoneNumberTypeLt?: InputMaybe<Scalars['String']>;
  phoneNumberTypeLte?: InputMaybe<Scalars['String']>;
  phoneNumberTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  state?: InputMaybe<Scalars['String']>;
  stateAny?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
  stateCodeAny?: InputMaybe<Scalars['String']>;
  stateCodeContain?: InputMaybe<Scalars['String']>;
  stateCodeEq?: InputMaybe<Scalars['String']>;
  stateCodeGt?: InputMaybe<Scalars['String']>;
  stateCodeGte?: InputMaybe<Scalars['String']>;
  stateCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  stateCodeLike?: InputMaybe<Scalars['String']>;
  stateCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  stateCodeLt?: InputMaybe<Scalars['String']>;
  stateCodeLte?: InputMaybe<Scalars['String']>;
  stateCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateContain?: InputMaybe<Scalars['String']>;
  stateDnc?: InputMaybe<Scalars['Boolean']>;
  stateDncAny?: InputMaybe<Scalars['Boolean']>;
  stateDncContain?: InputMaybe<Scalars['Boolean']>;
  stateDncEq?: InputMaybe<Scalars['Boolean']>;
  stateDncGt?: InputMaybe<Scalars['Boolean']>;
  stateDncGte?: InputMaybe<Scalars['Boolean']>;
  stateDncIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  stateDncIsNull?: InputMaybe<Scalars['Boolean']>;
  stateDncLike?: InputMaybe<Scalars['Boolean']>;
  stateDncLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  stateDncLt?: InputMaybe<Scalars['Boolean']>;
  stateDncLte?: InputMaybe<Scalars['Boolean']>;
  stateDncNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  stateEq?: InputMaybe<Scalars['String']>;
  stateGt?: InputMaybe<Scalars['String']>;
  stateGte?: InputMaybe<Scalars['String']>;
  stateIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateIsNull?: InputMaybe<Scalars['Boolean']>;
  stateLike?: InputMaybe<Scalars['String']>;
  stateLikeNoCase?: InputMaybe<Scalars['String']>;
  stateLt?: InputMaybe<Scalars['String']>;
  stateLte?: InputMaybe<Scalars['String']>;
  stateNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetAddressAny?: InputMaybe<Scalars['String']>;
  streetAddressContain?: InputMaybe<Scalars['String']>;
  streetAddressEq?: InputMaybe<Scalars['String']>;
  streetAddressGt?: InputMaybe<Scalars['String']>;
  streetAddressGte?: InputMaybe<Scalars['String']>;
  streetAddressIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  streetAddressIsNull?: InputMaybe<Scalars['Boolean']>;
  streetAddressLike?: InputMaybe<Scalars['String']>;
  streetAddressLikeNoCase?: InputMaybe<Scalars['String']>;
  streetAddressLt?: InputMaybe<Scalars['String']>;
  streetAddressLte?: InputMaybe<Scalars['String']>;
  streetAddressNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verified?: InputMaybe<Scalars['Boolean']>;
  verifiedAny?: InputMaybe<Scalars['Boolean']>;
  verifiedContain?: InputMaybe<Scalars['Boolean']>;
  verifiedEq?: InputMaybe<Scalars['Boolean']>;
  verifiedGt?: InputMaybe<Scalars['Boolean']>;
  verifiedGte?: InputMaybe<Scalars['Boolean']>;
  verifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  verifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  verifiedLike?: InputMaybe<Scalars['Boolean']>;
  verifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  verifiedLt?: InputMaybe<Scalars['Boolean']>;
  verifiedLte?: InputMaybe<Scalars['Boolean']>;
  verifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  zipCode?: InputMaybe<Scalars['String']>;
  zipCodeAny?: InputMaybe<Scalars['String']>;
  zipCodeContain?: InputMaybe<Scalars['String']>;
  zipCodeEq?: InputMaybe<Scalars['String']>;
  zipCodeGt?: InputMaybe<Scalars['String']>;
  zipCodeGte?: InputMaybe<Scalars['String']>;
  zipCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  zipCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  zipCodeLike?: InputMaybe<Scalars['String']>;
  zipCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  zipCodeLt?: InputMaybe<Scalars['String']>;
  zipCodeLte?: InputMaybe<Scalars['String']>;
  zipCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLLeadsTagsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLTagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTagsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLLeadsTrafficTypeArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTrafficTypesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTrafficTypesPropertiesEnum>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLLeadsVisitArgs = {
  adCampaign?: InputMaybe<Scalars['String']>;
  adCampaignAny?: InputMaybe<Scalars['String']>;
  adCampaignContain?: InputMaybe<Scalars['String']>;
  adCampaignEq?: InputMaybe<Scalars['String']>;
  adCampaignGt?: InputMaybe<Scalars['String']>;
  adCampaignGte?: InputMaybe<Scalars['String']>;
  adCampaignIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adCampaignIsNull?: InputMaybe<Scalars['Boolean']>;
  adCampaignLike?: InputMaybe<Scalars['String']>;
  adCampaignLikeNoCase?: InputMaybe<Scalars['String']>;
  adCampaignLt?: InputMaybe<Scalars['String']>;
  adCampaignLte?: InputMaybe<Scalars['String']>;
  adCampaignNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adDevice?: InputMaybe<Scalars['String']>;
  adDeviceAny?: InputMaybe<Scalars['String']>;
  adDeviceContain?: InputMaybe<Scalars['String']>;
  adDeviceEq?: InputMaybe<Scalars['String']>;
  adDeviceGt?: InputMaybe<Scalars['String']>;
  adDeviceGte?: InputMaybe<Scalars['String']>;
  adDeviceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adDeviceIsNull?: InputMaybe<Scalars['Boolean']>;
  adDeviceLike?: InputMaybe<Scalars['String']>;
  adDeviceLikeNoCase?: InputMaybe<Scalars['String']>;
  adDeviceLt?: InputMaybe<Scalars['String']>;
  adDeviceLte?: InputMaybe<Scalars['String']>;
  adDeviceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adGroup?: InputMaybe<Scalars['String']>;
  adGroupAny?: InputMaybe<Scalars['String']>;
  adGroupContain?: InputMaybe<Scalars['String']>;
  adGroupEq?: InputMaybe<Scalars['String']>;
  adGroupGt?: InputMaybe<Scalars['String']>;
  adGroupGte?: InputMaybe<Scalars['String']>;
  adGroupIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adGroupIsNull?: InputMaybe<Scalars['Boolean']>;
  adGroupLike?: InputMaybe<Scalars['String']>;
  adGroupLikeNoCase?: InputMaybe<Scalars['String']>;
  adGroupLt?: InputMaybe<Scalars['String']>;
  adGroupLte?: InputMaybe<Scalars['String']>;
  adGroupNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adKeyword?: InputMaybe<Scalars['String']>;
  adKeywordAny?: InputMaybe<Scalars['String']>;
  adKeywordContain?: InputMaybe<Scalars['String']>;
  adKeywordEq?: InputMaybe<Scalars['String']>;
  adKeywordGt?: InputMaybe<Scalars['String']>;
  adKeywordGte?: InputMaybe<Scalars['String']>;
  adKeywordIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adKeywordIsNull?: InputMaybe<Scalars['Boolean']>;
  adKeywordLike?: InputMaybe<Scalars['String']>;
  adKeywordLikeNoCase?: InputMaybe<Scalars['String']>;
  adKeywordLt?: InputMaybe<Scalars['String']>;
  adKeywordLte?: InputMaybe<Scalars['String']>;
  adKeywordNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adMedium?: InputMaybe<Scalars['String']>;
  adMediumAny?: InputMaybe<Scalars['String']>;
  adMediumContain?: InputMaybe<Scalars['String']>;
  adMediumEq?: InputMaybe<Scalars['String']>;
  adMediumGt?: InputMaybe<Scalars['String']>;
  adMediumGte?: InputMaybe<Scalars['String']>;
  adMediumIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adMediumIsNull?: InputMaybe<Scalars['Boolean']>;
  adMediumLike?: InputMaybe<Scalars['String']>;
  adMediumLikeNoCase?: InputMaybe<Scalars['String']>;
  adMediumLt?: InputMaybe<Scalars['String']>;
  adMediumLte?: InputMaybe<Scalars['String']>;
  adMediumNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adTrafficSource?: InputMaybe<Scalars['String']>;
  adTrafficSourceAny?: InputMaybe<Scalars['String']>;
  adTrafficSourceContain?: InputMaybe<Scalars['String']>;
  adTrafficSourceEq?: InputMaybe<Scalars['String']>;
  adTrafficSourceGt?: InputMaybe<Scalars['String']>;
  adTrafficSourceGte?: InputMaybe<Scalars['String']>;
  adTrafficSourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adTrafficSourceIsNull?: InputMaybe<Scalars['Boolean']>;
  adTrafficSourceLike?: InputMaybe<Scalars['String']>;
  adTrafficSourceLikeNoCase?: InputMaybe<Scalars['String']>;
  adTrafficSourceLt?: InputMaybe<Scalars['String']>;
  adTrafficSourceLte?: InputMaybe<Scalars['String']>;
  adTrafficSourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  expireAt?: InputMaybe<Scalars['String']>;
  expireAtAny?: InputMaybe<Scalars['String']>;
  expireAtContain?: InputMaybe<Scalars['String']>;
  expireAtEq?: InputMaybe<Scalars['String']>;
  expireAtGt?: InputMaybe<Scalars['String']>;
  expireAtGte?: InputMaybe<Scalars['String']>;
  expireAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  expireAtIsNull?: InputMaybe<Scalars['Boolean']>;
  expireAtLike?: InputMaybe<Scalars['String']>;
  expireAtLikeNoCase?: InputMaybe<Scalars['String']>;
  expireAtLt?: InputMaybe<Scalars['String']>;
  expireAtLte?: InputMaybe<Scalars['String']>;
  expireAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLVisitsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLVisitsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  urlAny?: InputMaybe<Scalars['String']>;
  urlContain?: InputMaybe<Scalars['String']>;
  urlEq?: InputMaybe<Scalars['String']>;
  urlGt?: InputMaybe<Scalars['String']>;
  urlGte?: InputMaybe<Scalars['String']>;
  urlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlIsNull?: InputMaybe<Scalars['Boolean']>;
  urlLike?: InputMaybe<Scalars['String']>;
  urlLikeNoCase?: InputMaybe<Scalars['String']>;
  urlLt?: InputMaybe<Scalars['String']>;
  urlLte?: InputMaybe<Scalars['String']>;
  urlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitorId?: InputMaybe<Scalars['String']>;
  visitorIdAny?: InputMaybe<Scalars['String']>;
  visitorIdContain?: InputMaybe<Scalars['String']>;
  visitorIdEq?: InputMaybe<Scalars['String']>;
  visitorIdGt?: InputMaybe<Scalars['String']>;
  visitorIdGte?: InputMaybe<Scalars['String']>;
  visitorIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitorIdIsNull?: InputMaybe<Scalars['Boolean']>;
  visitorIdLike?: InputMaybe<Scalars['String']>;
  visitorIdLikeNoCase?: InputMaybe<Scalars['String']>;
  visitorIdLt?: InputMaybe<Scalars['String']>;
  visitorIdLte?: InputMaybe<Scalars['String']>;
  visitorIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLLeadsVisitorArgs = {
  adCampaign?: InputMaybe<Scalars['String']>;
  adCampaignAny?: InputMaybe<Scalars['String']>;
  adCampaignContain?: InputMaybe<Scalars['String']>;
  adCampaignEq?: InputMaybe<Scalars['String']>;
  adCampaignGt?: InputMaybe<Scalars['String']>;
  adCampaignGte?: InputMaybe<Scalars['String']>;
  adCampaignIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adCampaignIsNull?: InputMaybe<Scalars['Boolean']>;
  adCampaignLike?: InputMaybe<Scalars['String']>;
  adCampaignLikeNoCase?: InputMaybe<Scalars['String']>;
  adCampaignLt?: InputMaybe<Scalars['String']>;
  adCampaignLte?: InputMaybe<Scalars['String']>;
  adCampaignNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adDevice?: InputMaybe<Scalars['String']>;
  adDeviceAny?: InputMaybe<Scalars['String']>;
  adDeviceContain?: InputMaybe<Scalars['String']>;
  adDeviceEq?: InputMaybe<Scalars['String']>;
  adDeviceGt?: InputMaybe<Scalars['String']>;
  adDeviceGte?: InputMaybe<Scalars['String']>;
  adDeviceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adDeviceIsNull?: InputMaybe<Scalars['Boolean']>;
  adDeviceLike?: InputMaybe<Scalars['String']>;
  adDeviceLikeNoCase?: InputMaybe<Scalars['String']>;
  adDeviceLt?: InputMaybe<Scalars['String']>;
  adDeviceLte?: InputMaybe<Scalars['String']>;
  adDeviceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adGroup?: InputMaybe<Scalars['String']>;
  adGroupAny?: InputMaybe<Scalars['String']>;
  adGroupContain?: InputMaybe<Scalars['String']>;
  adGroupEq?: InputMaybe<Scalars['String']>;
  adGroupGt?: InputMaybe<Scalars['String']>;
  adGroupGte?: InputMaybe<Scalars['String']>;
  adGroupIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adGroupIsNull?: InputMaybe<Scalars['Boolean']>;
  adGroupLike?: InputMaybe<Scalars['String']>;
  adGroupLikeNoCase?: InputMaybe<Scalars['String']>;
  adGroupLt?: InputMaybe<Scalars['String']>;
  adGroupLte?: InputMaybe<Scalars['String']>;
  adGroupNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adKeyword?: InputMaybe<Scalars['String']>;
  adKeywordAny?: InputMaybe<Scalars['String']>;
  adKeywordContain?: InputMaybe<Scalars['String']>;
  adKeywordEq?: InputMaybe<Scalars['String']>;
  adKeywordGt?: InputMaybe<Scalars['String']>;
  adKeywordGte?: InputMaybe<Scalars['String']>;
  adKeywordIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adKeywordIsNull?: InputMaybe<Scalars['Boolean']>;
  adKeywordLike?: InputMaybe<Scalars['String']>;
  adKeywordLikeNoCase?: InputMaybe<Scalars['String']>;
  adKeywordLt?: InputMaybe<Scalars['String']>;
  adKeywordLte?: InputMaybe<Scalars['String']>;
  adKeywordNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adMedium?: InputMaybe<Scalars['String']>;
  adMediumAny?: InputMaybe<Scalars['String']>;
  adMediumContain?: InputMaybe<Scalars['String']>;
  adMediumEq?: InputMaybe<Scalars['String']>;
  adMediumGt?: InputMaybe<Scalars['String']>;
  adMediumGte?: InputMaybe<Scalars['String']>;
  adMediumIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adMediumIsNull?: InputMaybe<Scalars['Boolean']>;
  adMediumLike?: InputMaybe<Scalars['String']>;
  adMediumLikeNoCase?: InputMaybe<Scalars['String']>;
  adMediumLt?: InputMaybe<Scalars['String']>;
  adMediumLte?: InputMaybe<Scalars['String']>;
  adMediumNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adTrafficSource?: InputMaybe<Scalars['String']>;
  adTrafficSourceAny?: InputMaybe<Scalars['String']>;
  adTrafficSourceContain?: InputMaybe<Scalars['String']>;
  adTrafficSourceEq?: InputMaybe<Scalars['String']>;
  adTrafficSourceGt?: InputMaybe<Scalars['String']>;
  adTrafficSourceGte?: InputMaybe<Scalars['String']>;
  adTrafficSourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adTrafficSourceIsNull?: InputMaybe<Scalars['Boolean']>;
  adTrafficSourceLike?: InputMaybe<Scalars['String']>;
  adTrafficSourceLikeNoCase?: InputMaybe<Scalars['String']>;
  adTrafficSourceLt?: InputMaybe<Scalars['String']>;
  adTrafficSourceLte?: InputMaybe<Scalars['String']>;
  adTrafficSourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browser?: InputMaybe<Scalars['String']>;
  browserAny?: InputMaybe<Scalars['String']>;
  browserCode?: InputMaybe<Scalars['String']>;
  browserCodeAny?: InputMaybe<Scalars['String']>;
  browserCodeContain?: InputMaybe<Scalars['String']>;
  browserCodeEq?: InputMaybe<Scalars['String']>;
  browserCodeGt?: InputMaybe<Scalars['String']>;
  browserCodeGte?: InputMaybe<Scalars['String']>;
  browserCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  browserCodeLike?: InputMaybe<Scalars['String']>;
  browserCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  browserCodeLt?: InputMaybe<Scalars['String']>;
  browserCodeLte?: InputMaybe<Scalars['String']>;
  browserCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserContain?: InputMaybe<Scalars['String']>;
  browserEq?: InputMaybe<Scalars['String']>;
  browserGt?: InputMaybe<Scalars['String']>;
  browserGte?: InputMaybe<Scalars['String']>;
  browserIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserIsNull?: InputMaybe<Scalars['Boolean']>;
  browserLike?: InputMaybe<Scalars['String']>;
  browserLikeNoCase?: InputMaybe<Scalars['String']>;
  browserLt?: InputMaybe<Scalars['String']>;
  browserLte?: InputMaybe<Scalars['String']>;
  browserNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserVersion?: InputMaybe<Scalars['String']>;
  browserVersionAny?: InputMaybe<Scalars['String']>;
  browserVersionContain?: InputMaybe<Scalars['String']>;
  browserVersionEq?: InputMaybe<Scalars['String']>;
  browserVersionGt?: InputMaybe<Scalars['String']>;
  browserVersionGte?: InputMaybe<Scalars['String']>;
  browserVersionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserVersionIsNull?: InputMaybe<Scalars['Boolean']>;
  browserVersionLike?: InputMaybe<Scalars['String']>;
  browserVersionLikeNoCase?: InputMaybe<Scalars['String']>;
  browserVersionLt?: InputMaybe<Scalars['String']>;
  browserVersionLte?: InputMaybe<Scalars['String']>;
  browserVersionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ipAddressId?: InputMaybe<Scalars['Int']>;
  ipAddressIdAny?: InputMaybe<Scalars['Int']>;
  ipAddressIdContain?: InputMaybe<Scalars['Int']>;
  ipAddressIdEq?: InputMaybe<Scalars['Int']>;
  ipAddressIdGt?: InputMaybe<Scalars['Int']>;
  ipAddressIdGte?: InputMaybe<Scalars['Int']>;
  ipAddressIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ipAddressIdIsNull?: InputMaybe<Scalars['Boolean']>;
  ipAddressIdLike?: InputMaybe<Scalars['Int']>;
  ipAddressIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  ipAddressIdLt?: InputMaybe<Scalars['Int']>;
  ipAddressIdLte?: InputMaybe<Scalars['Int']>;
  ipAddressIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLVisitorsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLVisitorsPropertiesEnum>;
  os?: InputMaybe<Scalars['String']>;
  osAny?: InputMaybe<Scalars['String']>;
  osCode?: InputMaybe<Scalars['String']>;
  osCodeAny?: InputMaybe<Scalars['String']>;
  osCodeContain?: InputMaybe<Scalars['String']>;
  osCodeEq?: InputMaybe<Scalars['String']>;
  osCodeGt?: InputMaybe<Scalars['String']>;
  osCodeGte?: InputMaybe<Scalars['String']>;
  osCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  osCodeLike?: InputMaybe<Scalars['String']>;
  osCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  osCodeLt?: InputMaybe<Scalars['String']>;
  osCodeLte?: InputMaybe<Scalars['String']>;
  osCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osContain?: InputMaybe<Scalars['String']>;
  osEq?: InputMaybe<Scalars['String']>;
  osGt?: InputMaybe<Scalars['String']>;
  osGte?: InputMaybe<Scalars['String']>;
  osIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osIsNull?: InputMaybe<Scalars['Boolean']>;
  osLike?: InputMaybe<Scalars['String']>;
  osLikeNoCase?: InputMaybe<Scalars['String']>;
  osLt?: InputMaybe<Scalars['String']>;
  osLte?: InputMaybe<Scalars['String']>;
  osNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osVersion?: InputMaybe<Scalars['String']>;
  osVersionAny?: InputMaybe<Scalars['String']>;
  osVersionContain?: InputMaybe<Scalars['String']>;
  osVersionEq?: InputMaybe<Scalars['String']>;
  osVersionGt?: InputMaybe<Scalars['String']>;
  osVersionGte?: InputMaybe<Scalars['String']>;
  osVersionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osVersionIsNull?: InputMaybe<Scalars['Boolean']>;
  osVersionLike?: InputMaybe<Scalars['String']>;
  osVersionLikeNoCase?: InputMaybe<Scalars['String']>;
  osVersionLt?: InputMaybe<Scalars['String']>;
  osVersionLte?: InputMaybe<Scalars['String']>;
  osVersionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  platform?: InputMaybe<Scalars['String']>;
  platformAny?: InputMaybe<Scalars['String']>;
  platformContain?: InputMaybe<Scalars['String']>;
  platformEq?: InputMaybe<Scalars['String']>;
  platformGt?: InputMaybe<Scalars['String']>;
  platformGte?: InputMaybe<Scalars['String']>;
  platformIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  platformIsNull?: InputMaybe<Scalars['Boolean']>;
  platformLike?: InputMaybe<Scalars['String']>;
  platformLikeNoCase?: InputMaybe<Scalars['String']>;
  platformLt?: InputMaybe<Scalars['String']>;
  platformLte?: InputMaybe<Scalars['String']>;
  platformNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  referrer?: InputMaybe<Scalars['String']>;
  referrerAny?: InputMaybe<Scalars['String']>;
  referrerContain?: InputMaybe<Scalars['String']>;
  referrerEq?: InputMaybe<Scalars['String']>;
  referrerGt?: InputMaybe<Scalars['String']>;
  referrerGte?: InputMaybe<Scalars['String']>;
  referrerIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  referrerIsNull?: InputMaybe<Scalars['Boolean']>;
  referrerLike?: InputMaybe<Scalars['String']>;
  referrerLikeNoCase?: InputMaybe<Scalars['String']>;
  referrerLt?: InputMaybe<Scalars['String']>;
  referrerLte?: InputMaybe<Scalars['String']>;
  referrerNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ua?: InputMaybe<Scalars['String']>;
  uaAny?: InputMaybe<Scalars['String']>;
  uaContain?: InputMaybe<Scalars['String']>;
  uaEq?: InputMaybe<Scalars['String']>;
  uaGt?: InputMaybe<Scalars['String']>;
  uaGte?: InputMaybe<Scalars['String']>;
  uaIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uaIsNull?: InputMaybe<Scalars['Boolean']>;
  uaLike?: InputMaybe<Scalars['String']>;
  uaLikeNoCase?: InputMaybe<Scalars['String']>;
  uaLt?: InputMaybe<Scalars['String']>;
  uaLte?: InputMaybe<Scalars['String']>;
  uaNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GQLLeadsMetadata = {
  __typename?: 'LeadsMetadata';
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  leadId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum GQLLeadsMetadataPropertiesEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  IsDeleted = 'isDeleted',
  Key = 'key',
  LeadId = 'leadId',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

export enum GQLLeadsPropertiesEnum {
  AdvertisingNetworkId = 'advertisingNetworkId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  DomainFormId = 'domainFormId',
  Feedback = 'feedback',
  HasAliasCalls = 'hasAliasCalls',
  Id = 'id',
  IsDeleted = 'isDeleted',
  IsOptedOut = 'isOptedOut',
  JornayaId = 'jornayaId',
  Language = 'language',
  ModifiedAt = 'modifiedAt',
  ModifiedBy = 'modifiedBy',
  PiiId = 'piiId',
  Sales = 'sales',
  Status = 'status',
  SubmissionStatus = 'submissionStatus',
  TrafficSource = 'trafficSource',
  TrafficTypeId = 'trafficTypeId',
  TrustedFormCertificateClaimed = 'trustedFormCertificateClaimed',
  TrustedFormCertificateUrl = 'trustedFormCertificateUrl',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  Uuid = 'uuid',
  VisitData = 'visitData',
  VisitId = 'visitId',
  VisitorId = 'visitorId'
}

export type GQLListingAttributes = {
  __typename?: 'ListingAttributes';
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  listingId?: Maybe<Scalars['Int']>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  updatedAt?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};


export type GQLListingAttributesTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export enum GQLListingAttributesPropertiesEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Hidden = 'hidden',
  Id = 'id',
  IsDeleted = 'isDeleted',
  Key = 'key',
  ListingId = 'listingId',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

export type GQLListingFeatures = {
  __typename?: 'ListingFeatures';
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  listing?: Maybe<Array<Maybe<GQLListings>>>;
  listingId?: Maybe<Scalars['Int']>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};


export type GQLListingFeaturesListingArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLListingsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLListingsPropertiesEnum>;
  pageTitle?: InputMaybe<Scalars['String']>;
  pageTitleAny?: InputMaybe<Scalars['String']>;
  pageTitleContain?: InputMaybe<Scalars['String']>;
  pageTitleEq?: InputMaybe<Scalars['String']>;
  pageTitleGt?: InputMaybe<Scalars['String']>;
  pageTitleGte?: InputMaybe<Scalars['String']>;
  pageTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  pageTitleLike?: InputMaybe<Scalars['String']>;
  pageTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  pageTitleLt?: InputMaybe<Scalars['String']>;
  pageTitleLte?: InputMaybe<Scalars['String']>;
  pageTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLListingFeaturesTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export enum GQLListingFeaturesPropertiesEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  Id = 'id',
  IsDeleted = 'isDeleted',
  ListingId = 'listingId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type GQLListings = {
  __typename?: 'Listings';
  attributes?: Maybe<Array<Maybe<GQLListingAttributes>>>;
  category?: Maybe<GQLCategories>;
  categoryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<GQLDomains>;
  features?: Maybe<Array<Maybe<GQLListingFeatures>>>;
  icon?: Maybe<GQLAttachments>;
  iconId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<GQLAttachments>;
  imageId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  offers?: Maybe<Array<Maybe<GQLOffers>>>;
  pageTitle?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  topOffer?: Maybe<GQLOffers>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};


export type GQLListingsAttributesArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  hiddenAny?: InputMaybe<Scalars['Boolean']>;
  hiddenContain?: InputMaybe<Scalars['Boolean']>;
  hiddenEq?: InputMaybe<Scalars['Boolean']>;
  hiddenGt?: InputMaybe<Scalars['Boolean']>;
  hiddenGte?: InputMaybe<Scalars['Boolean']>;
  hiddenIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  hiddenIsNull?: InputMaybe<Scalars['Boolean']>;
  hiddenLike?: InputMaybe<Scalars['Boolean']>;
  hiddenLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  hiddenLt?: InputMaybe<Scalars['Boolean']>;
  hiddenLte?: InputMaybe<Scalars['Boolean']>;
  hiddenNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingId?: InputMaybe<Scalars['Int']>;
  listingIdAny?: InputMaybe<Scalars['Int']>;
  listingIdContain?: InputMaybe<Scalars['Int']>;
  listingIdEq?: InputMaybe<Scalars['Int']>;
  listingIdGt?: InputMaybe<Scalars['Int']>;
  listingIdGte?: InputMaybe<Scalars['Int']>;
  listingIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingIdIsNull?: InputMaybe<Scalars['Boolean']>;
  listingIdLike?: InputMaybe<Scalars['Int']>;
  listingIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  listingIdLt?: InputMaybe<Scalars['Int']>;
  listingIdLte?: InputMaybe<Scalars['Int']>;
  listingIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLListingAttributesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLListingAttributesPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLListingsCategoryArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLListingsDomainArgs = {
  allowedLanguages?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesAny?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesContain?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesEq?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  allowedLanguagesIsNull?: InputMaybe<Scalars['Boolean']>;
  allowedLanguagesLike?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  analyticsCodeId?: InputMaybe<Scalars['String']>;
  analyticsCodeIdAny?: InputMaybe<Scalars['String']>;
  analyticsCodeIdContain?: InputMaybe<Scalars['String']>;
  analyticsCodeIdEq?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  analyticsCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  analyticsCodeIdLike?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cacheSettings?: InputMaybe<Scalars['JSON']>;
  cacheSettingsAny?: InputMaybe<Scalars['JSON']>;
  cacheSettingsContain?: InputMaybe<Scalars['JSON']>;
  cacheSettingsEq?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  cacheSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  cacheSettingsLike?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  clickyCodeId?: InputMaybe<Scalars['String']>;
  clickyCodeIdAny?: InputMaybe<Scalars['String']>;
  clickyCodeIdContain?: InputMaybe<Scalars['String']>;
  clickyCodeIdEq?: InputMaybe<Scalars['String']>;
  clickyCodeIdGt?: InputMaybe<Scalars['String']>;
  clickyCodeIdGte?: InputMaybe<Scalars['String']>;
  clickyCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clickyCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  clickyCodeIdLike?: InputMaybe<Scalars['String']>;
  clickyCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  clickyCodeIdLt?: InputMaybe<Scalars['String']>;
  clickyCodeIdLte?: InputMaybe<Scalars['String']>;
  clickyCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  enableChatWidget?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetAny?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetContain?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetEq?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableChatWidgetIsNull?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLike?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaId?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdAny?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdContain?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdEq?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLike?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedForm?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormAny?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormContain?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormEq?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedFormIsNull?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLike?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  facebookConversionAPISettings?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsAny?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsContain?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsEq?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookConversionAPISettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookConversionAPISettingsLike?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookSiteVerificationCode?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fallbackSettings?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsAny?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsContain?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsEq?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  fallbackSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  fallbackSettingsLike?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  faviconId?: InputMaybe<Scalars['String']>;
  faviconIdAny?: InputMaybe<Scalars['String']>;
  faviconIdContain?: InputMaybe<Scalars['String']>;
  faviconIdEq?: InputMaybe<Scalars['String']>;
  faviconIdGt?: InputMaybe<Scalars['String']>;
  faviconIdGte?: InputMaybe<Scalars['String']>;
  faviconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  faviconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  faviconIdLike?: InputMaybe<Scalars['String']>;
  faviconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  faviconIdLt?: InputMaybe<Scalars['String']>;
  faviconIdLte?: InputMaybe<Scalars['String']>;
  faviconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCode?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  googleSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmId?: InputMaybe<Scalars['String']>;
  gtmIdAny?: InputMaybe<Scalars['String']>;
  gtmIdContain?: InputMaybe<Scalars['String']>;
  gtmIdEq?: InputMaybe<Scalars['String']>;
  gtmIdGt?: InputMaybe<Scalars['String']>;
  gtmIdGte?: InputMaybe<Scalars['String']>;
  gtmIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmIdIsNull?: InputMaybe<Scalars['Boolean']>;
  gtmIdLike?: InputMaybe<Scalars['String']>;
  gtmIdLikeNoCase?: InputMaybe<Scalars['String']>;
  gtmIdLt?: InputMaybe<Scalars['String']>;
  gtmIdLte?: InputMaybe<Scalars['String']>;
  gtmIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  holdingRules?: InputMaybe<Scalars['JSON']>;
  holdingRulesAny?: InputMaybe<Scalars['JSON']>;
  holdingRulesContain?: InputMaybe<Scalars['JSON']>;
  holdingRulesEq?: InputMaybe<Scalars['JSON']>;
  holdingRulesGt?: InputMaybe<Scalars['JSON']>;
  holdingRulesGte?: InputMaybe<Scalars['JSON']>;
  holdingRulesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  holdingRulesIsNull?: InputMaybe<Scalars['Boolean']>;
  holdingRulesLike?: InputMaybe<Scalars['JSON']>;
  holdingRulesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  holdingRulesLt?: InputMaybe<Scalars['JSON']>;
  holdingRulesLte?: InputMaybe<Scalars['JSON']>;
  holdingRulesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabled?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledAny?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledContain?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledEq?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabledIsNull?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLike?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainsPropertiesEnum>;
  otpVerificationCriteria?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaAny?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaContain?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaEq?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  otpVerificationCriteriaIsNull?: InputMaybe<Scalars['Boolean']>;
  otpVerificationCriteriaLike?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfig?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigAny?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigContain?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigEq?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  recaptchaConfigLike?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  secondaryLogoId?: InputMaybe<Scalars['String']>;
  secondaryLogoIdAny?: InputMaybe<Scalars['String']>;
  secondaryLogoIdContain?: InputMaybe<Scalars['String']>;
  secondaryLogoIdEq?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondaryLogoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  secondaryLogoIdLike?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sendNotifications?: InputMaybe<Scalars['JSON']>;
  sendNotificationsAny?: InputMaybe<Scalars['JSON']>;
  sendNotificationsContain?: InputMaybe<Scalars['JSON']>;
  sendNotificationsEq?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  sendNotificationsIsNull?: InputMaybe<Scalars['Boolean']>;
  sendNotificationsLike?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settings?: InputMaybe<Scalars['JSON']>;
  settingsAny?: InputMaybe<Scalars['JSON']>;
  settingsContain?: InputMaybe<Scalars['JSON']>;
  settingsEq?: InputMaybe<Scalars['JSON']>;
  settingsGt?: InputMaybe<Scalars['JSON']>;
  settingsGte?: InputMaybe<Scalars['JSON']>;
  settingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settingsIsNull?: InputMaybe<Scalars['Boolean']>;
  settingsLike?: InputMaybe<Scalars['JSON']>;
  settingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  settingsLt?: InputMaybe<Scalars['JSON']>;
  settingsLte?: InputMaybe<Scalars['JSON']>;
  settingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  slogan?: InputMaybe<Scalars['String']>;
  sloganAny?: InputMaybe<Scalars['String']>;
  sloganContain?: InputMaybe<Scalars['String']>;
  sloganEq?: InputMaybe<Scalars['String']>;
  sloganGt?: InputMaybe<Scalars['String']>;
  sloganGte?: InputMaybe<Scalars['String']>;
  sloganIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sloganIsNull?: InputMaybe<Scalars['Boolean']>;
  sloganLike?: InputMaybe<Scalars['String']>;
  sloganLikeNoCase?: InputMaybe<Scalars['String']>;
  sloganLt?: InputMaybe<Scalars['String']>;
  sloganLte?: InputMaybe<Scalars['String']>;
  sloganNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateConfig?: InputMaybe<Scalars['JSON']>;
  templateConfigAny?: InputMaybe<Scalars['JSON']>;
  templateConfigContain?: InputMaybe<Scalars['JSON']>;
  templateConfigEq?: InputMaybe<Scalars['JSON']>;
  templateConfigGt?: InputMaybe<Scalars['JSON']>;
  templateConfigGte?: InputMaybe<Scalars['JSON']>;
  templateConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  templateConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  templateConfigLike?: InputMaybe<Scalars['JSON']>;
  templateConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  templateConfigLt?: InputMaybe<Scalars['JSON']>;
  templateConfigLte?: InputMaybe<Scalars['JSON']>;
  templateConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixel?: InputMaybe<Scalars['String']>;
  twitterPixelAny?: InputMaybe<Scalars['String']>;
  twitterPixelContain?: InputMaybe<Scalars['String']>;
  twitterPixelEq?: InputMaybe<Scalars['String']>;
  twitterPixelGt?: InputMaybe<Scalars['String']>;
  twitterPixelGte?: InputMaybe<Scalars['String']>;
  twitterPixelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixelIsNull?: InputMaybe<Scalars['Boolean']>;
  twitterPixelLike?: InputMaybe<Scalars['String']>;
  twitterPixelLikeNoCase?: InputMaybe<Scalars['String']>;
  twitterPixelLt?: InputMaybe<Scalars['String']>;
  twitterPixelLte?: InputMaybe<Scalars['String']>;
  twitterPixelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLListingsFeaturesArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingId?: InputMaybe<Scalars['Int']>;
  listingIdAny?: InputMaybe<Scalars['Int']>;
  listingIdContain?: InputMaybe<Scalars['Int']>;
  listingIdEq?: InputMaybe<Scalars['Int']>;
  listingIdGt?: InputMaybe<Scalars['Int']>;
  listingIdGte?: InputMaybe<Scalars['Int']>;
  listingIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingIdIsNull?: InputMaybe<Scalars['Boolean']>;
  listingIdLike?: InputMaybe<Scalars['Int']>;
  listingIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  listingIdLt?: InputMaybe<Scalars['Int']>;
  listingIdLte?: InputMaybe<Scalars['Int']>;
  listingIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLListingFeaturesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLListingFeaturesPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLListingsIconArgs = {
  access?: InputMaybe<Scalars['String']>;
  accessAny?: InputMaybe<Scalars['String']>;
  accessContain?: InputMaybe<Scalars['String']>;
  accessEq?: InputMaybe<Scalars['String']>;
  accessGt?: InputMaybe<Scalars['String']>;
  accessGte?: InputMaybe<Scalars['String']>;
  accessIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accessIsNull?: InputMaybe<Scalars['Boolean']>;
  accessLike?: InputMaybe<Scalars['String']>;
  accessLikeNoCase?: InputMaybe<Scalars['String']>;
  accessLt?: InputMaybe<Scalars['String']>;
  accessLte?: InputMaybe<Scalars['String']>;
  accessNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alt?: InputMaybe<Scalars['String']>;
  altAny?: InputMaybe<Scalars['String']>;
  altContain?: InputMaybe<Scalars['String']>;
  altEq?: InputMaybe<Scalars['String']>;
  altGt?: InputMaybe<Scalars['String']>;
  altGte?: InputMaybe<Scalars['String']>;
  altIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  altIsNull?: InputMaybe<Scalars['Boolean']>;
  altLike?: InputMaybe<Scalars['String']>;
  altLikeNoCase?: InputMaybe<Scalars['String']>;
  altLt?: InputMaybe<Scalars['String']>;
  altLte?: InputMaybe<Scalars['String']>;
  altNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caption?: InputMaybe<Scalars['String']>;
  captionAny?: InputMaybe<Scalars['String']>;
  captionContain?: InputMaybe<Scalars['String']>;
  captionEq?: InputMaybe<Scalars['String']>;
  captionGt?: InputMaybe<Scalars['String']>;
  captionGte?: InputMaybe<Scalars['String']>;
  captionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  captionIsNull?: InputMaybe<Scalars['Boolean']>;
  captionLike?: InputMaybe<Scalars['String']>;
  captionLikeNoCase?: InputMaybe<Scalars['String']>;
  captionLt?: InputMaybe<Scalars['String']>;
  captionLte?: InputMaybe<Scalars['String']>;
  captionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fullPath?: InputMaybe<Scalars['String']>;
  fullPathAny?: InputMaybe<Scalars['String']>;
  fullPathContain?: InputMaybe<Scalars['String']>;
  fullPathEq?: InputMaybe<Scalars['String']>;
  fullPathGt?: InputMaybe<Scalars['String']>;
  fullPathGte?: InputMaybe<Scalars['String']>;
  fullPathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullPathIsNull?: InputMaybe<Scalars['Boolean']>;
  fullPathLike?: InputMaybe<Scalars['String']>;
  fullPathLikeNoCase?: InputMaybe<Scalars['String']>;
  fullPathLt?: InputMaybe<Scalars['String']>;
  fullPathLte?: InputMaybe<Scalars['String']>;
  fullPathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mimeType?: InputMaybe<Scalars['String']>;
  mimeTypeAny?: InputMaybe<Scalars['String']>;
  mimeTypeContain?: InputMaybe<Scalars['String']>;
  mimeTypeEq?: InputMaybe<Scalars['String']>;
  mimeTypeGt?: InputMaybe<Scalars['String']>;
  mimeTypeGte?: InputMaybe<Scalars['String']>;
  mimeTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mimeTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  mimeTypeLike?: InputMaybe<Scalars['String']>;
  mimeTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  mimeTypeLt?: InputMaybe<Scalars['String']>;
  mimeTypeLte?: InputMaybe<Scalars['String']>;
  mimeTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  originalName?: InputMaybe<Scalars['String']>;
  originalNameAny?: InputMaybe<Scalars['String']>;
  originalNameContain?: InputMaybe<Scalars['String']>;
  originalNameEq?: InputMaybe<Scalars['String']>;
  originalNameGt?: InputMaybe<Scalars['String']>;
  originalNameGte?: InputMaybe<Scalars['String']>;
  originalNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  originalNameIsNull?: InputMaybe<Scalars['Boolean']>;
  originalNameLike?: InputMaybe<Scalars['String']>;
  originalNameLikeNoCase?: InputMaybe<Scalars['String']>;
  originalNameLt?: InputMaybe<Scalars['String']>;
  originalNameLte?: InputMaybe<Scalars['String']>;
  originalNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  path?: InputMaybe<Scalars['String']>;
  pathAny?: InputMaybe<Scalars['String']>;
  pathContain?: InputMaybe<Scalars['String']>;
  pathEq?: InputMaybe<Scalars['String']>;
  pathGt?: InputMaybe<Scalars['String']>;
  pathGte?: InputMaybe<Scalars['String']>;
  pathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pathIsNull?: InputMaybe<Scalars['Boolean']>;
  pathLike?: InputMaybe<Scalars['String']>;
  pathLikeNoCase?: InputMaybe<Scalars['String']>;
  pathLt?: InputMaybe<Scalars['String']>;
  pathLte?: InputMaybe<Scalars['String']>;
  pathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  size?: InputMaybe<Scalars['Int']>;
  sizeAny?: InputMaybe<Scalars['Int']>;
  sizeContain?: InputMaybe<Scalars['Int']>;
  sizeEq?: InputMaybe<Scalars['Int']>;
  sizeGt?: InputMaybe<Scalars['Int']>;
  sizeGte?: InputMaybe<Scalars['Int']>;
  sizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sizeLike?: InputMaybe<Scalars['Int']>;
  sizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sizeLt?: InputMaybe<Scalars['Int']>;
  sizeLte?: InputMaybe<Scalars['Int']>;
  sizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLListingsImageArgs = {
  access?: InputMaybe<Scalars['String']>;
  accessAny?: InputMaybe<Scalars['String']>;
  accessContain?: InputMaybe<Scalars['String']>;
  accessEq?: InputMaybe<Scalars['String']>;
  accessGt?: InputMaybe<Scalars['String']>;
  accessGte?: InputMaybe<Scalars['String']>;
  accessIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accessIsNull?: InputMaybe<Scalars['Boolean']>;
  accessLike?: InputMaybe<Scalars['String']>;
  accessLikeNoCase?: InputMaybe<Scalars['String']>;
  accessLt?: InputMaybe<Scalars['String']>;
  accessLte?: InputMaybe<Scalars['String']>;
  accessNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alt?: InputMaybe<Scalars['String']>;
  altAny?: InputMaybe<Scalars['String']>;
  altContain?: InputMaybe<Scalars['String']>;
  altEq?: InputMaybe<Scalars['String']>;
  altGt?: InputMaybe<Scalars['String']>;
  altGte?: InputMaybe<Scalars['String']>;
  altIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  altIsNull?: InputMaybe<Scalars['Boolean']>;
  altLike?: InputMaybe<Scalars['String']>;
  altLikeNoCase?: InputMaybe<Scalars['String']>;
  altLt?: InputMaybe<Scalars['String']>;
  altLte?: InputMaybe<Scalars['String']>;
  altNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caption?: InputMaybe<Scalars['String']>;
  captionAny?: InputMaybe<Scalars['String']>;
  captionContain?: InputMaybe<Scalars['String']>;
  captionEq?: InputMaybe<Scalars['String']>;
  captionGt?: InputMaybe<Scalars['String']>;
  captionGte?: InputMaybe<Scalars['String']>;
  captionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  captionIsNull?: InputMaybe<Scalars['Boolean']>;
  captionLike?: InputMaybe<Scalars['String']>;
  captionLikeNoCase?: InputMaybe<Scalars['String']>;
  captionLt?: InputMaybe<Scalars['String']>;
  captionLte?: InputMaybe<Scalars['String']>;
  captionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fullPath?: InputMaybe<Scalars['String']>;
  fullPathAny?: InputMaybe<Scalars['String']>;
  fullPathContain?: InputMaybe<Scalars['String']>;
  fullPathEq?: InputMaybe<Scalars['String']>;
  fullPathGt?: InputMaybe<Scalars['String']>;
  fullPathGte?: InputMaybe<Scalars['String']>;
  fullPathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullPathIsNull?: InputMaybe<Scalars['Boolean']>;
  fullPathLike?: InputMaybe<Scalars['String']>;
  fullPathLikeNoCase?: InputMaybe<Scalars['String']>;
  fullPathLt?: InputMaybe<Scalars['String']>;
  fullPathLte?: InputMaybe<Scalars['String']>;
  fullPathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mimeType?: InputMaybe<Scalars['String']>;
  mimeTypeAny?: InputMaybe<Scalars['String']>;
  mimeTypeContain?: InputMaybe<Scalars['String']>;
  mimeTypeEq?: InputMaybe<Scalars['String']>;
  mimeTypeGt?: InputMaybe<Scalars['String']>;
  mimeTypeGte?: InputMaybe<Scalars['String']>;
  mimeTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mimeTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  mimeTypeLike?: InputMaybe<Scalars['String']>;
  mimeTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  mimeTypeLt?: InputMaybe<Scalars['String']>;
  mimeTypeLte?: InputMaybe<Scalars['String']>;
  mimeTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  originalName?: InputMaybe<Scalars['String']>;
  originalNameAny?: InputMaybe<Scalars['String']>;
  originalNameContain?: InputMaybe<Scalars['String']>;
  originalNameEq?: InputMaybe<Scalars['String']>;
  originalNameGt?: InputMaybe<Scalars['String']>;
  originalNameGte?: InputMaybe<Scalars['String']>;
  originalNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  originalNameIsNull?: InputMaybe<Scalars['Boolean']>;
  originalNameLike?: InputMaybe<Scalars['String']>;
  originalNameLikeNoCase?: InputMaybe<Scalars['String']>;
  originalNameLt?: InputMaybe<Scalars['String']>;
  originalNameLte?: InputMaybe<Scalars['String']>;
  originalNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  path?: InputMaybe<Scalars['String']>;
  pathAny?: InputMaybe<Scalars['String']>;
  pathContain?: InputMaybe<Scalars['String']>;
  pathEq?: InputMaybe<Scalars['String']>;
  pathGt?: InputMaybe<Scalars['String']>;
  pathGte?: InputMaybe<Scalars['String']>;
  pathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pathIsNull?: InputMaybe<Scalars['Boolean']>;
  pathLike?: InputMaybe<Scalars['String']>;
  pathLikeNoCase?: InputMaybe<Scalars['String']>;
  pathLt?: InputMaybe<Scalars['String']>;
  pathLte?: InputMaybe<Scalars['String']>;
  pathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  size?: InputMaybe<Scalars['Int']>;
  sizeAny?: InputMaybe<Scalars['Int']>;
  sizeContain?: InputMaybe<Scalars['Int']>;
  sizeEq?: InputMaybe<Scalars['Int']>;
  sizeGt?: InputMaybe<Scalars['Int']>;
  sizeGte?: InputMaybe<Scalars['Int']>;
  sizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sizeLike?: InputMaybe<Scalars['Int']>;
  sizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sizeLt?: InputMaybe<Scalars['Int']>;
  sizeLte?: InputMaybe<Scalars['Int']>;
  sizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLListingsOffersArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checkWallet?: InputMaybe<Scalars['Boolean']>;
  checkWalletAny?: InputMaybe<Scalars['Boolean']>;
  checkWalletContain?: InputMaybe<Scalars['Boolean']>;
  checkWalletEq?: InputMaybe<Scalars['Boolean']>;
  checkWalletGt?: InputMaybe<Scalars['Boolean']>;
  checkWalletGte?: InputMaybe<Scalars['Boolean']>;
  checkWalletIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  checkWalletIsNull?: InputMaybe<Scalars['Boolean']>;
  checkWalletLike?: InputMaybe<Scalars['Boolean']>;
  checkWalletLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  checkWalletLt?: InputMaybe<Scalars['Boolean']>;
  checkWalletLte?: InputMaybe<Scalars['Boolean']>;
  checkWalletNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultAffiliateLinkId?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdAny?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdContain?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdEq?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  defaultAffiliateLinkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultAffiliateLinkIdLike?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrl?: InputMaybe<Scalars['String']>;
  displayUrlAny?: InputMaybe<Scalars['String']>;
  displayUrlContain?: InputMaybe<Scalars['String']>;
  displayUrlEq?: InputMaybe<Scalars['String']>;
  displayUrlGt?: InputMaybe<Scalars['String']>;
  displayUrlGte?: InputMaybe<Scalars['String']>;
  displayUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  displayUrlLike?: InputMaybe<Scalars['String']>;
  displayUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  displayUrlLt?: InputMaybe<Scalars['String']>;
  displayUrlLte?: InputMaybe<Scalars['String']>;
  displayUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalData?: InputMaybe<Scalars['JSON']>;
  externalDataAny?: InputMaybe<Scalars['JSON']>;
  externalDataContain?: InputMaybe<Scalars['JSON']>;
  externalDataEq?: InputMaybe<Scalars['JSON']>;
  externalDataGt?: InputMaybe<Scalars['JSON']>;
  externalDataGte?: InputMaybe<Scalars['JSON']>;
  externalDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  externalDataIsNull?: InputMaybe<Scalars['Boolean']>;
  externalDataLike?: InputMaybe<Scalars['JSON']>;
  externalDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  externalDataLt?: InputMaybe<Scalars['JSON']>;
  externalDataLte?: InputMaybe<Scalars['JSON']>;
  externalDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  featuresListTitle?: InputMaybe<Scalars['String']>;
  featuresListTitleAny?: InputMaybe<Scalars['String']>;
  featuresListTitleContain?: InputMaybe<Scalars['String']>;
  featuresListTitleEq?: InputMaybe<Scalars['String']>;
  featuresListTitleGt?: InputMaybe<Scalars['String']>;
  featuresListTitleGte?: InputMaybe<Scalars['String']>;
  featuresListTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuresListTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  featuresListTitleLike?: InputMaybe<Scalars['String']>;
  featuresListTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  featuresListTitleLt?: InputMaybe<Scalars['String']>;
  featuresListTitleLte?: InputMaybe<Scalars['String']>;
  featuresListTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  isPausedAny?: InputMaybe<Scalars['Boolean']>;
  isPausedContain?: InputMaybe<Scalars['Boolean']>;
  isPausedEq?: InputMaybe<Scalars['Boolean']>;
  isPausedGt?: InputMaybe<Scalars['Boolean']>;
  isPausedGte?: InputMaybe<Scalars['Boolean']>;
  isPausedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPausedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPausedLike?: InputMaybe<Scalars['Boolean']>;
  isPausedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPausedLt?: InputMaybe<Scalars['Boolean']>;
  isPausedLte?: InputMaybe<Scalars['Boolean']>;
  isPausedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldOverview?: InputMaybe<Scalars['String']>;
  oldOverviewAny?: InputMaybe<Scalars['String']>;
  oldOverviewContain?: InputMaybe<Scalars['String']>;
  oldOverviewEq?: InputMaybe<Scalars['String']>;
  oldOverviewGt?: InputMaybe<Scalars['String']>;
  oldOverviewGte?: InputMaybe<Scalars['String']>;
  oldOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  oldOverviewLike?: InputMaybe<Scalars['String']>;
  oldOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  oldOverviewLt?: InputMaybe<Scalars['String']>;
  oldOverviewLte?: InputMaybe<Scalars['String']>;
  oldOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOffersPropertiesEnum>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescription?: InputMaybe<Scalars['String']>;
  previewDescriptionAny?: InputMaybe<Scalars['String']>;
  previewDescriptionContain?: InputMaybe<Scalars['String']>;
  previewDescriptionEq?: InputMaybe<Scalars['String']>;
  previewDescriptionGt?: InputMaybe<Scalars['String']>;
  previewDescriptionGte?: InputMaybe<Scalars['String']>;
  previewDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  previewDescriptionLike?: InputMaybe<Scalars['String']>;
  previewDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  previewDescriptionLt?: InputMaybe<Scalars['String']>;
  previewDescriptionLte?: InputMaybe<Scalars['String']>;
  previewDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverview?: InputMaybe<Scalars['String']>;
  quickOverviewAny?: InputMaybe<Scalars['String']>;
  quickOverviewContain?: InputMaybe<Scalars['String']>;
  quickOverviewEq?: InputMaybe<Scalars['String']>;
  quickOverviewGt?: InputMaybe<Scalars['String']>;
  quickOverviewGte?: InputMaybe<Scalars['String']>;
  quickOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  quickOverviewLike?: InputMaybe<Scalars['String']>;
  quickOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  quickOverviewLt?: InputMaybe<Scalars['String']>;
  quickOverviewLte?: InputMaybe<Scalars['String']>;
  quickOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  score?: InputMaybe<Scalars['Float']>;
  scoreAny?: InputMaybe<Scalars['Float']>;
  scoreContain?: InputMaybe<Scalars['Float']>;
  scoreEq?: InputMaybe<Scalars['Float']>;
  scoreGt?: InputMaybe<Scalars['Float']>;
  scoreGte?: InputMaybe<Scalars['Float']>;
  scoreIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  scoreIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreLike?: InputMaybe<Scalars['Float']>;
  scoreLikeNoCase?: InputMaybe<Scalars['Float']>;
  scoreLt?: InputMaybe<Scalars['Float']>;
  scoreLte?: InputMaybe<Scalars['Float']>;
  scoreMessage?: InputMaybe<Scalars['String']>;
  scoreMessageAny?: InputMaybe<Scalars['String']>;
  scoreMessageContain?: InputMaybe<Scalars['String']>;
  scoreMessageEq?: InputMaybe<Scalars['String']>;
  scoreMessageGt?: InputMaybe<Scalars['String']>;
  scoreMessageGte?: InputMaybe<Scalars['String']>;
  scoreMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreMessageLike?: InputMaybe<Scalars['String']>;
  scoreMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  scoreMessageLt?: InputMaybe<Scalars['String']>;
  scoreMessageLte?: InputMaybe<Scalars['String']>;
  scoreMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleAny?: InputMaybe<Scalars['String']>;
  subTitleContain?: InputMaybe<Scalars['String']>;
  subTitleEq?: InputMaybe<Scalars['String']>;
  subTitleGt?: InputMaybe<Scalars['String']>;
  subTitleGte?: InputMaybe<Scalars['String']>;
  subTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subTitleLike?: InputMaybe<Scalars['String']>;
  subTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subTitleLt?: InputMaybe<Scalars['String']>;
  subTitleLte?: InputMaybe<Scalars['String']>;
  subTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescription?: InputMaybe<Scalars['String']>;
  summaryDescriptionAny?: InputMaybe<Scalars['String']>;
  summaryDescriptionContain?: InputMaybe<Scalars['String']>;
  summaryDescriptionEq?: InputMaybe<Scalars['String']>;
  summaryDescriptionGt?: InputMaybe<Scalars['String']>;
  summaryDescriptionGte?: InputMaybe<Scalars['String']>;
  summaryDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryDescriptionLike?: InputMaybe<Scalars['String']>;
  summaryDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryDescriptionLt?: InputMaybe<Scalars['String']>;
  summaryDescriptionLte?: InputMaybe<Scalars['String']>;
  summaryDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitle?: InputMaybe<Scalars['String']>;
  summaryTitleAny?: InputMaybe<Scalars['String']>;
  summaryTitleContain?: InputMaybe<Scalars['String']>;
  summaryTitleEq?: InputMaybe<Scalars['String']>;
  summaryTitleGt?: InputMaybe<Scalars['String']>;
  summaryTitleGte?: InputMaybe<Scalars['String']>;
  summaryTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryTitleLike?: InputMaybe<Scalars['String']>;
  summaryTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryTitleLt?: InputMaybe<Scalars['String']>;
  summaryTitleLte?: InputMaybe<Scalars['String']>;
  summaryTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLListingsTopOfferArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checkWallet?: InputMaybe<Scalars['Boolean']>;
  checkWalletAny?: InputMaybe<Scalars['Boolean']>;
  checkWalletContain?: InputMaybe<Scalars['Boolean']>;
  checkWalletEq?: InputMaybe<Scalars['Boolean']>;
  checkWalletGt?: InputMaybe<Scalars['Boolean']>;
  checkWalletGte?: InputMaybe<Scalars['Boolean']>;
  checkWalletIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  checkWalletIsNull?: InputMaybe<Scalars['Boolean']>;
  checkWalletLike?: InputMaybe<Scalars['Boolean']>;
  checkWalletLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  checkWalletLt?: InputMaybe<Scalars['Boolean']>;
  checkWalletLte?: InputMaybe<Scalars['Boolean']>;
  checkWalletNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultAffiliateLinkId?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdAny?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdContain?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdEq?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  defaultAffiliateLinkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultAffiliateLinkIdLike?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrl?: InputMaybe<Scalars['String']>;
  displayUrlAny?: InputMaybe<Scalars['String']>;
  displayUrlContain?: InputMaybe<Scalars['String']>;
  displayUrlEq?: InputMaybe<Scalars['String']>;
  displayUrlGt?: InputMaybe<Scalars['String']>;
  displayUrlGte?: InputMaybe<Scalars['String']>;
  displayUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  displayUrlLike?: InputMaybe<Scalars['String']>;
  displayUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  displayUrlLt?: InputMaybe<Scalars['String']>;
  displayUrlLte?: InputMaybe<Scalars['String']>;
  displayUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalData?: InputMaybe<Scalars['JSON']>;
  externalDataAny?: InputMaybe<Scalars['JSON']>;
  externalDataContain?: InputMaybe<Scalars['JSON']>;
  externalDataEq?: InputMaybe<Scalars['JSON']>;
  externalDataGt?: InputMaybe<Scalars['JSON']>;
  externalDataGte?: InputMaybe<Scalars['JSON']>;
  externalDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  externalDataIsNull?: InputMaybe<Scalars['Boolean']>;
  externalDataLike?: InputMaybe<Scalars['JSON']>;
  externalDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  externalDataLt?: InputMaybe<Scalars['JSON']>;
  externalDataLte?: InputMaybe<Scalars['JSON']>;
  externalDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  featuresListTitle?: InputMaybe<Scalars['String']>;
  featuresListTitleAny?: InputMaybe<Scalars['String']>;
  featuresListTitleContain?: InputMaybe<Scalars['String']>;
  featuresListTitleEq?: InputMaybe<Scalars['String']>;
  featuresListTitleGt?: InputMaybe<Scalars['String']>;
  featuresListTitleGte?: InputMaybe<Scalars['String']>;
  featuresListTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuresListTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  featuresListTitleLike?: InputMaybe<Scalars['String']>;
  featuresListTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  featuresListTitleLt?: InputMaybe<Scalars['String']>;
  featuresListTitleLte?: InputMaybe<Scalars['String']>;
  featuresListTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  isPausedAny?: InputMaybe<Scalars['Boolean']>;
  isPausedContain?: InputMaybe<Scalars['Boolean']>;
  isPausedEq?: InputMaybe<Scalars['Boolean']>;
  isPausedGt?: InputMaybe<Scalars['Boolean']>;
  isPausedGte?: InputMaybe<Scalars['Boolean']>;
  isPausedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPausedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPausedLike?: InputMaybe<Scalars['Boolean']>;
  isPausedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPausedLt?: InputMaybe<Scalars['Boolean']>;
  isPausedLte?: InputMaybe<Scalars['Boolean']>;
  isPausedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldOverview?: InputMaybe<Scalars['String']>;
  oldOverviewAny?: InputMaybe<Scalars['String']>;
  oldOverviewContain?: InputMaybe<Scalars['String']>;
  oldOverviewEq?: InputMaybe<Scalars['String']>;
  oldOverviewGt?: InputMaybe<Scalars['String']>;
  oldOverviewGte?: InputMaybe<Scalars['String']>;
  oldOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  oldOverviewLike?: InputMaybe<Scalars['String']>;
  oldOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  oldOverviewLt?: InputMaybe<Scalars['String']>;
  oldOverviewLte?: InputMaybe<Scalars['String']>;
  oldOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOffersPropertiesEnum>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescription?: InputMaybe<Scalars['String']>;
  previewDescriptionAny?: InputMaybe<Scalars['String']>;
  previewDescriptionContain?: InputMaybe<Scalars['String']>;
  previewDescriptionEq?: InputMaybe<Scalars['String']>;
  previewDescriptionGt?: InputMaybe<Scalars['String']>;
  previewDescriptionGte?: InputMaybe<Scalars['String']>;
  previewDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  previewDescriptionLike?: InputMaybe<Scalars['String']>;
  previewDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  previewDescriptionLt?: InputMaybe<Scalars['String']>;
  previewDescriptionLte?: InputMaybe<Scalars['String']>;
  previewDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverview?: InputMaybe<Scalars['String']>;
  quickOverviewAny?: InputMaybe<Scalars['String']>;
  quickOverviewContain?: InputMaybe<Scalars['String']>;
  quickOverviewEq?: InputMaybe<Scalars['String']>;
  quickOverviewGt?: InputMaybe<Scalars['String']>;
  quickOverviewGte?: InputMaybe<Scalars['String']>;
  quickOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  quickOverviewLike?: InputMaybe<Scalars['String']>;
  quickOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  quickOverviewLt?: InputMaybe<Scalars['String']>;
  quickOverviewLte?: InputMaybe<Scalars['String']>;
  quickOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  score?: InputMaybe<Scalars['Float']>;
  scoreAny?: InputMaybe<Scalars['Float']>;
  scoreContain?: InputMaybe<Scalars['Float']>;
  scoreEq?: InputMaybe<Scalars['Float']>;
  scoreGt?: InputMaybe<Scalars['Float']>;
  scoreGte?: InputMaybe<Scalars['Float']>;
  scoreIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  scoreIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreLike?: InputMaybe<Scalars['Float']>;
  scoreLikeNoCase?: InputMaybe<Scalars['Float']>;
  scoreLt?: InputMaybe<Scalars['Float']>;
  scoreLte?: InputMaybe<Scalars['Float']>;
  scoreMessage?: InputMaybe<Scalars['String']>;
  scoreMessageAny?: InputMaybe<Scalars['String']>;
  scoreMessageContain?: InputMaybe<Scalars['String']>;
  scoreMessageEq?: InputMaybe<Scalars['String']>;
  scoreMessageGt?: InputMaybe<Scalars['String']>;
  scoreMessageGte?: InputMaybe<Scalars['String']>;
  scoreMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreMessageLike?: InputMaybe<Scalars['String']>;
  scoreMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  scoreMessageLt?: InputMaybe<Scalars['String']>;
  scoreMessageLte?: InputMaybe<Scalars['String']>;
  scoreMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleAny?: InputMaybe<Scalars['String']>;
  subTitleContain?: InputMaybe<Scalars['String']>;
  subTitleEq?: InputMaybe<Scalars['String']>;
  subTitleGt?: InputMaybe<Scalars['String']>;
  subTitleGte?: InputMaybe<Scalars['String']>;
  subTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subTitleLike?: InputMaybe<Scalars['String']>;
  subTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subTitleLt?: InputMaybe<Scalars['String']>;
  subTitleLte?: InputMaybe<Scalars['String']>;
  subTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescription?: InputMaybe<Scalars['String']>;
  summaryDescriptionAny?: InputMaybe<Scalars['String']>;
  summaryDescriptionContain?: InputMaybe<Scalars['String']>;
  summaryDescriptionEq?: InputMaybe<Scalars['String']>;
  summaryDescriptionGt?: InputMaybe<Scalars['String']>;
  summaryDescriptionGte?: InputMaybe<Scalars['String']>;
  summaryDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryDescriptionLike?: InputMaybe<Scalars['String']>;
  summaryDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryDescriptionLt?: InputMaybe<Scalars['String']>;
  summaryDescriptionLte?: InputMaybe<Scalars['String']>;
  summaryDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitle?: InputMaybe<Scalars['String']>;
  summaryTitleAny?: InputMaybe<Scalars['String']>;
  summaryTitleContain?: InputMaybe<Scalars['String']>;
  summaryTitleEq?: InputMaybe<Scalars['String']>;
  summaryTitleGt?: InputMaybe<Scalars['String']>;
  summaryTitleGte?: InputMaybe<Scalars['String']>;
  summaryTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryTitleLike?: InputMaybe<Scalars['String']>;
  summaryTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryTitleLt?: InputMaybe<Scalars['String']>;
  summaryTitleLte?: InputMaybe<Scalars['String']>;
  summaryTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLListingsTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export enum GQLListingsPropertiesEnum {
  CategoryId = 'categoryId',
  CreatedAt = 'createdAt',
  Description = 'description',
  IconId = 'iconId',
  Id = 'id',
  ImageId = 'imageId',
  IsDeleted = 'isDeleted',
  Name = 'name',
  PageTitle = 'pageTitle',
  Slug = 'slug',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type GQLLookups = {
  __typename?: 'Lookups';
  children?: Maybe<Array<Maybe<GQLLookups>>>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parent?: Maybe<GQLLookups>;
  parentId?: Maybe<Scalars['Int']>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  variations?: Maybe<Array<Maybe<GQLVariations>>>;
};


export type GQLLookupsChildrenArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLLookupsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLookupsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLLookupsParentArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLLookupsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLookupsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLLookupsTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};


export type GQLLookupsVariationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLVariationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLVariationsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLLookupsPropertiesEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Id = 'id',
  IsDeleted = 'isDeleted',
  Label = 'label',
  Order = 'order',
  ParentId = 'parentId',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy',
  Value = 'value'
}

export type GQLLookupsVariations = {
  __typename?: 'LookupsVariations';
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lookupId?: Maybe<Scalars['Int']>;
  lookups?: Maybe<Array<Maybe<GQLLookups>>>;
  updatedAt?: Maybe<Scalars['String']>;
  variationId?: Maybe<Scalars['Int']>;
  variations?: Maybe<Array<Maybe<GQLVariations>>>;
};


export type GQLLookupsVariationsLookupsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLLookupsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLookupsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLLookupsVariationsVariationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLVariationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLVariationsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLLookupsVariationsPropertiesEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsDeleted = 'isDeleted',
  LookupId = 'lookupId',
  UpdatedAt = 'updatedAt',
  VariationId = 'variationId'
}

export type GQLMenuItems = {
  __typename?: 'MenuItems';
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  menuId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  parent?: Maybe<GQLMenuItems>;
  parentId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  updatedAt?: Maybe<Scalars['String']>;
};


export type GQLMenuItemsParentArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  link?: InputMaybe<Scalars['String']>;
  linkAny?: InputMaybe<Scalars['String']>;
  linkContain?: InputMaybe<Scalars['String']>;
  linkEq?: InputMaybe<Scalars['String']>;
  linkGt?: InputMaybe<Scalars['String']>;
  linkGte?: InputMaybe<Scalars['String']>;
  linkIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkIsNull?: InputMaybe<Scalars['Boolean']>;
  linkLike?: InputMaybe<Scalars['String']>;
  linkLikeNoCase?: InputMaybe<Scalars['String']>;
  linkLt?: InputMaybe<Scalars['String']>;
  linkLte?: InputMaybe<Scalars['String']>;
  linkNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  menuId?: InputMaybe<Scalars['Int']>;
  menuIdAny?: InputMaybe<Scalars['Int']>;
  menuIdContain?: InputMaybe<Scalars['Int']>;
  menuIdEq?: InputMaybe<Scalars['Int']>;
  menuIdGt?: InputMaybe<Scalars['Int']>;
  menuIdGte?: InputMaybe<Scalars['Int']>;
  menuIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  menuIdIsNull?: InputMaybe<Scalars['Boolean']>;
  menuIdLike?: InputMaybe<Scalars['Int']>;
  menuIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  menuIdLt?: InputMaybe<Scalars['Int']>;
  menuIdLte?: InputMaybe<Scalars['Int']>;
  menuIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLMenuItemsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLMenuItemsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLMenuItemsTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export enum GQLMenuItemsPropertiesEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  IsDeleted = 'isDeleted',
  Language = 'language',
  Link = 'link',
  MenuId = 'menuId',
  Order = 'order',
  ParentId = 'parentId',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type GQLMenus = {
  __typename?: 'Menus';
  category?: Maybe<GQLCategories>;
  categoryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  domain?: Maybe<GQLDomains>;
  domainId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<Maybe<GQLMenuItems>>>;
  links?: Maybe<Array<Maybe<GQLMenuItems>>>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  updatedAt?: Maybe<Scalars['String']>;
};


export type GQLMenusCategoryArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLMenusDomainArgs = {
  allowedLanguages?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesAny?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesContain?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesEq?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  allowedLanguagesIsNull?: InputMaybe<Scalars['Boolean']>;
  allowedLanguagesLike?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  analyticsCodeId?: InputMaybe<Scalars['String']>;
  analyticsCodeIdAny?: InputMaybe<Scalars['String']>;
  analyticsCodeIdContain?: InputMaybe<Scalars['String']>;
  analyticsCodeIdEq?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  analyticsCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  analyticsCodeIdLike?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cacheSettings?: InputMaybe<Scalars['JSON']>;
  cacheSettingsAny?: InputMaybe<Scalars['JSON']>;
  cacheSettingsContain?: InputMaybe<Scalars['JSON']>;
  cacheSettingsEq?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  cacheSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  cacheSettingsLike?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  clickyCodeId?: InputMaybe<Scalars['String']>;
  clickyCodeIdAny?: InputMaybe<Scalars['String']>;
  clickyCodeIdContain?: InputMaybe<Scalars['String']>;
  clickyCodeIdEq?: InputMaybe<Scalars['String']>;
  clickyCodeIdGt?: InputMaybe<Scalars['String']>;
  clickyCodeIdGte?: InputMaybe<Scalars['String']>;
  clickyCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clickyCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  clickyCodeIdLike?: InputMaybe<Scalars['String']>;
  clickyCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  clickyCodeIdLt?: InputMaybe<Scalars['String']>;
  clickyCodeIdLte?: InputMaybe<Scalars['String']>;
  clickyCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  enableChatWidget?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetAny?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetContain?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetEq?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableChatWidgetIsNull?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLike?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaId?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdAny?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdContain?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdEq?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLike?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedForm?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormAny?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormContain?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormEq?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedFormIsNull?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLike?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  facebookConversionAPISettings?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsAny?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsContain?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsEq?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookConversionAPISettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookConversionAPISettingsLike?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookSiteVerificationCode?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fallbackSettings?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsAny?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsContain?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsEq?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  fallbackSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  fallbackSettingsLike?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  faviconId?: InputMaybe<Scalars['String']>;
  faviconIdAny?: InputMaybe<Scalars['String']>;
  faviconIdContain?: InputMaybe<Scalars['String']>;
  faviconIdEq?: InputMaybe<Scalars['String']>;
  faviconIdGt?: InputMaybe<Scalars['String']>;
  faviconIdGte?: InputMaybe<Scalars['String']>;
  faviconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  faviconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  faviconIdLike?: InputMaybe<Scalars['String']>;
  faviconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  faviconIdLt?: InputMaybe<Scalars['String']>;
  faviconIdLte?: InputMaybe<Scalars['String']>;
  faviconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCode?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  googleSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmId?: InputMaybe<Scalars['String']>;
  gtmIdAny?: InputMaybe<Scalars['String']>;
  gtmIdContain?: InputMaybe<Scalars['String']>;
  gtmIdEq?: InputMaybe<Scalars['String']>;
  gtmIdGt?: InputMaybe<Scalars['String']>;
  gtmIdGte?: InputMaybe<Scalars['String']>;
  gtmIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmIdIsNull?: InputMaybe<Scalars['Boolean']>;
  gtmIdLike?: InputMaybe<Scalars['String']>;
  gtmIdLikeNoCase?: InputMaybe<Scalars['String']>;
  gtmIdLt?: InputMaybe<Scalars['String']>;
  gtmIdLte?: InputMaybe<Scalars['String']>;
  gtmIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  holdingRules?: InputMaybe<Scalars['JSON']>;
  holdingRulesAny?: InputMaybe<Scalars['JSON']>;
  holdingRulesContain?: InputMaybe<Scalars['JSON']>;
  holdingRulesEq?: InputMaybe<Scalars['JSON']>;
  holdingRulesGt?: InputMaybe<Scalars['JSON']>;
  holdingRulesGte?: InputMaybe<Scalars['JSON']>;
  holdingRulesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  holdingRulesIsNull?: InputMaybe<Scalars['Boolean']>;
  holdingRulesLike?: InputMaybe<Scalars['JSON']>;
  holdingRulesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  holdingRulesLt?: InputMaybe<Scalars['JSON']>;
  holdingRulesLte?: InputMaybe<Scalars['JSON']>;
  holdingRulesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabled?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledAny?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledContain?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledEq?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabledIsNull?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLike?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainsPropertiesEnum>;
  otpVerificationCriteria?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaAny?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaContain?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaEq?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  otpVerificationCriteriaIsNull?: InputMaybe<Scalars['Boolean']>;
  otpVerificationCriteriaLike?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfig?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigAny?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigContain?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigEq?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  recaptchaConfigLike?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  secondaryLogoId?: InputMaybe<Scalars['String']>;
  secondaryLogoIdAny?: InputMaybe<Scalars['String']>;
  secondaryLogoIdContain?: InputMaybe<Scalars['String']>;
  secondaryLogoIdEq?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondaryLogoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  secondaryLogoIdLike?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sendNotifications?: InputMaybe<Scalars['JSON']>;
  sendNotificationsAny?: InputMaybe<Scalars['JSON']>;
  sendNotificationsContain?: InputMaybe<Scalars['JSON']>;
  sendNotificationsEq?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  sendNotificationsIsNull?: InputMaybe<Scalars['Boolean']>;
  sendNotificationsLike?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settings?: InputMaybe<Scalars['JSON']>;
  settingsAny?: InputMaybe<Scalars['JSON']>;
  settingsContain?: InputMaybe<Scalars['JSON']>;
  settingsEq?: InputMaybe<Scalars['JSON']>;
  settingsGt?: InputMaybe<Scalars['JSON']>;
  settingsGte?: InputMaybe<Scalars['JSON']>;
  settingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settingsIsNull?: InputMaybe<Scalars['Boolean']>;
  settingsLike?: InputMaybe<Scalars['JSON']>;
  settingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  settingsLt?: InputMaybe<Scalars['JSON']>;
  settingsLte?: InputMaybe<Scalars['JSON']>;
  settingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  slogan?: InputMaybe<Scalars['String']>;
  sloganAny?: InputMaybe<Scalars['String']>;
  sloganContain?: InputMaybe<Scalars['String']>;
  sloganEq?: InputMaybe<Scalars['String']>;
  sloganGt?: InputMaybe<Scalars['String']>;
  sloganGte?: InputMaybe<Scalars['String']>;
  sloganIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sloganIsNull?: InputMaybe<Scalars['Boolean']>;
  sloganLike?: InputMaybe<Scalars['String']>;
  sloganLikeNoCase?: InputMaybe<Scalars['String']>;
  sloganLt?: InputMaybe<Scalars['String']>;
  sloganLte?: InputMaybe<Scalars['String']>;
  sloganNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateConfig?: InputMaybe<Scalars['JSON']>;
  templateConfigAny?: InputMaybe<Scalars['JSON']>;
  templateConfigContain?: InputMaybe<Scalars['JSON']>;
  templateConfigEq?: InputMaybe<Scalars['JSON']>;
  templateConfigGt?: InputMaybe<Scalars['JSON']>;
  templateConfigGte?: InputMaybe<Scalars['JSON']>;
  templateConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  templateConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  templateConfigLike?: InputMaybe<Scalars['JSON']>;
  templateConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  templateConfigLt?: InputMaybe<Scalars['JSON']>;
  templateConfigLte?: InputMaybe<Scalars['JSON']>;
  templateConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixel?: InputMaybe<Scalars['String']>;
  twitterPixelAny?: InputMaybe<Scalars['String']>;
  twitterPixelContain?: InputMaybe<Scalars['String']>;
  twitterPixelEq?: InputMaybe<Scalars['String']>;
  twitterPixelGt?: InputMaybe<Scalars['String']>;
  twitterPixelGte?: InputMaybe<Scalars['String']>;
  twitterPixelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixelIsNull?: InputMaybe<Scalars['Boolean']>;
  twitterPixelLike?: InputMaybe<Scalars['String']>;
  twitterPixelLikeNoCase?: InputMaybe<Scalars['String']>;
  twitterPixelLt?: InputMaybe<Scalars['String']>;
  twitterPixelLte?: InputMaybe<Scalars['String']>;
  twitterPixelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLMenusItemsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  link?: InputMaybe<Scalars['String']>;
  linkAny?: InputMaybe<Scalars['String']>;
  linkContain?: InputMaybe<Scalars['String']>;
  linkEq?: InputMaybe<Scalars['String']>;
  linkGt?: InputMaybe<Scalars['String']>;
  linkGte?: InputMaybe<Scalars['String']>;
  linkIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkIsNull?: InputMaybe<Scalars['Boolean']>;
  linkLike?: InputMaybe<Scalars['String']>;
  linkLikeNoCase?: InputMaybe<Scalars['String']>;
  linkLt?: InputMaybe<Scalars['String']>;
  linkLte?: InputMaybe<Scalars['String']>;
  linkNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  menuId?: InputMaybe<Scalars['Int']>;
  menuIdAny?: InputMaybe<Scalars['Int']>;
  menuIdContain?: InputMaybe<Scalars['Int']>;
  menuIdEq?: InputMaybe<Scalars['Int']>;
  menuIdGt?: InputMaybe<Scalars['Int']>;
  menuIdGte?: InputMaybe<Scalars['Int']>;
  menuIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  menuIdIsNull?: InputMaybe<Scalars['Boolean']>;
  menuIdLike?: InputMaybe<Scalars['Int']>;
  menuIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  menuIdLt?: InputMaybe<Scalars['Int']>;
  menuIdLte?: InputMaybe<Scalars['Int']>;
  menuIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLMenuItemsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLMenuItemsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLMenusLinksArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  link?: InputMaybe<Scalars['String']>;
  linkAny?: InputMaybe<Scalars['String']>;
  linkContain?: InputMaybe<Scalars['String']>;
  linkEq?: InputMaybe<Scalars['String']>;
  linkGt?: InputMaybe<Scalars['String']>;
  linkGte?: InputMaybe<Scalars['String']>;
  linkIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkIsNull?: InputMaybe<Scalars['Boolean']>;
  linkLike?: InputMaybe<Scalars['String']>;
  linkLikeNoCase?: InputMaybe<Scalars['String']>;
  linkLt?: InputMaybe<Scalars['String']>;
  linkLte?: InputMaybe<Scalars['String']>;
  linkNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  menuId?: InputMaybe<Scalars['Int']>;
  menuIdAny?: InputMaybe<Scalars['Int']>;
  menuIdContain?: InputMaybe<Scalars['Int']>;
  menuIdEq?: InputMaybe<Scalars['Int']>;
  menuIdGt?: InputMaybe<Scalars['Int']>;
  menuIdGte?: InputMaybe<Scalars['Int']>;
  menuIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  menuIdIsNull?: InputMaybe<Scalars['Boolean']>;
  menuIdLike?: InputMaybe<Scalars['Int']>;
  menuIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  menuIdLt?: InputMaybe<Scalars['Int']>;
  menuIdLte?: InputMaybe<Scalars['Int']>;
  menuIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLMenuItemsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLMenuItemsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLMenusTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export enum GQLMenusPropertiesEnum {
  CategoryId = 'categoryId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  DomainId = 'domainId',
  Id = 'id',
  IsDeleted = 'isDeleted',
  Name = 'name',
  Slug = 'slug',
  UpdatedAt = 'updatedAt'
}

export type GQLMetatags = {
  __typename?: 'Metatags';
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['Int']>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  updatedAt?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};


export type GQLMetatagsTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export enum GQLMetatagsPropertiesEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  Key = 'key',
  Model = 'model',
  ModelId = 'modelId',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

export type GQLOfferCategories = {
  __typename?: 'OfferCategories';
  categoryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  languages?: Maybe<Scalars['JSON']>;
  offerId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export enum GQLOfferCategoriesPropertiesEnum {
  CategoryId = 'categoryId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Languages = 'languages',
  OfferId = 'offerId',
  UpdatedAt = 'updatedAt'
}

export type GQLOfferFeatures = {
  __typename?: 'OfferFeatures';
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  offer?: Maybe<Array<Maybe<GQLOffers>>>;
  offerId?: Maybe<Scalars['Int']>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};


export type GQLOfferFeaturesOfferArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checkWallet?: InputMaybe<Scalars['Boolean']>;
  checkWalletAny?: InputMaybe<Scalars['Boolean']>;
  checkWalletContain?: InputMaybe<Scalars['Boolean']>;
  checkWalletEq?: InputMaybe<Scalars['Boolean']>;
  checkWalletGt?: InputMaybe<Scalars['Boolean']>;
  checkWalletGte?: InputMaybe<Scalars['Boolean']>;
  checkWalletIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  checkWalletIsNull?: InputMaybe<Scalars['Boolean']>;
  checkWalletLike?: InputMaybe<Scalars['Boolean']>;
  checkWalletLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  checkWalletLt?: InputMaybe<Scalars['Boolean']>;
  checkWalletLte?: InputMaybe<Scalars['Boolean']>;
  checkWalletNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultAffiliateLinkId?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdAny?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdContain?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdEq?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  defaultAffiliateLinkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultAffiliateLinkIdLike?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrl?: InputMaybe<Scalars['String']>;
  displayUrlAny?: InputMaybe<Scalars['String']>;
  displayUrlContain?: InputMaybe<Scalars['String']>;
  displayUrlEq?: InputMaybe<Scalars['String']>;
  displayUrlGt?: InputMaybe<Scalars['String']>;
  displayUrlGte?: InputMaybe<Scalars['String']>;
  displayUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  displayUrlLike?: InputMaybe<Scalars['String']>;
  displayUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  displayUrlLt?: InputMaybe<Scalars['String']>;
  displayUrlLte?: InputMaybe<Scalars['String']>;
  displayUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalData?: InputMaybe<Scalars['JSON']>;
  externalDataAny?: InputMaybe<Scalars['JSON']>;
  externalDataContain?: InputMaybe<Scalars['JSON']>;
  externalDataEq?: InputMaybe<Scalars['JSON']>;
  externalDataGt?: InputMaybe<Scalars['JSON']>;
  externalDataGte?: InputMaybe<Scalars['JSON']>;
  externalDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  externalDataIsNull?: InputMaybe<Scalars['Boolean']>;
  externalDataLike?: InputMaybe<Scalars['JSON']>;
  externalDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  externalDataLt?: InputMaybe<Scalars['JSON']>;
  externalDataLte?: InputMaybe<Scalars['JSON']>;
  externalDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  featuresListTitle?: InputMaybe<Scalars['String']>;
  featuresListTitleAny?: InputMaybe<Scalars['String']>;
  featuresListTitleContain?: InputMaybe<Scalars['String']>;
  featuresListTitleEq?: InputMaybe<Scalars['String']>;
  featuresListTitleGt?: InputMaybe<Scalars['String']>;
  featuresListTitleGte?: InputMaybe<Scalars['String']>;
  featuresListTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuresListTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  featuresListTitleLike?: InputMaybe<Scalars['String']>;
  featuresListTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  featuresListTitleLt?: InputMaybe<Scalars['String']>;
  featuresListTitleLte?: InputMaybe<Scalars['String']>;
  featuresListTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  isPausedAny?: InputMaybe<Scalars['Boolean']>;
  isPausedContain?: InputMaybe<Scalars['Boolean']>;
  isPausedEq?: InputMaybe<Scalars['Boolean']>;
  isPausedGt?: InputMaybe<Scalars['Boolean']>;
  isPausedGte?: InputMaybe<Scalars['Boolean']>;
  isPausedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPausedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPausedLike?: InputMaybe<Scalars['Boolean']>;
  isPausedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPausedLt?: InputMaybe<Scalars['Boolean']>;
  isPausedLte?: InputMaybe<Scalars['Boolean']>;
  isPausedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldOverview?: InputMaybe<Scalars['String']>;
  oldOverviewAny?: InputMaybe<Scalars['String']>;
  oldOverviewContain?: InputMaybe<Scalars['String']>;
  oldOverviewEq?: InputMaybe<Scalars['String']>;
  oldOverviewGt?: InputMaybe<Scalars['String']>;
  oldOverviewGte?: InputMaybe<Scalars['String']>;
  oldOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  oldOverviewLike?: InputMaybe<Scalars['String']>;
  oldOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  oldOverviewLt?: InputMaybe<Scalars['String']>;
  oldOverviewLte?: InputMaybe<Scalars['String']>;
  oldOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOffersPropertiesEnum>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescription?: InputMaybe<Scalars['String']>;
  previewDescriptionAny?: InputMaybe<Scalars['String']>;
  previewDescriptionContain?: InputMaybe<Scalars['String']>;
  previewDescriptionEq?: InputMaybe<Scalars['String']>;
  previewDescriptionGt?: InputMaybe<Scalars['String']>;
  previewDescriptionGte?: InputMaybe<Scalars['String']>;
  previewDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  previewDescriptionLike?: InputMaybe<Scalars['String']>;
  previewDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  previewDescriptionLt?: InputMaybe<Scalars['String']>;
  previewDescriptionLte?: InputMaybe<Scalars['String']>;
  previewDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverview?: InputMaybe<Scalars['String']>;
  quickOverviewAny?: InputMaybe<Scalars['String']>;
  quickOverviewContain?: InputMaybe<Scalars['String']>;
  quickOverviewEq?: InputMaybe<Scalars['String']>;
  quickOverviewGt?: InputMaybe<Scalars['String']>;
  quickOverviewGte?: InputMaybe<Scalars['String']>;
  quickOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  quickOverviewLike?: InputMaybe<Scalars['String']>;
  quickOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  quickOverviewLt?: InputMaybe<Scalars['String']>;
  quickOverviewLte?: InputMaybe<Scalars['String']>;
  quickOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  score?: InputMaybe<Scalars['Float']>;
  scoreAny?: InputMaybe<Scalars['Float']>;
  scoreContain?: InputMaybe<Scalars['Float']>;
  scoreEq?: InputMaybe<Scalars['Float']>;
  scoreGt?: InputMaybe<Scalars['Float']>;
  scoreGte?: InputMaybe<Scalars['Float']>;
  scoreIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  scoreIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreLike?: InputMaybe<Scalars['Float']>;
  scoreLikeNoCase?: InputMaybe<Scalars['Float']>;
  scoreLt?: InputMaybe<Scalars['Float']>;
  scoreLte?: InputMaybe<Scalars['Float']>;
  scoreMessage?: InputMaybe<Scalars['String']>;
  scoreMessageAny?: InputMaybe<Scalars['String']>;
  scoreMessageContain?: InputMaybe<Scalars['String']>;
  scoreMessageEq?: InputMaybe<Scalars['String']>;
  scoreMessageGt?: InputMaybe<Scalars['String']>;
  scoreMessageGte?: InputMaybe<Scalars['String']>;
  scoreMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreMessageLike?: InputMaybe<Scalars['String']>;
  scoreMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  scoreMessageLt?: InputMaybe<Scalars['String']>;
  scoreMessageLte?: InputMaybe<Scalars['String']>;
  scoreMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleAny?: InputMaybe<Scalars['String']>;
  subTitleContain?: InputMaybe<Scalars['String']>;
  subTitleEq?: InputMaybe<Scalars['String']>;
  subTitleGt?: InputMaybe<Scalars['String']>;
  subTitleGte?: InputMaybe<Scalars['String']>;
  subTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subTitleLike?: InputMaybe<Scalars['String']>;
  subTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subTitleLt?: InputMaybe<Scalars['String']>;
  subTitleLte?: InputMaybe<Scalars['String']>;
  subTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescription?: InputMaybe<Scalars['String']>;
  summaryDescriptionAny?: InputMaybe<Scalars['String']>;
  summaryDescriptionContain?: InputMaybe<Scalars['String']>;
  summaryDescriptionEq?: InputMaybe<Scalars['String']>;
  summaryDescriptionGt?: InputMaybe<Scalars['String']>;
  summaryDescriptionGte?: InputMaybe<Scalars['String']>;
  summaryDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryDescriptionLike?: InputMaybe<Scalars['String']>;
  summaryDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryDescriptionLt?: InputMaybe<Scalars['String']>;
  summaryDescriptionLte?: InputMaybe<Scalars['String']>;
  summaryDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitle?: InputMaybe<Scalars['String']>;
  summaryTitleAny?: InputMaybe<Scalars['String']>;
  summaryTitleContain?: InputMaybe<Scalars['String']>;
  summaryTitleEq?: InputMaybe<Scalars['String']>;
  summaryTitleGt?: InputMaybe<Scalars['String']>;
  summaryTitleGte?: InputMaybe<Scalars['String']>;
  summaryTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryTitleLike?: InputMaybe<Scalars['String']>;
  summaryTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryTitleLt?: InputMaybe<Scalars['String']>;
  summaryTitleLte?: InputMaybe<Scalars['String']>;
  summaryTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLOfferFeaturesTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export enum GQLOfferFeaturesPropertiesEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  Id = 'id',
  IsDeleted = 'isDeleted',
  Language = 'language',
  OfferId = 'offerId',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type GQLOfferSchedules = {
  __typename?: 'OfferSchedules';
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  offer?: Maybe<GQLOffers>;
  offerId?: Maybe<Scalars['Int']>;
  schedule?: Maybe<Scalars['JSON']>;
  timeZone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};


export type GQLOfferSchedulesOfferArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checkWallet?: InputMaybe<Scalars['Boolean']>;
  checkWalletAny?: InputMaybe<Scalars['Boolean']>;
  checkWalletContain?: InputMaybe<Scalars['Boolean']>;
  checkWalletEq?: InputMaybe<Scalars['Boolean']>;
  checkWalletGt?: InputMaybe<Scalars['Boolean']>;
  checkWalletGte?: InputMaybe<Scalars['Boolean']>;
  checkWalletIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  checkWalletIsNull?: InputMaybe<Scalars['Boolean']>;
  checkWalletLike?: InputMaybe<Scalars['Boolean']>;
  checkWalletLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  checkWalletLt?: InputMaybe<Scalars['Boolean']>;
  checkWalletLte?: InputMaybe<Scalars['Boolean']>;
  checkWalletNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultAffiliateLinkId?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdAny?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdContain?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdEq?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  defaultAffiliateLinkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultAffiliateLinkIdLike?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrl?: InputMaybe<Scalars['String']>;
  displayUrlAny?: InputMaybe<Scalars['String']>;
  displayUrlContain?: InputMaybe<Scalars['String']>;
  displayUrlEq?: InputMaybe<Scalars['String']>;
  displayUrlGt?: InputMaybe<Scalars['String']>;
  displayUrlGte?: InputMaybe<Scalars['String']>;
  displayUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  displayUrlLike?: InputMaybe<Scalars['String']>;
  displayUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  displayUrlLt?: InputMaybe<Scalars['String']>;
  displayUrlLte?: InputMaybe<Scalars['String']>;
  displayUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalData?: InputMaybe<Scalars['JSON']>;
  externalDataAny?: InputMaybe<Scalars['JSON']>;
  externalDataContain?: InputMaybe<Scalars['JSON']>;
  externalDataEq?: InputMaybe<Scalars['JSON']>;
  externalDataGt?: InputMaybe<Scalars['JSON']>;
  externalDataGte?: InputMaybe<Scalars['JSON']>;
  externalDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  externalDataIsNull?: InputMaybe<Scalars['Boolean']>;
  externalDataLike?: InputMaybe<Scalars['JSON']>;
  externalDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  externalDataLt?: InputMaybe<Scalars['JSON']>;
  externalDataLte?: InputMaybe<Scalars['JSON']>;
  externalDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  featuresListTitle?: InputMaybe<Scalars['String']>;
  featuresListTitleAny?: InputMaybe<Scalars['String']>;
  featuresListTitleContain?: InputMaybe<Scalars['String']>;
  featuresListTitleEq?: InputMaybe<Scalars['String']>;
  featuresListTitleGt?: InputMaybe<Scalars['String']>;
  featuresListTitleGte?: InputMaybe<Scalars['String']>;
  featuresListTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuresListTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  featuresListTitleLike?: InputMaybe<Scalars['String']>;
  featuresListTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  featuresListTitleLt?: InputMaybe<Scalars['String']>;
  featuresListTitleLte?: InputMaybe<Scalars['String']>;
  featuresListTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  isPausedAny?: InputMaybe<Scalars['Boolean']>;
  isPausedContain?: InputMaybe<Scalars['Boolean']>;
  isPausedEq?: InputMaybe<Scalars['Boolean']>;
  isPausedGt?: InputMaybe<Scalars['Boolean']>;
  isPausedGte?: InputMaybe<Scalars['Boolean']>;
  isPausedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPausedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPausedLike?: InputMaybe<Scalars['Boolean']>;
  isPausedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPausedLt?: InputMaybe<Scalars['Boolean']>;
  isPausedLte?: InputMaybe<Scalars['Boolean']>;
  isPausedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldOverview?: InputMaybe<Scalars['String']>;
  oldOverviewAny?: InputMaybe<Scalars['String']>;
  oldOverviewContain?: InputMaybe<Scalars['String']>;
  oldOverviewEq?: InputMaybe<Scalars['String']>;
  oldOverviewGt?: InputMaybe<Scalars['String']>;
  oldOverviewGte?: InputMaybe<Scalars['String']>;
  oldOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  oldOverviewLike?: InputMaybe<Scalars['String']>;
  oldOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  oldOverviewLt?: InputMaybe<Scalars['String']>;
  oldOverviewLte?: InputMaybe<Scalars['String']>;
  oldOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOffersPropertiesEnum>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescription?: InputMaybe<Scalars['String']>;
  previewDescriptionAny?: InputMaybe<Scalars['String']>;
  previewDescriptionContain?: InputMaybe<Scalars['String']>;
  previewDescriptionEq?: InputMaybe<Scalars['String']>;
  previewDescriptionGt?: InputMaybe<Scalars['String']>;
  previewDescriptionGte?: InputMaybe<Scalars['String']>;
  previewDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  previewDescriptionLike?: InputMaybe<Scalars['String']>;
  previewDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  previewDescriptionLt?: InputMaybe<Scalars['String']>;
  previewDescriptionLte?: InputMaybe<Scalars['String']>;
  previewDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverview?: InputMaybe<Scalars['String']>;
  quickOverviewAny?: InputMaybe<Scalars['String']>;
  quickOverviewContain?: InputMaybe<Scalars['String']>;
  quickOverviewEq?: InputMaybe<Scalars['String']>;
  quickOverviewGt?: InputMaybe<Scalars['String']>;
  quickOverviewGte?: InputMaybe<Scalars['String']>;
  quickOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  quickOverviewLike?: InputMaybe<Scalars['String']>;
  quickOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  quickOverviewLt?: InputMaybe<Scalars['String']>;
  quickOverviewLte?: InputMaybe<Scalars['String']>;
  quickOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  score?: InputMaybe<Scalars['Float']>;
  scoreAny?: InputMaybe<Scalars['Float']>;
  scoreContain?: InputMaybe<Scalars['Float']>;
  scoreEq?: InputMaybe<Scalars['Float']>;
  scoreGt?: InputMaybe<Scalars['Float']>;
  scoreGte?: InputMaybe<Scalars['Float']>;
  scoreIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  scoreIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreLike?: InputMaybe<Scalars['Float']>;
  scoreLikeNoCase?: InputMaybe<Scalars['Float']>;
  scoreLt?: InputMaybe<Scalars['Float']>;
  scoreLte?: InputMaybe<Scalars['Float']>;
  scoreMessage?: InputMaybe<Scalars['String']>;
  scoreMessageAny?: InputMaybe<Scalars['String']>;
  scoreMessageContain?: InputMaybe<Scalars['String']>;
  scoreMessageEq?: InputMaybe<Scalars['String']>;
  scoreMessageGt?: InputMaybe<Scalars['String']>;
  scoreMessageGte?: InputMaybe<Scalars['String']>;
  scoreMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreMessageLike?: InputMaybe<Scalars['String']>;
  scoreMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  scoreMessageLt?: InputMaybe<Scalars['String']>;
  scoreMessageLte?: InputMaybe<Scalars['String']>;
  scoreMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleAny?: InputMaybe<Scalars['String']>;
  subTitleContain?: InputMaybe<Scalars['String']>;
  subTitleEq?: InputMaybe<Scalars['String']>;
  subTitleGt?: InputMaybe<Scalars['String']>;
  subTitleGte?: InputMaybe<Scalars['String']>;
  subTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subTitleLike?: InputMaybe<Scalars['String']>;
  subTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subTitleLt?: InputMaybe<Scalars['String']>;
  subTitleLte?: InputMaybe<Scalars['String']>;
  subTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescription?: InputMaybe<Scalars['String']>;
  summaryDescriptionAny?: InputMaybe<Scalars['String']>;
  summaryDescriptionContain?: InputMaybe<Scalars['String']>;
  summaryDescriptionEq?: InputMaybe<Scalars['String']>;
  summaryDescriptionGt?: InputMaybe<Scalars['String']>;
  summaryDescriptionGte?: InputMaybe<Scalars['String']>;
  summaryDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryDescriptionLike?: InputMaybe<Scalars['String']>;
  summaryDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryDescriptionLt?: InputMaybe<Scalars['String']>;
  summaryDescriptionLte?: InputMaybe<Scalars['String']>;
  summaryDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitle?: InputMaybe<Scalars['String']>;
  summaryTitleAny?: InputMaybe<Scalars['String']>;
  summaryTitleContain?: InputMaybe<Scalars['String']>;
  summaryTitleEq?: InputMaybe<Scalars['String']>;
  summaryTitleGt?: InputMaybe<Scalars['String']>;
  summaryTitleGte?: InputMaybe<Scalars['String']>;
  summaryTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryTitleLike?: InputMaybe<Scalars['String']>;
  summaryTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryTitleLt?: InputMaybe<Scalars['String']>;
  summaryTitleLte?: InputMaybe<Scalars['String']>;
  summaryTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLOfferSchedulesPropertiesEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  OfferId = 'offerId',
  Schedule = 'schedule',
  TimeZone = 'timeZone',
  UpdatedAt = 'updatedAt'
}

export type GQLOffers = {
  __typename?: 'Offers';
  affiliateLinks?: Maybe<Array<Maybe<GQLAffiliateLinks>>>;
  attributes?: Maybe<Array<Maybe<GQLCategoryAttributesValues>>>;
  body?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<GQLCategories>>>;
  checkWallet?: Maybe<Scalars['Boolean']>;
  cons?: Maybe<Array<Maybe<GQLOfferFeatures>>>;
  createdAt?: Maybe<Scalars['String']>;
  defaultAffiliateLink?: Maybe<GQLAffiliateLinks>;
  defaultAffiliateLinkId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  displayUrl?: Maybe<Scalars['String']>;
  domainOffers?: Maybe<Array<Maybe<GQLDomainOffers>>>;
  domains?: Maybe<Array<Maybe<GQLDomains>>>;
  editedBy?: Maybe<Scalars['String']>;
  editorUser?: Maybe<GQLUsers>;
  externalData?: Maybe<Scalars['JSON']>;
  faqs?: Maybe<Array<Maybe<GQLFaqs>>>;
  features?: Maybe<Array<Maybe<GQLOfferFeatures>>>;
  featuresListTitle?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<GQLAttachments>;
  imageId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPaused?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Scalars['JSON']>;
  logo?: Maybe<GQLAttachments>;
  logoId?: Maybe<Scalars['String']>;
  mainImage?: Maybe<GQLAttachments>;
  mainImageId?: Maybe<Scalars['String']>;
  metatags?: Maybe<Array<Maybe<GQLMetatags>>>;
  name?: Maybe<Scalars['String']>;
  offerAttributes?: Maybe<Array<Maybe<GQLCategoryAttributesValues>>>;
  oldOverview?: Maybe<Scalars['String']>;
  overview?: Maybe<Scalars['String']>;
  previewDescription?: Maybe<Scalars['String']>;
  pros?: Maybe<Array<Maybe<GQLOfferFeatures>>>;
  quickOverview?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  scoreMessage?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugAlias?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  summaryDescription?: Maybe<Scalars['String']>;
  summaryTitle?: Maybe<Scalars['String']>;
  taxonomies?: Maybe<Array<Maybe<GQLTaxonomies>>>;
  title?: Maybe<Scalars['String']>;
  topics?: Maybe<Array<Maybe<GQLPosts>>>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  updatedAt?: Maybe<Scalars['String']>;
  url?: Maybe<GQLUrls>;
  urls?: Maybe<Array<Maybe<GQLUrls>>>;
  userId?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
  workingHours?: Maybe<GQLOfferSchedules>;
  writerUser?: Maybe<GQLUsers>;
  writtenBy?: Maybe<Scalars['String']>;
};


export type GQLOffersAffiliateLinksArgs = {
  affiliateProviderOfferId?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdAny?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdContain?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdEq?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdGt?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdGte?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  affiliateProviderOfferIdIsNull?: InputMaybe<Scalars['Boolean']>;
  affiliateProviderOfferIdLike?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdLikeNoCase?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdLt?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdLte?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buyerAffiliateProviderId?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdAny?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdContain?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdEq?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdGt?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdGte?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerAffiliateProviderIdIsNull?: InputMaybe<Scalars['Boolean']>;
  buyerAffiliateProviderIdLike?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdLt?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdLte?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerId?: InputMaybe<Scalars['Int']>;
  buyerIdAny?: InputMaybe<Scalars['Int']>;
  buyerIdContain?: InputMaybe<Scalars['Int']>;
  buyerIdEq?: InputMaybe<Scalars['Int']>;
  buyerIdGt?: InputMaybe<Scalars['Int']>;
  buyerIdGte?: InputMaybe<Scalars['Int']>;
  buyerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  buyerIdLike?: InputMaybe<Scalars['Int']>;
  buyerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  buyerIdLt?: InputMaybe<Scalars['Int']>;
  buyerIdLte?: InputMaybe<Scalars['Int']>;
  buyerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  currency?: InputMaybe<Scalars['String']>;
  currencyAny?: InputMaybe<Scalars['String']>;
  currencyContain?: InputMaybe<Scalars['String']>;
  currencyEq?: InputMaybe<Scalars['String']>;
  currencyGt?: InputMaybe<Scalars['String']>;
  currencyGte?: InputMaybe<Scalars['String']>;
  currencyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  currencyIsNull?: InputMaybe<Scalars['Boolean']>;
  currencyLike?: InputMaybe<Scalars['String']>;
  currencyLikeNoCase?: InputMaybe<Scalars['String']>;
  currencyLt?: InputMaybe<Scalars['String']>;
  currencyLte?: InputMaybe<Scalars['String']>;
  currencyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultPayout?: InputMaybe<Scalars['Float']>;
  defaultPayoutAny?: InputMaybe<Scalars['Float']>;
  defaultPayoutContain?: InputMaybe<Scalars['Float']>;
  defaultPayoutEq?: InputMaybe<Scalars['Float']>;
  defaultPayoutGt?: InputMaybe<Scalars['Float']>;
  defaultPayoutGte?: InputMaybe<Scalars['Float']>;
  defaultPayoutIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  defaultPayoutIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultPayoutLike?: InputMaybe<Scalars['Float']>;
  defaultPayoutLikeNoCase?: InputMaybe<Scalars['Float']>;
  defaultPayoutLt?: InputMaybe<Scalars['Float']>;
  defaultPayoutLte?: InputMaybe<Scalars['Float']>;
  defaultPayoutNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  factors?: InputMaybe<Scalars['JSON']>;
  factorsAny?: InputMaybe<Scalars['JSON']>;
  factorsContain?: InputMaybe<Scalars['JSON']>;
  factorsEq?: InputMaybe<Scalars['JSON']>;
  factorsGt?: InputMaybe<Scalars['JSON']>;
  factorsGte?: InputMaybe<Scalars['JSON']>;
  factorsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  factorsIsNull?: InputMaybe<Scalars['Boolean']>;
  factorsLike?: InputMaybe<Scalars['JSON']>;
  factorsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  factorsLt?: InputMaybe<Scalars['JSON']>;
  factorsLte?: InputMaybe<Scalars['JSON']>;
  factorsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  link?: InputMaybe<Scalars['String']>;
  linkAny?: InputMaybe<Scalars['String']>;
  linkContain?: InputMaybe<Scalars['String']>;
  linkEq?: InputMaybe<Scalars['String']>;
  linkGt?: InputMaybe<Scalars['String']>;
  linkGte?: InputMaybe<Scalars['String']>;
  linkIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkIsNull?: InputMaybe<Scalars['Boolean']>;
  linkLike?: InputMaybe<Scalars['String']>;
  linkLikeNoCase?: InputMaybe<Scalars['String']>;
  linkLt?: InputMaybe<Scalars['String']>;
  linkLte?: InputMaybe<Scalars['String']>;
  linkNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  method?: InputMaybe<Scalars['String']>;
  methodAny?: InputMaybe<Scalars['String']>;
  methodContain?: InputMaybe<Scalars['String']>;
  methodEq?: InputMaybe<Scalars['String']>;
  methodGt?: InputMaybe<Scalars['String']>;
  methodGte?: InputMaybe<Scalars['String']>;
  methodIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  methodIsNull?: InputMaybe<Scalars['Boolean']>;
  methodLike?: InputMaybe<Scalars['String']>;
  methodLikeNoCase?: InputMaybe<Scalars['String']>;
  methodLt?: InputMaybe<Scalars['String']>;
  methodLte?: InputMaybe<Scalars['String']>;
  methodNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldPrice?: InputMaybe<Scalars['Float']>;
  oldPriceAny?: InputMaybe<Scalars['Float']>;
  oldPriceContain?: InputMaybe<Scalars['Float']>;
  oldPriceEq?: InputMaybe<Scalars['Float']>;
  oldPriceGt?: InputMaybe<Scalars['Float']>;
  oldPriceGte?: InputMaybe<Scalars['Float']>;
  oldPriceIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  oldPriceIsNull?: InputMaybe<Scalars['Boolean']>;
  oldPriceLike?: InputMaybe<Scalars['Float']>;
  oldPriceLikeNoCase?: InputMaybe<Scalars['Float']>;
  oldPriceLt?: InputMaybe<Scalars['Float']>;
  oldPriceLte?: InputMaybe<Scalars['Float']>;
  oldPriceNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  orderBy?: InputMaybe<GQLAffiliateLinksPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAffiliateLinksPropertiesEnum>;
  price?: InputMaybe<Scalars['Float']>;
  priceAny?: InputMaybe<Scalars['Float']>;
  priceContain?: InputMaybe<Scalars['Float']>;
  priceEq?: InputMaybe<Scalars['Float']>;
  priceGt?: InputMaybe<Scalars['Float']>;
  priceGte?: InputMaybe<Scalars['Float']>;
  priceIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  priceIsNull?: InputMaybe<Scalars['Boolean']>;
  priceLike?: InputMaybe<Scalars['Float']>;
  priceLikeNoCase?: InputMaybe<Scalars['Float']>;
  priceLt?: InputMaybe<Scalars['Float']>;
  priceLte?: InputMaybe<Scalars['Float']>;
  priceNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLOffersAttributesArgs = {
  attributeId?: InputMaybe<Scalars['Int']>;
  attributeIdAny?: InputMaybe<Scalars['Int']>;
  attributeIdContain?: InputMaybe<Scalars['Int']>;
  attributeIdEq?: InputMaybe<Scalars['Int']>;
  attributeIdGt?: InputMaybe<Scalars['Int']>;
  attributeIdGte?: InputMaybe<Scalars['Int']>;
  attributeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  attributeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  attributeIdLike?: InputMaybe<Scalars['Int']>;
  attributeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  attributeIdLt?: InputMaybe<Scalars['Int']>;
  attributeIdLte?: InputMaybe<Scalars['Int']>;
  attributeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLCategoryAttributesValuesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoryAttributesValuesPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLOffersCategoriesArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLOffersConsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLOfferFeaturesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOfferFeaturesPropertiesEnum>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLOffersDefaultAffiliateLinkArgs = {
  affiliateProviderOfferId?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdAny?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdContain?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdEq?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdGt?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdGte?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  affiliateProviderOfferIdIsNull?: InputMaybe<Scalars['Boolean']>;
  affiliateProviderOfferIdLike?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdLikeNoCase?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdLt?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdLte?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buyerAffiliateProviderId?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdAny?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdContain?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdEq?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdGt?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdGte?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerAffiliateProviderIdIsNull?: InputMaybe<Scalars['Boolean']>;
  buyerAffiliateProviderIdLike?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdLt?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdLte?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerId?: InputMaybe<Scalars['Int']>;
  buyerIdAny?: InputMaybe<Scalars['Int']>;
  buyerIdContain?: InputMaybe<Scalars['Int']>;
  buyerIdEq?: InputMaybe<Scalars['Int']>;
  buyerIdGt?: InputMaybe<Scalars['Int']>;
  buyerIdGte?: InputMaybe<Scalars['Int']>;
  buyerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  buyerIdLike?: InputMaybe<Scalars['Int']>;
  buyerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  buyerIdLt?: InputMaybe<Scalars['Int']>;
  buyerIdLte?: InputMaybe<Scalars['Int']>;
  buyerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  currency?: InputMaybe<Scalars['String']>;
  currencyAny?: InputMaybe<Scalars['String']>;
  currencyContain?: InputMaybe<Scalars['String']>;
  currencyEq?: InputMaybe<Scalars['String']>;
  currencyGt?: InputMaybe<Scalars['String']>;
  currencyGte?: InputMaybe<Scalars['String']>;
  currencyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  currencyIsNull?: InputMaybe<Scalars['Boolean']>;
  currencyLike?: InputMaybe<Scalars['String']>;
  currencyLikeNoCase?: InputMaybe<Scalars['String']>;
  currencyLt?: InputMaybe<Scalars['String']>;
  currencyLte?: InputMaybe<Scalars['String']>;
  currencyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultPayout?: InputMaybe<Scalars['Float']>;
  defaultPayoutAny?: InputMaybe<Scalars['Float']>;
  defaultPayoutContain?: InputMaybe<Scalars['Float']>;
  defaultPayoutEq?: InputMaybe<Scalars['Float']>;
  defaultPayoutGt?: InputMaybe<Scalars['Float']>;
  defaultPayoutGte?: InputMaybe<Scalars['Float']>;
  defaultPayoutIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  defaultPayoutIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultPayoutLike?: InputMaybe<Scalars['Float']>;
  defaultPayoutLikeNoCase?: InputMaybe<Scalars['Float']>;
  defaultPayoutLt?: InputMaybe<Scalars['Float']>;
  defaultPayoutLte?: InputMaybe<Scalars['Float']>;
  defaultPayoutNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  factors?: InputMaybe<Scalars['JSON']>;
  factorsAny?: InputMaybe<Scalars['JSON']>;
  factorsContain?: InputMaybe<Scalars['JSON']>;
  factorsEq?: InputMaybe<Scalars['JSON']>;
  factorsGt?: InputMaybe<Scalars['JSON']>;
  factorsGte?: InputMaybe<Scalars['JSON']>;
  factorsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  factorsIsNull?: InputMaybe<Scalars['Boolean']>;
  factorsLike?: InputMaybe<Scalars['JSON']>;
  factorsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  factorsLt?: InputMaybe<Scalars['JSON']>;
  factorsLte?: InputMaybe<Scalars['JSON']>;
  factorsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  link?: InputMaybe<Scalars['String']>;
  linkAny?: InputMaybe<Scalars['String']>;
  linkContain?: InputMaybe<Scalars['String']>;
  linkEq?: InputMaybe<Scalars['String']>;
  linkGt?: InputMaybe<Scalars['String']>;
  linkGte?: InputMaybe<Scalars['String']>;
  linkIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkIsNull?: InputMaybe<Scalars['Boolean']>;
  linkLike?: InputMaybe<Scalars['String']>;
  linkLikeNoCase?: InputMaybe<Scalars['String']>;
  linkLt?: InputMaybe<Scalars['String']>;
  linkLte?: InputMaybe<Scalars['String']>;
  linkNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  method?: InputMaybe<Scalars['String']>;
  methodAny?: InputMaybe<Scalars['String']>;
  methodContain?: InputMaybe<Scalars['String']>;
  methodEq?: InputMaybe<Scalars['String']>;
  methodGt?: InputMaybe<Scalars['String']>;
  methodGte?: InputMaybe<Scalars['String']>;
  methodIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  methodIsNull?: InputMaybe<Scalars['Boolean']>;
  methodLike?: InputMaybe<Scalars['String']>;
  methodLikeNoCase?: InputMaybe<Scalars['String']>;
  methodLt?: InputMaybe<Scalars['String']>;
  methodLte?: InputMaybe<Scalars['String']>;
  methodNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldPrice?: InputMaybe<Scalars['Float']>;
  oldPriceAny?: InputMaybe<Scalars['Float']>;
  oldPriceContain?: InputMaybe<Scalars['Float']>;
  oldPriceEq?: InputMaybe<Scalars['Float']>;
  oldPriceGt?: InputMaybe<Scalars['Float']>;
  oldPriceGte?: InputMaybe<Scalars['Float']>;
  oldPriceIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  oldPriceIsNull?: InputMaybe<Scalars['Boolean']>;
  oldPriceLike?: InputMaybe<Scalars['Float']>;
  oldPriceLikeNoCase?: InputMaybe<Scalars['Float']>;
  oldPriceLt?: InputMaybe<Scalars['Float']>;
  oldPriceLte?: InputMaybe<Scalars['Float']>;
  oldPriceNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  orderBy?: InputMaybe<GQLAffiliateLinksPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAffiliateLinksPropertiesEnum>;
  price?: InputMaybe<Scalars['Float']>;
  priceAny?: InputMaybe<Scalars['Float']>;
  priceContain?: InputMaybe<Scalars['Float']>;
  priceEq?: InputMaybe<Scalars['Float']>;
  priceGt?: InputMaybe<Scalars['Float']>;
  priceGte?: InputMaybe<Scalars['Float']>;
  priceIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  priceIsNull?: InputMaybe<Scalars['Boolean']>;
  priceLike?: InputMaybe<Scalars['Float']>;
  priceLikeNoCase?: InputMaybe<Scalars['Float']>;
  priceLt?: InputMaybe<Scalars['Float']>;
  priceLte?: InputMaybe<Scalars['Float']>;
  priceNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLOffersDomainOffersArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainOffersPropertiesEnum>;
  placements?: InputMaybe<Scalars['JSON']>;
  placementsAny?: InputMaybe<Scalars['JSON']>;
  placementsContain?: InputMaybe<Scalars['JSON']>;
  placementsEq?: InputMaybe<Scalars['JSON']>;
  placementsGt?: InputMaybe<Scalars['JSON']>;
  placementsGte?: InputMaybe<Scalars['JSON']>;
  placementsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  placementsIsNull?: InputMaybe<Scalars['Boolean']>;
  placementsLike?: InputMaybe<Scalars['JSON']>;
  placementsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  placementsLt?: InputMaybe<Scalars['JSON']>;
  placementsLte?: InputMaybe<Scalars['JSON']>;
  placementsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  sticky?: InputMaybe<Scalars['Boolean']>;
  stickyAny?: InputMaybe<Scalars['Boolean']>;
  stickyContain?: InputMaybe<Scalars['Boolean']>;
  stickyEq?: InputMaybe<Scalars['Boolean']>;
  stickyGt?: InputMaybe<Scalars['Boolean']>;
  stickyGte?: InputMaybe<Scalars['Boolean']>;
  stickyIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  stickyIsNull?: InputMaybe<Scalars['Boolean']>;
  stickyLike?: InputMaybe<Scalars['Boolean']>;
  stickyLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  stickyLt?: InputMaybe<Scalars['Boolean']>;
  stickyLte?: InputMaybe<Scalars['Boolean']>;
  stickyNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLOffersDomainsArgs = {
  allowedLanguages?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesAny?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesContain?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesEq?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  allowedLanguagesIsNull?: InputMaybe<Scalars['Boolean']>;
  allowedLanguagesLike?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  analyticsCodeId?: InputMaybe<Scalars['String']>;
  analyticsCodeIdAny?: InputMaybe<Scalars['String']>;
  analyticsCodeIdContain?: InputMaybe<Scalars['String']>;
  analyticsCodeIdEq?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  analyticsCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  analyticsCodeIdLike?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cacheSettings?: InputMaybe<Scalars['JSON']>;
  cacheSettingsAny?: InputMaybe<Scalars['JSON']>;
  cacheSettingsContain?: InputMaybe<Scalars['JSON']>;
  cacheSettingsEq?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  cacheSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  cacheSettingsLike?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  clickyCodeId?: InputMaybe<Scalars['String']>;
  clickyCodeIdAny?: InputMaybe<Scalars['String']>;
  clickyCodeIdContain?: InputMaybe<Scalars['String']>;
  clickyCodeIdEq?: InputMaybe<Scalars['String']>;
  clickyCodeIdGt?: InputMaybe<Scalars['String']>;
  clickyCodeIdGte?: InputMaybe<Scalars['String']>;
  clickyCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clickyCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  clickyCodeIdLike?: InputMaybe<Scalars['String']>;
  clickyCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  clickyCodeIdLt?: InputMaybe<Scalars['String']>;
  clickyCodeIdLte?: InputMaybe<Scalars['String']>;
  clickyCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  enableChatWidget?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetAny?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetContain?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetEq?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableChatWidgetIsNull?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLike?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaId?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdAny?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdContain?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdEq?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLike?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedForm?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormAny?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormContain?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormEq?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedFormIsNull?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLike?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  facebookConversionAPISettings?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsAny?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsContain?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsEq?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookConversionAPISettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookConversionAPISettingsLike?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookSiteVerificationCode?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fallbackSettings?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsAny?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsContain?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsEq?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  fallbackSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  fallbackSettingsLike?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  faviconId?: InputMaybe<Scalars['String']>;
  faviconIdAny?: InputMaybe<Scalars['String']>;
  faviconIdContain?: InputMaybe<Scalars['String']>;
  faviconIdEq?: InputMaybe<Scalars['String']>;
  faviconIdGt?: InputMaybe<Scalars['String']>;
  faviconIdGte?: InputMaybe<Scalars['String']>;
  faviconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  faviconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  faviconIdLike?: InputMaybe<Scalars['String']>;
  faviconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  faviconIdLt?: InputMaybe<Scalars['String']>;
  faviconIdLte?: InputMaybe<Scalars['String']>;
  faviconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCode?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  googleSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmId?: InputMaybe<Scalars['String']>;
  gtmIdAny?: InputMaybe<Scalars['String']>;
  gtmIdContain?: InputMaybe<Scalars['String']>;
  gtmIdEq?: InputMaybe<Scalars['String']>;
  gtmIdGt?: InputMaybe<Scalars['String']>;
  gtmIdGte?: InputMaybe<Scalars['String']>;
  gtmIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmIdIsNull?: InputMaybe<Scalars['Boolean']>;
  gtmIdLike?: InputMaybe<Scalars['String']>;
  gtmIdLikeNoCase?: InputMaybe<Scalars['String']>;
  gtmIdLt?: InputMaybe<Scalars['String']>;
  gtmIdLte?: InputMaybe<Scalars['String']>;
  gtmIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  holdingRules?: InputMaybe<Scalars['JSON']>;
  holdingRulesAny?: InputMaybe<Scalars['JSON']>;
  holdingRulesContain?: InputMaybe<Scalars['JSON']>;
  holdingRulesEq?: InputMaybe<Scalars['JSON']>;
  holdingRulesGt?: InputMaybe<Scalars['JSON']>;
  holdingRulesGte?: InputMaybe<Scalars['JSON']>;
  holdingRulesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  holdingRulesIsNull?: InputMaybe<Scalars['Boolean']>;
  holdingRulesLike?: InputMaybe<Scalars['JSON']>;
  holdingRulesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  holdingRulesLt?: InputMaybe<Scalars['JSON']>;
  holdingRulesLte?: InputMaybe<Scalars['JSON']>;
  holdingRulesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabled?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledAny?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledContain?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledEq?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabledIsNull?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLike?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainsPropertiesEnum>;
  otpVerificationCriteria?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaAny?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaContain?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaEq?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  otpVerificationCriteriaIsNull?: InputMaybe<Scalars['Boolean']>;
  otpVerificationCriteriaLike?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfig?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigAny?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigContain?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigEq?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  recaptchaConfigLike?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  secondaryLogoId?: InputMaybe<Scalars['String']>;
  secondaryLogoIdAny?: InputMaybe<Scalars['String']>;
  secondaryLogoIdContain?: InputMaybe<Scalars['String']>;
  secondaryLogoIdEq?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondaryLogoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  secondaryLogoIdLike?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sendNotifications?: InputMaybe<Scalars['JSON']>;
  sendNotificationsAny?: InputMaybe<Scalars['JSON']>;
  sendNotificationsContain?: InputMaybe<Scalars['JSON']>;
  sendNotificationsEq?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  sendNotificationsIsNull?: InputMaybe<Scalars['Boolean']>;
  sendNotificationsLike?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settings?: InputMaybe<Scalars['JSON']>;
  settingsAny?: InputMaybe<Scalars['JSON']>;
  settingsContain?: InputMaybe<Scalars['JSON']>;
  settingsEq?: InputMaybe<Scalars['JSON']>;
  settingsGt?: InputMaybe<Scalars['JSON']>;
  settingsGte?: InputMaybe<Scalars['JSON']>;
  settingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settingsIsNull?: InputMaybe<Scalars['Boolean']>;
  settingsLike?: InputMaybe<Scalars['JSON']>;
  settingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  settingsLt?: InputMaybe<Scalars['JSON']>;
  settingsLte?: InputMaybe<Scalars['JSON']>;
  settingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  slogan?: InputMaybe<Scalars['String']>;
  sloganAny?: InputMaybe<Scalars['String']>;
  sloganContain?: InputMaybe<Scalars['String']>;
  sloganEq?: InputMaybe<Scalars['String']>;
  sloganGt?: InputMaybe<Scalars['String']>;
  sloganGte?: InputMaybe<Scalars['String']>;
  sloganIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sloganIsNull?: InputMaybe<Scalars['Boolean']>;
  sloganLike?: InputMaybe<Scalars['String']>;
  sloganLikeNoCase?: InputMaybe<Scalars['String']>;
  sloganLt?: InputMaybe<Scalars['String']>;
  sloganLte?: InputMaybe<Scalars['String']>;
  sloganNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateConfig?: InputMaybe<Scalars['JSON']>;
  templateConfigAny?: InputMaybe<Scalars['JSON']>;
  templateConfigContain?: InputMaybe<Scalars['JSON']>;
  templateConfigEq?: InputMaybe<Scalars['JSON']>;
  templateConfigGt?: InputMaybe<Scalars['JSON']>;
  templateConfigGte?: InputMaybe<Scalars['JSON']>;
  templateConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  templateConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  templateConfigLike?: InputMaybe<Scalars['JSON']>;
  templateConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  templateConfigLt?: InputMaybe<Scalars['JSON']>;
  templateConfigLte?: InputMaybe<Scalars['JSON']>;
  templateConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixel?: InputMaybe<Scalars['String']>;
  twitterPixelAny?: InputMaybe<Scalars['String']>;
  twitterPixelContain?: InputMaybe<Scalars['String']>;
  twitterPixelEq?: InputMaybe<Scalars['String']>;
  twitterPixelGt?: InputMaybe<Scalars['String']>;
  twitterPixelGte?: InputMaybe<Scalars['String']>;
  twitterPixelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixelIsNull?: InputMaybe<Scalars['Boolean']>;
  twitterPixelLike?: InputMaybe<Scalars['String']>;
  twitterPixelLikeNoCase?: InputMaybe<Scalars['String']>;
  twitterPixelLt?: InputMaybe<Scalars['String']>;
  twitterPixelLte?: InputMaybe<Scalars['String']>;
  twitterPixelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLOffersEditorUserArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLOffersFaqsArgs = {
  answer?: InputMaybe<Scalars['String']>;
  answerAny?: InputMaybe<Scalars['String']>;
  answerContain?: InputMaybe<Scalars['String']>;
  answerEq?: InputMaybe<Scalars['String']>;
  answerGt?: InputMaybe<Scalars['String']>;
  answerGte?: InputMaybe<Scalars['String']>;
  answerIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  answerIsNull?: InputMaybe<Scalars['Boolean']>;
  answerLike?: InputMaybe<Scalars['String']>;
  answerLikeNoCase?: InputMaybe<Scalars['String']>;
  answerLt?: InputMaybe<Scalars['String']>;
  answerLte?: InputMaybe<Scalars['String']>;
  answerNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedByAny?: InputMaybe<Scalars['String']>;
  deletedByContain?: InputMaybe<Scalars['String']>;
  deletedByEq?: InputMaybe<Scalars['String']>;
  deletedByGt?: InputMaybe<Scalars['String']>;
  deletedByGte?: InputMaybe<Scalars['String']>;
  deletedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedByIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedByLike?: InputMaybe<Scalars['String']>;
  deletedByLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedByLt?: InputMaybe<Scalars['String']>;
  deletedByLte?: InputMaybe<Scalars['String']>;
  deletedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLFaqsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLFaqsPropertiesEnum>;
  question?: InputMaybe<Scalars['String']>;
  questionAny?: InputMaybe<Scalars['String']>;
  questionContain?: InputMaybe<Scalars['String']>;
  questionEq?: InputMaybe<Scalars['String']>;
  questionGt?: InputMaybe<Scalars['String']>;
  questionGte?: InputMaybe<Scalars['String']>;
  questionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionIsNull?: InputMaybe<Scalars['Boolean']>;
  questionLike?: InputMaybe<Scalars['String']>;
  questionLikeNoCase?: InputMaybe<Scalars['String']>;
  questionLt?: InputMaybe<Scalars['String']>;
  questionLte?: InputMaybe<Scalars['String']>;
  questionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLOffersFeaturesArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLOfferFeaturesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOfferFeaturesPropertiesEnum>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLOffersImageArgs = {
  access?: InputMaybe<Scalars['String']>;
  accessAny?: InputMaybe<Scalars['String']>;
  accessContain?: InputMaybe<Scalars['String']>;
  accessEq?: InputMaybe<Scalars['String']>;
  accessGt?: InputMaybe<Scalars['String']>;
  accessGte?: InputMaybe<Scalars['String']>;
  accessIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accessIsNull?: InputMaybe<Scalars['Boolean']>;
  accessLike?: InputMaybe<Scalars['String']>;
  accessLikeNoCase?: InputMaybe<Scalars['String']>;
  accessLt?: InputMaybe<Scalars['String']>;
  accessLte?: InputMaybe<Scalars['String']>;
  accessNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alt?: InputMaybe<Scalars['String']>;
  altAny?: InputMaybe<Scalars['String']>;
  altContain?: InputMaybe<Scalars['String']>;
  altEq?: InputMaybe<Scalars['String']>;
  altGt?: InputMaybe<Scalars['String']>;
  altGte?: InputMaybe<Scalars['String']>;
  altIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  altIsNull?: InputMaybe<Scalars['Boolean']>;
  altLike?: InputMaybe<Scalars['String']>;
  altLikeNoCase?: InputMaybe<Scalars['String']>;
  altLt?: InputMaybe<Scalars['String']>;
  altLte?: InputMaybe<Scalars['String']>;
  altNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caption?: InputMaybe<Scalars['String']>;
  captionAny?: InputMaybe<Scalars['String']>;
  captionContain?: InputMaybe<Scalars['String']>;
  captionEq?: InputMaybe<Scalars['String']>;
  captionGt?: InputMaybe<Scalars['String']>;
  captionGte?: InputMaybe<Scalars['String']>;
  captionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  captionIsNull?: InputMaybe<Scalars['Boolean']>;
  captionLike?: InputMaybe<Scalars['String']>;
  captionLikeNoCase?: InputMaybe<Scalars['String']>;
  captionLt?: InputMaybe<Scalars['String']>;
  captionLte?: InputMaybe<Scalars['String']>;
  captionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fullPath?: InputMaybe<Scalars['String']>;
  fullPathAny?: InputMaybe<Scalars['String']>;
  fullPathContain?: InputMaybe<Scalars['String']>;
  fullPathEq?: InputMaybe<Scalars['String']>;
  fullPathGt?: InputMaybe<Scalars['String']>;
  fullPathGte?: InputMaybe<Scalars['String']>;
  fullPathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullPathIsNull?: InputMaybe<Scalars['Boolean']>;
  fullPathLike?: InputMaybe<Scalars['String']>;
  fullPathLikeNoCase?: InputMaybe<Scalars['String']>;
  fullPathLt?: InputMaybe<Scalars['String']>;
  fullPathLte?: InputMaybe<Scalars['String']>;
  fullPathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mimeType?: InputMaybe<Scalars['String']>;
  mimeTypeAny?: InputMaybe<Scalars['String']>;
  mimeTypeContain?: InputMaybe<Scalars['String']>;
  mimeTypeEq?: InputMaybe<Scalars['String']>;
  mimeTypeGt?: InputMaybe<Scalars['String']>;
  mimeTypeGte?: InputMaybe<Scalars['String']>;
  mimeTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mimeTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  mimeTypeLike?: InputMaybe<Scalars['String']>;
  mimeTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  mimeTypeLt?: InputMaybe<Scalars['String']>;
  mimeTypeLte?: InputMaybe<Scalars['String']>;
  mimeTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  originalName?: InputMaybe<Scalars['String']>;
  originalNameAny?: InputMaybe<Scalars['String']>;
  originalNameContain?: InputMaybe<Scalars['String']>;
  originalNameEq?: InputMaybe<Scalars['String']>;
  originalNameGt?: InputMaybe<Scalars['String']>;
  originalNameGte?: InputMaybe<Scalars['String']>;
  originalNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  originalNameIsNull?: InputMaybe<Scalars['Boolean']>;
  originalNameLike?: InputMaybe<Scalars['String']>;
  originalNameLikeNoCase?: InputMaybe<Scalars['String']>;
  originalNameLt?: InputMaybe<Scalars['String']>;
  originalNameLte?: InputMaybe<Scalars['String']>;
  originalNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  path?: InputMaybe<Scalars['String']>;
  pathAny?: InputMaybe<Scalars['String']>;
  pathContain?: InputMaybe<Scalars['String']>;
  pathEq?: InputMaybe<Scalars['String']>;
  pathGt?: InputMaybe<Scalars['String']>;
  pathGte?: InputMaybe<Scalars['String']>;
  pathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pathIsNull?: InputMaybe<Scalars['Boolean']>;
  pathLike?: InputMaybe<Scalars['String']>;
  pathLikeNoCase?: InputMaybe<Scalars['String']>;
  pathLt?: InputMaybe<Scalars['String']>;
  pathLte?: InputMaybe<Scalars['String']>;
  pathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  size?: InputMaybe<Scalars['Int']>;
  sizeAny?: InputMaybe<Scalars['Int']>;
  sizeContain?: InputMaybe<Scalars['Int']>;
  sizeEq?: InputMaybe<Scalars['Int']>;
  sizeGt?: InputMaybe<Scalars['Int']>;
  sizeGte?: InputMaybe<Scalars['Int']>;
  sizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sizeLike?: InputMaybe<Scalars['Int']>;
  sizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sizeLt?: InputMaybe<Scalars['Int']>;
  sizeLte?: InputMaybe<Scalars['Int']>;
  sizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLOffersLogoArgs = {
  access?: InputMaybe<Scalars['String']>;
  accessAny?: InputMaybe<Scalars['String']>;
  accessContain?: InputMaybe<Scalars['String']>;
  accessEq?: InputMaybe<Scalars['String']>;
  accessGt?: InputMaybe<Scalars['String']>;
  accessGte?: InputMaybe<Scalars['String']>;
  accessIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accessIsNull?: InputMaybe<Scalars['Boolean']>;
  accessLike?: InputMaybe<Scalars['String']>;
  accessLikeNoCase?: InputMaybe<Scalars['String']>;
  accessLt?: InputMaybe<Scalars['String']>;
  accessLte?: InputMaybe<Scalars['String']>;
  accessNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alt?: InputMaybe<Scalars['String']>;
  altAny?: InputMaybe<Scalars['String']>;
  altContain?: InputMaybe<Scalars['String']>;
  altEq?: InputMaybe<Scalars['String']>;
  altGt?: InputMaybe<Scalars['String']>;
  altGte?: InputMaybe<Scalars['String']>;
  altIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  altIsNull?: InputMaybe<Scalars['Boolean']>;
  altLike?: InputMaybe<Scalars['String']>;
  altLikeNoCase?: InputMaybe<Scalars['String']>;
  altLt?: InputMaybe<Scalars['String']>;
  altLte?: InputMaybe<Scalars['String']>;
  altNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caption?: InputMaybe<Scalars['String']>;
  captionAny?: InputMaybe<Scalars['String']>;
  captionContain?: InputMaybe<Scalars['String']>;
  captionEq?: InputMaybe<Scalars['String']>;
  captionGt?: InputMaybe<Scalars['String']>;
  captionGte?: InputMaybe<Scalars['String']>;
  captionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  captionIsNull?: InputMaybe<Scalars['Boolean']>;
  captionLike?: InputMaybe<Scalars['String']>;
  captionLikeNoCase?: InputMaybe<Scalars['String']>;
  captionLt?: InputMaybe<Scalars['String']>;
  captionLte?: InputMaybe<Scalars['String']>;
  captionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fullPath?: InputMaybe<Scalars['String']>;
  fullPathAny?: InputMaybe<Scalars['String']>;
  fullPathContain?: InputMaybe<Scalars['String']>;
  fullPathEq?: InputMaybe<Scalars['String']>;
  fullPathGt?: InputMaybe<Scalars['String']>;
  fullPathGte?: InputMaybe<Scalars['String']>;
  fullPathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullPathIsNull?: InputMaybe<Scalars['Boolean']>;
  fullPathLike?: InputMaybe<Scalars['String']>;
  fullPathLikeNoCase?: InputMaybe<Scalars['String']>;
  fullPathLt?: InputMaybe<Scalars['String']>;
  fullPathLte?: InputMaybe<Scalars['String']>;
  fullPathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mimeType?: InputMaybe<Scalars['String']>;
  mimeTypeAny?: InputMaybe<Scalars['String']>;
  mimeTypeContain?: InputMaybe<Scalars['String']>;
  mimeTypeEq?: InputMaybe<Scalars['String']>;
  mimeTypeGt?: InputMaybe<Scalars['String']>;
  mimeTypeGte?: InputMaybe<Scalars['String']>;
  mimeTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mimeTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  mimeTypeLike?: InputMaybe<Scalars['String']>;
  mimeTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  mimeTypeLt?: InputMaybe<Scalars['String']>;
  mimeTypeLte?: InputMaybe<Scalars['String']>;
  mimeTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  originalName?: InputMaybe<Scalars['String']>;
  originalNameAny?: InputMaybe<Scalars['String']>;
  originalNameContain?: InputMaybe<Scalars['String']>;
  originalNameEq?: InputMaybe<Scalars['String']>;
  originalNameGt?: InputMaybe<Scalars['String']>;
  originalNameGte?: InputMaybe<Scalars['String']>;
  originalNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  originalNameIsNull?: InputMaybe<Scalars['Boolean']>;
  originalNameLike?: InputMaybe<Scalars['String']>;
  originalNameLikeNoCase?: InputMaybe<Scalars['String']>;
  originalNameLt?: InputMaybe<Scalars['String']>;
  originalNameLte?: InputMaybe<Scalars['String']>;
  originalNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  path?: InputMaybe<Scalars['String']>;
  pathAny?: InputMaybe<Scalars['String']>;
  pathContain?: InputMaybe<Scalars['String']>;
  pathEq?: InputMaybe<Scalars['String']>;
  pathGt?: InputMaybe<Scalars['String']>;
  pathGte?: InputMaybe<Scalars['String']>;
  pathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pathIsNull?: InputMaybe<Scalars['Boolean']>;
  pathLike?: InputMaybe<Scalars['String']>;
  pathLikeNoCase?: InputMaybe<Scalars['String']>;
  pathLt?: InputMaybe<Scalars['String']>;
  pathLte?: InputMaybe<Scalars['String']>;
  pathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  size?: InputMaybe<Scalars['Int']>;
  sizeAny?: InputMaybe<Scalars['Int']>;
  sizeContain?: InputMaybe<Scalars['Int']>;
  sizeEq?: InputMaybe<Scalars['Int']>;
  sizeGt?: InputMaybe<Scalars['Int']>;
  sizeGte?: InputMaybe<Scalars['Int']>;
  sizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sizeLike?: InputMaybe<Scalars['Int']>;
  sizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sizeLt?: InputMaybe<Scalars['Int']>;
  sizeLte?: InputMaybe<Scalars['Int']>;
  sizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLOffersMainImageArgs = {
  access?: InputMaybe<Scalars['String']>;
  accessAny?: InputMaybe<Scalars['String']>;
  accessContain?: InputMaybe<Scalars['String']>;
  accessEq?: InputMaybe<Scalars['String']>;
  accessGt?: InputMaybe<Scalars['String']>;
  accessGte?: InputMaybe<Scalars['String']>;
  accessIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accessIsNull?: InputMaybe<Scalars['Boolean']>;
  accessLike?: InputMaybe<Scalars['String']>;
  accessLikeNoCase?: InputMaybe<Scalars['String']>;
  accessLt?: InputMaybe<Scalars['String']>;
  accessLte?: InputMaybe<Scalars['String']>;
  accessNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alt?: InputMaybe<Scalars['String']>;
  altAny?: InputMaybe<Scalars['String']>;
  altContain?: InputMaybe<Scalars['String']>;
  altEq?: InputMaybe<Scalars['String']>;
  altGt?: InputMaybe<Scalars['String']>;
  altGte?: InputMaybe<Scalars['String']>;
  altIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  altIsNull?: InputMaybe<Scalars['Boolean']>;
  altLike?: InputMaybe<Scalars['String']>;
  altLikeNoCase?: InputMaybe<Scalars['String']>;
  altLt?: InputMaybe<Scalars['String']>;
  altLte?: InputMaybe<Scalars['String']>;
  altNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caption?: InputMaybe<Scalars['String']>;
  captionAny?: InputMaybe<Scalars['String']>;
  captionContain?: InputMaybe<Scalars['String']>;
  captionEq?: InputMaybe<Scalars['String']>;
  captionGt?: InputMaybe<Scalars['String']>;
  captionGte?: InputMaybe<Scalars['String']>;
  captionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  captionIsNull?: InputMaybe<Scalars['Boolean']>;
  captionLike?: InputMaybe<Scalars['String']>;
  captionLikeNoCase?: InputMaybe<Scalars['String']>;
  captionLt?: InputMaybe<Scalars['String']>;
  captionLte?: InputMaybe<Scalars['String']>;
  captionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fullPath?: InputMaybe<Scalars['String']>;
  fullPathAny?: InputMaybe<Scalars['String']>;
  fullPathContain?: InputMaybe<Scalars['String']>;
  fullPathEq?: InputMaybe<Scalars['String']>;
  fullPathGt?: InputMaybe<Scalars['String']>;
  fullPathGte?: InputMaybe<Scalars['String']>;
  fullPathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullPathIsNull?: InputMaybe<Scalars['Boolean']>;
  fullPathLike?: InputMaybe<Scalars['String']>;
  fullPathLikeNoCase?: InputMaybe<Scalars['String']>;
  fullPathLt?: InputMaybe<Scalars['String']>;
  fullPathLte?: InputMaybe<Scalars['String']>;
  fullPathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mimeType?: InputMaybe<Scalars['String']>;
  mimeTypeAny?: InputMaybe<Scalars['String']>;
  mimeTypeContain?: InputMaybe<Scalars['String']>;
  mimeTypeEq?: InputMaybe<Scalars['String']>;
  mimeTypeGt?: InputMaybe<Scalars['String']>;
  mimeTypeGte?: InputMaybe<Scalars['String']>;
  mimeTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mimeTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  mimeTypeLike?: InputMaybe<Scalars['String']>;
  mimeTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  mimeTypeLt?: InputMaybe<Scalars['String']>;
  mimeTypeLte?: InputMaybe<Scalars['String']>;
  mimeTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  originalName?: InputMaybe<Scalars['String']>;
  originalNameAny?: InputMaybe<Scalars['String']>;
  originalNameContain?: InputMaybe<Scalars['String']>;
  originalNameEq?: InputMaybe<Scalars['String']>;
  originalNameGt?: InputMaybe<Scalars['String']>;
  originalNameGte?: InputMaybe<Scalars['String']>;
  originalNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  originalNameIsNull?: InputMaybe<Scalars['Boolean']>;
  originalNameLike?: InputMaybe<Scalars['String']>;
  originalNameLikeNoCase?: InputMaybe<Scalars['String']>;
  originalNameLt?: InputMaybe<Scalars['String']>;
  originalNameLte?: InputMaybe<Scalars['String']>;
  originalNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  path?: InputMaybe<Scalars['String']>;
  pathAny?: InputMaybe<Scalars['String']>;
  pathContain?: InputMaybe<Scalars['String']>;
  pathEq?: InputMaybe<Scalars['String']>;
  pathGt?: InputMaybe<Scalars['String']>;
  pathGte?: InputMaybe<Scalars['String']>;
  pathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pathIsNull?: InputMaybe<Scalars['Boolean']>;
  pathLike?: InputMaybe<Scalars['String']>;
  pathLikeNoCase?: InputMaybe<Scalars['String']>;
  pathLt?: InputMaybe<Scalars['String']>;
  pathLte?: InputMaybe<Scalars['String']>;
  pathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  size?: InputMaybe<Scalars['Int']>;
  sizeAny?: InputMaybe<Scalars['Int']>;
  sizeContain?: InputMaybe<Scalars['Int']>;
  sizeEq?: InputMaybe<Scalars['Int']>;
  sizeGt?: InputMaybe<Scalars['Int']>;
  sizeGte?: InputMaybe<Scalars['Int']>;
  sizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sizeLike?: InputMaybe<Scalars['Int']>;
  sizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sizeLt?: InputMaybe<Scalars['Int']>;
  sizeLte?: InputMaybe<Scalars['Int']>;
  sizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLOffersMetatagsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  model?: InputMaybe<Scalars['String']>;
  modelAny?: InputMaybe<Scalars['String']>;
  modelContain?: InputMaybe<Scalars['String']>;
  modelEq?: InputMaybe<Scalars['String']>;
  modelGt?: InputMaybe<Scalars['String']>;
  modelGte?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIsNull?: InputMaybe<Scalars['Boolean']>;
  modelLike?: InputMaybe<Scalars['String']>;
  modelLikeNoCase?: InputMaybe<Scalars['String']>;
  modelLt?: InputMaybe<Scalars['String']>;
  modelLte?: InputMaybe<Scalars['String']>;
  modelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLMetatagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLMetatagsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLOffersOfferAttributesArgs = {
  attributeId?: InputMaybe<Scalars['Int']>;
  attributeIdAny?: InputMaybe<Scalars['Int']>;
  attributeIdContain?: InputMaybe<Scalars['Int']>;
  attributeIdEq?: InputMaybe<Scalars['Int']>;
  attributeIdGt?: InputMaybe<Scalars['Int']>;
  attributeIdGte?: InputMaybe<Scalars['Int']>;
  attributeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  attributeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  attributeIdLike?: InputMaybe<Scalars['Int']>;
  attributeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  attributeIdLt?: InputMaybe<Scalars['Int']>;
  attributeIdLte?: InputMaybe<Scalars['Int']>;
  attributeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLCategoryAttributesValuesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoryAttributesValuesPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLOffersProsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLOfferFeaturesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOfferFeaturesPropertiesEnum>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLOffersTaxonomiesArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedByAny?: InputMaybe<Scalars['String']>;
  deletedByContain?: InputMaybe<Scalars['String']>;
  deletedByEq?: InputMaybe<Scalars['String']>;
  deletedByGt?: InputMaybe<Scalars['String']>;
  deletedByGte?: InputMaybe<Scalars['String']>;
  deletedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedByIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedByLike?: InputMaybe<Scalars['String']>;
  deletedByLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedByLt?: InputMaybe<Scalars['String']>;
  deletedByLte?: InputMaybe<Scalars['String']>;
  deletedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTaxonomiesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTaxonomiesPropertiesEnum>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetModel?: InputMaybe<Scalars['String']>;
  targetModelAny?: InputMaybe<Scalars['String']>;
  targetModelContain?: InputMaybe<Scalars['String']>;
  targetModelEq?: InputMaybe<Scalars['String']>;
  targetModelGt?: InputMaybe<Scalars['String']>;
  targetModelGte?: InputMaybe<Scalars['String']>;
  targetModelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetModelIsNull?: InputMaybe<Scalars['Boolean']>;
  targetModelLike?: InputMaybe<Scalars['String']>;
  targetModelLikeNoCase?: InputMaybe<Scalars['String']>;
  targetModelLt?: InputMaybe<Scalars['String']>;
  targetModelLte?: InputMaybe<Scalars['String']>;
  targetModelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCase?: InputMaybe<Scalars['String']>;
  useCaseAny?: InputMaybe<Scalars['String']>;
  useCaseContain?: InputMaybe<Scalars['String']>;
  useCaseEq?: InputMaybe<Scalars['String']>;
  useCaseGt?: InputMaybe<Scalars['String']>;
  useCaseGte?: InputMaybe<Scalars['String']>;
  useCaseIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCaseIsNull?: InputMaybe<Scalars['Boolean']>;
  useCaseLike?: InputMaybe<Scalars['String']>;
  useCaseLikeNoCase?: InputMaybe<Scalars['String']>;
  useCaseLt?: InputMaybe<Scalars['String']>;
  useCaseLte?: InputMaybe<Scalars['String']>;
  useCaseNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLOffersTopicsArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerpt?: InputMaybe<Scalars['String']>;
  excerptAny?: InputMaybe<Scalars['String']>;
  excerptContain?: InputMaybe<Scalars['String']>;
  excerptEq?: InputMaybe<Scalars['String']>;
  excerptGt?: InputMaybe<Scalars['String']>;
  excerptGte?: InputMaybe<Scalars['String']>;
  excerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerptIsNull?: InputMaybe<Scalars['Boolean']>;
  excerptLike?: InputMaybe<Scalars['String']>;
  excerptLikeNoCase?: InputMaybe<Scalars['String']>;
  excerptLt?: InputMaybe<Scalars['String']>;
  excerptLte?: InputMaybe<Scalars['String']>;
  excerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featured?: InputMaybe<Scalars['Boolean']>;
  featuredAny?: InputMaybe<Scalars['Boolean']>;
  featuredContain?: InputMaybe<Scalars['Boolean']>;
  featuredEq?: InputMaybe<Scalars['Boolean']>;
  featuredGt?: InputMaybe<Scalars['Boolean']>;
  featuredGte?: InputMaybe<Scalars['Boolean']>;
  featuredIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  featuredIsNull?: InputMaybe<Scalars['Boolean']>;
  featuredLike?: InputMaybe<Scalars['Boolean']>;
  featuredLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  featuredLt?: InputMaybe<Scalars['Boolean']>;
  featuredLte?: InputMaybe<Scalars['Boolean']>;
  featuredNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  fullBody?: InputMaybe<Scalars['String']>;
  fullBodyAny?: InputMaybe<Scalars['String']>;
  fullBodyContain?: InputMaybe<Scalars['String']>;
  fullBodyEq?: InputMaybe<Scalars['String']>;
  fullBodyGt?: InputMaybe<Scalars['String']>;
  fullBodyGte?: InputMaybe<Scalars['String']>;
  fullBodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullBodyIsNull?: InputMaybe<Scalars['Boolean']>;
  fullBodyLike?: InputMaybe<Scalars['String']>;
  fullBodyLikeNoCase?: InputMaybe<Scalars['String']>;
  fullBodyLt?: InputMaybe<Scalars['String']>;
  fullBodyLte?: InputMaybe<Scalars['String']>;
  fullBodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldExcerpt?: InputMaybe<Scalars['String']>;
  oldExcerptAny?: InputMaybe<Scalars['String']>;
  oldExcerptContain?: InputMaybe<Scalars['String']>;
  oldExcerptEq?: InputMaybe<Scalars['String']>;
  oldExcerptGt?: InputMaybe<Scalars['String']>;
  oldExcerptGte?: InputMaybe<Scalars['String']>;
  oldExcerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldExcerptIsNull?: InputMaybe<Scalars['Boolean']>;
  oldExcerptLike?: InputMaybe<Scalars['String']>;
  oldExcerptLikeNoCase?: InputMaybe<Scalars['String']>;
  oldExcerptLt?: InputMaybe<Scalars['String']>;
  oldExcerptLte?: InputMaybe<Scalars['String']>;
  oldExcerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLPostsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLPostsPropertiesEnum>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedAny?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['String']>;
  publishedAtAny?: InputMaybe<Scalars['String']>;
  publishedAtContain?: InputMaybe<Scalars['String']>;
  publishedAtEq?: InputMaybe<Scalars['String']>;
  publishedAtGt?: InputMaybe<Scalars['String']>;
  publishedAtGte?: InputMaybe<Scalars['String']>;
  publishedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedAtLike?: InputMaybe<Scalars['String']>;
  publishedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  publishedAtLt?: InputMaybe<Scalars['String']>;
  publishedAtLte?: InputMaybe<Scalars['String']>;
  publishedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedContain?: InputMaybe<Scalars['Boolean']>;
  publishedEq?: InputMaybe<Scalars['Boolean']>;
  publishedGt?: InputMaybe<Scalars['Boolean']>;
  publishedGte?: InputMaybe<Scalars['Boolean']>;
  publishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  publishedIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedLike?: InputMaybe<Scalars['Boolean']>;
  publishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  publishedLt?: InputMaybe<Scalars['Boolean']>;
  publishedLte?: InputMaybe<Scalars['Boolean']>;
  publishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Scalars['Int']>;
  typeIdAny?: InputMaybe<Scalars['Int']>;
  typeIdContain?: InputMaybe<Scalars['Int']>;
  typeIdEq?: InputMaybe<Scalars['Int']>;
  typeIdGt?: InputMaybe<Scalars['Int']>;
  typeIdGte?: InputMaybe<Scalars['Int']>;
  typeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  typeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  typeIdLike?: InputMaybe<Scalars['Int']>;
  typeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  typeIdLt?: InputMaybe<Scalars['Int']>;
  typeIdLte?: InputMaybe<Scalars['Int']>;
  typeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLOffersTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};


export type GQLOffersUrlArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMain?: InputMaybe<Scalars['Boolean']>;
  isMainAny?: InputMaybe<Scalars['Boolean']>;
  isMainContain?: InputMaybe<Scalars['Boolean']>;
  isMainEq?: InputMaybe<Scalars['Boolean']>;
  isMainGt?: InputMaybe<Scalars['Boolean']>;
  isMainGte?: InputMaybe<Scalars['Boolean']>;
  isMainIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMainIsNull?: InputMaybe<Scalars['Boolean']>;
  isMainLike?: InputMaybe<Scalars['Boolean']>;
  isMainLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isMainLt?: InputMaybe<Scalars['Boolean']>;
  isMainLte?: InputMaybe<Scalars['Boolean']>;
  isMainNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  meta?: InputMaybe<Scalars['JSON']>;
  metaAny?: InputMaybe<Scalars['JSON']>;
  metaContain?: InputMaybe<Scalars['JSON']>;
  metaEq?: InputMaybe<Scalars['JSON']>;
  metaGt?: InputMaybe<Scalars['JSON']>;
  metaGte?: InputMaybe<Scalars['JSON']>;
  metaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  metaIsNull?: InputMaybe<Scalars['Boolean']>;
  metaLike?: InputMaybe<Scalars['JSON']>;
  metaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  metaLt?: InputMaybe<Scalars['JSON']>;
  metaLte?: InputMaybe<Scalars['JSON']>;
  metaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  model?: InputMaybe<Scalars['String']>;
  modelAny?: InputMaybe<Scalars['String']>;
  modelContain?: InputMaybe<Scalars['String']>;
  modelEq?: InputMaybe<Scalars['String']>;
  modelGt?: InputMaybe<Scalars['String']>;
  modelGte?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['String']>;
  modelIdAny?: InputMaybe<Scalars['String']>;
  modelIdContain?: InputMaybe<Scalars['String']>;
  modelIdEq?: InputMaybe<Scalars['String']>;
  modelIdGt?: InputMaybe<Scalars['String']>;
  modelIdGte?: InputMaybe<Scalars['String']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['String']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['String']>;
  modelIdLt?: InputMaybe<Scalars['String']>;
  modelIdLte?: InputMaybe<Scalars['String']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIsNull?: InputMaybe<Scalars['Boolean']>;
  modelLike?: InputMaybe<Scalars['String']>;
  modelLikeNoCase?: InputMaybe<Scalars['String']>;
  modelLt?: InputMaybe<Scalars['String']>;
  modelLte?: InputMaybe<Scalars['String']>;
  modelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUrlsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUrlsPropertiesEnum>;
  redirectionStatusCode?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeAny?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeContain?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeEq?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  redirectionStatusCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  redirectionStatusCodeLike?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLikeNoCase?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  urlAny?: InputMaybe<Scalars['String']>;
  urlContain?: InputMaybe<Scalars['String']>;
  urlEq?: InputMaybe<Scalars['String']>;
  urlGt?: InputMaybe<Scalars['String']>;
  urlGte?: InputMaybe<Scalars['String']>;
  urlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlIsNull?: InputMaybe<Scalars['Boolean']>;
  urlLike?: InputMaybe<Scalars['String']>;
  urlLikeNoCase?: InputMaybe<Scalars['String']>;
  urlLt?: InputMaybe<Scalars['String']>;
  urlLte?: InputMaybe<Scalars['String']>;
  urlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLOffersUrlsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMain?: InputMaybe<Scalars['Boolean']>;
  isMainAny?: InputMaybe<Scalars['Boolean']>;
  isMainContain?: InputMaybe<Scalars['Boolean']>;
  isMainEq?: InputMaybe<Scalars['Boolean']>;
  isMainGt?: InputMaybe<Scalars['Boolean']>;
  isMainGte?: InputMaybe<Scalars['Boolean']>;
  isMainIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMainIsNull?: InputMaybe<Scalars['Boolean']>;
  isMainLike?: InputMaybe<Scalars['Boolean']>;
  isMainLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isMainLt?: InputMaybe<Scalars['Boolean']>;
  isMainLte?: InputMaybe<Scalars['Boolean']>;
  isMainNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  meta?: InputMaybe<Scalars['JSON']>;
  metaAny?: InputMaybe<Scalars['JSON']>;
  metaContain?: InputMaybe<Scalars['JSON']>;
  metaEq?: InputMaybe<Scalars['JSON']>;
  metaGt?: InputMaybe<Scalars['JSON']>;
  metaGte?: InputMaybe<Scalars['JSON']>;
  metaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  metaIsNull?: InputMaybe<Scalars['Boolean']>;
  metaLike?: InputMaybe<Scalars['JSON']>;
  metaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  metaLt?: InputMaybe<Scalars['JSON']>;
  metaLte?: InputMaybe<Scalars['JSON']>;
  metaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  model?: InputMaybe<Scalars['String']>;
  modelAny?: InputMaybe<Scalars['String']>;
  modelContain?: InputMaybe<Scalars['String']>;
  modelEq?: InputMaybe<Scalars['String']>;
  modelGt?: InputMaybe<Scalars['String']>;
  modelGte?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['String']>;
  modelIdAny?: InputMaybe<Scalars['String']>;
  modelIdContain?: InputMaybe<Scalars['String']>;
  modelIdEq?: InputMaybe<Scalars['String']>;
  modelIdGt?: InputMaybe<Scalars['String']>;
  modelIdGte?: InputMaybe<Scalars['String']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['String']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['String']>;
  modelIdLt?: InputMaybe<Scalars['String']>;
  modelIdLte?: InputMaybe<Scalars['String']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIsNull?: InputMaybe<Scalars['Boolean']>;
  modelLike?: InputMaybe<Scalars['String']>;
  modelLikeNoCase?: InputMaybe<Scalars['String']>;
  modelLt?: InputMaybe<Scalars['String']>;
  modelLte?: InputMaybe<Scalars['String']>;
  modelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUrlsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUrlsPropertiesEnum>;
  redirectionStatusCode?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeAny?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeContain?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeEq?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  redirectionStatusCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  redirectionStatusCodeLike?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLikeNoCase?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  urlAny?: InputMaybe<Scalars['String']>;
  urlContain?: InputMaybe<Scalars['String']>;
  urlEq?: InputMaybe<Scalars['String']>;
  urlGt?: InputMaybe<Scalars['String']>;
  urlGte?: InputMaybe<Scalars['String']>;
  urlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlIsNull?: InputMaybe<Scalars['Boolean']>;
  urlLike?: InputMaybe<Scalars['String']>;
  urlLikeNoCase?: InputMaybe<Scalars['String']>;
  urlLt?: InputMaybe<Scalars['String']>;
  urlLte?: InputMaybe<Scalars['String']>;
  urlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLOffersWorkingHoursArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLOfferSchedulesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOfferSchedulesPropertiesEnum>;
  schedule?: InputMaybe<Scalars['JSON']>;
  scheduleAny?: InputMaybe<Scalars['JSON']>;
  scheduleContain?: InputMaybe<Scalars['JSON']>;
  scheduleEq?: InputMaybe<Scalars['JSON']>;
  scheduleGt?: InputMaybe<Scalars['JSON']>;
  scheduleGte?: InputMaybe<Scalars['JSON']>;
  scheduleIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  scheduleIsNull?: InputMaybe<Scalars['Boolean']>;
  scheduleLike?: InputMaybe<Scalars['JSON']>;
  scheduleLikeNoCase?: InputMaybe<Scalars['JSON']>;
  scheduleLt?: InputMaybe<Scalars['JSON']>;
  scheduleLte?: InputMaybe<Scalars['JSON']>;
  scheduleNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  timeZone?: InputMaybe<Scalars['String']>;
  timeZoneAny?: InputMaybe<Scalars['String']>;
  timeZoneContain?: InputMaybe<Scalars['String']>;
  timeZoneEq?: InputMaybe<Scalars['String']>;
  timeZoneGt?: InputMaybe<Scalars['String']>;
  timeZoneGte?: InputMaybe<Scalars['String']>;
  timeZoneIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  timeZoneIsNull?: InputMaybe<Scalars['Boolean']>;
  timeZoneLike?: InputMaybe<Scalars['String']>;
  timeZoneLikeNoCase?: InputMaybe<Scalars['String']>;
  timeZoneLt?: InputMaybe<Scalars['String']>;
  timeZoneLte?: InputMaybe<Scalars['String']>;
  timeZoneNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLOffersWriterUserArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLOffersPropertiesEnum {
  Body = 'body',
  CheckWallet = 'checkWallet',
  CreatedAt = 'createdAt',
  DefaultAffiliateLinkId = 'defaultAffiliateLinkId',
  Description = 'description',
  DisplayUrl = 'displayUrl',
  EditedBy = 'editedBy',
  ExternalData = 'externalData',
  FeaturesListTitle = 'featuresListTitle',
  Id = 'id',
  ImageId = 'imageId',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  IsPaused = 'isPaused',
  Languages = 'languages',
  LogoId = 'logoId',
  MainImageId = 'mainImageId',
  Name = 'name',
  OldOverview = 'oldOverview',
  Overview = 'overview',
  PreviewDescription = 'previewDescription',
  QuickOverview = 'quickOverview',
  Score = 'score',
  ScoreMessage = 'scoreMessage',
  Slug = 'slug',
  SlugAlias = 'slugAlias',
  Source = 'source',
  SubTitle = 'subTitle',
  SummaryDescription = 'summaryDescription',
  SummaryTitle = 'summaryTitle',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  UserId = 'userId',
  Weight = 'weight',
  WrittenBy = 'writtenBy'
}

export type GQLPersonalIdentifiableInformation = {
  __typename?: 'PersonalIdentifiableInformation';
  aliasPhoneNumber?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  dma?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  ipAddress?: Maybe<Scalars['String']>;
  isBizEmail?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  litigator?: Maybe<Scalars['Boolean']>;
  metaData?: Maybe<Scalars['String']>;
  modifiedAt?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  nationalDnc?: Maybe<Scalars['Boolean']>;
  oldPhoneNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberType?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
  stateDnc?: Maybe<Scalars['Boolean']>;
  streetAddress?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
  zipCode?: Maybe<Scalars['String']>;
};

export enum GQLPersonalIdentifiableInformationPropertiesEnum {
  AliasPhoneNumber = 'aliasPhoneNumber',
  Birthdate = 'birthdate',
  City = 'city',
  Country = 'country',
  County = 'county',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Dma = 'dma',
  Email = 'email',
  FirstName = 'firstName',
  Id = 'id',
  IpAddress = 'ipAddress',
  IsBizEmail = 'isBizEmail',
  IsDeleted = 'isDeleted',
  LastName = 'lastName',
  Litigator = 'litigator',
  MetaData = 'metaData',
  ModifiedAt = 'modifiedAt',
  ModifiedBy = 'modifiedBy',
  NationalDnc = 'nationalDnc',
  OldPhoneNumber = 'oldPhoneNumber',
  PhoneNumber = 'phoneNumber',
  PhoneNumberType = 'phoneNumberType',
  State = 'state',
  StateCode = 'stateCode',
  StateDnc = 'stateDnc',
  StreetAddress = 'streetAddress',
  UpdatedAt = 'updatedAt',
  Verified = 'verified',
  ZipCode = 'zipCode'
}

export type GQLPostTags = {
  __typename?: 'PostTags';
  createdAt?: Maybe<Scalars['String']>;
  fullBody?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  postId?: Maybe<Scalars['Int']>;
  tagId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export enum GQLPostTagsPropertiesEnum {
  CreatedAt = 'createdAt',
  FullBody = 'fullBody',
  Id = 'id',
  IsDeleted = 'isDeleted',
  PostId = 'postId',
  TagId = 'tagId',
  UpdatedAt = 'updatedAt'
}

export type GQLPosts = {
  __typename?: 'Posts';
  body?: Maybe<Scalars['String']>;
  category?: Maybe<GQLCategories>;
  categoryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  domain?: Maybe<GQLDomains>;
  domainId?: Maybe<Scalars['Int']>;
  editedBy?: Maybe<Scalars['String']>;
  editorUser?: Maybe<GQLUsers>;
  excerpt?: Maybe<Scalars['String']>;
  featured?: Maybe<Scalars['Boolean']>;
  fullBody?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<GQLAttachments>;
  imageId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Scalars['JSON']>;
  lastUpdatedBy?: Maybe<GQLUsers>;
  metatags?: Maybe<Array<Maybe<GQLMetatags>>>;
  oldExcerpt?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  publishedAt?: Maybe<Scalars['String']>;
  related?: Maybe<Array<Maybe<GQLPosts>>>;
  tags?: Maybe<Array<Maybe<GQLTags>>>;
  taxonomies?: Maybe<Array<Maybe<GQLTaxonomies>>>;
  title?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  type?: Maybe<GQLLookups>;
  typeId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  url?: Maybe<GQLUrls>;
  urls?: Maybe<Array<Maybe<GQLUrls>>>;
  user?: Maybe<GQLUsers>;
  userId?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
  writerUser?: Maybe<GQLUsers>;
  writtenBy?: Maybe<Scalars['String']>;
};


export type GQLPostsCategoryArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLPostsDomainArgs = {
  allowedLanguages?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesAny?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesContain?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesEq?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  allowedLanguagesIsNull?: InputMaybe<Scalars['Boolean']>;
  allowedLanguagesLike?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  analyticsCodeId?: InputMaybe<Scalars['String']>;
  analyticsCodeIdAny?: InputMaybe<Scalars['String']>;
  analyticsCodeIdContain?: InputMaybe<Scalars['String']>;
  analyticsCodeIdEq?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  analyticsCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  analyticsCodeIdLike?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cacheSettings?: InputMaybe<Scalars['JSON']>;
  cacheSettingsAny?: InputMaybe<Scalars['JSON']>;
  cacheSettingsContain?: InputMaybe<Scalars['JSON']>;
  cacheSettingsEq?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  cacheSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  cacheSettingsLike?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  clickyCodeId?: InputMaybe<Scalars['String']>;
  clickyCodeIdAny?: InputMaybe<Scalars['String']>;
  clickyCodeIdContain?: InputMaybe<Scalars['String']>;
  clickyCodeIdEq?: InputMaybe<Scalars['String']>;
  clickyCodeIdGt?: InputMaybe<Scalars['String']>;
  clickyCodeIdGte?: InputMaybe<Scalars['String']>;
  clickyCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clickyCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  clickyCodeIdLike?: InputMaybe<Scalars['String']>;
  clickyCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  clickyCodeIdLt?: InputMaybe<Scalars['String']>;
  clickyCodeIdLte?: InputMaybe<Scalars['String']>;
  clickyCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  enableChatWidget?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetAny?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetContain?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetEq?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableChatWidgetIsNull?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLike?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaId?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdAny?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdContain?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdEq?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLike?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedForm?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormAny?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormContain?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormEq?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedFormIsNull?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLike?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  facebookConversionAPISettings?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsAny?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsContain?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsEq?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookConversionAPISettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookConversionAPISettingsLike?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookSiteVerificationCode?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fallbackSettings?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsAny?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsContain?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsEq?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  fallbackSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  fallbackSettingsLike?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  faviconId?: InputMaybe<Scalars['String']>;
  faviconIdAny?: InputMaybe<Scalars['String']>;
  faviconIdContain?: InputMaybe<Scalars['String']>;
  faviconIdEq?: InputMaybe<Scalars['String']>;
  faviconIdGt?: InputMaybe<Scalars['String']>;
  faviconIdGte?: InputMaybe<Scalars['String']>;
  faviconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  faviconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  faviconIdLike?: InputMaybe<Scalars['String']>;
  faviconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  faviconIdLt?: InputMaybe<Scalars['String']>;
  faviconIdLte?: InputMaybe<Scalars['String']>;
  faviconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCode?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  googleSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmId?: InputMaybe<Scalars['String']>;
  gtmIdAny?: InputMaybe<Scalars['String']>;
  gtmIdContain?: InputMaybe<Scalars['String']>;
  gtmIdEq?: InputMaybe<Scalars['String']>;
  gtmIdGt?: InputMaybe<Scalars['String']>;
  gtmIdGte?: InputMaybe<Scalars['String']>;
  gtmIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmIdIsNull?: InputMaybe<Scalars['Boolean']>;
  gtmIdLike?: InputMaybe<Scalars['String']>;
  gtmIdLikeNoCase?: InputMaybe<Scalars['String']>;
  gtmIdLt?: InputMaybe<Scalars['String']>;
  gtmIdLte?: InputMaybe<Scalars['String']>;
  gtmIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  holdingRules?: InputMaybe<Scalars['JSON']>;
  holdingRulesAny?: InputMaybe<Scalars['JSON']>;
  holdingRulesContain?: InputMaybe<Scalars['JSON']>;
  holdingRulesEq?: InputMaybe<Scalars['JSON']>;
  holdingRulesGt?: InputMaybe<Scalars['JSON']>;
  holdingRulesGte?: InputMaybe<Scalars['JSON']>;
  holdingRulesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  holdingRulesIsNull?: InputMaybe<Scalars['Boolean']>;
  holdingRulesLike?: InputMaybe<Scalars['JSON']>;
  holdingRulesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  holdingRulesLt?: InputMaybe<Scalars['JSON']>;
  holdingRulesLte?: InputMaybe<Scalars['JSON']>;
  holdingRulesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabled?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledAny?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledContain?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledEq?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabledIsNull?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLike?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainsPropertiesEnum>;
  otpVerificationCriteria?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaAny?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaContain?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaEq?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  otpVerificationCriteriaIsNull?: InputMaybe<Scalars['Boolean']>;
  otpVerificationCriteriaLike?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfig?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigAny?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigContain?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigEq?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  recaptchaConfigLike?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  secondaryLogoId?: InputMaybe<Scalars['String']>;
  secondaryLogoIdAny?: InputMaybe<Scalars['String']>;
  secondaryLogoIdContain?: InputMaybe<Scalars['String']>;
  secondaryLogoIdEq?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondaryLogoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  secondaryLogoIdLike?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sendNotifications?: InputMaybe<Scalars['JSON']>;
  sendNotificationsAny?: InputMaybe<Scalars['JSON']>;
  sendNotificationsContain?: InputMaybe<Scalars['JSON']>;
  sendNotificationsEq?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  sendNotificationsIsNull?: InputMaybe<Scalars['Boolean']>;
  sendNotificationsLike?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settings?: InputMaybe<Scalars['JSON']>;
  settingsAny?: InputMaybe<Scalars['JSON']>;
  settingsContain?: InputMaybe<Scalars['JSON']>;
  settingsEq?: InputMaybe<Scalars['JSON']>;
  settingsGt?: InputMaybe<Scalars['JSON']>;
  settingsGte?: InputMaybe<Scalars['JSON']>;
  settingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settingsIsNull?: InputMaybe<Scalars['Boolean']>;
  settingsLike?: InputMaybe<Scalars['JSON']>;
  settingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  settingsLt?: InputMaybe<Scalars['JSON']>;
  settingsLte?: InputMaybe<Scalars['JSON']>;
  settingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  slogan?: InputMaybe<Scalars['String']>;
  sloganAny?: InputMaybe<Scalars['String']>;
  sloganContain?: InputMaybe<Scalars['String']>;
  sloganEq?: InputMaybe<Scalars['String']>;
  sloganGt?: InputMaybe<Scalars['String']>;
  sloganGte?: InputMaybe<Scalars['String']>;
  sloganIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sloganIsNull?: InputMaybe<Scalars['Boolean']>;
  sloganLike?: InputMaybe<Scalars['String']>;
  sloganLikeNoCase?: InputMaybe<Scalars['String']>;
  sloganLt?: InputMaybe<Scalars['String']>;
  sloganLte?: InputMaybe<Scalars['String']>;
  sloganNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateConfig?: InputMaybe<Scalars['JSON']>;
  templateConfigAny?: InputMaybe<Scalars['JSON']>;
  templateConfigContain?: InputMaybe<Scalars['JSON']>;
  templateConfigEq?: InputMaybe<Scalars['JSON']>;
  templateConfigGt?: InputMaybe<Scalars['JSON']>;
  templateConfigGte?: InputMaybe<Scalars['JSON']>;
  templateConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  templateConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  templateConfigLike?: InputMaybe<Scalars['JSON']>;
  templateConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  templateConfigLt?: InputMaybe<Scalars['JSON']>;
  templateConfigLte?: InputMaybe<Scalars['JSON']>;
  templateConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixel?: InputMaybe<Scalars['String']>;
  twitterPixelAny?: InputMaybe<Scalars['String']>;
  twitterPixelContain?: InputMaybe<Scalars['String']>;
  twitterPixelEq?: InputMaybe<Scalars['String']>;
  twitterPixelGt?: InputMaybe<Scalars['String']>;
  twitterPixelGte?: InputMaybe<Scalars['String']>;
  twitterPixelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixelIsNull?: InputMaybe<Scalars['Boolean']>;
  twitterPixelLike?: InputMaybe<Scalars['String']>;
  twitterPixelLikeNoCase?: InputMaybe<Scalars['String']>;
  twitterPixelLt?: InputMaybe<Scalars['String']>;
  twitterPixelLte?: InputMaybe<Scalars['String']>;
  twitterPixelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLPostsEditorUserArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLPostsImageArgs = {
  access?: InputMaybe<Scalars['String']>;
  accessAny?: InputMaybe<Scalars['String']>;
  accessContain?: InputMaybe<Scalars['String']>;
  accessEq?: InputMaybe<Scalars['String']>;
  accessGt?: InputMaybe<Scalars['String']>;
  accessGte?: InputMaybe<Scalars['String']>;
  accessIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accessIsNull?: InputMaybe<Scalars['Boolean']>;
  accessLike?: InputMaybe<Scalars['String']>;
  accessLikeNoCase?: InputMaybe<Scalars['String']>;
  accessLt?: InputMaybe<Scalars['String']>;
  accessLte?: InputMaybe<Scalars['String']>;
  accessNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alt?: InputMaybe<Scalars['String']>;
  altAny?: InputMaybe<Scalars['String']>;
  altContain?: InputMaybe<Scalars['String']>;
  altEq?: InputMaybe<Scalars['String']>;
  altGt?: InputMaybe<Scalars['String']>;
  altGte?: InputMaybe<Scalars['String']>;
  altIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  altIsNull?: InputMaybe<Scalars['Boolean']>;
  altLike?: InputMaybe<Scalars['String']>;
  altLikeNoCase?: InputMaybe<Scalars['String']>;
  altLt?: InputMaybe<Scalars['String']>;
  altLte?: InputMaybe<Scalars['String']>;
  altNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caption?: InputMaybe<Scalars['String']>;
  captionAny?: InputMaybe<Scalars['String']>;
  captionContain?: InputMaybe<Scalars['String']>;
  captionEq?: InputMaybe<Scalars['String']>;
  captionGt?: InputMaybe<Scalars['String']>;
  captionGte?: InputMaybe<Scalars['String']>;
  captionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  captionIsNull?: InputMaybe<Scalars['Boolean']>;
  captionLike?: InputMaybe<Scalars['String']>;
  captionLikeNoCase?: InputMaybe<Scalars['String']>;
  captionLt?: InputMaybe<Scalars['String']>;
  captionLte?: InputMaybe<Scalars['String']>;
  captionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fullPath?: InputMaybe<Scalars['String']>;
  fullPathAny?: InputMaybe<Scalars['String']>;
  fullPathContain?: InputMaybe<Scalars['String']>;
  fullPathEq?: InputMaybe<Scalars['String']>;
  fullPathGt?: InputMaybe<Scalars['String']>;
  fullPathGte?: InputMaybe<Scalars['String']>;
  fullPathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullPathIsNull?: InputMaybe<Scalars['Boolean']>;
  fullPathLike?: InputMaybe<Scalars['String']>;
  fullPathLikeNoCase?: InputMaybe<Scalars['String']>;
  fullPathLt?: InputMaybe<Scalars['String']>;
  fullPathLte?: InputMaybe<Scalars['String']>;
  fullPathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mimeType?: InputMaybe<Scalars['String']>;
  mimeTypeAny?: InputMaybe<Scalars['String']>;
  mimeTypeContain?: InputMaybe<Scalars['String']>;
  mimeTypeEq?: InputMaybe<Scalars['String']>;
  mimeTypeGt?: InputMaybe<Scalars['String']>;
  mimeTypeGte?: InputMaybe<Scalars['String']>;
  mimeTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mimeTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  mimeTypeLike?: InputMaybe<Scalars['String']>;
  mimeTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  mimeTypeLt?: InputMaybe<Scalars['String']>;
  mimeTypeLte?: InputMaybe<Scalars['String']>;
  mimeTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  originalName?: InputMaybe<Scalars['String']>;
  originalNameAny?: InputMaybe<Scalars['String']>;
  originalNameContain?: InputMaybe<Scalars['String']>;
  originalNameEq?: InputMaybe<Scalars['String']>;
  originalNameGt?: InputMaybe<Scalars['String']>;
  originalNameGte?: InputMaybe<Scalars['String']>;
  originalNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  originalNameIsNull?: InputMaybe<Scalars['Boolean']>;
  originalNameLike?: InputMaybe<Scalars['String']>;
  originalNameLikeNoCase?: InputMaybe<Scalars['String']>;
  originalNameLt?: InputMaybe<Scalars['String']>;
  originalNameLte?: InputMaybe<Scalars['String']>;
  originalNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  path?: InputMaybe<Scalars['String']>;
  pathAny?: InputMaybe<Scalars['String']>;
  pathContain?: InputMaybe<Scalars['String']>;
  pathEq?: InputMaybe<Scalars['String']>;
  pathGt?: InputMaybe<Scalars['String']>;
  pathGte?: InputMaybe<Scalars['String']>;
  pathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pathIsNull?: InputMaybe<Scalars['Boolean']>;
  pathLike?: InputMaybe<Scalars['String']>;
  pathLikeNoCase?: InputMaybe<Scalars['String']>;
  pathLt?: InputMaybe<Scalars['String']>;
  pathLte?: InputMaybe<Scalars['String']>;
  pathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  size?: InputMaybe<Scalars['Int']>;
  sizeAny?: InputMaybe<Scalars['Int']>;
  sizeContain?: InputMaybe<Scalars['Int']>;
  sizeEq?: InputMaybe<Scalars['Int']>;
  sizeGt?: InputMaybe<Scalars['Int']>;
  sizeGte?: InputMaybe<Scalars['Int']>;
  sizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sizeLike?: InputMaybe<Scalars['Int']>;
  sizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sizeLt?: InputMaybe<Scalars['Int']>;
  sizeLte?: InputMaybe<Scalars['Int']>;
  sizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLPostsLastUpdatedByArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLPostsMetatagsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  model?: InputMaybe<Scalars['String']>;
  modelAny?: InputMaybe<Scalars['String']>;
  modelContain?: InputMaybe<Scalars['String']>;
  modelEq?: InputMaybe<Scalars['String']>;
  modelGt?: InputMaybe<Scalars['String']>;
  modelGte?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIsNull?: InputMaybe<Scalars['Boolean']>;
  modelLike?: InputMaybe<Scalars['String']>;
  modelLikeNoCase?: InputMaybe<Scalars['String']>;
  modelLt?: InputMaybe<Scalars['String']>;
  modelLte?: InputMaybe<Scalars['String']>;
  modelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLMetatagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLMetatagsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLPostsRelatedArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerpt?: InputMaybe<Scalars['String']>;
  excerptAny?: InputMaybe<Scalars['String']>;
  excerptContain?: InputMaybe<Scalars['String']>;
  excerptEq?: InputMaybe<Scalars['String']>;
  excerptGt?: InputMaybe<Scalars['String']>;
  excerptGte?: InputMaybe<Scalars['String']>;
  excerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerptIsNull?: InputMaybe<Scalars['Boolean']>;
  excerptLike?: InputMaybe<Scalars['String']>;
  excerptLikeNoCase?: InputMaybe<Scalars['String']>;
  excerptLt?: InputMaybe<Scalars['String']>;
  excerptLte?: InputMaybe<Scalars['String']>;
  excerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featured?: InputMaybe<Scalars['Boolean']>;
  featuredAny?: InputMaybe<Scalars['Boolean']>;
  featuredContain?: InputMaybe<Scalars['Boolean']>;
  featuredEq?: InputMaybe<Scalars['Boolean']>;
  featuredGt?: InputMaybe<Scalars['Boolean']>;
  featuredGte?: InputMaybe<Scalars['Boolean']>;
  featuredIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  featuredIsNull?: InputMaybe<Scalars['Boolean']>;
  featuredLike?: InputMaybe<Scalars['Boolean']>;
  featuredLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  featuredLt?: InputMaybe<Scalars['Boolean']>;
  featuredLte?: InputMaybe<Scalars['Boolean']>;
  featuredNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  fullBody?: InputMaybe<Scalars['String']>;
  fullBodyAny?: InputMaybe<Scalars['String']>;
  fullBodyContain?: InputMaybe<Scalars['String']>;
  fullBodyEq?: InputMaybe<Scalars['String']>;
  fullBodyGt?: InputMaybe<Scalars['String']>;
  fullBodyGte?: InputMaybe<Scalars['String']>;
  fullBodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullBodyIsNull?: InputMaybe<Scalars['Boolean']>;
  fullBodyLike?: InputMaybe<Scalars['String']>;
  fullBodyLikeNoCase?: InputMaybe<Scalars['String']>;
  fullBodyLt?: InputMaybe<Scalars['String']>;
  fullBodyLte?: InputMaybe<Scalars['String']>;
  fullBodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldExcerpt?: InputMaybe<Scalars['String']>;
  oldExcerptAny?: InputMaybe<Scalars['String']>;
  oldExcerptContain?: InputMaybe<Scalars['String']>;
  oldExcerptEq?: InputMaybe<Scalars['String']>;
  oldExcerptGt?: InputMaybe<Scalars['String']>;
  oldExcerptGte?: InputMaybe<Scalars['String']>;
  oldExcerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldExcerptIsNull?: InputMaybe<Scalars['Boolean']>;
  oldExcerptLike?: InputMaybe<Scalars['String']>;
  oldExcerptLikeNoCase?: InputMaybe<Scalars['String']>;
  oldExcerptLt?: InputMaybe<Scalars['String']>;
  oldExcerptLte?: InputMaybe<Scalars['String']>;
  oldExcerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLPostsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLPostsPropertiesEnum>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedAny?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['String']>;
  publishedAtAny?: InputMaybe<Scalars['String']>;
  publishedAtContain?: InputMaybe<Scalars['String']>;
  publishedAtEq?: InputMaybe<Scalars['String']>;
  publishedAtGt?: InputMaybe<Scalars['String']>;
  publishedAtGte?: InputMaybe<Scalars['String']>;
  publishedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedAtLike?: InputMaybe<Scalars['String']>;
  publishedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  publishedAtLt?: InputMaybe<Scalars['String']>;
  publishedAtLte?: InputMaybe<Scalars['String']>;
  publishedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedContain?: InputMaybe<Scalars['Boolean']>;
  publishedEq?: InputMaybe<Scalars['Boolean']>;
  publishedGt?: InputMaybe<Scalars['Boolean']>;
  publishedGte?: InputMaybe<Scalars['Boolean']>;
  publishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  publishedIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedLike?: InputMaybe<Scalars['Boolean']>;
  publishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  publishedLt?: InputMaybe<Scalars['Boolean']>;
  publishedLte?: InputMaybe<Scalars['Boolean']>;
  publishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Scalars['Int']>;
  typeIdAny?: InputMaybe<Scalars['Int']>;
  typeIdContain?: InputMaybe<Scalars['Int']>;
  typeIdEq?: InputMaybe<Scalars['Int']>;
  typeIdGt?: InputMaybe<Scalars['Int']>;
  typeIdGte?: InputMaybe<Scalars['Int']>;
  typeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  typeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  typeIdLike?: InputMaybe<Scalars['Int']>;
  typeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  typeIdLt?: InputMaybe<Scalars['Int']>;
  typeIdLte?: InputMaybe<Scalars['Int']>;
  typeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLPostsTagsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLTagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTagsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLPostsTaxonomiesArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedByAny?: InputMaybe<Scalars['String']>;
  deletedByContain?: InputMaybe<Scalars['String']>;
  deletedByEq?: InputMaybe<Scalars['String']>;
  deletedByGt?: InputMaybe<Scalars['String']>;
  deletedByGte?: InputMaybe<Scalars['String']>;
  deletedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedByIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedByLike?: InputMaybe<Scalars['String']>;
  deletedByLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedByLt?: InputMaybe<Scalars['String']>;
  deletedByLte?: InputMaybe<Scalars['String']>;
  deletedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTaxonomiesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTaxonomiesPropertiesEnum>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetModel?: InputMaybe<Scalars['String']>;
  targetModelAny?: InputMaybe<Scalars['String']>;
  targetModelContain?: InputMaybe<Scalars['String']>;
  targetModelEq?: InputMaybe<Scalars['String']>;
  targetModelGt?: InputMaybe<Scalars['String']>;
  targetModelGte?: InputMaybe<Scalars['String']>;
  targetModelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetModelIsNull?: InputMaybe<Scalars['Boolean']>;
  targetModelLike?: InputMaybe<Scalars['String']>;
  targetModelLikeNoCase?: InputMaybe<Scalars['String']>;
  targetModelLt?: InputMaybe<Scalars['String']>;
  targetModelLte?: InputMaybe<Scalars['String']>;
  targetModelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCase?: InputMaybe<Scalars['String']>;
  useCaseAny?: InputMaybe<Scalars['String']>;
  useCaseContain?: InputMaybe<Scalars['String']>;
  useCaseEq?: InputMaybe<Scalars['String']>;
  useCaseGt?: InputMaybe<Scalars['String']>;
  useCaseGte?: InputMaybe<Scalars['String']>;
  useCaseIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCaseIsNull?: InputMaybe<Scalars['Boolean']>;
  useCaseLike?: InputMaybe<Scalars['String']>;
  useCaseLikeNoCase?: InputMaybe<Scalars['String']>;
  useCaseLt?: InputMaybe<Scalars['String']>;
  useCaseLte?: InputMaybe<Scalars['String']>;
  useCaseNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLPostsTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};


export type GQLPostsTypeArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLLookupsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLookupsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLPostsUrlArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMain?: InputMaybe<Scalars['Boolean']>;
  isMainAny?: InputMaybe<Scalars['Boolean']>;
  isMainContain?: InputMaybe<Scalars['Boolean']>;
  isMainEq?: InputMaybe<Scalars['Boolean']>;
  isMainGt?: InputMaybe<Scalars['Boolean']>;
  isMainGte?: InputMaybe<Scalars['Boolean']>;
  isMainIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMainIsNull?: InputMaybe<Scalars['Boolean']>;
  isMainLike?: InputMaybe<Scalars['Boolean']>;
  isMainLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isMainLt?: InputMaybe<Scalars['Boolean']>;
  isMainLte?: InputMaybe<Scalars['Boolean']>;
  isMainNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  meta?: InputMaybe<Scalars['JSON']>;
  metaAny?: InputMaybe<Scalars['JSON']>;
  metaContain?: InputMaybe<Scalars['JSON']>;
  metaEq?: InputMaybe<Scalars['JSON']>;
  metaGt?: InputMaybe<Scalars['JSON']>;
  metaGte?: InputMaybe<Scalars['JSON']>;
  metaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  metaIsNull?: InputMaybe<Scalars['Boolean']>;
  metaLike?: InputMaybe<Scalars['JSON']>;
  metaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  metaLt?: InputMaybe<Scalars['JSON']>;
  metaLte?: InputMaybe<Scalars['JSON']>;
  metaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  model?: InputMaybe<Scalars['String']>;
  modelAny?: InputMaybe<Scalars['String']>;
  modelContain?: InputMaybe<Scalars['String']>;
  modelEq?: InputMaybe<Scalars['String']>;
  modelGt?: InputMaybe<Scalars['String']>;
  modelGte?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['String']>;
  modelIdAny?: InputMaybe<Scalars['String']>;
  modelIdContain?: InputMaybe<Scalars['String']>;
  modelIdEq?: InputMaybe<Scalars['String']>;
  modelIdGt?: InputMaybe<Scalars['String']>;
  modelIdGte?: InputMaybe<Scalars['String']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['String']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['String']>;
  modelIdLt?: InputMaybe<Scalars['String']>;
  modelIdLte?: InputMaybe<Scalars['String']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIsNull?: InputMaybe<Scalars['Boolean']>;
  modelLike?: InputMaybe<Scalars['String']>;
  modelLikeNoCase?: InputMaybe<Scalars['String']>;
  modelLt?: InputMaybe<Scalars['String']>;
  modelLte?: InputMaybe<Scalars['String']>;
  modelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUrlsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUrlsPropertiesEnum>;
  redirectionStatusCode?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeAny?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeContain?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeEq?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  redirectionStatusCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  redirectionStatusCodeLike?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLikeNoCase?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  urlAny?: InputMaybe<Scalars['String']>;
  urlContain?: InputMaybe<Scalars['String']>;
  urlEq?: InputMaybe<Scalars['String']>;
  urlGt?: InputMaybe<Scalars['String']>;
  urlGte?: InputMaybe<Scalars['String']>;
  urlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlIsNull?: InputMaybe<Scalars['Boolean']>;
  urlLike?: InputMaybe<Scalars['String']>;
  urlLikeNoCase?: InputMaybe<Scalars['String']>;
  urlLt?: InputMaybe<Scalars['String']>;
  urlLte?: InputMaybe<Scalars['String']>;
  urlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLPostsUrlsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMain?: InputMaybe<Scalars['Boolean']>;
  isMainAny?: InputMaybe<Scalars['Boolean']>;
  isMainContain?: InputMaybe<Scalars['Boolean']>;
  isMainEq?: InputMaybe<Scalars['Boolean']>;
  isMainGt?: InputMaybe<Scalars['Boolean']>;
  isMainGte?: InputMaybe<Scalars['Boolean']>;
  isMainIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMainIsNull?: InputMaybe<Scalars['Boolean']>;
  isMainLike?: InputMaybe<Scalars['Boolean']>;
  isMainLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isMainLt?: InputMaybe<Scalars['Boolean']>;
  isMainLte?: InputMaybe<Scalars['Boolean']>;
  isMainNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  meta?: InputMaybe<Scalars['JSON']>;
  metaAny?: InputMaybe<Scalars['JSON']>;
  metaContain?: InputMaybe<Scalars['JSON']>;
  metaEq?: InputMaybe<Scalars['JSON']>;
  metaGt?: InputMaybe<Scalars['JSON']>;
  metaGte?: InputMaybe<Scalars['JSON']>;
  metaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  metaIsNull?: InputMaybe<Scalars['Boolean']>;
  metaLike?: InputMaybe<Scalars['JSON']>;
  metaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  metaLt?: InputMaybe<Scalars['JSON']>;
  metaLte?: InputMaybe<Scalars['JSON']>;
  metaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  model?: InputMaybe<Scalars['String']>;
  modelAny?: InputMaybe<Scalars['String']>;
  modelContain?: InputMaybe<Scalars['String']>;
  modelEq?: InputMaybe<Scalars['String']>;
  modelGt?: InputMaybe<Scalars['String']>;
  modelGte?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['String']>;
  modelIdAny?: InputMaybe<Scalars['String']>;
  modelIdContain?: InputMaybe<Scalars['String']>;
  modelIdEq?: InputMaybe<Scalars['String']>;
  modelIdGt?: InputMaybe<Scalars['String']>;
  modelIdGte?: InputMaybe<Scalars['String']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['String']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['String']>;
  modelIdLt?: InputMaybe<Scalars['String']>;
  modelIdLte?: InputMaybe<Scalars['String']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIsNull?: InputMaybe<Scalars['Boolean']>;
  modelLike?: InputMaybe<Scalars['String']>;
  modelLikeNoCase?: InputMaybe<Scalars['String']>;
  modelLt?: InputMaybe<Scalars['String']>;
  modelLte?: InputMaybe<Scalars['String']>;
  modelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUrlsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUrlsPropertiesEnum>;
  redirectionStatusCode?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeAny?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeContain?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeEq?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  redirectionStatusCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  redirectionStatusCodeLike?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLikeNoCase?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  urlAny?: InputMaybe<Scalars['String']>;
  urlContain?: InputMaybe<Scalars['String']>;
  urlEq?: InputMaybe<Scalars['String']>;
  urlGt?: InputMaybe<Scalars['String']>;
  urlGte?: InputMaybe<Scalars['String']>;
  urlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlIsNull?: InputMaybe<Scalars['Boolean']>;
  urlLike?: InputMaybe<Scalars['String']>;
  urlLikeNoCase?: InputMaybe<Scalars['String']>;
  urlLt?: InputMaybe<Scalars['String']>;
  urlLte?: InputMaybe<Scalars['String']>;
  urlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLPostsUserArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLPostsWriterUserArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLPostsPropertiesEnum {
  Body = 'body',
  CategoryId = 'categoryId',
  CreatedAt = 'createdAt',
  DomainId = 'domainId',
  EditedBy = 'editedBy',
  Excerpt = 'excerpt',
  Featured = 'featured',
  FullBody = 'fullBody',
  Id = 'id',
  ImageId = 'imageId',
  IsDeleted = 'isDeleted',
  Languages = 'languages',
  OldExcerpt = 'oldExcerpt',
  Published = 'published',
  PublishedAt = 'publishedAt',
  Title = 'title',
  TypeId = 'typeId',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy',
  UserId = 'userId',
  Weight = 'weight',
  WrittenBy = 'writtenBy'
}

export type GQLQuery = {
  __typename?: 'Query';
  adnetworkTrackingSetting?: Maybe<GQLAdnetworkTrackingSettings>;
  advertisingNetwork?: Maybe<GQLAdvertisingNetworks>;
  affiliateLink?: Maybe<GQLAffiliateLinks>;
  allAdnetworkTrackingSettings?: Maybe<Array<Maybe<GQLAdnetworkTrackingSettings>>>;
  allAdvertisingNetworks?: Maybe<Array<Maybe<GQLAdvertisingNetworks>>>;
  allAffiliateLinks?: Maybe<Array<Maybe<GQLAffiliateLinks>>>;
  allAttachments?: Maybe<Array<Maybe<GQLAttachments>>>;
  allBuyerIntegrations?: Maybe<Array<Maybe<GQLBuyerIntegrations>>>;
  allCallCenter?: Maybe<Array<Maybe<GQLCallCenter>>>;
  allCategories?: Maybe<Array<Maybe<GQLCategories>>>;
  allCategoryAttributes?: Maybe<Array<Maybe<GQLCategoryAttributes>>>;
  allCategoryAttributesGroups?: Maybe<Array<Maybe<GQLCategoryAttributesGroups>>>;
  allCategoryAttributesValues?: Maybe<Array<Maybe<GQLCategoryAttributesValues>>>;
  allCustomTextBlocksPositions?: Maybe<Array<Maybe<GQLCustomTextBlocksPositions>>>;
  allDkis?: Maybe<Array<Maybe<GQLDkis>>>;
  allDomainCategories?: Maybe<Array<Maybe<GQLDomainCategories>>>;
  allDomainForms?: Maybe<Array<Maybe<GQLDomainForms>>>;
  allDomainListings?: Maybe<Array<Maybe<GQLDomainListings>>>;
  allDomainMetatags?: Maybe<Array<Maybe<GQLDomainMetatags>>>;
  allDomainOffers?: Maybe<Array<Maybe<GQLDomainOffers>>>;
  allDomainRoutes?: Maybe<Array<Maybe<GQLDomainRoutes>>>;
  allDomains?: Maybe<Array<Maybe<GQLDomains>>>;
  allDomainsEmailSettings?: Maybe<Array<Maybe<GQLDomainsEmailSettings>>>;
  allEnhancedRedirections?: Maybe<Array<Maybe<GQLEnhancedRedirections>>>;
  allFacebookWebhookEvents?: Maybe<Array<Maybe<GQLFacebookWebhookEvents>>>;
  allFaqs?: Maybe<Array<Maybe<GQLFaqs>>>;
  allFields?: Maybe<Array<Maybe<GQLFields>>>;
  allFieldsMeta?: Maybe<Array<Maybe<GQLFieldsMeta>>>;
  allForms?: Maybe<Array<Maybe<GQLForms>>>;
  allIpAddresses?: Maybe<Array<Maybe<GQLIpAddresses>>>;
  allIpFallbackProviderLog?: Maybe<Array<Maybe<GQLIpFallbackProviderLog>>>;
  allLeadConversionEventLogs?: Maybe<Array<Maybe<GQLLeadConversionEventLogs>>>;
  allLeadTags?: Maybe<Array<Maybe<GQLLeadTags>>>;
  allLeads?: Maybe<Array<Maybe<GQLLeads>>>;
  allLeadsMetadata?: Maybe<Array<Maybe<GQLLeadsMetadata>>>;
  allListingAttributes?: Maybe<Array<Maybe<GQLListingAttributes>>>;
  allListingFeatures?: Maybe<Array<Maybe<GQLListingFeatures>>>;
  allListings?: Maybe<Array<Maybe<GQLListings>>>;
  allLookups?: Maybe<Array<Maybe<GQLLookups>>>;
  allLookupsVariations?: Maybe<Array<Maybe<GQLLookupsVariations>>>;
  allMenuItems?: Maybe<Array<Maybe<GQLMenuItems>>>;
  allMenus?: Maybe<Array<Maybe<GQLMenus>>>;
  allMetatags?: Maybe<Array<Maybe<GQLMetatags>>>;
  allOfferCategories?: Maybe<Array<Maybe<GQLOfferCategories>>>;
  allOfferFeatures?: Maybe<Array<Maybe<GQLOfferFeatures>>>;
  allOfferSchedules?: Maybe<Array<Maybe<GQLOfferSchedules>>>;
  allOffers?: Maybe<Array<Maybe<GQLOffers>>>;
  allPersonalIdentifiableInformation?: Maybe<Array<Maybe<GQLPersonalIdentifiableInformation>>>;
  allPostTags?: Maybe<Array<Maybe<GQLPostTags>>>;
  allPosts?: Maybe<Array<Maybe<GQLPosts>>>;
  allRedirections?: Maybe<Array<Maybe<GQLRedirections>>>;
  allRelatedPosts?: Maybe<Array<Maybe<GQLRelatedPosts>>>;
  allStepFields?: Maybe<Array<Maybe<GQLStepFields>>>;
  allSteps?: Maybe<Array<Maybe<GQLSteps>>>;
  allTags?: Maybe<Array<Maybe<GQLTags>>>;
  allTaxonomies?: Maybe<Array<Maybe<GQLTaxonomies>>>;
  allTaxonomiesEntities?: Maybe<Array<Maybe<GQLTaxonomiesEntities>>>;
  allTextBlocks?: Maybe<Array<Maybe<GQLTextBlocks>>>;
  allTrafficSourceMap?: Maybe<Array<Maybe<GQLTrafficSourceMap>>>;
  allTrafficTypes?: Maybe<Array<Maybe<GQLTrafficTypes>>>;
  allTranslations?: Maybe<Array<Maybe<GQLTranslations>>>;
  allUrls?: Maybe<Array<Maybe<GQLUrls>>>;
  allUserRoles?: Maybe<Array<Maybe<GQLUserRoles>>>;
  allUsers?: Maybe<Array<Maybe<GQLUsers>>>;
  allVariations?: Maybe<Array<Maybe<GQLVariations>>>;
  allVisitors?: Maybe<Array<Maybe<GQLVisitors>>>;
  allVisits?: Maybe<Array<Maybe<GQLVisits>>>;
  attachment?: Maybe<GQLAttachments>;
  buyerIntegration?: Maybe<GQLBuyerIntegrations>;
  callCenter?: Maybe<GQLCallCenter>;
  category?: Maybe<GQLCategories>;
  categoryAttribute?: Maybe<GQLCategoryAttributes>;
  categoryAttributesGroup?: Maybe<GQLCategoryAttributesGroups>;
  categoryAttributesValue?: Maybe<GQLCategoryAttributesValues>;
  customTextBlocksPosition?: Maybe<GQLCustomTextBlocksPositions>;
  dki?: Maybe<GQLDkis>;
  domain?: Maybe<GQLDomains>;
  domainCategory?: Maybe<GQLDomainCategories>;
  domainForm?: Maybe<GQLDomainForms>;
  domainListing?: Maybe<GQLDomainListings>;
  domainMetatag?: Maybe<GQLDomainMetatags>;
  domainOffer?: Maybe<GQLDomainOffers>;
  domainRoute?: Maybe<GQLDomainRoutes>;
  domainsEmailSetting?: Maybe<GQLDomainsEmailSettings>;
  enhancedRedirection?: Maybe<GQLEnhancedRedirections>;
  facebookWebhookEvent?: Maybe<GQLFacebookWebhookEvents>;
  faq?: Maybe<GQLFaqs>;
  field?: Maybe<GQLFields>;
  fieldsMeta?: Maybe<GQLFieldsMeta>;
  form?: Maybe<GQLForms>;
  ipAddresse?: Maybe<GQLIpAddresses>;
  ipFallbackProviderLog?: Maybe<GQLIpFallbackProviderLog>;
  lead?: Maybe<GQLLeads>;
  leadConversionEventLog?: Maybe<GQLLeadConversionEventLogs>;
  leadTag?: Maybe<GQLLeadTags>;
  leadsMetadata?: Maybe<GQLLeadsMetadata>;
  listing?: Maybe<GQLListings>;
  listingAttribute?: Maybe<GQLListingAttributes>;
  listingFeature?: Maybe<GQLListingFeatures>;
  lookup?: Maybe<GQLLookups>;
  lookupsVariation?: Maybe<GQLLookupsVariations>;
  menuItem?: Maybe<GQLMenuItems>;
  menus?: Maybe<GQLMenus>;
  metatag?: Maybe<GQLMetatags>;
  offer?: Maybe<GQLOffers>;
  offerCategory?: Maybe<GQLOfferCategories>;
  offerFeature?: Maybe<GQLOfferFeatures>;
  offerSchedule?: Maybe<GQLOfferSchedules>;
  personalIdentifiableInformation?: Maybe<GQLPersonalIdentifiableInformation>;
  post?: Maybe<GQLPosts>;
  postTag?: Maybe<GQLPostTags>;
  redirection?: Maybe<GQLRedirections>;
  relatedPost?: Maybe<GQLRelatedPosts>;
  step?: Maybe<GQLSteps>;
  stepField?: Maybe<GQLStepFields>;
  tag?: Maybe<GQLTags>;
  taxonomiesEntity?: Maybe<GQLTaxonomiesEntities>;
  taxonomy?: Maybe<GQLTaxonomies>;
  textBlock?: Maybe<GQLTextBlocks>;
  trafficSourceMap?: Maybe<GQLTrafficSourceMap>;
  trafficType?: Maybe<GQLTrafficTypes>;
  translation?: Maybe<GQLTranslations>;
  url?: Maybe<GQLUrls>;
  user?: Maybe<GQLUsers>;
  userRole?: Maybe<GQLUserRoles>;
  variation?: Maybe<GQLVariations>;
  visit?: Maybe<GQLVisits>;
  visitor?: Maybe<GQLVisitors>;
};


export type GQLQueryAdnetworkTrackingSettingArgs = {
  adNetworkId?: InputMaybe<Scalars['Int']>;
  adNetworkIdAny?: InputMaybe<Scalars['Int']>;
  adNetworkIdContain?: InputMaybe<Scalars['Int']>;
  adNetworkIdEq?: InputMaybe<Scalars['Int']>;
  adNetworkIdGt?: InputMaybe<Scalars['Int']>;
  adNetworkIdGte?: InputMaybe<Scalars['Int']>;
  adNetworkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  adNetworkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  adNetworkIdLike?: InputMaybe<Scalars['Int']>;
  adNetworkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  adNetworkIdLt?: InputMaybe<Scalars['Int']>;
  adNetworkIdLte?: InputMaybe<Scalars['Int']>;
  adNetworkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  crossNetworkEventsEnabled?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledAny?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledContain?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledEq?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledGt?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledGte?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  crossNetworkEventsEnabledIsNull?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledLike?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledLt?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledLte?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainIds?: InputMaybe<Scalars['JSON']>;
  domainIdsAny?: InputMaybe<Scalars['JSON']>;
  domainIdsContain?: InputMaybe<Scalars['JSON']>;
  domainIdsEq?: InputMaybe<Scalars['JSON']>;
  domainIdsGt?: InputMaybe<Scalars['JSON']>;
  domainIdsGte?: InputMaybe<Scalars['JSON']>;
  domainIdsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  domainIdsIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdsLike?: InputMaybe<Scalars['JSON']>;
  domainIdsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  domainIdsLt?: InputMaybe<Scalars['JSON']>;
  domainIdsLte?: InputMaybe<Scalars['JSON']>;
  domainIdsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAdnetworkTrackingSettingsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAdnetworkTrackingSettingsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  settings?: InputMaybe<Scalars['JSON']>;
  settingsAny?: InputMaybe<Scalars['JSON']>;
  settingsContain?: InputMaybe<Scalars['JSON']>;
  settingsEq?: InputMaybe<Scalars['JSON']>;
  settingsGt?: InputMaybe<Scalars['JSON']>;
  settingsGte?: InputMaybe<Scalars['JSON']>;
  settingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settingsIsNull?: InputMaybe<Scalars['Boolean']>;
  settingsLike?: InputMaybe<Scalars['JSON']>;
  settingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  settingsLt?: InputMaybe<Scalars['JSON']>;
  settingsLte?: InputMaybe<Scalars['JSON']>;
  settingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  ts?: InputMaybe<Scalars['String']>;
  tsAny?: InputMaybe<Scalars['String']>;
  tsContain?: InputMaybe<Scalars['String']>;
  tsEq?: InputMaybe<Scalars['String']>;
  tsGt?: InputMaybe<Scalars['String']>;
  tsGte?: InputMaybe<Scalars['String']>;
  tsIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tsIsNull?: InputMaybe<Scalars['Boolean']>;
  tsLike?: InputMaybe<Scalars['String']>;
  tsLikeNoCase?: InputMaybe<Scalars['String']>;
  tsLt?: InputMaybe<Scalars['String']>;
  tsLte?: InputMaybe<Scalars['String']>;
  tsNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAdvertisingNetworkArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAdvertisingNetworksPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAdvertisingNetworksPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAffiliateLinkArgs = {
  affiliateProviderOfferId?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdAny?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdContain?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdEq?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdGt?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdGte?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  affiliateProviderOfferIdIsNull?: InputMaybe<Scalars['Boolean']>;
  affiliateProviderOfferIdLike?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdLikeNoCase?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdLt?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdLte?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buyerAffiliateProviderId?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdAny?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdContain?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdEq?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdGt?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdGte?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerAffiliateProviderIdIsNull?: InputMaybe<Scalars['Boolean']>;
  buyerAffiliateProviderIdLike?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdLt?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdLte?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerId?: InputMaybe<Scalars['Int']>;
  buyerIdAny?: InputMaybe<Scalars['Int']>;
  buyerIdContain?: InputMaybe<Scalars['Int']>;
  buyerIdEq?: InputMaybe<Scalars['Int']>;
  buyerIdGt?: InputMaybe<Scalars['Int']>;
  buyerIdGte?: InputMaybe<Scalars['Int']>;
  buyerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  buyerIdLike?: InputMaybe<Scalars['Int']>;
  buyerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  buyerIdLt?: InputMaybe<Scalars['Int']>;
  buyerIdLte?: InputMaybe<Scalars['Int']>;
  buyerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  currency?: InputMaybe<Scalars['String']>;
  currencyAny?: InputMaybe<Scalars['String']>;
  currencyContain?: InputMaybe<Scalars['String']>;
  currencyEq?: InputMaybe<Scalars['String']>;
  currencyGt?: InputMaybe<Scalars['String']>;
  currencyGte?: InputMaybe<Scalars['String']>;
  currencyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  currencyIsNull?: InputMaybe<Scalars['Boolean']>;
  currencyLike?: InputMaybe<Scalars['String']>;
  currencyLikeNoCase?: InputMaybe<Scalars['String']>;
  currencyLt?: InputMaybe<Scalars['String']>;
  currencyLte?: InputMaybe<Scalars['String']>;
  currencyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultPayout?: InputMaybe<Scalars['Float']>;
  defaultPayoutAny?: InputMaybe<Scalars['Float']>;
  defaultPayoutContain?: InputMaybe<Scalars['Float']>;
  defaultPayoutEq?: InputMaybe<Scalars['Float']>;
  defaultPayoutGt?: InputMaybe<Scalars['Float']>;
  defaultPayoutGte?: InputMaybe<Scalars['Float']>;
  defaultPayoutIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  defaultPayoutIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultPayoutLike?: InputMaybe<Scalars['Float']>;
  defaultPayoutLikeNoCase?: InputMaybe<Scalars['Float']>;
  defaultPayoutLt?: InputMaybe<Scalars['Float']>;
  defaultPayoutLte?: InputMaybe<Scalars['Float']>;
  defaultPayoutNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  factors?: InputMaybe<Scalars['JSON']>;
  factorsAny?: InputMaybe<Scalars['JSON']>;
  factorsContain?: InputMaybe<Scalars['JSON']>;
  factorsEq?: InputMaybe<Scalars['JSON']>;
  factorsGt?: InputMaybe<Scalars['JSON']>;
  factorsGte?: InputMaybe<Scalars['JSON']>;
  factorsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  factorsIsNull?: InputMaybe<Scalars['Boolean']>;
  factorsLike?: InputMaybe<Scalars['JSON']>;
  factorsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  factorsLt?: InputMaybe<Scalars['JSON']>;
  factorsLte?: InputMaybe<Scalars['JSON']>;
  factorsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  link?: InputMaybe<Scalars['String']>;
  linkAny?: InputMaybe<Scalars['String']>;
  linkContain?: InputMaybe<Scalars['String']>;
  linkEq?: InputMaybe<Scalars['String']>;
  linkGt?: InputMaybe<Scalars['String']>;
  linkGte?: InputMaybe<Scalars['String']>;
  linkIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkIsNull?: InputMaybe<Scalars['Boolean']>;
  linkLike?: InputMaybe<Scalars['String']>;
  linkLikeNoCase?: InputMaybe<Scalars['String']>;
  linkLt?: InputMaybe<Scalars['String']>;
  linkLte?: InputMaybe<Scalars['String']>;
  linkNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  method?: InputMaybe<Scalars['String']>;
  methodAny?: InputMaybe<Scalars['String']>;
  methodContain?: InputMaybe<Scalars['String']>;
  methodEq?: InputMaybe<Scalars['String']>;
  methodGt?: InputMaybe<Scalars['String']>;
  methodGte?: InputMaybe<Scalars['String']>;
  methodIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  methodIsNull?: InputMaybe<Scalars['Boolean']>;
  methodLike?: InputMaybe<Scalars['String']>;
  methodLikeNoCase?: InputMaybe<Scalars['String']>;
  methodLt?: InputMaybe<Scalars['String']>;
  methodLte?: InputMaybe<Scalars['String']>;
  methodNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldPrice?: InputMaybe<Scalars['Float']>;
  oldPriceAny?: InputMaybe<Scalars['Float']>;
  oldPriceContain?: InputMaybe<Scalars['Float']>;
  oldPriceEq?: InputMaybe<Scalars['Float']>;
  oldPriceGt?: InputMaybe<Scalars['Float']>;
  oldPriceGte?: InputMaybe<Scalars['Float']>;
  oldPriceIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  oldPriceIsNull?: InputMaybe<Scalars['Boolean']>;
  oldPriceLike?: InputMaybe<Scalars['Float']>;
  oldPriceLikeNoCase?: InputMaybe<Scalars['Float']>;
  oldPriceLt?: InputMaybe<Scalars['Float']>;
  oldPriceLte?: InputMaybe<Scalars['Float']>;
  oldPriceNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  orderBy?: InputMaybe<GQLAffiliateLinksPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAffiliateLinksPropertiesEnum>;
  price?: InputMaybe<Scalars['Float']>;
  priceAny?: InputMaybe<Scalars['Float']>;
  priceContain?: InputMaybe<Scalars['Float']>;
  priceEq?: InputMaybe<Scalars['Float']>;
  priceGt?: InputMaybe<Scalars['Float']>;
  priceGte?: InputMaybe<Scalars['Float']>;
  priceIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  priceIsNull?: InputMaybe<Scalars['Boolean']>;
  priceLike?: InputMaybe<Scalars['Float']>;
  priceLikeNoCase?: InputMaybe<Scalars['Float']>;
  priceLt?: InputMaybe<Scalars['Float']>;
  priceLte?: InputMaybe<Scalars['Float']>;
  priceNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLQueryAllAdnetworkTrackingSettingsArgs = {
  adNetworkId?: InputMaybe<Scalars['Int']>;
  adNetworkIdAny?: InputMaybe<Scalars['Int']>;
  adNetworkIdContain?: InputMaybe<Scalars['Int']>;
  adNetworkIdEq?: InputMaybe<Scalars['Int']>;
  adNetworkIdGt?: InputMaybe<Scalars['Int']>;
  adNetworkIdGte?: InputMaybe<Scalars['Int']>;
  adNetworkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  adNetworkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  adNetworkIdLike?: InputMaybe<Scalars['Int']>;
  adNetworkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  adNetworkIdLt?: InputMaybe<Scalars['Int']>;
  adNetworkIdLte?: InputMaybe<Scalars['Int']>;
  adNetworkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  crossNetworkEventsEnabled?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledAny?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledContain?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledEq?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledGt?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledGte?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  crossNetworkEventsEnabledIsNull?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledLike?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledLt?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledLte?: InputMaybe<Scalars['Boolean']>;
  crossNetworkEventsEnabledNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainIds?: InputMaybe<Scalars['JSON']>;
  domainIdsAny?: InputMaybe<Scalars['JSON']>;
  domainIdsContain?: InputMaybe<Scalars['JSON']>;
  domainIdsEq?: InputMaybe<Scalars['JSON']>;
  domainIdsGt?: InputMaybe<Scalars['JSON']>;
  domainIdsGte?: InputMaybe<Scalars['JSON']>;
  domainIdsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  domainIdsIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdsLike?: InputMaybe<Scalars['JSON']>;
  domainIdsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  domainIdsLt?: InputMaybe<Scalars['JSON']>;
  domainIdsLte?: InputMaybe<Scalars['JSON']>;
  domainIdsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAdnetworkTrackingSettingsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAdnetworkTrackingSettingsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  settings?: InputMaybe<Scalars['JSON']>;
  settingsAny?: InputMaybe<Scalars['JSON']>;
  settingsContain?: InputMaybe<Scalars['JSON']>;
  settingsEq?: InputMaybe<Scalars['JSON']>;
  settingsGt?: InputMaybe<Scalars['JSON']>;
  settingsGte?: InputMaybe<Scalars['JSON']>;
  settingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settingsIsNull?: InputMaybe<Scalars['Boolean']>;
  settingsLike?: InputMaybe<Scalars['JSON']>;
  settingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  settingsLt?: InputMaybe<Scalars['JSON']>;
  settingsLte?: InputMaybe<Scalars['JSON']>;
  settingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  ts?: InputMaybe<Scalars['String']>;
  tsAny?: InputMaybe<Scalars['String']>;
  tsContain?: InputMaybe<Scalars['String']>;
  tsEq?: InputMaybe<Scalars['String']>;
  tsGt?: InputMaybe<Scalars['String']>;
  tsGte?: InputMaybe<Scalars['String']>;
  tsIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tsIsNull?: InputMaybe<Scalars['Boolean']>;
  tsLike?: InputMaybe<Scalars['String']>;
  tsLikeNoCase?: InputMaybe<Scalars['String']>;
  tsLt?: InputMaybe<Scalars['String']>;
  tsLte?: InputMaybe<Scalars['String']>;
  tsNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllAdvertisingNetworksArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAdvertisingNetworksPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAdvertisingNetworksPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllAffiliateLinksArgs = {
  affiliateProviderOfferId?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdAny?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdContain?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdEq?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdGt?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdGte?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  affiliateProviderOfferIdIsNull?: InputMaybe<Scalars['Boolean']>;
  affiliateProviderOfferIdLike?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdLikeNoCase?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdLt?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdLte?: InputMaybe<Scalars['String']>;
  affiliateProviderOfferIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buyerAffiliateProviderId?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdAny?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdContain?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdEq?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdGt?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdGte?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerAffiliateProviderIdIsNull?: InputMaybe<Scalars['Boolean']>;
  buyerAffiliateProviderIdLike?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdLt?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdLte?: InputMaybe<Scalars['Int']>;
  buyerAffiliateProviderIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerId?: InputMaybe<Scalars['Int']>;
  buyerIdAny?: InputMaybe<Scalars['Int']>;
  buyerIdContain?: InputMaybe<Scalars['Int']>;
  buyerIdEq?: InputMaybe<Scalars['Int']>;
  buyerIdGt?: InputMaybe<Scalars['Int']>;
  buyerIdGte?: InputMaybe<Scalars['Int']>;
  buyerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  buyerIdLike?: InputMaybe<Scalars['Int']>;
  buyerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  buyerIdLt?: InputMaybe<Scalars['Int']>;
  buyerIdLte?: InputMaybe<Scalars['Int']>;
  buyerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  currency?: InputMaybe<Scalars['String']>;
  currencyAny?: InputMaybe<Scalars['String']>;
  currencyContain?: InputMaybe<Scalars['String']>;
  currencyEq?: InputMaybe<Scalars['String']>;
  currencyGt?: InputMaybe<Scalars['String']>;
  currencyGte?: InputMaybe<Scalars['String']>;
  currencyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  currencyIsNull?: InputMaybe<Scalars['Boolean']>;
  currencyLike?: InputMaybe<Scalars['String']>;
  currencyLikeNoCase?: InputMaybe<Scalars['String']>;
  currencyLt?: InputMaybe<Scalars['String']>;
  currencyLte?: InputMaybe<Scalars['String']>;
  currencyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultPayout?: InputMaybe<Scalars['Float']>;
  defaultPayoutAny?: InputMaybe<Scalars['Float']>;
  defaultPayoutContain?: InputMaybe<Scalars['Float']>;
  defaultPayoutEq?: InputMaybe<Scalars['Float']>;
  defaultPayoutGt?: InputMaybe<Scalars['Float']>;
  defaultPayoutGte?: InputMaybe<Scalars['Float']>;
  defaultPayoutIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  defaultPayoutIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultPayoutLike?: InputMaybe<Scalars['Float']>;
  defaultPayoutLikeNoCase?: InputMaybe<Scalars['Float']>;
  defaultPayoutLt?: InputMaybe<Scalars['Float']>;
  defaultPayoutLte?: InputMaybe<Scalars['Float']>;
  defaultPayoutNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  factors?: InputMaybe<Scalars['JSON']>;
  factorsAny?: InputMaybe<Scalars['JSON']>;
  factorsContain?: InputMaybe<Scalars['JSON']>;
  factorsEq?: InputMaybe<Scalars['JSON']>;
  factorsGt?: InputMaybe<Scalars['JSON']>;
  factorsGte?: InputMaybe<Scalars['JSON']>;
  factorsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  factorsIsNull?: InputMaybe<Scalars['Boolean']>;
  factorsLike?: InputMaybe<Scalars['JSON']>;
  factorsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  factorsLt?: InputMaybe<Scalars['JSON']>;
  factorsLte?: InputMaybe<Scalars['JSON']>;
  factorsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  link?: InputMaybe<Scalars['String']>;
  linkAny?: InputMaybe<Scalars['String']>;
  linkContain?: InputMaybe<Scalars['String']>;
  linkEq?: InputMaybe<Scalars['String']>;
  linkGt?: InputMaybe<Scalars['String']>;
  linkGte?: InputMaybe<Scalars['String']>;
  linkIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkIsNull?: InputMaybe<Scalars['Boolean']>;
  linkLike?: InputMaybe<Scalars['String']>;
  linkLikeNoCase?: InputMaybe<Scalars['String']>;
  linkLt?: InputMaybe<Scalars['String']>;
  linkLte?: InputMaybe<Scalars['String']>;
  linkNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  method?: InputMaybe<Scalars['String']>;
  methodAny?: InputMaybe<Scalars['String']>;
  methodContain?: InputMaybe<Scalars['String']>;
  methodEq?: InputMaybe<Scalars['String']>;
  methodGt?: InputMaybe<Scalars['String']>;
  methodGte?: InputMaybe<Scalars['String']>;
  methodIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  methodIsNull?: InputMaybe<Scalars['Boolean']>;
  methodLike?: InputMaybe<Scalars['String']>;
  methodLikeNoCase?: InputMaybe<Scalars['String']>;
  methodLt?: InputMaybe<Scalars['String']>;
  methodLte?: InputMaybe<Scalars['String']>;
  methodNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldPrice?: InputMaybe<Scalars['Float']>;
  oldPriceAny?: InputMaybe<Scalars['Float']>;
  oldPriceContain?: InputMaybe<Scalars['Float']>;
  oldPriceEq?: InputMaybe<Scalars['Float']>;
  oldPriceGt?: InputMaybe<Scalars['Float']>;
  oldPriceGte?: InputMaybe<Scalars['Float']>;
  oldPriceIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  oldPriceIsNull?: InputMaybe<Scalars['Boolean']>;
  oldPriceLike?: InputMaybe<Scalars['Float']>;
  oldPriceLikeNoCase?: InputMaybe<Scalars['Float']>;
  oldPriceLt?: InputMaybe<Scalars['Float']>;
  oldPriceLte?: InputMaybe<Scalars['Float']>;
  oldPriceNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  orderBy?: InputMaybe<GQLAffiliateLinksPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAffiliateLinksPropertiesEnum>;
  price?: InputMaybe<Scalars['Float']>;
  priceAny?: InputMaybe<Scalars['Float']>;
  priceContain?: InputMaybe<Scalars['Float']>;
  priceEq?: InputMaybe<Scalars['Float']>;
  priceGt?: InputMaybe<Scalars['Float']>;
  priceGte?: InputMaybe<Scalars['Float']>;
  priceIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  priceIsNull?: InputMaybe<Scalars['Boolean']>;
  priceLike?: InputMaybe<Scalars['Float']>;
  priceLikeNoCase?: InputMaybe<Scalars['Float']>;
  priceLt?: InputMaybe<Scalars['Float']>;
  priceLte?: InputMaybe<Scalars['Float']>;
  priceNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLQueryAllAttachmentsArgs = {
  access?: InputMaybe<Scalars['String']>;
  accessAny?: InputMaybe<Scalars['String']>;
  accessContain?: InputMaybe<Scalars['String']>;
  accessEq?: InputMaybe<Scalars['String']>;
  accessGt?: InputMaybe<Scalars['String']>;
  accessGte?: InputMaybe<Scalars['String']>;
  accessIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accessIsNull?: InputMaybe<Scalars['Boolean']>;
  accessLike?: InputMaybe<Scalars['String']>;
  accessLikeNoCase?: InputMaybe<Scalars['String']>;
  accessLt?: InputMaybe<Scalars['String']>;
  accessLte?: InputMaybe<Scalars['String']>;
  accessNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alt?: InputMaybe<Scalars['String']>;
  altAny?: InputMaybe<Scalars['String']>;
  altContain?: InputMaybe<Scalars['String']>;
  altEq?: InputMaybe<Scalars['String']>;
  altGt?: InputMaybe<Scalars['String']>;
  altGte?: InputMaybe<Scalars['String']>;
  altIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  altIsNull?: InputMaybe<Scalars['Boolean']>;
  altLike?: InputMaybe<Scalars['String']>;
  altLikeNoCase?: InputMaybe<Scalars['String']>;
  altLt?: InputMaybe<Scalars['String']>;
  altLte?: InputMaybe<Scalars['String']>;
  altNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caption?: InputMaybe<Scalars['String']>;
  captionAny?: InputMaybe<Scalars['String']>;
  captionContain?: InputMaybe<Scalars['String']>;
  captionEq?: InputMaybe<Scalars['String']>;
  captionGt?: InputMaybe<Scalars['String']>;
  captionGte?: InputMaybe<Scalars['String']>;
  captionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  captionIsNull?: InputMaybe<Scalars['Boolean']>;
  captionLike?: InputMaybe<Scalars['String']>;
  captionLikeNoCase?: InputMaybe<Scalars['String']>;
  captionLt?: InputMaybe<Scalars['String']>;
  captionLte?: InputMaybe<Scalars['String']>;
  captionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fullPath?: InputMaybe<Scalars['String']>;
  fullPathAny?: InputMaybe<Scalars['String']>;
  fullPathContain?: InputMaybe<Scalars['String']>;
  fullPathEq?: InputMaybe<Scalars['String']>;
  fullPathGt?: InputMaybe<Scalars['String']>;
  fullPathGte?: InputMaybe<Scalars['String']>;
  fullPathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullPathIsNull?: InputMaybe<Scalars['Boolean']>;
  fullPathLike?: InputMaybe<Scalars['String']>;
  fullPathLikeNoCase?: InputMaybe<Scalars['String']>;
  fullPathLt?: InputMaybe<Scalars['String']>;
  fullPathLte?: InputMaybe<Scalars['String']>;
  fullPathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mimeType?: InputMaybe<Scalars['String']>;
  mimeTypeAny?: InputMaybe<Scalars['String']>;
  mimeTypeContain?: InputMaybe<Scalars['String']>;
  mimeTypeEq?: InputMaybe<Scalars['String']>;
  mimeTypeGt?: InputMaybe<Scalars['String']>;
  mimeTypeGte?: InputMaybe<Scalars['String']>;
  mimeTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mimeTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  mimeTypeLike?: InputMaybe<Scalars['String']>;
  mimeTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  mimeTypeLt?: InputMaybe<Scalars['String']>;
  mimeTypeLte?: InputMaybe<Scalars['String']>;
  mimeTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  originalName?: InputMaybe<Scalars['String']>;
  originalNameAny?: InputMaybe<Scalars['String']>;
  originalNameContain?: InputMaybe<Scalars['String']>;
  originalNameEq?: InputMaybe<Scalars['String']>;
  originalNameGt?: InputMaybe<Scalars['String']>;
  originalNameGte?: InputMaybe<Scalars['String']>;
  originalNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  originalNameIsNull?: InputMaybe<Scalars['Boolean']>;
  originalNameLike?: InputMaybe<Scalars['String']>;
  originalNameLikeNoCase?: InputMaybe<Scalars['String']>;
  originalNameLt?: InputMaybe<Scalars['String']>;
  originalNameLte?: InputMaybe<Scalars['String']>;
  originalNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  path?: InputMaybe<Scalars['String']>;
  pathAny?: InputMaybe<Scalars['String']>;
  pathContain?: InputMaybe<Scalars['String']>;
  pathEq?: InputMaybe<Scalars['String']>;
  pathGt?: InputMaybe<Scalars['String']>;
  pathGte?: InputMaybe<Scalars['String']>;
  pathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pathIsNull?: InputMaybe<Scalars['Boolean']>;
  pathLike?: InputMaybe<Scalars['String']>;
  pathLikeNoCase?: InputMaybe<Scalars['String']>;
  pathLt?: InputMaybe<Scalars['String']>;
  pathLte?: InputMaybe<Scalars['String']>;
  pathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size?: InputMaybe<Scalars['Int']>;
  sizeAny?: InputMaybe<Scalars['Int']>;
  sizeContain?: InputMaybe<Scalars['Int']>;
  sizeEq?: InputMaybe<Scalars['Int']>;
  sizeGt?: InputMaybe<Scalars['Int']>;
  sizeGte?: InputMaybe<Scalars['Int']>;
  sizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sizeLike?: InputMaybe<Scalars['Int']>;
  sizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sizeLt?: InputMaybe<Scalars['Int']>;
  sizeLte?: InputMaybe<Scalars['Int']>;
  sizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllBuyerIntegrationsArgs = {
  authIntegrationId?: InputMaybe<Scalars['Int']>;
  authIntegrationIdAny?: InputMaybe<Scalars['Int']>;
  authIntegrationIdContain?: InputMaybe<Scalars['Int']>;
  authIntegrationIdEq?: InputMaybe<Scalars['Int']>;
  authIntegrationIdGt?: InputMaybe<Scalars['Int']>;
  authIntegrationIdGte?: InputMaybe<Scalars['Int']>;
  authIntegrationIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  authIntegrationIdIsNull?: InputMaybe<Scalars['Boolean']>;
  authIntegrationIdLike?: InputMaybe<Scalars['Int']>;
  authIntegrationIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  authIntegrationIdLt?: InputMaybe<Scalars['Int']>;
  authIntegrationIdLte?: InputMaybe<Scalars['Int']>;
  authIntegrationIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerId?: InputMaybe<Scalars['Int']>;
  buyerIdAny?: InputMaybe<Scalars['Int']>;
  buyerIdContain?: InputMaybe<Scalars['Int']>;
  buyerIdEq?: InputMaybe<Scalars['Int']>;
  buyerIdGt?: InputMaybe<Scalars['Int']>;
  buyerIdGte?: InputMaybe<Scalars['Int']>;
  buyerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  buyerIdLike?: InputMaybe<Scalars['Int']>;
  buyerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  buyerIdLt?: InputMaybe<Scalars['Int']>;
  buyerIdLte?: InputMaybe<Scalars['Int']>;
  buyerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerIntegrationId?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdAny?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdContain?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdEq?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdGt?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdGte?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerIntegrationIdIsNull?: InputMaybe<Scalars['Boolean']>;
  buyerIntegrationIdLike?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdLt?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdLte?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  criteria?: InputMaybe<Scalars['JSON']>;
  criteriaAny?: InputMaybe<Scalars['JSON']>;
  criteriaContain?: InputMaybe<Scalars['JSON']>;
  criteriaEq?: InputMaybe<Scalars['JSON']>;
  criteriaGt?: InputMaybe<Scalars['JSON']>;
  criteriaGte?: InputMaybe<Scalars['JSON']>;
  criteriaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  criteriaIsNull?: InputMaybe<Scalars['Boolean']>;
  criteriaLike?: InputMaybe<Scalars['JSON']>;
  criteriaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  criteriaLt?: InputMaybe<Scalars['JSON']>;
  criteriaLte?: InputMaybe<Scalars['JSON']>;
  criteriaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  log?: InputMaybe<Scalars['JSON']>;
  logAny?: InputMaybe<Scalars['JSON']>;
  logContain?: InputMaybe<Scalars['JSON']>;
  logEq?: InputMaybe<Scalars['JSON']>;
  logGt?: InputMaybe<Scalars['JSON']>;
  logGte?: InputMaybe<Scalars['JSON']>;
  logIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  logIsNull?: InputMaybe<Scalars['Boolean']>;
  logLike?: InputMaybe<Scalars['JSON']>;
  logLikeNoCase?: InputMaybe<Scalars['JSON']>;
  logLt?: InputMaybe<Scalars['JSON']>;
  logLte?: InputMaybe<Scalars['JSON']>;
  logNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  method?: InputMaybe<Scalars['String']>;
  methodAny?: InputMaybe<Scalars['String']>;
  methodContain?: InputMaybe<Scalars['String']>;
  methodEq?: InputMaybe<Scalars['String']>;
  methodGt?: InputMaybe<Scalars['String']>;
  methodGte?: InputMaybe<Scalars['String']>;
  methodIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  methodIsNull?: InputMaybe<Scalars['Boolean']>;
  methodLike?: InputMaybe<Scalars['String']>;
  methodLikeNoCase?: InputMaybe<Scalars['String']>;
  methodLt?: InputMaybe<Scalars['String']>;
  methodLte?: InputMaybe<Scalars['String']>;
  methodNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notQualified?: InputMaybe<Scalars['Boolean']>;
  notQualifiedAny?: InputMaybe<Scalars['Boolean']>;
  notQualifiedContain?: InputMaybe<Scalars['Boolean']>;
  notQualifiedEq?: InputMaybe<Scalars['Boolean']>;
  notQualifiedGt?: InputMaybe<Scalars['Boolean']>;
  notQualifiedGte?: InputMaybe<Scalars['Boolean']>;
  notQualifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  notQualifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  notQualifiedLike?: InputMaybe<Scalars['Boolean']>;
  notQualifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  notQualifiedLt?: InputMaybe<Scalars['Boolean']>;
  notQualifiedLte?: InputMaybe<Scalars['Boolean']>;
  notQualifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  notificationIntegrations?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsAny?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsContain?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsEq?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsGt?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsGte?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  notificationIntegrationsIsNull?: InputMaybe<Scalars['Boolean']>;
  notificationIntegrationsLike?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsLt?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsLte?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldVersion?: InputMaybe<Scalars['Float']>;
  oldVersionAny?: InputMaybe<Scalars['Float']>;
  oldVersionContain?: InputMaybe<Scalars['Float']>;
  oldVersionEq?: InputMaybe<Scalars['Float']>;
  oldVersionGt?: InputMaybe<Scalars['Float']>;
  oldVersionGte?: InputMaybe<Scalars['Float']>;
  oldVersionIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  oldVersionIsNull?: InputMaybe<Scalars['Boolean']>;
  oldVersionLike?: InputMaybe<Scalars['Float']>;
  oldVersionLikeNoCase?: InputMaybe<Scalars['Float']>;
  oldVersionLt?: InputMaybe<Scalars['Float']>;
  oldVersionLte?: InputMaybe<Scalars['Float']>;
  oldVersionNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  orderBy?: InputMaybe<GQLBuyerIntegrationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLBuyerIntegrationsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  relatedIntegrations?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsAny?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsContain?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsEq?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsGt?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsGte?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  relatedIntegrationsIsNull?: InputMaybe<Scalars['Boolean']>;
  relatedIntegrationsLike?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsLt?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsLte?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  secondRound?: InputMaybe<Scalars['Boolean']>;
  secondRoundAny?: InputMaybe<Scalars['Boolean']>;
  secondRoundContain?: InputMaybe<Scalars['Boolean']>;
  secondRoundEq?: InputMaybe<Scalars['Boolean']>;
  secondRoundGt?: InputMaybe<Scalars['Boolean']>;
  secondRoundGte?: InputMaybe<Scalars['Boolean']>;
  secondRoundIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  secondRoundIsNull?: InputMaybe<Scalars['Boolean']>;
  secondRoundLike?: InputMaybe<Scalars['Boolean']>;
  secondRoundLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  secondRoundLt?: InputMaybe<Scalars['Boolean']>;
  secondRoundLte?: InputMaybe<Scalars['Boolean']>;
  secondRoundNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uuid?: InputMaybe<Scalars['String']>;
  uuidAny?: InputMaybe<Scalars['String']>;
  uuidContain?: InputMaybe<Scalars['String']>;
  uuidEq?: InputMaybe<Scalars['String']>;
  uuidGt?: InputMaybe<Scalars['String']>;
  uuidGte?: InputMaybe<Scalars['String']>;
  uuidIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uuidIsNull?: InputMaybe<Scalars['Boolean']>;
  uuidLike?: InputMaybe<Scalars['String']>;
  uuidLikeNoCase?: InputMaybe<Scalars['String']>;
  uuidLt?: InputMaybe<Scalars['String']>;
  uuidLte?: InputMaybe<Scalars['String']>;
  uuidNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueRule?: InputMaybe<Scalars['JSON']>;
  valueRuleAny?: InputMaybe<Scalars['JSON']>;
  valueRuleContain?: InputMaybe<Scalars['JSON']>;
  valueRuleEq?: InputMaybe<Scalars['JSON']>;
  valueRuleGt?: InputMaybe<Scalars['JSON']>;
  valueRuleGte?: InputMaybe<Scalars['JSON']>;
  valueRuleIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueRuleIsNull?: InputMaybe<Scalars['Boolean']>;
  valueRuleLike?: InputMaybe<Scalars['JSON']>;
  valueRuleLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueRuleLt?: InputMaybe<Scalars['JSON']>;
  valueRuleLte?: InputMaybe<Scalars['JSON']>;
  valueRuleNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  version?: InputMaybe<Scalars['Float']>;
  versionAny?: InputMaybe<Scalars['Float']>;
  versionContain?: InputMaybe<Scalars['Float']>;
  versionEq?: InputMaybe<Scalars['Float']>;
  versionGt?: InputMaybe<Scalars['Float']>;
  versionGte?: InputMaybe<Scalars['Float']>;
  versionIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  versionIsNull?: InputMaybe<Scalars['Boolean']>;
  versionLike?: InputMaybe<Scalars['Float']>;
  versionLikeNoCase?: InputMaybe<Scalars['Float']>;
  versionLt?: InputMaybe<Scalars['Float']>;
  versionLte?: InputMaybe<Scalars['Float']>;
  versionNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  versionStatus?: InputMaybe<Scalars['String']>;
  versionStatusAny?: InputMaybe<Scalars['String']>;
  versionStatusContain?: InputMaybe<Scalars['String']>;
  versionStatusEq?: InputMaybe<Scalars['String']>;
  versionStatusGt?: InputMaybe<Scalars['String']>;
  versionStatusGte?: InputMaybe<Scalars['String']>;
  versionStatusIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  versionStatusIsNull?: InputMaybe<Scalars['Boolean']>;
  versionStatusLike?: InputMaybe<Scalars['String']>;
  versionStatusLikeNoCase?: InputMaybe<Scalars['String']>;
  versionStatusLt?: InputMaybe<Scalars['String']>;
  versionStatusLte?: InputMaybe<Scalars['String']>;
  versionStatusNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllCallCenterArgs = {
  categories?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryName?: InputMaybe<Scalars['String']>;
  categorySlug?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerSlug?: InputMaybe<Scalars['String']>;
  offerTitle?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  ts?: InputMaybe<Scalars['String']>;
};


export type GQLQueryAllCategoriesArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllCategoryAttributesArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  comparison?: InputMaybe<Scalars['Boolean']>;
  comparisonAny?: InputMaybe<Scalars['Boolean']>;
  comparisonContain?: InputMaybe<Scalars['Boolean']>;
  comparisonEq?: InputMaybe<Scalars['Boolean']>;
  comparisonGt?: InputMaybe<Scalars['Boolean']>;
  comparisonGte?: InputMaybe<Scalars['Boolean']>;
  comparisonIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  comparisonIsNull?: InputMaybe<Scalars['Boolean']>;
  comparisonLike?: InputMaybe<Scalars['Boolean']>;
  comparisonLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  comparisonLt?: InputMaybe<Scalars['Boolean']>;
  comparisonLte?: InputMaybe<Scalars['Boolean']>;
  comparisonNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  forceComparisonsDisplay?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayAny?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayContain?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayEq?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayGt?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayGte?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  forceComparisonsDisplayIsNull?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLike?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLt?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLte?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  group?: InputMaybe<Scalars['String']>;
  groupAny?: InputMaybe<Scalars['String']>;
  groupContain?: InputMaybe<Scalars['String']>;
  groupEq?: InputMaybe<Scalars['String']>;
  groupGt?: InputMaybe<Scalars['String']>;
  groupGte?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['Int']>;
  groupIdAny?: InputMaybe<Scalars['Int']>;
  groupIdContain?: InputMaybe<Scalars['Int']>;
  groupIdEq?: InputMaybe<Scalars['Int']>;
  groupIdGt?: InputMaybe<Scalars['Int']>;
  groupIdGte?: InputMaybe<Scalars['Int']>;
  groupIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  groupIdIsNull?: InputMaybe<Scalars['Boolean']>;
  groupIdLike?: InputMaybe<Scalars['Int']>;
  groupIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  groupIdLt?: InputMaybe<Scalars['Int']>;
  groupIdLte?: InputMaybe<Scalars['Int']>;
  groupIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  groupIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupIsNull?: InputMaybe<Scalars['Boolean']>;
  groupLike?: InputMaybe<Scalars['String']>;
  groupLikeNoCase?: InputMaybe<Scalars['String']>;
  groupLt?: InputMaybe<Scalars['String']>;
  groupLte?: InputMaybe<Scalars['String']>;
  groupNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupSlug?: InputMaybe<Scalars['String']>;
  groupSlugAny?: InputMaybe<Scalars['String']>;
  groupSlugContain?: InputMaybe<Scalars['String']>;
  groupSlugEq?: InputMaybe<Scalars['String']>;
  groupSlugGt?: InputMaybe<Scalars['String']>;
  groupSlugGte?: InputMaybe<Scalars['String']>;
  groupSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  groupSlugLike?: InputMaybe<Scalars['String']>;
  groupSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  groupSlugLt?: InputMaybe<Scalars['String']>;
  groupSlugLte?: InputMaybe<Scalars['String']>;
  groupSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  hiddenAny?: InputMaybe<Scalars['Boolean']>;
  hiddenContain?: InputMaybe<Scalars['Boolean']>;
  hiddenEq?: InputMaybe<Scalars['Boolean']>;
  hiddenGt?: InputMaybe<Scalars['Boolean']>;
  hiddenGte?: InputMaybe<Scalars['Boolean']>;
  hiddenIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  hiddenIsNull?: InputMaybe<Scalars['Boolean']>;
  hiddenLike?: InputMaybe<Scalars['Boolean']>;
  hiddenLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  hiddenLt?: InputMaybe<Scalars['Boolean']>;
  hiddenLte?: InputMaybe<Scalars['Boolean']>;
  hiddenNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLCategoryAttributesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoryAttributesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLQueryAllCategoryAttributesGroupsArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoryAttributesGroupsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoryAttributesGroupsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllCategoryAttributesValuesArgs = {
  attributeId?: InputMaybe<Scalars['Int']>;
  attributeIdAny?: InputMaybe<Scalars['Int']>;
  attributeIdContain?: InputMaybe<Scalars['Int']>;
  attributeIdEq?: InputMaybe<Scalars['Int']>;
  attributeIdGt?: InputMaybe<Scalars['Int']>;
  attributeIdGte?: InputMaybe<Scalars['Int']>;
  attributeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  attributeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  attributeIdLike?: InputMaybe<Scalars['Int']>;
  attributeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  attributeIdLt?: InputMaybe<Scalars['Int']>;
  attributeIdLte?: InputMaybe<Scalars['Int']>;
  attributeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLCategoryAttributesValuesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoryAttributesValuesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllCustomTextBlocksPositionsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedByAny?: InputMaybe<Scalars['String']>;
  deletedByContain?: InputMaybe<Scalars['String']>;
  deletedByEq?: InputMaybe<Scalars['String']>;
  deletedByGt?: InputMaybe<Scalars['String']>;
  deletedByGte?: InputMaybe<Scalars['String']>;
  deletedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedByIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedByLike?: InputMaybe<Scalars['String']>;
  deletedByLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedByLt?: InputMaybe<Scalars['String']>;
  deletedByLte?: InputMaybe<Scalars['String']>;
  deletedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLCustomTextBlocksPositionsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCustomTextBlocksPositionsPropertiesEnum>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllDkisArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDkisPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDkisPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllDomainCategoriesArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  crossSellingDomainFormId?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdAny?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdContain?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdEq?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdGt?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdGte?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  crossSellingDomainFormIdIsNull?: InputMaybe<Scalars['Boolean']>;
  crossSellingDomainFormIdLike?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdLt?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdLte?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLDomainCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllDomainFormsArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formId?: InputMaybe<Scalars['Int']>;
  formIdAny?: InputMaybe<Scalars['Int']>;
  formIdContain?: InputMaybe<Scalars['Int']>;
  formIdEq?: InputMaybe<Scalars['Int']>;
  formIdGt?: InputMaybe<Scalars['Int']>;
  formIdGte?: InputMaybe<Scalars['Int']>;
  formIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formIdIsNull?: InputMaybe<Scalars['Boolean']>;
  formIdLike?: InputMaybe<Scalars['Int']>;
  formIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  formIdLt?: InputMaybe<Scalars['Int']>;
  formIdLte?: InputMaybe<Scalars['Int']>;
  formIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  integrations?: InputMaybe<Scalars['JSON']>;
  integrationsAny?: InputMaybe<Scalars['JSON']>;
  integrationsContain?: InputMaybe<Scalars['JSON']>;
  integrationsEq?: InputMaybe<Scalars['JSON']>;
  integrationsGt?: InputMaybe<Scalars['JSON']>;
  integrationsGte?: InputMaybe<Scalars['JSON']>;
  integrationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  integrationsIsNull?: InputMaybe<Scalars['Boolean']>;
  integrationsLike?: InputMaybe<Scalars['JSON']>;
  integrationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  integrationsLt?: InputMaybe<Scalars['JSON']>;
  integrationsLte?: InputMaybe<Scalars['JSON']>;
  integrationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainFormsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainFormsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllDomainListingsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isComparison?: InputMaybe<Scalars['Boolean']>;
  isComparisonAny?: InputMaybe<Scalars['Boolean']>;
  isComparisonContain?: InputMaybe<Scalars['Boolean']>;
  isComparisonEq?: InputMaybe<Scalars['Boolean']>;
  isComparisonGt?: InputMaybe<Scalars['Boolean']>;
  isComparisonGte?: InputMaybe<Scalars['Boolean']>;
  isComparisonIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isComparisonIsNull?: InputMaybe<Scalars['Boolean']>;
  isComparisonLike?: InputMaybe<Scalars['Boolean']>;
  isComparisonLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isComparisonLt?: InputMaybe<Scalars['Boolean']>;
  isComparisonLte?: InputMaybe<Scalars['Boolean']>;
  isComparisonNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingId?: InputMaybe<Scalars['Int']>;
  listingIdAny?: InputMaybe<Scalars['Int']>;
  listingIdContain?: InputMaybe<Scalars['Int']>;
  listingIdEq?: InputMaybe<Scalars['Int']>;
  listingIdGt?: InputMaybe<Scalars['Int']>;
  listingIdGte?: InputMaybe<Scalars['Int']>;
  listingIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingIdIsNull?: InputMaybe<Scalars['Boolean']>;
  listingIdLike?: InputMaybe<Scalars['Int']>;
  listingIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  listingIdLt?: InputMaybe<Scalars['Int']>;
  listingIdLte?: InputMaybe<Scalars['Int']>;
  listingIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainListingsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainListingsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLQueryAllDomainMetatagsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainMetatagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainMetatagsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllDomainOffersArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainOffersPropertiesEnum>;
  placements?: InputMaybe<Scalars['JSON']>;
  placementsAny?: InputMaybe<Scalars['JSON']>;
  placementsContain?: InputMaybe<Scalars['JSON']>;
  placementsEq?: InputMaybe<Scalars['JSON']>;
  placementsGt?: InputMaybe<Scalars['JSON']>;
  placementsGte?: InputMaybe<Scalars['JSON']>;
  placementsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  placementsIsNull?: InputMaybe<Scalars['Boolean']>;
  placementsLike?: InputMaybe<Scalars['JSON']>;
  placementsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  placementsLt?: InputMaybe<Scalars['JSON']>;
  placementsLte?: InputMaybe<Scalars['JSON']>;
  placementsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sticky?: InputMaybe<Scalars['Boolean']>;
  stickyAny?: InputMaybe<Scalars['Boolean']>;
  stickyContain?: InputMaybe<Scalars['Boolean']>;
  stickyEq?: InputMaybe<Scalars['Boolean']>;
  stickyGt?: InputMaybe<Scalars['Boolean']>;
  stickyGte?: InputMaybe<Scalars['Boolean']>;
  stickyIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  stickyIsNull?: InputMaybe<Scalars['Boolean']>;
  stickyLike?: InputMaybe<Scalars['Boolean']>;
  stickyLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  stickyLt?: InputMaybe<Scalars['Boolean']>;
  stickyLte?: InputMaybe<Scalars['Boolean']>;
  stickyNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLQueryAllDomainRoutesArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ignoreKeyword?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordAny?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordContain?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordEq?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordGt?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordGte?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  ignoreKeywordIsNull?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordLike?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordLt?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordLte?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainRoutesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainRoutesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  route?: InputMaybe<Scalars['String']>;
  routeAny?: InputMaybe<Scalars['String']>;
  routeContain?: InputMaybe<Scalars['String']>;
  routeEq?: InputMaybe<Scalars['String']>;
  routeGt?: InputMaybe<Scalars['String']>;
  routeGte?: InputMaybe<Scalars['String']>;
  routeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  routeIsNull?: InputMaybe<Scalars['Boolean']>;
  routeLike?: InputMaybe<Scalars['String']>;
  routeLikeNoCase?: InputMaybe<Scalars['String']>;
  routeLt?: InputMaybe<Scalars['String']>;
  routeLte?: InputMaybe<Scalars['String']>;
  routeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllDomainsArgs = {
  allowedLanguages?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesAny?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesContain?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesEq?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  allowedLanguagesIsNull?: InputMaybe<Scalars['Boolean']>;
  allowedLanguagesLike?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  analyticsCodeId?: InputMaybe<Scalars['String']>;
  analyticsCodeIdAny?: InputMaybe<Scalars['String']>;
  analyticsCodeIdContain?: InputMaybe<Scalars['String']>;
  analyticsCodeIdEq?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  analyticsCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  analyticsCodeIdLike?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cacheSettings?: InputMaybe<Scalars['JSON']>;
  cacheSettingsAny?: InputMaybe<Scalars['JSON']>;
  cacheSettingsContain?: InputMaybe<Scalars['JSON']>;
  cacheSettingsEq?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  cacheSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  cacheSettingsLike?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  clickyCodeId?: InputMaybe<Scalars['String']>;
  clickyCodeIdAny?: InputMaybe<Scalars['String']>;
  clickyCodeIdContain?: InputMaybe<Scalars['String']>;
  clickyCodeIdEq?: InputMaybe<Scalars['String']>;
  clickyCodeIdGt?: InputMaybe<Scalars['String']>;
  clickyCodeIdGte?: InputMaybe<Scalars['String']>;
  clickyCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clickyCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  clickyCodeIdLike?: InputMaybe<Scalars['String']>;
  clickyCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  clickyCodeIdLt?: InputMaybe<Scalars['String']>;
  clickyCodeIdLte?: InputMaybe<Scalars['String']>;
  clickyCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  enableChatWidget?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetAny?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetContain?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetEq?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableChatWidgetIsNull?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLike?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaId?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdAny?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdContain?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdEq?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLike?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedForm?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormAny?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormContain?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormEq?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedFormIsNull?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLike?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  facebookConversionAPISettings?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsAny?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsContain?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsEq?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookConversionAPISettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookConversionAPISettingsLike?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookSiteVerificationCode?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fallbackSettings?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsAny?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsContain?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsEq?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  fallbackSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  fallbackSettingsLike?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  faviconId?: InputMaybe<Scalars['String']>;
  faviconIdAny?: InputMaybe<Scalars['String']>;
  faviconIdContain?: InputMaybe<Scalars['String']>;
  faviconIdEq?: InputMaybe<Scalars['String']>;
  faviconIdGt?: InputMaybe<Scalars['String']>;
  faviconIdGte?: InputMaybe<Scalars['String']>;
  faviconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  faviconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  faviconIdLike?: InputMaybe<Scalars['String']>;
  faviconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  faviconIdLt?: InputMaybe<Scalars['String']>;
  faviconIdLte?: InputMaybe<Scalars['String']>;
  faviconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCode?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  googleSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmId?: InputMaybe<Scalars['String']>;
  gtmIdAny?: InputMaybe<Scalars['String']>;
  gtmIdContain?: InputMaybe<Scalars['String']>;
  gtmIdEq?: InputMaybe<Scalars['String']>;
  gtmIdGt?: InputMaybe<Scalars['String']>;
  gtmIdGte?: InputMaybe<Scalars['String']>;
  gtmIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmIdIsNull?: InputMaybe<Scalars['Boolean']>;
  gtmIdLike?: InputMaybe<Scalars['String']>;
  gtmIdLikeNoCase?: InputMaybe<Scalars['String']>;
  gtmIdLt?: InputMaybe<Scalars['String']>;
  gtmIdLte?: InputMaybe<Scalars['String']>;
  gtmIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  holdingRules?: InputMaybe<Scalars['JSON']>;
  holdingRulesAny?: InputMaybe<Scalars['JSON']>;
  holdingRulesContain?: InputMaybe<Scalars['JSON']>;
  holdingRulesEq?: InputMaybe<Scalars['JSON']>;
  holdingRulesGt?: InputMaybe<Scalars['JSON']>;
  holdingRulesGte?: InputMaybe<Scalars['JSON']>;
  holdingRulesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  holdingRulesIsNull?: InputMaybe<Scalars['Boolean']>;
  holdingRulesLike?: InputMaybe<Scalars['JSON']>;
  holdingRulesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  holdingRulesLt?: InputMaybe<Scalars['JSON']>;
  holdingRulesLte?: InputMaybe<Scalars['JSON']>;
  holdingRulesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabled?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledAny?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledContain?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledEq?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabledIsNull?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLike?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainsPropertiesEnum>;
  otpVerificationCriteria?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaAny?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaContain?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaEq?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  otpVerificationCriteriaIsNull?: InputMaybe<Scalars['Boolean']>;
  otpVerificationCriteriaLike?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  recaptchaConfig?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigAny?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigContain?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigEq?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  recaptchaConfigLike?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  secondaryLogoId?: InputMaybe<Scalars['String']>;
  secondaryLogoIdAny?: InputMaybe<Scalars['String']>;
  secondaryLogoIdContain?: InputMaybe<Scalars['String']>;
  secondaryLogoIdEq?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondaryLogoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  secondaryLogoIdLike?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sendNotifications?: InputMaybe<Scalars['JSON']>;
  sendNotificationsAny?: InputMaybe<Scalars['JSON']>;
  sendNotificationsContain?: InputMaybe<Scalars['JSON']>;
  sendNotificationsEq?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  sendNotificationsIsNull?: InputMaybe<Scalars['Boolean']>;
  sendNotificationsLike?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settings?: InputMaybe<Scalars['JSON']>;
  settingsAny?: InputMaybe<Scalars['JSON']>;
  settingsContain?: InputMaybe<Scalars['JSON']>;
  settingsEq?: InputMaybe<Scalars['JSON']>;
  settingsGt?: InputMaybe<Scalars['JSON']>;
  settingsGte?: InputMaybe<Scalars['JSON']>;
  settingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settingsIsNull?: InputMaybe<Scalars['Boolean']>;
  settingsLike?: InputMaybe<Scalars['JSON']>;
  settingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  settingsLt?: InputMaybe<Scalars['JSON']>;
  settingsLte?: InputMaybe<Scalars['JSON']>;
  settingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  slogan?: InputMaybe<Scalars['String']>;
  sloganAny?: InputMaybe<Scalars['String']>;
  sloganContain?: InputMaybe<Scalars['String']>;
  sloganEq?: InputMaybe<Scalars['String']>;
  sloganGt?: InputMaybe<Scalars['String']>;
  sloganGte?: InputMaybe<Scalars['String']>;
  sloganIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sloganIsNull?: InputMaybe<Scalars['Boolean']>;
  sloganLike?: InputMaybe<Scalars['String']>;
  sloganLikeNoCase?: InputMaybe<Scalars['String']>;
  sloganLt?: InputMaybe<Scalars['String']>;
  sloganLte?: InputMaybe<Scalars['String']>;
  sloganNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateConfig?: InputMaybe<Scalars['JSON']>;
  templateConfigAny?: InputMaybe<Scalars['JSON']>;
  templateConfigContain?: InputMaybe<Scalars['JSON']>;
  templateConfigEq?: InputMaybe<Scalars['JSON']>;
  templateConfigGt?: InputMaybe<Scalars['JSON']>;
  templateConfigGte?: InputMaybe<Scalars['JSON']>;
  templateConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  templateConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  templateConfigLike?: InputMaybe<Scalars['JSON']>;
  templateConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  templateConfigLt?: InputMaybe<Scalars['JSON']>;
  templateConfigLte?: InputMaybe<Scalars['JSON']>;
  templateConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixel?: InputMaybe<Scalars['String']>;
  twitterPixelAny?: InputMaybe<Scalars['String']>;
  twitterPixelContain?: InputMaybe<Scalars['String']>;
  twitterPixelEq?: InputMaybe<Scalars['String']>;
  twitterPixelGt?: InputMaybe<Scalars['String']>;
  twitterPixelGte?: InputMaybe<Scalars['String']>;
  twitterPixelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixelIsNull?: InputMaybe<Scalars['Boolean']>;
  twitterPixelLike?: InputMaybe<Scalars['String']>;
  twitterPixelLikeNoCase?: InputMaybe<Scalars['String']>;
  twitterPixelLt?: InputMaybe<Scalars['String']>;
  twitterPixelLte?: InputMaybe<Scalars['String']>;
  twitterPixelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllDomainsEmailSettingsArgs = {
  bccEmail?: InputMaybe<Scalars['String']>;
  bccEmailAny?: InputMaybe<Scalars['String']>;
  bccEmailContain?: InputMaybe<Scalars['String']>;
  bccEmailEq?: InputMaybe<Scalars['String']>;
  bccEmailGt?: InputMaybe<Scalars['String']>;
  bccEmailGte?: InputMaybe<Scalars['String']>;
  bccEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bccEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  bccEmailLike?: InputMaybe<Scalars['String']>;
  bccEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  bccEmailLt?: InputMaybe<Scalars['String']>;
  bccEmailLte?: InputMaybe<Scalars['String']>;
  bccEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainLogoId?: InputMaybe<Scalars['String']>;
  domainLogoIdAny?: InputMaybe<Scalars['String']>;
  domainLogoIdContain?: InputMaybe<Scalars['String']>;
  domainLogoIdEq?: InputMaybe<Scalars['String']>;
  domainLogoIdGt?: InputMaybe<Scalars['String']>;
  domainLogoIdGte?: InputMaybe<Scalars['String']>;
  domainLogoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domainLogoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainLogoIdLike?: InputMaybe<Scalars['String']>;
  domainLogoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  domainLogoIdLt?: InputMaybe<Scalars['String']>;
  domainLogoIdLte?: InputMaybe<Scalars['String']>;
  domainLogoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailPassword?: InputMaybe<Scalars['String']>;
  emailPasswordAny?: InputMaybe<Scalars['String']>;
  emailPasswordContain?: InputMaybe<Scalars['String']>;
  emailPasswordEq?: InputMaybe<Scalars['String']>;
  emailPasswordGt?: InputMaybe<Scalars['String']>;
  emailPasswordGte?: InputMaybe<Scalars['String']>;
  emailPasswordIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailPasswordIsNull?: InputMaybe<Scalars['Boolean']>;
  emailPasswordLike?: InputMaybe<Scalars['String']>;
  emailPasswordLikeNoCase?: InputMaybe<Scalars['String']>;
  emailPasswordLt?: InputMaybe<Scalars['String']>;
  emailPasswordLte?: InputMaybe<Scalars['String']>;
  emailPasswordNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailService?: InputMaybe<Scalars['String']>;
  emailServiceAny?: InputMaybe<Scalars['String']>;
  emailServiceContain?: InputMaybe<Scalars['String']>;
  emailServiceEq?: InputMaybe<Scalars['String']>;
  emailServiceGt?: InputMaybe<Scalars['String']>;
  emailServiceGte?: InputMaybe<Scalars['String']>;
  emailServiceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailServiceIsNull?: InputMaybe<Scalars['Boolean']>;
  emailServiceLike?: InputMaybe<Scalars['String']>;
  emailServiceLikeNoCase?: InputMaybe<Scalars['String']>;
  emailServiceLt?: InputMaybe<Scalars['String']>;
  emailServiceLte?: InputMaybe<Scalars['String']>;
  emailServiceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailUserName?: InputMaybe<Scalars['String']>;
  emailUserNameAny?: InputMaybe<Scalars['String']>;
  emailUserNameContain?: InputMaybe<Scalars['String']>;
  emailUserNameEq?: InputMaybe<Scalars['String']>;
  emailUserNameGt?: InputMaybe<Scalars['String']>;
  emailUserNameGte?: InputMaybe<Scalars['String']>;
  emailUserNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailUserNameIsNull?: InputMaybe<Scalars['Boolean']>;
  emailUserNameLike?: InputMaybe<Scalars['String']>;
  emailUserNameLikeNoCase?: InputMaybe<Scalars['String']>;
  emailUserNameLt?: InputMaybe<Scalars['String']>;
  emailUserNameLte?: InputMaybe<Scalars['String']>;
  emailUserNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fromEmail?: InputMaybe<Scalars['String']>;
  fromEmailAny?: InputMaybe<Scalars['String']>;
  fromEmailContain?: InputMaybe<Scalars['String']>;
  fromEmailEq?: InputMaybe<Scalars['String']>;
  fromEmailGt?: InputMaybe<Scalars['String']>;
  fromEmailGte?: InputMaybe<Scalars['String']>;
  fromEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fromEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  fromEmailLike?: InputMaybe<Scalars['String']>;
  fromEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  fromEmailLt?: InputMaybe<Scalars['String']>;
  fromEmailLte?: InputMaybe<Scalars['String']>;
  fromEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainsEmailSettingsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainsEmailSettingsPropertiesEnum>;
  providerAPIKey?: InputMaybe<Scalars['String']>;
  providerAPIKeyAny?: InputMaybe<Scalars['String']>;
  providerAPIKeyContain?: InputMaybe<Scalars['String']>;
  providerAPIKeyEq?: InputMaybe<Scalars['String']>;
  providerAPIKeyGt?: InputMaybe<Scalars['String']>;
  providerAPIKeyGte?: InputMaybe<Scalars['String']>;
  providerAPIKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  providerAPIKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  providerAPIKeyLike?: InputMaybe<Scalars['String']>;
  providerAPIKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  providerAPIKeyLt?: InputMaybe<Scalars['String']>;
  providerAPIKeyLte?: InputMaybe<Scalars['String']>;
  providerAPIKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllEnhancedRedirectionsArgs = {
  createdBy?: InputMaybe<Scalars['String']>;
  destinationURI?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  redirectionStatusCode?: InputMaybe<Scalars['Int']>;
  srcURI?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};


export type GQLQueryAllFacebookWebhookEventsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  data?: InputMaybe<Scalars['JSON']>;
  dataAny?: InputMaybe<Scalars['JSON']>;
  dataContain?: InputMaybe<Scalars['JSON']>;
  dataEq?: InputMaybe<Scalars['JSON']>;
  dataGt?: InputMaybe<Scalars['JSON']>;
  dataGte?: InputMaybe<Scalars['JSON']>;
  dataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  dataIsNull?: InputMaybe<Scalars['Boolean']>;
  dataLike?: InputMaybe<Scalars['JSON']>;
  dataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  dataLt?: InputMaybe<Scalars['JSON']>;
  dataLte?: InputMaybe<Scalars['JSON']>;
  dataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  facebookFormId?: InputMaybe<Scalars['String']>;
  facebookFormIdAny?: InputMaybe<Scalars['String']>;
  facebookFormIdContain?: InputMaybe<Scalars['String']>;
  facebookFormIdEq?: InputMaybe<Scalars['String']>;
  facebookFormIdGt?: InputMaybe<Scalars['String']>;
  facebookFormIdGte?: InputMaybe<Scalars['String']>;
  facebookFormIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookFormIdIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookFormIdLike?: InputMaybe<Scalars['String']>;
  facebookFormIdLikeNoCase?: InputMaybe<Scalars['String']>;
  facebookFormIdLt?: InputMaybe<Scalars['String']>;
  facebookFormIdLte?: InputMaybe<Scalars['String']>;
  facebookFormIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookPageId?: InputMaybe<Scalars['String']>;
  facebookPageIdAny?: InputMaybe<Scalars['String']>;
  facebookPageIdContain?: InputMaybe<Scalars['String']>;
  facebookPageIdEq?: InputMaybe<Scalars['String']>;
  facebookPageIdGt?: InputMaybe<Scalars['String']>;
  facebookPageIdGte?: InputMaybe<Scalars['String']>;
  facebookPageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookPageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookPageIdLike?: InputMaybe<Scalars['String']>;
  facebookPageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  facebookPageIdLt?: InputMaybe<Scalars['String']>;
  facebookPageIdLte?: InputMaybe<Scalars['String']>;
  facebookPageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  leadUuid?: InputMaybe<Scalars['String']>;
  leadUuidAny?: InputMaybe<Scalars['String']>;
  leadUuidContain?: InputMaybe<Scalars['String']>;
  leadUuidEq?: InputMaybe<Scalars['String']>;
  leadUuidGt?: InputMaybe<Scalars['String']>;
  leadUuidGte?: InputMaybe<Scalars['String']>;
  leadUuidIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leadUuidIsNull?: InputMaybe<Scalars['Boolean']>;
  leadUuidLike?: InputMaybe<Scalars['String']>;
  leadUuidLikeNoCase?: InputMaybe<Scalars['String']>;
  leadUuidLt?: InputMaybe<Scalars['String']>;
  leadUuidLte?: InputMaybe<Scalars['String']>;
  leadUuidNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leadgenId?: InputMaybe<Scalars['String']>;
  leadgenIdAny?: InputMaybe<Scalars['String']>;
  leadgenIdContain?: InputMaybe<Scalars['String']>;
  leadgenIdEq?: InputMaybe<Scalars['String']>;
  leadgenIdGt?: InputMaybe<Scalars['String']>;
  leadgenIdGte?: InputMaybe<Scalars['String']>;
  leadgenIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leadgenIdIsNull?: InputMaybe<Scalars['Boolean']>;
  leadgenIdLike?: InputMaybe<Scalars['String']>;
  leadgenIdLikeNoCase?: InputMaybe<Scalars['String']>;
  leadgenIdLt?: InputMaybe<Scalars['String']>;
  leadgenIdLte?: InputMaybe<Scalars['String']>;
  leadgenIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  operation?: InputMaybe<Scalars['JSON']>;
  operationAny?: InputMaybe<Scalars['JSON']>;
  operationContain?: InputMaybe<Scalars['JSON']>;
  operationEq?: InputMaybe<Scalars['JSON']>;
  operationGt?: InputMaybe<Scalars['JSON']>;
  operationGte?: InputMaybe<Scalars['JSON']>;
  operationIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  operationIsNull?: InputMaybe<Scalars['Boolean']>;
  operationLike?: InputMaybe<Scalars['JSON']>;
  operationLikeNoCase?: InputMaybe<Scalars['JSON']>;
  operationLt?: InputMaybe<Scalars['JSON']>;
  operationLte?: InputMaybe<Scalars['JSON']>;
  operationNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  orderBy?: InputMaybe<GQLFacebookWebhookEventsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLFacebookWebhookEventsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requestInfo?: InputMaybe<Scalars['JSON']>;
  requestInfoAny?: InputMaybe<Scalars['JSON']>;
  requestInfoContain?: InputMaybe<Scalars['JSON']>;
  requestInfoEq?: InputMaybe<Scalars['JSON']>;
  requestInfoGt?: InputMaybe<Scalars['JSON']>;
  requestInfoGte?: InputMaybe<Scalars['JSON']>;
  requestInfoIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  requestInfoIsNull?: InputMaybe<Scalars['Boolean']>;
  requestInfoLike?: InputMaybe<Scalars['JSON']>;
  requestInfoLikeNoCase?: InputMaybe<Scalars['JSON']>;
  requestInfoLt?: InputMaybe<Scalars['JSON']>;
  requestInfoLte?: InputMaybe<Scalars['JSON']>;
  requestInfoNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  resultAny?: InputMaybe<Scalars['JSON']>;
  resultContain?: InputMaybe<Scalars['JSON']>;
  resultEq?: InputMaybe<Scalars['JSON']>;
  resultGt?: InputMaybe<Scalars['JSON']>;
  resultGte?: InputMaybe<Scalars['JSON']>;
  resultIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  resultIsNull?: InputMaybe<Scalars['Boolean']>;
  resultLike?: InputMaybe<Scalars['JSON']>;
  resultLikeNoCase?: InputMaybe<Scalars['JSON']>;
  resultLt?: InputMaybe<Scalars['JSON']>;
  resultLte?: InputMaybe<Scalars['JSON']>;
  resultNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  webHookEventData?: InputMaybe<Scalars['JSON']>;
  webHookEventDataAny?: InputMaybe<Scalars['JSON']>;
  webHookEventDataContain?: InputMaybe<Scalars['JSON']>;
  webHookEventDataEq?: InputMaybe<Scalars['JSON']>;
  webHookEventDataGt?: InputMaybe<Scalars['JSON']>;
  webHookEventDataGte?: InputMaybe<Scalars['JSON']>;
  webHookEventDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  webHookEventDataIsNull?: InputMaybe<Scalars['Boolean']>;
  webHookEventDataLike?: InputMaybe<Scalars['JSON']>;
  webHookEventDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  webHookEventDataLt?: InputMaybe<Scalars['JSON']>;
  webHookEventDataLte?: InputMaybe<Scalars['JSON']>;
  webHookEventDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};


export type GQLQueryAllFaqsArgs = {
  answer?: InputMaybe<Scalars['String']>;
  answerAny?: InputMaybe<Scalars['String']>;
  answerContain?: InputMaybe<Scalars['String']>;
  answerEq?: InputMaybe<Scalars['String']>;
  answerGt?: InputMaybe<Scalars['String']>;
  answerGte?: InputMaybe<Scalars['String']>;
  answerIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  answerIsNull?: InputMaybe<Scalars['Boolean']>;
  answerLike?: InputMaybe<Scalars['String']>;
  answerLikeNoCase?: InputMaybe<Scalars['String']>;
  answerLt?: InputMaybe<Scalars['String']>;
  answerLte?: InputMaybe<Scalars['String']>;
  answerNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedByAny?: InputMaybe<Scalars['String']>;
  deletedByContain?: InputMaybe<Scalars['String']>;
  deletedByEq?: InputMaybe<Scalars['String']>;
  deletedByGt?: InputMaybe<Scalars['String']>;
  deletedByGte?: InputMaybe<Scalars['String']>;
  deletedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedByIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedByLike?: InputMaybe<Scalars['String']>;
  deletedByLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedByLt?: InputMaybe<Scalars['String']>;
  deletedByLte?: InputMaybe<Scalars['String']>;
  deletedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLFaqsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLFaqsPropertiesEnum>;
  question?: InputMaybe<Scalars['String']>;
  questionAny?: InputMaybe<Scalars['String']>;
  questionContain?: InputMaybe<Scalars['String']>;
  questionEq?: InputMaybe<Scalars['String']>;
  questionGt?: InputMaybe<Scalars['String']>;
  questionGte?: InputMaybe<Scalars['String']>;
  questionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionIsNull?: InputMaybe<Scalars['Boolean']>;
  questionLike?: InputMaybe<Scalars['String']>;
  questionLikeNoCase?: InputMaybe<Scalars['String']>;
  questionLt?: InputMaybe<Scalars['String']>;
  questionLte?: InputMaybe<Scalars['String']>;
  questionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllFieldsArgs = {
  autocomplete?: InputMaybe<Scalars['String']>;
  autocompleteAny?: InputMaybe<Scalars['String']>;
  autocompleteContain?: InputMaybe<Scalars['String']>;
  autocompleteEq?: InputMaybe<Scalars['String']>;
  autocompleteGt?: InputMaybe<Scalars['String']>;
  autocompleteGte?: InputMaybe<Scalars['String']>;
  autocompleteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autocompleteIsNull?: InputMaybe<Scalars['Boolean']>;
  autocompleteLike?: InputMaybe<Scalars['String']>;
  autocompleteLikeNoCase?: InputMaybe<Scalars['String']>;
  autocompleteLt?: InputMaybe<Scalars['String']>;
  autocompleteLte?: InputMaybe<Scalars['String']>;
  autocompleteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  codeName?: InputMaybe<Scalars['String']>;
  codeNameAny?: InputMaybe<Scalars['String']>;
  codeNameContain?: InputMaybe<Scalars['String']>;
  codeNameEq?: InputMaybe<Scalars['String']>;
  codeNameGt?: InputMaybe<Scalars['String']>;
  codeNameGte?: InputMaybe<Scalars['String']>;
  codeNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  codeNameIsNull?: InputMaybe<Scalars['Boolean']>;
  codeNameLike?: InputMaybe<Scalars['String']>;
  codeNameLikeNoCase?: InputMaybe<Scalars['String']>;
  codeNameLt?: InputMaybe<Scalars['String']>;
  codeNameLte?: InputMaybe<Scalars['String']>;
  codeNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dataDependency?: InputMaybe<Scalars['JSON']>;
  dataDependencyAny?: InputMaybe<Scalars['JSON']>;
  dataDependencyContain?: InputMaybe<Scalars['JSON']>;
  dataDependencyEq?: InputMaybe<Scalars['JSON']>;
  dataDependencyGt?: InputMaybe<Scalars['JSON']>;
  dataDependencyGte?: InputMaybe<Scalars['JSON']>;
  dataDependencyIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  dataDependencyIsNull?: InputMaybe<Scalars['Boolean']>;
  dataDependencyLike?: InputMaybe<Scalars['JSON']>;
  dataDependencyLikeNoCase?: InputMaybe<Scalars['JSON']>;
  dataDependencyLt?: InputMaybe<Scalars['JSON']>;
  dataDependencyLte?: InputMaybe<Scalars['JSON']>;
  dataDependencyNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  defaultValue?: InputMaybe<Scalars['String']>;
  defaultValueAny?: InputMaybe<Scalars['String']>;
  defaultValueContain?: InputMaybe<Scalars['String']>;
  defaultValueEq?: InputMaybe<Scalars['String']>;
  defaultValueGt?: InputMaybe<Scalars['String']>;
  defaultValueGte?: InputMaybe<Scalars['String']>;
  defaultValueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultValueIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultValueLike?: InputMaybe<Scalars['String']>;
  defaultValueLikeNoCase?: InputMaybe<Scalars['String']>;
  defaultValueLt?: InputMaybe<Scalars['String']>;
  defaultValueLte?: InputMaybe<Scalars['String']>;
  defaultValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultValues?: InputMaybe<Scalars['JSON']>;
  defaultValuesAny?: InputMaybe<Scalars['JSON']>;
  defaultValuesContain?: InputMaybe<Scalars['JSON']>;
  defaultValuesEq?: InputMaybe<Scalars['JSON']>;
  defaultValuesGt?: InputMaybe<Scalars['JSON']>;
  defaultValuesGte?: InputMaybe<Scalars['JSON']>;
  defaultValuesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  defaultValuesIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultValuesLike?: InputMaybe<Scalars['JSON']>;
  defaultValuesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  defaultValuesLt?: InputMaybe<Scalars['JSON']>;
  defaultValuesLte?: InputMaybe<Scalars['JSON']>;
  defaultValuesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorMessageAny?: InputMaybe<Scalars['String']>;
  errorMessageContain?: InputMaybe<Scalars['String']>;
  errorMessageEq?: InputMaybe<Scalars['String']>;
  errorMessageGt?: InputMaybe<Scalars['String']>;
  errorMessageGte?: InputMaybe<Scalars['String']>;
  errorMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  errorMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  errorMessageLike?: InputMaybe<Scalars['String']>;
  errorMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  errorMessageLt?: InputMaybe<Scalars['String']>;
  errorMessageLte?: InputMaybe<Scalars['String']>;
  errorMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldType?: InputMaybe<Scalars['String']>;
  fieldTypeAny?: InputMaybe<Scalars['String']>;
  fieldTypeContain?: InputMaybe<Scalars['String']>;
  fieldTypeEq?: InputMaybe<Scalars['String']>;
  fieldTypeGt?: InputMaybe<Scalars['String']>;
  fieldTypeGte?: InputMaybe<Scalars['String']>;
  fieldTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  fieldTypeLike?: InputMaybe<Scalars['String']>;
  fieldTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  fieldTypeLt?: InputMaybe<Scalars['String']>;
  fieldTypeLte?: InputMaybe<Scalars['String']>;
  fieldTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  formId?: InputMaybe<Scalars['Int']>;
  formIdAny?: InputMaybe<Scalars['Int']>;
  formIdContain?: InputMaybe<Scalars['Int']>;
  formIdEq?: InputMaybe<Scalars['Int']>;
  formIdGt?: InputMaybe<Scalars['Int']>;
  formIdGte?: InputMaybe<Scalars['Int']>;
  formIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formIdIsNull?: InputMaybe<Scalars['Boolean']>;
  formIdLike?: InputMaybe<Scalars['Int']>;
  formIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  formIdLt?: InputMaybe<Scalars['Int']>;
  formIdLte?: InputMaybe<Scalars['Int']>;
  formIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  isGlobalAny?: InputMaybe<Scalars['Boolean']>;
  isGlobalContain?: InputMaybe<Scalars['Boolean']>;
  isGlobalEq?: InputMaybe<Scalars['Boolean']>;
  isGlobalGt?: InputMaybe<Scalars['Boolean']>;
  isGlobalGte?: InputMaybe<Scalars['Boolean']>;
  isGlobalIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isGlobalIsNull?: InputMaybe<Scalars['Boolean']>;
  isGlobalLike?: InputMaybe<Scalars['Boolean']>;
  isGlobalLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isGlobalLt?: InputMaybe<Scalars['Boolean']>;
  isGlobalLte?: InputMaybe<Scalars['Boolean']>;
  isGlobalNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mask?: InputMaybe<Scalars['String']>;
  maskAny?: InputMaybe<Scalars['String']>;
  maskContain?: InputMaybe<Scalars['String']>;
  maskEq?: InputMaybe<Scalars['String']>;
  maskGt?: InputMaybe<Scalars['String']>;
  maskGte?: InputMaybe<Scalars['String']>;
  maskIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maskIsNull?: InputMaybe<Scalars['Boolean']>;
  maskLike?: InputMaybe<Scalars['String']>;
  maskLikeNoCase?: InputMaybe<Scalars['String']>;
  maskLt?: InputMaybe<Scalars['String']>;
  maskLte?: InputMaybe<Scalars['String']>;
  maskNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxValue?: InputMaybe<Scalars['JSON']>;
  maxValueAny?: InputMaybe<Scalars['JSON']>;
  maxValueContain?: InputMaybe<Scalars['JSON']>;
  maxValueEq?: InputMaybe<Scalars['JSON']>;
  maxValueGt?: InputMaybe<Scalars['JSON']>;
  maxValueGte?: InputMaybe<Scalars['JSON']>;
  maxValueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  maxValueIsNull?: InputMaybe<Scalars['Boolean']>;
  maxValueLike?: InputMaybe<Scalars['JSON']>;
  maxValueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  maxValueLt?: InputMaybe<Scalars['JSON']>;
  maxValueLte?: InputMaybe<Scalars['JSON']>;
  maxValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  meta?: InputMaybe<Scalars['JSON']>;
  metaAny?: InputMaybe<Scalars['JSON']>;
  metaContain?: InputMaybe<Scalars['JSON']>;
  metaEq?: InputMaybe<Scalars['JSON']>;
  metaGt?: InputMaybe<Scalars['JSON']>;
  metaGte?: InputMaybe<Scalars['JSON']>;
  metaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  metaIsNull?: InputMaybe<Scalars['Boolean']>;
  metaLike?: InputMaybe<Scalars['JSON']>;
  metaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  metaLt?: InputMaybe<Scalars['JSON']>;
  metaLte?: InputMaybe<Scalars['JSON']>;
  metaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  minValue?: InputMaybe<Scalars['JSON']>;
  minValueAny?: InputMaybe<Scalars['JSON']>;
  minValueContain?: InputMaybe<Scalars['JSON']>;
  minValueEq?: InputMaybe<Scalars['JSON']>;
  minValueGt?: InputMaybe<Scalars['JSON']>;
  minValueGte?: InputMaybe<Scalars['JSON']>;
  minValueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  minValueIsNull?: InputMaybe<Scalars['Boolean']>;
  minValueLike?: InputMaybe<Scalars['JSON']>;
  minValueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  minValueLt?: InputMaybe<Scalars['JSON']>;
  minValueLte?: InputMaybe<Scalars['JSON']>;
  minValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  modifiedAt?: InputMaybe<Scalars['String']>;
  modifiedAtAny?: InputMaybe<Scalars['String']>;
  modifiedAtContain?: InputMaybe<Scalars['String']>;
  modifiedAtEq?: InputMaybe<Scalars['String']>;
  modifiedAtGt?: InputMaybe<Scalars['String']>;
  modifiedAtGte?: InputMaybe<Scalars['String']>;
  modifiedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedAtLike?: InputMaybe<Scalars['String']>;
  modifiedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedAtLt?: InputMaybe<Scalars['String']>;
  modifiedAtLte?: InputMaybe<Scalars['String']>;
  modifiedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  note?: InputMaybe<Scalars['String']>;
  noteAny?: InputMaybe<Scalars['String']>;
  noteContain?: InputMaybe<Scalars['String']>;
  noteEq?: InputMaybe<Scalars['String']>;
  noteGt?: InputMaybe<Scalars['String']>;
  noteGte?: InputMaybe<Scalars['String']>;
  noteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  noteIsNull?: InputMaybe<Scalars['Boolean']>;
  noteLike?: InputMaybe<Scalars['String']>;
  noteLikeNoCase?: InputMaybe<Scalars['String']>;
  noteLt?: InputMaybe<Scalars['String']>;
  noteLte?: InputMaybe<Scalars['String']>;
  noteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLFieldsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLFieldsPropertiesEnum>;
  pattern?: InputMaybe<Scalars['String']>;
  patternAny?: InputMaybe<Scalars['String']>;
  patternContain?: InputMaybe<Scalars['String']>;
  patternEq?: InputMaybe<Scalars['String']>;
  patternGt?: InputMaybe<Scalars['String']>;
  patternGte?: InputMaybe<Scalars['String']>;
  patternIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  patternIsNull?: InputMaybe<Scalars['Boolean']>;
  patternLike?: InputMaybe<Scalars['String']>;
  patternLikeNoCase?: InputMaybe<Scalars['String']>;
  patternLt?: InputMaybe<Scalars['String']>;
  patternLte?: InputMaybe<Scalars['String']>;
  patternNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeholder?: InputMaybe<Scalars['String']>;
  placeholderAny?: InputMaybe<Scalars['String']>;
  placeholderContain?: InputMaybe<Scalars['String']>;
  placeholderEq?: InputMaybe<Scalars['String']>;
  placeholderGt?: InputMaybe<Scalars['String']>;
  placeholderGte?: InputMaybe<Scalars['String']>;
  placeholderIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeholderIsNull?: InputMaybe<Scalars['Boolean']>;
  placeholderLike?: InputMaybe<Scalars['String']>;
  placeholderLikeNoCase?: InputMaybe<Scalars['String']>;
  placeholderLt?: InputMaybe<Scalars['String']>;
  placeholderLte?: InputMaybe<Scalars['String']>;
  placeholderNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCase?: InputMaybe<Scalars['String']>;
  useCaseAny?: InputMaybe<Scalars['String']>;
  useCaseContain?: InputMaybe<Scalars['String']>;
  useCaseEq?: InputMaybe<Scalars['String']>;
  useCaseGt?: InputMaybe<Scalars['String']>;
  useCaseGte?: InputMaybe<Scalars['String']>;
  useCaseIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCaseIsNull?: InputMaybe<Scalars['Boolean']>;
  useCaseLike?: InputMaybe<Scalars['String']>;
  useCaseLikeNoCase?: InputMaybe<Scalars['String']>;
  useCaseLt?: InputMaybe<Scalars['String']>;
  useCaseLte?: InputMaybe<Scalars['String']>;
  useCaseNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  validationType?: InputMaybe<Scalars['String']>;
  validationTypeAny?: InputMaybe<Scalars['String']>;
  validationTypeContain?: InputMaybe<Scalars['String']>;
  validationTypeEq?: InputMaybe<Scalars['String']>;
  validationTypeGt?: InputMaybe<Scalars['String']>;
  validationTypeGte?: InputMaybe<Scalars['String']>;
  validationTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  validationTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  validationTypeLike?: InputMaybe<Scalars['String']>;
  validationTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  validationTypeLt?: InputMaybe<Scalars['String']>;
  validationTypeLte?: InputMaybe<Scalars['String']>;
  validationTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllFieldsMetaArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLFieldsMetaPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLFieldsMetaPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllFormsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorMessageAny?: InputMaybe<Scalars['String']>;
  errorMessageContain?: InputMaybe<Scalars['String']>;
  errorMessageEq?: InputMaybe<Scalars['String']>;
  errorMessageGt?: InputMaybe<Scalars['String']>;
  errorMessageGte?: InputMaybe<Scalars['String']>;
  errorMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  errorMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  errorMessageLike?: InputMaybe<Scalars['String']>;
  errorMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  errorMessageLt?: InputMaybe<Scalars['String']>;
  errorMessageLte?: InputMaybe<Scalars['String']>;
  errorMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVariant?: InputMaybe<Scalars['Boolean']>;
  isVariantAny?: InputMaybe<Scalars['Boolean']>;
  isVariantContain?: InputMaybe<Scalars['Boolean']>;
  isVariantEq?: InputMaybe<Scalars['Boolean']>;
  isVariantGt?: InputMaybe<Scalars['Boolean']>;
  isVariantGte?: InputMaybe<Scalars['Boolean']>;
  isVariantIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVariantIsNull?: InputMaybe<Scalars['Boolean']>;
  isVariantLike?: InputMaybe<Scalars['Boolean']>;
  isVariantLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVariantLt?: InputMaybe<Scalars['Boolean']>;
  isVariantLte?: InputMaybe<Scalars['Boolean']>;
  isVariantNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingId?: InputMaybe<Scalars['Int']>;
  listingIdAny?: InputMaybe<Scalars['Int']>;
  listingIdContain?: InputMaybe<Scalars['Int']>;
  listingIdEq?: InputMaybe<Scalars['Int']>;
  listingIdGt?: InputMaybe<Scalars['Int']>;
  listingIdGte?: InputMaybe<Scalars['Int']>;
  listingIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingIdIsNull?: InputMaybe<Scalars['Boolean']>;
  listingIdLike?: InputMaybe<Scalars['Int']>;
  listingIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  listingIdLt?: InputMaybe<Scalars['Int']>;
  listingIdLte?: InputMaybe<Scalars['Int']>;
  listingIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modifiedAt?: InputMaybe<Scalars['String']>;
  modifiedAtAny?: InputMaybe<Scalars['String']>;
  modifiedAtContain?: InputMaybe<Scalars['String']>;
  modifiedAtEq?: InputMaybe<Scalars['String']>;
  modifiedAtGt?: InputMaybe<Scalars['String']>;
  modifiedAtGte?: InputMaybe<Scalars['String']>;
  modifiedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedAtLike?: InputMaybe<Scalars['String']>;
  modifiedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedAtLt?: InputMaybe<Scalars['String']>;
  modifiedAtLte?: InputMaybe<Scalars['String']>;
  modifiedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLFormsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLFormsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToFetchBuyers?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersAny?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersContain?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersEq?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersGt?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersGte?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToFetchBuyersIsNull?: InputMaybe<Scalars['Boolean']>;
  stepToFetchBuyersLike?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersLikeNoCase?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersLt?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersLte?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToSendingData?: InputMaybe<Scalars['Int']>;
  stepToSendingDataAny?: InputMaybe<Scalars['Int']>;
  stepToSendingDataContain?: InputMaybe<Scalars['Int']>;
  stepToSendingDataEq?: InputMaybe<Scalars['Int']>;
  stepToSendingDataGt?: InputMaybe<Scalars['Int']>;
  stepToSendingDataGte?: InputMaybe<Scalars['Int']>;
  stepToSendingDataIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToSendingDataIsNull?: InputMaybe<Scalars['Boolean']>;
  stepToSendingDataLike?: InputMaybe<Scalars['Int']>;
  stepToSendingDataLikeNoCase?: InputMaybe<Scalars['Int']>;
  stepToSendingDataLt?: InputMaybe<Scalars['Int']>;
  stepToSendingDataLte?: InputMaybe<Scalars['Int']>;
  stepToSendingDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  successMessage?: InputMaybe<Scalars['String']>;
  successMessageAny?: InputMaybe<Scalars['String']>;
  successMessageContain?: InputMaybe<Scalars['String']>;
  successMessageEq?: InputMaybe<Scalars['String']>;
  successMessageGt?: InputMaybe<Scalars['String']>;
  successMessageGte?: InputMaybe<Scalars['String']>;
  successMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  successMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  successMessageLike?: InputMaybe<Scalars['String']>;
  successMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  successMessageLt?: InputMaybe<Scalars['String']>;
  successMessageLte?: InputMaybe<Scalars['String']>;
  successMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  variantParentId?: InputMaybe<Scalars['Int']>;
  variantParentIdAny?: InputMaybe<Scalars['Int']>;
  variantParentIdContain?: InputMaybe<Scalars['Int']>;
  variantParentIdEq?: InputMaybe<Scalars['Int']>;
  variantParentIdGt?: InputMaybe<Scalars['Int']>;
  variantParentIdGte?: InputMaybe<Scalars['Int']>;
  variantParentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  variantParentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  variantParentIdLike?: InputMaybe<Scalars['Int']>;
  variantParentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  variantParentIdLt?: InputMaybe<Scalars['Int']>;
  variantParentIdLte?: InputMaybe<Scalars['Int']>;
  variantParentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLQueryAllIpAddressesArgs = {
  bannedAt?: InputMaybe<Scalars['String']>;
  bannedAtAny?: InputMaybe<Scalars['String']>;
  bannedAtContain?: InputMaybe<Scalars['String']>;
  bannedAtEq?: InputMaybe<Scalars['String']>;
  bannedAtGt?: InputMaybe<Scalars['String']>;
  bannedAtGte?: InputMaybe<Scalars['String']>;
  bannedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bannedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  bannedAtLike?: InputMaybe<Scalars['String']>;
  bannedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  bannedAtLt?: InputMaybe<Scalars['String']>;
  bannedAtLte?: InputMaybe<Scalars['String']>;
  bannedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<Scalars['String']>;
  cityAny?: InputMaybe<Scalars['String']>;
  cityContain?: InputMaybe<Scalars['String']>;
  cityEq?: InputMaybe<Scalars['String']>;
  cityGt?: InputMaybe<Scalars['String']>;
  cityGte?: InputMaybe<Scalars['String']>;
  cityIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityIsNull?: InputMaybe<Scalars['Boolean']>;
  cityLike?: InputMaybe<Scalars['String']>;
  cityLikeNoCase?: InputMaybe<Scalars['String']>;
  cityLt?: InputMaybe<Scalars['String']>;
  cityLte?: InputMaybe<Scalars['String']>;
  cityNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  continent?: InputMaybe<Scalars['String']>;
  continentAny?: InputMaybe<Scalars['String']>;
  continentCode?: InputMaybe<Scalars['String']>;
  continentCodeAny?: InputMaybe<Scalars['String']>;
  continentCodeContain?: InputMaybe<Scalars['String']>;
  continentCodeEq?: InputMaybe<Scalars['String']>;
  continentCodeGt?: InputMaybe<Scalars['String']>;
  continentCodeGte?: InputMaybe<Scalars['String']>;
  continentCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  continentCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  continentCodeLike?: InputMaybe<Scalars['String']>;
  continentCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  continentCodeLt?: InputMaybe<Scalars['String']>;
  continentCodeLte?: InputMaybe<Scalars['String']>;
  continentCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  continentContain?: InputMaybe<Scalars['String']>;
  continentEq?: InputMaybe<Scalars['String']>;
  continentGt?: InputMaybe<Scalars['String']>;
  continentGte?: InputMaybe<Scalars['String']>;
  continentIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  continentIsNull?: InputMaybe<Scalars['Boolean']>;
  continentLike?: InputMaybe<Scalars['String']>;
  continentLikeNoCase?: InputMaybe<Scalars['String']>;
  continentLt?: InputMaybe<Scalars['String']>;
  continentLte?: InputMaybe<Scalars['String']>;
  continentNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  country?: InputMaybe<Scalars['String']>;
  countryAny?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  countryCodeAny?: InputMaybe<Scalars['String']>;
  countryCodeContain?: InputMaybe<Scalars['String']>;
  countryCodeEq?: InputMaybe<Scalars['String']>;
  countryCodeGt?: InputMaybe<Scalars['String']>;
  countryCodeGte?: InputMaybe<Scalars['String']>;
  countryCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  countryCodeLike?: InputMaybe<Scalars['String']>;
  countryCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  countryCodeLt?: InputMaybe<Scalars['String']>;
  countryCodeLte?: InputMaybe<Scalars['String']>;
  countryCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryContain?: InputMaybe<Scalars['String']>;
  countryEq?: InputMaybe<Scalars['String']>;
  countryGt?: InputMaybe<Scalars['String']>;
  countryGte?: InputMaybe<Scalars['String']>;
  countryIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryIsNull?: InputMaybe<Scalars['Boolean']>;
  countryLike?: InputMaybe<Scalars['String']>;
  countryLikeNoCase?: InputMaybe<Scalars['String']>;
  countryLt?: InputMaybe<Scalars['String']>;
  countryLte?: InputMaybe<Scalars['String']>;
  countryNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  expireAt?: InputMaybe<Scalars['String']>;
  expireAtAny?: InputMaybe<Scalars['String']>;
  expireAtContain?: InputMaybe<Scalars['String']>;
  expireAtEq?: InputMaybe<Scalars['String']>;
  expireAtGt?: InputMaybe<Scalars['String']>;
  expireAtGte?: InputMaybe<Scalars['String']>;
  expireAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  expireAtIsNull?: InputMaybe<Scalars['Boolean']>;
  expireAtLike?: InputMaybe<Scalars['String']>;
  expireAtLikeNoCase?: InputMaybe<Scalars['String']>;
  expireAtLt?: InputMaybe<Scalars['String']>;
  expireAtLte?: InputMaybe<Scalars['String']>;
  expireAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ip?: InputMaybe<Scalars['String']>;
  ipAny?: InputMaybe<Scalars['String']>;
  ipContain?: InputMaybe<Scalars['String']>;
  ipEq?: InputMaybe<Scalars['String']>;
  ipGt?: InputMaybe<Scalars['String']>;
  ipGte?: InputMaybe<Scalars['String']>;
  ipIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ipIsNull?: InputMaybe<Scalars['Boolean']>;
  ipLike?: InputMaybe<Scalars['String']>;
  ipLikeNoCase?: InputMaybe<Scalars['String']>;
  ipLt?: InputMaybe<Scalars['String']>;
  ipLte?: InputMaybe<Scalars['String']>;
  ipNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBanned?: InputMaybe<Scalars['Boolean']>;
  isBannedAny?: InputMaybe<Scalars['Boolean']>;
  isBannedContain?: InputMaybe<Scalars['Boolean']>;
  isBannedEq?: InputMaybe<Scalars['Boolean']>;
  isBannedGt?: InputMaybe<Scalars['Boolean']>;
  isBannedGte?: InputMaybe<Scalars['Boolean']>;
  isBannedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBannedIsNull?: InputMaybe<Scalars['Boolean']>;
  isBannedLike?: InputMaybe<Scalars['Boolean']>;
  isBannedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBannedLt?: InputMaybe<Scalars['Boolean']>;
  isBannedLte?: InputMaybe<Scalars['Boolean']>;
  isBannedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isp?: InputMaybe<Scalars['String']>;
  ispAny?: InputMaybe<Scalars['String']>;
  ispContain?: InputMaybe<Scalars['String']>;
  ispEq?: InputMaybe<Scalars['String']>;
  ispGt?: InputMaybe<Scalars['String']>;
  ispGte?: InputMaybe<Scalars['String']>;
  ispIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ispIsNull?: InputMaybe<Scalars['Boolean']>;
  ispLike?: InputMaybe<Scalars['String']>;
  ispLikeNoCase?: InputMaybe<Scalars['String']>;
  ispLt?: InputMaybe<Scalars['String']>;
  ispLte?: InputMaybe<Scalars['String']>;
  ispNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  latitude?: InputMaybe<Scalars['String']>;
  latitudeAny?: InputMaybe<Scalars['String']>;
  latitudeContain?: InputMaybe<Scalars['String']>;
  latitudeEq?: InputMaybe<Scalars['String']>;
  latitudeGt?: InputMaybe<Scalars['String']>;
  latitudeGte?: InputMaybe<Scalars['String']>;
  latitudeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  latitudeIsNull?: InputMaybe<Scalars['Boolean']>;
  latitudeLike?: InputMaybe<Scalars['String']>;
  latitudeLikeNoCase?: InputMaybe<Scalars['String']>;
  latitudeLt?: InputMaybe<Scalars['String']>;
  latitudeLte?: InputMaybe<Scalars['String']>;
  latitudeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  longitude?: InputMaybe<Scalars['String']>;
  longitudeAny?: InputMaybe<Scalars['String']>;
  longitudeContain?: InputMaybe<Scalars['String']>;
  longitudeEq?: InputMaybe<Scalars['String']>;
  longitudeGt?: InputMaybe<Scalars['String']>;
  longitudeGte?: InputMaybe<Scalars['String']>;
  longitudeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  longitudeIsNull?: InputMaybe<Scalars['Boolean']>;
  longitudeLike?: InputMaybe<Scalars['String']>;
  longitudeLikeNoCase?: InputMaybe<Scalars['String']>;
  longitudeLt?: InputMaybe<Scalars['String']>;
  longitudeLte?: InputMaybe<Scalars['String']>;
  longitudeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLIpAddressesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLIpAddressesPropertiesEnum>;
  postalCode?: InputMaybe<Scalars['String']>;
  postalCodeAny?: InputMaybe<Scalars['String']>;
  postalCodeContain?: InputMaybe<Scalars['String']>;
  postalCodeEq?: InputMaybe<Scalars['String']>;
  postalCodeGt?: InputMaybe<Scalars['String']>;
  postalCodeGte?: InputMaybe<Scalars['String']>;
  postalCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  postalCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  postalCodeLike?: InputMaybe<Scalars['String']>;
  postalCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  postalCodeLt?: InputMaybe<Scalars['String']>;
  postalCodeLte?: InputMaybe<Scalars['String']>;
  postalCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  provider?: InputMaybe<Scalars['String']>;
  providerAny?: InputMaybe<Scalars['String']>;
  providerContain?: InputMaybe<Scalars['String']>;
  providerEq?: InputMaybe<Scalars['String']>;
  providerGt?: InputMaybe<Scalars['String']>;
  providerGte?: InputMaybe<Scalars['String']>;
  providerIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  providerIsNull?: InputMaybe<Scalars['Boolean']>;
  providerLike?: InputMaybe<Scalars['String']>;
  providerLikeNoCase?: InputMaybe<Scalars['String']>;
  providerLt?: InputMaybe<Scalars['String']>;
  providerLte?: InputMaybe<Scalars['String']>;
  providerNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  state?: InputMaybe<Scalars['String']>;
  stateAny?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
  stateCodeAny?: InputMaybe<Scalars['String']>;
  stateCodeContain?: InputMaybe<Scalars['String']>;
  stateCodeEq?: InputMaybe<Scalars['String']>;
  stateCodeGt?: InputMaybe<Scalars['String']>;
  stateCodeGte?: InputMaybe<Scalars['String']>;
  stateCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  stateCodeLike?: InputMaybe<Scalars['String']>;
  stateCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  stateCodeLt?: InputMaybe<Scalars['String']>;
  stateCodeLte?: InputMaybe<Scalars['String']>;
  stateCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateContain?: InputMaybe<Scalars['String']>;
  stateEq?: InputMaybe<Scalars['String']>;
  stateGt?: InputMaybe<Scalars['String']>;
  stateGte?: InputMaybe<Scalars['String']>;
  stateIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateIsNull?: InputMaybe<Scalars['Boolean']>;
  stateLike?: InputMaybe<Scalars['String']>;
  stateLikeNoCase?: InputMaybe<Scalars['String']>;
  stateLt?: InputMaybe<Scalars['String']>;
  stateLte?: InputMaybe<Scalars['String']>;
  stateNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllIpFallbackProviderLogArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fallbackProvider?: InputMaybe<Scalars['String']>;
  fallbackProviderAny?: InputMaybe<Scalars['String']>;
  fallbackProviderContain?: InputMaybe<Scalars['String']>;
  fallbackProviderData?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataAny?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataContain?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataEq?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataGt?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataGte?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  fallbackProviderDataIsNull?: InputMaybe<Scalars['Boolean']>;
  fallbackProviderDataLike?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataLt?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataLte?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  fallbackProviderEq?: InputMaybe<Scalars['String']>;
  fallbackProviderGt?: InputMaybe<Scalars['String']>;
  fallbackProviderGte?: InputMaybe<Scalars['String']>;
  fallbackProviderIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fallbackProviderIsNull?: InputMaybe<Scalars['Boolean']>;
  fallbackProviderLike?: InputMaybe<Scalars['String']>;
  fallbackProviderLikeNoCase?: InputMaybe<Scalars['String']>;
  fallbackProviderLt?: InputMaybe<Scalars['String']>;
  fallbackProviderLte?: InputMaybe<Scalars['String']>;
  fallbackProviderNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ipAddress?: InputMaybe<Scalars['String']>;
  ipAddressAny?: InputMaybe<Scalars['String']>;
  ipAddressContain?: InputMaybe<Scalars['String']>;
  ipAddressEq?: InputMaybe<Scalars['String']>;
  ipAddressGt?: InputMaybe<Scalars['String']>;
  ipAddressGte?: InputMaybe<Scalars['String']>;
  ipAddressId?: InputMaybe<Scalars['Int']>;
  ipAddressIdAny?: InputMaybe<Scalars['Int']>;
  ipAddressIdContain?: InputMaybe<Scalars['Int']>;
  ipAddressIdEq?: InputMaybe<Scalars['Int']>;
  ipAddressIdGt?: InputMaybe<Scalars['Int']>;
  ipAddressIdGte?: InputMaybe<Scalars['Int']>;
  ipAddressIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ipAddressIdIsNull?: InputMaybe<Scalars['Boolean']>;
  ipAddressIdLike?: InputMaybe<Scalars['Int']>;
  ipAddressIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  ipAddressIdLt?: InputMaybe<Scalars['Int']>;
  ipAddressIdLte?: InputMaybe<Scalars['Int']>;
  ipAddressIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ipAddressIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ipAddressIsNull?: InputMaybe<Scalars['Boolean']>;
  ipAddressLike?: InputMaybe<Scalars['String']>;
  ipAddressLikeNoCase?: InputMaybe<Scalars['String']>;
  ipAddressLt?: InputMaybe<Scalars['String']>;
  ipAddressLte?: InputMaybe<Scalars['String']>;
  ipAddressNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainProvider?: InputMaybe<Scalars['String']>;
  mainProviderAny?: InputMaybe<Scalars['String']>;
  mainProviderContain?: InputMaybe<Scalars['String']>;
  mainProviderData?: InputMaybe<Scalars['JSON']>;
  mainProviderDataAny?: InputMaybe<Scalars['JSON']>;
  mainProviderDataContain?: InputMaybe<Scalars['JSON']>;
  mainProviderDataEq?: InputMaybe<Scalars['JSON']>;
  mainProviderDataGt?: InputMaybe<Scalars['JSON']>;
  mainProviderDataGte?: InputMaybe<Scalars['JSON']>;
  mainProviderDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  mainProviderDataIsNull?: InputMaybe<Scalars['Boolean']>;
  mainProviderDataLike?: InputMaybe<Scalars['JSON']>;
  mainProviderDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  mainProviderDataLt?: InputMaybe<Scalars['JSON']>;
  mainProviderDataLte?: InputMaybe<Scalars['JSON']>;
  mainProviderDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  mainProviderEq?: InputMaybe<Scalars['String']>;
  mainProviderGt?: InputMaybe<Scalars['String']>;
  mainProviderGte?: InputMaybe<Scalars['String']>;
  mainProviderIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainProviderIsNull?: InputMaybe<Scalars['Boolean']>;
  mainProviderLike?: InputMaybe<Scalars['String']>;
  mainProviderLikeNoCase?: InputMaybe<Scalars['String']>;
  mainProviderLt?: InputMaybe<Scalars['String']>;
  mainProviderLte?: InputMaybe<Scalars['String']>;
  mainProviderNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLIpFallbackProviderLogPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLIpFallbackProviderLogPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllLeadConversionEventLogsArgs = {
  adNetworkId?: InputMaybe<Scalars['Int']>;
  adNetworkIdAny?: InputMaybe<Scalars['Int']>;
  adNetworkIdContain?: InputMaybe<Scalars['Int']>;
  adNetworkIdEq?: InputMaybe<Scalars['Int']>;
  adNetworkIdGt?: InputMaybe<Scalars['Int']>;
  adNetworkIdGte?: InputMaybe<Scalars['Int']>;
  adNetworkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  adNetworkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  adNetworkIdLike?: InputMaybe<Scalars['Int']>;
  adNetworkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  adNetworkIdLt?: InputMaybe<Scalars['Int']>;
  adNetworkIdLte?: InputMaybe<Scalars['Int']>;
  adNetworkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  event?: InputMaybe<Scalars['String']>;
  eventAny?: InputMaybe<Scalars['String']>;
  eventContain?: InputMaybe<Scalars['String']>;
  eventEq?: InputMaybe<Scalars['String']>;
  eventGt?: InputMaybe<Scalars['String']>;
  eventGte?: InputMaybe<Scalars['String']>;
  eventIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eventIsNull?: InputMaybe<Scalars['Boolean']>;
  eventLike?: InputMaybe<Scalars['String']>;
  eventLikeNoCase?: InputMaybe<Scalars['String']>;
  eventLt?: InputMaybe<Scalars['String']>;
  eventLte?: InputMaybe<Scalars['String']>;
  eventNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  formId?: InputMaybe<Scalars['Int']>;
  formIdAny?: InputMaybe<Scalars['Int']>;
  formIdContain?: InputMaybe<Scalars['Int']>;
  formIdEq?: InputMaybe<Scalars['Int']>;
  formIdGt?: InputMaybe<Scalars['Int']>;
  formIdGte?: InputMaybe<Scalars['Int']>;
  formIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formIdIsNull?: InputMaybe<Scalars['Boolean']>;
  formIdLike?: InputMaybe<Scalars['Int']>;
  formIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  formIdLt?: InputMaybe<Scalars['Int']>;
  formIdLte?: InputMaybe<Scalars['Int']>;
  formIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  leadId?: InputMaybe<Scalars['Int']>;
  leadIdAny?: InputMaybe<Scalars['Int']>;
  leadIdContain?: InputMaybe<Scalars['Int']>;
  leadIdEq?: InputMaybe<Scalars['Int']>;
  leadIdGt?: InputMaybe<Scalars['Int']>;
  leadIdGte?: InputMaybe<Scalars['Int']>;
  leadIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  leadIdIsNull?: InputMaybe<Scalars['Boolean']>;
  leadIdLike?: InputMaybe<Scalars['Int']>;
  leadIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  leadIdLt?: InputMaybe<Scalars['Int']>;
  leadIdLte?: InputMaybe<Scalars['Int']>;
  leadIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLLeadConversionEventLogsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLeadConversionEventLogsPropertiesEnum>;
  pixelId?: InputMaybe<Scalars['String']>;
  pixelIdAny?: InputMaybe<Scalars['String']>;
  pixelIdContain?: InputMaybe<Scalars['String']>;
  pixelIdEq?: InputMaybe<Scalars['String']>;
  pixelIdGt?: InputMaybe<Scalars['String']>;
  pixelIdGte?: InputMaybe<Scalars['String']>;
  pixelIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pixelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  pixelIdLike?: InputMaybe<Scalars['String']>;
  pixelIdLikeNoCase?: InputMaybe<Scalars['String']>;
  pixelIdLt?: InputMaybe<Scalars['String']>;
  pixelIdLte?: InputMaybe<Scalars['String']>;
  pixelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  request?: InputMaybe<Scalars['JSON']>;
  requestAny?: InputMaybe<Scalars['JSON']>;
  requestContain?: InputMaybe<Scalars['JSON']>;
  requestEq?: InputMaybe<Scalars['JSON']>;
  requestGt?: InputMaybe<Scalars['JSON']>;
  requestGte?: InputMaybe<Scalars['JSON']>;
  requestIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  requestIsNull?: InputMaybe<Scalars['Boolean']>;
  requestLike?: InputMaybe<Scalars['JSON']>;
  requestLikeNoCase?: InputMaybe<Scalars['JSON']>;
  requestLt?: InputMaybe<Scalars['JSON']>;
  requestLte?: InputMaybe<Scalars['JSON']>;
  requestNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  response?: InputMaybe<Scalars['JSON']>;
  responseAny?: InputMaybe<Scalars['JSON']>;
  responseContain?: InputMaybe<Scalars['JSON']>;
  responseEq?: InputMaybe<Scalars['JSON']>;
  responseGt?: InputMaybe<Scalars['JSON']>;
  responseGte?: InputMaybe<Scalars['JSON']>;
  responseIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  responseIsNull?: InputMaybe<Scalars['Boolean']>;
  responseLike?: InputMaybe<Scalars['JSON']>;
  responseLikeNoCase?: InputMaybe<Scalars['JSON']>;
  responseLt?: InputMaybe<Scalars['JSON']>;
  responseLte?: InputMaybe<Scalars['JSON']>;
  responseNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  status?: InputMaybe<Scalars['String']>;
  statusAny?: InputMaybe<Scalars['String']>;
  statusContain?: InputMaybe<Scalars['String']>;
  statusEq?: InputMaybe<Scalars['String']>;
  statusGt?: InputMaybe<Scalars['String']>;
  statusGte?: InputMaybe<Scalars['String']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statusIsNull?: InputMaybe<Scalars['Boolean']>;
  statusLike?: InputMaybe<Scalars['String']>;
  statusLikeNoCase?: InputMaybe<Scalars['String']>;
  statusLt?: InputMaybe<Scalars['String']>;
  statusLte?: InputMaybe<Scalars['String']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitId?: InputMaybe<Scalars['String']>;
  visitIdAny?: InputMaybe<Scalars['String']>;
  visitIdContain?: InputMaybe<Scalars['String']>;
  visitIdEq?: InputMaybe<Scalars['String']>;
  visitIdGt?: InputMaybe<Scalars['String']>;
  visitIdGte?: InputMaybe<Scalars['String']>;
  visitIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitIdIsNull?: InputMaybe<Scalars['Boolean']>;
  visitIdLike?: InputMaybe<Scalars['String']>;
  visitIdLikeNoCase?: InputMaybe<Scalars['String']>;
  visitIdLt?: InputMaybe<Scalars['String']>;
  visitIdLte?: InputMaybe<Scalars['String']>;
  visitIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllLeadTagsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  leadId?: InputMaybe<Scalars['Int']>;
  leadIdAny?: InputMaybe<Scalars['Int']>;
  leadIdContain?: InputMaybe<Scalars['Int']>;
  leadIdEq?: InputMaybe<Scalars['Int']>;
  leadIdGt?: InputMaybe<Scalars['Int']>;
  leadIdGte?: InputMaybe<Scalars['Int']>;
  leadIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  leadIdIsNull?: InputMaybe<Scalars['Boolean']>;
  leadIdLike?: InputMaybe<Scalars['Int']>;
  leadIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  leadIdLt?: InputMaybe<Scalars['Int']>;
  leadIdLte?: InputMaybe<Scalars['Int']>;
  leadIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLLeadTagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLeadTagsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tagId?: InputMaybe<Scalars['Int']>;
  tagIdAny?: InputMaybe<Scalars['Int']>;
  tagIdContain?: InputMaybe<Scalars['Int']>;
  tagIdEq?: InputMaybe<Scalars['Int']>;
  tagIdGt?: InputMaybe<Scalars['Int']>;
  tagIdGte?: InputMaybe<Scalars['Int']>;
  tagIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tagIdIsNull?: InputMaybe<Scalars['Boolean']>;
  tagIdLike?: InputMaybe<Scalars['Int']>;
  tagIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  tagIdLt?: InputMaybe<Scalars['Int']>;
  tagIdLte?: InputMaybe<Scalars['Int']>;
  tagIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllLeadsArgs = {
  advertisingNetworkId?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdAny?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdContain?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdEq?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdGt?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdGte?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  advertisingNetworkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  advertisingNetworkIdLike?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdLt?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdLte?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainFormId?: InputMaybe<Scalars['Int']>;
  domainFormIdAny?: InputMaybe<Scalars['Int']>;
  domainFormIdContain?: InputMaybe<Scalars['Int']>;
  domainFormIdEq?: InputMaybe<Scalars['Int']>;
  domainFormIdGt?: InputMaybe<Scalars['Int']>;
  domainFormIdGte?: InputMaybe<Scalars['Int']>;
  domainFormIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainFormIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainFormIdLike?: InputMaybe<Scalars['Int']>;
  domainFormIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainFormIdLt?: InputMaybe<Scalars['Int']>;
  domainFormIdLte?: InputMaybe<Scalars['Int']>;
  domainFormIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  feedback?: InputMaybe<Scalars['JSON']>;
  feedbackAny?: InputMaybe<Scalars['JSON']>;
  feedbackContain?: InputMaybe<Scalars['JSON']>;
  feedbackEq?: InputMaybe<Scalars['JSON']>;
  feedbackGt?: InputMaybe<Scalars['JSON']>;
  feedbackGte?: InputMaybe<Scalars['JSON']>;
  feedbackIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  feedbackIsNull?: InputMaybe<Scalars['Boolean']>;
  feedbackLike?: InputMaybe<Scalars['JSON']>;
  feedbackLikeNoCase?: InputMaybe<Scalars['JSON']>;
  feedbackLt?: InputMaybe<Scalars['JSON']>;
  feedbackLte?: InputMaybe<Scalars['JSON']>;
  feedbackNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  hasAliasCalls?: InputMaybe<Scalars['String']>;
  hasAliasCallsAny?: InputMaybe<Scalars['String']>;
  hasAliasCallsContain?: InputMaybe<Scalars['String']>;
  hasAliasCallsEq?: InputMaybe<Scalars['String']>;
  hasAliasCallsGt?: InputMaybe<Scalars['String']>;
  hasAliasCallsGte?: InputMaybe<Scalars['String']>;
  hasAliasCallsIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hasAliasCallsIsNull?: InputMaybe<Scalars['Boolean']>;
  hasAliasCallsLike?: InputMaybe<Scalars['String']>;
  hasAliasCallsLikeNoCase?: InputMaybe<Scalars['String']>;
  hasAliasCallsLt?: InputMaybe<Scalars['String']>;
  hasAliasCallsLte?: InputMaybe<Scalars['String']>;
  hasAliasCallsNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOptedOut?: InputMaybe<Scalars['Boolean']>;
  isOptedOutAny?: InputMaybe<Scalars['Boolean']>;
  isOptedOutContain?: InputMaybe<Scalars['Boolean']>;
  isOptedOutEq?: InputMaybe<Scalars['Boolean']>;
  isOptedOutGt?: InputMaybe<Scalars['Boolean']>;
  isOptedOutGte?: InputMaybe<Scalars['Boolean']>;
  isOptedOutIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOptedOutIsNull?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLike?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLt?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLte?: InputMaybe<Scalars['Boolean']>;
  isOptedOutNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  jornayaId?: InputMaybe<Scalars['String']>;
  jornayaIdAny?: InputMaybe<Scalars['String']>;
  jornayaIdContain?: InputMaybe<Scalars['String']>;
  jornayaIdEq?: InputMaybe<Scalars['String']>;
  jornayaIdGt?: InputMaybe<Scalars['String']>;
  jornayaIdGte?: InputMaybe<Scalars['String']>;
  jornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  jornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  jornayaIdLike?: InputMaybe<Scalars['String']>;
  jornayaIdLikeNoCase?: InputMaybe<Scalars['String']>;
  jornayaIdLt?: InputMaybe<Scalars['String']>;
  jornayaIdLte?: InputMaybe<Scalars['String']>;
  jornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modifiedAt?: InputMaybe<Scalars['String']>;
  modifiedAtAny?: InputMaybe<Scalars['String']>;
  modifiedAtContain?: InputMaybe<Scalars['String']>;
  modifiedAtEq?: InputMaybe<Scalars['String']>;
  modifiedAtGt?: InputMaybe<Scalars['String']>;
  modifiedAtGte?: InputMaybe<Scalars['String']>;
  modifiedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedAtLike?: InputMaybe<Scalars['String']>;
  modifiedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedAtLt?: InputMaybe<Scalars['String']>;
  modifiedAtLte?: InputMaybe<Scalars['String']>;
  modifiedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLLeadsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLeadsPropertiesEnum>;
  piiId?: InputMaybe<Scalars['Int']>;
  piiIdAny?: InputMaybe<Scalars['Int']>;
  piiIdContain?: InputMaybe<Scalars['Int']>;
  piiIdEq?: InputMaybe<Scalars['Int']>;
  piiIdGt?: InputMaybe<Scalars['Int']>;
  piiIdGte?: InputMaybe<Scalars['Int']>;
  piiIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  piiIdIsNull?: InputMaybe<Scalars['Boolean']>;
  piiIdLike?: InputMaybe<Scalars['Int']>;
  piiIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  piiIdLt?: InputMaybe<Scalars['Int']>;
  piiIdLte?: InputMaybe<Scalars['Int']>;
  piiIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sales?: InputMaybe<Scalars['String']>;
  salesAny?: InputMaybe<Scalars['String']>;
  salesContain?: InputMaybe<Scalars['String']>;
  salesEq?: InputMaybe<Scalars['String']>;
  salesGt?: InputMaybe<Scalars['String']>;
  salesGte?: InputMaybe<Scalars['String']>;
  salesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  salesIsNull?: InputMaybe<Scalars['Boolean']>;
  salesLike?: InputMaybe<Scalars['String']>;
  salesLikeNoCase?: InputMaybe<Scalars['String']>;
  salesLt?: InputMaybe<Scalars['String']>;
  salesLte?: InputMaybe<Scalars['String']>;
  salesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Scalars['String']>;
  statusAny?: InputMaybe<Scalars['String']>;
  statusContain?: InputMaybe<Scalars['String']>;
  statusEq?: InputMaybe<Scalars['String']>;
  statusGt?: InputMaybe<Scalars['String']>;
  statusGte?: InputMaybe<Scalars['String']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statusIsNull?: InputMaybe<Scalars['Boolean']>;
  statusLike?: InputMaybe<Scalars['String']>;
  statusLikeNoCase?: InputMaybe<Scalars['String']>;
  statusLt?: InputMaybe<Scalars['String']>;
  statusLte?: InputMaybe<Scalars['String']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  submissionStatus?: InputMaybe<Scalars['String']>;
  submissionStatusAny?: InputMaybe<Scalars['String']>;
  submissionStatusContain?: InputMaybe<Scalars['String']>;
  submissionStatusEq?: InputMaybe<Scalars['String']>;
  submissionStatusGt?: InputMaybe<Scalars['String']>;
  submissionStatusGte?: InputMaybe<Scalars['String']>;
  submissionStatusIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  submissionStatusIsNull?: InputMaybe<Scalars['Boolean']>;
  submissionStatusLike?: InputMaybe<Scalars['String']>;
  submissionStatusLikeNoCase?: InputMaybe<Scalars['String']>;
  submissionStatusLt?: InputMaybe<Scalars['String']>;
  submissionStatusLte?: InputMaybe<Scalars['String']>;
  submissionStatusNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficSource?: InputMaybe<Scalars['String']>;
  trafficSourceAny?: InputMaybe<Scalars['String']>;
  trafficSourceContain?: InputMaybe<Scalars['String']>;
  trafficSourceEq?: InputMaybe<Scalars['String']>;
  trafficSourceGt?: InputMaybe<Scalars['String']>;
  trafficSourceGte?: InputMaybe<Scalars['String']>;
  trafficSourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficSourceIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficSourceLike?: InputMaybe<Scalars['String']>;
  trafficSourceLikeNoCase?: InputMaybe<Scalars['String']>;
  trafficSourceLt?: InputMaybe<Scalars['String']>;
  trafficSourceLte?: InputMaybe<Scalars['String']>;
  trafficSourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficTypeId?: InputMaybe<Scalars['Int']>;
  trafficTypeIdAny?: InputMaybe<Scalars['Int']>;
  trafficTypeIdContain?: InputMaybe<Scalars['Int']>;
  trafficTypeIdEq?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  trafficTypeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficTypeIdLike?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  trustedFormCertificateClaimed?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedAny?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedContain?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedEq?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedGt?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedGte?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  trustedFormCertificateClaimedIsNull?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLike?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLt?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLte?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  trustedFormCertificateUrl?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlAny?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlContain?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlEq?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlGt?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlGte?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trustedFormCertificateUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateUrlLike?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlLt?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlLte?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uuid?: InputMaybe<Scalars['String']>;
  uuidAny?: InputMaybe<Scalars['String']>;
  uuidContain?: InputMaybe<Scalars['String']>;
  uuidEq?: InputMaybe<Scalars['String']>;
  uuidGt?: InputMaybe<Scalars['String']>;
  uuidGte?: InputMaybe<Scalars['String']>;
  uuidIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uuidIsNull?: InputMaybe<Scalars['Boolean']>;
  uuidLike?: InputMaybe<Scalars['String']>;
  uuidLikeNoCase?: InputMaybe<Scalars['String']>;
  uuidLt?: InputMaybe<Scalars['String']>;
  uuidLte?: InputMaybe<Scalars['String']>;
  uuidNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitData?: InputMaybe<Scalars['JSON']>;
  visitDataAny?: InputMaybe<Scalars['JSON']>;
  visitDataContain?: InputMaybe<Scalars['JSON']>;
  visitDataEq?: InputMaybe<Scalars['JSON']>;
  visitDataGt?: InputMaybe<Scalars['JSON']>;
  visitDataGte?: InputMaybe<Scalars['JSON']>;
  visitDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  visitDataIsNull?: InputMaybe<Scalars['Boolean']>;
  visitDataLike?: InputMaybe<Scalars['JSON']>;
  visitDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  visitDataLt?: InputMaybe<Scalars['JSON']>;
  visitDataLte?: InputMaybe<Scalars['JSON']>;
  visitDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  visitId?: InputMaybe<Scalars['String']>;
  visitIdAny?: InputMaybe<Scalars['String']>;
  visitIdContain?: InputMaybe<Scalars['String']>;
  visitIdEq?: InputMaybe<Scalars['String']>;
  visitIdGt?: InputMaybe<Scalars['String']>;
  visitIdGte?: InputMaybe<Scalars['String']>;
  visitIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitIdIsNull?: InputMaybe<Scalars['Boolean']>;
  visitIdLike?: InputMaybe<Scalars['String']>;
  visitIdLikeNoCase?: InputMaybe<Scalars['String']>;
  visitIdLt?: InputMaybe<Scalars['String']>;
  visitIdLte?: InputMaybe<Scalars['String']>;
  visitIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitorId?: InputMaybe<Scalars['String']>;
  visitorIdAny?: InputMaybe<Scalars['String']>;
  visitorIdContain?: InputMaybe<Scalars['String']>;
  visitorIdEq?: InputMaybe<Scalars['String']>;
  visitorIdGt?: InputMaybe<Scalars['String']>;
  visitorIdGte?: InputMaybe<Scalars['String']>;
  visitorIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitorIdIsNull?: InputMaybe<Scalars['Boolean']>;
  visitorIdLike?: InputMaybe<Scalars['String']>;
  visitorIdLikeNoCase?: InputMaybe<Scalars['String']>;
  visitorIdLt?: InputMaybe<Scalars['String']>;
  visitorIdLte?: InputMaybe<Scalars['String']>;
  visitorIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllLeadsMetadataArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leadId?: InputMaybe<Scalars['Int']>;
  leadIdAny?: InputMaybe<Scalars['Int']>;
  leadIdContain?: InputMaybe<Scalars['Int']>;
  leadIdEq?: InputMaybe<Scalars['Int']>;
  leadIdGt?: InputMaybe<Scalars['Int']>;
  leadIdGte?: InputMaybe<Scalars['Int']>;
  leadIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  leadIdIsNull?: InputMaybe<Scalars['Boolean']>;
  leadIdLike?: InputMaybe<Scalars['Int']>;
  leadIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  leadIdLt?: InputMaybe<Scalars['Int']>;
  leadIdLte?: InputMaybe<Scalars['Int']>;
  leadIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLLeadsMetadataPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLeadsMetadataPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllListingAttributesArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  hiddenAny?: InputMaybe<Scalars['Boolean']>;
  hiddenContain?: InputMaybe<Scalars['Boolean']>;
  hiddenEq?: InputMaybe<Scalars['Boolean']>;
  hiddenGt?: InputMaybe<Scalars['Boolean']>;
  hiddenGte?: InputMaybe<Scalars['Boolean']>;
  hiddenIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  hiddenIsNull?: InputMaybe<Scalars['Boolean']>;
  hiddenLike?: InputMaybe<Scalars['Boolean']>;
  hiddenLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  hiddenLt?: InputMaybe<Scalars['Boolean']>;
  hiddenLte?: InputMaybe<Scalars['Boolean']>;
  hiddenNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingId?: InputMaybe<Scalars['Int']>;
  listingIdAny?: InputMaybe<Scalars['Int']>;
  listingIdContain?: InputMaybe<Scalars['Int']>;
  listingIdEq?: InputMaybe<Scalars['Int']>;
  listingIdGt?: InputMaybe<Scalars['Int']>;
  listingIdGte?: InputMaybe<Scalars['Int']>;
  listingIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingIdIsNull?: InputMaybe<Scalars['Boolean']>;
  listingIdLike?: InputMaybe<Scalars['Int']>;
  listingIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  listingIdLt?: InputMaybe<Scalars['Int']>;
  listingIdLte?: InputMaybe<Scalars['Int']>;
  listingIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLListingAttributesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLListingAttributesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllListingFeaturesArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingId?: InputMaybe<Scalars['Int']>;
  listingIdAny?: InputMaybe<Scalars['Int']>;
  listingIdContain?: InputMaybe<Scalars['Int']>;
  listingIdEq?: InputMaybe<Scalars['Int']>;
  listingIdGt?: InputMaybe<Scalars['Int']>;
  listingIdGte?: InputMaybe<Scalars['Int']>;
  listingIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingIdIsNull?: InputMaybe<Scalars['Boolean']>;
  listingIdLike?: InputMaybe<Scalars['Int']>;
  listingIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  listingIdLt?: InputMaybe<Scalars['Int']>;
  listingIdLte?: InputMaybe<Scalars['Int']>;
  listingIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLListingFeaturesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLListingFeaturesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllListingsArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLListingsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLListingsPropertiesEnum>;
  pageTitle?: InputMaybe<Scalars['String']>;
  pageTitleAny?: InputMaybe<Scalars['String']>;
  pageTitleContain?: InputMaybe<Scalars['String']>;
  pageTitleEq?: InputMaybe<Scalars['String']>;
  pageTitleGt?: InputMaybe<Scalars['String']>;
  pageTitleGte?: InputMaybe<Scalars['String']>;
  pageTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  pageTitleLike?: InputMaybe<Scalars['String']>;
  pageTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  pageTitleLt?: InputMaybe<Scalars['String']>;
  pageTitleLte?: InputMaybe<Scalars['String']>;
  pageTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllLookupsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLLookupsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLookupsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllLookupsVariationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lookupId?: InputMaybe<Scalars['Int']>;
  lookupIdAny?: InputMaybe<Scalars['Int']>;
  lookupIdContain?: InputMaybe<Scalars['Int']>;
  lookupIdEq?: InputMaybe<Scalars['Int']>;
  lookupIdGt?: InputMaybe<Scalars['Int']>;
  lookupIdGte?: InputMaybe<Scalars['Int']>;
  lookupIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lookupIdIsNull?: InputMaybe<Scalars['Boolean']>;
  lookupIdLike?: InputMaybe<Scalars['Int']>;
  lookupIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  lookupIdLt?: InputMaybe<Scalars['Int']>;
  lookupIdLte?: InputMaybe<Scalars['Int']>;
  lookupIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLLookupsVariationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLookupsVariationsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  variationId?: InputMaybe<Scalars['Int']>;
  variationIdAny?: InputMaybe<Scalars['Int']>;
  variationIdContain?: InputMaybe<Scalars['Int']>;
  variationIdEq?: InputMaybe<Scalars['Int']>;
  variationIdGt?: InputMaybe<Scalars['Int']>;
  variationIdGte?: InputMaybe<Scalars['Int']>;
  variationIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  variationIdIsNull?: InputMaybe<Scalars['Boolean']>;
  variationIdLike?: InputMaybe<Scalars['Int']>;
  variationIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  variationIdLt?: InputMaybe<Scalars['Int']>;
  variationIdLte?: InputMaybe<Scalars['Int']>;
  variationIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLQueryAllMenuItemsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  link?: InputMaybe<Scalars['String']>;
  linkAny?: InputMaybe<Scalars['String']>;
  linkContain?: InputMaybe<Scalars['String']>;
  linkEq?: InputMaybe<Scalars['String']>;
  linkGt?: InputMaybe<Scalars['String']>;
  linkGte?: InputMaybe<Scalars['String']>;
  linkIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkIsNull?: InputMaybe<Scalars['Boolean']>;
  linkLike?: InputMaybe<Scalars['String']>;
  linkLikeNoCase?: InputMaybe<Scalars['String']>;
  linkLt?: InputMaybe<Scalars['String']>;
  linkLte?: InputMaybe<Scalars['String']>;
  linkNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  menuId?: InputMaybe<Scalars['Int']>;
  menuIdAny?: InputMaybe<Scalars['Int']>;
  menuIdContain?: InputMaybe<Scalars['Int']>;
  menuIdEq?: InputMaybe<Scalars['Int']>;
  menuIdGt?: InputMaybe<Scalars['Int']>;
  menuIdGte?: InputMaybe<Scalars['Int']>;
  menuIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  menuIdIsNull?: InputMaybe<Scalars['Boolean']>;
  menuIdLike?: InputMaybe<Scalars['Int']>;
  menuIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  menuIdLt?: InputMaybe<Scalars['Int']>;
  menuIdLte?: InputMaybe<Scalars['Int']>;
  menuIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLMenuItemsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLMenuItemsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllMenusArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLMenusPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLMenusPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllMetatagsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  model?: InputMaybe<Scalars['String']>;
  modelAny?: InputMaybe<Scalars['String']>;
  modelContain?: InputMaybe<Scalars['String']>;
  modelEq?: InputMaybe<Scalars['String']>;
  modelGt?: InputMaybe<Scalars['String']>;
  modelGte?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIsNull?: InputMaybe<Scalars['Boolean']>;
  modelLike?: InputMaybe<Scalars['String']>;
  modelLikeNoCase?: InputMaybe<Scalars['String']>;
  modelLt?: InputMaybe<Scalars['String']>;
  modelLte?: InputMaybe<Scalars['String']>;
  modelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLMetatagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLMetatagsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllOfferCategoriesArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLOfferCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOfferCategoriesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllOfferFeaturesArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLOfferFeaturesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOfferFeaturesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllOfferSchedulesArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLOfferSchedulesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOfferSchedulesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  schedule?: InputMaybe<Scalars['JSON']>;
  scheduleAny?: InputMaybe<Scalars['JSON']>;
  scheduleContain?: InputMaybe<Scalars['JSON']>;
  scheduleEq?: InputMaybe<Scalars['JSON']>;
  scheduleGt?: InputMaybe<Scalars['JSON']>;
  scheduleGte?: InputMaybe<Scalars['JSON']>;
  scheduleIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  scheduleIsNull?: InputMaybe<Scalars['Boolean']>;
  scheduleLike?: InputMaybe<Scalars['JSON']>;
  scheduleLikeNoCase?: InputMaybe<Scalars['JSON']>;
  scheduleLt?: InputMaybe<Scalars['JSON']>;
  scheduleLte?: InputMaybe<Scalars['JSON']>;
  scheduleNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  timeZone?: InputMaybe<Scalars['String']>;
  timeZoneAny?: InputMaybe<Scalars['String']>;
  timeZoneContain?: InputMaybe<Scalars['String']>;
  timeZoneEq?: InputMaybe<Scalars['String']>;
  timeZoneGt?: InputMaybe<Scalars['String']>;
  timeZoneGte?: InputMaybe<Scalars['String']>;
  timeZoneIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  timeZoneIsNull?: InputMaybe<Scalars['Boolean']>;
  timeZoneLike?: InputMaybe<Scalars['String']>;
  timeZoneLikeNoCase?: InputMaybe<Scalars['String']>;
  timeZoneLt?: InputMaybe<Scalars['String']>;
  timeZoneLte?: InputMaybe<Scalars['String']>;
  timeZoneNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllOffersArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checkWallet?: InputMaybe<Scalars['Boolean']>;
  checkWalletAny?: InputMaybe<Scalars['Boolean']>;
  checkWalletContain?: InputMaybe<Scalars['Boolean']>;
  checkWalletEq?: InputMaybe<Scalars['Boolean']>;
  checkWalletGt?: InputMaybe<Scalars['Boolean']>;
  checkWalletGte?: InputMaybe<Scalars['Boolean']>;
  checkWalletIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  checkWalletIsNull?: InputMaybe<Scalars['Boolean']>;
  checkWalletLike?: InputMaybe<Scalars['Boolean']>;
  checkWalletLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  checkWalletLt?: InputMaybe<Scalars['Boolean']>;
  checkWalletLte?: InputMaybe<Scalars['Boolean']>;
  checkWalletNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultAffiliateLinkId?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdAny?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdContain?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdEq?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  defaultAffiliateLinkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultAffiliateLinkIdLike?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrl?: InputMaybe<Scalars['String']>;
  displayUrlAny?: InputMaybe<Scalars['String']>;
  displayUrlContain?: InputMaybe<Scalars['String']>;
  displayUrlEq?: InputMaybe<Scalars['String']>;
  displayUrlGt?: InputMaybe<Scalars['String']>;
  displayUrlGte?: InputMaybe<Scalars['String']>;
  displayUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  displayUrlLike?: InputMaybe<Scalars['String']>;
  displayUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  displayUrlLt?: InputMaybe<Scalars['String']>;
  displayUrlLte?: InputMaybe<Scalars['String']>;
  displayUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalData?: InputMaybe<Scalars['JSON']>;
  externalDataAny?: InputMaybe<Scalars['JSON']>;
  externalDataContain?: InputMaybe<Scalars['JSON']>;
  externalDataEq?: InputMaybe<Scalars['JSON']>;
  externalDataGt?: InputMaybe<Scalars['JSON']>;
  externalDataGte?: InputMaybe<Scalars['JSON']>;
  externalDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  externalDataIsNull?: InputMaybe<Scalars['Boolean']>;
  externalDataLike?: InputMaybe<Scalars['JSON']>;
  externalDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  externalDataLt?: InputMaybe<Scalars['JSON']>;
  externalDataLte?: InputMaybe<Scalars['JSON']>;
  externalDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  featuresListTitle?: InputMaybe<Scalars['String']>;
  featuresListTitleAny?: InputMaybe<Scalars['String']>;
  featuresListTitleContain?: InputMaybe<Scalars['String']>;
  featuresListTitleEq?: InputMaybe<Scalars['String']>;
  featuresListTitleGt?: InputMaybe<Scalars['String']>;
  featuresListTitleGte?: InputMaybe<Scalars['String']>;
  featuresListTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuresListTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  featuresListTitleLike?: InputMaybe<Scalars['String']>;
  featuresListTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  featuresListTitleLt?: InputMaybe<Scalars['String']>;
  featuresListTitleLte?: InputMaybe<Scalars['String']>;
  featuresListTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  isPausedAny?: InputMaybe<Scalars['Boolean']>;
  isPausedContain?: InputMaybe<Scalars['Boolean']>;
  isPausedEq?: InputMaybe<Scalars['Boolean']>;
  isPausedGt?: InputMaybe<Scalars['Boolean']>;
  isPausedGte?: InputMaybe<Scalars['Boolean']>;
  isPausedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPausedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPausedLike?: InputMaybe<Scalars['Boolean']>;
  isPausedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPausedLt?: InputMaybe<Scalars['Boolean']>;
  isPausedLte?: InputMaybe<Scalars['Boolean']>;
  isPausedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldOverview?: InputMaybe<Scalars['String']>;
  oldOverviewAny?: InputMaybe<Scalars['String']>;
  oldOverviewContain?: InputMaybe<Scalars['String']>;
  oldOverviewEq?: InputMaybe<Scalars['String']>;
  oldOverviewGt?: InputMaybe<Scalars['String']>;
  oldOverviewGte?: InputMaybe<Scalars['String']>;
  oldOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  oldOverviewLike?: InputMaybe<Scalars['String']>;
  oldOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  oldOverviewLt?: InputMaybe<Scalars['String']>;
  oldOverviewLte?: InputMaybe<Scalars['String']>;
  oldOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOffersPropertiesEnum>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescription?: InputMaybe<Scalars['String']>;
  previewDescriptionAny?: InputMaybe<Scalars['String']>;
  previewDescriptionContain?: InputMaybe<Scalars['String']>;
  previewDescriptionEq?: InputMaybe<Scalars['String']>;
  previewDescriptionGt?: InputMaybe<Scalars['String']>;
  previewDescriptionGte?: InputMaybe<Scalars['String']>;
  previewDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  previewDescriptionLike?: InputMaybe<Scalars['String']>;
  previewDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  previewDescriptionLt?: InputMaybe<Scalars['String']>;
  previewDescriptionLte?: InputMaybe<Scalars['String']>;
  previewDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverview?: InputMaybe<Scalars['String']>;
  quickOverviewAny?: InputMaybe<Scalars['String']>;
  quickOverviewContain?: InputMaybe<Scalars['String']>;
  quickOverviewEq?: InputMaybe<Scalars['String']>;
  quickOverviewGt?: InputMaybe<Scalars['String']>;
  quickOverviewGte?: InputMaybe<Scalars['String']>;
  quickOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  quickOverviewLike?: InputMaybe<Scalars['String']>;
  quickOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  quickOverviewLt?: InputMaybe<Scalars['String']>;
  quickOverviewLte?: InputMaybe<Scalars['String']>;
  quickOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  score?: InputMaybe<Scalars['Float']>;
  scoreAny?: InputMaybe<Scalars['Float']>;
  scoreContain?: InputMaybe<Scalars['Float']>;
  scoreEq?: InputMaybe<Scalars['Float']>;
  scoreGt?: InputMaybe<Scalars['Float']>;
  scoreGte?: InputMaybe<Scalars['Float']>;
  scoreIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  scoreIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreLike?: InputMaybe<Scalars['Float']>;
  scoreLikeNoCase?: InputMaybe<Scalars['Float']>;
  scoreLt?: InputMaybe<Scalars['Float']>;
  scoreLte?: InputMaybe<Scalars['Float']>;
  scoreMessage?: InputMaybe<Scalars['String']>;
  scoreMessageAny?: InputMaybe<Scalars['String']>;
  scoreMessageContain?: InputMaybe<Scalars['String']>;
  scoreMessageEq?: InputMaybe<Scalars['String']>;
  scoreMessageGt?: InputMaybe<Scalars['String']>;
  scoreMessageGte?: InputMaybe<Scalars['String']>;
  scoreMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreMessageLike?: InputMaybe<Scalars['String']>;
  scoreMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  scoreMessageLt?: InputMaybe<Scalars['String']>;
  scoreMessageLte?: InputMaybe<Scalars['String']>;
  scoreMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleAny?: InputMaybe<Scalars['String']>;
  subTitleContain?: InputMaybe<Scalars['String']>;
  subTitleEq?: InputMaybe<Scalars['String']>;
  subTitleGt?: InputMaybe<Scalars['String']>;
  subTitleGte?: InputMaybe<Scalars['String']>;
  subTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subTitleLike?: InputMaybe<Scalars['String']>;
  subTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subTitleLt?: InputMaybe<Scalars['String']>;
  subTitleLte?: InputMaybe<Scalars['String']>;
  subTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescription?: InputMaybe<Scalars['String']>;
  summaryDescriptionAny?: InputMaybe<Scalars['String']>;
  summaryDescriptionContain?: InputMaybe<Scalars['String']>;
  summaryDescriptionEq?: InputMaybe<Scalars['String']>;
  summaryDescriptionGt?: InputMaybe<Scalars['String']>;
  summaryDescriptionGte?: InputMaybe<Scalars['String']>;
  summaryDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryDescriptionLike?: InputMaybe<Scalars['String']>;
  summaryDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryDescriptionLt?: InputMaybe<Scalars['String']>;
  summaryDescriptionLte?: InputMaybe<Scalars['String']>;
  summaryDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitle?: InputMaybe<Scalars['String']>;
  summaryTitleAny?: InputMaybe<Scalars['String']>;
  summaryTitleContain?: InputMaybe<Scalars['String']>;
  summaryTitleEq?: InputMaybe<Scalars['String']>;
  summaryTitleGt?: InputMaybe<Scalars['String']>;
  summaryTitleGte?: InputMaybe<Scalars['String']>;
  summaryTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryTitleLike?: InputMaybe<Scalars['String']>;
  summaryTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryTitleLt?: InputMaybe<Scalars['String']>;
  summaryTitleLte?: InputMaybe<Scalars['String']>;
  summaryTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllPersonalIdentifiableInformationArgs = {
  aliasPhoneNumber?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberAny?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberContain?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberEq?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberGt?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberGte?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  aliasPhoneNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  aliasPhoneNumberLike?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberLt?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberLte?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  birthdate?: InputMaybe<Scalars['String']>;
  birthdateAny?: InputMaybe<Scalars['String']>;
  birthdateContain?: InputMaybe<Scalars['String']>;
  birthdateEq?: InputMaybe<Scalars['String']>;
  birthdateGt?: InputMaybe<Scalars['String']>;
  birthdateGte?: InputMaybe<Scalars['String']>;
  birthdateIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  birthdateIsNull?: InputMaybe<Scalars['Boolean']>;
  birthdateLike?: InputMaybe<Scalars['String']>;
  birthdateLikeNoCase?: InputMaybe<Scalars['String']>;
  birthdateLt?: InputMaybe<Scalars['String']>;
  birthdateLte?: InputMaybe<Scalars['String']>;
  birthdateNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<Scalars['String']>;
  cityAny?: InputMaybe<Scalars['String']>;
  cityContain?: InputMaybe<Scalars['String']>;
  cityEq?: InputMaybe<Scalars['String']>;
  cityGt?: InputMaybe<Scalars['String']>;
  cityGte?: InputMaybe<Scalars['String']>;
  cityIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityIsNull?: InputMaybe<Scalars['Boolean']>;
  cityLike?: InputMaybe<Scalars['String']>;
  cityLikeNoCase?: InputMaybe<Scalars['String']>;
  cityLt?: InputMaybe<Scalars['String']>;
  cityLte?: InputMaybe<Scalars['String']>;
  cityNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  country?: InputMaybe<Scalars['String']>;
  countryAny?: InputMaybe<Scalars['String']>;
  countryContain?: InputMaybe<Scalars['String']>;
  countryEq?: InputMaybe<Scalars['String']>;
  countryGt?: InputMaybe<Scalars['String']>;
  countryGte?: InputMaybe<Scalars['String']>;
  countryIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryIsNull?: InputMaybe<Scalars['Boolean']>;
  countryLike?: InputMaybe<Scalars['String']>;
  countryLikeNoCase?: InputMaybe<Scalars['String']>;
  countryLt?: InputMaybe<Scalars['String']>;
  countryLte?: InputMaybe<Scalars['String']>;
  countryNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  county?: InputMaybe<Scalars['String']>;
  countyAny?: InputMaybe<Scalars['String']>;
  countyContain?: InputMaybe<Scalars['String']>;
  countyEq?: InputMaybe<Scalars['String']>;
  countyGt?: InputMaybe<Scalars['String']>;
  countyGte?: InputMaybe<Scalars['String']>;
  countyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countyIsNull?: InputMaybe<Scalars['Boolean']>;
  countyLike?: InputMaybe<Scalars['String']>;
  countyLikeNoCase?: InputMaybe<Scalars['String']>;
  countyLt?: InputMaybe<Scalars['String']>;
  countyLte?: InputMaybe<Scalars['String']>;
  countyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  dma?: InputMaybe<Scalars['Boolean']>;
  dmaAny?: InputMaybe<Scalars['Boolean']>;
  dmaContain?: InputMaybe<Scalars['Boolean']>;
  dmaEq?: InputMaybe<Scalars['Boolean']>;
  dmaGt?: InputMaybe<Scalars['Boolean']>;
  dmaGte?: InputMaybe<Scalars['Boolean']>;
  dmaIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  dmaIsNull?: InputMaybe<Scalars['Boolean']>;
  dmaLike?: InputMaybe<Scalars['Boolean']>;
  dmaLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  dmaLt?: InputMaybe<Scalars['Boolean']>;
  dmaLte?: InputMaybe<Scalars['Boolean']>;
  dmaNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  firstName?: InputMaybe<Scalars['String']>;
  firstNameAny?: InputMaybe<Scalars['String']>;
  firstNameContain?: InputMaybe<Scalars['String']>;
  firstNameEq?: InputMaybe<Scalars['String']>;
  firstNameGt?: InputMaybe<Scalars['String']>;
  firstNameGte?: InputMaybe<Scalars['String']>;
  firstNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  firstNameIsNull?: InputMaybe<Scalars['Boolean']>;
  firstNameLike?: InputMaybe<Scalars['String']>;
  firstNameLikeNoCase?: InputMaybe<Scalars['String']>;
  firstNameLt?: InputMaybe<Scalars['String']>;
  firstNameLte?: InputMaybe<Scalars['String']>;
  firstNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ipAddress?: InputMaybe<Scalars['String']>;
  ipAddressAny?: InputMaybe<Scalars['String']>;
  ipAddressContain?: InputMaybe<Scalars['String']>;
  ipAddressEq?: InputMaybe<Scalars['String']>;
  ipAddressGt?: InputMaybe<Scalars['String']>;
  ipAddressGte?: InputMaybe<Scalars['String']>;
  ipAddressIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ipAddressIsNull?: InputMaybe<Scalars['Boolean']>;
  ipAddressLike?: InputMaybe<Scalars['String']>;
  ipAddressLikeNoCase?: InputMaybe<Scalars['String']>;
  ipAddressLt?: InputMaybe<Scalars['String']>;
  ipAddressLte?: InputMaybe<Scalars['String']>;
  ipAddressNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBizEmail?: InputMaybe<Scalars['Boolean']>;
  isBizEmailAny?: InputMaybe<Scalars['Boolean']>;
  isBizEmailContain?: InputMaybe<Scalars['Boolean']>;
  isBizEmailEq?: InputMaybe<Scalars['Boolean']>;
  isBizEmailGt?: InputMaybe<Scalars['Boolean']>;
  isBizEmailGte?: InputMaybe<Scalars['Boolean']>;
  isBizEmailIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBizEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  isBizEmailLike?: InputMaybe<Scalars['Boolean']>;
  isBizEmailLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBizEmailLt?: InputMaybe<Scalars['Boolean']>;
  isBizEmailLte?: InputMaybe<Scalars['Boolean']>;
  isBizEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lastName?: InputMaybe<Scalars['String']>;
  lastNameAny?: InputMaybe<Scalars['String']>;
  lastNameContain?: InputMaybe<Scalars['String']>;
  lastNameEq?: InputMaybe<Scalars['String']>;
  lastNameGt?: InputMaybe<Scalars['String']>;
  lastNameGte?: InputMaybe<Scalars['String']>;
  lastNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lastNameIsNull?: InputMaybe<Scalars['Boolean']>;
  lastNameLike?: InputMaybe<Scalars['String']>;
  lastNameLikeNoCase?: InputMaybe<Scalars['String']>;
  lastNameLt?: InputMaybe<Scalars['String']>;
  lastNameLte?: InputMaybe<Scalars['String']>;
  lastNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  litigator?: InputMaybe<Scalars['Boolean']>;
  litigatorAny?: InputMaybe<Scalars['Boolean']>;
  litigatorContain?: InputMaybe<Scalars['Boolean']>;
  litigatorEq?: InputMaybe<Scalars['Boolean']>;
  litigatorGt?: InputMaybe<Scalars['Boolean']>;
  litigatorGte?: InputMaybe<Scalars['Boolean']>;
  litigatorIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  litigatorIsNull?: InputMaybe<Scalars['Boolean']>;
  litigatorLike?: InputMaybe<Scalars['Boolean']>;
  litigatorLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  litigatorLt?: InputMaybe<Scalars['Boolean']>;
  litigatorLte?: InputMaybe<Scalars['Boolean']>;
  litigatorNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  metaData?: InputMaybe<Scalars['String']>;
  metaDataAny?: InputMaybe<Scalars['String']>;
  metaDataContain?: InputMaybe<Scalars['String']>;
  metaDataEq?: InputMaybe<Scalars['String']>;
  metaDataGt?: InputMaybe<Scalars['String']>;
  metaDataGte?: InputMaybe<Scalars['String']>;
  metaDataIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  metaDataIsNull?: InputMaybe<Scalars['Boolean']>;
  metaDataLike?: InputMaybe<Scalars['String']>;
  metaDataLikeNoCase?: InputMaybe<Scalars['String']>;
  metaDataLt?: InputMaybe<Scalars['String']>;
  metaDataLte?: InputMaybe<Scalars['String']>;
  metaDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAt?: InputMaybe<Scalars['String']>;
  modifiedAtAny?: InputMaybe<Scalars['String']>;
  modifiedAtContain?: InputMaybe<Scalars['String']>;
  modifiedAtEq?: InputMaybe<Scalars['String']>;
  modifiedAtGt?: InputMaybe<Scalars['String']>;
  modifiedAtGte?: InputMaybe<Scalars['String']>;
  modifiedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedAtLike?: InputMaybe<Scalars['String']>;
  modifiedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedAtLt?: InputMaybe<Scalars['String']>;
  modifiedAtLte?: InputMaybe<Scalars['String']>;
  modifiedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nationalDnc?: InputMaybe<Scalars['Boolean']>;
  nationalDncAny?: InputMaybe<Scalars['Boolean']>;
  nationalDncContain?: InputMaybe<Scalars['Boolean']>;
  nationalDncEq?: InputMaybe<Scalars['Boolean']>;
  nationalDncGt?: InputMaybe<Scalars['Boolean']>;
  nationalDncGte?: InputMaybe<Scalars['Boolean']>;
  nationalDncIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  nationalDncIsNull?: InputMaybe<Scalars['Boolean']>;
  nationalDncLike?: InputMaybe<Scalars['Boolean']>;
  nationalDncLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  nationalDncLt?: InputMaybe<Scalars['Boolean']>;
  nationalDncLte?: InputMaybe<Scalars['Boolean']>;
  nationalDncNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldPhoneNumber?: InputMaybe<Scalars['String']>;
  oldPhoneNumberAny?: InputMaybe<Scalars['String']>;
  oldPhoneNumberContain?: InputMaybe<Scalars['String']>;
  oldPhoneNumberEq?: InputMaybe<Scalars['String']>;
  oldPhoneNumberGt?: InputMaybe<Scalars['String']>;
  oldPhoneNumberGte?: InputMaybe<Scalars['String']>;
  oldPhoneNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldPhoneNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  oldPhoneNumberLike?: InputMaybe<Scalars['String']>;
  oldPhoneNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  oldPhoneNumberLt?: InputMaybe<Scalars['String']>;
  oldPhoneNumberLte?: InputMaybe<Scalars['String']>;
  oldPhoneNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLPersonalIdentifiableInformationPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLPersonalIdentifiableInformationPropertiesEnum>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumberAny?: InputMaybe<Scalars['String']>;
  phoneNumberContain?: InputMaybe<Scalars['String']>;
  phoneNumberEq?: InputMaybe<Scalars['String']>;
  phoneNumberGt?: InputMaybe<Scalars['String']>;
  phoneNumberGte?: InputMaybe<Scalars['String']>;
  phoneNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  phoneNumberLike?: InputMaybe<Scalars['String']>;
  phoneNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  phoneNumberLt?: InputMaybe<Scalars['String']>;
  phoneNumberLte?: InputMaybe<Scalars['String']>;
  phoneNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneNumberType?: InputMaybe<Scalars['String']>;
  phoneNumberTypeAny?: InputMaybe<Scalars['String']>;
  phoneNumberTypeContain?: InputMaybe<Scalars['String']>;
  phoneNumberTypeEq?: InputMaybe<Scalars['String']>;
  phoneNumberTypeGt?: InputMaybe<Scalars['String']>;
  phoneNumberTypeGte?: InputMaybe<Scalars['String']>;
  phoneNumberTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneNumberTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  phoneNumberTypeLike?: InputMaybe<Scalars['String']>;
  phoneNumberTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  phoneNumberTypeLt?: InputMaybe<Scalars['String']>;
  phoneNumberTypeLte?: InputMaybe<Scalars['String']>;
  phoneNumberTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  state?: InputMaybe<Scalars['String']>;
  stateAny?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
  stateCodeAny?: InputMaybe<Scalars['String']>;
  stateCodeContain?: InputMaybe<Scalars['String']>;
  stateCodeEq?: InputMaybe<Scalars['String']>;
  stateCodeGt?: InputMaybe<Scalars['String']>;
  stateCodeGte?: InputMaybe<Scalars['String']>;
  stateCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  stateCodeLike?: InputMaybe<Scalars['String']>;
  stateCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  stateCodeLt?: InputMaybe<Scalars['String']>;
  stateCodeLte?: InputMaybe<Scalars['String']>;
  stateCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateContain?: InputMaybe<Scalars['String']>;
  stateDnc?: InputMaybe<Scalars['Boolean']>;
  stateDncAny?: InputMaybe<Scalars['Boolean']>;
  stateDncContain?: InputMaybe<Scalars['Boolean']>;
  stateDncEq?: InputMaybe<Scalars['Boolean']>;
  stateDncGt?: InputMaybe<Scalars['Boolean']>;
  stateDncGte?: InputMaybe<Scalars['Boolean']>;
  stateDncIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  stateDncIsNull?: InputMaybe<Scalars['Boolean']>;
  stateDncLike?: InputMaybe<Scalars['Boolean']>;
  stateDncLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  stateDncLt?: InputMaybe<Scalars['Boolean']>;
  stateDncLte?: InputMaybe<Scalars['Boolean']>;
  stateDncNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  stateEq?: InputMaybe<Scalars['String']>;
  stateGt?: InputMaybe<Scalars['String']>;
  stateGte?: InputMaybe<Scalars['String']>;
  stateIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateIsNull?: InputMaybe<Scalars['Boolean']>;
  stateLike?: InputMaybe<Scalars['String']>;
  stateLikeNoCase?: InputMaybe<Scalars['String']>;
  stateLt?: InputMaybe<Scalars['String']>;
  stateLte?: InputMaybe<Scalars['String']>;
  stateNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetAddressAny?: InputMaybe<Scalars['String']>;
  streetAddressContain?: InputMaybe<Scalars['String']>;
  streetAddressEq?: InputMaybe<Scalars['String']>;
  streetAddressGt?: InputMaybe<Scalars['String']>;
  streetAddressGte?: InputMaybe<Scalars['String']>;
  streetAddressIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  streetAddressIsNull?: InputMaybe<Scalars['Boolean']>;
  streetAddressLike?: InputMaybe<Scalars['String']>;
  streetAddressLikeNoCase?: InputMaybe<Scalars['String']>;
  streetAddressLt?: InputMaybe<Scalars['String']>;
  streetAddressLte?: InputMaybe<Scalars['String']>;
  streetAddressNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verified?: InputMaybe<Scalars['Boolean']>;
  verifiedAny?: InputMaybe<Scalars['Boolean']>;
  verifiedContain?: InputMaybe<Scalars['Boolean']>;
  verifiedEq?: InputMaybe<Scalars['Boolean']>;
  verifiedGt?: InputMaybe<Scalars['Boolean']>;
  verifiedGte?: InputMaybe<Scalars['Boolean']>;
  verifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  verifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  verifiedLike?: InputMaybe<Scalars['Boolean']>;
  verifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  verifiedLt?: InputMaybe<Scalars['Boolean']>;
  verifiedLte?: InputMaybe<Scalars['Boolean']>;
  verifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  zipCode?: InputMaybe<Scalars['String']>;
  zipCodeAny?: InputMaybe<Scalars['String']>;
  zipCodeContain?: InputMaybe<Scalars['String']>;
  zipCodeEq?: InputMaybe<Scalars['String']>;
  zipCodeGt?: InputMaybe<Scalars['String']>;
  zipCodeGte?: InputMaybe<Scalars['String']>;
  zipCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  zipCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  zipCodeLike?: InputMaybe<Scalars['String']>;
  zipCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  zipCodeLt?: InputMaybe<Scalars['String']>;
  zipCodeLte?: InputMaybe<Scalars['String']>;
  zipCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllPostTagsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fullBody?: InputMaybe<Scalars['String']>;
  fullBodyAny?: InputMaybe<Scalars['String']>;
  fullBodyContain?: InputMaybe<Scalars['String']>;
  fullBodyEq?: InputMaybe<Scalars['String']>;
  fullBodyGt?: InputMaybe<Scalars['String']>;
  fullBodyGte?: InputMaybe<Scalars['String']>;
  fullBodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullBodyIsNull?: InputMaybe<Scalars['Boolean']>;
  fullBodyLike?: InputMaybe<Scalars['String']>;
  fullBodyLikeNoCase?: InputMaybe<Scalars['String']>;
  fullBodyLt?: InputMaybe<Scalars['String']>;
  fullBodyLte?: InputMaybe<Scalars['String']>;
  fullBodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLPostTagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLPostTagsPropertiesEnum>;
  postId?: InputMaybe<Scalars['Int']>;
  postIdAny?: InputMaybe<Scalars['Int']>;
  postIdContain?: InputMaybe<Scalars['Int']>;
  postIdEq?: InputMaybe<Scalars['Int']>;
  postIdGt?: InputMaybe<Scalars['Int']>;
  postIdGte?: InputMaybe<Scalars['Int']>;
  postIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  postIdIsNull?: InputMaybe<Scalars['Boolean']>;
  postIdLike?: InputMaybe<Scalars['Int']>;
  postIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  postIdLt?: InputMaybe<Scalars['Int']>;
  postIdLte?: InputMaybe<Scalars['Int']>;
  postIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tagId?: InputMaybe<Scalars['Int']>;
  tagIdAny?: InputMaybe<Scalars['Int']>;
  tagIdContain?: InputMaybe<Scalars['Int']>;
  tagIdEq?: InputMaybe<Scalars['Int']>;
  tagIdGt?: InputMaybe<Scalars['Int']>;
  tagIdGte?: InputMaybe<Scalars['Int']>;
  tagIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tagIdIsNull?: InputMaybe<Scalars['Boolean']>;
  tagIdLike?: InputMaybe<Scalars['Int']>;
  tagIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  tagIdLt?: InputMaybe<Scalars['Int']>;
  tagIdLte?: InputMaybe<Scalars['Int']>;
  tagIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllPostsArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerpt?: InputMaybe<Scalars['String']>;
  excerptAny?: InputMaybe<Scalars['String']>;
  excerptContain?: InputMaybe<Scalars['String']>;
  excerptEq?: InputMaybe<Scalars['String']>;
  excerptGt?: InputMaybe<Scalars['String']>;
  excerptGte?: InputMaybe<Scalars['String']>;
  excerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerptIsNull?: InputMaybe<Scalars['Boolean']>;
  excerptLike?: InputMaybe<Scalars['String']>;
  excerptLikeNoCase?: InputMaybe<Scalars['String']>;
  excerptLt?: InputMaybe<Scalars['String']>;
  excerptLte?: InputMaybe<Scalars['String']>;
  excerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featured?: InputMaybe<Scalars['Boolean']>;
  featuredAny?: InputMaybe<Scalars['Boolean']>;
  featuredContain?: InputMaybe<Scalars['Boolean']>;
  featuredEq?: InputMaybe<Scalars['Boolean']>;
  featuredGt?: InputMaybe<Scalars['Boolean']>;
  featuredGte?: InputMaybe<Scalars['Boolean']>;
  featuredIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  featuredIsNull?: InputMaybe<Scalars['Boolean']>;
  featuredLike?: InputMaybe<Scalars['Boolean']>;
  featuredLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  featuredLt?: InputMaybe<Scalars['Boolean']>;
  featuredLte?: InputMaybe<Scalars['Boolean']>;
  featuredNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  fullBody?: InputMaybe<Scalars['String']>;
  fullBodyAny?: InputMaybe<Scalars['String']>;
  fullBodyContain?: InputMaybe<Scalars['String']>;
  fullBodyEq?: InputMaybe<Scalars['String']>;
  fullBodyGt?: InputMaybe<Scalars['String']>;
  fullBodyGte?: InputMaybe<Scalars['String']>;
  fullBodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullBodyIsNull?: InputMaybe<Scalars['Boolean']>;
  fullBodyLike?: InputMaybe<Scalars['String']>;
  fullBodyLikeNoCase?: InputMaybe<Scalars['String']>;
  fullBodyLt?: InputMaybe<Scalars['String']>;
  fullBodyLte?: InputMaybe<Scalars['String']>;
  fullBodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldExcerpt?: InputMaybe<Scalars['String']>;
  oldExcerptAny?: InputMaybe<Scalars['String']>;
  oldExcerptContain?: InputMaybe<Scalars['String']>;
  oldExcerptEq?: InputMaybe<Scalars['String']>;
  oldExcerptGt?: InputMaybe<Scalars['String']>;
  oldExcerptGte?: InputMaybe<Scalars['String']>;
  oldExcerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldExcerptIsNull?: InputMaybe<Scalars['Boolean']>;
  oldExcerptLike?: InputMaybe<Scalars['String']>;
  oldExcerptLikeNoCase?: InputMaybe<Scalars['String']>;
  oldExcerptLt?: InputMaybe<Scalars['String']>;
  oldExcerptLte?: InputMaybe<Scalars['String']>;
  oldExcerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLPostsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLPostsPropertiesEnum>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedAny?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['String']>;
  publishedAtAny?: InputMaybe<Scalars['String']>;
  publishedAtContain?: InputMaybe<Scalars['String']>;
  publishedAtEq?: InputMaybe<Scalars['String']>;
  publishedAtGt?: InputMaybe<Scalars['String']>;
  publishedAtGte?: InputMaybe<Scalars['String']>;
  publishedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedAtLike?: InputMaybe<Scalars['String']>;
  publishedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  publishedAtLt?: InputMaybe<Scalars['String']>;
  publishedAtLte?: InputMaybe<Scalars['String']>;
  publishedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedContain?: InputMaybe<Scalars['Boolean']>;
  publishedEq?: InputMaybe<Scalars['Boolean']>;
  publishedGt?: InputMaybe<Scalars['Boolean']>;
  publishedGte?: InputMaybe<Scalars['Boolean']>;
  publishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  publishedIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedLike?: InputMaybe<Scalars['Boolean']>;
  publishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  publishedLt?: InputMaybe<Scalars['Boolean']>;
  publishedLte?: InputMaybe<Scalars['Boolean']>;
  publishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Scalars['Int']>;
  typeIdAny?: InputMaybe<Scalars['Int']>;
  typeIdContain?: InputMaybe<Scalars['Int']>;
  typeIdEq?: InputMaybe<Scalars['Int']>;
  typeIdGt?: InputMaybe<Scalars['Int']>;
  typeIdGte?: InputMaybe<Scalars['Int']>;
  typeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  typeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  typeIdLike?: InputMaybe<Scalars['Int']>;
  typeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  typeIdLt?: InputMaybe<Scalars['Int']>;
  typeIdLte?: InputMaybe<Scalars['Int']>;
  typeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllRedirectionsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  destinationURI?: InputMaybe<Scalars['String']>;
  destinationURIAny?: InputMaybe<Scalars['String']>;
  destinationURIContain?: InputMaybe<Scalars['String']>;
  destinationURIEq?: InputMaybe<Scalars['String']>;
  destinationURIGt?: InputMaybe<Scalars['String']>;
  destinationURIGte?: InputMaybe<Scalars['String']>;
  destinationURIIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  destinationURIIsNull?: InputMaybe<Scalars['Boolean']>;
  destinationURILike?: InputMaybe<Scalars['String']>;
  destinationURILikeNoCase?: InputMaybe<Scalars['String']>;
  destinationURILt?: InputMaybe<Scalars['String']>;
  destinationURILte?: InputMaybe<Scalars['String']>;
  destinationURINotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLRedirectionsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLRedirectionsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  redirectionStatusCode?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeAny?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeContain?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeEq?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  redirectionStatusCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  redirectionStatusCodeLike?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLikeNoCase?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  srcURI?: InputMaybe<Scalars['String']>;
  srcURIAny?: InputMaybe<Scalars['String']>;
  srcURIContain?: InputMaybe<Scalars['String']>;
  srcURIEq?: InputMaybe<Scalars['String']>;
  srcURIGt?: InputMaybe<Scalars['String']>;
  srcURIGte?: InputMaybe<Scalars['String']>;
  srcURIIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  srcURIIsNull?: InputMaybe<Scalars['Boolean']>;
  srcURILike?: InputMaybe<Scalars['String']>;
  srcURILikeNoCase?: InputMaybe<Scalars['String']>;
  srcURILt?: InputMaybe<Scalars['String']>;
  srcURILte?: InputMaybe<Scalars['String']>;
  srcURINotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllRelatedPostsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLRelatedPostsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLRelatedPostsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  postId?: InputMaybe<Scalars['Int']>;
  postIdAny?: InputMaybe<Scalars['Int']>;
  postIdContain?: InputMaybe<Scalars['Int']>;
  postIdEq?: InputMaybe<Scalars['Int']>;
  postIdGt?: InputMaybe<Scalars['Int']>;
  postIdGte?: InputMaybe<Scalars['Int']>;
  postIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  postIdIsNull?: InputMaybe<Scalars['Boolean']>;
  postIdLike?: InputMaybe<Scalars['Int']>;
  postIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  postIdLt?: InputMaybe<Scalars['Int']>;
  postIdLte?: InputMaybe<Scalars['Int']>;
  postIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  relatedPostId?: InputMaybe<Scalars['Int']>;
  relatedPostIdAny?: InputMaybe<Scalars['Int']>;
  relatedPostIdContain?: InputMaybe<Scalars['Int']>;
  relatedPostIdEq?: InputMaybe<Scalars['Int']>;
  relatedPostIdGt?: InputMaybe<Scalars['Int']>;
  relatedPostIdGte?: InputMaybe<Scalars['Int']>;
  relatedPostIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  relatedPostIdIsNull?: InputMaybe<Scalars['Boolean']>;
  relatedPostIdLike?: InputMaybe<Scalars['Int']>;
  relatedPostIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  relatedPostIdLt?: InputMaybe<Scalars['Int']>;
  relatedPostIdLte?: InputMaybe<Scalars['Int']>;
  relatedPostIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllStepFieldsArgs = {
  autocomplete?: InputMaybe<Scalars['String']>;
  autocompleteAny?: InputMaybe<Scalars['String']>;
  autocompleteContain?: InputMaybe<Scalars['String']>;
  autocompleteEq?: InputMaybe<Scalars['String']>;
  autocompleteGt?: InputMaybe<Scalars['String']>;
  autocompleteGte?: InputMaybe<Scalars['String']>;
  autocompleteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autocompleteIsNull?: InputMaybe<Scalars['Boolean']>;
  autocompleteLike?: InputMaybe<Scalars['String']>;
  autocompleteLikeNoCase?: InputMaybe<Scalars['String']>;
  autocompleteLt?: InputMaybe<Scalars['String']>;
  autocompleteLte?: InputMaybe<Scalars['String']>;
  autocompleteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  conditionalLogic?: InputMaybe<Scalars['JSON']>;
  conditionalLogicAny?: InputMaybe<Scalars['JSON']>;
  conditionalLogicContain?: InputMaybe<Scalars['JSON']>;
  conditionalLogicEq?: InputMaybe<Scalars['JSON']>;
  conditionalLogicGt?: InputMaybe<Scalars['JSON']>;
  conditionalLogicGte?: InputMaybe<Scalars['JSON']>;
  conditionalLogicIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  conditionalLogicIsNull?: InputMaybe<Scalars['Boolean']>;
  conditionalLogicLike?: InputMaybe<Scalars['JSON']>;
  conditionalLogicLikeNoCase?: InputMaybe<Scalars['JSON']>;
  conditionalLogicLt?: InputMaybe<Scalars['JSON']>;
  conditionalLogicLte?: InputMaybe<Scalars['JSON']>;
  conditionalLogicNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dataDependency?: InputMaybe<Scalars['JSON']>;
  dataDependencyAny?: InputMaybe<Scalars['JSON']>;
  dataDependencyContain?: InputMaybe<Scalars['JSON']>;
  dataDependencyEq?: InputMaybe<Scalars['JSON']>;
  dataDependencyGt?: InputMaybe<Scalars['JSON']>;
  dataDependencyGte?: InputMaybe<Scalars['JSON']>;
  dataDependencyIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  dataDependencyIsNull?: InputMaybe<Scalars['Boolean']>;
  dataDependencyLike?: InputMaybe<Scalars['JSON']>;
  dataDependencyLikeNoCase?: InputMaybe<Scalars['JSON']>;
  dataDependencyLt?: InputMaybe<Scalars['JSON']>;
  dataDependencyLte?: InputMaybe<Scalars['JSON']>;
  dataDependencyNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  defaultValue?: InputMaybe<Scalars['String']>;
  defaultValueAny?: InputMaybe<Scalars['String']>;
  defaultValueContain?: InputMaybe<Scalars['String']>;
  defaultValueEq?: InputMaybe<Scalars['String']>;
  defaultValueGt?: InputMaybe<Scalars['String']>;
  defaultValueGte?: InputMaybe<Scalars['String']>;
  defaultValueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultValueIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultValueLike?: InputMaybe<Scalars['String']>;
  defaultValueLikeNoCase?: InputMaybe<Scalars['String']>;
  defaultValueLt?: InputMaybe<Scalars['String']>;
  defaultValueLte?: InputMaybe<Scalars['String']>;
  defaultValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultValues?: InputMaybe<Scalars['JSON']>;
  defaultValuesAny?: InputMaybe<Scalars['JSON']>;
  defaultValuesContain?: InputMaybe<Scalars['JSON']>;
  defaultValuesEq?: InputMaybe<Scalars['JSON']>;
  defaultValuesGt?: InputMaybe<Scalars['JSON']>;
  defaultValuesGte?: InputMaybe<Scalars['JSON']>;
  defaultValuesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  defaultValuesIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultValuesLike?: InputMaybe<Scalars['JSON']>;
  defaultValuesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  defaultValuesLt?: InputMaybe<Scalars['JSON']>;
  defaultValuesLte?: InputMaybe<Scalars['JSON']>;
  defaultValuesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorMessageAny?: InputMaybe<Scalars['String']>;
  errorMessageContain?: InputMaybe<Scalars['String']>;
  errorMessageEq?: InputMaybe<Scalars['String']>;
  errorMessageGt?: InputMaybe<Scalars['String']>;
  errorMessageGte?: InputMaybe<Scalars['String']>;
  errorMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  errorMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  errorMessageLike?: InputMaybe<Scalars['String']>;
  errorMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  errorMessageLt?: InputMaybe<Scalars['String']>;
  errorMessageLte?: InputMaybe<Scalars['String']>;
  errorMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldId?: InputMaybe<Scalars['Int']>;
  fieldIdAny?: InputMaybe<Scalars['Int']>;
  fieldIdContain?: InputMaybe<Scalars['Int']>;
  fieldIdEq?: InputMaybe<Scalars['Int']>;
  fieldIdGt?: InputMaybe<Scalars['Int']>;
  fieldIdGte?: InputMaybe<Scalars['Int']>;
  fieldIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fieldIdIsNull?: InputMaybe<Scalars['Boolean']>;
  fieldIdLike?: InputMaybe<Scalars['Int']>;
  fieldIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  fieldIdLt?: InputMaybe<Scalars['Int']>;
  fieldIdLte?: InputMaybe<Scalars['Int']>;
  fieldIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fieldType?: InputMaybe<Scalars['String']>;
  fieldTypeAny?: InputMaybe<Scalars['String']>;
  fieldTypeContain?: InputMaybe<Scalars['String']>;
  fieldTypeEq?: InputMaybe<Scalars['String']>;
  fieldTypeGt?: InputMaybe<Scalars['String']>;
  fieldTypeGte?: InputMaybe<Scalars['String']>;
  fieldTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  fieldTypeLike?: InputMaybe<Scalars['String']>;
  fieldTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  fieldTypeLt?: InputMaybe<Scalars['String']>;
  fieldTypeLte?: InputMaybe<Scalars['String']>;
  fieldTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  isRequiredAny?: InputMaybe<Scalars['Boolean']>;
  isRequiredContain?: InputMaybe<Scalars['Boolean']>;
  isRequiredEq?: InputMaybe<Scalars['Boolean']>;
  isRequiredGt?: InputMaybe<Scalars['Boolean']>;
  isRequiredGte?: InputMaybe<Scalars['Boolean']>;
  isRequiredIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isRequiredIsNull?: InputMaybe<Scalars['Boolean']>;
  isRequiredLike?: InputMaybe<Scalars['Boolean']>;
  isRequiredLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isRequiredLt?: InputMaybe<Scalars['Boolean']>;
  isRequiredLte?: InputMaybe<Scalars['Boolean']>;
  isRequiredNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mask?: InputMaybe<Scalars['String']>;
  maskAny?: InputMaybe<Scalars['String']>;
  maskContain?: InputMaybe<Scalars['String']>;
  maskEq?: InputMaybe<Scalars['String']>;
  maskGt?: InputMaybe<Scalars['String']>;
  maskGte?: InputMaybe<Scalars['String']>;
  maskIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maskIsNull?: InputMaybe<Scalars['Boolean']>;
  maskLike?: InputMaybe<Scalars['String']>;
  maskLikeNoCase?: InputMaybe<Scalars['String']>;
  maskLt?: InputMaybe<Scalars['String']>;
  maskLte?: InputMaybe<Scalars['String']>;
  maskNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxValue?: InputMaybe<Scalars['JSON']>;
  maxValueAny?: InputMaybe<Scalars['JSON']>;
  maxValueContain?: InputMaybe<Scalars['JSON']>;
  maxValueEq?: InputMaybe<Scalars['JSON']>;
  maxValueGt?: InputMaybe<Scalars['JSON']>;
  maxValueGte?: InputMaybe<Scalars['JSON']>;
  maxValueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  maxValueIsNull?: InputMaybe<Scalars['Boolean']>;
  maxValueLike?: InputMaybe<Scalars['JSON']>;
  maxValueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  maxValueLt?: InputMaybe<Scalars['JSON']>;
  maxValueLte?: InputMaybe<Scalars['JSON']>;
  maxValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  meta?: InputMaybe<Scalars['JSON']>;
  metaAny?: InputMaybe<Scalars['JSON']>;
  metaContain?: InputMaybe<Scalars['JSON']>;
  metaEq?: InputMaybe<Scalars['JSON']>;
  metaGt?: InputMaybe<Scalars['JSON']>;
  metaGte?: InputMaybe<Scalars['JSON']>;
  metaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  metaIsNull?: InputMaybe<Scalars['Boolean']>;
  metaLike?: InputMaybe<Scalars['JSON']>;
  metaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  metaLt?: InputMaybe<Scalars['JSON']>;
  metaLte?: InputMaybe<Scalars['JSON']>;
  metaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  minValue?: InputMaybe<Scalars['JSON']>;
  minValueAny?: InputMaybe<Scalars['JSON']>;
  minValueContain?: InputMaybe<Scalars['JSON']>;
  minValueEq?: InputMaybe<Scalars['JSON']>;
  minValueGt?: InputMaybe<Scalars['JSON']>;
  minValueGte?: InputMaybe<Scalars['JSON']>;
  minValueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  minValueIsNull?: InputMaybe<Scalars['Boolean']>;
  minValueLike?: InputMaybe<Scalars['JSON']>;
  minValueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  minValueLt?: InputMaybe<Scalars['JSON']>;
  minValueLte?: InputMaybe<Scalars['JSON']>;
  minValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  note?: InputMaybe<Scalars['String']>;
  noteAny?: InputMaybe<Scalars['String']>;
  noteContain?: InputMaybe<Scalars['String']>;
  noteEq?: InputMaybe<Scalars['String']>;
  noteGt?: InputMaybe<Scalars['String']>;
  noteGte?: InputMaybe<Scalars['String']>;
  noteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  noteIsNull?: InputMaybe<Scalars['Boolean']>;
  noteLike?: InputMaybe<Scalars['String']>;
  noteLikeNoCase?: InputMaybe<Scalars['String']>;
  noteLt?: InputMaybe<Scalars['String']>;
  noteLte?: InputMaybe<Scalars['String']>;
  noteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLStepFieldsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLStepFieldsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  pattern?: InputMaybe<Scalars['String']>;
  patternAny?: InputMaybe<Scalars['String']>;
  patternContain?: InputMaybe<Scalars['String']>;
  patternEq?: InputMaybe<Scalars['String']>;
  patternGt?: InputMaybe<Scalars['String']>;
  patternGte?: InputMaybe<Scalars['String']>;
  patternIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  patternIsNull?: InputMaybe<Scalars['Boolean']>;
  patternLike?: InputMaybe<Scalars['String']>;
  patternLikeNoCase?: InputMaybe<Scalars['String']>;
  patternLt?: InputMaybe<Scalars['String']>;
  patternLte?: InputMaybe<Scalars['String']>;
  patternNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeholder?: InputMaybe<Scalars['String']>;
  placeholderAny?: InputMaybe<Scalars['String']>;
  placeholderContain?: InputMaybe<Scalars['String']>;
  placeholderEq?: InputMaybe<Scalars['String']>;
  placeholderGt?: InputMaybe<Scalars['String']>;
  placeholderGte?: InputMaybe<Scalars['String']>;
  placeholderIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeholderIsNull?: InputMaybe<Scalars['Boolean']>;
  placeholderLike?: InputMaybe<Scalars['String']>;
  placeholderLikeNoCase?: InputMaybe<Scalars['String']>;
  placeholderLt?: InputMaybe<Scalars['String']>;
  placeholderLte?: InputMaybe<Scalars['String']>;
  placeholderNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepId?: InputMaybe<Scalars['Int']>;
  stepIdAny?: InputMaybe<Scalars['Int']>;
  stepIdContain?: InputMaybe<Scalars['Int']>;
  stepIdEq?: InputMaybe<Scalars['Int']>;
  stepIdGt?: InputMaybe<Scalars['Int']>;
  stepIdGte?: InputMaybe<Scalars['Int']>;
  stepIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepIdIsNull?: InputMaybe<Scalars['Boolean']>;
  stepIdLike?: InputMaybe<Scalars['Int']>;
  stepIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  stepIdLt?: InputMaybe<Scalars['Int']>;
  stepIdLte?: InputMaybe<Scalars['Int']>;
  stepIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllStepsArgs = {
  adminTitle?: InputMaybe<Scalars['String']>;
  adminTitleAny?: InputMaybe<Scalars['String']>;
  adminTitleContain?: InputMaybe<Scalars['String']>;
  adminTitleEq?: InputMaybe<Scalars['String']>;
  adminTitleGt?: InputMaybe<Scalars['String']>;
  adminTitleGte?: InputMaybe<Scalars['String']>;
  adminTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adminTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  adminTitleLike?: InputMaybe<Scalars['String']>;
  adminTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  adminTitleLt?: InputMaybe<Scalars['String']>;
  adminTitleLte?: InputMaybe<Scalars['String']>;
  adminTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buttonText?: InputMaybe<Scalars['String']>;
  buttonTextAny?: InputMaybe<Scalars['String']>;
  buttonTextContain?: InputMaybe<Scalars['String']>;
  buttonTextEq?: InputMaybe<Scalars['String']>;
  buttonTextGt?: InputMaybe<Scalars['String']>;
  buttonTextGte?: InputMaybe<Scalars['String']>;
  buttonTextIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buttonTextIsNull?: InputMaybe<Scalars['Boolean']>;
  buttonTextLike?: InputMaybe<Scalars['String']>;
  buttonTextLikeNoCase?: InputMaybe<Scalars['String']>;
  buttonTextLt?: InputMaybe<Scalars['String']>;
  buttonTextLte?: InputMaybe<Scalars['String']>;
  buttonTextNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  formId?: InputMaybe<Scalars['Int']>;
  formIdAny?: InputMaybe<Scalars['Int']>;
  formIdContain?: InputMaybe<Scalars['Int']>;
  formIdEq?: InputMaybe<Scalars['Int']>;
  formIdGt?: InputMaybe<Scalars['Int']>;
  formIdGte?: InputMaybe<Scalars['Int']>;
  formIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formIdIsNull?: InputMaybe<Scalars['Boolean']>;
  formIdLike?: InputMaybe<Scalars['Int']>;
  formIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  formIdLt?: InputMaybe<Scalars['Int']>;
  formIdLte?: InputMaybe<Scalars['Int']>;
  formIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  includeTCPAMessage?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageAny?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageContain?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageEq?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageGt?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageGte?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  includeTCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageLike?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageLt?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageLte?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLStepsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLStepsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltipAny?: InputMaybe<Scalars['String']>;
  tooltipContain?: InputMaybe<Scalars['String']>;
  tooltipEq?: InputMaybe<Scalars['String']>;
  tooltipGt?: InputMaybe<Scalars['String']>;
  tooltipGte?: InputMaybe<Scalars['String']>;
  tooltipIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tooltipIsNull?: InputMaybe<Scalars['Boolean']>;
  tooltipLike?: InputMaybe<Scalars['String']>;
  tooltipLikeNoCase?: InputMaybe<Scalars['String']>;
  tooltipLt?: InputMaybe<Scalars['String']>;
  tooltipLte?: InputMaybe<Scalars['String']>;
  tooltipNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllTagsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLTagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTagsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllTaxonomiesArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedByAny?: InputMaybe<Scalars['String']>;
  deletedByContain?: InputMaybe<Scalars['String']>;
  deletedByEq?: InputMaybe<Scalars['String']>;
  deletedByGt?: InputMaybe<Scalars['String']>;
  deletedByGte?: InputMaybe<Scalars['String']>;
  deletedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedByIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedByLike?: InputMaybe<Scalars['String']>;
  deletedByLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedByLt?: InputMaybe<Scalars['String']>;
  deletedByLte?: InputMaybe<Scalars['String']>;
  deletedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTaxonomiesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTaxonomiesPropertiesEnum>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetModel?: InputMaybe<Scalars['String']>;
  targetModelAny?: InputMaybe<Scalars['String']>;
  targetModelContain?: InputMaybe<Scalars['String']>;
  targetModelEq?: InputMaybe<Scalars['String']>;
  targetModelGt?: InputMaybe<Scalars['String']>;
  targetModelGte?: InputMaybe<Scalars['String']>;
  targetModelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetModelIsNull?: InputMaybe<Scalars['Boolean']>;
  targetModelLike?: InputMaybe<Scalars['String']>;
  targetModelLikeNoCase?: InputMaybe<Scalars['String']>;
  targetModelLt?: InputMaybe<Scalars['String']>;
  targetModelLte?: InputMaybe<Scalars['String']>;
  targetModelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCase?: InputMaybe<Scalars['String']>;
  useCaseAny?: InputMaybe<Scalars['String']>;
  useCaseContain?: InputMaybe<Scalars['String']>;
  useCaseEq?: InputMaybe<Scalars['String']>;
  useCaseGt?: InputMaybe<Scalars['String']>;
  useCaseGte?: InputMaybe<Scalars['String']>;
  useCaseIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCaseIsNull?: InputMaybe<Scalars['Boolean']>;
  useCaseLike?: InputMaybe<Scalars['String']>;
  useCaseLikeNoCase?: InputMaybe<Scalars['String']>;
  useCaseLt?: InputMaybe<Scalars['String']>;
  useCaseLte?: InputMaybe<Scalars['String']>;
  useCaseNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllTaxonomiesEntitiesArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  model?: InputMaybe<Scalars['String']>;
  modelAny?: InputMaybe<Scalars['String']>;
  modelContain?: InputMaybe<Scalars['String']>;
  modelEq?: InputMaybe<Scalars['String']>;
  modelGt?: InputMaybe<Scalars['String']>;
  modelGte?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIsNull?: InputMaybe<Scalars['Boolean']>;
  modelLike?: InputMaybe<Scalars['String']>;
  modelLikeNoCase?: InputMaybe<Scalars['String']>;
  modelLt?: InputMaybe<Scalars['String']>;
  modelLte?: InputMaybe<Scalars['String']>;
  modelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTaxonomiesEntitiesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTaxonomiesEntitiesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  sortOrderAny?: InputMaybe<Scalars['Int']>;
  sortOrderContain?: InputMaybe<Scalars['Int']>;
  sortOrderEq?: InputMaybe<Scalars['Int']>;
  sortOrderGt?: InputMaybe<Scalars['Int']>;
  sortOrderGte?: InputMaybe<Scalars['Int']>;
  sortOrderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sortOrderIsNull?: InputMaybe<Scalars['Boolean']>;
  sortOrderLike?: InputMaybe<Scalars['Int']>;
  sortOrderLikeNoCase?: InputMaybe<Scalars['Int']>;
  sortOrderLt?: InputMaybe<Scalars['Int']>;
  sortOrderLte?: InputMaybe<Scalars['Int']>;
  sortOrderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  taxonomyId?: InputMaybe<Scalars['Int']>;
  taxonomyIdAny?: InputMaybe<Scalars['Int']>;
  taxonomyIdContain?: InputMaybe<Scalars['Int']>;
  taxonomyIdEq?: InputMaybe<Scalars['Int']>;
  taxonomyIdGt?: InputMaybe<Scalars['Int']>;
  taxonomyIdGte?: InputMaybe<Scalars['Int']>;
  taxonomyIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  taxonomyIdIsNull?: InputMaybe<Scalars['Boolean']>;
  taxonomyIdLike?: InputMaybe<Scalars['Int']>;
  taxonomyIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  taxonomyIdLt?: InputMaybe<Scalars['Int']>;
  taxonomyIdLte?: InputMaybe<Scalars['Int']>;
  taxonomyIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllTextBlocksArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedByAny?: InputMaybe<Scalars['String']>;
  deletedByContain?: InputMaybe<Scalars['String']>;
  deletedByEq?: InputMaybe<Scalars['String']>;
  deletedByGt?: InputMaybe<Scalars['String']>;
  deletedByGte?: InputMaybe<Scalars['String']>;
  deletedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedByIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedByLike?: InputMaybe<Scalars['String']>;
  deletedByLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedByLt?: InputMaybe<Scalars['String']>;
  deletedByLte?: InputMaybe<Scalars['String']>;
  deletedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIds?: InputMaybe<Scalars['JSON']>;
  offerIdsAny?: InputMaybe<Scalars['JSON']>;
  offerIdsContain?: InputMaybe<Scalars['JSON']>;
  offerIdsEq?: InputMaybe<Scalars['JSON']>;
  offerIdsGt?: InputMaybe<Scalars['JSON']>;
  offerIdsGte?: InputMaybe<Scalars['JSON']>;
  offerIdsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  offerIdsIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdsLike?: InputMaybe<Scalars['JSON']>;
  offerIdsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  offerIdsLt?: InputMaybe<Scalars['JSON']>;
  offerIdsLte?: InputMaybe<Scalars['JSON']>;
  offerIdsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTextBlocksPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTextBlocksPropertiesEnum>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  queryString?: InputMaybe<Scalars['JSON']>;
  queryStringAny?: InputMaybe<Scalars['JSON']>;
  queryStringContain?: InputMaybe<Scalars['JSON']>;
  queryStringEq?: InputMaybe<Scalars['JSON']>;
  queryStringGt?: InputMaybe<Scalars['JSON']>;
  queryStringGte?: InputMaybe<Scalars['JSON']>;
  queryStringIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  queryStringIsNull?: InputMaybe<Scalars['Boolean']>;
  queryStringLike?: InputMaybe<Scalars['JSON']>;
  queryStringLikeNoCase?: InputMaybe<Scalars['JSON']>;
  queryStringLt?: InputMaybe<Scalars['JSON']>;
  queryStringLte?: InputMaybe<Scalars['JSON']>;
  queryStringNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  text?: InputMaybe<Scalars['String']>;
  textAny?: InputMaybe<Scalars['String']>;
  textContain?: InputMaybe<Scalars['String']>;
  textEq?: InputMaybe<Scalars['String']>;
  textGt?: InputMaybe<Scalars['String']>;
  textGte?: InputMaybe<Scalars['String']>;
  textIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textIsNull?: InputMaybe<Scalars['Boolean']>;
  textLike?: InputMaybe<Scalars['String']>;
  textLikeNoCase?: InputMaybe<Scalars['String']>;
  textLt?: InputMaybe<Scalars['String']>;
  textLte?: InputMaybe<Scalars['String']>;
  textNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllTrafficSourceMapArgs = {
  accountId?: InputMaybe<Scalars['Int']>;
  accountIdAny?: InputMaybe<Scalars['Int']>;
  accountIdContain?: InputMaybe<Scalars['Int']>;
  accountIdEq?: InputMaybe<Scalars['Int']>;
  accountIdGt?: InputMaybe<Scalars['Int']>;
  accountIdGte?: InputMaybe<Scalars['Int']>;
  accountIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  accountIdIsNull?: InputMaybe<Scalars['Boolean']>;
  accountIdLike?: InputMaybe<Scalars['Int']>;
  accountIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  accountIdLt?: InputMaybe<Scalars['Int']>;
  accountIdLte?: InputMaybe<Scalars['Int']>;
  accountIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  excludeFromDailyPL?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLAny?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLContain?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLEq?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLGt?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLGte?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  excludeFromDailyPLIsNull?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLike?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLt?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLte?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  networkId?: InputMaybe<Scalars['Int']>;
  networkIdAny?: InputMaybe<Scalars['Int']>;
  networkIdContain?: InputMaybe<Scalars['Int']>;
  networkIdEq?: InputMaybe<Scalars['Int']>;
  networkIdGt?: InputMaybe<Scalars['Int']>;
  networkIdGte?: InputMaybe<Scalars['Int']>;
  networkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  networkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  networkIdLike?: InputMaybe<Scalars['Int']>;
  networkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  networkIdLt?: InputMaybe<Scalars['Int']>;
  networkIdLte?: InputMaybe<Scalars['Int']>;
  networkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTrafficSourceMapPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTrafficSourceMapPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  trafficSource?: InputMaybe<Scalars['String']>;
  trafficSourceAny?: InputMaybe<Scalars['String']>;
  trafficSourceContain?: InputMaybe<Scalars['String']>;
  trafficSourceEq?: InputMaybe<Scalars['String']>;
  trafficSourceGt?: InputMaybe<Scalars['String']>;
  trafficSourceGte?: InputMaybe<Scalars['String']>;
  trafficSourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficSourceIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficSourceLike?: InputMaybe<Scalars['String']>;
  trafficSourceLikeNoCase?: InputMaybe<Scalars['String']>;
  trafficSourceLt?: InputMaybe<Scalars['String']>;
  trafficSourceLte?: InputMaybe<Scalars['String']>;
  trafficSourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficTypeId?: InputMaybe<Scalars['Int']>;
  trafficTypeIdAny?: InputMaybe<Scalars['Int']>;
  trafficTypeIdContain?: InputMaybe<Scalars['Int']>;
  trafficTypeIdEq?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  trafficTypeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficTypeIdLike?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllTrafficTypesArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTrafficTypesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTrafficTypesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};


export type GQLQueryAllUrlsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMain?: InputMaybe<Scalars['Boolean']>;
  isMainAny?: InputMaybe<Scalars['Boolean']>;
  isMainContain?: InputMaybe<Scalars['Boolean']>;
  isMainEq?: InputMaybe<Scalars['Boolean']>;
  isMainGt?: InputMaybe<Scalars['Boolean']>;
  isMainGte?: InputMaybe<Scalars['Boolean']>;
  isMainIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMainIsNull?: InputMaybe<Scalars['Boolean']>;
  isMainLike?: InputMaybe<Scalars['Boolean']>;
  isMainLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isMainLt?: InputMaybe<Scalars['Boolean']>;
  isMainLte?: InputMaybe<Scalars['Boolean']>;
  isMainNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  meta?: InputMaybe<Scalars['JSON']>;
  metaAny?: InputMaybe<Scalars['JSON']>;
  metaContain?: InputMaybe<Scalars['JSON']>;
  metaEq?: InputMaybe<Scalars['JSON']>;
  metaGt?: InputMaybe<Scalars['JSON']>;
  metaGte?: InputMaybe<Scalars['JSON']>;
  metaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  metaIsNull?: InputMaybe<Scalars['Boolean']>;
  metaLike?: InputMaybe<Scalars['JSON']>;
  metaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  metaLt?: InputMaybe<Scalars['JSON']>;
  metaLte?: InputMaybe<Scalars['JSON']>;
  metaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  model?: InputMaybe<Scalars['String']>;
  modelAny?: InputMaybe<Scalars['String']>;
  modelContain?: InputMaybe<Scalars['String']>;
  modelEq?: InputMaybe<Scalars['String']>;
  modelGt?: InputMaybe<Scalars['String']>;
  modelGte?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['String']>;
  modelIdAny?: InputMaybe<Scalars['String']>;
  modelIdContain?: InputMaybe<Scalars['String']>;
  modelIdEq?: InputMaybe<Scalars['String']>;
  modelIdGt?: InputMaybe<Scalars['String']>;
  modelIdGte?: InputMaybe<Scalars['String']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['String']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['String']>;
  modelIdLt?: InputMaybe<Scalars['String']>;
  modelIdLte?: InputMaybe<Scalars['String']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIsNull?: InputMaybe<Scalars['Boolean']>;
  modelLike?: InputMaybe<Scalars['String']>;
  modelLikeNoCase?: InputMaybe<Scalars['String']>;
  modelLt?: InputMaybe<Scalars['String']>;
  modelLte?: InputMaybe<Scalars['String']>;
  modelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUrlsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUrlsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  redirectionStatusCode?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeAny?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeContain?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeEq?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  redirectionStatusCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  redirectionStatusCodeLike?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLikeNoCase?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  urlAny?: InputMaybe<Scalars['String']>;
  urlContain?: InputMaybe<Scalars['String']>;
  urlEq?: InputMaybe<Scalars['String']>;
  urlGt?: InputMaybe<Scalars['String']>;
  urlGte?: InputMaybe<Scalars['String']>;
  urlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlIsNull?: InputMaybe<Scalars['Boolean']>;
  urlLike?: InputMaybe<Scalars['String']>;
  urlLikeNoCase?: InputMaybe<Scalars['String']>;
  urlLt?: InputMaybe<Scalars['String']>;
  urlLte?: InputMaybe<Scalars['String']>;
  urlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllUserRolesArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUserRolesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUserRolesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  roleCodeName?: InputMaybe<Scalars['String']>;
  roleCodeNameAny?: InputMaybe<Scalars['String']>;
  roleCodeNameContain?: InputMaybe<Scalars['String']>;
  roleCodeNameEq?: InputMaybe<Scalars['String']>;
  roleCodeNameGt?: InputMaybe<Scalars['String']>;
  roleCodeNameGte?: InputMaybe<Scalars['String']>;
  roleCodeNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleCodeNameIsNull?: InputMaybe<Scalars['Boolean']>;
  roleCodeNameLike?: InputMaybe<Scalars['String']>;
  roleCodeNameLikeNoCase?: InputMaybe<Scalars['String']>;
  roleCodeNameLt?: InputMaybe<Scalars['String']>;
  roleCodeNameLte?: InputMaybe<Scalars['String']>;
  roleCodeNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleName?: InputMaybe<Scalars['String']>;
  roleNameAny?: InputMaybe<Scalars['String']>;
  roleNameContain?: InputMaybe<Scalars['String']>;
  roleNameEq?: InputMaybe<Scalars['String']>;
  roleNameGt?: InputMaybe<Scalars['String']>;
  roleNameGte?: InputMaybe<Scalars['String']>;
  roleNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleNameIsNull?: InputMaybe<Scalars['Boolean']>;
  roleNameLike?: InputMaybe<Scalars['String']>;
  roleNameLikeNoCase?: InputMaybe<Scalars['String']>;
  roleNameLt?: InputMaybe<Scalars['String']>;
  roleNameLte?: InputMaybe<Scalars['String']>;
  roleNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rolePolicies?: InputMaybe<Scalars['JSON']>;
  rolePoliciesAny?: InputMaybe<Scalars['JSON']>;
  rolePoliciesContain?: InputMaybe<Scalars['JSON']>;
  rolePoliciesEq?: InputMaybe<Scalars['JSON']>;
  rolePoliciesGt?: InputMaybe<Scalars['JSON']>;
  rolePoliciesGte?: InputMaybe<Scalars['JSON']>;
  rolePoliciesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  rolePoliciesIsNull?: InputMaybe<Scalars['Boolean']>;
  rolePoliciesLike?: InputMaybe<Scalars['JSON']>;
  rolePoliciesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  rolePoliciesLt?: InputMaybe<Scalars['JSON']>;
  rolePoliciesLte?: InputMaybe<Scalars['JSON']>;
  rolePoliciesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllUsersArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllVariationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLVariationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLVariationsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllVisitorsArgs = {
  adCampaign?: InputMaybe<Scalars['String']>;
  adCampaignAny?: InputMaybe<Scalars['String']>;
  adCampaignContain?: InputMaybe<Scalars['String']>;
  adCampaignEq?: InputMaybe<Scalars['String']>;
  adCampaignGt?: InputMaybe<Scalars['String']>;
  adCampaignGte?: InputMaybe<Scalars['String']>;
  adCampaignIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adCampaignIsNull?: InputMaybe<Scalars['Boolean']>;
  adCampaignLike?: InputMaybe<Scalars['String']>;
  adCampaignLikeNoCase?: InputMaybe<Scalars['String']>;
  adCampaignLt?: InputMaybe<Scalars['String']>;
  adCampaignLte?: InputMaybe<Scalars['String']>;
  adCampaignNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adDevice?: InputMaybe<Scalars['String']>;
  adDeviceAny?: InputMaybe<Scalars['String']>;
  adDeviceContain?: InputMaybe<Scalars['String']>;
  adDeviceEq?: InputMaybe<Scalars['String']>;
  adDeviceGt?: InputMaybe<Scalars['String']>;
  adDeviceGte?: InputMaybe<Scalars['String']>;
  adDeviceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adDeviceIsNull?: InputMaybe<Scalars['Boolean']>;
  adDeviceLike?: InputMaybe<Scalars['String']>;
  adDeviceLikeNoCase?: InputMaybe<Scalars['String']>;
  adDeviceLt?: InputMaybe<Scalars['String']>;
  adDeviceLte?: InputMaybe<Scalars['String']>;
  adDeviceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adGroup?: InputMaybe<Scalars['String']>;
  adGroupAny?: InputMaybe<Scalars['String']>;
  adGroupContain?: InputMaybe<Scalars['String']>;
  adGroupEq?: InputMaybe<Scalars['String']>;
  adGroupGt?: InputMaybe<Scalars['String']>;
  adGroupGte?: InputMaybe<Scalars['String']>;
  adGroupIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adGroupIsNull?: InputMaybe<Scalars['Boolean']>;
  adGroupLike?: InputMaybe<Scalars['String']>;
  adGroupLikeNoCase?: InputMaybe<Scalars['String']>;
  adGroupLt?: InputMaybe<Scalars['String']>;
  adGroupLte?: InputMaybe<Scalars['String']>;
  adGroupNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adKeyword?: InputMaybe<Scalars['String']>;
  adKeywordAny?: InputMaybe<Scalars['String']>;
  adKeywordContain?: InputMaybe<Scalars['String']>;
  adKeywordEq?: InputMaybe<Scalars['String']>;
  adKeywordGt?: InputMaybe<Scalars['String']>;
  adKeywordGte?: InputMaybe<Scalars['String']>;
  adKeywordIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adKeywordIsNull?: InputMaybe<Scalars['Boolean']>;
  adKeywordLike?: InputMaybe<Scalars['String']>;
  adKeywordLikeNoCase?: InputMaybe<Scalars['String']>;
  adKeywordLt?: InputMaybe<Scalars['String']>;
  adKeywordLte?: InputMaybe<Scalars['String']>;
  adKeywordNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adMedium?: InputMaybe<Scalars['String']>;
  adMediumAny?: InputMaybe<Scalars['String']>;
  adMediumContain?: InputMaybe<Scalars['String']>;
  adMediumEq?: InputMaybe<Scalars['String']>;
  adMediumGt?: InputMaybe<Scalars['String']>;
  adMediumGte?: InputMaybe<Scalars['String']>;
  adMediumIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adMediumIsNull?: InputMaybe<Scalars['Boolean']>;
  adMediumLike?: InputMaybe<Scalars['String']>;
  adMediumLikeNoCase?: InputMaybe<Scalars['String']>;
  adMediumLt?: InputMaybe<Scalars['String']>;
  adMediumLte?: InputMaybe<Scalars['String']>;
  adMediumNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adTrafficSource?: InputMaybe<Scalars['String']>;
  adTrafficSourceAny?: InputMaybe<Scalars['String']>;
  adTrafficSourceContain?: InputMaybe<Scalars['String']>;
  adTrafficSourceEq?: InputMaybe<Scalars['String']>;
  adTrafficSourceGt?: InputMaybe<Scalars['String']>;
  adTrafficSourceGte?: InputMaybe<Scalars['String']>;
  adTrafficSourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adTrafficSourceIsNull?: InputMaybe<Scalars['Boolean']>;
  adTrafficSourceLike?: InputMaybe<Scalars['String']>;
  adTrafficSourceLikeNoCase?: InputMaybe<Scalars['String']>;
  adTrafficSourceLt?: InputMaybe<Scalars['String']>;
  adTrafficSourceLte?: InputMaybe<Scalars['String']>;
  adTrafficSourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browser?: InputMaybe<Scalars['String']>;
  browserAny?: InputMaybe<Scalars['String']>;
  browserCode?: InputMaybe<Scalars['String']>;
  browserCodeAny?: InputMaybe<Scalars['String']>;
  browserCodeContain?: InputMaybe<Scalars['String']>;
  browserCodeEq?: InputMaybe<Scalars['String']>;
  browserCodeGt?: InputMaybe<Scalars['String']>;
  browserCodeGte?: InputMaybe<Scalars['String']>;
  browserCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  browserCodeLike?: InputMaybe<Scalars['String']>;
  browserCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  browserCodeLt?: InputMaybe<Scalars['String']>;
  browserCodeLte?: InputMaybe<Scalars['String']>;
  browserCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserContain?: InputMaybe<Scalars['String']>;
  browserEq?: InputMaybe<Scalars['String']>;
  browserGt?: InputMaybe<Scalars['String']>;
  browserGte?: InputMaybe<Scalars['String']>;
  browserIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserIsNull?: InputMaybe<Scalars['Boolean']>;
  browserLike?: InputMaybe<Scalars['String']>;
  browserLikeNoCase?: InputMaybe<Scalars['String']>;
  browserLt?: InputMaybe<Scalars['String']>;
  browserLte?: InputMaybe<Scalars['String']>;
  browserNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserVersion?: InputMaybe<Scalars['String']>;
  browserVersionAny?: InputMaybe<Scalars['String']>;
  browserVersionContain?: InputMaybe<Scalars['String']>;
  browserVersionEq?: InputMaybe<Scalars['String']>;
  browserVersionGt?: InputMaybe<Scalars['String']>;
  browserVersionGte?: InputMaybe<Scalars['String']>;
  browserVersionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserVersionIsNull?: InputMaybe<Scalars['Boolean']>;
  browserVersionLike?: InputMaybe<Scalars['String']>;
  browserVersionLikeNoCase?: InputMaybe<Scalars['String']>;
  browserVersionLt?: InputMaybe<Scalars['String']>;
  browserVersionLte?: InputMaybe<Scalars['String']>;
  browserVersionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ipAddressId?: InputMaybe<Scalars['Int']>;
  ipAddressIdAny?: InputMaybe<Scalars['Int']>;
  ipAddressIdContain?: InputMaybe<Scalars['Int']>;
  ipAddressIdEq?: InputMaybe<Scalars['Int']>;
  ipAddressIdGt?: InputMaybe<Scalars['Int']>;
  ipAddressIdGte?: InputMaybe<Scalars['Int']>;
  ipAddressIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ipAddressIdIsNull?: InputMaybe<Scalars['Boolean']>;
  ipAddressIdLike?: InputMaybe<Scalars['Int']>;
  ipAddressIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  ipAddressIdLt?: InputMaybe<Scalars['Int']>;
  ipAddressIdLte?: InputMaybe<Scalars['Int']>;
  ipAddressIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLVisitorsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLVisitorsPropertiesEnum>;
  os?: InputMaybe<Scalars['String']>;
  osAny?: InputMaybe<Scalars['String']>;
  osCode?: InputMaybe<Scalars['String']>;
  osCodeAny?: InputMaybe<Scalars['String']>;
  osCodeContain?: InputMaybe<Scalars['String']>;
  osCodeEq?: InputMaybe<Scalars['String']>;
  osCodeGt?: InputMaybe<Scalars['String']>;
  osCodeGte?: InputMaybe<Scalars['String']>;
  osCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  osCodeLike?: InputMaybe<Scalars['String']>;
  osCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  osCodeLt?: InputMaybe<Scalars['String']>;
  osCodeLte?: InputMaybe<Scalars['String']>;
  osCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osContain?: InputMaybe<Scalars['String']>;
  osEq?: InputMaybe<Scalars['String']>;
  osGt?: InputMaybe<Scalars['String']>;
  osGte?: InputMaybe<Scalars['String']>;
  osIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osIsNull?: InputMaybe<Scalars['Boolean']>;
  osLike?: InputMaybe<Scalars['String']>;
  osLikeNoCase?: InputMaybe<Scalars['String']>;
  osLt?: InputMaybe<Scalars['String']>;
  osLte?: InputMaybe<Scalars['String']>;
  osNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osVersion?: InputMaybe<Scalars['String']>;
  osVersionAny?: InputMaybe<Scalars['String']>;
  osVersionContain?: InputMaybe<Scalars['String']>;
  osVersionEq?: InputMaybe<Scalars['String']>;
  osVersionGt?: InputMaybe<Scalars['String']>;
  osVersionGte?: InputMaybe<Scalars['String']>;
  osVersionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osVersionIsNull?: InputMaybe<Scalars['Boolean']>;
  osVersionLike?: InputMaybe<Scalars['String']>;
  osVersionLikeNoCase?: InputMaybe<Scalars['String']>;
  osVersionLt?: InputMaybe<Scalars['String']>;
  osVersionLte?: InputMaybe<Scalars['String']>;
  osVersionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  platform?: InputMaybe<Scalars['String']>;
  platformAny?: InputMaybe<Scalars['String']>;
  platformContain?: InputMaybe<Scalars['String']>;
  platformEq?: InputMaybe<Scalars['String']>;
  platformGt?: InputMaybe<Scalars['String']>;
  platformGte?: InputMaybe<Scalars['String']>;
  platformIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  platformIsNull?: InputMaybe<Scalars['Boolean']>;
  platformLike?: InputMaybe<Scalars['String']>;
  platformLikeNoCase?: InputMaybe<Scalars['String']>;
  platformLt?: InputMaybe<Scalars['String']>;
  platformLte?: InputMaybe<Scalars['String']>;
  platformNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  referrer?: InputMaybe<Scalars['String']>;
  referrerAny?: InputMaybe<Scalars['String']>;
  referrerContain?: InputMaybe<Scalars['String']>;
  referrerEq?: InputMaybe<Scalars['String']>;
  referrerGt?: InputMaybe<Scalars['String']>;
  referrerGte?: InputMaybe<Scalars['String']>;
  referrerIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  referrerIsNull?: InputMaybe<Scalars['Boolean']>;
  referrerLike?: InputMaybe<Scalars['String']>;
  referrerLikeNoCase?: InputMaybe<Scalars['String']>;
  referrerLt?: InputMaybe<Scalars['String']>;
  referrerLte?: InputMaybe<Scalars['String']>;
  referrerNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ua?: InputMaybe<Scalars['String']>;
  uaAny?: InputMaybe<Scalars['String']>;
  uaContain?: InputMaybe<Scalars['String']>;
  uaEq?: InputMaybe<Scalars['String']>;
  uaGt?: InputMaybe<Scalars['String']>;
  uaGte?: InputMaybe<Scalars['String']>;
  uaIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uaIsNull?: InputMaybe<Scalars['Boolean']>;
  uaLike?: InputMaybe<Scalars['String']>;
  uaLikeNoCase?: InputMaybe<Scalars['String']>;
  uaLt?: InputMaybe<Scalars['String']>;
  uaLte?: InputMaybe<Scalars['String']>;
  uaNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAllVisitsArgs = {
  adCampaign?: InputMaybe<Scalars['String']>;
  adCampaignAny?: InputMaybe<Scalars['String']>;
  adCampaignContain?: InputMaybe<Scalars['String']>;
  adCampaignEq?: InputMaybe<Scalars['String']>;
  adCampaignGt?: InputMaybe<Scalars['String']>;
  adCampaignGte?: InputMaybe<Scalars['String']>;
  adCampaignIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adCampaignIsNull?: InputMaybe<Scalars['Boolean']>;
  adCampaignLike?: InputMaybe<Scalars['String']>;
  adCampaignLikeNoCase?: InputMaybe<Scalars['String']>;
  adCampaignLt?: InputMaybe<Scalars['String']>;
  adCampaignLte?: InputMaybe<Scalars['String']>;
  adCampaignNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adDevice?: InputMaybe<Scalars['String']>;
  adDeviceAny?: InputMaybe<Scalars['String']>;
  adDeviceContain?: InputMaybe<Scalars['String']>;
  adDeviceEq?: InputMaybe<Scalars['String']>;
  adDeviceGt?: InputMaybe<Scalars['String']>;
  adDeviceGte?: InputMaybe<Scalars['String']>;
  adDeviceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adDeviceIsNull?: InputMaybe<Scalars['Boolean']>;
  adDeviceLike?: InputMaybe<Scalars['String']>;
  adDeviceLikeNoCase?: InputMaybe<Scalars['String']>;
  adDeviceLt?: InputMaybe<Scalars['String']>;
  adDeviceLte?: InputMaybe<Scalars['String']>;
  adDeviceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adGroup?: InputMaybe<Scalars['String']>;
  adGroupAny?: InputMaybe<Scalars['String']>;
  adGroupContain?: InputMaybe<Scalars['String']>;
  adGroupEq?: InputMaybe<Scalars['String']>;
  adGroupGt?: InputMaybe<Scalars['String']>;
  adGroupGte?: InputMaybe<Scalars['String']>;
  adGroupIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adGroupIsNull?: InputMaybe<Scalars['Boolean']>;
  adGroupLike?: InputMaybe<Scalars['String']>;
  adGroupLikeNoCase?: InputMaybe<Scalars['String']>;
  adGroupLt?: InputMaybe<Scalars['String']>;
  adGroupLte?: InputMaybe<Scalars['String']>;
  adGroupNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adKeyword?: InputMaybe<Scalars['String']>;
  adKeywordAny?: InputMaybe<Scalars['String']>;
  adKeywordContain?: InputMaybe<Scalars['String']>;
  adKeywordEq?: InputMaybe<Scalars['String']>;
  adKeywordGt?: InputMaybe<Scalars['String']>;
  adKeywordGte?: InputMaybe<Scalars['String']>;
  adKeywordIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adKeywordIsNull?: InputMaybe<Scalars['Boolean']>;
  adKeywordLike?: InputMaybe<Scalars['String']>;
  adKeywordLikeNoCase?: InputMaybe<Scalars['String']>;
  adKeywordLt?: InputMaybe<Scalars['String']>;
  adKeywordLte?: InputMaybe<Scalars['String']>;
  adKeywordNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adMedium?: InputMaybe<Scalars['String']>;
  adMediumAny?: InputMaybe<Scalars['String']>;
  adMediumContain?: InputMaybe<Scalars['String']>;
  adMediumEq?: InputMaybe<Scalars['String']>;
  adMediumGt?: InputMaybe<Scalars['String']>;
  adMediumGte?: InputMaybe<Scalars['String']>;
  adMediumIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adMediumIsNull?: InputMaybe<Scalars['Boolean']>;
  adMediumLike?: InputMaybe<Scalars['String']>;
  adMediumLikeNoCase?: InputMaybe<Scalars['String']>;
  adMediumLt?: InputMaybe<Scalars['String']>;
  adMediumLte?: InputMaybe<Scalars['String']>;
  adMediumNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adTrafficSource?: InputMaybe<Scalars['String']>;
  adTrafficSourceAny?: InputMaybe<Scalars['String']>;
  adTrafficSourceContain?: InputMaybe<Scalars['String']>;
  adTrafficSourceEq?: InputMaybe<Scalars['String']>;
  adTrafficSourceGt?: InputMaybe<Scalars['String']>;
  adTrafficSourceGte?: InputMaybe<Scalars['String']>;
  adTrafficSourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adTrafficSourceIsNull?: InputMaybe<Scalars['Boolean']>;
  adTrafficSourceLike?: InputMaybe<Scalars['String']>;
  adTrafficSourceLikeNoCase?: InputMaybe<Scalars['String']>;
  adTrafficSourceLt?: InputMaybe<Scalars['String']>;
  adTrafficSourceLte?: InputMaybe<Scalars['String']>;
  adTrafficSourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  expireAt?: InputMaybe<Scalars['String']>;
  expireAtAny?: InputMaybe<Scalars['String']>;
  expireAtContain?: InputMaybe<Scalars['String']>;
  expireAtEq?: InputMaybe<Scalars['String']>;
  expireAtGt?: InputMaybe<Scalars['String']>;
  expireAtGte?: InputMaybe<Scalars['String']>;
  expireAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  expireAtIsNull?: InputMaybe<Scalars['Boolean']>;
  expireAtLike?: InputMaybe<Scalars['String']>;
  expireAtLikeNoCase?: InputMaybe<Scalars['String']>;
  expireAtLt?: InputMaybe<Scalars['String']>;
  expireAtLte?: InputMaybe<Scalars['String']>;
  expireAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLVisitsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLVisitsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  urlAny?: InputMaybe<Scalars['String']>;
  urlContain?: InputMaybe<Scalars['String']>;
  urlEq?: InputMaybe<Scalars['String']>;
  urlGt?: InputMaybe<Scalars['String']>;
  urlGte?: InputMaybe<Scalars['String']>;
  urlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlIsNull?: InputMaybe<Scalars['Boolean']>;
  urlLike?: InputMaybe<Scalars['String']>;
  urlLikeNoCase?: InputMaybe<Scalars['String']>;
  urlLt?: InputMaybe<Scalars['String']>;
  urlLte?: InputMaybe<Scalars['String']>;
  urlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitorId?: InputMaybe<Scalars['String']>;
  visitorIdAny?: InputMaybe<Scalars['String']>;
  visitorIdContain?: InputMaybe<Scalars['String']>;
  visitorIdEq?: InputMaybe<Scalars['String']>;
  visitorIdGt?: InputMaybe<Scalars['String']>;
  visitorIdGte?: InputMaybe<Scalars['String']>;
  visitorIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitorIdIsNull?: InputMaybe<Scalars['Boolean']>;
  visitorIdLike?: InputMaybe<Scalars['String']>;
  visitorIdLikeNoCase?: InputMaybe<Scalars['String']>;
  visitorIdLt?: InputMaybe<Scalars['String']>;
  visitorIdLte?: InputMaybe<Scalars['String']>;
  visitorIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryAttachmentArgs = {
  access?: InputMaybe<Scalars['String']>;
  accessAny?: InputMaybe<Scalars['String']>;
  accessContain?: InputMaybe<Scalars['String']>;
  accessEq?: InputMaybe<Scalars['String']>;
  accessGt?: InputMaybe<Scalars['String']>;
  accessGte?: InputMaybe<Scalars['String']>;
  accessIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accessIsNull?: InputMaybe<Scalars['Boolean']>;
  accessLike?: InputMaybe<Scalars['String']>;
  accessLikeNoCase?: InputMaybe<Scalars['String']>;
  accessLt?: InputMaybe<Scalars['String']>;
  accessLte?: InputMaybe<Scalars['String']>;
  accessNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alt?: InputMaybe<Scalars['String']>;
  altAny?: InputMaybe<Scalars['String']>;
  altContain?: InputMaybe<Scalars['String']>;
  altEq?: InputMaybe<Scalars['String']>;
  altGt?: InputMaybe<Scalars['String']>;
  altGte?: InputMaybe<Scalars['String']>;
  altIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  altIsNull?: InputMaybe<Scalars['Boolean']>;
  altLike?: InputMaybe<Scalars['String']>;
  altLikeNoCase?: InputMaybe<Scalars['String']>;
  altLt?: InputMaybe<Scalars['String']>;
  altLte?: InputMaybe<Scalars['String']>;
  altNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caption?: InputMaybe<Scalars['String']>;
  captionAny?: InputMaybe<Scalars['String']>;
  captionContain?: InputMaybe<Scalars['String']>;
  captionEq?: InputMaybe<Scalars['String']>;
  captionGt?: InputMaybe<Scalars['String']>;
  captionGte?: InputMaybe<Scalars['String']>;
  captionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  captionIsNull?: InputMaybe<Scalars['Boolean']>;
  captionLike?: InputMaybe<Scalars['String']>;
  captionLikeNoCase?: InputMaybe<Scalars['String']>;
  captionLt?: InputMaybe<Scalars['String']>;
  captionLte?: InputMaybe<Scalars['String']>;
  captionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fullPath?: InputMaybe<Scalars['String']>;
  fullPathAny?: InputMaybe<Scalars['String']>;
  fullPathContain?: InputMaybe<Scalars['String']>;
  fullPathEq?: InputMaybe<Scalars['String']>;
  fullPathGt?: InputMaybe<Scalars['String']>;
  fullPathGte?: InputMaybe<Scalars['String']>;
  fullPathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullPathIsNull?: InputMaybe<Scalars['Boolean']>;
  fullPathLike?: InputMaybe<Scalars['String']>;
  fullPathLikeNoCase?: InputMaybe<Scalars['String']>;
  fullPathLt?: InputMaybe<Scalars['String']>;
  fullPathLte?: InputMaybe<Scalars['String']>;
  fullPathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mimeType?: InputMaybe<Scalars['String']>;
  mimeTypeAny?: InputMaybe<Scalars['String']>;
  mimeTypeContain?: InputMaybe<Scalars['String']>;
  mimeTypeEq?: InputMaybe<Scalars['String']>;
  mimeTypeGt?: InputMaybe<Scalars['String']>;
  mimeTypeGte?: InputMaybe<Scalars['String']>;
  mimeTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mimeTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  mimeTypeLike?: InputMaybe<Scalars['String']>;
  mimeTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  mimeTypeLt?: InputMaybe<Scalars['String']>;
  mimeTypeLte?: InputMaybe<Scalars['String']>;
  mimeTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  originalName?: InputMaybe<Scalars['String']>;
  originalNameAny?: InputMaybe<Scalars['String']>;
  originalNameContain?: InputMaybe<Scalars['String']>;
  originalNameEq?: InputMaybe<Scalars['String']>;
  originalNameGt?: InputMaybe<Scalars['String']>;
  originalNameGte?: InputMaybe<Scalars['String']>;
  originalNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  originalNameIsNull?: InputMaybe<Scalars['Boolean']>;
  originalNameLike?: InputMaybe<Scalars['String']>;
  originalNameLikeNoCase?: InputMaybe<Scalars['String']>;
  originalNameLt?: InputMaybe<Scalars['String']>;
  originalNameLte?: InputMaybe<Scalars['String']>;
  originalNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  path?: InputMaybe<Scalars['String']>;
  pathAny?: InputMaybe<Scalars['String']>;
  pathContain?: InputMaybe<Scalars['String']>;
  pathEq?: InputMaybe<Scalars['String']>;
  pathGt?: InputMaybe<Scalars['String']>;
  pathGte?: InputMaybe<Scalars['String']>;
  pathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pathIsNull?: InputMaybe<Scalars['Boolean']>;
  pathLike?: InputMaybe<Scalars['String']>;
  pathLikeNoCase?: InputMaybe<Scalars['String']>;
  pathLt?: InputMaybe<Scalars['String']>;
  pathLte?: InputMaybe<Scalars['String']>;
  pathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size?: InputMaybe<Scalars['Int']>;
  sizeAny?: InputMaybe<Scalars['Int']>;
  sizeContain?: InputMaybe<Scalars['Int']>;
  sizeEq?: InputMaybe<Scalars['Int']>;
  sizeGt?: InputMaybe<Scalars['Int']>;
  sizeGte?: InputMaybe<Scalars['Int']>;
  sizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sizeLike?: InputMaybe<Scalars['Int']>;
  sizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sizeLt?: InputMaybe<Scalars['Int']>;
  sizeLte?: InputMaybe<Scalars['Int']>;
  sizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryBuyerIntegrationArgs = {
  authIntegrationId?: InputMaybe<Scalars['Int']>;
  authIntegrationIdAny?: InputMaybe<Scalars['Int']>;
  authIntegrationIdContain?: InputMaybe<Scalars['Int']>;
  authIntegrationIdEq?: InputMaybe<Scalars['Int']>;
  authIntegrationIdGt?: InputMaybe<Scalars['Int']>;
  authIntegrationIdGte?: InputMaybe<Scalars['Int']>;
  authIntegrationIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  authIntegrationIdIsNull?: InputMaybe<Scalars['Boolean']>;
  authIntegrationIdLike?: InputMaybe<Scalars['Int']>;
  authIntegrationIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  authIntegrationIdLt?: InputMaybe<Scalars['Int']>;
  authIntegrationIdLte?: InputMaybe<Scalars['Int']>;
  authIntegrationIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerId?: InputMaybe<Scalars['Int']>;
  buyerIdAny?: InputMaybe<Scalars['Int']>;
  buyerIdContain?: InputMaybe<Scalars['Int']>;
  buyerIdEq?: InputMaybe<Scalars['Int']>;
  buyerIdGt?: InputMaybe<Scalars['Int']>;
  buyerIdGte?: InputMaybe<Scalars['Int']>;
  buyerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  buyerIdLike?: InputMaybe<Scalars['Int']>;
  buyerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  buyerIdLt?: InputMaybe<Scalars['Int']>;
  buyerIdLte?: InputMaybe<Scalars['Int']>;
  buyerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerIntegrationId?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdAny?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdContain?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdEq?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdGt?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdGte?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  buyerIntegrationIdIsNull?: InputMaybe<Scalars['Boolean']>;
  buyerIntegrationIdLike?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdLt?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdLte?: InputMaybe<Scalars['Int']>;
  buyerIntegrationIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  criteria?: InputMaybe<Scalars['JSON']>;
  criteriaAny?: InputMaybe<Scalars['JSON']>;
  criteriaContain?: InputMaybe<Scalars['JSON']>;
  criteriaEq?: InputMaybe<Scalars['JSON']>;
  criteriaGt?: InputMaybe<Scalars['JSON']>;
  criteriaGte?: InputMaybe<Scalars['JSON']>;
  criteriaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  criteriaIsNull?: InputMaybe<Scalars['Boolean']>;
  criteriaLike?: InputMaybe<Scalars['JSON']>;
  criteriaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  criteriaLt?: InputMaybe<Scalars['JSON']>;
  criteriaLte?: InputMaybe<Scalars['JSON']>;
  criteriaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  log?: InputMaybe<Scalars['JSON']>;
  logAny?: InputMaybe<Scalars['JSON']>;
  logContain?: InputMaybe<Scalars['JSON']>;
  logEq?: InputMaybe<Scalars['JSON']>;
  logGt?: InputMaybe<Scalars['JSON']>;
  logGte?: InputMaybe<Scalars['JSON']>;
  logIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  logIsNull?: InputMaybe<Scalars['Boolean']>;
  logLike?: InputMaybe<Scalars['JSON']>;
  logLikeNoCase?: InputMaybe<Scalars['JSON']>;
  logLt?: InputMaybe<Scalars['JSON']>;
  logLte?: InputMaybe<Scalars['JSON']>;
  logNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  method?: InputMaybe<Scalars['String']>;
  methodAny?: InputMaybe<Scalars['String']>;
  methodContain?: InputMaybe<Scalars['String']>;
  methodEq?: InputMaybe<Scalars['String']>;
  methodGt?: InputMaybe<Scalars['String']>;
  methodGte?: InputMaybe<Scalars['String']>;
  methodIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  methodIsNull?: InputMaybe<Scalars['Boolean']>;
  methodLike?: InputMaybe<Scalars['String']>;
  methodLikeNoCase?: InputMaybe<Scalars['String']>;
  methodLt?: InputMaybe<Scalars['String']>;
  methodLte?: InputMaybe<Scalars['String']>;
  methodNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notQualified?: InputMaybe<Scalars['Boolean']>;
  notQualifiedAny?: InputMaybe<Scalars['Boolean']>;
  notQualifiedContain?: InputMaybe<Scalars['Boolean']>;
  notQualifiedEq?: InputMaybe<Scalars['Boolean']>;
  notQualifiedGt?: InputMaybe<Scalars['Boolean']>;
  notQualifiedGte?: InputMaybe<Scalars['Boolean']>;
  notQualifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  notQualifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  notQualifiedLike?: InputMaybe<Scalars['Boolean']>;
  notQualifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  notQualifiedLt?: InputMaybe<Scalars['Boolean']>;
  notQualifiedLte?: InputMaybe<Scalars['Boolean']>;
  notQualifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  notificationIntegrations?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsAny?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsContain?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsEq?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsGt?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsGte?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  notificationIntegrationsIsNull?: InputMaybe<Scalars['Boolean']>;
  notificationIntegrationsLike?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsLt?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsLte?: InputMaybe<Scalars['JSON']>;
  notificationIntegrationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldVersion?: InputMaybe<Scalars['Float']>;
  oldVersionAny?: InputMaybe<Scalars['Float']>;
  oldVersionContain?: InputMaybe<Scalars['Float']>;
  oldVersionEq?: InputMaybe<Scalars['Float']>;
  oldVersionGt?: InputMaybe<Scalars['Float']>;
  oldVersionGte?: InputMaybe<Scalars['Float']>;
  oldVersionIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  oldVersionIsNull?: InputMaybe<Scalars['Boolean']>;
  oldVersionLike?: InputMaybe<Scalars['Float']>;
  oldVersionLikeNoCase?: InputMaybe<Scalars['Float']>;
  oldVersionLt?: InputMaybe<Scalars['Float']>;
  oldVersionLte?: InputMaybe<Scalars['Float']>;
  oldVersionNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  orderBy?: InputMaybe<GQLBuyerIntegrationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLBuyerIntegrationsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  relatedIntegrations?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsAny?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsContain?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsEq?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsGt?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsGte?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  relatedIntegrationsIsNull?: InputMaybe<Scalars['Boolean']>;
  relatedIntegrationsLike?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsLt?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsLte?: InputMaybe<Scalars['JSON']>;
  relatedIntegrationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  secondRound?: InputMaybe<Scalars['Boolean']>;
  secondRoundAny?: InputMaybe<Scalars['Boolean']>;
  secondRoundContain?: InputMaybe<Scalars['Boolean']>;
  secondRoundEq?: InputMaybe<Scalars['Boolean']>;
  secondRoundGt?: InputMaybe<Scalars['Boolean']>;
  secondRoundGte?: InputMaybe<Scalars['Boolean']>;
  secondRoundIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  secondRoundIsNull?: InputMaybe<Scalars['Boolean']>;
  secondRoundLike?: InputMaybe<Scalars['Boolean']>;
  secondRoundLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  secondRoundLt?: InputMaybe<Scalars['Boolean']>;
  secondRoundLte?: InputMaybe<Scalars['Boolean']>;
  secondRoundNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uuid?: InputMaybe<Scalars['String']>;
  uuidAny?: InputMaybe<Scalars['String']>;
  uuidContain?: InputMaybe<Scalars['String']>;
  uuidEq?: InputMaybe<Scalars['String']>;
  uuidGt?: InputMaybe<Scalars['String']>;
  uuidGte?: InputMaybe<Scalars['String']>;
  uuidIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uuidIsNull?: InputMaybe<Scalars['Boolean']>;
  uuidLike?: InputMaybe<Scalars['String']>;
  uuidLikeNoCase?: InputMaybe<Scalars['String']>;
  uuidLt?: InputMaybe<Scalars['String']>;
  uuidLte?: InputMaybe<Scalars['String']>;
  uuidNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueRule?: InputMaybe<Scalars['JSON']>;
  valueRuleAny?: InputMaybe<Scalars['JSON']>;
  valueRuleContain?: InputMaybe<Scalars['JSON']>;
  valueRuleEq?: InputMaybe<Scalars['JSON']>;
  valueRuleGt?: InputMaybe<Scalars['JSON']>;
  valueRuleGte?: InputMaybe<Scalars['JSON']>;
  valueRuleIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueRuleIsNull?: InputMaybe<Scalars['Boolean']>;
  valueRuleLike?: InputMaybe<Scalars['JSON']>;
  valueRuleLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueRuleLt?: InputMaybe<Scalars['JSON']>;
  valueRuleLte?: InputMaybe<Scalars['JSON']>;
  valueRuleNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  version?: InputMaybe<Scalars['Float']>;
  versionAny?: InputMaybe<Scalars['Float']>;
  versionContain?: InputMaybe<Scalars['Float']>;
  versionEq?: InputMaybe<Scalars['Float']>;
  versionGt?: InputMaybe<Scalars['Float']>;
  versionGte?: InputMaybe<Scalars['Float']>;
  versionIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  versionIsNull?: InputMaybe<Scalars['Boolean']>;
  versionLike?: InputMaybe<Scalars['Float']>;
  versionLikeNoCase?: InputMaybe<Scalars['Float']>;
  versionLt?: InputMaybe<Scalars['Float']>;
  versionLte?: InputMaybe<Scalars['Float']>;
  versionNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  versionStatus?: InputMaybe<Scalars['String']>;
  versionStatusAny?: InputMaybe<Scalars['String']>;
  versionStatusContain?: InputMaybe<Scalars['String']>;
  versionStatusEq?: InputMaybe<Scalars['String']>;
  versionStatusGt?: InputMaybe<Scalars['String']>;
  versionStatusGte?: InputMaybe<Scalars['String']>;
  versionStatusIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  versionStatusIsNull?: InputMaybe<Scalars['Boolean']>;
  versionStatusLike?: InputMaybe<Scalars['String']>;
  versionStatusLikeNoCase?: InputMaybe<Scalars['String']>;
  versionStatusLt?: InputMaybe<Scalars['String']>;
  versionStatusLte?: InputMaybe<Scalars['String']>;
  versionStatusNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryCallCenterArgs = {
  categories?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categorySlug?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerSlug?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  ts?: InputMaybe<Scalars['String']>;
};


export type GQLQueryCategoryArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryCategoryAttributeArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  comparison?: InputMaybe<Scalars['Boolean']>;
  comparisonAny?: InputMaybe<Scalars['Boolean']>;
  comparisonContain?: InputMaybe<Scalars['Boolean']>;
  comparisonEq?: InputMaybe<Scalars['Boolean']>;
  comparisonGt?: InputMaybe<Scalars['Boolean']>;
  comparisonGte?: InputMaybe<Scalars['Boolean']>;
  comparisonIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  comparisonIsNull?: InputMaybe<Scalars['Boolean']>;
  comparisonLike?: InputMaybe<Scalars['Boolean']>;
  comparisonLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  comparisonLt?: InputMaybe<Scalars['Boolean']>;
  comparisonLte?: InputMaybe<Scalars['Boolean']>;
  comparisonNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  forceComparisonsDisplay?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayAny?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayContain?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayEq?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayGt?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayGte?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  forceComparisonsDisplayIsNull?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLike?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLt?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayLte?: InputMaybe<Scalars['Boolean']>;
  forceComparisonsDisplayNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  group?: InputMaybe<Scalars['String']>;
  groupAny?: InputMaybe<Scalars['String']>;
  groupContain?: InputMaybe<Scalars['String']>;
  groupEq?: InputMaybe<Scalars['String']>;
  groupGt?: InputMaybe<Scalars['String']>;
  groupGte?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['Int']>;
  groupIdAny?: InputMaybe<Scalars['Int']>;
  groupIdContain?: InputMaybe<Scalars['Int']>;
  groupIdEq?: InputMaybe<Scalars['Int']>;
  groupIdGt?: InputMaybe<Scalars['Int']>;
  groupIdGte?: InputMaybe<Scalars['Int']>;
  groupIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  groupIdIsNull?: InputMaybe<Scalars['Boolean']>;
  groupIdLike?: InputMaybe<Scalars['Int']>;
  groupIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  groupIdLt?: InputMaybe<Scalars['Int']>;
  groupIdLte?: InputMaybe<Scalars['Int']>;
  groupIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  groupIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupIsNull?: InputMaybe<Scalars['Boolean']>;
  groupLike?: InputMaybe<Scalars['String']>;
  groupLikeNoCase?: InputMaybe<Scalars['String']>;
  groupLt?: InputMaybe<Scalars['String']>;
  groupLte?: InputMaybe<Scalars['String']>;
  groupNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupSlug?: InputMaybe<Scalars['String']>;
  groupSlugAny?: InputMaybe<Scalars['String']>;
  groupSlugContain?: InputMaybe<Scalars['String']>;
  groupSlugEq?: InputMaybe<Scalars['String']>;
  groupSlugGt?: InputMaybe<Scalars['String']>;
  groupSlugGte?: InputMaybe<Scalars['String']>;
  groupSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  groupSlugLike?: InputMaybe<Scalars['String']>;
  groupSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  groupSlugLt?: InputMaybe<Scalars['String']>;
  groupSlugLte?: InputMaybe<Scalars['String']>;
  groupSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  hiddenAny?: InputMaybe<Scalars['Boolean']>;
  hiddenContain?: InputMaybe<Scalars['Boolean']>;
  hiddenEq?: InputMaybe<Scalars['Boolean']>;
  hiddenGt?: InputMaybe<Scalars['Boolean']>;
  hiddenGte?: InputMaybe<Scalars['Boolean']>;
  hiddenIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  hiddenIsNull?: InputMaybe<Scalars['Boolean']>;
  hiddenLike?: InputMaybe<Scalars['Boolean']>;
  hiddenLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  hiddenLt?: InputMaybe<Scalars['Boolean']>;
  hiddenLte?: InputMaybe<Scalars['Boolean']>;
  hiddenNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLCategoryAttributesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoryAttributesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLQueryCategoryAttributesGroupArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoryAttributesGroupsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoryAttributesGroupsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryCategoryAttributesValueArgs = {
  attributeId?: InputMaybe<Scalars['Int']>;
  attributeIdAny?: InputMaybe<Scalars['Int']>;
  attributeIdContain?: InputMaybe<Scalars['Int']>;
  attributeIdEq?: InputMaybe<Scalars['Int']>;
  attributeIdGt?: InputMaybe<Scalars['Int']>;
  attributeIdGte?: InputMaybe<Scalars['Int']>;
  attributeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  attributeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  attributeIdLike?: InputMaybe<Scalars['Int']>;
  attributeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  attributeIdLt?: InputMaybe<Scalars['Int']>;
  attributeIdLte?: InputMaybe<Scalars['Int']>;
  attributeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLCategoryAttributesValuesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoryAttributesValuesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryCustomTextBlocksPositionArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedByAny?: InputMaybe<Scalars['String']>;
  deletedByContain?: InputMaybe<Scalars['String']>;
  deletedByEq?: InputMaybe<Scalars['String']>;
  deletedByGt?: InputMaybe<Scalars['String']>;
  deletedByGte?: InputMaybe<Scalars['String']>;
  deletedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedByIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedByLike?: InputMaybe<Scalars['String']>;
  deletedByLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedByLt?: InputMaybe<Scalars['String']>;
  deletedByLte?: InputMaybe<Scalars['String']>;
  deletedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLCustomTextBlocksPositionsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCustomTextBlocksPositionsPropertiesEnum>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryDkiArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDkisPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDkisPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryDomainArgs = {
  allowedLanguages?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesAny?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesContain?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesEq?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  allowedLanguagesIsNull?: InputMaybe<Scalars['Boolean']>;
  allowedLanguagesLike?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  analyticsCodeId?: InputMaybe<Scalars['String']>;
  analyticsCodeIdAny?: InputMaybe<Scalars['String']>;
  analyticsCodeIdContain?: InputMaybe<Scalars['String']>;
  analyticsCodeIdEq?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  analyticsCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  analyticsCodeIdLike?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cacheSettings?: InputMaybe<Scalars['JSON']>;
  cacheSettingsAny?: InputMaybe<Scalars['JSON']>;
  cacheSettingsContain?: InputMaybe<Scalars['JSON']>;
  cacheSettingsEq?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  cacheSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  cacheSettingsLike?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  clickyCodeId?: InputMaybe<Scalars['String']>;
  clickyCodeIdAny?: InputMaybe<Scalars['String']>;
  clickyCodeIdContain?: InputMaybe<Scalars['String']>;
  clickyCodeIdEq?: InputMaybe<Scalars['String']>;
  clickyCodeIdGt?: InputMaybe<Scalars['String']>;
  clickyCodeIdGte?: InputMaybe<Scalars['String']>;
  clickyCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clickyCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  clickyCodeIdLike?: InputMaybe<Scalars['String']>;
  clickyCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  clickyCodeIdLt?: InputMaybe<Scalars['String']>;
  clickyCodeIdLte?: InputMaybe<Scalars['String']>;
  clickyCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  enableChatWidget?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetAny?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetContain?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetEq?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableChatWidgetIsNull?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLike?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaId?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdAny?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdContain?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdEq?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLike?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedForm?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormAny?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormContain?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormEq?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedFormIsNull?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLike?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  facebookConversionAPISettings?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsAny?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsContain?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsEq?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookConversionAPISettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookConversionAPISettingsLike?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookSiteVerificationCode?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fallbackSettings?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsAny?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsContain?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsEq?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  fallbackSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  fallbackSettingsLike?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  faviconId?: InputMaybe<Scalars['String']>;
  faviconIdAny?: InputMaybe<Scalars['String']>;
  faviconIdContain?: InputMaybe<Scalars['String']>;
  faviconIdEq?: InputMaybe<Scalars['String']>;
  faviconIdGt?: InputMaybe<Scalars['String']>;
  faviconIdGte?: InputMaybe<Scalars['String']>;
  faviconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  faviconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  faviconIdLike?: InputMaybe<Scalars['String']>;
  faviconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  faviconIdLt?: InputMaybe<Scalars['String']>;
  faviconIdLte?: InputMaybe<Scalars['String']>;
  faviconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCode?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  googleSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmId?: InputMaybe<Scalars['String']>;
  gtmIdAny?: InputMaybe<Scalars['String']>;
  gtmIdContain?: InputMaybe<Scalars['String']>;
  gtmIdEq?: InputMaybe<Scalars['String']>;
  gtmIdGt?: InputMaybe<Scalars['String']>;
  gtmIdGte?: InputMaybe<Scalars['String']>;
  gtmIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmIdIsNull?: InputMaybe<Scalars['Boolean']>;
  gtmIdLike?: InputMaybe<Scalars['String']>;
  gtmIdLikeNoCase?: InputMaybe<Scalars['String']>;
  gtmIdLt?: InputMaybe<Scalars['String']>;
  gtmIdLte?: InputMaybe<Scalars['String']>;
  gtmIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  holdingRules?: InputMaybe<Scalars['JSON']>;
  holdingRulesAny?: InputMaybe<Scalars['JSON']>;
  holdingRulesContain?: InputMaybe<Scalars['JSON']>;
  holdingRulesEq?: InputMaybe<Scalars['JSON']>;
  holdingRulesGt?: InputMaybe<Scalars['JSON']>;
  holdingRulesGte?: InputMaybe<Scalars['JSON']>;
  holdingRulesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  holdingRulesIsNull?: InputMaybe<Scalars['Boolean']>;
  holdingRulesLike?: InputMaybe<Scalars['JSON']>;
  holdingRulesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  holdingRulesLt?: InputMaybe<Scalars['JSON']>;
  holdingRulesLte?: InputMaybe<Scalars['JSON']>;
  holdingRulesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabled?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledAny?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledContain?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledEq?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabledIsNull?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLike?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainsPropertiesEnum>;
  otpVerificationCriteria?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaAny?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaContain?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaEq?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  otpVerificationCriteriaIsNull?: InputMaybe<Scalars['Boolean']>;
  otpVerificationCriteriaLike?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  recaptchaConfig?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigAny?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigContain?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigEq?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  recaptchaConfigLike?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  secondaryLogoId?: InputMaybe<Scalars['String']>;
  secondaryLogoIdAny?: InputMaybe<Scalars['String']>;
  secondaryLogoIdContain?: InputMaybe<Scalars['String']>;
  secondaryLogoIdEq?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondaryLogoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  secondaryLogoIdLike?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sendNotifications?: InputMaybe<Scalars['JSON']>;
  sendNotificationsAny?: InputMaybe<Scalars['JSON']>;
  sendNotificationsContain?: InputMaybe<Scalars['JSON']>;
  sendNotificationsEq?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  sendNotificationsIsNull?: InputMaybe<Scalars['Boolean']>;
  sendNotificationsLike?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settings?: InputMaybe<Scalars['JSON']>;
  settingsAny?: InputMaybe<Scalars['JSON']>;
  settingsContain?: InputMaybe<Scalars['JSON']>;
  settingsEq?: InputMaybe<Scalars['JSON']>;
  settingsGt?: InputMaybe<Scalars['JSON']>;
  settingsGte?: InputMaybe<Scalars['JSON']>;
  settingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settingsIsNull?: InputMaybe<Scalars['Boolean']>;
  settingsLike?: InputMaybe<Scalars['JSON']>;
  settingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  settingsLt?: InputMaybe<Scalars['JSON']>;
  settingsLte?: InputMaybe<Scalars['JSON']>;
  settingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  slogan?: InputMaybe<Scalars['String']>;
  sloganAny?: InputMaybe<Scalars['String']>;
  sloganContain?: InputMaybe<Scalars['String']>;
  sloganEq?: InputMaybe<Scalars['String']>;
  sloganGt?: InputMaybe<Scalars['String']>;
  sloganGte?: InputMaybe<Scalars['String']>;
  sloganIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sloganIsNull?: InputMaybe<Scalars['Boolean']>;
  sloganLike?: InputMaybe<Scalars['String']>;
  sloganLikeNoCase?: InputMaybe<Scalars['String']>;
  sloganLt?: InputMaybe<Scalars['String']>;
  sloganLte?: InputMaybe<Scalars['String']>;
  sloganNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateConfig?: InputMaybe<Scalars['JSON']>;
  templateConfigAny?: InputMaybe<Scalars['JSON']>;
  templateConfigContain?: InputMaybe<Scalars['JSON']>;
  templateConfigEq?: InputMaybe<Scalars['JSON']>;
  templateConfigGt?: InputMaybe<Scalars['JSON']>;
  templateConfigGte?: InputMaybe<Scalars['JSON']>;
  templateConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  templateConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  templateConfigLike?: InputMaybe<Scalars['JSON']>;
  templateConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  templateConfigLt?: InputMaybe<Scalars['JSON']>;
  templateConfigLte?: InputMaybe<Scalars['JSON']>;
  templateConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixel?: InputMaybe<Scalars['String']>;
  twitterPixelAny?: InputMaybe<Scalars['String']>;
  twitterPixelContain?: InputMaybe<Scalars['String']>;
  twitterPixelEq?: InputMaybe<Scalars['String']>;
  twitterPixelGt?: InputMaybe<Scalars['String']>;
  twitterPixelGte?: InputMaybe<Scalars['String']>;
  twitterPixelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixelIsNull?: InputMaybe<Scalars['Boolean']>;
  twitterPixelLike?: InputMaybe<Scalars['String']>;
  twitterPixelLikeNoCase?: InputMaybe<Scalars['String']>;
  twitterPixelLt?: InputMaybe<Scalars['String']>;
  twitterPixelLte?: InputMaybe<Scalars['String']>;
  twitterPixelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryDomainCategoryArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  crossSellingDomainFormId?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdAny?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdContain?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdEq?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdGt?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdGte?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  crossSellingDomainFormIdIsNull?: InputMaybe<Scalars['Boolean']>;
  crossSellingDomainFormIdLike?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdLt?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdLte?: InputMaybe<Scalars['Int']>;
  crossSellingDomainFormIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLDomainCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryDomainFormArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formId?: InputMaybe<Scalars['Int']>;
  formIdAny?: InputMaybe<Scalars['Int']>;
  formIdContain?: InputMaybe<Scalars['Int']>;
  formIdEq?: InputMaybe<Scalars['Int']>;
  formIdGt?: InputMaybe<Scalars['Int']>;
  formIdGte?: InputMaybe<Scalars['Int']>;
  formIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formIdIsNull?: InputMaybe<Scalars['Boolean']>;
  formIdLike?: InputMaybe<Scalars['Int']>;
  formIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  formIdLt?: InputMaybe<Scalars['Int']>;
  formIdLte?: InputMaybe<Scalars['Int']>;
  formIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  integrations?: InputMaybe<Scalars['JSON']>;
  integrationsAny?: InputMaybe<Scalars['JSON']>;
  integrationsContain?: InputMaybe<Scalars['JSON']>;
  integrationsEq?: InputMaybe<Scalars['JSON']>;
  integrationsGt?: InputMaybe<Scalars['JSON']>;
  integrationsGte?: InputMaybe<Scalars['JSON']>;
  integrationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  integrationsIsNull?: InputMaybe<Scalars['Boolean']>;
  integrationsLike?: InputMaybe<Scalars['JSON']>;
  integrationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  integrationsLt?: InputMaybe<Scalars['JSON']>;
  integrationsLte?: InputMaybe<Scalars['JSON']>;
  integrationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainFormsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainFormsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryDomainListingArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isComparison?: InputMaybe<Scalars['Boolean']>;
  isComparisonAny?: InputMaybe<Scalars['Boolean']>;
  isComparisonContain?: InputMaybe<Scalars['Boolean']>;
  isComparisonEq?: InputMaybe<Scalars['Boolean']>;
  isComparisonGt?: InputMaybe<Scalars['Boolean']>;
  isComparisonGte?: InputMaybe<Scalars['Boolean']>;
  isComparisonIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isComparisonIsNull?: InputMaybe<Scalars['Boolean']>;
  isComparisonLike?: InputMaybe<Scalars['Boolean']>;
  isComparisonLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isComparisonLt?: InputMaybe<Scalars['Boolean']>;
  isComparisonLte?: InputMaybe<Scalars['Boolean']>;
  isComparisonNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingId?: InputMaybe<Scalars['Int']>;
  listingIdAny?: InputMaybe<Scalars['Int']>;
  listingIdContain?: InputMaybe<Scalars['Int']>;
  listingIdEq?: InputMaybe<Scalars['Int']>;
  listingIdGt?: InputMaybe<Scalars['Int']>;
  listingIdGte?: InputMaybe<Scalars['Int']>;
  listingIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingIdIsNull?: InputMaybe<Scalars['Boolean']>;
  listingIdLike?: InputMaybe<Scalars['Int']>;
  listingIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  listingIdLt?: InputMaybe<Scalars['Int']>;
  listingIdLte?: InputMaybe<Scalars['Int']>;
  listingIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainListingsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainListingsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLQueryDomainMetatagArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainMetatagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainMetatagsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryDomainOfferArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainOffersPropertiesEnum>;
  placements?: InputMaybe<Scalars['JSON']>;
  placementsAny?: InputMaybe<Scalars['JSON']>;
  placementsContain?: InputMaybe<Scalars['JSON']>;
  placementsEq?: InputMaybe<Scalars['JSON']>;
  placementsGt?: InputMaybe<Scalars['JSON']>;
  placementsGte?: InputMaybe<Scalars['JSON']>;
  placementsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  placementsIsNull?: InputMaybe<Scalars['Boolean']>;
  placementsLike?: InputMaybe<Scalars['JSON']>;
  placementsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  placementsLt?: InputMaybe<Scalars['JSON']>;
  placementsLte?: InputMaybe<Scalars['JSON']>;
  placementsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sticky?: InputMaybe<Scalars['Boolean']>;
  stickyAny?: InputMaybe<Scalars['Boolean']>;
  stickyContain?: InputMaybe<Scalars['Boolean']>;
  stickyEq?: InputMaybe<Scalars['Boolean']>;
  stickyGt?: InputMaybe<Scalars['Boolean']>;
  stickyGte?: InputMaybe<Scalars['Boolean']>;
  stickyIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  stickyIsNull?: InputMaybe<Scalars['Boolean']>;
  stickyLike?: InputMaybe<Scalars['Boolean']>;
  stickyLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  stickyLt?: InputMaybe<Scalars['Boolean']>;
  stickyLte?: InputMaybe<Scalars['Boolean']>;
  stickyNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLQueryDomainRouteArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ignoreKeyword?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordAny?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordContain?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordEq?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordGt?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordGte?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  ignoreKeywordIsNull?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordLike?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordLt?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordLte?: InputMaybe<Scalars['Boolean']>;
  ignoreKeywordNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainRoutesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainRoutesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  route?: InputMaybe<Scalars['String']>;
  routeAny?: InputMaybe<Scalars['String']>;
  routeContain?: InputMaybe<Scalars['String']>;
  routeEq?: InputMaybe<Scalars['String']>;
  routeGt?: InputMaybe<Scalars['String']>;
  routeGte?: InputMaybe<Scalars['String']>;
  routeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  routeIsNull?: InputMaybe<Scalars['Boolean']>;
  routeLike?: InputMaybe<Scalars['String']>;
  routeLikeNoCase?: InputMaybe<Scalars['String']>;
  routeLt?: InputMaybe<Scalars['String']>;
  routeLte?: InputMaybe<Scalars['String']>;
  routeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryDomainsEmailSettingArgs = {
  bccEmail?: InputMaybe<Scalars['String']>;
  bccEmailAny?: InputMaybe<Scalars['String']>;
  bccEmailContain?: InputMaybe<Scalars['String']>;
  bccEmailEq?: InputMaybe<Scalars['String']>;
  bccEmailGt?: InputMaybe<Scalars['String']>;
  bccEmailGte?: InputMaybe<Scalars['String']>;
  bccEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bccEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  bccEmailLike?: InputMaybe<Scalars['String']>;
  bccEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  bccEmailLt?: InputMaybe<Scalars['String']>;
  bccEmailLte?: InputMaybe<Scalars['String']>;
  bccEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainLogoId?: InputMaybe<Scalars['String']>;
  domainLogoIdAny?: InputMaybe<Scalars['String']>;
  domainLogoIdContain?: InputMaybe<Scalars['String']>;
  domainLogoIdEq?: InputMaybe<Scalars['String']>;
  domainLogoIdGt?: InputMaybe<Scalars['String']>;
  domainLogoIdGte?: InputMaybe<Scalars['String']>;
  domainLogoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domainLogoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainLogoIdLike?: InputMaybe<Scalars['String']>;
  domainLogoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  domainLogoIdLt?: InputMaybe<Scalars['String']>;
  domainLogoIdLte?: InputMaybe<Scalars['String']>;
  domainLogoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailPassword?: InputMaybe<Scalars['String']>;
  emailPasswordAny?: InputMaybe<Scalars['String']>;
  emailPasswordContain?: InputMaybe<Scalars['String']>;
  emailPasswordEq?: InputMaybe<Scalars['String']>;
  emailPasswordGt?: InputMaybe<Scalars['String']>;
  emailPasswordGte?: InputMaybe<Scalars['String']>;
  emailPasswordIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailPasswordIsNull?: InputMaybe<Scalars['Boolean']>;
  emailPasswordLike?: InputMaybe<Scalars['String']>;
  emailPasswordLikeNoCase?: InputMaybe<Scalars['String']>;
  emailPasswordLt?: InputMaybe<Scalars['String']>;
  emailPasswordLte?: InputMaybe<Scalars['String']>;
  emailPasswordNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailService?: InputMaybe<Scalars['String']>;
  emailServiceAny?: InputMaybe<Scalars['String']>;
  emailServiceContain?: InputMaybe<Scalars['String']>;
  emailServiceEq?: InputMaybe<Scalars['String']>;
  emailServiceGt?: InputMaybe<Scalars['String']>;
  emailServiceGte?: InputMaybe<Scalars['String']>;
  emailServiceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailServiceIsNull?: InputMaybe<Scalars['Boolean']>;
  emailServiceLike?: InputMaybe<Scalars['String']>;
  emailServiceLikeNoCase?: InputMaybe<Scalars['String']>;
  emailServiceLt?: InputMaybe<Scalars['String']>;
  emailServiceLte?: InputMaybe<Scalars['String']>;
  emailServiceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailUserName?: InputMaybe<Scalars['String']>;
  emailUserNameAny?: InputMaybe<Scalars['String']>;
  emailUserNameContain?: InputMaybe<Scalars['String']>;
  emailUserNameEq?: InputMaybe<Scalars['String']>;
  emailUserNameGt?: InputMaybe<Scalars['String']>;
  emailUserNameGte?: InputMaybe<Scalars['String']>;
  emailUserNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailUserNameIsNull?: InputMaybe<Scalars['Boolean']>;
  emailUserNameLike?: InputMaybe<Scalars['String']>;
  emailUserNameLikeNoCase?: InputMaybe<Scalars['String']>;
  emailUserNameLt?: InputMaybe<Scalars['String']>;
  emailUserNameLte?: InputMaybe<Scalars['String']>;
  emailUserNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fromEmail?: InputMaybe<Scalars['String']>;
  fromEmailAny?: InputMaybe<Scalars['String']>;
  fromEmailContain?: InputMaybe<Scalars['String']>;
  fromEmailEq?: InputMaybe<Scalars['String']>;
  fromEmailGt?: InputMaybe<Scalars['String']>;
  fromEmailGte?: InputMaybe<Scalars['String']>;
  fromEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fromEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  fromEmailLike?: InputMaybe<Scalars['String']>;
  fromEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  fromEmailLt?: InputMaybe<Scalars['String']>;
  fromEmailLte?: InputMaybe<Scalars['String']>;
  fromEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainsEmailSettingsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainsEmailSettingsPropertiesEnum>;
  providerAPIKey?: InputMaybe<Scalars['String']>;
  providerAPIKeyAny?: InputMaybe<Scalars['String']>;
  providerAPIKeyContain?: InputMaybe<Scalars['String']>;
  providerAPIKeyEq?: InputMaybe<Scalars['String']>;
  providerAPIKeyGt?: InputMaybe<Scalars['String']>;
  providerAPIKeyGte?: InputMaybe<Scalars['String']>;
  providerAPIKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  providerAPIKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  providerAPIKeyLike?: InputMaybe<Scalars['String']>;
  providerAPIKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  providerAPIKeyLt?: InputMaybe<Scalars['String']>;
  providerAPIKeyLte?: InputMaybe<Scalars['String']>;
  providerAPIKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryEnhancedRedirectionArgs = {
  createdBy?: InputMaybe<Scalars['String']>;
  destinationURI?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  redirectionStatusCode?: InputMaybe<Scalars['Int']>;
  srcURI?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};


export type GQLQueryFacebookWebhookEventArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  data?: InputMaybe<Scalars['JSON']>;
  dataAny?: InputMaybe<Scalars['JSON']>;
  dataContain?: InputMaybe<Scalars['JSON']>;
  dataEq?: InputMaybe<Scalars['JSON']>;
  dataGt?: InputMaybe<Scalars['JSON']>;
  dataGte?: InputMaybe<Scalars['JSON']>;
  dataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  dataIsNull?: InputMaybe<Scalars['Boolean']>;
  dataLike?: InputMaybe<Scalars['JSON']>;
  dataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  dataLt?: InputMaybe<Scalars['JSON']>;
  dataLte?: InputMaybe<Scalars['JSON']>;
  dataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  facebookFormId?: InputMaybe<Scalars['String']>;
  facebookFormIdAny?: InputMaybe<Scalars['String']>;
  facebookFormIdContain?: InputMaybe<Scalars['String']>;
  facebookFormIdEq?: InputMaybe<Scalars['String']>;
  facebookFormIdGt?: InputMaybe<Scalars['String']>;
  facebookFormIdGte?: InputMaybe<Scalars['String']>;
  facebookFormIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookFormIdIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookFormIdLike?: InputMaybe<Scalars['String']>;
  facebookFormIdLikeNoCase?: InputMaybe<Scalars['String']>;
  facebookFormIdLt?: InputMaybe<Scalars['String']>;
  facebookFormIdLte?: InputMaybe<Scalars['String']>;
  facebookFormIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookPageId?: InputMaybe<Scalars['String']>;
  facebookPageIdAny?: InputMaybe<Scalars['String']>;
  facebookPageIdContain?: InputMaybe<Scalars['String']>;
  facebookPageIdEq?: InputMaybe<Scalars['String']>;
  facebookPageIdGt?: InputMaybe<Scalars['String']>;
  facebookPageIdGte?: InputMaybe<Scalars['String']>;
  facebookPageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookPageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookPageIdLike?: InputMaybe<Scalars['String']>;
  facebookPageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  facebookPageIdLt?: InputMaybe<Scalars['String']>;
  facebookPageIdLte?: InputMaybe<Scalars['String']>;
  facebookPageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  leadUuid?: InputMaybe<Scalars['String']>;
  leadUuidAny?: InputMaybe<Scalars['String']>;
  leadUuidContain?: InputMaybe<Scalars['String']>;
  leadUuidEq?: InputMaybe<Scalars['String']>;
  leadUuidGt?: InputMaybe<Scalars['String']>;
  leadUuidGte?: InputMaybe<Scalars['String']>;
  leadUuidIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leadUuidIsNull?: InputMaybe<Scalars['Boolean']>;
  leadUuidLike?: InputMaybe<Scalars['String']>;
  leadUuidLikeNoCase?: InputMaybe<Scalars['String']>;
  leadUuidLt?: InputMaybe<Scalars['String']>;
  leadUuidLte?: InputMaybe<Scalars['String']>;
  leadUuidNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leadgenId?: InputMaybe<Scalars['String']>;
  leadgenIdAny?: InputMaybe<Scalars['String']>;
  leadgenIdContain?: InputMaybe<Scalars['String']>;
  leadgenIdEq?: InputMaybe<Scalars['String']>;
  leadgenIdGt?: InputMaybe<Scalars['String']>;
  leadgenIdGte?: InputMaybe<Scalars['String']>;
  leadgenIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leadgenIdIsNull?: InputMaybe<Scalars['Boolean']>;
  leadgenIdLike?: InputMaybe<Scalars['String']>;
  leadgenIdLikeNoCase?: InputMaybe<Scalars['String']>;
  leadgenIdLt?: InputMaybe<Scalars['String']>;
  leadgenIdLte?: InputMaybe<Scalars['String']>;
  leadgenIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  operation?: InputMaybe<Scalars['JSON']>;
  operationAny?: InputMaybe<Scalars['JSON']>;
  operationContain?: InputMaybe<Scalars['JSON']>;
  operationEq?: InputMaybe<Scalars['JSON']>;
  operationGt?: InputMaybe<Scalars['JSON']>;
  operationGte?: InputMaybe<Scalars['JSON']>;
  operationIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  operationIsNull?: InputMaybe<Scalars['Boolean']>;
  operationLike?: InputMaybe<Scalars['JSON']>;
  operationLikeNoCase?: InputMaybe<Scalars['JSON']>;
  operationLt?: InputMaybe<Scalars['JSON']>;
  operationLte?: InputMaybe<Scalars['JSON']>;
  operationNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  orderBy?: InputMaybe<GQLFacebookWebhookEventsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLFacebookWebhookEventsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requestInfo?: InputMaybe<Scalars['JSON']>;
  requestInfoAny?: InputMaybe<Scalars['JSON']>;
  requestInfoContain?: InputMaybe<Scalars['JSON']>;
  requestInfoEq?: InputMaybe<Scalars['JSON']>;
  requestInfoGt?: InputMaybe<Scalars['JSON']>;
  requestInfoGte?: InputMaybe<Scalars['JSON']>;
  requestInfoIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  requestInfoIsNull?: InputMaybe<Scalars['Boolean']>;
  requestInfoLike?: InputMaybe<Scalars['JSON']>;
  requestInfoLikeNoCase?: InputMaybe<Scalars['JSON']>;
  requestInfoLt?: InputMaybe<Scalars['JSON']>;
  requestInfoLte?: InputMaybe<Scalars['JSON']>;
  requestInfoNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  resultAny?: InputMaybe<Scalars['JSON']>;
  resultContain?: InputMaybe<Scalars['JSON']>;
  resultEq?: InputMaybe<Scalars['JSON']>;
  resultGt?: InputMaybe<Scalars['JSON']>;
  resultGte?: InputMaybe<Scalars['JSON']>;
  resultIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  resultIsNull?: InputMaybe<Scalars['Boolean']>;
  resultLike?: InputMaybe<Scalars['JSON']>;
  resultLikeNoCase?: InputMaybe<Scalars['JSON']>;
  resultLt?: InputMaybe<Scalars['JSON']>;
  resultLte?: InputMaybe<Scalars['JSON']>;
  resultNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  webHookEventData?: InputMaybe<Scalars['JSON']>;
  webHookEventDataAny?: InputMaybe<Scalars['JSON']>;
  webHookEventDataContain?: InputMaybe<Scalars['JSON']>;
  webHookEventDataEq?: InputMaybe<Scalars['JSON']>;
  webHookEventDataGt?: InputMaybe<Scalars['JSON']>;
  webHookEventDataGte?: InputMaybe<Scalars['JSON']>;
  webHookEventDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  webHookEventDataIsNull?: InputMaybe<Scalars['Boolean']>;
  webHookEventDataLike?: InputMaybe<Scalars['JSON']>;
  webHookEventDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  webHookEventDataLt?: InputMaybe<Scalars['JSON']>;
  webHookEventDataLte?: InputMaybe<Scalars['JSON']>;
  webHookEventDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};


export type GQLQueryFaqArgs = {
  answer?: InputMaybe<Scalars['String']>;
  answerAny?: InputMaybe<Scalars['String']>;
  answerContain?: InputMaybe<Scalars['String']>;
  answerEq?: InputMaybe<Scalars['String']>;
  answerGt?: InputMaybe<Scalars['String']>;
  answerGte?: InputMaybe<Scalars['String']>;
  answerIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  answerIsNull?: InputMaybe<Scalars['Boolean']>;
  answerLike?: InputMaybe<Scalars['String']>;
  answerLikeNoCase?: InputMaybe<Scalars['String']>;
  answerLt?: InputMaybe<Scalars['String']>;
  answerLte?: InputMaybe<Scalars['String']>;
  answerNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedByAny?: InputMaybe<Scalars['String']>;
  deletedByContain?: InputMaybe<Scalars['String']>;
  deletedByEq?: InputMaybe<Scalars['String']>;
  deletedByGt?: InputMaybe<Scalars['String']>;
  deletedByGte?: InputMaybe<Scalars['String']>;
  deletedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedByIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedByLike?: InputMaybe<Scalars['String']>;
  deletedByLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedByLt?: InputMaybe<Scalars['String']>;
  deletedByLte?: InputMaybe<Scalars['String']>;
  deletedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLFaqsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLFaqsPropertiesEnum>;
  question?: InputMaybe<Scalars['String']>;
  questionAny?: InputMaybe<Scalars['String']>;
  questionContain?: InputMaybe<Scalars['String']>;
  questionEq?: InputMaybe<Scalars['String']>;
  questionGt?: InputMaybe<Scalars['String']>;
  questionGte?: InputMaybe<Scalars['String']>;
  questionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionIsNull?: InputMaybe<Scalars['Boolean']>;
  questionLike?: InputMaybe<Scalars['String']>;
  questionLikeNoCase?: InputMaybe<Scalars['String']>;
  questionLt?: InputMaybe<Scalars['String']>;
  questionLte?: InputMaybe<Scalars['String']>;
  questionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryFieldArgs = {
  autocomplete?: InputMaybe<Scalars['String']>;
  autocompleteAny?: InputMaybe<Scalars['String']>;
  autocompleteContain?: InputMaybe<Scalars['String']>;
  autocompleteEq?: InputMaybe<Scalars['String']>;
  autocompleteGt?: InputMaybe<Scalars['String']>;
  autocompleteGte?: InputMaybe<Scalars['String']>;
  autocompleteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autocompleteIsNull?: InputMaybe<Scalars['Boolean']>;
  autocompleteLike?: InputMaybe<Scalars['String']>;
  autocompleteLikeNoCase?: InputMaybe<Scalars['String']>;
  autocompleteLt?: InputMaybe<Scalars['String']>;
  autocompleteLte?: InputMaybe<Scalars['String']>;
  autocompleteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  codeName?: InputMaybe<Scalars['String']>;
  codeNameAny?: InputMaybe<Scalars['String']>;
  codeNameContain?: InputMaybe<Scalars['String']>;
  codeNameEq?: InputMaybe<Scalars['String']>;
  codeNameGt?: InputMaybe<Scalars['String']>;
  codeNameGte?: InputMaybe<Scalars['String']>;
  codeNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  codeNameIsNull?: InputMaybe<Scalars['Boolean']>;
  codeNameLike?: InputMaybe<Scalars['String']>;
  codeNameLikeNoCase?: InputMaybe<Scalars['String']>;
  codeNameLt?: InputMaybe<Scalars['String']>;
  codeNameLte?: InputMaybe<Scalars['String']>;
  codeNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dataDependency?: InputMaybe<Scalars['JSON']>;
  dataDependencyAny?: InputMaybe<Scalars['JSON']>;
  dataDependencyContain?: InputMaybe<Scalars['JSON']>;
  dataDependencyEq?: InputMaybe<Scalars['JSON']>;
  dataDependencyGt?: InputMaybe<Scalars['JSON']>;
  dataDependencyGte?: InputMaybe<Scalars['JSON']>;
  dataDependencyIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  dataDependencyIsNull?: InputMaybe<Scalars['Boolean']>;
  dataDependencyLike?: InputMaybe<Scalars['JSON']>;
  dataDependencyLikeNoCase?: InputMaybe<Scalars['JSON']>;
  dataDependencyLt?: InputMaybe<Scalars['JSON']>;
  dataDependencyLte?: InputMaybe<Scalars['JSON']>;
  dataDependencyNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  defaultValue?: InputMaybe<Scalars['String']>;
  defaultValueAny?: InputMaybe<Scalars['String']>;
  defaultValueContain?: InputMaybe<Scalars['String']>;
  defaultValueEq?: InputMaybe<Scalars['String']>;
  defaultValueGt?: InputMaybe<Scalars['String']>;
  defaultValueGte?: InputMaybe<Scalars['String']>;
  defaultValueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultValueIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultValueLike?: InputMaybe<Scalars['String']>;
  defaultValueLikeNoCase?: InputMaybe<Scalars['String']>;
  defaultValueLt?: InputMaybe<Scalars['String']>;
  defaultValueLte?: InputMaybe<Scalars['String']>;
  defaultValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultValues?: InputMaybe<Scalars['JSON']>;
  defaultValuesAny?: InputMaybe<Scalars['JSON']>;
  defaultValuesContain?: InputMaybe<Scalars['JSON']>;
  defaultValuesEq?: InputMaybe<Scalars['JSON']>;
  defaultValuesGt?: InputMaybe<Scalars['JSON']>;
  defaultValuesGte?: InputMaybe<Scalars['JSON']>;
  defaultValuesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  defaultValuesIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultValuesLike?: InputMaybe<Scalars['JSON']>;
  defaultValuesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  defaultValuesLt?: InputMaybe<Scalars['JSON']>;
  defaultValuesLte?: InputMaybe<Scalars['JSON']>;
  defaultValuesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorMessageAny?: InputMaybe<Scalars['String']>;
  errorMessageContain?: InputMaybe<Scalars['String']>;
  errorMessageEq?: InputMaybe<Scalars['String']>;
  errorMessageGt?: InputMaybe<Scalars['String']>;
  errorMessageGte?: InputMaybe<Scalars['String']>;
  errorMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  errorMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  errorMessageLike?: InputMaybe<Scalars['String']>;
  errorMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  errorMessageLt?: InputMaybe<Scalars['String']>;
  errorMessageLte?: InputMaybe<Scalars['String']>;
  errorMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldType?: InputMaybe<Scalars['String']>;
  fieldTypeAny?: InputMaybe<Scalars['String']>;
  fieldTypeContain?: InputMaybe<Scalars['String']>;
  fieldTypeEq?: InputMaybe<Scalars['String']>;
  fieldTypeGt?: InputMaybe<Scalars['String']>;
  fieldTypeGte?: InputMaybe<Scalars['String']>;
  fieldTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  fieldTypeLike?: InputMaybe<Scalars['String']>;
  fieldTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  fieldTypeLt?: InputMaybe<Scalars['String']>;
  fieldTypeLte?: InputMaybe<Scalars['String']>;
  fieldTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  formId?: InputMaybe<Scalars['Int']>;
  formIdAny?: InputMaybe<Scalars['Int']>;
  formIdContain?: InputMaybe<Scalars['Int']>;
  formIdEq?: InputMaybe<Scalars['Int']>;
  formIdGt?: InputMaybe<Scalars['Int']>;
  formIdGte?: InputMaybe<Scalars['Int']>;
  formIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formIdIsNull?: InputMaybe<Scalars['Boolean']>;
  formIdLike?: InputMaybe<Scalars['Int']>;
  formIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  formIdLt?: InputMaybe<Scalars['Int']>;
  formIdLte?: InputMaybe<Scalars['Int']>;
  formIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  isGlobalAny?: InputMaybe<Scalars['Boolean']>;
  isGlobalContain?: InputMaybe<Scalars['Boolean']>;
  isGlobalEq?: InputMaybe<Scalars['Boolean']>;
  isGlobalGt?: InputMaybe<Scalars['Boolean']>;
  isGlobalGte?: InputMaybe<Scalars['Boolean']>;
  isGlobalIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isGlobalIsNull?: InputMaybe<Scalars['Boolean']>;
  isGlobalLike?: InputMaybe<Scalars['Boolean']>;
  isGlobalLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isGlobalLt?: InputMaybe<Scalars['Boolean']>;
  isGlobalLte?: InputMaybe<Scalars['Boolean']>;
  isGlobalNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mask?: InputMaybe<Scalars['String']>;
  maskAny?: InputMaybe<Scalars['String']>;
  maskContain?: InputMaybe<Scalars['String']>;
  maskEq?: InputMaybe<Scalars['String']>;
  maskGt?: InputMaybe<Scalars['String']>;
  maskGte?: InputMaybe<Scalars['String']>;
  maskIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maskIsNull?: InputMaybe<Scalars['Boolean']>;
  maskLike?: InputMaybe<Scalars['String']>;
  maskLikeNoCase?: InputMaybe<Scalars['String']>;
  maskLt?: InputMaybe<Scalars['String']>;
  maskLte?: InputMaybe<Scalars['String']>;
  maskNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxValue?: InputMaybe<Scalars['JSON']>;
  maxValueAny?: InputMaybe<Scalars['JSON']>;
  maxValueContain?: InputMaybe<Scalars['JSON']>;
  maxValueEq?: InputMaybe<Scalars['JSON']>;
  maxValueGt?: InputMaybe<Scalars['JSON']>;
  maxValueGte?: InputMaybe<Scalars['JSON']>;
  maxValueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  maxValueIsNull?: InputMaybe<Scalars['Boolean']>;
  maxValueLike?: InputMaybe<Scalars['JSON']>;
  maxValueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  maxValueLt?: InputMaybe<Scalars['JSON']>;
  maxValueLte?: InputMaybe<Scalars['JSON']>;
  maxValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  meta?: InputMaybe<Scalars['JSON']>;
  metaAny?: InputMaybe<Scalars['JSON']>;
  metaContain?: InputMaybe<Scalars['JSON']>;
  metaEq?: InputMaybe<Scalars['JSON']>;
  metaGt?: InputMaybe<Scalars['JSON']>;
  metaGte?: InputMaybe<Scalars['JSON']>;
  metaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  metaIsNull?: InputMaybe<Scalars['Boolean']>;
  metaLike?: InputMaybe<Scalars['JSON']>;
  metaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  metaLt?: InputMaybe<Scalars['JSON']>;
  metaLte?: InputMaybe<Scalars['JSON']>;
  metaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  minValue?: InputMaybe<Scalars['JSON']>;
  minValueAny?: InputMaybe<Scalars['JSON']>;
  minValueContain?: InputMaybe<Scalars['JSON']>;
  minValueEq?: InputMaybe<Scalars['JSON']>;
  minValueGt?: InputMaybe<Scalars['JSON']>;
  minValueGte?: InputMaybe<Scalars['JSON']>;
  minValueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  minValueIsNull?: InputMaybe<Scalars['Boolean']>;
  minValueLike?: InputMaybe<Scalars['JSON']>;
  minValueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  minValueLt?: InputMaybe<Scalars['JSON']>;
  minValueLte?: InputMaybe<Scalars['JSON']>;
  minValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  modifiedAt?: InputMaybe<Scalars['String']>;
  modifiedAtAny?: InputMaybe<Scalars['String']>;
  modifiedAtContain?: InputMaybe<Scalars['String']>;
  modifiedAtEq?: InputMaybe<Scalars['String']>;
  modifiedAtGt?: InputMaybe<Scalars['String']>;
  modifiedAtGte?: InputMaybe<Scalars['String']>;
  modifiedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedAtLike?: InputMaybe<Scalars['String']>;
  modifiedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedAtLt?: InputMaybe<Scalars['String']>;
  modifiedAtLte?: InputMaybe<Scalars['String']>;
  modifiedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  note?: InputMaybe<Scalars['String']>;
  noteAny?: InputMaybe<Scalars['String']>;
  noteContain?: InputMaybe<Scalars['String']>;
  noteEq?: InputMaybe<Scalars['String']>;
  noteGt?: InputMaybe<Scalars['String']>;
  noteGte?: InputMaybe<Scalars['String']>;
  noteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  noteIsNull?: InputMaybe<Scalars['Boolean']>;
  noteLike?: InputMaybe<Scalars['String']>;
  noteLikeNoCase?: InputMaybe<Scalars['String']>;
  noteLt?: InputMaybe<Scalars['String']>;
  noteLte?: InputMaybe<Scalars['String']>;
  noteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLFieldsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLFieldsPropertiesEnum>;
  pattern?: InputMaybe<Scalars['String']>;
  patternAny?: InputMaybe<Scalars['String']>;
  patternContain?: InputMaybe<Scalars['String']>;
  patternEq?: InputMaybe<Scalars['String']>;
  patternGt?: InputMaybe<Scalars['String']>;
  patternGte?: InputMaybe<Scalars['String']>;
  patternIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  patternIsNull?: InputMaybe<Scalars['Boolean']>;
  patternLike?: InputMaybe<Scalars['String']>;
  patternLikeNoCase?: InputMaybe<Scalars['String']>;
  patternLt?: InputMaybe<Scalars['String']>;
  patternLte?: InputMaybe<Scalars['String']>;
  patternNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeholder?: InputMaybe<Scalars['String']>;
  placeholderAny?: InputMaybe<Scalars['String']>;
  placeholderContain?: InputMaybe<Scalars['String']>;
  placeholderEq?: InputMaybe<Scalars['String']>;
  placeholderGt?: InputMaybe<Scalars['String']>;
  placeholderGte?: InputMaybe<Scalars['String']>;
  placeholderIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeholderIsNull?: InputMaybe<Scalars['Boolean']>;
  placeholderLike?: InputMaybe<Scalars['String']>;
  placeholderLikeNoCase?: InputMaybe<Scalars['String']>;
  placeholderLt?: InputMaybe<Scalars['String']>;
  placeholderLte?: InputMaybe<Scalars['String']>;
  placeholderNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCase?: InputMaybe<Scalars['String']>;
  useCaseAny?: InputMaybe<Scalars['String']>;
  useCaseContain?: InputMaybe<Scalars['String']>;
  useCaseEq?: InputMaybe<Scalars['String']>;
  useCaseGt?: InputMaybe<Scalars['String']>;
  useCaseGte?: InputMaybe<Scalars['String']>;
  useCaseIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCaseIsNull?: InputMaybe<Scalars['Boolean']>;
  useCaseLike?: InputMaybe<Scalars['String']>;
  useCaseLikeNoCase?: InputMaybe<Scalars['String']>;
  useCaseLt?: InputMaybe<Scalars['String']>;
  useCaseLte?: InputMaybe<Scalars['String']>;
  useCaseNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  validationType?: InputMaybe<Scalars['String']>;
  validationTypeAny?: InputMaybe<Scalars['String']>;
  validationTypeContain?: InputMaybe<Scalars['String']>;
  validationTypeEq?: InputMaybe<Scalars['String']>;
  validationTypeGt?: InputMaybe<Scalars['String']>;
  validationTypeGte?: InputMaybe<Scalars['String']>;
  validationTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  validationTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  validationTypeLike?: InputMaybe<Scalars['String']>;
  validationTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  validationTypeLt?: InputMaybe<Scalars['String']>;
  validationTypeLte?: InputMaybe<Scalars['String']>;
  validationTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryFieldsMetaArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLFieldsMetaPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLFieldsMetaPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryFormArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorMessageAny?: InputMaybe<Scalars['String']>;
  errorMessageContain?: InputMaybe<Scalars['String']>;
  errorMessageEq?: InputMaybe<Scalars['String']>;
  errorMessageGt?: InputMaybe<Scalars['String']>;
  errorMessageGte?: InputMaybe<Scalars['String']>;
  errorMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  errorMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  errorMessageLike?: InputMaybe<Scalars['String']>;
  errorMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  errorMessageLt?: InputMaybe<Scalars['String']>;
  errorMessageLte?: InputMaybe<Scalars['String']>;
  errorMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVariant?: InputMaybe<Scalars['Boolean']>;
  isVariantAny?: InputMaybe<Scalars['Boolean']>;
  isVariantContain?: InputMaybe<Scalars['Boolean']>;
  isVariantEq?: InputMaybe<Scalars['Boolean']>;
  isVariantGt?: InputMaybe<Scalars['Boolean']>;
  isVariantGte?: InputMaybe<Scalars['Boolean']>;
  isVariantIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVariantIsNull?: InputMaybe<Scalars['Boolean']>;
  isVariantLike?: InputMaybe<Scalars['Boolean']>;
  isVariantLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVariantLt?: InputMaybe<Scalars['Boolean']>;
  isVariantLte?: InputMaybe<Scalars['Boolean']>;
  isVariantNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingId?: InputMaybe<Scalars['Int']>;
  listingIdAny?: InputMaybe<Scalars['Int']>;
  listingIdContain?: InputMaybe<Scalars['Int']>;
  listingIdEq?: InputMaybe<Scalars['Int']>;
  listingIdGt?: InputMaybe<Scalars['Int']>;
  listingIdGte?: InputMaybe<Scalars['Int']>;
  listingIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingIdIsNull?: InputMaybe<Scalars['Boolean']>;
  listingIdLike?: InputMaybe<Scalars['Int']>;
  listingIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  listingIdLt?: InputMaybe<Scalars['Int']>;
  listingIdLte?: InputMaybe<Scalars['Int']>;
  listingIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modifiedAt?: InputMaybe<Scalars['String']>;
  modifiedAtAny?: InputMaybe<Scalars['String']>;
  modifiedAtContain?: InputMaybe<Scalars['String']>;
  modifiedAtEq?: InputMaybe<Scalars['String']>;
  modifiedAtGt?: InputMaybe<Scalars['String']>;
  modifiedAtGte?: InputMaybe<Scalars['String']>;
  modifiedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedAtLike?: InputMaybe<Scalars['String']>;
  modifiedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedAtLt?: InputMaybe<Scalars['String']>;
  modifiedAtLte?: InputMaybe<Scalars['String']>;
  modifiedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLFormsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLFormsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToFetchBuyers?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersAny?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersContain?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersEq?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersGt?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersGte?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToFetchBuyersIsNull?: InputMaybe<Scalars['Boolean']>;
  stepToFetchBuyersLike?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersLikeNoCase?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersLt?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersLte?: InputMaybe<Scalars['Int']>;
  stepToFetchBuyersNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToSendingData?: InputMaybe<Scalars['Int']>;
  stepToSendingDataAny?: InputMaybe<Scalars['Int']>;
  stepToSendingDataContain?: InputMaybe<Scalars['Int']>;
  stepToSendingDataEq?: InputMaybe<Scalars['Int']>;
  stepToSendingDataGt?: InputMaybe<Scalars['Int']>;
  stepToSendingDataGte?: InputMaybe<Scalars['Int']>;
  stepToSendingDataIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepToSendingDataIsNull?: InputMaybe<Scalars['Boolean']>;
  stepToSendingDataLike?: InputMaybe<Scalars['Int']>;
  stepToSendingDataLikeNoCase?: InputMaybe<Scalars['Int']>;
  stepToSendingDataLt?: InputMaybe<Scalars['Int']>;
  stepToSendingDataLte?: InputMaybe<Scalars['Int']>;
  stepToSendingDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  successMessage?: InputMaybe<Scalars['String']>;
  successMessageAny?: InputMaybe<Scalars['String']>;
  successMessageContain?: InputMaybe<Scalars['String']>;
  successMessageEq?: InputMaybe<Scalars['String']>;
  successMessageGt?: InputMaybe<Scalars['String']>;
  successMessageGte?: InputMaybe<Scalars['String']>;
  successMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  successMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  successMessageLike?: InputMaybe<Scalars['String']>;
  successMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  successMessageLt?: InputMaybe<Scalars['String']>;
  successMessageLte?: InputMaybe<Scalars['String']>;
  successMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  variantParentId?: InputMaybe<Scalars['Int']>;
  variantParentIdAny?: InputMaybe<Scalars['Int']>;
  variantParentIdContain?: InputMaybe<Scalars['Int']>;
  variantParentIdEq?: InputMaybe<Scalars['Int']>;
  variantParentIdGt?: InputMaybe<Scalars['Int']>;
  variantParentIdGte?: InputMaybe<Scalars['Int']>;
  variantParentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  variantParentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  variantParentIdLike?: InputMaybe<Scalars['Int']>;
  variantParentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  variantParentIdLt?: InputMaybe<Scalars['Int']>;
  variantParentIdLte?: InputMaybe<Scalars['Int']>;
  variantParentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLQueryIpAddresseArgs = {
  bannedAt?: InputMaybe<Scalars['String']>;
  bannedAtAny?: InputMaybe<Scalars['String']>;
  bannedAtContain?: InputMaybe<Scalars['String']>;
  bannedAtEq?: InputMaybe<Scalars['String']>;
  bannedAtGt?: InputMaybe<Scalars['String']>;
  bannedAtGte?: InputMaybe<Scalars['String']>;
  bannedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bannedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  bannedAtLike?: InputMaybe<Scalars['String']>;
  bannedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  bannedAtLt?: InputMaybe<Scalars['String']>;
  bannedAtLte?: InputMaybe<Scalars['String']>;
  bannedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<Scalars['String']>;
  cityAny?: InputMaybe<Scalars['String']>;
  cityContain?: InputMaybe<Scalars['String']>;
  cityEq?: InputMaybe<Scalars['String']>;
  cityGt?: InputMaybe<Scalars['String']>;
  cityGte?: InputMaybe<Scalars['String']>;
  cityIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityIsNull?: InputMaybe<Scalars['Boolean']>;
  cityLike?: InputMaybe<Scalars['String']>;
  cityLikeNoCase?: InputMaybe<Scalars['String']>;
  cityLt?: InputMaybe<Scalars['String']>;
  cityLte?: InputMaybe<Scalars['String']>;
  cityNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  continent?: InputMaybe<Scalars['String']>;
  continentAny?: InputMaybe<Scalars['String']>;
  continentCode?: InputMaybe<Scalars['String']>;
  continentCodeAny?: InputMaybe<Scalars['String']>;
  continentCodeContain?: InputMaybe<Scalars['String']>;
  continentCodeEq?: InputMaybe<Scalars['String']>;
  continentCodeGt?: InputMaybe<Scalars['String']>;
  continentCodeGte?: InputMaybe<Scalars['String']>;
  continentCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  continentCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  continentCodeLike?: InputMaybe<Scalars['String']>;
  continentCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  continentCodeLt?: InputMaybe<Scalars['String']>;
  continentCodeLte?: InputMaybe<Scalars['String']>;
  continentCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  continentContain?: InputMaybe<Scalars['String']>;
  continentEq?: InputMaybe<Scalars['String']>;
  continentGt?: InputMaybe<Scalars['String']>;
  continentGte?: InputMaybe<Scalars['String']>;
  continentIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  continentIsNull?: InputMaybe<Scalars['Boolean']>;
  continentLike?: InputMaybe<Scalars['String']>;
  continentLikeNoCase?: InputMaybe<Scalars['String']>;
  continentLt?: InputMaybe<Scalars['String']>;
  continentLte?: InputMaybe<Scalars['String']>;
  continentNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  country?: InputMaybe<Scalars['String']>;
  countryAny?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  countryCodeAny?: InputMaybe<Scalars['String']>;
  countryCodeContain?: InputMaybe<Scalars['String']>;
  countryCodeEq?: InputMaybe<Scalars['String']>;
  countryCodeGt?: InputMaybe<Scalars['String']>;
  countryCodeGte?: InputMaybe<Scalars['String']>;
  countryCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  countryCodeLike?: InputMaybe<Scalars['String']>;
  countryCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  countryCodeLt?: InputMaybe<Scalars['String']>;
  countryCodeLte?: InputMaybe<Scalars['String']>;
  countryCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryContain?: InputMaybe<Scalars['String']>;
  countryEq?: InputMaybe<Scalars['String']>;
  countryGt?: InputMaybe<Scalars['String']>;
  countryGte?: InputMaybe<Scalars['String']>;
  countryIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryIsNull?: InputMaybe<Scalars['Boolean']>;
  countryLike?: InputMaybe<Scalars['String']>;
  countryLikeNoCase?: InputMaybe<Scalars['String']>;
  countryLt?: InputMaybe<Scalars['String']>;
  countryLte?: InputMaybe<Scalars['String']>;
  countryNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  expireAt?: InputMaybe<Scalars['String']>;
  expireAtAny?: InputMaybe<Scalars['String']>;
  expireAtContain?: InputMaybe<Scalars['String']>;
  expireAtEq?: InputMaybe<Scalars['String']>;
  expireAtGt?: InputMaybe<Scalars['String']>;
  expireAtGte?: InputMaybe<Scalars['String']>;
  expireAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  expireAtIsNull?: InputMaybe<Scalars['Boolean']>;
  expireAtLike?: InputMaybe<Scalars['String']>;
  expireAtLikeNoCase?: InputMaybe<Scalars['String']>;
  expireAtLt?: InputMaybe<Scalars['String']>;
  expireAtLte?: InputMaybe<Scalars['String']>;
  expireAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ip?: InputMaybe<Scalars['String']>;
  ipAny?: InputMaybe<Scalars['String']>;
  ipContain?: InputMaybe<Scalars['String']>;
  ipEq?: InputMaybe<Scalars['String']>;
  ipGt?: InputMaybe<Scalars['String']>;
  ipGte?: InputMaybe<Scalars['String']>;
  ipIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ipIsNull?: InputMaybe<Scalars['Boolean']>;
  ipLike?: InputMaybe<Scalars['String']>;
  ipLikeNoCase?: InputMaybe<Scalars['String']>;
  ipLt?: InputMaybe<Scalars['String']>;
  ipLte?: InputMaybe<Scalars['String']>;
  ipNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBanned?: InputMaybe<Scalars['Boolean']>;
  isBannedAny?: InputMaybe<Scalars['Boolean']>;
  isBannedContain?: InputMaybe<Scalars['Boolean']>;
  isBannedEq?: InputMaybe<Scalars['Boolean']>;
  isBannedGt?: InputMaybe<Scalars['Boolean']>;
  isBannedGte?: InputMaybe<Scalars['Boolean']>;
  isBannedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBannedIsNull?: InputMaybe<Scalars['Boolean']>;
  isBannedLike?: InputMaybe<Scalars['Boolean']>;
  isBannedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBannedLt?: InputMaybe<Scalars['Boolean']>;
  isBannedLte?: InputMaybe<Scalars['Boolean']>;
  isBannedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isp?: InputMaybe<Scalars['String']>;
  ispAny?: InputMaybe<Scalars['String']>;
  ispContain?: InputMaybe<Scalars['String']>;
  ispEq?: InputMaybe<Scalars['String']>;
  ispGt?: InputMaybe<Scalars['String']>;
  ispGte?: InputMaybe<Scalars['String']>;
  ispIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ispIsNull?: InputMaybe<Scalars['Boolean']>;
  ispLike?: InputMaybe<Scalars['String']>;
  ispLikeNoCase?: InputMaybe<Scalars['String']>;
  ispLt?: InputMaybe<Scalars['String']>;
  ispLte?: InputMaybe<Scalars['String']>;
  ispNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  latitude?: InputMaybe<Scalars['String']>;
  latitudeAny?: InputMaybe<Scalars['String']>;
  latitudeContain?: InputMaybe<Scalars['String']>;
  latitudeEq?: InputMaybe<Scalars['String']>;
  latitudeGt?: InputMaybe<Scalars['String']>;
  latitudeGte?: InputMaybe<Scalars['String']>;
  latitudeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  latitudeIsNull?: InputMaybe<Scalars['Boolean']>;
  latitudeLike?: InputMaybe<Scalars['String']>;
  latitudeLikeNoCase?: InputMaybe<Scalars['String']>;
  latitudeLt?: InputMaybe<Scalars['String']>;
  latitudeLte?: InputMaybe<Scalars['String']>;
  latitudeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  longitude?: InputMaybe<Scalars['String']>;
  longitudeAny?: InputMaybe<Scalars['String']>;
  longitudeContain?: InputMaybe<Scalars['String']>;
  longitudeEq?: InputMaybe<Scalars['String']>;
  longitudeGt?: InputMaybe<Scalars['String']>;
  longitudeGte?: InputMaybe<Scalars['String']>;
  longitudeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  longitudeIsNull?: InputMaybe<Scalars['Boolean']>;
  longitudeLike?: InputMaybe<Scalars['String']>;
  longitudeLikeNoCase?: InputMaybe<Scalars['String']>;
  longitudeLt?: InputMaybe<Scalars['String']>;
  longitudeLte?: InputMaybe<Scalars['String']>;
  longitudeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLIpAddressesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLIpAddressesPropertiesEnum>;
  postalCode?: InputMaybe<Scalars['String']>;
  postalCodeAny?: InputMaybe<Scalars['String']>;
  postalCodeContain?: InputMaybe<Scalars['String']>;
  postalCodeEq?: InputMaybe<Scalars['String']>;
  postalCodeGt?: InputMaybe<Scalars['String']>;
  postalCodeGte?: InputMaybe<Scalars['String']>;
  postalCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  postalCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  postalCodeLike?: InputMaybe<Scalars['String']>;
  postalCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  postalCodeLt?: InputMaybe<Scalars['String']>;
  postalCodeLte?: InputMaybe<Scalars['String']>;
  postalCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  provider?: InputMaybe<Scalars['String']>;
  providerAny?: InputMaybe<Scalars['String']>;
  providerContain?: InputMaybe<Scalars['String']>;
  providerEq?: InputMaybe<Scalars['String']>;
  providerGt?: InputMaybe<Scalars['String']>;
  providerGte?: InputMaybe<Scalars['String']>;
  providerIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  providerIsNull?: InputMaybe<Scalars['Boolean']>;
  providerLike?: InputMaybe<Scalars['String']>;
  providerLikeNoCase?: InputMaybe<Scalars['String']>;
  providerLt?: InputMaybe<Scalars['String']>;
  providerLte?: InputMaybe<Scalars['String']>;
  providerNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  state?: InputMaybe<Scalars['String']>;
  stateAny?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
  stateCodeAny?: InputMaybe<Scalars['String']>;
  stateCodeContain?: InputMaybe<Scalars['String']>;
  stateCodeEq?: InputMaybe<Scalars['String']>;
  stateCodeGt?: InputMaybe<Scalars['String']>;
  stateCodeGte?: InputMaybe<Scalars['String']>;
  stateCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  stateCodeLike?: InputMaybe<Scalars['String']>;
  stateCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  stateCodeLt?: InputMaybe<Scalars['String']>;
  stateCodeLte?: InputMaybe<Scalars['String']>;
  stateCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateContain?: InputMaybe<Scalars['String']>;
  stateEq?: InputMaybe<Scalars['String']>;
  stateGt?: InputMaybe<Scalars['String']>;
  stateGte?: InputMaybe<Scalars['String']>;
  stateIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateIsNull?: InputMaybe<Scalars['Boolean']>;
  stateLike?: InputMaybe<Scalars['String']>;
  stateLikeNoCase?: InputMaybe<Scalars['String']>;
  stateLt?: InputMaybe<Scalars['String']>;
  stateLte?: InputMaybe<Scalars['String']>;
  stateNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryIpFallbackProviderLogArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fallbackProvider?: InputMaybe<Scalars['String']>;
  fallbackProviderAny?: InputMaybe<Scalars['String']>;
  fallbackProviderContain?: InputMaybe<Scalars['String']>;
  fallbackProviderData?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataAny?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataContain?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataEq?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataGt?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataGte?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  fallbackProviderDataIsNull?: InputMaybe<Scalars['Boolean']>;
  fallbackProviderDataLike?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataLt?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataLte?: InputMaybe<Scalars['JSON']>;
  fallbackProviderDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  fallbackProviderEq?: InputMaybe<Scalars['String']>;
  fallbackProviderGt?: InputMaybe<Scalars['String']>;
  fallbackProviderGte?: InputMaybe<Scalars['String']>;
  fallbackProviderIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fallbackProviderIsNull?: InputMaybe<Scalars['Boolean']>;
  fallbackProviderLike?: InputMaybe<Scalars['String']>;
  fallbackProviderLikeNoCase?: InputMaybe<Scalars['String']>;
  fallbackProviderLt?: InputMaybe<Scalars['String']>;
  fallbackProviderLte?: InputMaybe<Scalars['String']>;
  fallbackProviderNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ipAddress?: InputMaybe<Scalars['String']>;
  ipAddressAny?: InputMaybe<Scalars['String']>;
  ipAddressContain?: InputMaybe<Scalars['String']>;
  ipAddressEq?: InputMaybe<Scalars['String']>;
  ipAddressGt?: InputMaybe<Scalars['String']>;
  ipAddressGte?: InputMaybe<Scalars['String']>;
  ipAddressId?: InputMaybe<Scalars['Int']>;
  ipAddressIdAny?: InputMaybe<Scalars['Int']>;
  ipAddressIdContain?: InputMaybe<Scalars['Int']>;
  ipAddressIdEq?: InputMaybe<Scalars['Int']>;
  ipAddressIdGt?: InputMaybe<Scalars['Int']>;
  ipAddressIdGte?: InputMaybe<Scalars['Int']>;
  ipAddressIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ipAddressIdIsNull?: InputMaybe<Scalars['Boolean']>;
  ipAddressIdLike?: InputMaybe<Scalars['Int']>;
  ipAddressIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  ipAddressIdLt?: InputMaybe<Scalars['Int']>;
  ipAddressIdLte?: InputMaybe<Scalars['Int']>;
  ipAddressIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ipAddressIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ipAddressIsNull?: InputMaybe<Scalars['Boolean']>;
  ipAddressLike?: InputMaybe<Scalars['String']>;
  ipAddressLikeNoCase?: InputMaybe<Scalars['String']>;
  ipAddressLt?: InputMaybe<Scalars['String']>;
  ipAddressLte?: InputMaybe<Scalars['String']>;
  ipAddressNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainProvider?: InputMaybe<Scalars['String']>;
  mainProviderAny?: InputMaybe<Scalars['String']>;
  mainProviderContain?: InputMaybe<Scalars['String']>;
  mainProviderData?: InputMaybe<Scalars['JSON']>;
  mainProviderDataAny?: InputMaybe<Scalars['JSON']>;
  mainProviderDataContain?: InputMaybe<Scalars['JSON']>;
  mainProviderDataEq?: InputMaybe<Scalars['JSON']>;
  mainProviderDataGt?: InputMaybe<Scalars['JSON']>;
  mainProviderDataGte?: InputMaybe<Scalars['JSON']>;
  mainProviderDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  mainProviderDataIsNull?: InputMaybe<Scalars['Boolean']>;
  mainProviderDataLike?: InputMaybe<Scalars['JSON']>;
  mainProviderDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  mainProviderDataLt?: InputMaybe<Scalars['JSON']>;
  mainProviderDataLte?: InputMaybe<Scalars['JSON']>;
  mainProviderDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  mainProviderEq?: InputMaybe<Scalars['String']>;
  mainProviderGt?: InputMaybe<Scalars['String']>;
  mainProviderGte?: InputMaybe<Scalars['String']>;
  mainProviderIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainProviderIsNull?: InputMaybe<Scalars['Boolean']>;
  mainProviderLike?: InputMaybe<Scalars['String']>;
  mainProviderLikeNoCase?: InputMaybe<Scalars['String']>;
  mainProviderLt?: InputMaybe<Scalars['String']>;
  mainProviderLte?: InputMaybe<Scalars['String']>;
  mainProviderNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLIpFallbackProviderLogPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLIpFallbackProviderLogPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryLeadArgs = {
  advertisingNetworkId?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdAny?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdContain?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdEq?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdGt?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdGte?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  advertisingNetworkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  advertisingNetworkIdLike?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdLt?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdLte?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainFormId?: InputMaybe<Scalars['Int']>;
  domainFormIdAny?: InputMaybe<Scalars['Int']>;
  domainFormIdContain?: InputMaybe<Scalars['Int']>;
  domainFormIdEq?: InputMaybe<Scalars['Int']>;
  domainFormIdGt?: InputMaybe<Scalars['Int']>;
  domainFormIdGte?: InputMaybe<Scalars['Int']>;
  domainFormIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainFormIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainFormIdLike?: InputMaybe<Scalars['Int']>;
  domainFormIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainFormIdLt?: InputMaybe<Scalars['Int']>;
  domainFormIdLte?: InputMaybe<Scalars['Int']>;
  domainFormIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  feedback?: InputMaybe<Scalars['JSON']>;
  feedbackAny?: InputMaybe<Scalars['JSON']>;
  feedbackContain?: InputMaybe<Scalars['JSON']>;
  feedbackEq?: InputMaybe<Scalars['JSON']>;
  feedbackGt?: InputMaybe<Scalars['JSON']>;
  feedbackGte?: InputMaybe<Scalars['JSON']>;
  feedbackIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  feedbackIsNull?: InputMaybe<Scalars['Boolean']>;
  feedbackLike?: InputMaybe<Scalars['JSON']>;
  feedbackLikeNoCase?: InputMaybe<Scalars['JSON']>;
  feedbackLt?: InputMaybe<Scalars['JSON']>;
  feedbackLte?: InputMaybe<Scalars['JSON']>;
  feedbackNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  hasAliasCalls?: InputMaybe<Scalars['String']>;
  hasAliasCallsAny?: InputMaybe<Scalars['String']>;
  hasAliasCallsContain?: InputMaybe<Scalars['String']>;
  hasAliasCallsEq?: InputMaybe<Scalars['String']>;
  hasAliasCallsGt?: InputMaybe<Scalars['String']>;
  hasAliasCallsGte?: InputMaybe<Scalars['String']>;
  hasAliasCallsIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hasAliasCallsIsNull?: InputMaybe<Scalars['Boolean']>;
  hasAliasCallsLike?: InputMaybe<Scalars['String']>;
  hasAliasCallsLikeNoCase?: InputMaybe<Scalars['String']>;
  hasAliasCallsLt?: InputMaybe<Scalars['String']>;
  hasAliasCallsLte?: InputMaybe<Scalars['String']>;
  hasAliasCallsNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOptedOut?: InputMaybe<Scalars['Boolean']>;
  isOptedOutAny?: InputMaybe<Scalars['Boolean']>;
  isOptedOutContain?: InputMaybe<Scalars['Boolean']>;
  isOptedOutEq?: InputMaybe<Scalars['Boolean']>;
  isOptedOutGt?: InputMaybe<Scalars['Boolean']>;
  isOptedOutGte?: InputMaybe<Scalars['Boolean']>;
  isOptedOutIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOptedOutIsNull?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLike?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLt?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLte?: InputMaybe<Scalars['Boolean']>;
  isOptedOutNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  jornayaId?: InputMaybe<Scalars['String']>;
  jornayaIdAny?: InputMaybe<Scalars['String']>;
  jornayaIdContain?: InputMaybe<Scalars['String']>;
  jornayaIdEq?: InputMaybe<Scalars['String']>;
  jornayaIdGt?: InputMaybe<Scalars['String']>;
  jornayaIdGte?: InputMaybe<Scalars['String']>;
  jornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  jornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  jornayaIdLike?: InputMaybe<Scalars['String']>;
  jornayaIdLikeNoCase?: InputMaybe<Scalars['String']>;
  jornayaIdLt?: InputMaybe<Scalars['String']>;
  jornayaIdLte?: InputMaybe<Scalars['String']>;
  jornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modifiedAt?: InputMaybe<Scalars['String']>;
  modifiedAtAny?: InputMaybe<Scalars['String']>;
  modifiedAtContain?: InputMaybe<Scalars['String']>;
  modifiedAtEq?: InputMaybe<Scalars['String']>;
  modifiedAtGt?: InputMaybe<Scalars['String']>;
  modifiedAtGte?: InputMaybe<Scalars['String']>;
  modifiedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedAtLike?: InputMaybe<Scalars['String']>;
  modifiedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedAtLt?: InputMaybe<Scalars['String']>;
  modifiedAtLte?: InputMaybe<Scalars['String']>;
  modifiedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLLeadsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLeadsPropertiesEnum>;
  piiId?: InputMaybe<Scalars['Int']>;
  piiIdAny?: InputMaybe<Scalars['Int']>;
  piiIdContain?: InputMaybe<Scalars['Int']>;
  piiIdEq?: InputMaybe<Scalars['Int']>;
  piiIdGt?: InputMaybe<Scalars['Int']>;
  piiIdGte?: InputMaybe<Scalars['Int']>;
  piiIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  piiIdIsNull?: InputMaybe<Scalars['Boolean']>;
  piiIdLike?: InputMaybe<Scalars['Int']>;
  piiIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  piiIdLt?: InputMaybe<Scalars['Int']>;
  piiIdLte?: InputMaybe<Scalars['Int']>;
  piiIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sales?: InputMaybe<Scalars['String']>;
  salesAny?: InputMaybe<Scalars['String']>;
  salesContain?: InputMaybe<Scalars['String']>;
  salesEq?: InputMaybe<Scalars['String']>;
  salesGt?: InputMaybe<Scalars['String']>;
  salesGte?: InputMaybe<Scalars['String']>;
  salesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  salesIsNull?: InputMaybe<Scalars['Boolean']>;
  salesLike?: InputMaybe<Scalars['String']>;
  salesLikeNoCase?: InputMaybe<Scalars['String']>;
  salesLt?: InputMaybe<Scalars['String']>;
  salesLte?: InputMaybe<Scalars['String']>;
  salesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Scalars['String']>;
  statusAny?: InputMaybe<Scalars['String']>;
  statusContain?: InputMaybe<Scalars['String']>;
  statusEq?: InputMaybe<Scalars['String']>;
  statusGt?: InputMaybe<Scalars['String']>;
  statusGte?: InputMaybe<Scalars['String']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statusIsNull?: InputMaybe<Scalars['Boolean']>;
  statusLike?: InputMaybe<Scalars['String']>;
  statusLikeNoCase?: InputMaybe<Scalars['String']>;
  statusLt?: InputMaybe<Scalars['String']>;
  statusLte?: InputMaybe<Scalars['String']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  submissionStatus?: InputMaybe<Scalars['String']>;
  submissionStatusAny?: InputMaybe<Scalars['String']>;
  submissionStatusContain?: InputMaybe<Scalars['String']>;
  submissionStatusEq?: InputMaybe<Scalars['String']>;
  submissionStatusGt?: InputMaybe<Scalars['String']>;
  submissionStatusGte?: InputMaybe<Scalars['String']>;
  submissionStatusIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  submissionStatusIsNull?: InputMaybe<Scalars['Boolean']>;
  submissionStatusLike?: InputMaybe<Scalars['String']>;
  submissionStatusLikeNoCase?: InputMaybe<Scalars['String']>;
  submissionStatusLt?: InputMaybe<Scalars['String']>;
  submissionStatusLte?: InputMaybe<Scalars['String']>;
  submissionStatusNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficSource?: InputMaybe<Scalars['String']>;
  trafficSourceAny?: InputMaybe<Scalars['String']>;
  trafficSourceContain?: InputMaybe<Scalars['String']>;
  trafficSourceEq?: InputMaybe<Scalars['String']>;
  trafficSourceGt?: InputMaybe<Scalars['String']>;
  trafficSourceGte?: InputMaybe<Scalars['String']>;
  trafficSourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficSourceIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficSourceLike?: InputMaybe<Scalars['String']>;
  trafficSourceLikeNoCase?: InputMaybe<Scalars['String']>;
  trafficSourceLt?: InputMaybe<Scalars['String']>;
  trafficSourceLte?: InputMaybe<Scalars['String']>;
  trafficSourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficTypeId?: InputMaybe<Scalars['Int']>;
  trafficTypeIdAny?: InputMaybe<Scalars['Int']>;
  trafficTypeIdContain?: InputMaybe<Scalars['Int']>;
  trafficTypeIdEq?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  trafficTypeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficTypeIdLike?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  trustedFormCertificateClaimed?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedAny?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedContain?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedEq?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedGt?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedGte?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  trustedFormCertificateClaimedIsNull?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLike?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLt?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLte?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  trustedFormCertificateUrl?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlAny?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlContain?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlEq?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlGt?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlGte?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trustedFormCertificateUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateUrlLike?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlLt?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlLte?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uuid?: InputMaybe<Scalars['String']>;
  uuidAny?: InputMaybe<Scalars['String']>;
  uuidContain?: InputMaybe<Scalars['String']>;
  uuidEq?: InputMaybe<Scalars['String']>;
  uuidGt?: InputMaybe<Scalars['String']>;
  uuidGte?: InputMaybe<Scalars['String']>;
  uuidIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uuidIsNull?: InputMaybe<Scalars['Boolean']>;
  uuidLike?: InputMaybe<Scalars['String']>;
  uuidLikeNoCase?: InputMaybe<Scalars['String']>;
  uuidLt?: InputMaybe<Scalars['String']>;
  uuidLte?: InputMaybe<Scalars['String']>;
  uuidNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitData?: InputMaybe<Scalars['JSON']>;
  visitDataAny?: InputMaybe<Scalars['JSON']>;
  visitDataContain?: InputMaybe<Scalars['JSON']>;
  visitDataEq?: InputMaybe<Scalars['JSON']>;
  visitDataGt?: InputMaybe<Scalars['JSON']>;
  visitDataGte?: InputMaybe<Scalars['JSON']>;
  visitDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  visitDataIsNull?: InputMaybe<Scalars['Boolean']>;
  visitDataLike?: InputMaybe<Scalars['JSON']>;
  visitDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  visitDataLt?: InputMaybe<Scalars['JSON']>;
  visitDataLte?: InputMaybe<Scalars['JSON']>;
  visitDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  visitId?: InputMaybe<Scalars['String']>;
  visitIdAny?: InputMaybe<Scalars['String']>;
  visitIdContain?: InputMaybe<Scalars['String']>;
  visitIdEq?: InputMaybe<Scalars['String']>;
  visitIdGt?: InputMaybe<Scalars['String']>;
  visitIdGte?: InputMaybe<Scalars['String']>;
  visitIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitIdIsNull?: InputMaybe<Scalars['Boolean']>;
  visitIdLike?: InputMaybe<Scalars['String']>;
  visitIdLikeNoCase?: InputMaybe<Scalars['String']>;
  visitIdLt?: InputMaybe<Scalars['String']>;
  visitIdLte?: InputMaybe<Scalars['String']>;
  visitIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitorId?: InputMaybe<Scalars['String']>;
  visitorIdAny?: InputMaybe<Scalars['String']>;
  visitorIdContain?: InputMaybe<Scalars['String']>;
  visitorIdEq?: InputMaybe<Scalars['String']>;
  visitorIdGt?: InputMaybe<Scalars['String']>;
  visitorIdGte?: InputMaybe<Scalars['String']>;
  visitorIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitorIdIsNull?: InputMaybe<Scalars['Boolean']>;
  visitorIdLike?: InputMaybe<Scalars['String']>;
  visitorIdLikeNoCase?: InputMaybe<Scalars['String']>;
  visitorIdLt?: InputMaybe<Scalars['String']>;
  visitorIdLte?: InputMaybe<Scalars['String']>;
  visitorIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryLeadConversionEventLogArgs = {
  adNetworkId?: InputMaybe<Scalars['Int']>;
  adNetworkIdAny?: InputMaybe<Scalars['Int']>;
  adNetworkIdContain?: InputMaybe<Scalars['Int']>;
  adNetworkIdEq?: InputMaybe<Scalars['Int']>;
  adNetworkIdGt?: InputMaybe<Scalars['Int']>;
  adNetworkIdGte?: InputMaybe<Scalars['Int']>;
  adNetworkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  adNetworkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  adNetworkIdLike?: InputMaybe<Scalars['Int']>;
  adNetworkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  adNetworkIdLt?: InputMaybe<Scalars['Int']>;
  adNetworkIdLte?: InputMaybe<Scalars['Int']>;
  adNetworkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  event?: InputMaybe<Scalars['String']>;
  eventAny?: InputMaybe<Scalars['String']>;
  eventContain?: InputMaybe<Scalars['String']>;
  eventEq?: InputMaybe<Scalars['String']>;
  eventGt?: InputMaybe<Scalars['String']>;
  eventGte?: InputMaybe<Scalars['String']>;
  eventIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eventIsNull?: InputMaybe<Scalars['Boolean']>;
  eventLike?: InputMaybe<Scalars['String']>;
  eventLikeNoCase?: InputMaybe<Scalars['String']>;
  eventLt?: InputMaybe<Scalars['String']>;
  eventLte?: InputMaybe<Scalars['String']>;
  eventNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  formId?: InputMaybe<Scalars['Int']>;
  formIdAny?: InputMaybe<Scalars['Int']>;
  formIdContain?: InputMaybe<Scalars['Int']>;
  formIdEq?: InputMaybe<Scalars['Int']>;
  formIdGt?: InputMaybe<Scalars['Int']>;
  formIdGte?: InputMaybe<Scalars['Int']>;
  formIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formIdIsNull?: InputMaybe<Scalars['Boolean']>;
  formIdLike?: InputMaybe<Scalars['Int']>;
  formIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  formIdLt?: InputMaybe<Scalars['Int']>;
  formIdLte?: InputMaybe<Scalars['Int']>;
  formIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  leadId?: InputMaybe<Scalars['Int']>;
  leadIdAny?: InputMaybe<Scalars['Int']>;
  leadIdContain?: InputMaybe<Scalars['Int']>;
  leadIdEq?: InputMaybe<Scalars['Int']>;
  leadIdGt?: InputMaybe<Scalars['Int']>;
  leadIdGte?: InputMaybe<Scalars['Int']>;
  leadIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  leadIdIsNull?: InputMaybe<Scalars['Boolean']>;
  leadIdLike?: InputMaybe<Scalars['Int']>;
  leadIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  leadIdLt?: InputMaybe<Scalars['Int']>;
  leadIdLte?: InputMaybe<Scalars['Int']>;
  leadIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLLeadConversionEventLogsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLeadConversionEventLogsPropertiesEnum>;
  pixelId?: InputMaybe<Scalars['String']>;
  pixelIdAny?: InputMaybe<Scalars['String']>;
  pixelIdContain?: InputMaybe<Scalars['String']>;
  pixelIdEq?: InputMaybe<Scalars['String']>;
  pixelIdGt?: InputMaybe<Scalars['String']>;
  pixelIdGte?: InputMaybe<Scalars['String']>;
  pixelIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pixelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  pixelIdLike?: InputMaybe<Scalars['String']>;
  pixelIdLikeNoCase?: InputMaybe<Scalars['String']>;
  pixelIdLt?: InputMaybe<Scalars['String']>;
  pixelIdLte?: InputMaybe<Scalars['String']>;
  pixelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  request?: InputMaybe<Scalars['JSON']>;
  requestAny?: InputMaybe<Scalars['JSON']>;
  requestContain?: InputMaybe<Scalars['JSON']>;
  requestEq?: InputMaybe<Scalars['JSON']>;
  requestGt?: InputMaybe<Scalars['JSON']>;
  requestGte?: InputMaybe<Scalars['JSON']>;
  requestIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  requestIsNull?: InputMaybe<Scalars['Boolean']>;
  requestLike?: InputMaybe<Scalars['JSON']>;
  requestLikeNoCase?: InputMaybe<Scalars['JSON']>;
  requestLt?: InputMaybe<Scalars['JSON']>;
  requestLte?: InputMaybe<Scalars['JSON']>;
  requestNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  response?: InputMaybe<Scalars['JSON']>;
  responseAny?: InputMaybe<Scalars['JSON']>;
  responseContain?: InputMaybe<Scalars['JSON']>;
  responseEq?: InputMaybe<Scalars['JSON']>;
  responseGt?: InputMaybe<Scalars['JSON']>;
  responseGte?: InputMaybe<Scalars['JSON']>;
  responseIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  responseIsNull?: InputMaybe<Scalars['Boolean']>;
  responseLike?: InputMaybe<Scalars['JSON']>;
  responseLikeNoCase?: InputMaybe<Scalars['JSON']>;
  responseLt?: InputMaybe<Scalars['JSON']>;
  responseLte?: InputMaybe<Scalars['JSON']>;
  responseNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  status?: InputMaybe<Scalars['String']>;
  statusAny?: InputMaybe<Scalars['String']>;
  statusContain?: InputMaybe<Scalars['String']>;
  statusEq?: InputMaybe<Scalars['String']>;
  statusGt?: InputMaybe<Scalars['String']>;
  statusGte?: InputMaybe<Scalars['String']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statusIsNull?: InputMaybe<Scalars['Boolean']>;
  statusLike?: InputMaybe<Scalars['String']>;
  statusLikeNoCase?: InputMaybe<Scalars['String']>;
  statusLt?: InputMaybe<Scalars['String']>;
  statusLte?: InputMaybe<Scalars['String']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitId?: InputMaybe<Scalars['String']>;
  visitIdAny?: InputMaybe<Scalars['String']>;
  visitIdContain?: InputMaybe<Scalars['String']>;
  visitIdEq?: InputMaybe<Scalars['String']>;
  visitIdGt?: InputMaybe<Scalars['String']>;
  visitIdGte?: InputMaybe<Scalars['String']>;
  visitIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitIdIsNull?: InputMaybe<Scalars['Boolean']>;
  visitIdLike?: InputMaybe<Scalars['String']>;
  visitIdLikeNoCase?: InputMaybe<Scalars['String']>;
  visitIdLt?: InputMaybe<Scalars['String']>;
  visitIdLte?: InputMaybe<Scalars['String']>;
  visitIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryLeadTagArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  leadId?: InputMaybe<Scalars['Int']>;
  leadIdAny?: InputMaybe<Scalars['Int']>;
  leadIdContain?: InputMaybe<Scalars['Int']>;
  leadIdEq?: InputMaybe<Scalars['Int']>;
  leadIdGt?: InputMaybe<Scalars['Int']>;
  leadIdGte?: InputMaybe<Scalars['Int']>;
  leadIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  leadIdIsNull?: InputMaybe<Scalars['Boolean']>;
  leadIdLike?: InputMaybe<Scalars['Int']>;
  leadIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  leadIdLt?: InputMaybe<Scalars['Int']>;
  leadIdLte?: InputMaybe<Scalars['Int']>;
  leadIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLLeadTagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLeadTagsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tagId?: InputMaybe<Scalars['Int']>;
  tagIdAny?: InputMaybe<Scalars['Int']>;
  tagIdContain?: InputMaybe<Scalars['Int']>;
  tagIdEq?: InputMaybe<Scalars['Int']>;
  tagIdGt?: InputMaybe<Scalars['Int']>;
  tagIdGte?: InputMaybe<Scalars['Int']>;
  tagIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tagIdIsNull?: InputMaybe<Scalars['Boolean']>;
  tagIdLike?: InputMaybe<Scalars['Int']>;
  tagIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  tagIdLt?: InputMaybe<Scalars['Int']>;
  tagIdLte?: InputMaybe<Scalars['Int']>;
  tagIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryLeadsMetadataArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leadId?: InputMaybe<Scalars['Int']>;
  leadIdAny?: InputMaybe<Scalars['Int']>;
  leadIdContain?: InputMaybe<Scalars['Int']>;
  leadIdEq?: InputMaybe<Scalars['Int']>;
  leadIdGt?: InputMaybe<Scalars['Int']>;
  leadIdGte?: InputMaybe<Scalars['Int']>;
  leadIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  leadIdIsNull?: InputMaybe<Scalars['Boolean']>;
  leadIdLike?: InputMaybe<Scalars['Int']>;
  leadIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  leadIdLt?: InputMaybe<Scalars['Int']>;
  leadIdLte?: InputMaybe<Scalars['Int']>;
  leadIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLLeadsMetadataPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLeadsMetadataPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryListingArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLListingsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLListingsPropertiesEnum>;
  pageTitle?: InputMaybe<Scalars['String']>;
  pageTitleAny?: InputMaybe<Scalars['String']>;
  pageTitleContain?: InputMaybe<Scalars['String']>;
  pageTitleEq?: InputMaybe<Scalars['String']>;
  pageTitleGt?: InputMaybe<Scalars['String']>;
  pageTitleGte?: InputMaybe<Scalars['String']>;
  pageTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  pageTitleLike?: InputMaybe<Scalars['String']>;
  pageTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  pageTitleLt?: InputMaybe<Scalars['String']>;
  pageTitleLte?: InputMaybe<Scalars['String']>;
  pageTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryListingAttributeArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  hiddenAny?: InputMaybe<Scalars['Boolean']>;
  hiddenContain?: InputMaybe<Scalars['Boolean']>;
  hiddenEq?: InputMaybe<Scalars['Boolean']>;
  hiddenGt?: InputMaybe<Scalars['Boolean']>;
  hiddenGte?: InputMaybe<Scalars['Boolean']>;
  hiddenIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  hiddenIsNull?: InputMaybe<Scalars['Boolean']>;
  hiddenLike?: InputMaybe<Scalars['Boolean']>;
  hiddenLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  hiddenLt?: InputMaybe<Scalars['Boolean']>;
  hiddenLte?: InputMaybe<Scalars['Boolean']>;
  hiddenNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingId?: InputMaybe<Scalars['Int']>;
  listingIdAny?: InputMaybe<Scalars['Int']>;
  listingIdContain?: InputMaybe<Scalars['Int']>;
  listingIdEq?: InputMaybe<Scalars['Int']>;
  listingIdGt?: InputMaybe<Scalars['Int']>;
  listingIdGte?: InputMaybe<Scalars['Int']>;
  listingIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingIdIsNull?: InputMaybe<Scalars['Boolean']>;
  listingIdLike?: InputMaybe<Scalars['Int']>;
  listingIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  listingIdLt?: InputMaybe<Scalars['Int']>;
  listingIdLte?: InputMaybe<Scalars['Int']>;
  listingIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLListingAttributesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLListingAttributesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryListingFeatureArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingId?: InputMaybe<Scalars['Int']>;
  listingIdAny?: InputMaybe<Scalars['Int']>;
  listingIdContain?: InputMaybe<Scalars['Int']>;
  listingIdEq?: InputMaybe<Scalars['Int']>;
  listingIdGt?: InputMaybe<Scalars['Int']>;
  listingIdGte?: InputMaybe<Scalars['Int']>;
  listingIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  listingIdIsNull?: InputMaybe<Scalars['Boolean']>;
  listingIdLike?: InputMaybe<Scalars['Int']>;
  listingIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  listingIdLt?: InputMaybe<Scalars['Int']>;
  listingIdLte?: InputMaybe<Scalars['Int']>;
  listingIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLListingFeaturesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLListingFeaturesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryLookupArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLLookupsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLookupsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryLookupsVariationArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lookupId?: InputMaybe<Scalars['Int']>;
  lookupIdAny?: InputMaybe<Scalars['Int']>;
  lookupIdContain?: InputMaybe<Scalars['Int']>;
  lookupIdEq?: InputMaybe<Scalars['Int']>;
  lookupIdGt?: InputMaybe<Scalars['Int']>;
  lookupIdGte?: InputMaybe<Scalars['Int']>;
  lookupIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lookupIdIsNull?: InputMaybe<Scalars['Boolean']>;
  lookupIdLike?: InputMaybe<Scalars['Int']>;
  lookupIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  lookupIdLt?: InputMaybe<Scalars['Int']>;
  lookupIdLte?: InputMaybe<Scalars['Int']>;
  lookupIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLLookupsVariationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLookupsVariationsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  variationId?: InputMaybe<Scalars['Int']>;
  variationIdAny?: InputMaybe<Scalars['Int']>;
  variationIdContain?: InputMaybe<Scalars['Int']>;
  variationIdEq?: InputMaybe<Scalars['Int']>;
  variationIdGt?: InputMaybe<Scalars['Int']>;
  variationIdGte?: InputMaybe<Scalars['Int']>;
  variationIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  variationIdIsNull?: InputMaybe<Scalars['Boolean']>;
  variationIdLike?: InputMaybe<Scalars['Int']>;
  variationIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  variationIdLt?: InputMaybe<Scalars['Int']>;
  variationIdLte?: InputMaybe<Scalars['Int']>;
  variationIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type GQLQueryMenuItemArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  link?: InputMaybe<Scalars['String']>;
  linkAny?: InputMaybe<Scalars['String']>;
  linkContain?: InputMaybe<Scalars['String']>;
  linkEq?: InputMaybe<Scalars['String']>;
  linkGt?: InputMaybe<Scalars['String']>;
  linkGte?: InputMaybe<Scalars['String']>;
  linkIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkIsNull?: InputMaybe<Scalars['Boolean']>;
  linkLike?: InputMaybe<Scalars['String']>;
  linkLikeNoCase?: InputMaybe<Scalars['String']>;
  linkLt?: InputMaybe<Scalars['String']>;
  linkLte?: InputMaybe<Scalars['String']>;
  linkNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  menuId?: InputMaybe<Scalars['Int']>;
  menuIdAny?: InputMaybe<Scalars['Int']>;
  menuIdContain?: InputMaybe<Scalars['Int']>;
  menuIdEq?: InputMaybe<Scalars['Int']>;
  menuIdGt?: InputMaybe<Scalars['Int']>;
  menuIdGte?: InputMaybe<Scalars['Int']>;
  menuIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  menuIdIsNull?: InputMaybe<Scalars['Boolean']>;
  menuIdLike?: InputMaybe<Scalars['Int']>;
  menuIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  menuIdLt?: InputMaybe<Scalars['Int']>;
  menuIdLte?: InputMaybe<Scalars['Int']>;
  menuIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLMenuItemsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLMenuItemsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryMenusArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLMenusPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLMenusPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryMetatagArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  model?: InputMaybe<Scalars['String']>;
  modelAny?: InputMaybe<Scalars['String']>;
  modelContain?: InputMaybe<Scalars['String']>;
  modelEq?: InputMaybe<Scalars['String']>;
  modelGt?: InputMaybe<Scalars['String']>;
  modelGte?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIsNull?: InputMaybe<Scalars['Boolean']>;
  modelLike?: InputMaybe<Scalars['String']>;
  modelLikeNoCase?: InputMaybe<Scalars['String']>;
  modelLt?: InputMaybe<Scalars['String']>;
  modelLte?: InputMaybe<Scalars['String']>;
  modelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLMetatagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLMetatagsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryOfferArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checkWallet?: InputMaybe<Scalars['Boolean']>;
  checkWalletAny?: InputMaybe<Scalars['Boolean']>;
  checkWalletContain?: InputMaybe<Scalars['Boolean']>;
  checkWalletEq?: InputMaybe<Scalars['Boolean']>;
  checkWalletGt?: InputMaybe<Scalars['Boolean']>;
  checkWalletGte?: InputMaybe<Scalars['Boolean']>;
  checkWalletIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  checkWalletIsNull?: InputMaybe<Scalars['Boolean']>;
  checkWalletLike?: InputMaybe<Scalars['Boolean']>;
  checkWalletLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  checkWalletLt?: InputMaybe<Scalars['Boolean']>;
  checkWalletLte?: InputMaybe<Scalars['Boolean']>;
  checkWalletNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultAffiliateLinkId?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdAny?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdContain?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdEq?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  defaultAffiliateLinkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultAffiliateLinkIdLike?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrl?: InputMaybe<Scalars['String']>;
  displayUrlAny?: InputMaybe<Scalars['String']>;
  displayUrlContain?: InputMaybe<Scalars['String']>;
  displayUrlEq?: InputMaybe<Scalars['String']>;
  displayUrlGt?: InputMaybe<Scalars['String']>;
  displayUrlGte?: InputMaybe<Scalars['String']>;
  displayUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  displayUrlLike?: InputMaybe<Scalars['String']>;
  displayUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  displayUrlLt?: InputMaybe<Scalars['String']>;
  displayUrlLte?: InputMaybe<Scalars['String']>;
  displayUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalData?: InputMaybe<Scalars['JSON']>;
  externalDataAny?: InputMaybe<Scalars['JSON']>;
  externalDataContain?: InputMaybe<Scalars['JSON']>;
  externalDataEq?: InputMaybe<Scalars['JSON']>;
  externalDataGt?: InputMaybe<Scalars['JSON']>;
  externalDataGte?: InputMaybe<Scalars['JSON']>;
  externalDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  externalDataIsNull?: InputMaybe<Scalars['Boolean']>;
  externalDataLike?: InputMaybe<Scalars['JSON']>;
  externalDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  externalDataLt?: InputMaybe<Scalars['JSON']>;
  externalDataLte?: InputMaybe<Scalars['JSON']>;
  externalDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  featuresListTitle?: InputMaybe<Scalars['String']>;
  featuresListTitleAny?: InputMaybe<Scalars['String']>;
  featuresListTitleContain?: InputMaybe<Scalars['String']>;
  featuresListTitleEq?: InputMaybe<Scalars['String']>;
  featuresListTitleGt?: InputMaybe<Scalars['String']>;
  featuresListTitleGte?: InputMaybe<Scalars['String']>;
  featuresListTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuresListTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  featuresListTitleLike?: InputMaybe<Scalars['String']>;
  featuresListTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  featuresListTitleLt?: InputMaybe<Scalars['String']>;
  featuresListTitleLte?: InputMaybe<Scalars['String']>;
  featuresListTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  isPausedAny?: InputMaybe<Scalars['Boolean']>;
  isPausedContain?: InputMaybe<Scalars['Boolean']>;
  isPausedEq?: InputMaybe<Scalars['Boolean']>;
  isPausedGt?: InputMaybe<Scalars['Boolean']>;
  isPausedGte?: InputMaybe<Scalars['Boolean']>;
  isPausedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPausedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPausedLike?: InputMaybe<Scalars['Boolean']>;
  isPausedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPausedLt?: InputMaybe<Scalars['Boolean']>;
  isPausedLte?: InputMaybe<Scalars['Boolean']>;
  isPausedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldOverview?: InputMaybe<Scalars['String']>;
  oldOverviewAny?: InputMaybe<Scalars['String']>;
  oldOverviewContain?: InputMaybe<Scalars['String']>;
  oldOverviewEq?: InputMaybe<Scalars['String']>;
  oldOverviewGt?: InputMaybe<Scalars['String']>;
  oldOverviewGte?: InputMaybe<Scalars['String']>;
  oldOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  oldOverviewLike?: InputMaybe<Scalars['String']>;
  oldOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  oldOverviewLt?: InputMaybe<Scalars['String']>;
  oldOverviewLte?: InputMaybe<Scalars['String']>;
  oldOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOffersPropertiesEnum>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescription?: InputMaybe<Scalars['String']>;
  previewDescriptionAny?: InputMaybe<Scalars['String']>;
  previewDescriptionContain?: InputMaybe<Scalars['String']>;
  previewDescriptionEq?: InputMaybe<Scalars['String']>;
  previewDescriptionGt?: InputMaybe<Scalars['String']>;
  previewDescriptionGte?: InputMaybe<Scalars['String']>;
  previewDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  previewDescriptionLike?: InputMaybe<Scalars['String']>;
  previewDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  previewDescriptionLt?: InputMaybe<Scalars['String']>;
  previewDescriptionLte?: InputMaybe<Scalars['String']>;
  previewDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverview?: InputMaybe<Scalars['String']>;
  quickOverviewAny?: InputMaybe<Scalars['String']>;
  quickOverviewContain?: InputMaybe<Scalars['String']>;
  quickOverviewEq?: InputMaybe<Scalars['String']>;
  quickOverviewGt?: InputMaybe<Scalars['String']>;
  quickOverviewGte?: InputMaybe<Scalars['String']>;
  quickOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  quickOverviewLike?: InputMaybe<Scalars['String']>;
  quickOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  quickOverviewLt?: InputMaybe<Scalars['String']>;
  quickOverviewLte?: InputMaybe<Scalars['String']>;
  quickOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  score?: InputMaybe<Scalars['Float']>;
  scoreAny?: InputMaybe<Scalars['Float']>;
  scoreContain?: InputMaybe<Scalars['Float']>;
  scoreEq?: InputMaybe<Scalars['Float']>;
  scoreGt?: InputMaybe<Scalars['Float']>;
  scoreGte?: InputMaybe<Scalars['Float']>;
  scoreIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  scoreIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreLike?: InputMaybe<Scalars['Float']>;
  scoreLikeNoCase?: InputMaybe<Scalars['Float']>;
  scoreLt?: InputMaybe<Scalars['Float']>;
  scoreLte?: InputMaybe<Scalars['Float']>;
  scoreMessage?: InputMaybe<Scalars['String']>;
  scoreMessageAny?: InputMaybe<Scalars['String']>;
  scoreMessageContain?: InputMaybe<Scalars['String']>;
  scoreMessageEq?: InputMaybe<Scalars['String']>;
  scoreMessageGt?: InputMaybe<Scalars['String']>;
  scoreMessageGte?: InputMaybe<Scalars['String']>;
  scoreMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreMessageLike?: InputMaybe<Scalars['String']>;
  scoreMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  scoreMessageLt?: InputMaybe<Scalars['String']>;
  scoreMessageLte?: InputMaybe<Scalars['String']>;
  scoreMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleAny?: InputMaybe<Scalars['String']>;
  subTitleContain?: InputMaybe<Scalars['String']>;
  subTitleEq?: InputMaybe<Scalars['String']>;
  subTitleGt?: InputMaybe<Scalars['String']>;
  subTitleGte?: InputMaybe<Scalars['String']>;
  subTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subTitleLike?: InputMaybe<Scalars['String']>;
  subTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subTitleLt?: InputMaybe<Scalars['String']>;
  subTitleLte?: InputMaybe<Scalars['String']>;
  subTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescription?: InputMaybe<Scalars['String']>;
  summaryDescriptionAny?: InputMaybe<Scalars['String']>;
  summaryDescriptionContain?: InputMaybe<Scalars['String']>;
  summaryDescriptionEq?: InputMaybe<Scalars['String']>;
  summaryDescriptionGt?: InputMaybe<Scalars['String']>;
  summaryDescriptionGte?: InputMaybe<Scalars['String']>;
  summaryDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryDescriptionLike?: InputMaybe<Scalars['String']>;
  summaryDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryDescriptionLt?: InputMaybe<Scalars['String']>;
  summaryDescriptionLte?: InputMaybe<Scalars['String']>;
  summaryDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitle?: InputMaybe<Scalars['String']>;
  summaryTitleAny?: InputMaybe<Scalars['String']>;
  summaryTitleContain?: InputMaybe<Scalars['String']>;
  summaryTitleEq?: InputMaybe<Scalars['String']>;
  summaryTitleGt?: InputMaybe<Scalars['String']>;
  summaryTitleGte?: InputMaybe<Scalars['String']>;
  summaryTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryTitleLike?: InputMaybe<Scalars['String']>;
  summaryTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryTitleLt?: InputMaybe<Scalars['String']>;
  summaryTitleLte?: InputMaybe<Scalars['String']>;
  summaryTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryOfferCategoryArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLOfferCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOfferCategoriesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryOfferFeatureArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLOfferFeaturesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOfferFeaturesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryOfferScheduleArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerId?: InputMaybe<Scalars['Int']>;
  offerIdAny?: InputMaybe<Scalars['Int']>;
  offerIdContain?: InputMaybe<Scalars['Int']>;
  offerIdEq?: InputMaybe<Scalars['Int']>;
  offerIdGt?: InputMaybe<Scalars['Int']>;
  offerIdGte?: InputMaybe<Scalars['Int']>;
  offerIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdLike?: InputMaybe<Scalars['Int']>;
  offerIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  offerIdLt?: InputMaybe<Scalars['Int']>;
  offerIdLte?: InputMaybe<Scalars['Int']>;
  offerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLOfferSchedulesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOfferSchedulesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  schedule?: InputMaybe<Scalars['JSON']>;
  scheduleAny?: InputMaybe<Scalars['JSON']>;
  scheduleContain?: InputMaybe<Scalars['JSON']>;
  scheduleEq?: InputMaybe<Scalars['JSON']>;
  scheduleGt?: InputMaybe<Scalars['JSON']>;
  scheduleGte?: InputMaybe<Scalars['JSON']>;
  scheduleIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  scheduleIsNull?: InputMaybe<Scalars['Boolean']>;
  scheduleLike?: InputMaybe<Scalars['JSON']>;
  scheduleLikeNoCase?: InputMaybe<Scalars['JSON']>;
  scheduleLt?: InputMaybe<Scalars['JSON']>;
  scheduleLte?: InputMaybe<Scalars['JSON']>;
  scheduleNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  timeZone?: InputMaybe<Scalars['String']>;
  timeZoneAny?: InputMaybe<Scalars['String']>;
  timeZoneContain?: InputMaybe<Scalars['String']>;
  timeZoneEq?: InputMaybe<Scalars['String']>;
  timeZoneGt?: InputMaybe<Scalars['String']>;
  timeZoneGte?: InputMaybe<Scalars['String']>;
  timeZoneIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  timeZoneIsNull?: InputMaybe<Scalars['Boolean']>;
  timeZoneLike?: InputMaybe<Scalars['String']>;
  timeZoneLikeNoCase?: InputMaybe<Scalars['String']>;
  timeZoneLt?: InputMaybe<Scalars['String']>;
  timeZoneLte?: InputMaybe<Scalars['String']>;
  timeZoneNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryPersonalIdentifiableInformationArgs = {
  aliasPhoneNumber?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberAny?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberContain?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberEq?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberGt?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberGte?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  aliasPhoneNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  aliasPhoneNumberLike?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberLt?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberLte?: InputMaybe<Scalars['String']>;
  aliasPhoneNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  birthdate?: InputMaybe<Scalars['String']>;
  birthdateAny?: InputMaybe<Scalars['String']>;
  birthdateContain?: InputMaybe<Scalars['String']>;
  birthdateEq?: InputMaybe<Scalars['String']>;
  birthdateGt?: InputMaybe<Scalars['String']>;
  birthdateGte?: InputMaybe<Scalars['String']>;
  birthdateIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  birthdateIsNull?: InputMaybe<Scalars['Boolean']>;
  birthdateLike?: InputMaybe<Scalars['String']>;
  birthdateLikeNoCase?: InputMaybe<Scalars['String']>;
  birthdateLt?: InputMaybe<Scalars['String']>;
  birthdateLte?: InputMaybe<Scalars['String']>;
  birthdateNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<Scalars['String']>;
  cityAny?: InputMaybe<Scalars['String']>;
  cityContain?: InputMaybe<Scalars['String']>;
  cityEq?: InputMaybe<Scalars['String']>;
  cityGt?: InputMaybe<Scalars['String']>;
  cityGte?: InputMaybe<Scalars['String']>;
  cityIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityIsNull?: InputMaybe<Scalars['Boolean']>;
  cityLike?: InputMaybe<Scalars['String']>;
  cityLikeNoCase?: InputMaybe<Scalars['String']>;
  cityLt?: InputMaybe<Scalars['String']>;
  cityLte?: InputMaybe<Scalars['String']>;
  cityNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  country?: InputMaybe<Scalars['String']>;
  countryAny?: InputMaybe<Scalars['String']>;
  countryContain?: InputMaybe<Scalars['String']>;
  countryEq?: InputMaybe<Scalars['String']>;
  countryGt?: InputMaybe<Scalars['String']>;
  countryGte?: InputMaybe<Scalars['String']>;
  countryIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryIsNull?: InputMaybe<Scalars['Boolean']>;
  countryLike?: InputMaybe<Scalars['String']>;
  countryLikeNoCase?: InputMaybe<Scalars['String']>;
  countryLt?: InputMaybe<Scalars['String']>;
  countryLte?: InputMaybe<Scalars['String']>;
  countryNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  county?: InputMaybe<Scalars['String']>;
  countyAny?: InputMaybe<Scalars['String']>;
  countyContain?: InputMaybe<Scalars['String']>;
  countyEq?: InputMaybe<Scalars['String']>;
  countyGt?: InputMaybe<Scalars['String']>;
  countyGte?: InputMaybe<Scalars['String']>;
  countyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countyIsNull?: InputMaybe<Scalars['Boolean']>;
  countyLike?: InputMaybe<Scalars['String']>;
  countyLikeNoCase?: InputMaybe<Scalars['String']>;
  countyLt?: InputMaybe<Scalars['String']>;
  countyLte?: InputMaybe<Scalars['String']>;
  countyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  dma?: InputMaybe<Scalars['Boolean']>;
  dmaAny?: InputMaybe<Scalars['Boolean']>;
  dmaContain?: InputMaybe<Scalars['Boolean']>;
  dmaEq?: InputMaybe<Scalars['Boolean']>;
  dmaGt?: InputMaybe<Scalars['Boolean']>;
  dmaGte?: InputMaybe<Scalars['Boolean']>;
  dmaIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  dmaIsNull?: InputMaybe<Scalars['Boolean']>;
  dmaLike?: InputMaybe<Scalars['Boolean']>;
  dmaLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  dmaLt?: InputMaybe<Scalars['Boolean']>;
  dmaLte?: InputMaybe<Scalars['Boolean']>;
  dmaNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  firstName?: InputMaybe<Scalars['String']>;
  firstNameAny?: InputMaybe<Scalars['String']>;
  firstNameContain?: InputMaybe<Scalars['String']>;
  firstNameEq?: InputMaybe<Scalars['String']>;
  firstNameGt?: InputMaybe<Scalars['String']>;
  firstNameGte?: InputMaybe<Scalars['String']>;
  firstNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  firstNameIsNull?: InputMaybe<Scalars['Boolean']>;
  firstNameLike?: InputMaybe<Scalars['String']>;
  firstNameLikeNoCase?: InputMaybe<Scalars['String']>;
  firstNameLt?: InputMaybe<Scalars['String']>;
  firstNameLte?: InputMaybe<Scalars['String']>;
  firstNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ipAddress?: InputMaybe<Scalars['String']>;
  ipAddressAny?: InputMaybe<Scalars['String']>;
  ipAddressContain?: InputMaybe<Scalars['String']>;
  ipAddressEq?: InputMaybe<Scalars['String']>;
  ipAddressGt?: InputMaybe<Scalars['String']>;
  ipAddressGte?: InputMaybe<Scalars['String']>;
  ipAddressIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ipAddressIsNull?: InputMaybe<Scalars['Boolean']>;
  ipAddressLike?: InputMaybe<Scalars['String']>;
  ipAddressLikeNoCase?: InputMaybe<Scalars['String']>;
  ipAddressLt?: InputMaybe<Scalars['String']>;
  ipAddressLte?: InputMaybe<Scalars['String']>;
  ipAddressNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBizEmail?: InputMaybe<Scalars['Boolean']>;
  isBizEmailAny?: InputMaybe<Scalars['Boolean']>;
  isBizEmailContain?: InputMaybe<Scalars['Boolean']>;
  isBizEmailEq?: InputMaybe<Scalars['Boolean']>;
  isBizEmailGt?: InputMaybe<Scalars['Boolean']>;
  isBizEmailGte?: InputMaybe<Scalars['Boolean']>;
  isBizEmailIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBizEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  isBizEmailLike?: InputMaybe<Scalars['Boolean']>;
  isBizEmailLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBizEmailLt?: InputMaybe<Scalars['Boolean']>;
  isBizEmailLte?: InputMaybe<Scalars['Boolean']>;
  isBizEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lastName?: InputMaybe<Scalars['String']>;
  lastNameAny?: InputMaybe<Scalars['String']>;
  lastNameContain?: InputMaybe<Scalars['String']>;
  lastNameEq?: InputMaybe<Scalars['String']>;
  lastNameGt?: InputMaybe<Scalars['String']>;
  lastNameGte?: InputMaybe<Scalars['String']>;
  lastNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lastNameIsNull?: InputMaybe<Scalars['Boolean']>;
  lastNameLike?: InputMaybe<Scalars['String']>;
  lastNameLikeNoCase?: InputMaybe<Scalars['String']>;
  lastNameLt?: InputMaybe<Scalars['String']>;
  lastNameLte?: InputMaybe<Scalars['String']>;
  lastNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  litigator?: InputMaybe<Scalars['Boolean']>;
  litigatorAny?: InputMaybe<Scalars['Boolean']>;
  litigatorContain?: InputMaybe<Scalars['Boolean']>;
  litigatorEq?: InputMaybe<Scalars['Boolean']>;
  litigatorGt?: InputMaybe<Scalars['Boolean']>;
  litigatorGte?: InputMaybe<Scalars['Boolean']>;
  litigatorIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  litigatorIsNull?: InputMaybe<Scalars['Boolean']>;
  litigatorLike?: InputMaybe<Scalars['Boolean']>;
  litigatorLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  litigatorLt?: InputMaybe<Scalars['Boolean']>;
  litigatorLte?: InputMaybe<Scalars['Boolean']>;
  litigatorNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  metaData?: InputMaybe<Scalars['String']>;
  metaDataAny?: InputMaybe<Scalars['String']>;
  metaDataContain?: InputMaybe<Scalars['String']>;
  metaDataEq?: InputMaybe<Scalars['String']>;
  metaDataGt?: InputMaybe<Scalars['String']>;
  metaDataGte?: InputMaybe<Scalars['String']>;
  metaDataIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  metaDataIsNull?: InputMaybe<Scalars['Boolean']>;
  metaDataLike?: InputMaybe<Scalars['String']>;
  metaDataLikeNoCase?: InputMaybe<Scalars['String']>;
  metaDataLt?: InputMaybe<Scalars['String']>;
  metaDataLte?: InputMaybe<Scalars['String']>;
  metaDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAt?: InputMaybe<Scalars['String']>;
  modifiedAtAny?: InputMaybe<Scalars['String']>;
  modifiedAtContain?: InputMaybe<Scalars['String']>;
  modifiedAtEq?: InputMaybe<Scalars['String']>;
  modifiedAtGt?: InputMaybe<Scalars['String']>;
  modifiedAtGte?: InputMaybe<Scalars['String']>;
  modifiedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedAtLike?: InputMaybe<Scalars['String']>;
  modifiedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedAtLt?: InputMaybe<Scalars['String']>;
  modifiedAtLte?: InputMaybe<Scalars['String']>;
  modifiedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nationalDnc?: InputMaybe<Scalars['Boolean']>;
  nationalDncAny?: InputMaybe<Scalars['Boolean']>;
  nationalDncContain?: InputMaybe<Scalars['Boolean']>;
  nationalDncEq?: InputMaybe<Scalars['Boolean']>;
  nationalDncGt?: InputMaybe<Scalars['Boolean']>;
  nationalDncGte?: InputMaybe<Scalars['Boolean']>;
  nationalDncIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  nationalDncIsNull?: InputMaybe<Scalars['Boolean']>;
  nationalDncLike?: InputMaybe<Scalars['Boolean']>;
  nationalDncLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  nationalDncLt?: InputMaybe<Scalars['Boolean']>;
  nationalDncLte?: InputMaybe<Scalars['Boolean']>;
  nationalDncNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldPhoneNumber?: InputMaybe<Scalars['String']>;
  oldPhoneNumberAny?: InputMaybe<Scalars['String']>;
  oldPhoneNumberContain?: InputMaybe<Scalars['String']>;
  oldPhoneNumberEq?: InputMaybe<Scalars['String']>;
  oldPhoneNumberGt?: InputMaybe<Scalars['String']>;
  oldPhoneNumberGte?: InputMaybe<Scalars['String']>;
  oldPhoneNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldPhoneNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  oldPhoneNumberLike?: InputMaybe<Scalars['String']>;
  oldPhoneNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  oldPhoneNumberLt?: InputMaybe<Scalars['String']>;
  oldPhoneNumberLte?: InputMaybe<Scalars['String']>;
  oldPhoneNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLPersonalIdentifiableInformationPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLPersonalIdentifiableInformationPropertiesEnum>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumberAny?: InputMaybe<Scalars['String']>;
  phoneNumberContain?: InputMaybe<Scalars['String']>;
  phoneNumberEq?: InputMaybe<Scalars['String']>;
  phoneNumberGt?: InputMaybe<Scalars['String']>;
  phoneNumberGte?: InputMaybe<Scalars['String']>;
  phoneNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  phoneNumberLike?: InputMaybe<Scalars['String']>;
  phoneNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  phoneNumberLt?: InputMaybe<Scalars['String']>;
  phoneNumberLte?: InputMaybe<Scalars['String']>;
  phoneNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneNumberType?: InputMaybe<Scalars['String']>;
  phoneNumberTypeAny?: InputMaybe<Scalars['String']>;
  phoneNumberTypeContain?: InputMaybe<Scalars['String']>;
  phoneNumberTypeEq?: InputMaybe<Scalars['String']>;
  phoneNumberTypeGt?: InputMaybe<Scalars['String']>;
  phoneNumberTypeGte?: InputMaybe<Scalars['String']>;
  phoneNumberTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneNumberTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  phoneNumberTypeLike?: InputMaybe<Scalars['String']>;
  phoneNumberTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  phoneNumberTypeLt?: InputMaybe<Scalars['String']>;
  phoneNumberTypeLte?: InputMaybe<Scalars['String']>;
  phoneNumberTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  state?: InputMaybe<Scalars['String']>;
  stateAny?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
  stateCodeAny?: InputMaybe<Scalars['String']>;
  stateCodeContain?: InputMaybe<Scalars['String']>;
  stateCodeEq?: InputMaybe<Scalars['String']>;
  stateCodeGt?: InputMaybe<Scalars['String']>;
  stateCodeGte?: InputMaybe<Scalars['String']>;
  stateCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  stateCodeLike?: InputMaybe<Scalars['String']>;
  stateCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  stateCodeLt?: InputMaybe<Scalars['String']>;
  stateCodeLte?: InputMaybe<Scalars['String']>;
  stateCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateContain?: InputMaybe<Scalars['String']>;
  stateDnc?: InputMaybe<Scalars['Boolean']>;
  stateDncAny?: InputMaybe<Scalars['Boolean']>;
  stateDncContain?: InputMaybe<Scalars['Boolean']>;
  stateDncEq?: InputMaybe<Scalars['Boolean']>;
  stateDncGt?: InputMaybe<Scalars['Boolean']>;
  stateDncGte?: InputMaybe<Scalars['Boolean']>;
  stateDncIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  stateDncIsNull?: InputMaybe<Scalars['Boolean']>;
  stateDncLike?: InputMaybe<Scalars['Boolean']>;
  stateDncLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  stateDncLt?: InputMaybe<Scalars['Boolean']>;
  stateDncLte?: InputMaybe<Scalars['Boolean']>;
  stateDncNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  stateEq?: InputMaybe<Scalars['String']>;
  stateGt?: InputMaybe<Scalars['String']>;
  stateGte?: InputMaybe<Scalars['String']>;
  stateIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateIsNull?: InputMaybe<Scalars['Boolean']>;
  stateLike?: InputMaybe<Scalars['String']>;
  stateLikeNoCase?: InputMaybe<Scalars['String']>;
  stateLt?: InputMaybe<Scalars['String']>;
  stateLte?: InputMaybe<Scalars['String']>;
  stateNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetAddressAny?: InputMaybe<Scalars['String']>;
  streetAddressContain?: InputMaybe<Scalars['String']>;
  streetAddressEq?: InputMaybe<Scalars['String']>;
  streetAddressGt?: InputMaybe<Scalars['String']>;
  streetAddressGte?: InputMaybe<Scalars['String']>;
  streetAddressIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  streetAddressIsNull?: InputMaybe<Scalars['Boolean']>;
  streetAddressLike?: InputMaybe<Scalars['String']>;
  streetAddressLikeNoCase?: InputMaybe<Scalars['String']>;
  streetAddressLt?: InputMaybe<Scalars['String']>;
  streetAddressLte?: InputMaybe<Scalars['String']>;
  streetAddressNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verified?: InputMaybe<Scalars['Boolean']>;
  verifiedAny?: InputMaybe<Scalars['Boolean']>;
  verifiedContain?: InputMaybe<Scalars['Boolean']>;
  verifiedEq?: InputMaybe<Scalars['Boolean']>;
  verifiedGt?: InputMaybe<Scalars['Boolean']>;
  verifiedGte?: InputMaybe<Scalars['Boolean']>;
  verifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  verifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  verifiedLike?: InputMaybe<Scalars['Boolean']>;
  verifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  verifiedLt?: InputMaybe<Scalars['Boolean']>;
  verifiedLte?: InputMaybe<Scalars['Boolean']>;
  verifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  zipCode?: InputMaybe<Scalars['String']>;
  zipCodeAny?: InputMaybe<Scalars['String']>;
  zipCodeContain?: InputMaybe<Scalars['String']>;
  zipCodeEq?: InputMaybe<Scalars['String']>;
  zipCodeGt?: InputMaybe<Scalars['String']>;
  zipCodeGte?: InputMaybe<Scalars['String']>;
  zipCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  zipCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  zipCodeLike?: InputMaybe<Scalars['String']>;
  zipCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  zipCodeLt?: InputMaybe<Scalars['String']>;
  zipCodeLte?: InputMaybe<Scalars['String']>;
  zipCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryPostArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerpt?: InputMaybe<Scalars['String']>;
  excerptAny?: InputMaybe<Scalars['String']>;
  excerptContain?: InputMaybe<Scalars['String']>;
  excerptEq?: InputMaybe<Scalars['String']>;
  excerptGt?: InputMaybe<Scalars['String']>;
  excerptGte?: InputMaybe<Scalars['String']>;
  excerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerptIsNull?: InputMaybe<Scalars['Boolean']>;
  excerptLike?: InputMaybe<Scalars['String']>;
  excerptLikeNoCase?: InputMaybe<Scalars['String']>;
  excerptLt?: InputMaybe<Scalars['String']>;
  excerptLte?: InputMaybe<Scalars['String']>;
  excerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featured?: InputMaybe<Scalars['Boolean']>;
  featuredAny?: InputMaybe<Scalars['Boolean']>;
  featuredContain?: InputMaybe<Scalars['Boolean']>;
  featuredEq?: InputMaybe<Scalars['Boolean']>;
  featuredGt?: InputMaybe<Scalars['Boolean']>;
  featuredGte?: InputMaybe<Scalars['Boolean']>;
  featuredIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  featuredIsNull?: InputMaybe<Scalars['Boolean']>;
  featuredLike?: InputMaybe<Scalars['Boolean']>;
  featuredLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  featuredLt?: InputMaybe<Scalars['Boolean']>;
  featuredLte?: InputMaybe<Scalars['Boolean']>;
  featuredNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  fullBody?: InputMaybe<Scalars['String']>;
  fullBodyAny?: InputMaybe<Scalars['String']>;
  fullBodyContain?: InputMaybe<Scalars['String']>;
  fullBodyEq?: InputMaybe<Scalars['String']>;
  fullBodyGt?: InputMaybe<Scalars['String']>;
  fullBodyGte?: InputMaybe<Scalars['String']>;
  fullBodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullBodyIsNull?: InputMaybe<Scalars['Boolean']>;
  fullBodyLike?: InputMaybe<Scalars['String']>;
  fullBodyLikeNoCase?: InputMaybe<Scalars['String']>;
  fullBodyLt?: InputMaybe<Scalars['String']>;
  fullBodyLte?: InputMaybe<Scalars['String']>;
  fullBodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldExcerpt?: InputMaybe<Scalars['String']>;
  oldExcerptAny?: InputMaybe<Scalars['String']>;
  oldExcerptContain?: InputMaybe<Scalars['String']>;
  oldExcerptEq?: InputMaybe<Scalars['String']>;
  oldExcerptGt?: InputMaybe<Scalars['String']>;
  oldExcerptGte?: InputMaybe<Scalars['String']>;
  oldExcerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldExcerptIsNull?: InputMaybe<Scalars['Boolean']>;
  oldExcerptLike?: InputMaybe<Scalars['String']>;
  oldExcerptLikeNoCase?: InputMaybe<Scalars['String']>;
  oldExcerptLt?: InputMaybe<Scalars['String']>;
  oldExcerptLte?: InputMaybe<Scalars['String']>;
  oldExcerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLPostsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLPostsPropertiesEnum>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedAny?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['String']>;
  publishedAtAny?: InputMaybe<Scalars['String']>;
  publishedAtContain?: InputMaybe<Scalars['String']>;
  publishedAtEq?: InputMaybe<Scalars['String']>;
  publishedAtGt?: InputMaybe<Scalars['String']>;
  publishedAtGte?: InputMaybe<Scalars['String']>;
  publishedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedAtLike?: InputMaybe<Scalars['String']>;
  publishedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  publishedAtLt?: InputMaybe<Scalars['String']>;
  publishedAtLte?: InputMaybe<Scalars['String']>;
  publishedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedContain?: InputMaybe<Scalars['Boolean']>;
  publishedEq?: InputMaybe<Scalars['Boolean']>;
  publishedGt?: InputMaybe<Scalars['Boolean']>;
  publishedGte?: InputMaybe<Scalars['Boolean']>;
  publishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  publishedIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedLike?: InputMaybe<Scalars['Boolean']>;
  publishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  publishedLt?: InputMaybe<Scalars['Boolean']>;
  publishedLte?: InputMaybe<Scalars['Boolean']>;
  publishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Scalars['Int']>;
  typeIdAny?: InputMaybe<Scalars['Int']>;
  typeIdContain?: InputMaybe<Scalars['Int']>;
  typeIdEq?: InputMaybe<Scalars['Int']>;
  typeIdGt?: InputMaybe<Scalars['Int']>;
  typeIdGte?: InputMaybe<Scalars['Int']>;
  typeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  typeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  typeIdLike?: InputMaybe<Scalars['Int']>;
  typeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  typeIdLt?: InputMaybe<Scalars['Int']>;
  typeIdLte?: InputMaybe<Scalars['Int']>;
  typeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryPostTagArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fullBody?: InputMaybe<Scalars['String']>;
  fullBodyAny?: InputMaybe<Scalars['String']>;
  fullBodyContain?: InputMaybe<Scalars['String']>;
  fullBodyEq?: InputMaybe<Scalars['String']>;
  fullBodyGt?: InputMaybe<Scalars['String']>;
  fullBodyGte?: InputMaybe<Scalars['String']>;
  fullBodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullBodyIsNull?: InputMaybe<Scalars['Boolean']>;
  fullBodyLike?: InputMaybe<Scalars['String']>;
  fullBodyLikeNoCase?: InputMaybe<Scalars['String']>;
  fullBodyLt?: InputMaybe<Scalars['String']>;
  fullBodyLte?: InputMaybe<Scalars['String']>;
  fullBodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLPostTagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLPostTagsPropertiesEnum>;
  postId?: InputMaybe<Scalars['Int']>;
  postIdAny?: InputMaybe<Scalars['Int']>;
  postIdContain?: InputMaybe<Scalars['Int']>;
  postIdEq?: InputMaybe<Scalars['Int']>;
  postIdGt?: InputMaybe<Scalars['Int']>;
  postIdGte?: InputMaybe<Scalars['Int']>;
  postIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  postIdIsNull?: InputMaybe<Scalars['Boolean']>;
  postIdLike?: InputMaybe<Scalars['Int']>;
  postIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  postIdLt?: InputMaybe<Scalars['Int']>;
  postIdLte?: InputMaybe<Scalars['Int']>;
  postIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tagId?: InputMaybe<Scalars['Int']>;
  tagIdAny?: InputMaybe<Scalars['Int']>;
  tagIdContain?: InputMaybe<Scalars['Int']>;
  tagIdEq?: InputMaybe<Scalars['Int']>;
  tagIdGt?: InputMaybe<Scalars['Int']>;
  tagIdGte?: InputMaybe<Scalars['Int']>;
  tagIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tagIdIsNull?: InputMaybe<Scalars['Boolean']>;
  tagIdLike?: InputMaybe<Scalars['Int']>;
  tagIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  tagIdLt?: InputMaybe<Scalars['Int']>;
  tagIdLte?: InputMaybe<Scalars['Int']>;
  tagIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryRedirectionArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  destinationURI?: InputMaybe<Scalars['String']>;
  destinationURIAny?: InputMaybe<Scalars['String']>;
  destinationURIContain?: InputMaybe<Scalars['String']>;
  destinationURIEq?: InputMaybe<Scalars['String']>;
  destinationURIGt?: InputMaybe<Scalars['String']>;
  destinationURIGte?: InputMaybe<Scalars['String']>;
  destinationURIIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  destinationURIIsNull?: InputMaybe<Scalars['Boolean']>;
  destinationURILike?: InputMaybe<Scalars['String']>;
  destinationURILikeNoCase?: InputMaybe<Scalars['String']>;
  destinationURILt?: InputMaybe<Scalars['String']>;
  destinationURILte?: InputMaybe<Scalars['String']>;
  destinationURINotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLRedirectionsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLRedirectionsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  redirectionStatusCode?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeAny?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeContain?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeEq?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  redirectionStatusCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  redirectionStatusCodeLike?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLikeNoCase?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  srcURI?: InputMaybe<Scalars['String']>;
  srcURIAny?: InputMaybe<Scalars['String']>;
  srcURIContain?: InputMaybe<Scalars['String']>;
  srcURIEq?: InputMaybe<Scalars['String']>;
  srcURIGt?: InputMaybe<Scalars['String']>;
  srcURIGte?: InputMaybe<Scalars['String']>;
  srcURIIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  srcURIIsNull?: InputMaybe<Scalars['Boolean']>;
  srcURILike?: InputMaybe<Scalars['String']>;
  srcURILikeNoCase?: InputMaybe<Scalars['String']>;
  srcURILt?: InputMaybe<Scalars['String']>;
  srcURILte?: InputMaybe<Scalars['String']>;
  srcURINotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryRelatedPostArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLRelatedPostsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLRelatedPostsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  postId?: InputMaybe<Scalars['Int']>;
  postIdAny?: InputMaybe<Scalars['Int']>;
  postIdContain?: InputMaybe<Scalars['Int']>;
  postIdEq?: InputMaybe<Scalars['Int']>;
  postIdGt?: InputMaybe<Scalars['Int']>;
  postIdGte?: InputMaybe<Scalars['Int']>;
  postIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  postIdIsNull?: InputMaybe<Scalars['Boolean']>;
  postIdLike?: InputMaybe<Scalars['Int']>;
  postIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  postIdLt?: InputMaybe<Scalars['Int']>;
  postIdLte?: InputMaybe<Scalars['Int']>;
  postIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  relatedPostId?: InputMaybe<Scalars['Int']>;
  relatedPostIdAny?: InputMaybe<Scalars['Int']>;
  relatedPostIdContain?: InputMaybe<Scalars['Int']>;
  relatedPostIdEq?: InputMaybe<Scalars['Int']>;
  relatedPostIdGt?: InputMaybe<Scalars['Int']>;
  relatedPostIdGte?: InputMaybe<Scalars['Int']>;
  relatedPostIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  relatedPostIdIsNull?: InputMaybe<Scalars['Boolean']>;
  relatedPostIdLike?: InputMaybe<Scalars['Int']>;
  relatedPostIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  relatedPostIdLt?: InputMaybe<Scalars['Int']>;
  relatedPostIdLte?: InputMaybe<Scalars['Int']>;
  relatedPostIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryStepArgs = {
  adminTitle?: InputMaybe<Scalars['String']>;
  adminTitleAny?: InputMaybe<Scalars['String']>;
  adminTitleContain?: InputMaybe<Scalars['String']>;
  adminTitleEq?: InputMaybe<Scalars['String']>;
  adminTitleGt?: InputMaybe<Scalars['String']>;
  adminTitleGte?: InputMaybe<Scalars['String']>;
  adminTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adminTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  adminTitleLike?: InputMaybe<Scalars['String']>;
  adminTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  adminTitleLt?: InputMaybe<Scalars['String']>;
  adminTitleLte?: InputMaybe<Scalars['String']>;
  adminTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buttonText?: InputMaybe<Scalars['String']>;
  buttonTextAny?: InputMaybe<Scalars['String']>;
  buttonTextContain?: InputMaybe<Scalars['String']>;
  buttonTextEq?: InputMaybe<Scalars['String']>;
  buttonTextGt?: InputMaybe<Scalars['String']>;
  buttonTextGte?: InputMaybe<Scalars['String']>;
  buttonTextIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buttonTextIsNull?: InputMaybe<Scalars['Boolean']>;
  buttonTextLike?: InputMaybe<Scalars['String']>;
  buttonTextLikeNoCase?: InputMaybe<Scalars['String']>;
  buttonTextLt?: InputMaybe<Scalars['String']>;
  buttonTextLte?: InputMaybe<Scalars['String']>;
  buttonTextNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  formId?: InputMaybe<Scalars['Int']>;
  formIdAny?: InputMaybe<Scalars['Int']>;
  formIdContain?: InputMaybe<Scalars['Int']>;
  formIdEq?: InputMaybe<Scalars['Int']>;
  formIdGt?: InputMaybe<Scalars['Int']>;
  formIdGte?: InputMaybe<Scalars['Int']>;
  formIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formIdIsNull?: InputMaybe<Scalars['Boolean']>;
  formIdLike?: InputMaybe<Scalars['Int']>;
  formIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  formIdLt?: InputMaybe<Scalars['Int']>;
  formIdLte?: InputMaybe<Scalars['Int']>;
  formIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  includeTCPAMessage?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageAny?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageContain?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageEq?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageGt?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageGte?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  includeTCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageLike?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageLt?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageLte?: InputMaybe<Scalars['Boolean']>;
  includeTCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLStepsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLStepsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltipAny?: InputMaybe<Scalars['String']>;
  tooltipContain?: InputMaybe<Scalars['String']>;
  tooltipEq?: InputMaybe<Scalars['String']>;
  tooltipGt?: InputMaybe<Scalars['String']>;
  tooltipGte?: InputMaybe<Scalars['String']>;
  tooltipIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tooltipIsNull?: InputMaybe<Scalars['Boolean']>;
  tooltipLike?: InputMaybe<Scalars['String']>;
  tooltipLikeNoCase?: InputMaybe<Scalars['String']>;
  tooltipLt?: InputMaybe<Scalars['String']>;
  tooltipLte?: InputMaybe<Scalars['String']>;
  tooltipNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryStepFieldArgs = {
  autocomplete?: InputMaybe<Scalars['String']>;
  autocompleteAny?: InputMaybe<Scalars['String']>;
  autocompleteContain?: InputMaybe<Scalars['String']>;
  autocompleteEq?: InputMaybe<Scalars['String']>;
  autocompleteGt?: InputMaybe<Scalars['String']>;
  autocompleteGte?: InputMaybe<Scalars['String']>;
  autocompleteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autocompleteIsNull?: InputMaybe<Scalars['Boolean']>;
  autocompleteLike?: InputMaybe<Scalars['String']>;
  autocompleteLikeNoCase?: InputMaybe<Scalars['String']>;
  autocompleteLt?: InputMaybe<Scalars['String']>;
  autocompleteLte?: InputMaybe<Scalars['String']>;
  autocompleteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  conditionalLogic?: InputMaybe<Scalars['JSON']>;
  conditionalLogicAny?: InputMaybe<Scalars['JSON']>;
  conditionalLogicContain?: InputMaybe<Scalars['JSON']>;
  conditionalLogicEq?: InputMaybe<Scalars['JSON']>;
  conditionalLogicGt?: InputMaybe<Scalars['JSON']>;
  conditionalLogicGte?: InputMaybe<Scalars['JSON']>;
  conditionalLogicIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  conditionalLogicIsNull?: InputMaybe<Scalars['Boolean']>;
  conditionalLogicLike?: InputMaybe<Scalars['JSON']>;
  conditionalLogicLikeNoCase?: InputMaybe<Scalars['JSON']>;
  conditionalLogicLt?: InputMaybe<Scalars['JSON']>;
  conditionalLogicLte?: InputMaybe<Scalars['JSON']>;
  conditionalLogicNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dataDependency?: InputMaybe<Scalars['JSON']>;
  dataDependencyAny?: InputMaybe<Scalars['JSON']>;
  dataDependencyContain?: InputMaybe<Scalars['JSON']>;
  dataDependencyEq?: InputMaybe<Scalars['JSON']>;
  dataDependencyGt?: InputMaybe<Scalars['JSON']>;
  dataDependencyGte?: InputMaybe<Scalars['JSON']>;
  dataDependencyIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  dataDependencyIsNull?: InputMaybe<Scalars['Boolean']>;
  dataDependencyLike?: InputMaybe<Scalars['JSON']>;
  dataDependencyLikeNoCase?: InputMaybe<Scalars['JSON']>;
  dataDependencyLt?: InputMaybe<Scalars['JSON']>;
  dataDependencyLte?: InputMaybe<Scalars['JSON']>;
  dataDependencyNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  defaultValue?: InputMaybe<Scalars['String']>;
  defaultValueAny?: InputMaybe<Scalars['String']>;
  defaultValueContain?: InputMaybe<Scalars['String']>;
  defaultValueEq?: InputMaybe<Scalars['String']>;
  defaultValueGt?: InputMaybe<Scalars['String']>;
  defaultValueGte?: InputMaybe<Scalars['String']>;
  defaultValueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultValueIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultValueLike?: InputMaybe<Scalars['String']>;
  defaultValueLikeNoCase?: InputMaybe<Scalars['String']>;
  defaultValueLt?: InputMaybe<Scalars['String']>;
  defaultValueLte?: InputMaybe<Scalars['String']>;
  defaultValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultValues?: InputMaybe<Scalars['JSON']>;
  defaultValuesAny?: InputMaybe<Scalars['JSON']>;
  defaultValuesContain?: InputMaybe<Scalars['JSON']>;
  defaultValuesEq?: InputMaybe<Scalars['JSON']>;
  defaultValuesGt?: InputMaybe<Scalars['JSON']>;
  defaultValuesGte?: InputMaybe<Scalars['JSON']>;
  defaultValuesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  defaultValuesIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultValuesLike?: InputMaybe<Scalars['JSON']>;
  defaultValuesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  defaultValuesLt?: InputMaybe<Scalars['JSON']>;
  defaultValuesLte?: InputMaybe<Scalars['JSON']>;
  defaultValuesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorMessageAny?: InputMaybe<Scalars['String']>;
  errorMessageContain?: InputMaybe<Scalars['String']>;
  errorMessageEq?: InputMaybe<Scalars['String']>;
  errorMessageGt?: InputMaybe<Scalars['String']>;
  errorMessageGte?: InputMaybe<Scalars['String']>;
  errorMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  errorMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  errorMessageLike?: InputMaybe<Scalars['String']>;
  errorMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  errorMessageLt?: InputMaybe<Scalars['String']>;
  errorMessageLte?: InputMaybe<Scalars['String']>;
  errorMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldId?: InputMaybe<Scalars['Int']>;
  fieldIdAny?: InputMaybe<Scalars['Int']>;
  fieldIdContain?: InputMaybe<Scalars['Int']>;
  fieldIdEq?: InputMaybe<Scalars['Int']>;
  fieldIdGt?: InputMaybe<Scalars['Int']>;
  fieldIdGte?: InputMaybe<Scalars['Int']>;
  fieldIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fieldIdIsNull?: InputMaybe<Scalars['Boolean']>;
  fieldIdLike?: InputMaybe<Scalars['Int']>;
  fieldIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  fieldIdLt?: InputMaybe<Scalars['Int']>;
  fieldIdLte?: InputMaybe<Scalars['Int']>;
  fieldIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fieldType?: InputMaybe<Scalars['String']>;
  fieldTypeAny?: InputMaybe<Scalars['String']>;
  fieldTypeContain?: InputMaybe<Scalars['String']>;
  fieldTypeEq?: InputMaybe<Scalars['String']>;
  fieldTypeGt?: InputMaybe<Scalars['String']>;
  fieldTypeGte?: InputMaybe<Scalars['String']>;
  fieldTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  fieldTypeLike?: InputMaybe<Scalars['String']>;
  fieldTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  fieldTypeLt?: InputMaybe<Scalars['String']>;
  fieldTypeLte?: InputMaybe<Scalars['String']>;
  fieldTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  isRequiredAny?: InputMaybe<Scalars['Boolean']>;
  isRequiredContain?: InputMaybe<Scalars['Boolean']>;
  isRequiredEq?: InputMaybe<Scalars['Boolean']>;
  isRequiredGt?: InputMaybe<Scalars['Boolean']>;
  isRequiredGte?: InputMaybe<Scalars['Boolean']>;
  isRequiredIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isRequiredIsNull?: InputMaybe<Scalars['Boolean']>;
  isRequiredLike?: InputMaybe<Scalars['Boolean']>;
  isRequiredLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isRequiredLt?: InputMaybe<Scalars['Boolean']>;
  isRequiredLte?: InputMaybe<Scalars['Boolean']>;
  isRequiredNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mask?: InputMaybe<Scalars['String']>;
  maskAny?: InputMaybe<Scalars['String']>;
  maskContain?: InputMaybe<Scalars['String']>;
  maskEq?: InputMaybe<Scalars['String']>;
  maskGt?: InputMaybe<Scalars['String']>;
  maskGte?: InputMaybe<Scalars['String']>;
  maskIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maskIsNull?: InputMaybe<Scalars['Boolean']>;
  maskLike?: InputMaybe<Scalars['String']>;
  maskLikeNoCase?: InputMaybe<Scalars['String']>;
  maskLt?: InputMaybe<Scalars['String']>;
  maskLte?: InputMaybe<Scalars['String']>;
  maskNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxValue?: InputMaybe<Scalars['JSON']>;
  maxValueAny?: InputMaybe<Scalars['JSON']>;
  maxValueContain?: InputMaybe<Scalars['JSON']>;
  maxValueEq?: InputMaybe<Scalars['JSON']>;
  maxValueGt?: InputMaybe<Scalars['JSON']>;
  maxValueGte?: InputMaybe<Scalars['JSON']>;
  maxValueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  maxValueIsNull?: InputMaybe<Scalars['Boolean']>;
  maxValueLike?: InputMaybe<Scalars['JSON']>;
  maxValueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  maxValueLt?: InputMaybe<Scalars['JSON']>;
  maxValueLte?: InputMaybe<Scalars['JSON']>;
  maxValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  meta?: InputMaybe<Scalars['JSON']>;
  metaAny?: InputMaybe<Scalars['JSON']>;
  metaContain?: InputMaybe<Scalars['JSON']>;
  metaEq?: InputMaybe<Scalars['JSON']>;
  metaGt?: InputMaybe<Scalars['JSON']>;
  metaGte?: InputMaybe<Scalars['JSON']>;
  metaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  metaIsNull?: InputMaybe<Scalars['Boolean']>;
  metaLike?: InputMaybe<Scalars['JSON']>;
  metaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  metaLt?: InputMaybe<Scalars['JSON']>;
  metaLte?: InputMaybe<Scalars['JSON']>;
  metaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  minValue?: InputMaybe<Scalars['JSON']>;
  minValueAny?: InputMaybe<Scalars['JSON']>;
  minValueContain?: InputMaybe<Scalars['JSON']>;
  minValueEq?: InputMaybe<Scalars['JSON']>;
  minValueGt?: InputMaybe<Scalars['JSON']>;
  minValueGte?: InputMaybe<Scalars['JSON']>;
  minValueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  minValueIsNull?: InputMaybe<Scalars['Boolean']>;
  minValueLike?: InputMaybe<Scalars['JSON']>;
  minValueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  minValueLt?: InputMaybe<Scalars['JSON']>;
  minValueLte?: InputMaybe<Scalars['JSON']>;
  minValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  note?: InputMaybe<Scalars['String']>;
  noteAny?: InputMaybe<Scalars['String']>;
  noteContain?: InputMaybe<Scalars['String']>;
  noteEq?: InputMaybe<Scalars['String']>;
  noteGt?: InputMaybe<Scalars['String']>;
  noteGte?: InputMaybe<Scalars['String']>;
  noteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  noteIsNull?: InputMaybe<Scalars['Boolean']>;
  noteLike?: InputMaybe<Scalars['String']>;
  noteLikeNoCase?: InputMaybe<Scalars['String']>;
  noteLt?: InputMaybe<Scalars['String']>;
  noteLte?: InputMaybe<Scalars['String']>;
  noteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLStepFieldsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLStepFieldsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  pattern?: InputMaybe<Scalars['String']>;
  patternAny?: InputMaybe<Scalars['String']>;
  patternContain?: InputMaybe<Scalars['String']>;
  patternEq?: InputMaybe<Scalars['String']>;
  patternGt?: InputMaybe<Scalars['String']>;
  patternGte?: InputMaybe<Scalars['String']>;
  patternIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  patternIsNull?: InputMaybe<Scalars['Boolean']>;
  patternLike?: InputMaybe<Scalars['String']>;
  patternLikeNoCase?: InputMaybe<Scalars['String']>;
  patternLt?: InputMaybe<Scalars['String']>;
  patternLte?: InputMaybe<Scalars['String']>;
  patternNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeholder?: InputMaybe<Scalars['String']>;
  placeholderAny?: InputMaybe<Scalars['String']>;
  placeholderContain?: InputMaybe<Scalars['String']>;
  placeholderEq?: InputMaybe<Scalars['String']>;
  placeholderGt?: InputMaybe<Scalars['String']>;
  placeholderGte?: InputMaybe<Scalars['String']>;
  placeholderIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeholderIsNull?: InputMaybe<Scalars['Boolean']>;
  placeholderLike?: InputMaybe<Scalars['String']>;
  placeholderLikeNoCase?: InputMaybe<Scalars['String']>;
  placeholderLt?: InputMaybe<Scalars['String']>;
  placeholderLte?: InputMaybe<Scalars['String']>;
  placeholderNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepId?: InputMaybe<Scalars['Int']>;
  stepIdAny?: InputMaybe<Scalars['Int']>;
  stepIdContain?: InputMaybe<Scalars['Int']>;
  stepIdEq?: InputMaybe<Scalars['Int']>;
  stepIdGt?: InputMaybe<Scalars['Int']>;
  stepIdGte?: InputMaybe<Scalars['Int']>;
  stepIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepIdIsNull?: InputMaybe<Scalars['Boolean']>;
  stepIdLike?: InputMaybe<Scalars['Int']>;
  stepIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  stepIdLt?: InputMaybe<Scalars['Int']>;
  stepIdLte?: InputMaybe<Scalars['Int']>;
  stepIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryTagArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLTagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTagsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryTaxonomiesEntityArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  model?: InputMaybe<Scalars['String']>;
  modelAny?: InputMaybe<Scalars['String']>;
  modelContain?: InputMaybe<Scalars['String']>;
  modelEq?: InputMaybe<Scalars['String']>;
  modelGt?: InputMaybe<Scalars['String']>;
  modelGte?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIsNull?: InputMaybe<Scalars['Boolean']>;
  modelLike?: InputMaybe<Scalars['String']>;
  modelLikeNoCase?: InputMaybe<Scalars['String']>;
  modelLt?: InputMaybe<Scalars['String']>;
  modelLte?: InputMaybe<Scalars['String']>;
  modelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTaxonomiesEntitiesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTaxonomiesEntitiesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  sortOrderAny?: InputMaybe<Scalars['Int']>;
  sortOrderContain?: InputMaybe<Scalars['Int']>;
  sortOrderEq?: InputMaybe<Scalars['Int']>;
  sortOrderGt?: InputMaybe<Scalars['Int']>;
  sortOrderGte?: InputMaybe<Scalars['Int']>;
  sortOrderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sortOrderIsNull?: InputMaybe<Scalars['Boolean']>;
  sortOrderLike?: InputMaybe<Scalars['Int']>;
  sortOrderLikeNoCase?: InputMaybe<Scalars['Int']>;
  sortOrderLt?: InputMaybe<Scalars['Int']>;
  sortOrderLte?: InputMaybe<Scalars['Int']>;
  sortOrderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  taxonomyId?: InputMaybe<Scalars['Int']>;
  taxonomyIdAny?: InputMaybe<Scalars['Int']>;
  taxonomyIdContain?: InputMaybe<Scalars['Int']>;
  taxonomyIdEq?: InputMaybe<Scalars['Int']>;
  taxonomyIdGt?: InputMaybe<Scalars['Int']>;
  taxonomyIdGte?: InputMaybe<Scalars['Int']>;
  taxonomyIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  taxonomyIdIsNull?: InputMaybe<Scalars['Boolean']>;
  taxonomyIdLike?: InputMaybe<Scalars['Int']>;
  taxonomyIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  taxonomyIdLt?: InputMaybe<Scalars['Int']>;
  taxonomyIdLte?: InputMaybe<Scalars['Int']>;
  taxonomyIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryTaxonomyArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedByAny?: InputMaybe<Scalars['String']>;
  deletedByContain?: InputMaybe<Scalars['String']>;
  deletedByEq?: InputMaybe<Scalars['String']>;
  deletedByGt?: InputMaybe<Scalars['String']>;
  deletedByGte?: InputMaybe<Scalars['String']>;
  deletedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedByIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedByLike?: InputMaybe<Scalars['String']>;
  deletedByLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedByLt?: InputMaybe<Scalars['String']>;
  deletedByLte?: InputMaybe<Scalars['String']>;
  deletedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTaxonomiesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTaxonomiesPropertiesEnum>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetModel?: InputMaybe<Scalars['String']>;
  targetModelAny?: InputMaybe<Scalars['String']>;
  targetModelContain?: InputMaybe<Scalars['String']>;
  targetModelEq?: InputMaybe<Scalars['String']>;
  targetModelGt?: InputMaybe<Scalars['String']>;
  targetModelGte?: InputMaybe<Scalars['String']>;
  targetModelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetModelIsNull?: InputMaybe<Scalars['Boolean']>;
  targetModelLike?: InputMaybe<Scalars['String']>;
  targetModelLikeNoCase?: InputMaybe<Scalars['String']>;
  targetModelLt?: InputMaybe<Scalars['String']>;
  targetModelLte?: InputMaybe<Scalars['String']>;
  targetModelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCase?: InputMaybe<Scalars['String']>;
  useCaseAny?: InputMaybe<Scalars['String']>;
  useCaseContain?: InputMaybe<Scalars['String']>;
  useCaseEq?: InputMaybe<Scalars['String']>;
  useCaseGt?: InputMaybe<Scalars['String']>;
  useCaseGte?: InputMaybe<Scalars['String']>;
  useCaseIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCaseIsNull?: InputMaybe<Scalars['Boolean']>;
  useCaseLike?: InputMaybe<Scalars['String']>;
  useCaseLikeNoCase?: InputMaybe<Scalars['String']>;
  useCaseLt?: InputMaybe<Scalars['String']>;
  useCaseLte?: InputMaybe<Scalars['String']>;
  useCaseNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryTextBlockArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedByAny?: InputMaybe<Scalars['String']>;
  deletedByContain?: InputMaybe<Scalars['String']>;
  deletedByEq?: InputMaybe<Scalars['String']>;
  deletedByGt?: InputMaybe<Scalars['String']>;
  deletedByGte?: InputMaybe<Scalars['String']>;
  deletedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedByIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedByLike?: InputMaybe<Scalars['String']>;
  deletedByLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedByLt?: InputMaybe<Scalars['String']>;
  deletedByLte?: InputMaybe<Scalars['String']>;
  deletedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offerIds?: InputMaybe<Scalars['JSON']>;
  offerIdsAny?: InputMaybe<Scalars['JSON']>;
  offerIdsContain?: InputMaybe<Scalars['JSON']>;
  offerIdsEq?: InputMaybe<Scalars['JSON']>;
  offerIdsGt?: InputMaybe<Scalars['JSON']>;
  offerIdsGte?: InputMaybe<Scalars['JSON']>;
  offerIdsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  offerIdsIsNull?: InputMaybe<Scalars['Boolean']>;
  offerIdsLike?: InputMaybe<Scalars['JSON']>;
  offerIdsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  offerIdsLt?: InputMaybe<Scalars['JSON']>;
  offerIdsLte?: InputMaybe<Scalars['JSON']>;
  offerIdsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTextBlocksPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTextBlocksPropertiesEnum>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  queryString?: InputMaybe<Scalars['JSON']>;
  queryStringAny?: InputMaybe<Scalars['JSON']>;
  queryStringContain?: InputMaybe<Scalars['JSON']>;
  queryStringEq?: InputMaybe<Scalars['JSON']>;
  queryStringGt?: InputMaybe<Scalars['JSON']>;
  queryStringGte?: InputMaybe<Scalars['JSON']>;
  queryStringIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  queryStringIsNull?: InputMaybe<Scalars['Boolean']>;
  queryStringLike?: InputMaybe<Scalars['JSON']>;
  queryStringLikeNoCase?: InputMaybe<Scalars['JSON']>;
  queryStringLt?: InputMaybe<Scalars['JSON']>;
  queryStringLte?: InputMaybe<Scalars['JSON']>;
  queryStringNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  text?: InputMaybe<Scalars['String']>;
  textAny?: InputMaybe<Scalars['String']>;
  textContain?: InputMaybe<Scalars['String']>;
  textEq?: InputMaybe<Scalars['String']>;
  textGt?: InputMaybe<Scalars['String']>;
  textGte?: InputMaybe<Scalars['String']>;
  textIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textIsNull?: InputMaybe<Scalars['Boolean']>;
  textLike?: InputMaybe<Scalars['String']>;
  textLikeNoCase?: InputMaybe<Scalars['String']>;
  textLt?: InputMaybe<Scalars['String']>;
  textLte?: InputMaybe<Scalars['String']>;
  textNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryTrafficSourceMapArgs = {
  accountId?: InputMaybe<Scalars['Int']>;
  accountIdAny?: InputMaybe<Scalars['Int']>;
  accountIdContain?: InputMaybe<Scalars['Int']>;
  accountIdEq?: InputMaybe<Scalars['Int']>;
  accountIdGt?: InputMaybe<Scalars['Int']>;
  accountIdGte?: InputMaybe<Scalars['Int']>;
  accountIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  accountIdIsNull?: InputMaybe<Scalars['Boolean']>;
  accountIdLike?: InputMaybe<Scalars['Int']>;
  accountIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  accountIdLt?: InputMaybe<Scalars['Int']>;
  accountIdLte?: InputMaybe<Scalars['Int']>;
  accountIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  excludeFromDailyPL?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLAny?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLContain?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLEq?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLGt?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLGte?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  excludeFromDailyPLIsNull?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLike?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLt?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLte?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  networkId?: InputMaybe<Scalars['Int']>;
  networkIdAny?: InputMaybe<Scalars['Int']>;
  networkIdContain?: InputMaybe<Scalars['Int']>;
  networkIdEq?: InputMaybe<Scalars['Int']>;
  networkIdGt?: InputMaybe<Scalars['Int']>;
  networkIdGte?: InputMaybe<Scalars['Int']>;
  networkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  networkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  networkIdLike?: InputMaybe<Scalars['Int']>;
  networkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  networkIdLt?: InputMaybe<Scalars['Int']>;
  networkIdLte?: InputMaybe<Scalars['Int']>;
  networkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTrafficSourceMapPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTrafficSourceMapPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  trafficSource?: InputMaybe<Scalars['String']>;
  trafficSourceAny?: InputMaybe<Scalars['String']>;
  trafficSourceContain?: InputMaybe<Scalars['String']>;
  trafficSourceEq?: InputMaybe<Scalars['String']>;
  trafficSourceGt?: InputMaybe<Scalars['String']>;
  trafficSourceGte?: InputMaybe<Scalars['String']>;
  trafficSourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficSourceIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficSourceLike?: InputMaybe<Scalars['String']>;
  trafficSourceLikeNoCase?: InputMaybe<Scalars['String']>;
  trafficSourceLt?: InputMaybe<Scalars['String']>;
  trafficSourceLte?: InputMaybe<Scalars['String']>;
  trafficSourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficTypeId?: InputMaybe<Scalars['Int']>;
  trafficTypeIdAny?: InputMaybe<Scalars['Int']>;
  trafficTypeIdContain?: InputMaybe<Scalars['Int']>;
  trafficTypeIdEq?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  trafficTypeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficTypeIdLike?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryTrafficTypeArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTrafficTypesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTrafficTypesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryTranslationArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};


export type GQLQueryUrlArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMain?: InputMaybe<Scalars['Boolean']>;
  isMainAny?: InputMaybe<Scalars['Boolean']>;
  isMainContain?: InputMaybe<Scalars['Boolean']>;
  isMainEq?: InputMaybe<Scalars['Boolean']>;
  isMainGt?: InputMaybe<Scalars['Boolean']>;
  isMainGte?: InputMaybe<Scalars['Boolean']>;
  isMainIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMainIsNull?: InputMaybe<Scalars['Boolean']>;
  isMainLike?: InputMaybe<Scalars['Boolean']>;
  isMainLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isMainLt?: InputMaybe<Scalars['Boolean']>;
  isMainLte?: InputMaybe<Scalars['Boolean']>;
  isMainNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  meta?: InputMaybe<Scalars['JSON']>;
  metaAny?: InputMaybe<Scalars['JSON']>;
  metaContain?: InputMaybe<Scalars['JSON']>;
  metaEq?: InputMaybe<Scalars['JSON']>;
  metaGt?: InputMaybe<Scalars['JSON']>;
  metaGte?: InputMaybe<Scalars['JSON']>;
  metaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  metaIsNull?: InputMaybe<Scalars['Boolean']>;
  metaLike?: InputMaybe<Scalars['JSON']>;
  metaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  metaLt?: InputMaybe<Scalars['JSON']>;
  metaLte?: InputMaybe<Scalars['JSON']>;
  metaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  model?: InputMaybe<Scalars['String']>;
  modelAny?: InputMaybe<Scalars['String']>;
  modelContain?: InputMaybe<Scalars['String']>;
  modelEq?: InputMaybe<Scalars['String']>;
  modelGt?: InputMaybe<Scalars['String']>;
  modelGte?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['String']>;
  modelIdAny?: InputMaybe<Scalars['String']>;
  modelIdContain?: InputMaybe<Scalars['String']>;
  modelIdEq?: InputMaybe<Scalars['String']>;
  modelIdGt?: InputMaybe<Scalars['String']>;
  modelIdGte?: InputMaybe<Scalars['String']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['String']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['String']>;
  modelIdLt?: InputMaybe<Scalars['String']>;
  modelIdLte?: InputMaybe<Scalars['String']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIsNull?: InputMaybe<Scalars['Boolean']>;
  modelLike?: InputMaybe<Scalars['String']>;
  modelLikeNoCase?: InputMaybe<Scalars['String']>;
  modelLt?: InputMaybe<Scalars['String']>;
  modelLte?: InputMaybe<Scalars['String']>;
  modelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUrlsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUrlsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  redirectionStatusCode?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeAny?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeContain?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeEq?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  redirectionStatusCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  redirectionStatusCodeLike?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLikeNoCase?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  urlAny?: InputMaybe<Scalars['String']>;
  urlContain?: InputMaybe<Scalars['String']>;
  urlEq?: InputMaybe<Scalars['String']>;
  urlGt?: InputMaybe<Scalars['String']>;
  urlGte?: InputMaybe<Scalars['String']>;
  urlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlIsNull?: InputMaybe<Scalars['Boolean']>;
  urlLike?: InputMaybe<Scalars['String']>;
  urlLikeNoCase?: InputMaybe<Scalars['String']>;
  urlLt?: InputMaybe<Scalars['String']>;
  urlLte?: InputMaybe<Scalars['String']>;
  urlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryUserArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryUserRoleArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUserRolesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUserRolesPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  roleCodeName?: InputMaybe<Scalars['String']>;
  roleCodeNameAny?: InputMaybe<Scalars['String']>;
  roleCodeNameContain?: InputMaybe<Scalars['String']>;
  roleCodeNameEq?: InputMaybe<Scalars['String']>;
  roleCodeNameGt?: InputMaybe<Scalars['String']>;
  roleCodeNameGte?: InputMaybe<Scalars['String']>;
  roleCodeNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleCodeNameIsNull?: InputMaybe<Scalars['Boolean']>;
  roleCodeNameLike?: InputMaybe<Scalars['String']>;
  roleCodeNameLikeNoCase?: InputMaybe<Scalars['String']>;
  roleCodeNameLt?: InputMaybe<Scalars['String']>;
  roleCodeNameLte?: InputMaybe<Scalars['String']>;
  roleCodeNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleName?: InputMaybe<Scalars['String']>;
  roleNameAny?: InputMaybe<Scalars['String']>;
  roleNameContain?: InputMaybe<Scalars['String']>;
  roleNameEq?: InputMaybe<Scalars['String']>;
  roleNameGt?: InputMaybe<Scalars['String']>;
  roleNameGte?: InputMaybe<Scalars['String']>;
  roleNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleNameIsNull?: InputMaybe<Scalars['Boolean']>;
  roleNameLike?: InputMaybe<Scalars['String']>;
  roleNameLikeNoCase?: InputMaybe<Scalars['String']>;
  roleNameLt?: InputMaybe<Scalars['String']>;
  roleNameLte?: InputMaybe<Scalars['String']>;
  roleNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rolePolicies?: InputMaybe<Scalars['JSON']>;
  rolePoliciesAny?: InputMaybe<Scalars['JSON']>;
  rolePoliciesContain?: InputMaybe<Scalars['JSON']>;
  rolePoliciesEq?: InputMaybe<Scalars['JSON']>;
  rolePoliciesGt?: InputMaybe<Scalars['JSON']>;
  rolePoliciesGte?: InputMaybe<Scalars['JSON']>;
  rolePoliciesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  rolePoliciesIsNull?: InputMaybe<Scalars['Boolean']>;
  rolePoliciesLike?: InputMaybe<Scalars['JSON']>;
  rolePoliciesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  rolePoliciesLt?: InputMaybe<Scalars['JSON']>;
  rolePoliciesLte?: InputMaybe<Scalars['JSON']>;
  rolePoliciesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryVariationArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLVariationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLVariationsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
  valueAny?: InputMaybe<Scalars['String']>;
  valueContain?: InputMaybe<Scalars['String']>;
  valueEq?: InputMaybe<Scalars['String']>;
  valueGt?: InputMaybe<Scalars['String']>;
  valueGte?: InputMaybe<Scalars['String']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['String']>;
  valueLikeNoCase?: InputMaybe<Scalars['String']>;
  valueLt?: InputMaybe<Scalars['String']>;
  valueLte?: InputMaybe<Scalars['String']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryVisitArgs = {
  adCampaign?: InputMaybe<Scalars['String']>;
  adCampaignAny?: InputMaybe<Scalars['String']>;
  adCampaignContain?: InputMaybe<Scalars['String']>;
  adCampaignEq?: InputMaybe<Scalars['String']>;
  adCampaignGt?: InputMaybe<Scalars['String']>;
  adCampaignGte?: InputMaybe<Scalars['String']>;
  adCampaignIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adCampaignIsNull?: InputMaybe<Scalars['Boolean']>;
  adCampaignLike?: InputMaybe<Scalars['String']>;
  adCampaignLikeNoCase?: InputMaybe<Scalars['String']>;
  adCampaignLt?: InputMaybe<Scalars['String']>;
  adCampaignLte?: InputMaybe<Scalars['String']>;
  adCampaignNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adDevice?: InputMaybe<Scalars['String']>;
  adDeviceAny?: InputMaybe<Scalars['String']>;
  adDeviceContain?: InputMaybe<Scalars['String']>;
  adDeviceEq?: InputMaybe<Scalars['String']>;
  adDeviceGt?: InputMaybe<Scalars['String']>;
  adDeviceGte?: InputMaybe<Scalars['String']>;
  adDeviceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adDeviceIsNull?: InputMaybe<Scalars['Boolean']>;
  adDeviceLike?: InputMaybe<Scalars['String']>;
  adDeviceLikeNoCase?: InputMaybe<Scalars['String']>;
  adDeviceLt?: InputMaybe<Scalars['String']>;
  adDeviceLte?: InputMaybe<Scalars['String']>;
  adDeviceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adGroup?: InputMaybe<Scalars['String']>;
  adGroupAny?: InputMaybe<Scalars['String']>;
  adGroupContain?: InputMaybe<Scalars['String']>;
  adGroupEq?: InputMaybe<Scalars['String']>;
  adGroupGt?: InputMaybe<Scalars['String']>;
  adGroupGte?: InputMaybe<Scalars['String']>;
  adGroupIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adGroupIsNull?: InputMaybe<Scalars['Boolean']>;
  adGroupLike?: InputMaybe<Scalars['String']>;
  adGroupLikeNoCase?: InputMaybe<Scalars['String']>;
  adGroupLt?: InputMaybe<Scalars['String']>;
  adGroupLte?: InputMaybe<Scalars['String']>;
  adGroupNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adKeyword?: InputMaybe<Scalars['String']>;
  adKeywordAny?: InputMaybe<Scalars['String']>;
  adKeywordContain?: InputMaybe<Scalars['String']>;
  adKeywordEq?: InputMaybe<Scalars['String']>;
  adKeywordGt?: InputMaybe<Scalars['String']>;
  adKeywordGte?: InputMaybe<Scalars['String']>;
  adKeywordIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adKeywordIsNull?: InputMaybe<Scalars['Boolean']>;
  adKeywordLike?: InputMaybe<Scalars['String']>;
  adKeywordLikeNoCase?: InputMaybe<Scalars['String']>;
  adKeywordLt?: InputMaybe<Scalars['String']>;
  adKeywordLte?: InputMaybe<Scalars['String']>;
  adKeywordNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adMedium?: InputMaybe<Scalars['String']>;
  adMediumAny?: InputMaybe<Scalars['String']>;
  adMediumContain?: InputMaybe<Scalars['String']>;
  adMediumEq?: InputMaybe<Scalars['String']>;
  adMediumGt?: InputMaybe<Scalars['String']>;
  adMediumGte?: InputMaybe<Scalars['String']>;
  adMediumIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adMediumIsNull?: InputMaybe<Scalars['Boolean']>;
  adMediumLike?: InputMaybe<Scalars['String']>;
  adMediumLikeNoCase?: InputMaybe<Scalars['String']>;
  adMediumLt?: InputMaybe<Scalars['String']>;
  adMediumLte?: InputMaybe<Scalars['String']>;
  adMediumNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adTrafficSource?: InputMaybe<Scalars['String']>;
  adTrafficSourceAny?: InputMaybe<Scalars['String']>;
  adTrafficSourceContain?: InputMaybe<Scalars['String']>;
  adTrafficSourceEq?: InputMaybe<Scalars['String']>;
  adTrafficSourceGt?: InputMaybe<Scalars['String']>;
  adTrafficSourceGte?: InputMaybe<Scalars['String']>;
  adTrafficSourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adTrafficSourceIsNull?: InputMaybe<Scalars['Boolean']>;
  adTrafficSourceLike?: InputMaybe<Scalars['String']>;
  adTrafficSourceLikeNoCase?: InputMaybe<Scalars['String']>;
  adTrafficSourceLt?: InputMaybe<Scalars['String']>;
  adTrafficSourceLte?: InputMaybe<Scalars['String']>;
  adTrafficSourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  expireAt?: InputMaybe<Scalars['String']>;
  expireAtAny?: InputMaybe<Scalars['String']>;
  expireAtContain?: InputMaybe<Scalars['String']>;
  expireAtEq?: InputMaybe<Scalars['String']>;
  expireAtGt?: InputMaybe<Scalars['String']>;
  expireAtGte?: InputMaybe<Scalars['String']>;
  expireAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  expireAtIsNull?: InputMaybe<Scalars['Boolean']>;
  expireAtLike?: InputMaybe<Scalars['String']>;
  expireAtLikeNoCase?: InputMaybe<Scalars['String']>;
  expireAtLt?: InputMaybe<Scalars['String']>;
  expireAtLte?: InputMaybe<Scalars['String']>;
  expireAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLVisitsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLVisitsPropertiesEnum>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  urlAny?: InputMaybe<Scalars['String']>;
  urlContain?: InputMaybe<Scalars['String']>;
  urlEq?: InputMaybe<Scalars['String']>;
  urlGt?: InputMaybe<Scalars['String']>;
  urlGte?: InputMaybe<Scalars['String']>;
  urlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlIsNull?: InputMaybe<Scalars['Boolean']>;
  urlLike?: InputMaybe<Scalars['String']>;
  urlLikeNoCase?: InputMaybe<Scalars['String']>;
  urlLt?: InputMaybe<Scalars['String']>;
  urlLte?: InputMaybe<Scalars['String']>;
  urlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitorId?: InputMaybe<Scalars['String']>;
  visitorIdAny?: InputMaybe<Scalars['String']>;
  visitorIdContain?: InputMaybe<Scalars['String']>;
  visitorIdEq?: InputMaybe<Scalars['String']>;
  visitorIdGt?: InputMaybe<Scalars['String']>;
  visitorIdGte?: InputMaybe<Scalars['String']>;
  visitorIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitorIdIsNull?: InputMaybe<Scalars['Boolean']>;
  visitorIdLike?: InputMaybe<Scalars['String']>;
  visitorIdLikeNoCase?: InputMaybe<Scalars['String']>;
  visitorIdLt?: InputMaybe<Scalars['String']>;
  visitorIdLte?: InputMaybe<Scalars['String']>;
  visitorIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLQueryVisitorArgs = {
  adCampaign?: InputMaybe<Scalars['String']>;
  adCampaignAny?: InputMaybe<Scalars['String']>;
  adCampaignContain?: InputMaybe<Scalars['String']>;
  adCampaignEq?: InputMaybe<Scalars['String']>;
  adCampaignGt?: InputMaybe<Scalars['String']>;
  adCampaignGte?: InputMaybe<Scalars['String']>;
  adCampaignIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adCampaignIsNull?: InputMaybe<Scalars['Boolean']>;
  adCampaignLike?: InputMaybe<Scalars['String']>;
  adCampaignLikeNoCase?: InputMaybe<Scalars['String']>;
  adCampaignLt?: InputMaybe<Scalars['String']>;
  adCampaignLte?: InputMaybe<Scalars['String']>;
  adCampaignNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adDevice?: InputMaybe<Scalars['String']>;
  adDeviceAny?: InputMaybe<Scalars['String']>;
  adDeviceContain?: InputMaybe<Scalars['String']>;
  adDeviceEq?: InputMaybe<Scalars['String']>;
  adDeviceGt?: InputMaybe<Scalars['String']>;
  adDeviceGte?: InputMaybe<Scalars['String']>;
  adDeviceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adDeviceIsNull?: InputMaybe<Scalars['Boolean']>;
  adDeviceLike?: InputMaybe<Scalars['String']>;
  adDeviceLikeNoCase?: InputMaybe<Scalars['String']>;
  adDeviceLt?: InputMaybe<Scalars['String']>;
  adDeviceLte?: InputMaybe<Scalars['String']>;
  adDeviceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adGroup?: InputMaybe<Scalars['String']>;
  adGroupAny?: InputMaybe<Scalars['String']>;
  adGroupContain?: InputMaybe<Scalars['String']>;
  adGroupEq?: InputMaybe<Scalars['String']>;
  adGroupGt?: InputMaybe<Scalars['String']>;
  adGroupGte?: InputMaybe<Scalars['String']>;
  adGroupIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adGroupIsNull?: InputMaybe<Scalars['Boolean']>;
  adGroupLike?: InputMaybe<Scalars['String']>;
  adGroupLikeNoCase?: InputMaybe<Scalars['String']>;
  adGroupLt?: InputMaybe<Scalars['String']>;
  adGroupLte?: InputMaybe<Scalars['String']>;
  adGroupNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adKeyword?: InputMaybe<Scalars['String']>;
  adKeywordAny?: InputMaybe<Scalars['String']>;
  adKeywordContain?: InputMaybe<Scalars['String']>;
  adKeywordEq?: InputMaybe<Scalars['String']>;
  adKeywordGt?: InputMaybe<Scalars['String']>;
  adKeywordGte?: InputMaybe<Scalars['String']>;
  adKeywordIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adKeywordIsNull?: InputMaybe<Scalars['Boolean']>;
  adKeywordLike?: InputMaybe<Scalars['String']>;
  adKeywordLikeNoCase?: InputMaybe<Scalars['String']>;
  adKeywordLt?: InputMaybe<Scalars['String']>;
  adKeywordLte?: InputMaybe<Scalars['String']>;
  adKeywordNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adMedium?: InputMaybe<Scalars['String']>;
  adMediumAny?: InputMaybe<Scalars['String']>;
  adMediumContain?: InputMaybe<Scalars['String']>;
  adMediumEq?: InputMaybe<Scalars['String']>;
  adMediumGt?: InputMaybe<Scalars['String']>;
  adMediumGte?: InputMaybe<Scalars['String']>;
  adMediumIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adMediumIsNull?: InputMaybe<Scalars['Boolean']>;
  adMediumLike?: InputMaybe<Scalars['String']>;
  adMediumLikeNoCase?: InputMaybe<Scalars['String']>;
  adMediumLt?: InputMaybe<Scalars['String']>;
  adMediumLte?: InputMaybe<Scalars['String']>;
  adMediumNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adTrafficSource?: InputMaybe<Scalars['String']>;
  adTrafficSourceAny?: InputMaybe<Scalars['String']>;
  adTrafficSourceContain?: InputMaybe<Scalars['String']>;
  adTrafficSourceEq?: InputMaybe<Scalars['String']>;
  adTrafficSourceGt?: InputMaybe<Scalars['String']>;
  adTrafficSourceGte?: InputMaybe<Scalars['String']>;
  adTrafficSourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adTrafficSourceIsNull?: InputMaybe<Scalars['Boolean']>;
  adTrafficSourceLike?: InputMaybe<Scalars['String']>;
  adTrafficSourceLikeNoCase?: InputMaybe<Scalars['String']>;
  adTrafficSourceLt?: InputMaybe<Scalars['String']>;
  adTrafficSourceLte?: InputMaybe<Scalars['String']>;
  adTrafficSourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browser?: InputMaybe<Scalars['String']>;
  browserAny?: InputMaybe<Scalars['String']>;
  browserCode?: InputMaybe<Scalars['String']>;
  browserCodeAny?: InputMaybe<Scalars['String']>;
  browserCodeContain?: InputMaybe<Scalars['String']>;
  browserCodeEq?: InputMaybe<Scalars['String']>;
  browserCodeGt?: InputMaybe<Scalars['String']>;
  browserCodeGte?: InputMaybe<Scalars['String']>;
  browserCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  browserCodeLike?: InputMaybe<Scalars['String']>;
  browserCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  browserCodeLt?: InputMaybe<Scalars['String']>;
  browserCodeLte?: InputMaybe<Scalars['String']>;
  browserCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserContain?: InputMaybe<Scalars['String']>;
  browserEq?: InputMaybe<Scalars['String']>;
  browserGt?: InputMaybe<Scalars['String']>;
  browserGte?: InputMaybe<Scalars['String']>;
  browserIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserIsNull?: InputMaybe<Scalars['Boolean']>;
  browserLike?: InputMaybe<Scalars['String']>;
  browserLikeNoCase?: InputMaybe<Scalars['String']>;
  browserLt?: InputMaybe<Scalars['String']>;
  browserLte?: InputMaybe<Scalars['String']>;
  browserNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserVersion?: InputMaybe<Scalars['String']>;
  browserVersionAny?: InputMaybe<Scalars['String']>;
  browserVersionContain?: InputMaybe<Scalars['String']>;
  browserVersionEq?: InputMaybe<Scalars['String']>;
  browserVersionGt?: InputMaybe<Scalars['String']>;
  browserVersionGte?: InputMaybe<Scalars['String']>;
  browserVersionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserVersionIsNull?: InputMaybe<Scalars['Boolean']>;
  browserVersionLike?: InputMaybe<Scalars['String']>;
  browserVersionLikeNoCase?: InputMaybe<Scalars['String']>;
  browserVersionLt?: InputMaybe<Scalars['String']>;
  browserVersionLte?: InputMaybe<Scalars['String']>;
  browserVersionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ipAddressId?: InputMaybe<Scalars['Int']>;
  ipAddressIdAny?: InputMaybe<Scalars['Int']>;
  ipAddressIdContain?: InputMaybe<Scalars['Int']>;
  ipAddressIdEq?: InputMaybe<Scalars['Int']>;
  ipAddressIdGt?: InputMaybe<Scalars['Int']>;
  ipAddressIdGte?: InputMaybe<Scalars['Int']>;
  ipAddressIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ipAddressIdIsNull?: InputMaybe<Scalars['Boolean']>;
  ipAddressIdLike?: InputMaybe<Scalars['Int']>;
  ipAddressIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  ipAddressIdLt?: InputMaybe<Scalars['Int']>;
  ipAddressIdLte?: InputMaybe<Scalars['Int']>;
  ipAddressIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLVisitorsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLVisitorsPropertiesEnum>;
  os?: InputMaybe<Scalars['String']>;
  osAny?: InputMaybe<Scalars['String']>;
  osCode?: InputMaybe<Scalars['String']>;
  osCodeAny?: InputMaybe<Scalars['String']>;
  osCodeContain?: InputMaybe<Scalars['String']>;
  osCodeEq?: InputMaybe<Scalars['String']>;
  osCodeGt?: InputMaybe<Scalars['String']>;
  osCodeGte?: InputMaybe<Scalars['String']>;
  osCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  osCodeLike?: InputMaybe<Scalars['String']>;
  osCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  osCodeLt?: InputMaybe<Scalars['String']>;
  osCodeLte?: InputMaybe<Scalars['String']>;
  osCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osContain?: InputMaybe<Scalars['String']>;
  osEq?: InputMaybe<Scalars['String']>;
  osGt?: InputMaybe<Scalars['String']>;
  osGte?: InputMaybe<Scalars['String']>;
  osIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osIsNull?: InputMaybe<Scalars['Boolean']>;
  osLike?: InputMaybe<Scalars['String']>;
  osLikeNoCase?: InputMaybe<Scalars['String']>;
  osLt?: InputMaybe<Scalars['String']>;
  osLte?: InputMaybe<Scalars['String']>;
  osNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osVersion?: InputMaybe<Scalars['String']>;
  osVersionAny?: InputMaybe<Scalars['String']>;
  osVersionContain?: InputMaybe<Scalars['String']>;
  osVersionEq?: InputMaybe<Scalars['String']>;
  osVersionGt?: InputMaybe<Scalars['String']>;
  osVersionGte?: InputMaybe<Scalars['String']>;
  osVersionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osVersionIsNull?: InputMaybe<Scalars['Boolean']>;
  osVersionLike?: InputMaybe<Scalars['String']>;
  osVersionLikeNoCase?: InputMaybe<Scalars['String']>;
  osVersionLt?: InputMaybe<Scalars['String']>;
  osVersionLte?: InputMaybe<Scalars['String']>;
  osVersionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  platform?: InputMaybe<Scalars['String']>;
  platformAny?: InputMaybe<Scalars['String']>;
  platformContain?: InputMaybe<Scalars['String']>;
  platformEq?: InputMaybe<Scalars['String']>;
  platformGt?: InputMaybe<Scalars['String']>;
  platformGte?: InputMaybe<Scalars['String']>;
  platformIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  platformIsNull?: InputMaybe<Scalars['Boolean']>;
  platformLike?: InputMaybe<Scalars['String']>;
  platformLikeNoCase?: InputMaybe<Scalars['String']>;
  platformLt?: InputMaybe<Scalars['String']>;
  platformLte?: InputMaybe<Scalars['String']>;
  platformNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  referrer?: InputMaybe<Scalars['String']>;
  referrerAny?: InputMaybe<Scalars['String']>;
  referrerContain?: InputMaybe<Scalars['String']>;
  referrerEq?: InputMaybe<Scalars['String']>;
  referrerGt?: InputMaybe<Scalars['String']>;
  referrerGte?: InputMaybe<Scalars['String']>;
  referrerIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  referrerIsNull?: InputMaybe<Scalars['Boolean']>;
  referrerLike?: InputMaybe<Scalars['String']>;
  referrerLikeNoCase?: InputMaybe<Scalars['String']>;
  referrerLt?: InputMaybe<Scalars['String']>;
  referrerLte?: InputMaybe<Scalars['String']>;
  referrerNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ua?: InputMaybe<Scalars['String']>;
  uaAny?: InputMaybe<Scalars['String']>;
  uaContain?: InputMaybe<Scalars['String']>;
  uaEq?: InputMaybe<Scalars['String']>;
  uaGt?: InputMaybe<Scalars['String']>;
  uaGte?: InputMaybe<Scalars['String']>;
  uaIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uaIsNull?: InputMaybe<Scalars['Boolean']>;
  uaLike?: InputMaybe<Scalars['String']>;
  uaLikeNoCase?: InputMaybe<Scalars['String']>;
  uaLt?: InputMaybe<Scalars['String']>;
  uaLte?: InputMaybe<Scalars['String']>;
  uaNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GQLRedirections = {
  __typename?: 'Redirections';
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  destinationURI?: Maybe<Scalars['String']>;
  domainId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  redirectionStatusCode?: Maybe<Scalars['Int']>;
  srcURI?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export enum GQLRedirectionsPropertiesEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DestinationUri = 'destinationURI',
  DomainId = 'domainId',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  Language = 'language',
  RedirectionStatusCode = 'redirectionStatusCode',
  SrcUri = 'srcURI',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy'
}

export type GQLRelatedPosts = {
  __typename?: 'RelatedPosts';
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  postId?: Maybe<Scalars['Int']>;
  relatedPostId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export enum GQLRelatedPostsPropertiesEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  Id = 'id',
  IsDeleted = 'isDeleted',
  Order = 'order',
  PostId = 'postId',
  RelatedPostId = 'relatedPostId',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy'
}

export type GQLStepFields = {
  __typename?: 'StepFields';
  autocomplete?: Maybe<Scalars['String']>;
  conditionalLogic?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['String']>;
  dataDependency?: Maybe<Scalars['JSON']>;
  defaultValue?: Maybe<Scalars['String']>;
  defaultValues?: Maybe<Scalars['JSON']>;
  deletedAt?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  fieldId?: Maybe<Scalars['Int']>;
  fieldType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  mask?: Maybe<Scalars['String']>;
  maxValue?: Maybe<Scalars['JSON']>;
  meta?: Maybe<Scalars['JSON']>;
  minValue?: Maybe<Scalars['JSON']>;
  niceName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  origin?: Maybe<GQLFields>;
  pattern?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  stepId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  updatedAt?: Maybe<Scalars['String']>;
};


export type GQLStepFieldsOriginArgs = {
  autocomplete?: InputMaybe<Scalars['String']>;
  autocompleteAny?: InputMaybe<Scalars['String']>;
  autocompleteContain?: InputMaybe<Scalars['String']>;
  autocompleteEq?: InputMaybe<Scalars['String']>;
  autocompleteGt?: InputMaybe<Scalars['String']>;
  autocompleteGte?: InputMaybe<Scalars['String']>;
  autocompleteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autocompleteIsNull?: InputMaybe<Scalars['Boolean']>;
  autocompleteLike?: InputMaybe<Scalars['String']>;
  autocompleteLikeNoCase?: InputMaybe<Scalars['String']>;
  autocompleteLt?: InputMaybe<Scalars['String']>;
  autocompleteLte?: InputMaybe<Scalars['String']>;
  autocompleteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  codeName?: InputMaybe<Scalars['String']>;
  codeNameAny?: InputMaybe<Scalars['String']>;
  codeNameContain?: InputMaybe<Scalars['String']>;
  codeNameEq?: InputMaybe<Scalars['String']>;
  codeNameGt?: InputMaybe<Scalars['String']>;
  codeNameGte?: InputMaybe<Scalars['String']>;
  codeNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  codeNameIsNull?: InputMaybe<Scalars['Boolean']>;
  codeNameLike?: InputMaybe<Scalars['String']>;
  codeNameLikeNoCase?: InputMaybe<Scalars['String']>;
  codeNameLt?: InputMaybe<Scalars['String']>;
  codeNameLte?: InputMaybe<Scalars['String']>;
  codeNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dataDependency?: InputMaybe<Scalars['JSON']>;
  dataDependencyAny?: InputMaybe<Scalars['JSON']>;
  dataDependencyContain?: InputMaybe<Scalars['JSON']>;
  dataDependencyEq?: InputMaybe<Scalars['JSON']>;
  dataDependencyGt?: InputMaybe<Scalars['JSON']>;
  dataDependencyGte?: InputMaybe<Scalars['JSON']>;
  dataDependencyIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  dataDependencyIsNull?: InputMaybe<Scalars['Boolean']>;
  dataDependencyLike?: InputMaybe<Scalars['JSON']>;
  dataDependencyLikeNoCase?: InputMaybe<Scalars['JSON']>;
  dataDependencyLt?: InputMaybe<Scalars['JSON']>;
  dataDependencyLte?: InputMaybe<Scalars['JSON']>;
  dataDependencyNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  defaultValue?: InputMaybe<Scalars['String']>;
  defaultValueAny?: InputMaybe<Scalars['String']>;
  defaultValueContain?: InputMaybe<Scalars['String']>;
  defaultValueEq?: InputMaybe<Scalars['String']>;
  defaultValueGt?: InputMaybe<Scalars['String']>;
  defaultValueGte?: InputMaybe<Scalars['String']>;
  defaultValueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultValueIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultValueLike?: InputMaybe<Scalars['String']>;
  defaultValueLikeNoCase?: InputMaybe<Scalars['String']>;
  defaultValueLt?: InputMaybe<Scalars['String']>;
  defaultValueLte?: InputMaybe<Scalars['String']>;
  defaultValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultValues?: InputMaybe<Scalars['JSON']>;
  defaultValuesAny?: InputMaybe<Scalars['JSON']>;
  defaultValuesContain?: InputMaybe<Scalars['JSON']>;
  defaultValuesEq?: InputMaybe<Scalars['JSON']>;
  defaultValuesGt?: InputMaybe<Scalars['JSON']>;
  defaultValuesGte?: InputMaybe<Scalars['JSON']>;
  defaultValuesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  defaultValuesIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultValuesLike?: InputMaybe<Scalars['JSON']>;
  defaultValuesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  defaultValuesLt?: InputMaybe<Scalars['JSON']>;
  defaultValuesLte?: InputMaybe<Scalars['JSON']>;
  defaultValuesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorMessageAny?: InputMaybe<Scalars['String']>;
  errorMessageContain?: InputMaybe<Scalars['String']>;
  errorMessageEq?: InputMaybe<Scalars['String']>;
  errorMessageGt?: InputMaybe<Scalars['String']>;
  errorMessageGte?: InputMaybe<Scalars['String']>;
  errorMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  errorMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  errorMessageLike?: InputMaybe<Scalars['String']>;
  errorMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  errorMessageLt?: InputMaybe<Scalars['String']>;
  errorMessageLte?: InputMaybe<Scalars['String']>;
  errorMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldType?: InputMaybe<Scalars['String']>;
  fieldTypeAny?: InputMaybe<Scalars['String']>;
  fieldTypeContain?: InputMaybe<Scalars['String']>;
  fieldTypeEq?: InputMaybe<Scalars['String']>;
  fieldTypeGt?: InputMaybe<Scalars['String']>;
  fieldTypeGte?: InputMaybe<Scalars['String']>;
  fieldTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  fieldTypeLike?: InputMaybe<Scalars['String']>;
  fieldTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  fieldTypeLt?: InputMaybe<Scalars['String']>;
  fieldTypeLte?: InputMaybe<Scalars['String']>;
  fieldTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  formId?: InputMaybe<Scalars['Int']>;
  formIdAny?: InputMaybe<Scalars['Int']>;
  formIdContain?: InputMaybe<Scalars['Int']>;
  formIdEq?: InputMaybe<Scalars['Int']>;
  formIdGt?: InputMaybe<Scalars['Int']>;
  formIdGte?: InputMaybe<Scalars['Int']>;
  formIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formIdIsNull?: InputMaybe<Scalars['Boolean']>;
  formIdLike?: InputMaybe<Scalars['Int']>;
  formIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  formIdLt?: InputMaybe<Scalars['Int']>;
  formIdLte?: InputMaybe<Scalars['Int']>;
  formIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  isGlobalAny?: InputMaybe<Scalars['Boolean']>;
  isGlobalContain?: InputMaybe<Scalars['Boolean']>;
  isGlobalEq?: InputMaybe<Scalars['Boolean']>;
  isGlobalGt?: InputMaybe<Scalars['Boolean']>;
  isGlobalGte?: InputMaybe<Scalars['Boolean']>;
  isGlobalIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isGlobalIsNull?: InputMaybe<Scalars['Boolean']>;
  isGlobalLike?: InputMaybe<Scalars['Boolean']>;
  isGlobalLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isGlobalLt?: InputMaybe<Scalars['Boolean']>;
  isGlobalLte?: InputMaybe<Scalars['Boolean']>;
  isGlobalNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mask?: InputMaybe<Scalars['String']>;
  maskAny?: InputMaybe<Scalars['String']>;
  maskContain?: InputMaybe<Scalars['String']>;
  maskEq?: InputMaybe<Scalars['String']>;
  maskGt?: InputMaybe<Scalars['String']>;
  maskGte?: InputMaybe<Scalars['String']>;
  maskIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maskIsNull?: InputMaybe<Scalars['Boolean']>;
  maskLike?: InputMaybe<Scalars['String']>;
  maskLikeNoCase?: InputMaybe<Scalars['String']>;
  maskLt?: InputMaybe<Scalars['String']>;
  maskLte?: InputMaybe<Scalars['String']>;
  maskNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxValue?: InputMaybe<Scalars['JSON']>;
  maxValueAny?: InputMaybe<Scalars['JSON']>;
  maxValueContain?: InputMaybe<Scalars['JSON']>;
  maxValueEq?: InputMaybe<Scalars['JSON']>;
  maxValueGt?: InputMaybe<Scalars['JSON']>;
  maxValueGte?: InputMaybe<Scalars['JSON']>;
  maxValueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  maxValueIsNull?: InputMaybe<Scalars['Boolean']>;
  maxValueLike?: InputMaybe<Scalars['JSON']>;
  maxValueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  maxValueLt?: InputMaybe<Scalars['JSON']>;
  maxValueLte?: InputMaybe<Scalars['JSON']>;
  maxValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  meta?: InputMaybe<Scalars['JSON']>;
  metaAny?: InputMaybe<Scalars['JSON']>;
  metaContain?: InputMaybe<Scalars['JSON']>;
  metaEq?: InputMaybe<Scalars['JSON']>;
  metaGt?: InputMaybe<Scalars['JSON']>;
  metaGte?: InputMaybe<Scalars['JSON']>;
  metaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  metaIsNull?: InputMaybe<Scalars['Boolean']>;
  metaLike?: InputMaybe<Scalars['JSON']>;
  metaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  metaLt?: InputMaybe<Scalars['JSON']>;
  metaLte?: InputMaybe<Scalars['JSON']>;
  metaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  minValue?: InputMaybe<Scalars['JSON']>;
  minValueAny?: InputMaybe<Scalars['JSON']>;
  minValueContain?: InputMaybe<Scalars['JSON']>;
  minValueEq?: InputMaybe<Scalars['JSON']>;
  minValueGt?: InputMaybe<Scalars['JSON']>;
  minValueGte?: InputMaybe<Scalars['JSON']>;
  minValueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  minValueIsNull?: InputMaybe<Scalars['Boolean']>;
  minValueLike?: InputMaybe<Scalars['JSON']>;
  minValueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  minValueLt?: InputMaybe<Scalars['JSON']>;
  minValueLte?: InputMaybe<Scalars['JSON']>;
  minValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  modifiedAt?: InputMaybe<Scalars['String']>;
  modifiedAtAny?: InputMaybe<Scalars['String']>;
  modifiedAtContain?: InputMaybe<Scalars['String']>;
  modifiedAtEq?: InputMaybe<Scalars['String']>;
  modifiedAtGt?: InputMaybe<Scalars['String']>;
  modifiedAtGte?: InputMaybe<Scalars['String']>;
  modifiedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedAtLike?: InputMaybe<Scalars['String']>;
  modifiedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedAtLt?: InputMaybe<Scalars['String']>;
  modifiedAtLte?: InputMaybe<Scalars['String']>;
  modifiedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  note?: InputMaybe<Scalars['String']>;
  noteAny?: InputMaybe<Scalars['String']>;
  noteContain?: InputMaybe<Scalars['String']>;
  noteEq?: InputMaybe<Scalars['String']>;
  noteGt?: InputMaybe<Scalars['String']>;
  noteGte?: InputMaybe<Scalars['String']>;
  noteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  noteIsNull?: InputMaybe<Scalars['Boolean']>;
  noteLike?: InputMaybe<Scalars['String']>;
  noteLikeNoCase?: InputMaybe<Scalars['String']>;
  noteLt?: InputMaybe<Scalars['String']>;
  noteLte?: InputMaybe<Scalars['String']>;
  noteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLFieldsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLFieldsPropertiesEnum>;
  pattern?: InputMaybe<Scalars['String']>;
  patternAny?: InputMaybe<Scalars['String']>;
  patternContain?: InputMaybe<Scalars['String']>;
  patternEq?: InputMaybe<Scalars['String']>;
  patternGt?: InputMaybe<Scalars['String']>;
  patternGte?: InputMaybe<Scalars['String']>;
  patternIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  patternIsNull?: InputMaybe<Scalars['Boolean']>;
  patternLike?: InputMaybe<Scalars['String']>;
  patternLikeNoCase?: InputMaybe<Scalars['String']>;
  patternLt?: InputMaybe<Scalars['String']>;
  patternLte?: InputMaybe<Scalars['String']>;
  patternNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeholder?: InputMaybe<Scalars['String']>;
  placeholderAny?: InputMaybe<Scalars['String']>;
  placeholderContain?: InputMaybe<Scalars['String']>;
  placeholderEq?: InputMaybe<Scalars['String']>;
  placeholderGt?: InputMaybe<Scalars['String']>;
  placeholderGte?: InputMaybe<Scalars['String']>;
  placeholderIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeholderIsNull?: InputMaybe<Scalars['Boolean']>;
  placeholderLike?: InputMaybe<Scalars['String']>;
  placeholderLikeNoCase?: InputMaybe<Scalars['String']>;
  placeholderLt?: InputMaybe<Scalars['String']>;
  placeholderLte?: InputMaybe<Scalars['String']>;
  placeholderNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCase?: InputMaybe<Scalars['String']>;
  useCaseAny?: InputMaybe<Scalars['String']>;
  useCaseContain?: InputMaybe<Scalars['String']>;
  useCaseEq?: InputMaybe<Scalars['String']>;
  useCaseGt?: InputMaybe<Scalars['String']>;
  useCaseGte?: InputMaybe<Scalars['String']>;
  useCaseIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCaseIsNull?: InputMaybe<Scalars['Boolean']>;
  useCaseLike?: InputMaybe<Scalars['String']>;
  useCaseLikeNoCase?: InputMaybe<Scalars['String']>;
  useCaseLt?: InputMaybe<Scalars['String']>;
  useCaseLte?: InputMaybe<Scalars['String']>;
  useCaseNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  validationType?: InputMaybe<Scalars['String']>;
  validationTypeAny?: InputMaybe<Scalars['String']>;
  validationTypeContain?: InputMaybe<Scalars['String']>;
  validationTypeEq?: InputMaybe<Scalars['String']>;
  validationTypeGt?: InputMaybe<Scalars['String']>;
  validationTypeGte?: InputMaybe<Scalars['String']>;
  validationTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  validationTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  validationTypeLike?: InputMaybe<Scalars['String']>;
  validationTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  validationTypeLt?: InputMaybe<Scalars['String']>;
  validationTypeLte?: InputMaybe<Scalars['String']>;
  validationTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLStepFieldsTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export enum GQLStepFieldsPropertiesEnum {
  Autocomplete = 'autocomplete',
  ConditionalLogic = 'conditionalLogic',
  CreatedAt = 'createdAt',
  DataDependency = 'dataDependency',
  DefaultValue = 'defaultValue',
  DefaultValues = 'defaultValues',
  DeletedAt = 'deletedAt',
  ErrorMessage = 'errorMessage',
  FieldId = 'fieldId',
  FieldType = 'fieldType',
  Id = 'id',
  IsDeleted = 'isDeleted',
  IsRequired = 'isRequired',
  Label = 'label',
  Mask = 'mask',
  MaxValue = 'maxValue',
  Meta = 'meta',
  MinValue = 'minValue',
  NiceName = 'niceName',
  Note = 'note',
  Order = 'order',
  Pattern = 'pattern',
  Placeholder = 'placeholder',
  StepId = 'stepId',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type GQLSteps = {
  __typename?: 'Steps';
  adminTitle?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<Maybe<GQLStepFields>>>;
  formId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  includeTCPAMessage?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  updatedAt?: Maybe<Scalars['String']>;
};


export type GQLStepsFieldsArgs = {
  autocomplete?: InputMaybe<Scalars['String']>;
  autocompleteAny?: InputMaybe<Scalars['String']>;
  autocompleteContain?: InputMaybe<Scalars['String']>;
  autocompleteEq?: InputMaybe<Scalars['String']>;
  autocompleteGt?: InputMaybe<Scalars['String']>;
  autocompleteGte?: InputMaybe<Scalars['String']>;
  autocompleteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autocompleteIsNull?: InputMaybe<Scalars['Boolean']>;
  autocompleteLike?: InputMaybe<Scalars['String']>;
  autocompleteLikeNoCase?: InputMaybe<Scalars['String']>;
  autocompleteLt?: InputMaybe<Scalars['String']>;
  autocompleteLte?: InputMaybe<Scalars['String']>;
  autocompleteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  conditionalLogic?: InputMaybe<Scalars['JSON']>;
  conditionalLogicAny?: InputMaybe<Scalars['JSON']>;
  conditionalLogicContain?: InputMaybe<Scalars['JSON']>;
  conditionalLogicEq?: InputMaybe<Scalars['JSON']>;
  conditionalLogicGt?: InputMaybe<Scalars['JSON']>;
  conditionalLogicGte?: InputMaybe<Scalars['JSON']>;
  conditionalLogicIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  conditionalLogicIsNull?: InputMaybe<Scalars['Boolean']>;
  conditionalLogicLike?: InputMaybe<Scalars['JSON']>;
  conditionalLogicLikeNoCase?: InputMaybe<Scalars['JSON']>;
  conditionalLogicLt?: InputMaybe<Scalars['JSON']>;
  conditionalLogicLte?: InputMaybe<Scalars['JSON']>;
  conditionalLogicNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dataDependency?: InputMaybe<Scalars['JSON']>;
  dataDependencyAny?: InputMaybe<Scalars['JSON']>;
  dataDependencyContain?: InputMaybe<Scalars['JSON']>;
  dataDependencyEq?: InputMaybe<Scalars['JSON']>;
  dataDependencyGt?: InputMaybe<Scalars['JSON']>;
  dataDependencyGte?: InputMaybe<Scalars['JSON']>;
  dataDependencyIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  dataDependencyIsNull?: InputMaybe<Scalars['Boolean']>;
  dataDependencyLike?: InputMaybe<Scalars['JSON']>;
  dataDependencyLikeNoCase?: InputMaybe<Scalars['JSON']>;
  dataDependencyLt?: InputMaybe<Scalars['JSON']>;
  dataDependencyLte?: InputMaybe<Scalars['JSON']>;
  dataDependencyNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  defaultValue?: InputMaybe<Scalars['String']>;
  defaultValueAny?: InputMaybe<Scalars['String']>;
  defaultValueContain?: InputMaybe<Scalars['String']>;
  defaultValueEq?: InputMaybe<Scalars['String']>;
  defaultValueGt?: InputMaybe<Scalars['String']>;
  defaultValueGte?: InputMaybe<Scalars['String']>;
  defaultValueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultValueIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultValueLike?: InputMaybe<Scalars['String']>;
  defaultValueLikeNoCase?: InputMaybe<Scalars['String']>;
  defaultValueLt?: InputMaybe<Scalars['String']>;
  defaultValueLte?: InputMaybe<Scalars['String']>;
  defaultValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultValues?: InputMaybe<Scalars['JSON']>;
  defaultValuesAny?: InputMaybe<Scalars['JSON']>;
  defaultValuesContain?: InputMaybe<Scalars['JSON']>;
  defaultValuesEq?: InputMaybe<Scalars['JSON']>;
  defaultValuesGt?: InputMaybe<Scalars['JSON']>;
  defaultValuesGte?: InputMaybe<Scalars['JSON']>;
  defaultValuesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  defaultValuesIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultValuesLike?: InputMaybe<Scalars['JSON']>;
  defaultValuesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  defaultValuesLt?: InputMaybe<Scalars['JSON']>;
  defaultValuesLte?: InputMaybe<Scalars['JSON']>;
  defaultValuesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorMessageAny?: InputMaybe<Scalars['String']>;
  errorMessageContain?: InputMaybe<Scalars['String']>;
  errorMessageEq?: InputMaybe<Scalars['String']>;
  errorMessageGt?: InputMaybe<Scalars['String']>;
  errorMessageGte?: InputMaybe<Scalars['String']>;
  errorMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  errorMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  errorMessageLike?: InputMaybe<Scalars['String']>;
  errorMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  errorMessageLt?: InputMaybe<Scalars['String']>;
  errorMessageLte?: InputMaybe<Scalars['String']>;
  errorMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldId?: InputMaybe<Scalars['Int']>;
  fieldIdAny?: InputMaybe<Scalars['Int']>;
  fieldIdContain?: InputMaybe<Scalars['Int']>;
  fieldIdEq?: InputMaybe<Scalars['Int']>;
  fieldIdGt?: InputMaybe<Scalars['Int']>;
  fieldIdGte?: InputMaybe<Scalars['Int']>;
  fieldIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fieldIdIsNull?: InputMaybe<Scalars['Boolean']>;
  fieldIdLike?: InputMaybe<Scalars['Int']>;
  fieldIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  fieldIdLt?: InputMaybe<Scalars['Int']>;
  fieldIdLte?: InputMaybe<Scalars['Int']>;
  fieldIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fieldType?: InputMaybe<Scalars['String']>;
  fieldTypeAny?: InputMaybe<Scalars['String']>;
  fieldTypeContain?: InputMaybe<Scalars['String']>;
  fieldTypeEq?: InputMaybe<Scalars['String']>;
  fieldTypeGt?: InputMaybe<Scalars['String']>;
  fieldTypeGte?: InputMaybe<Scalars['String']>;
  fieldTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  fieldTypeLike?: InputMaybe<Scalars['String']>;
  fieldTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  fieldTypeLt?: InputMaybe<Scalars['String']>;
  fieldTypeLte?: InputMaybe<Scalars['String']>;
  fieldTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  isRequiredAny?: InputMaybe<Scalars['Boolean']>;
  isRequiredContain?: InputMaybe<Scalars['Boolean']>;
  isRequiredEq?: InputMaybe<Scalars['Boolean']>;
  isRequiredGt?: InputMaybe<Scalars['Boolean']>;
  isRequiredGte?: InputMaybe<Scalars['Boolean']>;
  isRequiredIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isRequiredIsNull?: InputMaybe<Scalars['Boolean']>;
  isRequiredLike?: InputMaybe<Scalars['Boolean']>;
  isRequiredLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isRequiredLt?: InputMaybe<Scalars['Boolean']>;
  isRequiredLte?: InputMaybe<Scalars['Boolean']>;
  isRequiredNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mask?: InputMaybe<Scalars['String']>;
  maskAny?: InputMaybe<Scalars['String']>;
  maskContain?: InputMaybe<Scalars['String']>;
  maskEq?: InputMaybe<Scalars['String']>;
  maskGt?: InputMaybe<Scalars['String']>;
  maskGte?: InputMaybe<Scalars['String']>;
  maskIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maskIsNull?: InputMaybe<Scalars['Boolean']>;
  maskLike?: InputMaybe<Scalars['String']>;
  maskLikeNoCase?: InputMaybe<Scalars['String']>;
  maskLt?: InputMaybe<Scalars['String']>;
  maskLte?: InputMaybe<Scalars['String']>;
  maskNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxValue?: InputMaybe<Scalars['JSON']>;
  maxValueAny?: InputMaybe<Scalars['JSON']>;
  maxValueContain?: InputMaybe<Scalars['JSON']>;
  maxValueEq?: InputMaybe<Scalars['JSON']>;
  maxValueGt?: InputMaybe<Scalars['JSON']>;
  maxValueGte?: InputMaybe<Scalars['JSON']>;
  maxValueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  maxValueIsNull?: InputMaybe<Scalars['Boolean']>;
  maxValueLike?: InputMaybe<Scalars['JSON']>;
  maxValueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  maxValueLt?: InputMaybe<Scalars['JSON']>;
  maxValueLte?: InputMaybe<Scalars['JSON']>;
  maxValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  meta?: InputMaybe<Scalars['JSON']>;
  metaAny?: InputMaybe<Scalars['JSON']>;
  metaContain?: InputMaybe<Scalars['JSON']>;
  metaEq?: InputMaybe<Scalars['JSON']>;
  metaGt?: InputMaybe<Scalars['JSON']>;
  metaGte?: InputMaybe<Scalars['JSON']>;
  metaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  metaIsNull?: InputMaybe<Scalars['Boolean']>;
  metaLike?: InputMaybe<Scalars['JSON']>;
  metaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  metaLt?: InputMaybe<Scalars['JSON']>;
  metaLte?: InputMaybe<Scalars['JSON']>;
  metaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  minValue?: InputMaybe<Scalars['JSON']>;
  minValueAny?: InputMaybe<Scalars['JSON']>;
  minValueContain?: InputMaybe<Scalars['JSON']>;
  minValueEq?: InputMaybe<Scalars['JSON']>;
  minValueGt?: InputMaybe<Scalars['JSON']>;
  minValueGte?: InputMaybe<Scalars['JSON']>;
  minValueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  minValueIsNull?: InputMaybe<Scalars['Boolean']>;
  minValueLike?: InputMaybe<Scalars['JSON']>;
  minValueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  minValueLt?: InputMaybe<Scalars['JSON']>;
  minValueLte?: InputMaybe<Scalars['JSON']>;
  minValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  note?: InputMaybe<Scalars['String']>;
  noteAny?: InputMaybe<Scalars['String']>;
  noteContain?: InputMaybe<Scalars['String']>;
  noteEq?: InputMaybe<Scalars['String']>;
  noteGt?: InputMaybe<Scalars['String']>;
  noteGte?: InputMaybe<Scalars['String']>;
  noteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  noteIsNull?: InputMaybe<Scalars['Boolean']>;
  noteLike?: InputMaybe<Scalars['String']>;
  noteLikeNoCase?: InputMaybe<Scalars['String']>;
  noteLt?: InputMaybe<Scalars['String']>;
  noteLte?: InputMaybe<Scalars['String']>;
  noteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLStepFieldsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLStepFieldsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  pattern?: InputMaybe<Scalars['String']>;
  patternAny?: InputMaybe<Scalars['String']>;
  patternContain?: InputMaybe<Scalars['String']>;
  patternEq?: InputMaybe<Scalars['String']>;
  patternGt?: InputMaybe<Scalars['String']>;
  patternGte?: InputMaybe<Scalars['String']>;
  patternIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  patternIsNull?: InputMaybe<Scalars['Boolean']>;
  patternLike?: InputMaybe<Scalars['String']>;
  patternLikeNoCase?: InputMaybe<Scalars['String']>;
  patternLt?: InputMaybe<Scalars['String']>;
  patternLte?: InputMaybe<Scalars['String']>;
  patternNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeholder?: InputMaybe<Scalars['String']>;
  placeholderAny?: InputMaybe<Scalars['String']>;
  placeholderContain?: InputMaybe<Scalars['String']>;
  placeholderEq?: InputMaybe<Scalars['String']>;
  placeholderGt?: InputMaybe<Scalars['String']>;
  placeholderGte?: InputMaybe<Scalars['String']>;
  placeholderIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeholderIsNull?: InputMaybe<Scalars['Boolean']>;
  placeholderLike?: InputMaybe<Scalars['String']>;
  placeholderLikeNoCase?: InputMaybe<Scalars['String']>;
  placeholderLt?: InputMaybe<Scalars['String']>;
  placeholderLte?: InputMaybe<Scalars['String']>;
  placeholderNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stepId?: InputMaybe<Scalars['Int']>;
  stepIdAny?: InputMaybe<Scalars['Int']>;
  stepIdContain?: InputMaybe<Scalars['Int']>;
  stepIdEq?: InputMaybe<Scalars['Int']>;
  stepIdGt?: InputMaybe<Scalars['Int']>;
  stepIdGte?: InputMaybe<Scalars['Int']>;
  stepIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  stepIdIsNull?: InputMaybe<Scalars['Boolean']>;
  stepIdLike?: InputMaybe<Scalars['Int']>;
  stepIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  stepIdLt?: InputMaybe<Scalars['Int']>;
  stepIdLte?: InputMaybe<Scalars['Int']>;
  stepIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLStepsTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export enum GQLStepsPropertiesEnum {
  AdminTitle = 'adminTitle',
  ButtonText = 'buttonText',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  FormId = 'formId',
  Id = 'id',
  IncludeTcpaMessage = 'includeTCPAMessage',
  IsDeleted = 'isDeleted',
  Order = 'order',
  Title = 'title',
  Tooltip = 'tooltip',
  UpdatedAt = 'updatedAt'
}

export type GQLTags = {
  __typename?: 'Tags';
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['Int']>;
  posts?: Maybe<Array<Maybe<GQLPosts>>>;
  slug?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  url?: Maybe<GQLUrls>;
};


export type GQLTagsPostsArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerpt?: InputMaybe<Scalars['String']>;
  excerptAny?: InputMaybe<Scalars['String']>;
  excerptContain?: InputMaybe<Scalars['String']>;
  excerptEq?: InputMaybe<Scalars['String']>;
  excerptGt?: InputMaybe<Scalars['String']>;
  excerptGte?: InputMaybe<Scalars['String']>;
  excerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerptIsNull?: InputMaybe<Scalars['Boolean']>;
  excerptLike?: InputMaybe<Scalars['String']>;
  excerptLikeNoCase?: InputMaybe<Scalars['String']>;
  excerptLt?: InputMaybe<Scalars['String']>;
  excerptLte?: InputMaybe<Scalars['String']>;
  excerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featured?: InputMaybe<Scalars['Boolean']>;
  featuredAny?: InputMaybe<Scalars['Boolean']>;
  featuredContain?: InputMaybe<Scalars['Boolean']>;
  featuredEq?: InputMaybe<Scalars['Boolean']>;
  featuredGt?: InputMaybe<Scalars['Boolean']>;
  featuredGte?: InputMaybe<Scalars['Boolean']>;
  featuredIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  featuredIsNull?: InputMaybe<Scalars['Boolean']>;
  featuredLike?: InputMaybe<Scalars['Boolean']>;
  featuredLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  featuredLt?: InputMaybe<Scalars['Boolean']>;
  featuredLte?: InputMaybe<Scalars['Boolean']>;
  featuredNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  fullBody?: InputMaybe<Scalars['String']>;
  fullBodyAny?: InputMaybe<Scalars['String']>;
  fullBodyContain?: InputMaybe<Scalars['String']>;
  fullBodyEq?: InputMaybe<Scalars['String']>;
  fullBodyGt?: InputMaybe<Scalars['String']>;
  fullBodyGte?: InputMaybe<Scalars['String']>;
  fullBodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullBodyIsNull?: InputMaybe<Scalars['Boolean']>;
  fullBodyLike?: InputMaybe<Scalars['String']>;
  fullBodyLikeNoCase?: InputMaybe<Scalars['String']>;
  fullBodyLt?: InputMaybe<Scalars['String']>;
  fullBodyLte?: InputMaybe<Scalars['String']>;
  fullBodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldExcerpt?: InputMaybe<Scalars['String']>;
  oldExcerptAny?: InputMaybe<Scalars['String']>;
  oldExcerptContain?: InputMaybe<Scalars['String']>;
  oldExcerptEq?: InputMaybe<Scalars['String']>;
  oldExcerptGt?: InputMaybe<Scalars['String']>;
  oldExcerptGte?: InputMaybe<Scalars['String']>;
  oldExcerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldExcerptIsNull?: InputMaybe<Scalars['Boolean']>;
  oldExcerptLike?: InputMaybe<Scalars['String']>;
  oldExcerptLikeNoCase?: InputMaybe<Scalars['String']>;
  oldExcerptLt?: InputMaybe<Scalars['String']>;
  oldExcerptLte?: InputMaybe<Scalars['String']>;
  oldExcerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLPostsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLPostsPropertiesEnum>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedAny?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['String']>;
  publishedAtAny?: InputMaybe<Scalars['String']>;
  publishedAtContain?: InputMaybe<Scalars['String']>;
  publishedAtEq?: InputMaybe<Scalars['String']>;
  publishedAtGt?: InputMaybe<Scalars['String']>;
  publishedAtGte?: InputMaybe<Scalars['String']>;
  publishedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedAtLike?: InputMaybe<Scalars['String']>;
  publishedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  publishedAtLt?: InputMaybe<Scalars['String']>;
  publishedAtLte?: InputMaybe<Scalars['String']>;
  publishedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedContain?: InputMaybe<Scalars['Boolean']>;
  publishedEq?: InputMaybe<Scalars['Boolean']>;
  publishedGt?: InputMaybe<Scalars['Boolean']>;
  publishedGte?: InputMaybe<Scalars['Boolean']>;
  publishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  publishedIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedLike?: InputMaybe<Scalars['Boolean']>;
  publishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  publishedLt?: InputMaybe<Scalars['Boolean']>;
  publishedLte?: InputMaybe<Scalars['Boolean']>;
  publishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Scalars['Int']>;
  typeIdAny?: InputMaybe<Scalars['Int']>;
  typeIdContain?: InputMaybe<Scalars['Int']>;
  typeIdEq?: InputMaybe<Scalars['Int']>;
  typeIdGt?: InputMaybe<Scalars['Int']>;
  typeIdGte?: InputMaybe<Scalars['Int']>;
  typeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  typeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  typeIdLike?: InputMaybe<Scalars['Int']>;
  typeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  typeIdLt?: InputMaybe<Scalars['Int']>;
  typeIdLte?: InputMaybe<Scalars['Int']>;
  typeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLTagsTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};


export type GQLTagsUrlArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMain?: InputMaybe<Scalars['Boolean']>;
  isMainAny?: InputMaybe<Scalars['Boolean']>;
  isMainContain?: InputMaybe<Scalars['Boolean']>;
  isMainEq?: InputMaybe<Scalars['Boolean']>;
  isMainGt?: InputMaybe<Scalars['Boolean']>;
  isMainGte?: InputMaybe<Scalars['Boolean']>;
  isMainIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMainIsNull?: InputMaybe<Scalars['Boolean']>;
  isMainLike?: InputMaybe<Scalars['Boolean']>;
  isMainLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isMainLt?: InputMaybe<Scalars['Boolean']>;
  isMainLte?: InputMaybe<Scalars['Boolean']>;
  isMainNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  meta?: InputMaybe<Scalars['JSON']>;
  metaAny?: InputMaybe<Scalars['JSON']>;
  metaContain?: InputMaybe<Scalars['JSON']>;
  metaEq?: InputMaybe<Scalars['JSON']>;
  metaGt?: InputMaybe<Scalars['JSON']>;
  metaGte?: InputMaybe<Scalars['JSON']>;
  metaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  metaIsNull?: InputMaybe<Scalars['Boolean']>;
  metaLike?: InputMaybe<Scalars['JSON']>;
  metaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  metaLt?: InputMaybe<Scalars['JSON']>;
  metaLte?: InputMaybe<Scalars['JSON']>;
  metaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  model?: InputMaybe<Scalars['String']>;
  modelAny?: InputMaybe<Scalars['String']>;
  modelContain?: InputMaybe<Scalars['String']>;
  modelEq?: InputMaybe<Scalars['String']>;
  modelGt?: InputMaybe<Scalars['String']>;
  modelGte?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['String']>;
  modelIdAny?: InputMaybe<Scalars['String']>;
  modelIdContain?: InputMaybe<Scalars['String']>;
  modelIdEq?: InputMaybe<Scalars['String']>;
  modelIdGt?: InputMaybe<Scalars['String']>;
  modelIdGte?: InputMaybe<Scalars['String']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['String']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['String']>;
  modelIdLt?: InputMaybe<Scalars['String']>;
  modelIdLte?: InputMaybe<Scalars['String']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIsNull?: InputMaybe<Scalars['Boolean']>;
  modelLike?: InputMaybe<Scalars['String']>;
  modelLikeNoCase?: InputMaybe<Scalars['String']>;
  modelLt?: InputMaybe<Scalars['String']>;
  modelLte?: InputMaybe<Scalars['String']>;
  modelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUrlsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUrlsPropertiesEnum>;
  redirectionStatusCode?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeAny?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeContain?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeEq?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  redirectionStatusCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  redirectionStatusCodeLike?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLikeNoCase?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  urlAny?: InputMaybe<Scalars['String']>;
  urlContain?: InputMaybe<Scalars['String']>;
  urlEq?: InputMaybe<Scalars['String']>;
  urlGt?: InputMaybe<Scalars['String']>;
  urlGte?: InputMaybe<Scalars['String']>;
  urlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlIsNull?: InputMaybe<Scalars['Boolean']>;
  urlLike?: InputMaybe<Scalars['String']>;
  urlLikeNoCase?: InputMaybe<Scalars['String']>;
  urlLt?: InputMaybe<Scalars['String']>;
  urlLte?: InputMaybe<Scalars['String']>;
  urlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLTagsPropertiesEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  Description = 'description',
  Id = 'id',
  IsDeleted = 'isDeleted',
  IsPublished = 'isPublished',
  Name = 'name',
  Order = 'order',
  ParentId = 'parentId',
  Slug = 'slug',
  Source = 'source',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type GQLTaxonomies = {
  __typename?: 'Taxonomies';
  categoryId?: Maybe<Scalars['Int']>;
  children?: Maybe<Array<Maybe<GQLTaxonomies>>>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  creator?: Maybe<GQLUsers>;
  deletedAt?: Maybe<Scalars['String']>;
  deletedBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  domains?: Maybe<Array<Maybe<GQLDomains>>>;
  entities?: Maybe<Array<Maybe<GQLTaxonomiesEntities>>>;
  fields?: Maybe<Array<Maybe<GQLFields>>>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<GQLAttachments>;
  logoId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<GQLTaxonomies>;
  parentId?: Maybe<Scalars['Int']>;
  posts?: Maybe<Array<Maybe<GQLPosts>>>;
  slug?: Maybe<Scalars['String']>;
  targetModel?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updater?: Maybe<GQLUsers>;
  useCase?: Maybe<Scalars['String']>;
};


export type GQLTaxonomiesChildrenArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedByAny?: InputMaybe<Scalars['String']>;
  deletedByContain?: InputMaybe<Scalars['String']>;
  deletedByEq?: InputMaybe<Scalars['String']>;
  deletedByGt?: InputMaybe<Scalars['String']>;
  deletedByGte?: InputMaybe<Scalars['String']>;
  deletedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedByIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedByLike?: InputMaybe<Scalars['String']>;
  deletedByLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedByLt?: InputMaybe<Scalars['String']>;
  deletedByLte?: InputMaybe<Scalars['String']>;
  deletedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTaxonomiesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTaxonomiesPropertiesEnum>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetModel?: InputMaybe<Scalars['String']>;
  targetModelAny?: InputMaybe<Scalars['String']>;
  targetModelContain?: InputMaybe<Scalars['String']>;
  targetModelEq?: InputMaybe<Scalars['String']>;
  targetModelGt?: InputMaybe<Scalars['String']>;
  targetModelGte?: InputMaybe<Scalars['String']>;
  targetModelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetModelIsNull?: InputMaybe<Scalars['Boolean']>;
  targetModelLike?: InputMaybe<Scalars['String']>;
  targetModelLikeNoCase?: InputMaybe<Scalars['String']>;
  targetModelLt?: InputMaybe<Scalars['String']>;
  targetModelLte?: InputMaybe<Scalars['String']>;
  targetModelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCase?: InputMaybe<Scalars['String']>;
  useCaseAny?: InputMaybe<Scalars['String']>;
  useCaseContain?: InputMaybe<Scalars['String']>;
  useCaseEq?: InputMaybe<Scalars['String']>;
  useCaseGt?: InputMaybe<Scalars['String']>;
  useCaseGte?: InputMaybe<Scalars['String']>;
  useCaseIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCaseIsNull?: InputMaybe<Scalars['Boolean']>;
  useCaseLike?: InputMaybe<Scalars['String']>;
  useCaseLikeNoCase?: InputMaybe<Scalars['String']>;
  useCaseLt?: InputMaybe<Scalars['String']>;
  useCaseLte?: InputMaybe<Scalars['String']>;
  useCaseNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLTaxonomiesCreatorArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLTaxonomiesDomainsArgs = {
  allowedLanguages?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesAny?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesContain?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesEq?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  allowedLanguagesIsNull?: InputMaybe<Scalars['Boolean']>;
  allowedLanguagesLike?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  analyticsCodeId?: InputMaybe<Scalars['String']>;
  analyticsCodeIdAny?: InputMaybe<Scalars['String']>;
  analyticsCodeIdContain?: InputMaybe<Scalars['String']>;
  analyticsCodeIdEq?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  analyticsCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  analyticsCodeIdLike?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cacheSettings?: InputMaybe<Scalars['JSON']>;
  cacheSettingsAny?: InputMaybe<Scalars['JSON']>;
  cacheSettingsContain?: InputMaybe<Scalars['JSON']>;
  cacheSettingsEq?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  cacheSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  cacheSettingsLike?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  clickyCodeId?: InputMaybe<Scalars['String']>;
  clickyCodeIdAny?: InputMaybe<Scalars['String']>;
  clickyCodeIdContain?: InputMaybe<Scalars['String']>;
  clickyCodeIdEq?: InputMaybe<Scalars['String']>;
  clickyCodeIdGt?: InputMaybe<Scalars['String']>;
  clickyCodeIdGte?: InputMaybe<Scalars['String']>;
  clickyCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clickyCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  clickyCodeIdLike?: InputMaybe<Scalars['String']>;
  clickyCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  clickyCodeIdLt?: InputMaybe<Scalars['String']>;
  clickyCodeIdLte?: InputMaybe<Scalars['String']>;
  clickyCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  enableChatWidget?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetAny?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetContain?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetEq?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableChatWidgetIsNull?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLike?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaId?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdAny?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdContain?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdEq?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLike?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedForm?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormAny?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormContain?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormEq?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedFormIsNull?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLike?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  facebookConversionAPISettings?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsAny?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsContain?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsEq?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookConversionAPISettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookConversionAPISettingsLike?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookSiteVerificationCode?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fallbackSettings?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsAny?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsContain?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsEq?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  fallbackSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  fallbackSettingsLike?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  faviconId?: InputMaybe<Scalars['String']>;
  faviconIdAny?: InputMaybe<Scalars['String']>;
  faviconIdContain?: InputMaybe<Scalars['String']>;
  faviconIdEq?: InputMaybe<Scalars['String']>;
  faviconIdGt?: InputMaybe<Scalars['String']>;
  faviconIdGte?: InputMaybe<Scalars['String']>;
  faviconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  faviconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  faviconIdLike?: InputMaybe<Scalars['String']>;
  faviconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  faviconIdLt?: InputMaybe<Scalars['String']>;
  faviconIdLte?: InputMaybe<Scalars['String']>;
  faviconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCode?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  googleSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmId?: InputMaybe<Scalars['String']>;
  gtmIdAny?: InputMaybe<Scalars['String']>;
  gtmIdContain?: InputMaybe<Scalars['String']>;
  gtmIdEq?: InputMaybe<Scalars['String']>;
  gtmIdGt?: InputMaybe<Scalars['String']>;
  gtmIdGte?: InputMaybe<Scalars['String']>;
  gtmIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmIdIsNull?: InputMaybe<Scalars['Boolean']>;
  gtmIdLike?: InputMaybe<Scalars['String']>;
  gtmIdLikeNoCase?: InputMaybe<Scalars['String']>;
  gtmIdLt?: InputMaybe<Scalars['String']>;
  gtmIdLte?: InputMaybe<Scalars['String']>;
  gtmIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  holdingRules?: InputMaybe<Scalars['JSON']>;
  holdingRulesAny?: InputMaybe<Scalars['JSON']>;
  holdingRulesContain?: InputMaybe<Scalars['JSON']>;
  holdingRulesEq?: InputMaybe<Scalars['JSON']>;
  holdingRulesGt?: InputMaybe<Scalars['JSON']>;
  holdingRulesGte?: InputMaybe<Scalars['JSON']>;
  holdingRulesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  holdingRulesIsNull?: InputMaybe<Scalars['Boolean']>;
  holdingRulesLike?: InputMaybe<Scalars['JSON']>;
  holdingRulesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  holdingRulesLt?: InputMaybe<Scalars['JSON']>;
  holdingRulesLte?: InputMaybe<Scalars['JSON']>;
  holdingRulesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabled?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledAny?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledContain?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledEq?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabledIsNull?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLike?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainsPropertiesEnum>;
  otpVerificationCriteria?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaAny?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaContain?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaEq?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  otpVerificationCriteriaIsNull?: InputMaybe<Scalars['Boolean']>;
  otpVerificationCriteriaLike?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfig?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigAny?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigContain?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigEq?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  recaptchaConfigLike?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  secondaryLogoId?: InputMaybe<Scalars['String']>;
  secondaryLogoIdAny?: InputMaybe<Scalars['String']>;
  secondaryLogoIdContain?: InputMaybe<Scalars['String']>;
  secondaryLogoIdEq?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondaryLogoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  secondaryLogoIdLike?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sendNotifications?: InputMaybe<Scalars['JSON']>;
  sendNotificationsAny?: InputMaybe<Scalars['JSON']>;
  sendNotificationsContain?: InputMaybe<Scalars['JSON']>;
  sendNotificationsEq?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  sendNotificationsIsNull?: InputMaybe<Scalars['Boolean']>;
  sendNotificationsLike?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settings?: InputMaybe<Scalars['JSON']>;
  settingsAny?: InputMaybe<Scalars['JSON']>;
  settingsContain?: InputMaybe<Scalars['JSON']>;
  settingsEq?: InputMaybe<Scalars['JSON']>;
  settingsGt?: InputMaybe<Scalars['JSON']>;
  settingsGte?: InputMaybe<Scalars['JSON']>;
  settingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settingsIsNull?: InputMaybe<Scalars['Boolean']>;
  settingsLike?: InputMaybe<Scalars['JSON']>;
  settingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  settingsLt?: InputMaybe<Scalars['JSON']>;
  settingsLte?: InputMaybe<Scalars['JSON']>;
  settingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  slogan?: InputMaybe<Scalars['String']>;
  sloganAny?: InputMaybe<Scalars['String']>;
  sloganContain?: InputMaybe<Scalars['String']>;
  sloganEq?: InputMaybe<Scalars['String']>;
  sloganGt?: InputMaybe<Scalars['String']>;
  sloganGte?: InputMaybe<Scalars['String']>;
  sloganIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sloganIsNull?: InputMaybe<Scalars['Boolean']>;
  sloganLike?: InputMaybe<Scalars['String']>;
  sloganLikeNoCase?: InputMaybe<Scalars['String']>;
  sloganLt?: InputMaybe<Scalars['String']>;
  sloganLte?: InputMaybe<Scalars['String']>;
  sloganNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateConfig?: InputMaybe<Scalars['JSON']>;
  templateConfigAny?: InputMaybe<Scalars['JSON']>;
  templateConfigContain?: InputMaybe<Scalars['JSON']>;
  templateConfigEq?: InputMaybe<Scalars['JSON']>;
  templateConfigGt?: InputMaybe<Scalars['JSON']>;
  templateConfigGte?: InputMaybe<Scalars['JSON']>;
  templateConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  templateConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  templateConfigLike?: InputMaybe<Scalars['JSON']>;
  templateConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  templateConfigLt?: InputMaybe<Scalars['JSON']>;
  templateConfigLte?: InputMaybe<Scalars['JSON']>;
  templateConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixel?: InputMaybe<Scalars['String']>;
  twitterPixelAny?: InputMaybe<Scalars['String']>;
  twitterPixelContain?: InputMaybe<Scalars['String']>;
  twitterPixelEq?: InputMaybe<Scalars['String']>;
  twitterPixelGt?: InputMaybe<Scalars['String']>;
  twitterPixelGte?: InputMaybe<Scalars['String']>;
  twitterPixelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixelIsNull?: InputMaybe<Scalars['Boolean']>;
  twitterPixelLike?: InputMaybe<Scalars['String']>;
  twitterPixelLikeNoCase?: InputMaybe<Scalars['String']>;
  twitterPixelLt?: InputMaybe<Scalars['String']>;
  twitterPixelLte?: InputMaybe<Scalars['String']>;
  twitterPixelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLTaxonomiesEntitiesArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  model?: InputMaybe<Scalars['String']>;
  modelAny?: InputMaybe<Scalars['String']>;
  modelContain?: InputMaybe<Scalars['String']>;
  modelEq?: InputMaybe<Scalars['String']>;
  modelGt?: InputMaybe<Scalars['String']>;
  modelGte?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIsNull?: InputMaybe<Scalars['Boolean']>;
  modelLike?: InputMaybe<Scalars['String']>;
  modelLikeNoCase?: InputMaybe<Scalars['String']>;
  modelLt?: InputMaybe<Scalars['String']>;
  modelLte?: InputMaybe<Scalars['String']>;
  modelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTaxonomiesEntitiesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTaxonomiesEntitiesPropertiesEnum>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  sortOrderAny?: InputMaybe<Scalars['Int']>;
  sortOrderContain?: InputMaybe<Scalars['Int']>;
  sortOrderEq?: InputMaybe<Scalars['Int']>;
  sortOrderGt?: InputMaybe<Scalars['Int']>;
  sortOrderGte?: InputMaybe<Scalars['Int']>;
  sortOrderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sortOrderIsNull?: InputMaybe<Scalars['Boolean']>;
  sortOrderLike?: InputMaybe<Scalars['Int']>;
  sortOrderLikeNoCase?: InputMaybe<Scalars['Int']>;
  sortOrderLt?: InputMaybe<Scalars['Int']>;
  sortOrderLte?: InputMaybe<Scalars['Int']>;
  sortOrderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  taxonomyId?: InputMaybe<Scalars['Int']>;
  taxonomyIdAny?: InputMaybe<Scalars['Int']>;
  taxonomyIdContain?: InputMaybe<Scalars['Int']>;
  taxonomyIdEq?: InputMaybe<Scalars['Int']>;
  taxonomyIdGt?: InputMaybe<Scalars['Int']>;
  taxonomyIdGte?: InputMaybe<Scalars['Int']>;
  taxonomyIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  taxonomyIdIsNull?: InputMaybe<Scalars['Boolean']>;
  taxonomyIdLike?: InputMaybe<Scalars['Int']>;
  taxonomyIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  taxonomyIdLt?: InputMaybe<Scalars['Int']>;
  taxonomyIdLte?: InputMaybe<Scalars['Int']>;
  taxonomyIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLTaxonomiesFieldsArgs = {
  autocomplete?: InputMaybe<Scalars['String']>;
  autocompleteAny?: InputMaybe<Scalars['String']>;
  autocompleteContain?: InputMaybe<Scalars['String']>;
  autocompleteEq?: InputMaybe<Scalars['String']>;
  autocompleteGt?: InputMaybe<Scalars['String']>;
  autocompleteGte?: InputMaybe<Scalars['String']>;
  autocompleteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autocompleteIsNull?: InputMaybe<Scalars['Boolean']>;
  autocompleteLike?: InputMaybe<Scalars['String']>;
  autocompleteLikeNoCase?: InputMaybe<Scalars['String']>;
  autocompleteLt?: InputMaybe<Scalars['String']>;
  autocompleteLte?: InputMaybe<Scalars['String']>;
  autocompleteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  codeName?: InputMaybe<Scalars['String']>;
  codeNameAny?: InputMaybe<Scalars['String']>;
  codeNameContain?: InputMaybe<Scalars['String']>;
  codeNameEq?: InputMaybe<Scalars['String']>;
  codeNameGt?: InputMaybe<Scalars['String']>;
  codeNameGte?: InputMaybe<Scalars['String']>;
  codeNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  codeNameIsNull?: InputMaybe<Scalars['Boolean']>;
  codeNameLike?: InputMaybe<Scalars['String']>;
  codeNameLikeNoCase?: InputMaybe<Scalars['String']>;
  codeNameLt?: InputMaybe<Scalars['String']>;
  codeNameLte?: InputMaybe<Scalars['String']>;
  codeNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dataDependency?: InputMaybe<Scalars['JSON']>;
  dataDependencyAny?: InputMaybe<Scalars['JSON']>;
  dataDependencyContain?: InputMaybe<Scalars['JSON']>;
  dataDependencyEq?: InputMaybe<Scalars['JSON']>;
  dataDependencyGt?: InputMaybe<Scalars['JSON']>;
  dataDependencyGte?: InputMaybe<Scalars['JSON']>;
  dataDependencyIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  dataDependencyIsNull?: InputMaybe<Scalars['Boolean']>;
  dataDependencyLike?: InputMaybe<Scalars['JSON']>;
  dataDependencyLikeNoCase?: InputMaybe<Scalars['JSON']>;
  dataDependencyLt?: InputMaybe<Scalars['JSON']>;
  dataDependencyLte?: InputMaybe<Scalars['JSON']>;
  dataDependencyNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  defaultValue?: InputMaybe<Scalars['String']>;
  defaultValueAny?: InputMaybe<Scalars['String']>;
  defaultValueContain?: InputMaybe<Scalars['String']>;
  defaultValueEq?: InputMaybe<Scalars['String']>;
  defaultValueGt?: InputMaybe<Scalars['String']>;
  defaultValueGte?: InputMaybe<Scalars['String']>;
  defaultValueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultValueIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultValueLike?: InputMaybe<Scalars['String']>;
  defaultValueLikeNoCase?: InputMaybe<Scalars['String']>;
  defaultValueLt?: InputMaybe<Scalars['String']>;
  defaultValueLte?: InputMaybe<Scalars['String']>;
  defaultValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultValues?: InputMaybe<Scalars['JSON']>;
  defaultValuesAny?: InputMaybe<Scalars['JSON']>;
  defaultValuesContain?: InputMaybe<Scalars['JSON']>;
  defaultValuesEq?: InputMaybe<Scalars['JSON']>;
  defaultValuesGt?: InputMaybe<Scalars['JSON']>;
  defaultValuesGte?: InputMaybe<Scalars['JSON']>;
  defaultValuesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  defaultValuesIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultValuesLike?: InputMaybe<Scalars['JSON']>;
  defaultValuesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  defaultValuesLt?: InputMaybe<Scalars['JSON']>;
  defaultValuesLte?: InputMaybe<Scalars['JSON']>;
  defaultValuesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorMessageAny?: InputMaybe<Scalars['String']>;
  errorMessageContain?: InputMaybe<Scalars['String']>;
  errorMessageEq?: InputMaybe<Scalars['String']>;
  errorMessageGt?: InputMaybe<Scalars['String']>;
  errorMessageGte?: InputMaybe<Scalars['String']>;
  errorMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  errorMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  errorMessageLike?: InputMaybe<Scalars['String']>;
  errorMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  errorMessageLt?: InputMaybe<Scalars['String']>;
  errorMessageLte?: InputMaybe<Scalars['String']>;
  errorMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldType?: InputMaybe<Scalars['String']>;
  fieldTypeAny?: InputMaybe<Scalars['String']>;
  fieldTypeContain?: InputMaybe<Scalars['String']>;
  fieldTypeEq?: InputMaybe<Scalars['String']>;
  fieldTypeGt?: InputMaybe<Scalars['String']>;
  fieldTypeGte?: InputMaybe<Scalars['String']>;
  fieldTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  fieldTypeLike?: InputMaybe<Scalars['String']>;
  fieldTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  fieldTypeLt?: InputMaybe<Scalars['String']>;
  fieldTypeLte?: InputMaybe<Scalars['String']>;
  fieldTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  formId?: InputMaybe<Scalars['Int']>;
  formIdAny?: InputMaybe<Scalars['Int']>;
  formIdContain?: InputMaybe<Scalars['Int']>;
  formIdEq?: InputMaybe<Scalars['Int']>;
  formIdGt?: InputMaybe<Scalars['Int']>;
  formIdGte?: InputMaybe<Scalars['Int']>;
  formIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formIdIsNull?: InputMaybe<Scalars['Boolean']>;
  formIdLike?: InputMaybe<Scalars['Int']>;
  formIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  formIdLt?: InputMaybe<Scalars['Int']>;
  formIdLte?: InputMaybe<Scalars['Int']>;
  formIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  isGlobalAny?: InputMaybe<Scalars['Boolean']>;
  isGlobalContain?: InputMaybe<Scalars['Boolean']>;
  isGlobalEq?: InputMaybe<Scalars['Boolean']>;
  isGlobalGt?: InputMaybe<Scalars['Boolean']>;
  isGlobalGte?: InputMaybe<Scalars['Boolean']>;
  isGlobalIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isGlobalIsNull?: InputMaybe<Scalars['Boolean']>;
  isGlobalLike?: InputMaybe<Scalars['Boolean']>;
  isGlobalLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isGlobalLt?: InputMaybe<Scalars['Boolean']>;
  isGlobalLte?: InputMaybe<Scalars['Boolean']>;
  isGlobalNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mask?: InputMaybe<Scalars['String']>;
  maskAny?: InputMaybe<Scalars['String']>;
  maskContain?: InputMaybe<Scalars['String']>;
  maskEq?: InputMaybe<Scalars['String']>;
  maskGt?: InputMaybe<Scalars['String']>;
  maskGte?: InputMaybe<Scalars['String']>;
  maskIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maskIsNull?: InputMaybe<Scalars['Boolean']>;
  maskLike?: InputMaybe<Scalars['String']>;
  maskLikeNoCase?: InputMaybe<Scalars['String']>;
  maskLt?: InputMaybe<Scalars['String']>;
  maskLte?: InputMaybe<Scalars['String']>;
  maskNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxValue?: InputMaybe<Scalars['JSON']>;
  maxValueAny?: InputMaybe<Scalars['JSON']>;
  maxValueContain?: InputMaybe<Scalars['JSON']>;
  maxValueEq?: InputMaybe<Scalars['JSON']>;
  maxValueGt?: InputMaybe<Scalars['JSON']>;
  maxValueGte?: InputMaybe<Scalars['JSON']>;
  maxValueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  maxValueIsNull?: InputMaybe<Scalars['Boolean']>;
  maxValueLike?: InputMaybe<Scalars['JSON']>;
  maxValueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  maxValueLt?: InputMaybe<Scalars['JSON']>;
  maxValueLte?: InputMaybe<Scalars['JSON']>;
  maxValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  meta?: InputMaybe<Scalars['JSON']>;
  metaAny?: InputMaybe<Scalars['JSON']>;
  metaContain?: InputMaybe<Scalars['JSON']>;
  metaEq?: InputMaybe<Scalars['JSON']>;
  metaGt?: InputMaybe<Scalars['JSON']>;
  metaGte?: InputMaybe<Scalars['JSON']>;
  metaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  metaIsNull?: InputMaybe<Scalars['Boolean']>;
  metaLike?: InputMaybe<Scalars['JSON']>;
  metaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  metaLt?: InputMaybe<Scalars['JSON']>;
  metaLte?: InputMaybe<Scalars['JSON']>;
  metaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  minValue?: InputMaybe<Scalars['JSON']>;
  minValueAny?: InputMaybe<Scalars['JSON']>;
  minValueContain?: InputMaybe<Scalars['JSON']>;
  minValueEq?: InputMaybe<Scalars['JSON']>;
  minValueGt?: InputMaybe<Scalars['JSON']>;
  minValueGte?: InputMaybe<Scalars['JSON']>;
  minValueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  minValueIsNull?: InputMaybe<Scalars['Boolean']>;
  minValueLike?: InputMaybe<Scalars['JSON']>;
  minValueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  minValueLt?: InputMaybe<Scalars['JSON']>;
  minValueLte?: InputMaybe<Scalars['JSON']>;
  minValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  modifiedAt?: InputMaybe<Scalars['String']>;
  modifiedAtAny?: InputMaybe<Scalars['String']>;
  modifiedAtContain?: InputMaybe<Scalars['String']>;
  modifiedAtEq?: InputMaybe<Scalars['String']>;
  modifiedAtGt?: InputMaybe<Scalars['String']>;
  modifiedAtGte?: InputMaybe<Scalars['String']>;
  modifiedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedAtLike?: InputMaybe<Scalars['String']>;
  modifiedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedAtLt?: InputMaybe<Scalars['String']>;
  modifiedAtLte?: InputMaybe<Scalars['String']>;
  modifiedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  note?: InputMaybe<Scalars['String']>;
  noteAny?: InputMaybe<Scalars['String']>;
  noteContain?: InputMaybe<Scalars['String']>;
  noteEq?: InputMaybe<Scalars['String']>;
  noteGt?: InputMaybe<Scalars['String']>;
  noteGte?: InputMaybe<Scalars['String']>;
  noteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  noteIsNull?: InputMaybe<Scalars['Boolean']>;
  noteLike?: InputMaybe<Scalars['String']>;
  noteLikeNoCase?: InputMaybe<Scalars['String']>;
  noteLt?: InputMaybe<Scalars['String']>;
  noteLte?: InputMaybe<Scalars['String']>;
  noteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLFieldsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLFieldsPropertiesEnum>;
  pattern?: InputMaybe<Scalars['String']>;
  patternAny?: InputMaybe<Scalars['String']>;
  patternContain?: InputMaybe<Scalars['String']>;
  patternEq?: InputMaybe<Scalars['String']>;
  patternGt?: InputMaybe<Scalars['String']>;
  patternGte?: InputMaybe<Scalars['String']>;
  patternIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  patternIsNull?: InputMaybe<Scalars['Boolean']>;
  patternLike?: InputMaybe<Scalars['String']>;
  patternLikeNoCase?: InputMaybe<Scalars['String']>;
  patternLt?: InputMaybe<Scalars['String']>;
  patternLte?: InputMaybe<Scalars['String']>;
  patternNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeholder?: InputMaybe<Scalars['String']>;
  placeholderAny?: InputMaybe<Scalars['String']>;
  placeholderContain?: InputMaybe<Scalars['String']>;
  placeholderEq?: InputMaybe<Scalars['String']>;
  placeholderGt?: InputMaybe<Scalars['String']>;
  placeholderGte?: InputMaybe<Scalars['String']>;
  placeholderIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeholderIsNull?: InputMaybe<Scalars['Boolean']>;
  placeholderLike?: InputMaybe<Scalars['String']>;
  placeholderLikeNoCase?: InputMaybe<Scalars['String']>;
  placeholderLt?: InputMaybe<Scalars['String']>;
  placeholderLte?: InputMaybe<Scalars['String']>;
  placeholderNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCase?: InputMaybe<Scalars['String']>;
  useCaseAny?: InputMaybe<Scalars['String']>;
  useCaseContain?: InputMaybe<Scalars['String']>;
  useCaseEq?: InputMaybe<Scalars['String']>;
  useCaseGt?: InputMaybe<Scalars['String']>;
  useCaseGte?: InputMaybe<Scalars['String']>;
  useCaseIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCaseIsNull?: InputMaybe<Scalars['Boolean']>;
  useCaseLike?: InputMaybe<Scalars['String']>;
  useCaseLikeNoCase?: InputMaybe<Scalars['String']>;
  useCaseLt?: InputMaybe<Scalars['String']>;
  useCaseLte?: InputMaybe<Scalars['String']>;
  useCaseNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  validationType?: InputMaybe<Scalars['String']>;
  validationTypeAny?: InputMaybe<Scalars['String']>;
  validationTypeContain?: InputMaybe<Scalars['String']>;
  validationTypeEq?: InputMaybe<Scalars['String']>;
  validationTypeGt?: InputMaybe<Scalars['String']>;
  validationTypeGte?: InputMaybe<Scalars['String']>;
  validationTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  validationTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  validationTypeLike?: InputMaybe<Scalars['String']>;
  validationTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  validationTypeLt?: InputMaybe<Scalars['String']>;
  validationTypeLte?: InputMaybe<Scalars['String']>;
  validationTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLTaxonomiesLogoArgs = {
  access?: InputMaybe<Scalars['String']>;
  accessAny?: InputMaybe<Scalars['String']>;
  accessContain?: InputMaybe<Scalars['String']>;
  accessEq?: InputMaybe<Scalars['String']>;
  accessGt?: InputMaybe<Scalars['String']>;
  accessGte?: InputMaybe<Scalars['String']>;
  accessIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accessIsNull?: InputMaybe<Scalars['Boolean']>;
  accessLike?: InputMaybe<Scalars['String']>;
  accessLikeNoCase?: InputMaybe<Scalars['String']>;
  accessLt?: InputMaybe<Scalars['String']>;
  accessLte?: InputMaybe<Scalars['String']>;
  accessNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alt?: InputMaybe<Scalars['String']>;
  altAny?: InputMaybe<Scalars['String']>;
  altContain?: InputMaybe<Scalars['String']>;
  altEq?: InputMaybe<Scalars['String']>;
  altGt?: InputMaybe<Scalars['String']>;
  altGte?: InputMaybe<Scalars['String']>;
  altIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  altIsNull?: InputMaybe<Scalars['Boolean']>;
  altLike?: InputMaybe<Scalars['String']>;
  altLikeNoCase?: InputMaybe<Scalars['String']>;
  altLt?: InputMaybe<Scalars['String']>;
  altLte?: InputMaybe<Scalars['String']>;
  altNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caption?: InputMaybe<Scalars['String']>;
  captionAny?: InputMaybe<Scalars['String']>;
  captionContain?: InputMaybe<Scalars['String']>;
  captionEq?: InputMaybe<Scalars['String']>;
  captionGt?: InputMaybe<Scalars['String']>;
  captionGte?: InputMaybe<Scalars['String']>;
  captionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  captionIsNull?: InputMaybe<Scalars['Boolean']>;
  captionLike?: InputMaybe<Scalars['String']>;
  captionLikeNoCase?: InputMaybe<Scalars['String']>;
  captionLt?: InputMaybe<Scalars['String']>;
  captionLte?: InputMaybe<Scalars['String']>;
  captionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fullPath?: InputMaybe<Scalars['String']>;
  fullPathAny?: InputMaybe<Scalars['String']>;
  fullPathContain?: InputMaybe<Scalars['String']>;
  fullPathEq?: InputMaybe<Scalars['String']>;
  fullPathGt?: InputMaybe<Scalars['String']>;
  fullPathGte?: InputMaybe<Scalars['String']>;
  fullPathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullPathIsNull?: InputMaybe<Scalars['Boolean']>;
  fullPathLike?: InputMaybe<Scalars['String']>;
  fullPathLikeNoCase?: InputMaybe<Scalars['String']>;
  fullPathLt?: InputMaybe<Scalars['String']>;
  fullPathLte?: InputMaybe<Scalars['String']>;
  fullPathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mimeType?: InputMaybe<Scalars['String']>;
  mimeTypeAny?: InputMaybe<Scalars['String']>;
  mimeTypeContain?: InputMaybe<Scalars['String']>;
  mimeTypeEq?: InputMaybe<Scalars['String']>;
  mimeTypeGt?: InputMaybe<Scalars['String']>;
  mimeTypeGte?: InputMaybe<Scalars['String']>;
  mimeTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mimeTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  mimeTypeLike?: InputMaybe<Scalars['String']>;
  mimeTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  mimeTypeLt?: InputMaybe<Scalars['String']>;
  mimeTypeLte?: InputMaybe<Scalars['String']>;
  mimeTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  originalName?: InputMaybe<Scalars['String']>;
  originalNameAny?: InputMaybe<Scalars['String']>;
  originalNameContain?: InputMaybe<Scalars['String']>;
  originalNameEq?: InputMaybe<Scalars['String']>;
  originalNameGt?: InputMaybe<Scalars['String']>;
  originalNameGte?: InputMaybe<Scalars['String']>;
  originalNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  originalNameIsNull?: InputMaybe<Scalars['Boolean']>;
  originalNameLike?: InputMaybe<Scalars['String']>;
  originalNameLikeNoCase?: InputMaybe<Scalars['String']>;
  originalNameLt?: InputMaybe<Scalars['String']>;
  originalNameLte?: InputMaybe<Scalars['String']>;
  originalNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  path?: InputMaybe<Scalars['String']>;
  pathAny?: InputMaybe<Scalars['String']>;
  pathContain?: InputMaybe<Scalars['String']>;
  pathEq?: InputMaybe<Scalars['String']>;
  pathGt?: InputMaybe<Scalars['String']>;
  pathGte?: InputMaybe<Scalars['String']>;
  pathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pathIsNull?: InputMaybe<Scalars['Boolean']>;
  pathLike?: InputMaybe<Scalars['String']>;
  pathLikeNoCase?: InputMaybe<Scalars['String']>;
  pathLt?: InputMaybe<Scalars['String']>;
  pathLte?: InputMaybe<Scalars['String']>;
  pathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  size?: InputMaybe<Scalars['Int']>;
  sizeAny?: InputMaybe<Scalars['Int']>;
  sizeContain?: InputMaybe<Scalars['Int']>;
  sizeEq?: InputMaybe<Scalars['Int']>;
  sizeGt?: InputMaybe<Scalars['Int']>;
  sizeGte?: InputMaybe<Scalars['Int']>;
  sizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sizeLike?: InputMaybe<Scalars['Int']>;
  sizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sizeLt?: InputMaybe<Scalars['Int']>;
  sizeLte?: InputMaybe<Scalars['Int']>;
  sizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLTaxonomiesParentArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedByAny?: InputMaybe<Scalars['String']>;
  deletedByContain?: InputMaybe<Scalars['String']>;
  deletedByEq?: InputMaybe<Scalars['String']>;
  deletedByGt?: InputMaybe<Scalars['String']>;
  deletedByGte?: InputMaybe<Scalars['String']>;
  deletedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedByIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedByLike?: InputMaybe<Scalars['String']>;
  deletedByLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedByLt?: InputMaybe<Scalars['String']>;
  deletedByLte?: InputMaybe<Scalars['String']>;
  deletedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTaxonomiesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTaxonomiesPropertiesEnum>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetModel?: InputMaybe<Scalars['String']>;
  targetModelAny?: InputMaybe<Scalars['String']>;
  targetModelContain?: InputMaybe<Scalars['String']>;
  targetModelEq?: InputMaybe<Scalars['String']>;
  targetModelGt?: InputMaybe<Scalars['String']>;
  targetModelGte?: InputMaybe<Scalars['String']>;
  targetModelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetModelIsNull?: InputMaybe<Scalars['Boolean']>;
  targetModelLike?: InputMaybe<Scalars['String']>;
  targetModelLikeNoCase?: InputMaybe<Scalars['String']>;
  targetModelLt?: InputMaybe<Scalars['String']>;
  targetModelLte?: InputMaybe<Scalars['String']>;
  targetModelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCase?: InputMaybe<Scalars['String']>;
  useCaseAny?: InputMaybe<Scalars['String']>;
  useCaseContain?: InputMaybe<Scalars['String']>;
  useCaseEq?: InputMaybe<Scalars['String']>;
  useCaseGt?: InputMaybe<Scalars['String']>;
  useCaseGte?: InputMaybe<Scalars['String']>;
  useCaseIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCaseIsNull?: InputMaybe<Scalars['Boolean']>;
  useCaseLike?: InputMaybe<Scalars['String']>;
  useCaseLikeNoCase?: InputMaybe<Scalars['String']>;
  useCaseLt?: InputMaybe<Scalars['String']>;
  useCaseLte?: InputMaybe<Scalars['String']>;
  useCaseNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLTaxonomiesPostsArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerpt?: InputMaybe<Scalars['String']>;
  excerptAny?: InputMaybe<Scalars['String']>;
  excerptContain?: InputMaybe<Scalars['String']>;
  excerptEq?: InputMaybe<Scalars['String']>;
  excerptGt?: InputMaybe<Scalars['String']>;
  excerptGte?: InputMaybe<Scalars['String']>;
  excerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerptIsNull?: InputMaybe<Scalars['Boolean']>;
  excerptLike?: InputMaybe<Scalars['String']>;
  excerptLikeNoCase?: InputMaybe<Scalars['String']>;
  excerptLt?: InputMaybe<Scalars['String']>;
  excerptLte?: InputMaybe<Scalars['String']>;
  excerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featured?: InputMaybe<Scalars['Boolean']>;
  featuredAny?: InputMaybe<Scalars['Boolean']>;
  featuredContain?: InputMaybe<Scalars['Boolean']>;
  featuredEq?: InputMaybe<Scalars['Boolean']>;
  featuredGt?: InputMaybe<Scalars['Boolean']>;
  featuredGte?: InputMaybe<Scalars['Boolean']>;
  featuredIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  featuredIsNull?: InputMaybe<Scalars['Boolean']>;
  featuredLike?: InputMaybe<Scalars['Boolean']>;
  featuredLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  featuredLt?: InputMaybe<Scalars['Boolean']>;
  featuredLte?: InputMaybe<Scalars['Boolean']>;
  featuredNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  fullBody?: InputMaybe<Scalars['String']>;
  fullBodyAny?: InputMaybe<Scalars['String']>;
  fullBodyContain?: InputMaybe<Scalars['String']>;
  fullBodyEq?: InputMaybe<Scalars['String']>;
  fullBodyGt?: InputMaybe<Scalars['String']>;
  fullBodyGte?: InputMaybe<Scalars['String']>;
  fullBodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullBodyIsNull?: InputMaybe<Scalars['Boolean']>;
  fullBodyLike?: InputMaybe<Scalars['String']>;
  fullBodyLikeNoCase?: InputMaybe<Scalars['String']>;
  fullBodyLt?: InputMaybe<Scalars['String']>;
  fullBodyLte?: InputMaybe<Scalars['String']>;
  fullBodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldExcerpt?: InputMaybe<Scalars['String']>;
  oldExcerptAny?: InputMaybe<Scalars['String']>;
  oldExcerptContain?: InputMaybe<Scalars['String']>;
  oldExcerptEq?: InputMaybe<Scalars['String']>;
  oldExcerptGt?: InputMaybe<Scalars['String']>;
  oldExcerptGte?: InputMaybe<Scalars['String']>;
  oldExcerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldExcerptIsNull?: InputMaybe<Scalars['Boolean']>;
  oldExcerptLike?: InputMaybe<Scalars['String']>;
  oldExcerptLikeNoCase?: InputMaybe<Scalars['String']>;
  oldExcerptLt?: InputMaybe<Scalars['String']>;
  oldExcerptLte?: InputMaybe<Scalars['String']>;
  oldExcerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLPostsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLPostsPropertiesEnum>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedAny?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['String']>;
  publishedAtAny?: InputMaybe<Scalars['String']>;
  publishedAtContain?: InputMaybe<Scalars['String']>;
  publishedAtEq?: InputMaybe<Scalars['String']>;
  publishedAtGt?: InputMaybe<Scalars['String']>;
  publishedAtGte?: InputMaybe<Scalars['String']>;
  publishedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedAtLike?: InputMaybe<Scalars['String']>;
  publishedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  publishedAtLt?: InputMaybe<Scalars['String']>;
  publishedAtLte?: InputMaybe<Scalars['String']>;
  publishedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedContain?: InputMaybe<Scalars['Boolean']>;
  publishedEq?: InputMaybe<Scalars['Boolean']>;
  publishedGt?: InputMaybe<Scalars['Boolean']>;
  publishedGte?: InputMaybe<Scalars['Boolean']>;
  publishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  publishedIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedLike?: InputMaybe<Scalars['Boolean']>;
  publishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  publishedLt?: InputMaybe<Scalars['Boolean']>;
  publishedLte?: InputMaybe<Scalars['Boolean']>;
  publishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Scalars['Int']>;
  typeIdAny?: InputMaybe<Scalars['Int']>;
  typeIdContain?: InputMaybe<Scalars['Int']>;
  typeIdEq?: InputMaybe<Scalars['Int']>;
  typeIdGt?: InputMaybe<Scalars['Int']>;
  typeIdGte?: InputMaybe<Scalars['Int']>;
  typeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  typeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  typeIdLike?: InputMaybe<Scalars['Int']>;
  typeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  typeIdLt?: InputMaybe<Scalars['Int']>;
  typeIdLte?: InputMaybe<Scalars['Int']>;
  typeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLTaxonomiesUpdaterArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GQLTaxonomiesEntities = {
  __typename?: 'TaxonomiesEntities';
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['Int']>;
  sortOrder?: Maybe<Scalars['Int']>;
  taxonomyField?: Maybe<GQLFields>;
  taxonomyId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['String']>;
};


export type GQLTaxonomiesEntitiesTaxonomyFieldArgs = {
  autocomplete?: InputMaybe<Scalars['String']>;
  autocompleteAny?: InputMaybe<Scalars['String']>;
  autocompleteContain?: InputMaybe<Scalars['String']>;
  autocompleteEq?: InputMaybe<Scalars['String']>;
  autocompleteGt?: InputMaybe<Scalars['String']>;
  autocompleteGte?: InputMaybe<Scalars['String']>;
  autocompleteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autocompleteIsNull?: InputMaybe<Scalars['Boolean']>;
  autocompleteLike?: InputMaybe<Scalars['String']>;
  autocompleteLikeNoCase?: InputMaybe<Scalars['String']>;
  autocompleteLt?: InputMaybe<Scalars['String']>;
  autocompleteLte?: InputMaybe<Scalars['String']>;
  autocompleteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  codeName?: InputMaybe<Scalars['String']>;
  codeNameAny?: InputMaybe<Scalars['String']>;
  codeNameContain?: InputMaybe<Scalars['String']>;
  codeNameEq?: InputMaybe<Scalars['String']>;
  codeNameGt?: InputMaybe<Scalars['String']>;
  codeNameGte?: InputMaybe<Scalars['String']>;
  codeNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  codeNameIsNull?: InputMaybe<Scalars['Boolean']>;
  codeNameLike?: InputMaybe<Scalars['String']>;
  codeNameLikeNoCase?: InputMaybe<Scalars['String']>;
  codeNameLt?: InputMaybe<Scalars['String']>;
  codeNameLte?: InputMaybe<Scalars['String']>;
  codeNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dataDependency?: InputMaybe<Scalars['JSON']>;
  dataDependencyAny?: InputMaybe<Scalars['JSON']>;
  dataDependencyContain?: InputMaybe<Scalars['JSON']>;
  dataDependencyEq?: InputMaybe<Scalars['JSON']>;
  dataDependencyGt?: InputMaybe<Scalars['JSON']>;
  dataDependencyGte?: InputMaybe<Scalars['JSON']>;
  dataDependencyIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  dataDependencyIsNull?: InputMaybe<Scalars['Boolean']>;
  dataDependencyLike?: InputMaybe<Scalars['JSON']>;
  dataDependencyLikeNoCase?: InputMaybe<Scalars['JSON']>;
  dataDependencyLt?: InputMaybe<Scalars['JSON']>;
  dataDependencyLte?: InputMaybe<Scalars['JSON']>;
  dataDependencyNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  defaultValue?: InputMaybe<Scalars['String']>;
  defaultValueAny?: InputMaybe<Scalars['String']>;
  defaultValueContain?: InputMaybe<Scalars['String']>;
  defaultValueEq?: InputMaybe<Scalars['String']>;
  defaultValueGt?: InputMaybe<Scalars['String']>;
  defaultValueGte?: InputMaybe<Scalars['String']>;
  defaultValueIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultValueIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultValueLike?: InputMaybe<Scalars['String']>;
  defaultValueLikeNoCase?: InputMaybe<Scalars['String']>;
  defaultValueLt?: InputMaybe<Scalars['String']>;
  defaultValueLte?: InputMaybe<Scalars['String']>;
  defaultValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultValues?: InputMaybe<Scalars['JSON']>;
  defaultValuesAny?: InputMaybe<Scalars['JSON']>;
  defaultValuesContain?: InputMaybe<Scalars['JSON']>;
  defaultValuesEq?: InputMaybe<Scalars['JSON']>;
  defaultValuesGt?: InputMaybe<Scalars['JSON']>;
  defaultValuesGte?: InputMaybe<Scalars['JSON']>;
  defaultValuesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  defaultValuesIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultValuesLike?: InputMaybe<Scalars['JSON']>;
  defaultValuesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  defaultValuesLt?: InputMaybe<Scalars['JSON']>;
  defaultValuesLte?: InputMaybe<Scalars['JSON']>;
  defaultValuesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorMessageAny?: InputMaybe<Scalars['String']>;
  errorMessageContain?: InputMaybe<Scalars['String']>;
  errorMessageEq?: InputMaybe<Scalars['String']>;
  errorMessageGt?: InputMaybe<Scalars['String']>;
  errorMessageGte?: InputMaybe<Scalars['String']>;
  errorMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  errorMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  errorMessageLike?: InputMaybe<Scalars['String']>;
  errorMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  errorMessageLt?: InputMaybe<Scalars['String']>;
  errorMessageLte?: InputMaybe<Scalars['String']>;
  errorMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldType?: InputMaybe<Scalars['String']>;
  fieldTypeAny?: InputMaybe<Scalars['String']>;
  fieldTypeContain?: InputMaybe<Scalars['String']>;
  fieldTypeEq?: InputMaybe<Scalars['String']>;
  fieldTypeGt?: InputMaybe<Scalars['String']>;
  fieldTypeGte?: InputMaybe<Scalars['String']>;
  fieldTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  fieldTypeLike?: InputMaybe<Scalars['String']>;
  fieldTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  fieldTypeLt?: InputMaybe<Scalars['String']>;
  fieldTypeLte?: InputMaybe<Scalars['String']>;
  fieldTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  formId?: InputMaybe<Scalars['Int']>;
  formIdAny?: InputMaybe<Scalars['Int']>;
  formIdContain?: InputMaybe<Scalars['Int']>;
  formIdEq?: InputMaybe<Scalars['Int']>;
  formIdGt?: InputMaybe<Scalars['Int']>;
  formIdGte?: InputMaybe<Scalars['Int']>;
  formIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formIdIsNull?: InputMaybe<Scalars['Boolean']>;
  formIdLike?: InputMaybe<Scalars['Int']>;
  formIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  formIdLt?: InputMaybe<Scalars['Int']>;
  formIdLte?: InputMaybe<Scalars['Int']>;
  formIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  isGlobalAny?: InputMaybe<Scalars['Boolean']>;
  isGlobalContain?: InputMaybe<Scalars['Boolean']>;
  isGlobalEq?: InputMaybe<Scalars['Boolean']>;
  isGlobalGt?: InputMaybe<Scalars['Boolean']>;
  isGlobalGte?: InputMaybe<Scalars['Boolean']>;
  isGlobalIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isGlobalIsNull?: InputMaybe<Scalars['Boolean']>;
  isGlobalLike?: InputMaybe<Scalars['Boolean']>;
  isGlobalLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isGlobalLt?: InputMaybe<Scalars['Boolean']>;
  isGlobalLte?: InputMaybe<Scalars['Boolean']>;
  isGlobalNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mask?: InputMaybe<Scalars['String']>;
  maskAny?: InputMaybe<Scalars['String']>;
  maskContain?: InputMaybe<Scalars['String']>;
  maskEq?: InputMaybe<Scalars['String']>;
  maskGt?: InputMaybe<Scalars['String']>;
  maskGte?: InputMaybe<Scalars['String']>;
  maskIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maskIsNull?: InputMaybe<Scalars['Boolean']>;
  maskLike?: InputMaybe<Scalars['String']>;
  maskLikeNoCase?: InputMaybe<Scalars['String']>;
  maskLt?: InputMaybe<Scalars['String']>;
  maskLte?: InputMaybe<Scalars['String']>;
  maskNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxValue?: InputMaybe<Scalars['JSON']>;
  maxValueAny?: InputMaybe<Scalars['JSON']>;
  maxValueContain?: InputMaybe<Scalars['JSON']>;
  maxValueEq?: InputMaybe<Scalars['JSON']>;
  maxValueGt?: InputMaybe<Scalars['JSON']>;
  maxValueGte?: InputMaybe<Scalars['JSON']>;
  maxValueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  maxValueIsNull?: InputMaybe<Scalars['Boolean']>;
  maxValueLike?: InputMaybe<Scalars['JSON']>;
  maxValueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  maxValueLt?: InputMaybe<Scalars['JSON']>;
  maxValueLte?: InputMaybe<Scalars['JSON']>;
  maxValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  meta?: InputMaybe<Scalars['JSON']>;
  metaAny?: InputMaybe<Scalars['JSON']>;
  metaContain?: InputMaybe<Scalars['JSON']>;
  metaEq?: InputMaybe<Scalars['JSON']>;
  metaGt?: InputMaybe<Scalars['JSON']>;
  metaGte?: InputMaybe<Scalars['JSON']>;
  metaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  metaIsNull?: InputMaybe<Scalars['Boolean']>;
  metaLike?: InputMaybe<Scalars['JSON']>;
  metaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  metaLt?: InputMaybe<Scalars['JSON']>;
  metaLte?: InputMaybe<Scalars['JSON']>;
  metaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  minValue?: InputMaybe<Scalars['JSON']>;
  minValueAny?: InputMaybe<Scalars['JSON']>;
  minValueContain?: InputMaybe<Scalars['JSON']>;
  minValueEq?: InputMaybe<Scalars['JSON']>;
  minValueGt?: InputMaybe<Scalars['JSON']>;
  minValueGte?: InputMaybe<Scalars['JSON']>;
  minValueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  minValueIsNull?: InputMaybe<Scalars['Boolean']>;
  minValueLike?: InputMaybe<Scalars['JSON']>;
  minValueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  minValueLt?: InputMaybe<Scalars['JSON']>;
  minValueLte?: InputMaybe<Scalars['JSON']>;
  minValueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  modifiedAt?: InputMaybe<Scalars['String']>;
  modifiedAtAny?: InputMaybe<Scalars['String']>;
  modifiedAtContain?: InputMaybe<Scalars['String']>;
  modifiedAtEq?: InputMaybe<Scalars['String']>;
  modifiedAtGt?: InputMaybe<Scalars['String']>;
  modifiedAtGte?: InputMaybe<Scalars['String']>;
  modifiedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedAtLike?: InputMaybe<Scalars['String']>;
  modifiedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedAtLt?: InputMaybe<Scalars['String']>;
  modifiedAtLte?: InputMaybe<Scalars['String']>;
  modifiedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  note?: InputMaybe<Scalars['String']>;
  noteAny?: InputMaybe<Scalars['String']>;
  noteContain?: InputMaybe<Scalars['String']>;
  noteEq?: InputMaybe<Scalars['String']>;
  noteGt?: InputMaybe<Scalars['String']>;
  noteGte?: InputMaybe<Scalars['String']>;
  noteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  noteIsNull?: InputMaybe<Scalars['Boolean']>;
  noteLike?: InputMaybe<Scalars['String']>;
  noteLikeNoCase?: InputMaybe<Scalars['String']>;
  noteLt?: InputMaybe<Scalars['String']>;
  noteLte?: InputMaybe<Scalars['String']>;
  noteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLFieldsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLFieldsPropertiesEnum>;
  pattern?: InputMaybe<Scalars['String']>;
  patternAny?: InputMaybe<Scalars['String']>;
  patternContain?: InputMaybe<Scalars['String']>;
  patternEq?: InputMaybe<Scalars['String']>;
  patternGt?: InputMaybe<Scalars['String']>;
  patternGte?: InputMaybe<Scalars['String']>;
  patternIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  patternIsNull?: InputMaybe<Scalars['Boolean']>;
  patternLike?: InputMaybe<Scalars['String']>;
  patternLikeNoCase?: InputMaybe<Scalars['String']>;
  patternLt?: InputMaybe<Scalars['String']>;
  patternLte?: InputMaybe<Scalars['String']>;
  patternNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeholder?: InputMaybe<Scalars['String']>;
  placeholderAny?: InputMaybe<Scalars['String']>;
  placeholderContain?: InputMaybe<Scalars['String']>;
  placeholderEq?: InputMaybe<Scalars['String']>;
  placeholderGt?: InputMaybe<Scalars['String']>;
  placeholderGte?: InputMaybe<Scalars['String']>;
  placeholderIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeholderIsNull?: InputMaybe<Scalars['Boolean']>;
  placeholderLike?: InputMaybe<Scalars['String']>;
  placeholderLikeNoCase?: InputMaybe<Scalars['String']>;
  placeholderLt?: InputMaybe<Scalars['String']>;
  placeholderLte?: InputMaybe<Scalars['String']>;
  placeholderNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCase?: InputMaybe<Scalars['String']>;
  useCaseAny?: InputMaybe<Scalars['String']>;
  useCaseContain?: InputMaybe<Scalars['String']>;
  useCaseEq?: InputMaybe<Scalars['String']>;
  useCaseGt?: InputMaybe<Scalars['String']>;
  useCaseGte?: InputMaybe<Scalars['String']>;
  useCaseIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useCaseIsNull?: InputMaybe<Scalars['Boolean']>;
  useCaseLike?: InputMaybe<Scalars['String']>;
  useCaseLikeNoCase?: InputMaybe<Scalars['String']>;
  useCaseLt?: InputMaybe<Scalars['String']>;
  useCaseLte?: InputMaybe<Scalars['String']>;
  useCaseNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  validationType?: InputMaybe<Scalars['String']>;
  validationTypeAny?: InputMaybe<Scalars['String']>;
  validationTypeContain?: InputMaybe<Scalars['String']>;
  validationTypeEq?: InputMaybe<Scalars['String']>;
  validationTypeGt?: InputMaybe<Scalars['String']>;
  validationTypeGte?: InputMaybe<Scalars['String']>;
  validationTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  validationTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  validationTypeLike?: InputMaybe<Scalars['String']>;
  validationTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  validationTypeLt?: InputMaybe<Scalars['String']>;
  validationTypeLte?: InputMaybe<Scalars['String']>;
  validationTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLTaxonomiesEntitiesPropertiesEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Model = 'model',
  ModelId = 'modelId',
  SortOrder = 'sortOrder',
  TaxonomyId = 'taxonomyId',
  UpdatedAt = 'updatedAt'
}

export enum GQLTaxonomiesPropertiesEnum {
  CategoryId = 'categoryId',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Description = 'description',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  LogoId = 'logoId',
  Name = 'name',
  ParentId = 'parentId',
  Slug = 'slug',
  TargetModel = 'targetModel',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy',
  UseCase = 'useCase'
}

export type GQLTextBlocks = {
  __typename?: 'TextBlocks';
  category?: Maybe<GQLCategories>;
  categoryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  deletedBy?: Maybe<Scalars['String']>;
  domainId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  offerIds?: Maybe<Scalars['JSON']>;
  position?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['JSON']>;
  text?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  user?: Maybe<GQLUsers>;
};


export type GQLTextBlocksCategoryArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLTextBlocksTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};


export type GQLTextBlocksUserArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLTextBlocksPropertiesEnum {
  CategoryId = 'categoryId',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  DomainId = 'domainId',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  Label = 'label',
  OfferIds = 'offerIds',
  Position = 'position',
  QueryString = 'queryString',
  Text = 'text',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy'
}

export type GQLTrafficSourceMap = {
  __typename?: 'TrafficSourceMap';
  accountId?: Maybe<Scalars['Int']>;
  advertisingNetwork?: Maybe<GQLAdvertisingNetworks>;
  categories?: Maybe<Array<Maybe<GQLCategories>>>;
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  excludeFromDailyPL?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  networkId?: Maybe<Scalars['Int']>;
  trafficSource?: Maybe<Scalars['String']>;
  trafficType?: Maybe<GQLTrafficTypes>;
  trafficTypeId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['String']>;
  user?: Maybe<GQLUsers>;
  userId?: Maybe<Scalars['String']>;
};


export type GQLTrafficSourceMapAdvertisingNetworkArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAdvertisingNetworksPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAdvertisingNetworksPropertiesEnum>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLTrafficSourceMapCategoriesArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLTrafficSourceMapTrafficTypeArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTrafficTypesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTrafficTypesPropertiesEnum>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLTrafficSourceMapUserArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLTrafficSourceMapPropertiesEnum {
  AccountId = 'accountId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  ExcludeFromDailyPl = 'excludeFromDailyPL',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  NetworkId = 'networkId',
  TrafficSource = 'trafficSource',
  TrafficTypeId = 'trafficTypeId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type GQLTrafficTypes = {
  __typename?: 'TrafficTypes';
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export enum GQLTrafficTypesPropertiesEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  Name = 'name',
  Slug = 'slug',
  UpdatedAt = 'updatedAt'
}

export type GQLTranslations = {
  __typename?: 'Translations';
  categories?: Maybe<GQLCategories>;
  category?: Maybe<GQLCategories>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['Int']>;
  modelType?: Maybe<Scalars['String']>;
  offer?: Maybe<GQLOffers>;
  offers?: Maybe<GQLOffers>;
  post?: Maybe<GQLPosts>;
  posts?: Maybe<GQLPosts>;
  tag?: Maybe<GQLTags>;
  updatedAt?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};


export type GQLTranslationsCategoriesArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLTranslationsCategoryArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLTranslationsOfferArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checkWallet?: InputMaybe<Scalars['Boolean']>;
  checkWalletAny?: InputMaybe<Scalars['Boolean']>;
  checkWalletContain?: InputMaybe<Scalars['Boolean']>;
  checkWalletEq?: InputMaybe<Scalars['Boolean']>;
  checkWalletGt?: InputMaybe<Scalars['Boolean']>;
  checkWalletGte?: InputMaybe<Scalars['Boolean']>;
  checkWalletIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  checkWalletIsNull?: InputMaybe<Scalars['Boolean']>;
  checkWalletLike?: InputMaybe<Scalars['Boolean']>;
  checkWalletLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  checkWalletLt?: InputMaybe<Scalars['Boolean']>;
  checkWalletLte?: InputMaybe<Scalars['Boolean']>;
  checkWalletNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultAffiliateLinkId?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdAny?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdContain?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdEq?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  defaultAffiliateLinkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultAffiliateLinkIdLike?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrl?: InputMaybe<Scalars['String']>;
  displayUrlAny?: InputMaybe<Scalars['String']>;
  displayUrlContain?: InputMaybe<Scalars['String']>;
  displayUrlEq?: InputMaybe<Scalars['String']>;
  displayUrlGt?: InputMaybe<Scalars['String']>;
  displayUrlGte?: InputMaybe<Scalars['String']>;
  displayUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  displayUrlLike?: InputMaybe<Scalars['String']>;
  displayUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  displayUrlLt?: InputMaybe<Scalars['String']>;
  displayUrlLte?: InputMaybe<Scalars['String']>;
  displayUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalData?: InputMaybe<Scalars['JSON']>;
  externalDataAny?: InputMaybe<Scalars['JSON']>;
  externalDataContain?: InputMaybe<Scalars['JSON']>;
  externalDataEq?: InputMaybe<Scalars['JSON']>;
  externalDataGt?: InputMaybe<Scalars['JSON']>;
  externalDataGte?: InputMaybe<Scalars['JSON']>;
  externalDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  externalDataIsNull?: InputMaybe<Scalars['Boolean']>;
  externalDataLike?: InputMaybe<Scalars['JSON']>;
  externalDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  externalDataLt?: InputMaybe<Scalars['JSON']>;
  externalDataLte?: InputMaybe<Scalars['JSON']>;
  externalDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  featuresListTitle?: InputMaybe<Scalars['String']>;
  featuresListTitleAny?: InputMaybe<Scalars['String']>;
  featuresListTitleContain?: InputMaybe<Scalars['String']>;
  featuresListTitleEq?: InputMaybe<Scalars['String']>;
  featuresListTitleGt?: InputMaybe<Scalars['String']>;
  featuresListTitleGte?: InputMaybe<Scalars['String']>;
  featuresListTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuresListTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  featuresListTitleLike?: InputMaybe<Scalars['String']>;
  featuresListTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  featuresListTitleLt?: InputMaybe<Scalars['String']>;
  featuresListTitleLte?: InputMaybe<Scalars['String']>;
  featuresListTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  isPausedAny?: InputMaybe<Scalars['Boolean']>;
  isPausedContain?: InputMaybe<Scalars['Boolean']>;
  isPausedEq?: InputMaybe<Scalars['Boolean']>;
  isPausedGt?: InputMaybe<Scalars['Boolean']>;
  isPausedGte?: InputMaybe<Scalars['Boolean']>;
  isPausedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPausedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPausedLike?: InputMaybe<Scalars['Boolean']>;
  isPausedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPausedLt?: InputMaybe<Scalars['Boolean']>;
  isPausedLte?: InputMaybe<Scalars['Boolean']>;
  isPausedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldOverview?: InputMaybe<Scalars['String']>;
  oldOverviewAny?: InputMaybe<Scalars['String']>;
  oldOverviewContain?: InputMaybe<Scalars['String']>;
  oldOverviewEq?: InputMaybe<Scalars['String']>;
  oldOverviewGt?: InputMaybe<Scalars['String']>;
  oldOverviewGte?: InputMaybe<Scalars['String']>;
  oldOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  oldOverviewLike?: InputMaybe<Scalars['String']>;
  oldOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  oldOverviewLt?: InputMaybe<Scalars['String']>;
  oldOverviewLte?: InputMaybe<Scalars['String']>;
  oldOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOffersPropertiesEnum>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescription?: InputMaybe<Scalars['String']>;
  previewDescriptionAny?: InputMaybe<Scalars['String']>;
  previewDescriptionContain?: InputMaybe<Scalars['String']>;
  previewDescriptionEq?: InputMaybe<Scalars['String']>;
  previewDescriptionGt?: InputMaybe<Scalars['String']>;
  previewDescriptionGte?: InputMaybe<Scalars['String']>;
  previewDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  previewDescriptionLike?: InputMaybe<Scalars['String']>;
  previewDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  previewDescriptionLt?: InputMaybe<Scalars['String']>;
  previewDescriptionLte?: InputMaybe<Scalars['String']>;
  previewDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverview?: InputMaybe<Scalars['String']>;
  quickOverviewAny?: InputMaybe<Scalars['String']>;
  quickOverviewContain?: InputMaybe<Scalars['String']>;
  quickOverviewEq?: InputMaybe<Scalars['String']>;
  quickOverviewGt?: InputMaybe<Scalars['String']>;
  quickOverviewGte?: InputMaybe<Scalars['String']>;
  quickOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  quickOverviewLike?: InputMaybe<Scalars['String']>;
  quickOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  quickOverviewLt?: InputMaybe<Scalars['String']>;
  quickOverviewLte?: InputMaybe<Scalars['String']>;
  quickOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  score?: InputMaybe<Scalars['Float']>;
  scoreAny?: InputMaybe<Scalars['Float']>;
  scoreContain?: InputMaybe<Scalars['Float']>;
  scoreEq?: InputMaybe<Scalars['Float']>;
  scoreGt?: InputMaybe<Scalars['Float']>;
  scoreGte?: InputMaybe<Scalars['Float']>;
  scoreIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  scoreIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreLike?: InputMaybe<Scalars['Float']>;
  scoreLikeNoCase?: InputMaybe<Scalars['Float']>;
  scoreLt?: InputMaybe<Scalars['Float']>;
  scoreLte?: InputMaybe<Scalars['Float']>;
  scoreMessage?: InputMaybe<Scalars['String']>;
  scoreMessageAny?: InputMaybe<Scalars['String']>;
  scoreMessageContain?: InputMaybe<Scalars['String']>;
  scoreMessageEq?: InputMaybe<Scalars['String']>;
  scoreMessageGt?: InputMaybe<Scalars['String']>;
  scoreMessageGte?: InputMaybe<Scalars['String']>;
  scoreMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreMessageLike?: InputMaybe<Scalars['String']>;
  scoreMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  scoreMessageLt?: InputMaybe<Scalars['String']>;
  scoreMessageLte?: InputMaybe<Scalars['String']>;
  scoreMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleAny?: InputMaybe<Scalars['String']>;
  subTitleContain?: InputMaybe<Scalars['String']>;
  subTitleEq?: InputMaybe<Scalars['String']>;
  subTitleGt?: InputMaybe<Scalars['String']>;
  subTitleGte?: InputMaybe<Scalars['String']>;
  subTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subTitleLike?: InputMaybe<Scalars['String']>;
  subTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subTitleLt?: InputMaybe<Scalars['String']>;
  subTitleLte?: InputMaybe<Scalars['String']>;
  subTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescription?: InputMaybe<Scalars['String']>;
  summaryDescriptionAny?: InputMaybe<Scalars['String']>;
  summaryDescriptionContain?: InputMaybe<Scalars['String']>;
  summaryDescriptionEq?: InputMaybe<Scalars['String']>;
  summaryDescriptionGt?: InputMaybe<Scalars['String']>;
  summaryDescriptionGte?: InputMaybe<Scalars['String']>;
  summaryDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryDescriptionLike?: InputMaybe<Scalars['String']>;
  summaryDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryDescriptionLt?: InputMaybe<Scalars['String']>;
  summaryDescriptionLte?: InputMaybe<Scalars['String']>;
  summaryDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitle?: InputMaybe<Scalars['String']>;
  summaryTitleAny?: InputMaybe<Scalars['String']>;
  summaryTitleContain?: InputMaybe<Scalars['String']>;
  summaryTitleEq?: InputMaybe<Scalars['String']>;
  summaryTitleGt?: InputMaybe<Scalars['String']>;
  summaryTitleGte?: InputMaybe<Scalars['String']>;
  summaryTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryTitleLike?: InputMaybe<Scalars['String']>;
  summaryTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryTitleLt?: InputMaybe<Scalars['String']>;
  summaryTitleLte?: InputMaybe<Scalars['String']>;
  summaryTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLTranslationsOffersArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checkWallet?: InputMaybe<Scalars['Boolean']>;
  checkWalletAny?: InputMaybe<Scalars['Boolean']>;
  checkWalletContain?: InputMaybe<Scalars['Boolean']>;
  checkWalletEq?: InputMaybe<Scalars['Boolean']>;
  checkWalletGt?: InputMaybe<Scalars['Boolean']>;
  checkWalletGte?: InputMaybe<Scalars['Boolean']>;
  checkWalletIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  checkWalletIsNull?: InputMaybe<Scalars['Boolean']>;
  checkWalletLike?: InputMaybe<Scalars['Boolean']>;
  checkWalletLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  checkWalletLt?: InputMaybe<Scalars['Boolean']>;
  checkWalletLte?: InputMaybe<Scalars['Boolean']>;
  checkWalletNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultAffiliateLinkId?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdAny?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdContain?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdEq?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  defaultAffiliateLinkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultAffiliateLinkIdLike?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrl?: InputMaybe<Scalars['String']>;
  displayUrlAny?: InputMaybe<Scalars['String']>;
  displayUrlContain?: InputMaybe<Scalars['String']>;
  displayUrlEq?: InputMaybe<Scalars['String']>;
  displayUrlGt?: InputMaybe<Scalars['String']>;
  displayUrlGte?: InputMaybe<Scalars['String']>;
  displayUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  displayUrlLike?: InputMaybe<Scalars['String']>;
  displayUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  displayUrlLt?: InputMaybe<Scalars['String']>;
  displayUrlLte?: InputMaybe<Scalars['String']>;
  displayUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalData?: InputMaybe<Scalars['JSON']>;
  externalDataAny?: InputMaybe<Scalars['JSON']>;
  externalDataContain?: InputMaybe<Scalars['JSON']>;
  externalDataEq?: InputMaybe<Scalars['JSON']>;
  externalDataGt?: InputMaybe<Scalars['JSON']>;
  externalDataGte?: InputMaybe<Scalars['JSON']>;
  externalDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  externalDataIsNull?: InputMaybe<Scalars['Boolean']>;
  externalDataLike?: InputMaybe<Scalars['JSON']>;
  externalDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  externalDataLt?: InputMaybe<Scalars['JSON']>;
  externalDataLte?: InputMaybe<Scalars['JSON']>;
  externalDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  featuresListTitle?: InputMaybe<Scalars['String']>;
  featuresListTitleAny?: InputMaybe<Scalars['String']>;
  featuresListTitleContain?: InputMaybe<Scalars['String']>;
  featuresListTitleEq?: InputMaybe<Scalars['String']>;
  featuresListTitleGt?: InputMaybe<Scalars['String']>;
  featuresListTitleGte?: InputMaybe<Scalars['String']>;
  featuresListTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuresListTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  featuresListTitleLike?: InputMaybe<Scalars['String']>;
  featuresListTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  featuresListTitleLt?: InputMaybe<Scalars['String']>;
  featuresListTitleLte?: InputMaybe<Scalars['String']>;
  featuresListTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  isPausedAny?: InputMaybe<Scalars['Boolean']>;
  isPausedContain?: InputMaybe<Scalars['Boolean']>;
  isPausedEq?: InputMaybe<Scalars['Boolean']>;
  isPausedGt?: InputMaybe<Scalars['Boolean']>;
  isPausedGte?: InputMaybe<Scalars['Boolean']>;
  isPausedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPausedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPausedLike?: InputMaybe<Scalars['Boolean']>;
  isPausedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPausedLt?: InputMaybe<Scalars['Boolean']>;
  isPausedLte?: InputMaybe<Scalars['Boolean']>;
  isPausedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldOverview?: InputMaybe<Scalars['String']>;
  oldOverviewAny?: InputMaybe<Scalars['String']>;
  oldOverviewContain?: InputMaybe<Scalars['String']>;
  oldOverviewEq?: InputMaybe<Scalars['String']>;
  oldOverviewGt?: InputMaybe<Scalars['String']>;
  oldOverviewGte?: InputMaybe<Scalars['String']>;
  oldOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  oldOverviewLike?: InputMaybe<Scalars['String']>;
  oldOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  oldOverviewLt?: InputMaybe<Scalars['String']>;
  oldOverviewLte?: InputMaybe<Scalars['String']>;
  oldOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOffersPropertiesEnum>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescription?: InputMaybe<Scalars['String']>;
  previewDescriptionAny?: InputMaybe<Scalars['String']>;
  previewDescriptionContain?: InputMaybe<Scalars['String']>;
  previewDescriptionEq?: InputMaybe<Scalars['String']>;
  previewDescriptionGt?: InputMaybe<Scalars['String']>;
  previewDescriptionGte?: InputMaybe<Scalars['String']>;
  previewDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  previewDescriptionLike?: InputMaybe<Scalars['String']>;
  previewDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  previewDescriptionLt?: InputMaybe<Scalars['String']>;
  previewDescriptionLte?: InputMaybe<Scalars['String']>;
  previewDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverview?: InputMaybe<Scalars['String']>;
  quickOverviewAny?: InputMaybe<Scalars['String']>;
  quickOverviewContain?: InputMaybe<Scalars['String']>;
  quickOverviewEq?: InputMaybe<Scalars['String']>;
  quickOverviewGt?: InputMaybe<Scalars['String']>;
  quickOverviewGte?: InputMaybe<Scalars['String']>;
  quickOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  quickOverviewLike?: InputMaybe<Scalars['String']>;
  quickOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  quickOverviewLt?: InputMaybe<Scalars['String']>;
  quickOverviewLte?: InputMaybe<Scalars['String']>;
  quickOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  score?: InputMaybe<Scalars['Float']>;
  scoreAny?: InputMaybe<Scalars['Float']>;
  scoreContain?: InputMaybe<Scalars['Float']>;
  scoreEq?: InputMaybe<Scalars['Float']>;
  scoreGt?: InputMaybe<Scalars['Float']>;
  scoreGte?: InputMaybe<Scalars['Float']>;
  scoreIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  scoreIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreLike?: InputMaybe<Scalars['Float']>;
  scoreLikeNoCase?: InputMaybe<Scalars['Float']>;
  scoreLt?: InputMaybe<Scalars['Float']>;
  scoreLte?: InputMaybe<Scalars['Float']>;
  scoreMessage?: InputMaybe<Scalars['String']>;
  scoreMessageAny?: InputMaybe<Scalars['String']>;
  scoreMessageContain?: InputMaybe<Scalars['String']>;
  scoreMessageEq?: InputMaybe<Scalars['String']>;
  scoreMessageGt?: InputMaybe<Scalars['String']>;
  scoreMessageGte?: InputMaybe<Scalars['String']>;
  scoreMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreMessageLike?: InputMaybe<Scalars['String']>;
  scoreMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  scoreMessageLt?: InputMaybe<Scalars['String']>;
  scoreMessageLte?: InputMaybe<Scalars['String']>;
  scoreMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleAny?: InputMaybe<Scalars['String']>;
  subTitleContain?: InputMaybe<Scalars['String']>;
  subTitleEq?: InputMaybe<Scalars['String']>;
  subTitleGt?: InputMaybe<Scalars['String']>;
  subTitleGte?: InputMaybe<Scalars['String']>;
  subTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subTitleLike?: InputMaybe<Scalars['String']>;
  subTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subTitleLt?: InputMaybe<Scalars['String']>;
  subTitleLte?: InputMaybe<Scalars['String']>;
  subTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescription?: InputMaybe<Scalars['String']>;
  summaryDescriptionAny?: InputMaybe<Scalars['String']>;
  summaryDescriptionContain?: InputMaybe<Scalars['String']>;
  summaryDescriptionEq?: InputMaybe<Scalars['String']>;
  summaryDescriptionGt?: InputMaybe<Scalars['String']>;
  summaryDescriptionGte?: InputMaybe<Scalars['String']>;
  summaryDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryDescriptionLike?: InputMaybe<Scalars['String']>;
  summaryDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryDescriptionLt?: InputMaybe<Scalars['String']>;
  summaryDescriptionLte?: InputMaybe<Scalars['String']>;
  summaryDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitle?: InputMaybe<Scalars['String']>;
  summaryTitleAny?: InputMaybe<Scalars['String']>;
  summaryTitleContain?: InputMaybe<Scalars['String']>;
  summaryTitleEq?: InputMaybe<Scalars['String']>;
  summaryTitleGt?: InputMaybe<Scalars['String']>;
  summaryTitleGte?: InputMaybe<Scalars['String']>;
  summaryTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryTitleLike?: InputMaybe<Scalars['String']>;
  summaryTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryTitleLt?: InputMaybe<Scalars['String']>;
  summaryTitleLte?: InputMaybe<Scalars['String']>;
  summaryTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLTranslationsPostArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerpt?: InputMaybe<Scalars['String']>;
  excerptAny?: InputMaybe<Scalars['String']>;
  excerptContain?: InputMaybe<Scalars['String']>;
  excerptEq?: InputMaybe<Scalars['String']>;
  excerptGt?: InputMaybe<Scalars['String']>;
  excerptGte?: InputMaybe<Scalars['String']>;
  excerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerptIsNull?: InputMaybe<Scalars['Boolean']>;
  excerptLike?: InputMaybe<Scalars['String']>;
  excerptLikeNoCase?: InputMaybe<Scalars['String']>;
  excerptLt?: InputMaybe<Scalars['String']>;
  excerptLte?: InputMaybe<Scalars['String']>;
  excerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featured?: InputMaybe<Scalars['Boolean']>;
  featuredAny?: InputMaybe<Scalars['Boolean']>;
  featuredContain?: InputMaybe<Scalars['Boolean']>;
  featuredEq?: InputMaybe<Scalars['Boolean']>;
  featuredGt?: InputMaybe<Scalars['Boolean']>;
  featuredGte?: InputMaybe<Scalars['Boolean']>;
  featuredIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  featuredIsNull?: InputMaybe<Scalars['Boolean']>;
  featuredLike?: InputMaybe<Scalars['Boolean']>;
  featuredLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  featuredLt?: InputMaybe<Scalars['Boolean']>;
  featuredLte?: InputMaybe<Scalars['Boolean']>;
  featuredNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  fullBody?: InputMaybe<Scalars['String']>;
  fullBodyAny?: InputMaybe<Scalars['String']>;
  fullBodyContain?: InputMaybe<Scalars['String']>;
  fullBodyEq?: InputMaybe<Scalars['String']>;
  fullBodyGt?: InputMaybe<Scalars['String']>;
  fullBodyGte?: InputMaybe<Scalars['String']>;
  fullBodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullBodyIsNull?: InputMaybe<Scalars['Boolean']>;
  fullBodyLike?: InputMaybe<Scalars['String']>;
  fullBodyLikeNoCase?: InputMaybe<Scalars['String']>;
  fullBodyLt?: InputMaybe<Scalars['String']>;
  fullBodyLte?: InputMaybe<Scalars['String']>;
  fullBodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldExcerpt?: InputMaybe<Scalars['String']>;
  oldExcerptAny?: InputMaybe<Scalars['String']>;
  oldExcerptContain?: InputMaybe<Scalars['String']>;
  oldExcerptEq?: InputMaybe<Scalars['String']>;
  oldExcerptGt?: InputMaybe<Scalars['String']>;
  oldExcerptGte?: InputMaybe<Scalars['String']>;
  oldExcerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldExcerptIsNull?: InputMaybe<Scalars['Boolean']>;
  oldExcerptLike?: InputMaybe<Scalars['String']>;
  oldExcerptLikeNoCase?: InputMaybe<Scalars['String']>;
  oldExcerptLt?: InputMaybe<Scalars['String']>;
  oldExcerptLte?: InputMaybe<Scalars['String']>;
  oldExcerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLPostsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLPostsPropertiesEnum>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedAny?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['String']>;
  publishedAtAny?: InputMaybe<Scalars['String']>;
  publishedAtContain?: InputMaybe<Scalars['String']>;
  publishedAtEq?: InputMaybe<Scalars['String']>;
  publishedAtGt?: InputMaybe<Scalars['String']>;
  publishedAtGte?: InputMaybe<Scalars['String']>;
  publishedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedAtLike?: InputMaybe<Scalars['String']>;
  publishedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  publishedAtLt?: InputMaybe<Scalars['String']>;
  publishedAtLte?: InputMaybe<Scalars['String']>;
  publishedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedContain?: InputMaybe<Scalars['Boolean']>;
  publishedEq?: InputMaybe<Scalars['Boolean']>;
  publishedGt?: InputMaybe<Scalars['Boolean']>;
  publishedGte?: InputMaybe<Scalars['Boolean']>;
  publishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  publishedIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedLike?: InputMaybe<Scalars['Boolean']>;
  publishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  publishedLt?: InputMaybe<Scalars['Boolean']>;
  publishedLte?: InputMaybe<Scalars['Boolean']>;
  publishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Scalars['Int']>;
  typeIdAny?: InputMaybe<Scalars['Int']>;
  typeIdContain?: InputMaybe<Scalars['Int']>;
  typeIdEq?: InputMaybe<Scalars['Int']>;
  typeIdGt?: InputMaybe<Scalars['Int']>;
  typeIdGte?: InputMaybe<Scalars['Int']>;
  typeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  typeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  typeIdLike?: InputMaybe<Scalars['Int']>;
  typeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  typeIdLt?: InputMaybe<Scalars['Int']>;
  typeIdLte?: InputMaybe<Scalars['Int']>;
  typeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLTranslationsPostsArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerpt?: InputMaybe<Scalars['String']>;
  excerptAny?: InputMaybe<Scalars['String']>;
  excerptContain?: InputMaybe<Scalars['String']>;
  excerptEq?: InputMaybe<Scalars['String']>;
  excerptGt?: InputMaybe<Scalars['String']>;
  excerptGte?: InputMaybe<Scalars['String']>;
  excerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerptIsNull?: InputMaybe<Scalars['Boolean']>;
  excerptLike?: InputMaybe<Scalars['String']>;
  excerptLikeNoCase?: InputMaybe<Scalars['String']>;
  excerptLt?: InputMaybe<Scalars['String']>;
  excerptLte?: InputMaybe<Scalars['String']>;
  excerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featured?: InputMaybe<Scalars['Boolean']>;
  featuredAny?: InputMaybe<Scalars['Boolean']>;
  featuredContain?: InputMaybe<Scalars['Boolean']>;
  featuredEq?: InputMaybe<Scalars['Boolean']>;
  featuredGt?: InputMaybe<Scalars['Boolean']>;
  featuredGte?: InputMaybe<Scalars['Boolean']>;
  featuredIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  featuredIsNull?: InputMaybe<Scalars['Boolean']>;
  featuredLike?: InputMaybe<Scalars['Boolean']>;
  featuredLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  featuredLt?: InputMaybe<Scalars['Boolean']>;
  featuredLte?: InputMaybe<Scalars['Boolean']>;
  featuredNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  fullBody?: InputMaybe<Scalars['String']>;
  fullBodyAny?: InputMaybe<Scalars['String']>;
  fullBodyContain?: InputMaybe<Scalars['String']>;
  fullBodyEq?: InputMaybe<Scalars['String']>;
  fullBodyGt?: InputMaybe<Scalars['String']>;
  fullBodyGte?: InputMaybe<Scalars['String']>;
  fullBodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullBodyIsNull?: InputMaybe<Scalars['Boolean']>;
  fullBodyLike?: InputMaybe<Scalars['String']>;
  fullBodyLikeNoCase?: InputMaybe<Scalars['String']>;
  fullBodyLt?: InputMaybe<Scalars['String']>;
  fullBodyLte?: InputMaybe<Scalars['String']>;
  fullBodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldExcerpt?: InputMaybe<Scalars['String']>;
  oldExcerptAny?: InputMaybe<Scalars['String']>;
  oldExcerptContain?: InputMaybe<Scalars['String']>;
  oldExcerptEq?: InputMaybe<Scalars['String']>;
  oldExcerptGt?: InputMaybe<Scalars['String']>;
  oldExcerptGte?: InputMaybe<Scalars['String']>;
  oldExcerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldExcerptIsNull?: InputMaybe<Scalars['Boolean']>;
  oldExcerptLike?: InputMaybe<Scalars['String']>;
  oldExcerptLikeNoCase?: InputMaybe<Scalars['String']>;
  oldExcerptLt?: InputMaybe<Scalars['String']>;
  oldExcerptLte?: InputMaybe<Scalars['String']>;
  oldExcerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLPostsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLPostsPropertiesEnum>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedAny?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['String']>;
  publishedAtAny?: InputMaybe<Scalars['String']>;
  publishedAtContain?: InputMaybe<Scalars['String']>;
  publishedAtEq?: InputMaybe<Scalars['String']>;
  publishedAtGt?: InputMaybe<Scalars['String']>;
  publishedAtGte?: InputMaybe<Scalars['String']>;
  publishedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedAtLike?: InputMaybe<Scalars['String']>;
  publishedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  publishedAtLt?: InputMaybe<Scalars['String']>;
  publishedAtLte?: InputMaybe<Scalars['String']>;
  publishedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedContain?: InputMaybe<Scalars['Boolean']>;
  publishedEq?: InputMaybe<Scalars['Boolean']>;
  publishedGt?: InputMaybe<Scalars['Boolean']>;
  publishedGte?: InputMaybe<Scalars['Boolean']>;
  publishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  publishedIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedLike?: InputMaybe<Scalars['Boolean']>;
  publishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  publishedLt?: InputMaybe<Scalars['Boolean']>;
  publishedLte?: InputMaybe<Scalars['Boolean']>;
  publishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Scalars['Int']>;
  typeIdAny?: InputMaybe<Scalars['Int']>;
  typeIdContain?: InputMaybe<Scalars['Int']>;
  typeIdEq?: InputMaybe<Scalars['Int']>;
  typeIdGt?: InputMaybe<Scalars['Int']>;
  typeIdGte?: InputMaybe<Scalars['Int']>;
  typeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  typeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  typeIdLike?: InputMaybe<Scalars['Int']>;
  typeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  typeIdLt?: InputMaybe<Scalars['Int']>;
  typeIdLte?: InputMaybe<Scalars['Int']>;
  typeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLTranslationsTagArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLTagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTagsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLTranslationsPropertiesEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  Id = 'id',
  IsDeleted = 'isDeleted',
  Key = 'key',
  Language = 'language',
  ModelId = 'modelId',
  ModelType = 'modelType',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

export type GQLUrls = {
  __typename?: 'Urls';
  category?: Maybe<GQLCategories>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  domain?: Maybe<GQLDomains>;
  domainId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMain?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  main?: Maybe<GQLUrls>;
  meta?: Maybe<Scalars['JSON']>;
  model?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  offer?: Maybe<GQLOffers>;
  post?: Maybe<GQLPosts>;
  redirectionStatusCode?: Maybe<Scalars['Int']>;
  tag?: Maybe<GQLTags>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type GQLUrlsCategoryArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLUrlsDomainArgs = {
  allowedLanguages?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesAny?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesContain?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesEq?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  allowedLanguagesIsNull?: InputMaybe<Scalars['Boolean']>;
  allowedLanguagesLike?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  analyticsCodeId?: InputMaybe<Scalars['String']>;
  analyticsCodeIdAny?: InputMaybe<Scalars['String']>;
  analyticsCodeIdContain?: InputMaybe<Scalars['String']>;
  analyticsCodeIdEq?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  analyticsCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  analyticsCodeIdLike?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cacheSettings?: InputMaybe<Scalars['JSON']>;
  cacheSettingsAny?: InputMaybe<Scalars['JSON']>;
  cacheSettingsContain?: InputMaybe<Scalars['JSON']>;
  cacheSettingsEq?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  cacheSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  cacheSettingsLike?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  clickyCodeId?: InputMaybe<Scalars['String']>;
  clickyCodeIdAny?: InputMaybe<Scalars['String']>;
  clickyCodeIdContain?: InputMaybe<Scalars['String']>;
  clickyCodeIdEq?: InputMaybe<Scalars['String']>;
  clickyCodeIdGt?: InputMaybe<Scalars['String']>;
  clickyCodeIdGte?: InputMaybe<Scalars['String']>;
  clickyCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clickyCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  clickyCodeIdLike?: InputMaybe<Scalars['String']>;
  clickyCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  clickyCodeIdLt?: InputMaybe<Scalars['String']>;
  clickyCodeIdLte?: InputMaybe<Scalars['String']>;
  clickyCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  enableChatWidget?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetAny?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetContain?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetEq?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableChatWidgetIsNull?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLike?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaId?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdAny?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdContain?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdEq?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLike?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedForm?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormAny?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormContain?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormEq?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedFormIsNull?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLike?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  facebookConversionAPISettings?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsAny?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsContain?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsEq?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookConversionAPISettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookConversionAPISettingsLike?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookSiteVerificationCode?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fallbackSettings?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsAny?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsContain?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsEq?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  fallbackSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  fallbackSettingsLike?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  faviconId?: InputMaybe<Scalars['String']>;
  faviconIdAny?: InputMaybe<Scalars['String']>;
  faviconIdContain?: InputMaybe<Scalars['String']>;
  faviconIdEq?: InputMaybe<Scalars['String']>;
  faviconIdGt?: InputMaybe<Scalars['String']>;
  faviconIdGte?: InputMaybe<Scalars['String']>;
  faviconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  faviconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  faviconIdLike?: InputMaybe<Scalars['String']>;
  faviconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  faviconIdLt?: InputMaybe<Scalars['String']>;
  faviconIdLte?: InputMaybe<Scalars['String']>;
  faviconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCode?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  googleSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmId?: InputMaybe<Scalars['String']>;
  gtmIdAny?: InputMaybe<Scalars['String']>;
  gtmIdContain?: InputMaybe<Scalars['String']>;
  gtmIdEq?: InputMaybe<Scalars['String']>;
  gtmIdGt?: InputMaybe<Scalars['String']>;
  gtmIdGte?: InputMaybe<Scalars['String']>;
  gtmIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmIdIsNull?: InputMaybe<Scalars['Boolean']>;
  gtmIdLike?: InputMaybe<Scalars['String']>;
  gtmIdLikeNoCase?: InputMaybe<Scalars['String']>;
  gtmIdLt?: InputMaybe<Scalars['String']>;
  gtmIdLte?: InputMaybe<Scalars['String']>;
  gtmIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  holdingRules?: InputMaybe<Scalars['JSON']>;
  holdingRulesAny?: InputMaybe<Scalars['JSON']>;
  holdingRulesContain?: InputMaybe<Scalars['JSON']>;
  holdingRulesEq?: InputMaybe<Scalars['JSON']>;
  holdingRulesGt?: InputMaybe<Scalars['JSON']>;
  holdingRulesGte?: InputMaybe<Scalars['JSON']>;
  holdingRulesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  holdingRulesIsNull?: InputMaybe<Scalars['Boolean']>;
  holdingRulesLike?: InputMaybe<Scalars['JSON']>;
  holdingRulesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  holdingRulesLt?: InputMaybe<Scalars['JSON']>;
  holdingRulesLte?: InputMaybe<Scalars['JSON']>;
  holdingRulesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabled?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledAny?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledContain?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledEq?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabledIsNull?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLike?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainsPropertiesEnum>;
  otpVerificationCriteria?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaAny?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaContain?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaEq?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  otpVerificationCriteriaIsNull?: InputMaybe<Scalars['Boolean']>;
  otpVerificationCriteriaLike?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfig?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigAny?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigContain?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigEq?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  recaptchaConfigLike?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  secondaryLogoId?: InputMaybe<Scalars['String']>;
  secondaryLogoIdAny?: InputMaybe<Scalars['String']>;
  secondaryLogoIdContain?: InputMaybe<Scalars['String']>;
  secondaryLogoIdEq?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondaryLogoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  secondaryLogoIdLike?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sendNotifications?: InputMaybe<Scalars['JSON']>;
  sendNotificationsAny?: InputMaybe<Scalars['JSON']>;
  sendNotificationsContain?: InputMaybe<Scalars['JSON']>;
  sendNotificationsEq?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  sendNotificationsIsNull?: InputMaybe<Scalars['Boolean']>;
  sendNotificationsLike?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settings?: InputMaybe<Scalars['JSON']>;
  settingsAny?: InputMaybe<Scalars['JSON']>;
  settingsContain?: InputMaybe<Scalars['JSON']>;
  settingsEq?: InputMaybe<Scalars['JSON']>;
  settingsGt?: InputMaybe<Scalars['JSON']>;
  settingsGte?: InputMaybe<Scalars['JSON']>;
  settingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settingsIsNull?: InputMaybe<Scalars['Boolean']>;
  settingsLike?: InputMaybe<Scalars['JSON']>;
  settingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  settingsLt?: InputMaybe<Scalars['JSON']>;
  settingsLte?: InputMaybe<Scalars['JSON']>;
  settingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  slogan?: InputMaybe<Scalars['String']>;
  sloganAny?: InputMaybe<Scalars['String']>;
  sloganContain?: InputMaybe<Scalars['String']>;
  sloganEq?: InputMaybe<Scalars['String']>;
  sloganGt?: InputMaybe<Scalars['String']>;
  sloganGte?: InputMaybe<Scalars['String']>;
  sloganIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sloganIsNull?: InputMaybe<Scalars['Boolean']>;
  sloganLike?: InputMaybe<Scalars['String']>;
  sloganLikeNoCase?: InputMaybe<Scalars['String']>;
  sloganLt?: InputMaybe<Scalars['String']>;
  sloganLte?: InputMaybe<Scalars['String']>;
  sloganNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateConfig?: InputMaybe<Scalars['JSON']>;
  templateConfigAny?: InputMaybe<Scalars['JSON']>;
  templateConfigContain?: InputMaybe<Scalars['JSON']>;
  templateConfigEq?: InputMaybe<Scalars['JSON']>;
  templateConfigGt?: InputMaybe<Scalars['JSON']>;
  templateConfigGte?: InputMaybe<Scalars['JSON']>;
  templateConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  templateConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  templateConfigLike?: InputMaybe<Scalars['JSON']>;
  templateConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  templateConfigLt?: InputMaybe<Scalars['JSON']>;
  templateConfigLte?: InputMaybe<Scalars['JSON']>;
  templateConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixel?: InputMaybe<Scalars['String']>;
  twitterPixelAny?: InputMaybe<Scalars['String']>;
  twitterPixelContain?: InputMaybe<Scalars['String']>;
  twitterPixelEq?: InputMaybe<Scalars['String']>;
  twitterPixelGt?: InputMaybe<Scalars['String']>;
  twitterPixelGte?: InputMaybe<Scalars['String']>;
  twitterPixelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixelIsNull?: InputMaybe<Scalars['Boolean']>;
  twitterPixelLike?: InputMaybe<Scalars['String']>;
  twitterPixelLikeNoCase?: InputMaybe<Scalars['String']>;
  twitterPixelLt?: InputMaybe<Scalars['String']>;
  twitterPixelLte?: InputMaybe<Scalars['String']>;
  twitterPixelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLUrlsMainArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMain?: InputMaybe<Scalars['Boolean']>;
  isMainAny?: InputMaybe<Scalars['Boolean']>;
  isMainContain?: InputMaybe<Scalars['Boolean']>;
  isMainEq?: InputMaybe<Scalars['Boolean']>;
  isMainGt?: InputMaybe<Scalars['Boolean']>;
  isMainGte?: InputMaybe<Scalars['Boolean']>;
  isMainIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isMainIsNull?: InputMaybe<Scalars['Boolean']>;
  isMainLike?: InputMaybe<Scalars['Boolean']>;
  isMainLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isMainLt?: InputMaybe<Scalars['Boolean']>;
  isMainLte?: InputMaybe<Scalars['Boolean']>;
  isMainNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  meta?: InputMaybe<Scalars['JSON']>;
  metaAny?: InputMaybe<Scalars['JSON']>;
  metaContain?: InputMaybe<Scalars['JSON']>;
  metaEq?: InputMaybe<Scalars['JSON']>;
  metaGt?: InputMaybe<Scalars['JSON']>;
  metaGte?: InputMaybe<Scalars['JSON']>;
  metaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  metaIsNull?: InputMaybe<Scalars['Boolean']>;
  metaLike?: InputMaybe<Scalars['JSON']>;
  metaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  metaLt?: InputMaybe<Scalars['JSON']>;
  metaLte?: InputMaybe<Scalars['JSON']>;
  metaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  model?: InputMaybe<Scalars['String']>;
  modelAny?: InputMaybe<Scalars['String']>;
  modelContain?: InputMaybe<Scalars['String']>;
  modelEq?: InputMaybe<Scalars['String']>;
  modelGt?: InputMaybe<Scalars['String']>;
  modelGte?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['String']>;
  modelIdAny?: InputMaybe<Scalars['String']>;
  modelIdContain?: InputMaybe<Scalars['String']>;
  modelIdEq?: InputMaybe<Scalars['String']>;
  modelIdGt?: InputMaybe<Scalars['String']>;
  modelIdGte?: InputMaybe<Scalars['String']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['String']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['String']>;
  modelIdLt?: InputMaybe<Scalars['String']>;
  modelIdLte?: InputMaybe<Scalars['String']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelIsNull?: InputMaybe<Scalars['Boolean']>;
  modelLike?: InputMaybe<Scalars['String']>;
  modelLikeNoCase?: InputMaybe<Scalars['String']>;
  modelLt?: InputMaybe<Scalars['String']>;
  modelLte?: InputMaybe<Scalars['String']>;
  modelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUrlsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUrlsPropertiesEnum>;
  redirectionStatusCode?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeAny?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeContain?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeEq?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeGte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  redirectionStatusCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  redirectionStatusCodeLike?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLikeNoCase?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLt?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeLte?: InputMaybe<Scalars['Int']>;
  redirectionStatusCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  urlAny?: InputMaybe<Scalars['String']>;
  urlContain?: InputMaybe<Scalars['String']>;
  urlEq?: InputMaybe<Scalars['String']>;
  urlGt?: InputMaybe<Scalars['String']>;
  urlGte?: InputMaybe<Scalars['String']>;
  urlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlIsNull?: InputMaybe<Scalars['Boolean']>;
  urlLike?: InputMaybe<Scalars['String']>;
  urlLikeNoCase?: InputMaybe<Scalars['String']>;
  urlLt?: InputMaybe<Scalars['String']>;
  urlLte?: InputMaybe<Scalars['String']>;
  urlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLUrlsOfferArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checkWallet?: InputMaybe<Scalars['Boolean']>;
  checkWalletAny?: InputMaybe<Scalars['Boolean']>;
  checkWalletContain?: InputMaybe<Scalars['Boolean']>;
  checkWalletEq?: InputMaybe<Scalars['Boolean']>;
  checkWalletGt?: InputMaybe<Scalars['Boolean']>;
  checkWalletGte?: InputMaybe<Scalars['Boolean']>;
  checkWalletIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  checkWalletIsNull?: InputMaybe<Scalars['Boolean']>;
  checkWalletLike?: InputMaybe<Scalars['Boolean']>;
  checkWalletLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  checkWalletLt?: InputMaybe<Scalars['Boolean']>;
  checkWalletLte?: InputMaybe<Scalars['Boolean']>;
  checkWalletNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultAffiliateLinkId?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdAny?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdContain?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdEq?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdGte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  defaultAffiliateLinkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  defaultAffiliateLinkIdLike?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLt?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdLte?: InputMaybe<Scalars['Int']>;
  defaultAffiliateLinkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrl?: InputMaybe<Scalars['String']>;
  displayUrlAny?: InputMaybe<Scalars['String']>;
  displayUrlContain?: InputMaybe<Scalars['String']>;
  displayUrlEq?: InputMaybe<Scalars['String']>;
  displayUrlGt?: InputMaybe<Scalars['String']>;
  displayUrlGte?: InputMaybe<Scalars['String']>;
  displayUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  displayUrlLike?: InputMaybe<Scalars['String']>;
  displayUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  displayUrlLt?: InputMaybe<Scalars['String']>;
  displayUrlLte?: InputMaybe<Scalars['String']>;
  displayUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalData?: InputMaybe<Scalars['JSON']>;
  externalDataAny?: InputMaybe<Scalars['JSON']>;
  externalDataContain?: InputMaybe<Scalars['JSON']>;
  externalDataEq?: InputMaybe<Scalars['JSON']>;
  externalDataGt?: InputMaybe<Scalars['JSON']>;
  externalDataGte?: InputMaybe<Scalars['JSON']>;
  externalDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  externalDataIsNull?: InputMaybe<Scalars['Boolean']>;
  externalDataLike?: InputMaybe<Scalars['JSON']>;
  externalDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  externalDataLt?: InputMaybe<Scalars['JSON']>;
  externalDataLte?: InputMaybe<Scalars['JSON']>;
  externalDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  featuresListTitle?: InputMaybe<Scalars['String']>;
  featuresListTitleAny?: InputMaybe<Scalars['String']>;
  featuresListTitleContain?: InputMaybe<Scalars['String']>;
  featuresListTitleEq?: InputMaybe<Scalars['String']>;
  featuresListTitleGt?: InputMaybe<Scalars['String']>;
  featuresListTitleGte?: InputMaybe<Scalars['String']>;
  featuresListTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuresListTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  featuresListTitleLike?: InputMaybe<Scalars['String']>;
  featuresListTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  featuresListTitleLt?: InputMaybe<Scalars['String']>;
  featuresListTitleLte?: InputMaybe<Scalars['String']>;
  featuresListTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  isPausedAny?: InputMaybe<Scalars['Boolean']>;
  isPausedContain?: InputMaybe<Scalars['Boolean']>;
  isPausedEq?: InputMaybe<Scalars['Boolean']>;
  isPausedGt?: InputMaybe<Scalars['Boolean']>;
  isPausedGte?: InputMaybe<Scalars['Boolean']>;
  isPausedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPausedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPausedLike?: InputMaybe<Scalars['Boolean']>;
  isPausedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPausedLt?: InputMaybe<Scalars['Boolean']>;
  isPausedLte?: InputMaybe<Scalars['Boolean']>;
  isPausedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldOverview?: InputMaybe<Scalars['String']>;
  oldOverviewAny?: InputMaybe<Scalars['String']>;
  oldOverviewContain?: InputMaybe<Scalars['String']>;
  oldOverviewEq?: InputMaybe<Scalars['String']>;
  oldOverviewGt?: InputMaybe<Scalars['String']>;
  oldOverviewGte?: InputMaybe<Scalars['String']>;
  oldOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  oldOverviewLike?: InputMaybe<Scalars['String']>;
  oldOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  oldOverviewLt?: InputMaybe<Scalars['String']>;
  oldOverviewLte?: InputMaybe<Scalars['String']>;
  oldOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLOffersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLOffersPropertiesEnum>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescription?: InputMaybe<Scalars['String']>;
  previewDescriptionAny?: InputMaybe<Scalars['String']>;
  previewDescriptionContain?: InputMaybe<Scalars['String']>;
  previewDescriptionEq?: InputMaybe<Scalars['String']>;
  previewDescriptionGt?: InputMaybe<Scalars['String']>;
  previewDescriptionGte?: InputMaybe<Scalars['String']>;
  previewDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previewDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  previewDescriptionLike?: InputMaybe<Scalars['String']>;
  previewDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  previewDescriptionLt?: InputMaybe<Scalars['String']>;
  previewDescriptionLte?: InputMaybe<Scalars['String']>;
  previewDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverview?: InputMaybe<Scalars['String']>;
  quickOverviewAny?: InputMaybe<Scalars['String']>;
  quickOverviewContain?: InputMaybe<Scalars['String']>;
  quickOverviewEq?: InputMaybe<Scalars['String']>;
  quickOverviewGt?: InputMaybe<Scalars['String']>;
  quickOverviewGte?: InputMaybe<Scalars['String']>;
  quickOverviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quickOverviewIsNull?: InputMaybe<Scalars['Boolean']>;
  quickOverviewLike?: InputMaybe<Scalars['String']>;
  quickOverviewLikeNoCase?: InputMaybe<Scalars['String']>;
  quickOverviewLt?: InputMaybe<Scalars['String']>;
  quickOverviewLte?: InputMaybe<Scalars['String']>;
  quickOverviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  score?: InputMaybe<Scalars['Float']>;
  scoreAny?: InputMaybe<Scalars['Float']>;
  scoreContain?: InputMaybe<Scalars['Float']>;
  scoreEq?: InputMaybe<Scalars['Float']>;
  scoreGt?: InputMaybe<Scalars['Float']>;
  scoreGte?: InputMaybe<Scalars['Float']>;
  scoreIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  scoreIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreLike?: InputMaybe<Scalars['Float']>;
  scoreLikeNoCase?: InputMaybe<Scalars['Float']>;
  scoreLt?: InputMaybe<Scalars['Float']>;
  scoreLte?: InputMaybe<Scalars['Float']>;
  scoreMessage?: InputMaybe<Scalars['String']>;
  scoreMessageAny?: InputMaybe<Scalars['String']>;
  scoreMessageContain?: InputMaybe<Scalars['String']>;
  scoreMessageEq?: InputMaybe<Scalars['String']>;
  scoreMessageGt?: InputMaybe<Scalars['String']>;
  scoreMessageGte?: InputMaybe<Scalars['String']>;
  scoreMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  scoreMessageLike?: InputMaybe<Scalars['String']>;
  scoreMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  scoreMessageLt?: InputMaybe<Scalars['String']>;
  scoreMessageLte?: InputMaybe<Scalars['String']>;
  scoreMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreNotIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleAny?: InputMaybe<Scalars['String']>;
  subTitleContain?: InputMaybe<Scalars['String']>;
  subTitleEq?: InputMaybe<Scalars['String']>;
  subTitleGt?: InputMaybe<Scalars['String']>;
  subTitleGte?: InputMaybe<Scalars['String']>;
  subTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subTitleLike?: InputMaybe<Scalars['String']>;
  subTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subTitleLt?: InputMaybe<Scalars['String']>;
  subTitleLte?: InputMaybe<Scalars['String']>;
  subTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescription?: InputMaybe<Scalars['String']>;
  summaryDescriptionAny?: InputMaybe<Scalars['String']>;
  summaryDescriptionContain?: InputMaybe<Scalars['String']>;
  summaryDescriptionEq?: InputMaybe<Scalars['String']>;
  summaryDescriptionGt?: InputMaybe<Scalars['String']>;
  summaryDescriptionGte?: InputMaybe<Scalars['String']>;
  summaryDescriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryDescriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryDescriptionLike?: InputMaybe<Scalars['String']>;
  summaryDescriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryDescriptionLt?: InputMaybe<Scalars['String']>;
  summaryDescriptionLte?: InputMaybe<Scalars['String']>;
  summaryDescriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitle?: InputMaybe<Scalars['String']>;
  summaryTitleAny?: InputMaybe<Scalars['String']>;
  summaryTitleContain?: InputMaybe<Scalars['String']>;
  summaryTitleEq?: InputMaybe<Scalars['String']>;
  summaryTitleGt?: InputMaybe<Scalars['String']>;
  summaryTitleGte?: InputMaybe<Scalars['String']>;
  summaryTitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  summaryTitleIsNull?: InputMaybe<Scalars['Boolean']>;
  summaryTitleLike?: InputMaybe<Scalars['String']>;
  summaryTitleLikeNoCase?: InputMaybe<Scalars['String']>;
  summaryTitleLt?: InputMaybe<Scalars['String']>;
  summaryTitleLte?: InputMaybe<Scalars['String']>;
  summaryTitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLUrlsPostArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerpt?: InputMaybe<Scalars['String']>;
  excerptAny?: InputMaybe<Scalars['String']>;
  excerptContain?: InputMaybe<Scalars['String']>;
  excerptEq?: InputMaybe<Scalars['String']>;
  excerptGt?: InputMaybe<Scalars['String']>;
  excerptGte?: InputMaybe<Scalars['String']>;
  excerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerptIsNull?: InputMaybe<Scalars['Boolean']>;
  excerptLike?: InputMaybe<Scalars['String']>;
  excerptLikeNoCase?: InputMaybe<Scalars['String']>;
  excerptLt?: InputMaybe<Scalars['String']>;
  excerptLte?: InputMaybe<Scalars['String']>;
  excerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featured?: InputMaybe<Scalars['Boolean']>;
  featuredAny?: InputMaybe<Scalars['Boolean']>;
  featuredContain?: InputMaybe<Scalars['Boolean']>;
  featuredEq?: InputMaybe<Scalars['Boolean']>;
  featuredGt?: InputMaybe<Scalars['Boolean']>;
  featuredGte?: InputMaybe<Scalars['Boolean']>;
  featuredIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  featuredIsNull?: InputMaybe<Scalars['Boolean']>;
  featuredLike?: InputMaybe<Scalars['Boolean']>;
  featuredLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  featuredLt?: InputMaybe<Scalars['Boolean']>;
  featuredLte?: InputMaybe<Scalars['Boolean']>;
  featuredNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  fullBody?: InputMaybe<Scalars['String']>;
  fullBodyAny?: InputMaybe<Scalars['String']>;
  fullBodyContain?: InputMaybe<Scalars['String']>;
  fullBodyEq?: InputMaybe<Scalars['String']>;
  fullBodyGt?: InputMaybe<Scalars['String']>;
  fullBodyGte?: InputMaybe<Scalars['String']>;
  fullBodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullBodyIsNull?: InputMaybe<Scalars['Boolean']>;
  fullBodyLike?: InputMaybe<Scalars['String']>;
  fullBodyLikeNoCase?: InputMaybe<Scalars['String']>;
  fullBodyLt?: InputMaybe<Scalars['String']>;
  fullBodyLte?: InputMaybe<Scalars['String']>;
  fullBodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldExcerpt?: InputMaybe<Scalars['String']>;
  oldExcerptAny?: InputMaybe<Scalars['String']>;
  oldExcerptContain?: InputMaybe<Scalars['String']>;
  oldExcerptEq?: InputMaybe<Scalars['String']>;
  oldExcerptGt?: InputMaybe<Scalars['String']>;
  oldExcerptGte?: InputMaybe<Scalars['String']>;
  oldExcerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldExcerptIsNull?: InputMaybe<Scalars['Boolean']>;
  oldExcerptLike?: InputMaybe<Scalars['String']>;
  oldExcerptLikeNoCase?: InputMaybe<Scalars['String']>;
  oldExcerptLt?: InputMaybe<Scalars['String']>;
  oldExcerptLte?: InputMaybe<Scalars['String']>;
  oldExcerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLPostsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLPostsPropertiesEnum>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedAny?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['String']>;
  publishedAtAny?: InputMaybe<Scalars['String']>;
  publishedAtContain?: InputMaybe<Scalars['String']>;
  publishedAtEq?: InputMaybe<Scalars['String']>;
  publishedAtGt?: InputMaybe<Scalars['String']>;
  publishedAtGte?: InputMaybe<Scalars['String']>;
  publishedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedAtLike?: InputMaybe<Scalars['String']>;
  publishedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  publishedAtLt?: InputMaybe<Scalars['String']>;
  publishedAtLte?: InputMaybe<Scalars['String']>;
  publishedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedContain?: InputMaybe<Scalars['Boolean']>;
  publishedEq?: InputMaybe<Scalars['Boolean']>;
  publishedGt?: InputMaybe<Scalars['Boolean']>;
  publishedGte?: InputMaybe<Scalars['Boolean']>;
  publishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  publishedIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedLike?: InputMaybe<Scalars['Boolean']>;
  publishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  publishedLt?: InputMaybe<Scalars['Boolean']>;
  publishedLte?: InputMaybe<Scalars['Boolean']>;
  publishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Scalars['Int']>;
  typeIdAny?: InputMaybe<Scalars['Int']>;
  typeIdContain?: InputMaybe<Scalars['Int']>;
  typeIdEq?: InputMaybe<Scalars['Int']>;
  typeIdGt?: InputMaybe<Scalars['Int']>;
  typeIdGte?: InputMaybe<Scalars['Int']>;
  typeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  typeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  typeIdLike?: InputMaybe<Scalars['Int']>;
  typeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  typeIdLt?: InputMaybe<Scalars['Int']>;
  typeIdLte?: InputMaybe<Scalars['Int']>;
  typeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLUrlsTagArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLTagsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTagsPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLUrlsPropertiesEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DomainId = 'domainId',
  Id = 'id',
  IsActive = 'isActive',
  IsDeleted = 'isDeleted',
  IsMain = 'isMain',
  Language = 'language',
  Meta = 'meta',
  Model = 'model',
  ModelId = 'modelId',
  RedirectionStatusCode = 'redirectionStatusCode',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy',
  Url = 'url'
}

export type GQLUserRoles = {
  __typename?: 'UserRoles';
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  roleCodeName?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
  rolePolicies?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<GQLUsers>>>;
};


export type GQLUserRolesUsersArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLUserRolesPropertiesEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  IsDeleted = 'isDeleted',
  RoleCodeName = 'roleCodeName',
  RoleName = 'roleName',
  RolePolicies = 'rolePolicies',
  UpdatedAt = 'updatedAt'
}

export type GQLUsers = {
  __typename?: 'Users';
  accessibleEntities?: Maybe<Scalars['JSON']>;
  apiKey?: Maybe<Scalars['String']>;
  apiSecret?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  callCenterId?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<GQLCategories>>>;
  countryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  directManager?: Maybe<GQLUsers>;
  directManagerId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailConfirmToken?: Maybe<Scalars['String']>;
  githubToken?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isConfirmedRegistration?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  maxSessions?: Maybe<Scalars['Int']>;
  mobileNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  newEmail?: Maybe<Scalars['String']>;
  newMobileNumber?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  nicknameSlug?: Maybe<Scalars['String']>;
  passwordHash?: Maybe<Scalars['String']>;
  policies?: Maybe<Scalars['JSON']>;
  position?: Maybe<Scalars['String']>;
  posts?: Maybe<Array<Maybe<GQLPosts>>>;
  preferredLanguage?: Maybe<Scalars['String']>;
  profileImage?: Maybe<GQLAttachments>;
  profileImageId?: Maybe<Scalars['String']>;
  resetPasswordCode?: Maybe<Scalars['String']>;
  resetPasswordOTP?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  roleInfo?: Maybe<GQLUserRoles>;
  slackId?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  team?: Maybe<Array<Maybe<GQLUsers>>>;
  trafficSources?: Maybe<Array<Maybe<GQLTrafficSourceMap>>>;
  updateToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userRole?: Maybe<GQLUserRoles>;
  verifyCode?: Maybe<Scalars['String']>;
};


export type GQLUsersCategoriesArgs = {
  TCPAMessage?: InputMaybe<Scalars['String']>;
  TCPAMessageAny?: InputMaybe<Scalars['String']>;
  TCPAMessageContain?: InputMaybe<Scalars['String']>;
  TCPAMessageEq?: InputMaybe<Scalars['String']>;
  TCPAMessageGt?: InputMaybe<Scalars['String']>;
  TCPAMessageGte?: InputMaybe<Scalars['String']>;
  TCPAMessageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TCPAMessageIsNull?: InputMaybe<Scalars['Boolean']>;
  TCPAMessageLike?: InputMaybe<Scalars['String']>;
  TCPAMessageLikeNoCase?: InputMaybe<Scalars['String']>;
  TCPAMessageLt?: InputMaybe<Scalars['String']>;
  TCPAMessageLte?: InputMaybe<Scalars['String']>;
  TCPAMessageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetite?: InputMaybe<Scalars['String']>;
  appetiteAny?: InputMaybe<Scalars['String']>;
  appetiteContain?: InputMaybe<Scalars['String']>;
  appetiteEq?: InputMaybe<Scalars['String']>;
  appetiteGt?: InputMaybe<Scalars['String']>;
  appetiteGte?: InputMaybe<Scalars['String']>;
  appetiteIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appetiteIsNull?: InputMaybe<Scalars['Boolean']>;
  appetiteLike?: InputMaybe<Scalars['String']>;
  appetiteLikeNoCase?: InputMaybe<Scalars['String']>;
  appetiteLt?: InputMaybe<Scalars['String']>;
  appetiteLte?: InputMaybe<Scalars['String']>;
  appetiteNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoListing?: InputMaybe<Scalars['Boolean']>;
  autoListingAny?: InputMaybe<Scalars['Boolean']>;
  autoListingContain?: InputMaybe<Scalars['Boolean']>;
  autoListingEq?: InputMaybe<Scalars['Boolean']>;
  autoListingGt?: InputMaybe<Scalars['Boolean']>;
  autoListingGte?: InputMaybe<Scalars['Boolean']>;
  autoListingIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  autoListingIsNull?: InputMaybe<Scalars['Boolean']>;
  autoListingLike?: InputMaybe<Scalars['Boolean']>;
  autoListingLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  autoListingLt?: InputMaybe<Scalars['Boolean']>;
  autoListingLte?: InputMaybe<Scalars['Boolean']>;
  autoListingNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  bestMatchCount?: InputMaybe<Scalars['Int']>;
  bestMatchCountAny?: InputMaybe<Scalars['Int']>;
  bestMatchCountContain?: InputMaybe<Scalars['Int']>;
  bestMatchCountEq?: InputMaybe<Scalars['Int']>;
  bestMatchCountGt?: InputMaybe<Scalars['Int']>;
  bestMatchCountGte?: InputMaybe<Scalars['Int']>;
  bestMatchCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bestMatchCountIsNull?: InputMaybe<Scalars['Boolean']>;
  bestMatchCountLike?: InputMaybe<Scalars['Int']>;
  bestMatchCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  bestMatchCountLt?: InputMaybe<Scalars['Int']>;
  bestMatchCountLte?: InputMaybe<Scalars['Int']>;
  bestMatchCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fetchedBuyersCount?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountAny?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountContain?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountEq?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountGte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fetchedBuyersCountIsNull?: InputMaybe<Scalars['Boolean']>;
  fetchedBuyersCountLike?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLikeNoCase?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLt?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountLte?: InputMaybe<Scalars['Int']>;
  fetchedBuyersCountNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headlineAny?: InputMaybe<Scalars['String']>;
  headlineContain?: InputMaybe<Scalars['String']>;
  headlineEq?: InputMaybe<Scalars['String']>;
  headlineGt?: InputMaybe<Scalars['String']>;
  headlineGte?: InputMaybe<Scalars['String']>;
  headlineIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIsNull?: InputMaybe<Scalars['Boolean']>;
  headlineLike?: InputMaybe<Scalars['String']>;
  headlineLikeNoCase?: InputMaybe<Scalars['String']>;
  headlineLt?: InputMaybe<Scalars['String']>;
  headlineLte?: InputMaybe<Scalars['String']>;
  headlineNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconId?: InputMaybe<Scalars['String']>;
  iconIdAny?: InputMaybe<Scalars['String']>;
  iconIdContain?: InputMaybe<Scalars['String']>;
  iconIdEq?: InputMaybe<Scalars['String']>;
  iconIdGt?: InputMaybe<Scalars['String']>;
  iconIdGte?: InputMaybe<Scalars['String']>;
  iconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  iconIdLike?: InputMaybe<Scalars['String']>;
  iconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  iconIdLt?: InputMaybe<Scalars['String']>;
  iconIdLte?: InputMaybe<Scalars['String']>;
  iconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBestMatch?: InputMaybe<Scalars['Boolean']>;
  isBestMatchAny?: InputMaybe<Scalars['Boolean']>;
  isBestMatchContain?: InputMaybe<Scalars['Boolean']>;
  isBestMatchEq?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchGte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBestMatchIsNull?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLike?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLt?: InputMaybe<Scalars['Boolean']>;
  isBestMatchLte?: InputMaybe<Scalars['Boolean']>;
  isBestMatchNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsent?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentAny?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentContain?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentEq?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentGte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOneToOneConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLike?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLt?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentLte?: InputMaybe<Scalars['Boolean']>;
  isOneToOneConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isPublishedAny?: InputMaybe<Scalars['Boolean']>;
  isPublishedContain?: InputMaybe<Scalars['Boolean']>;
  isPublishedEq?: InputMaybe<Scalars['Boolean']>;
  isPublishedGt?: InputMaybe<Scalars['Boolean']>;
  isPublishedGte?: InputMaybe<Scalars['Boolean']>;
  isPublishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isPublishedIsNull?: InputMaybe<Scalars['Boolean']>;
  isPublishedLike?: InputMaybe<Scalars['Boolean']>;
  isPublishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isPublishedLt?: InputMaybe<Scalars['Boolean']>;
  isPublishedLte?: InputMaybe<Scalars['Boolean']>;
  isPublishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  label?: InputMaybe<Scalars['String']>;
  labelAny?: InputMaybe<Scalars['String']>;
  labelContain?: InputMaybe<Scalars['String']>;
  labelEq?: InputMaybe<Scalars['String']>;
  labelGt?: InputMaybe<Scalars['String']>;
  labelGte?: InputMaybe<Scalars['String']>;
  labelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  labelIsNull?: InputMaybe<Scalars['Boolean']>;
  labelLike?: InputMaybe<Scalars['String']>;
  labelLikeNoCase?: InputMaybe<Scalars['String']>;
  labelLt?: InputMaybe<Scalars['String']>;
  labelLte?: InputMaybe<Scalars['String']>;
  labelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mainImageId?: InputMaybe<Scalars['String']>;
  mainImageIdAny?: InputMaybe<Scalars['String']>;
  mainImageIdContain?: InputMaybe<Scalars['String']>;
  mainImageIdEq?: InputMaybe<Scalars['String']>;
  mainImageIdGt?: InputMaybe<Scalars['String']>;
  mainImageIdGte?: InputMaybe<Scalars['String']>;
  mainImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  mainImageIdLike?: InputMaybe<Scalars['String']>;
  mainImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  mainImageIdLt?: InputMaybe<Scalars['String']>;
  mainImageIdLte?: InputMaybe<Scalars['String']>;
  mainImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notes?: InputMaybe<Scalars['String']>;
  notesAny?: InputMaybe<Scalars['String']>;
  notesContain?: InputMaybe<Scalars['String']>;
  notesEq?: InputMaybe<Scalars['String']>;
  notesGt?: InputMaybe<Scalars['String']>;
  notesGte?: InputMaybe<Scalars['String']>;
  notesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notesIsNull?: InputMaybe<Scalars['Boolean']>;
  notesLike?: InputMaybe<Scalars['String']>;
  notesLikeNoCase?: InputMaybe<Scalars['String']>;
  notesLt?: InputMaybe<Scalars['String']>;
  notesLte?: InputMaybe<Scalars['String']>;
  notesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order?: InputMaybe<Scalars['Int']>;
  orderAny?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLCategoriesPropertiesEnum>;
  orderContain?: InputMaybe<Scalars['Int']>;
  orderEq?: InputMaybe<Scalars['Int']>;
  orderGt?: InputMaybe<Scalars['Int']>;
  orderGte?: InputMaybe<Scalars['Int']>;
  orderIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderIsNull?: InputMaybe<Scalars['Boolean']>;
  orderLike?: InputMaybe<Scalars['Int']>;
  orderLikeNoCase?: InputMaybe<Scalars['Int']>;
  orderLt?: InputMaybe<Scalars['Int']>;
  orderLte?: InputMaybe<Scalars['Int']>;
  orderNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  overview?: InputMaybe<Scalars['String']>;
  overviewAny?: InputMaybe<Scalars['String']>;
  overviewContain?: InputMaybe<Scalars['String']>;
  overviewEq?: InputMaybe<Scalars['String']>;
  overviewGt?: InputMaybe<Scalars['String']>;
  overviewGte?: InputMaybe<Scalars['String']>;
  overviewIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overviewIsNull?: InputMaybe<Scalars['Boolean']>;
  overviewLike?: InputMaybe<Scalars['String']>;
  overviewLikeNoCase?: InputMaybe<Scalars['String']>;
  overviewLt?: InputMaybe<Scalars['String']>;
  overviewLte?: InputMaybe<Scalars['String']>;
  overviewNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['Int']>;
  parentIdAny?: InputMaybe<Scalars['Int']>;
  parentIdContain?: InputMaybe<Scalars['Int']>;
  parentIdEq?: InputMaybe<Scalars['Int']>;
  parentIdGt?: InputMaybe<Scalars['Int']>;
  parentIdGte?: InputMaybe<Scalars['Int']>;
  parentIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  parentIdIsNull?: InputMaybe<Scalars['Boolean']>;
  parentIdLike?: InputMaybe<Scalars['Int']>;
  parentIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  parentIdLt?: InputMaybe<Scalars['Int']>;
  parentIdLte?: InputMaybe<Scalars['Int']>;
  parentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requiresConsent?: InputMaybe<Scalars['Boolean']>;
  requiresConsentAny?: InputMaybe<Scalars['Boolean']>;
  requiresConsentContain?: InputMaybe<Scalars['Boolean']>;
  requiresConsentEq?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentGte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  requiresConsentIsNull?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLike?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLt?: InputMaybe<Scalars['Boolean']>;
  requiresConsentLte?: InputMaybe<Scalars['Boolean']>;
  requiresConsentNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  sharedBuyersGroupSize?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeAny?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeContain?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeEq?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeGte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sharedBuyersGroupSizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sharedBuyersGroupSizeLike?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLt?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeLte?: InputMaybe<Scalars['Int']>;
  sharedBuyersGroupSizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugAlias?: InputMaybe<Scalars['String']>;
  slugAliasAny?: InputMaybe<Scalars['String']>;
  slugAliasContain?: InputMaybe<Scalars['String']>;
  slugAliasEq?: InputMaybe<Scalars['String']>;
  slugAliasGt?: InputMaybe<Scalars['String']>;
  slugAliasGte?: InputMaybe<Scalars['String']>;
  slugAliasIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAliasIsNull?: InputMaybe<Scalars['Boolean']>;
  slugAliasLike?: InputMaybe<Scalars['String']>;
  slugAliasLikeNoCase?: InputMaybe<Scalars['String']>;
  slugAliasLt?: InputMaybe<Scalars['String']>;
  slugAliasLte?: InputMaybe<Scalars['String']>;
  slugAliasNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitleAny?: InputMaybe<Scalars['String']>;
  subtitleContain?: InputMaybe<Scalars['String']>;
  subtitleEq?: InputMaybe<Scalars['String']>;
  subtitleGt?: InputMaybe<Scalars['String']>;
  subtitleGte?: InputMaybe<Scalars['String']>;
  subtitleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitleIsNull?: InputMaybe<Scalars['Boolean']>;
  subtitleLike?: InputMaybe<Scalars['String']>;
  subtitleLikeNoCase?: InputMaybe<Scalars['String']>;
  subtitleLt?: InputMaybe<Scalars['String']>;
  subtitleLte?: InputMaybe<Scalars['String']>;
  subtitleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportedCountries?: InputMaybe<Scalars['JSON']>;
  supportedCountriesAny?: InputMaybe<Scalars['JSON']>;
  supportedCountriesContain?: InputMaybe<Scalars['JSON']>;
  supportedCountriesEq?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesGte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  supportedCountriesIsNull?: InputMaybe<Scalars['Boolean']>;
  supportedCountriesLike?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLt?: InputMaybe<Scalars['JSON']>;
  supportedCountriesLte?: InputMaybe<Scalars['JSON']>;
  supportedCountriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLUsersDirectManagerArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLUsersPostsArgs = {
  body?: InputMaybe<Scalars['String']>;
  bodyAny?: InputMaybe<Scalars['String']>;
  bodyContain?: InputMaybe<Scalars['String']>;
  bodyEq?: InputMaybe<Scalars['String']>;
  bodyGt?: InputMaybe<Scalars['String']>;
  bodyGte?: InputMaybe<Scalars['String']>;
  bodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bodyIsNull?: InputMaybe<Scalars['Boolean']>;
  bodyLike?: InputMaybe<Scalars['String']>;
  bodyLikeNoCase?: InputMaybe<Scalars['String']>;
  bodyLt?: InputMaybe<Scalars['String']>;
  bodyLte?: InputMaybe<Scalars['String']>;
  bodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  editedBy?: InputMaybe<Scalars['String']>;
  editedByAny?: InputMaybe<Scalars['String']>;
  editedByContain?: InputMaybe<Scalars['String']>;
  editedByEq?: InputMaybe<Scalars['String']>;
  editedByGt?: InputMaybe<Scalars['String']>;
  editedByGte?: InputMaybe<Scalars['String']>;
  editedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editedByIsNull?: InputMaybe<Scalars['Boolean']>;
  editedByLike?: InputMaybe<Scalars['String']>;
  editedByLikeNoCase?: InputMaybe<Scalars['String']>;
  editedByLt?: InputMaybe<Scalars['String']>;
  editedByLte?: InputMaybe<Scalars['String']>;
  editedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerpt?: InputMaybe<Scalars['String']>;
  excerptAny?: InputMaybe<Scalars['String']>;
  excerptContain?: InputMaybe<Scalars['String']>;
  excerptEq?: InputMaybe<Scalars['String']>;
  excerptGt?: InputMaybe<Scalars['String']>;
  excerptGte?: InputMaybe<Scalars['String']>;
  excerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excerptIsNull?: InputMaybe<Scalars['Boolean']>;
  excerptLike?: InputMaybe<Scalars['String']>;
  excerptLikeNoCase?: InputMaybe<Scalars['String']>;
  excerptLt?: InputMaybe<Scalars['String']>;
  excerptLte?: InputMaybe<Scalars['String']>;
  excerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featured?: InputMaybe<Scalars['Boolean']>;
  featuredAny?: InputMaybe<Scalars['Boolean']>;
  featuredContain?: InputMaybe<Scalars['Boolean']>;
  featuredEq?: InputMaybe<Scalars['Boolean']>;
  featuredGt?: InputMaybe<Scalars['Boolean']>;
  featuredGte?: InputMaybe<Scalars['Boolean']>;
  featuredIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  featuredIsNull?: InputMaybe<Scalars['Boolean']>;
  featuredLike?: InputMaybe<Scalars['Boolean']>;
  featuredLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  featuredLt?: InputMaybe<Scalars['Boolean']>;
  featuredLte?: InputMaybe<Scalars['Boolean']>;
  featuredNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  fullBody?: InputMaybe<Scalars['String']>;
  fullBodyAny?: InputMaybe<Scalars['String']>;
  fullBodyContain?: InputMaybe<Scalars['String']>;
  fullBodyEq?: InputMaybe<Scalars['String']>;
  fullBodyGt?: InputMaybe<Scalars['String']>;
  fullBodyGte?: InputMaybe<Scalars['String']>;
  fullBodyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullBodyIsNull?: InputMaybe<Scalars['Boolean']>;
  fullBodyLike?: InputMaybe<Scalars['String']>;
  fullBodyLikeNoCase?: InputMaybe<Scalars['String']>;
  fullBodyLt?: InputMaybe<Scalars['String']>;
  fullBodyLte?: InputMaybe<Scalars['String']>;
  fullBodyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageId?: InputMaybe<Scalars['String']>;
  imageIdAny?: InputMaybe<Scalars['String']>;
  imageIdContain?: InputMaybe<Scalars['String']>;
  imageIdEq?: InputMaybe<Scalars['String']>;
  imageIdGt?: InputMaybe<Scalars['String']>;
  imageIdGte?: InputMaybe<Scalars['String']>;
  imageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  imageIdLike?: InputMaybe<Scalars['String']>;
  imageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  imageIdLt?: InputMaybe<Scalars['String']>;
  imageIdLte?: InputMaybe<Scalars['String']>;
  imageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  languages?: InputMaybe<Scalars['JSON']>;
  languagesAny?: InputMaybe<Scalars['JSON']>;
  languagesContain?: InputMaybe<Scalars['JSON']>;
  languagesEq?: InputMaybe<Scalars['JSON']>;
  languagesGt?: InputMaybe<Scalars['JSON']>;
  languagesGte?: InputMaybe<Scalars['JSON']>;
  languagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  languagesIsNull?: InputMaybe<Scalars['Boolean']>;
  languagesLike?: InputMaybe<Scalars['JSON']>;
  languagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  languagesLt?: InputMaybe<Scalars['JSON']>;
  languagesLte?: InputMaybe<Scalars['JSON']>;
  languagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  oldExcerpt?: InputMaybe<Scalars['String']>;
  oldExcerptAny?: InputMaybe<Scalars['String']>;
  oldExcerptContain?: InputMaybe<Scalars['String']>;
  oldExcerptEq?: InputMaybe<Scalars['String']>;
  oldExcerptGt?: InputMaybe<Scalars['String']>;
  oldExcerptGte?: InputMaybe<Scalars['String']>;
  oldExcerptIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldExcerptIsNull?: InputMaybe<Scalars['Boolean']>;
  oldExcerptLike?: InputMaybe<Scalars['String']>;
  oldExcerptLikeNoCase?: InputMaybe<Scalars['String']>;
  oldExcerptLt?: InputMaybe<Scalars['String']>;
  oldExcerptLte?: InputMaybe<Scalars['String']>;
  oldExcerptNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<GQLPostsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLPostsPropertiesEnum>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedAny?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['String']>;
  publishedAtAny?: InputMaybe<Scalars['String']>;
  publishedAtContain?: InputMaybe<Scalars['String']>;
  publishedAtEq?: InputMaybe<Scalars['String']>;
  publishedAtGt?: InputMaybe<Scalars['String']>;
  publishedAtGte?: InputMaybe<Scalars['String']>;
  publishedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedAtLike?: InputMaybe<Scalars['String']>;
  publishedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  publishedAtLt?: InputMaybe<Scalars['String']>;
  publishedAtLte?: InputMaybe<Scalars['String']>;
  publishedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedContain?: InputMaybe<Scalars['Boolean']>;
  publishedEq?: InputMaybe<Scalars['Boolean']>;
  publishedGt?: InputMaybe<Scalars['Boolean']>;
  publishedGte?: InputMaybe<Scalars['Boolean']>;
  publishedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  publishedIsNull?: InputMaybe<Scalars['Boolean']>;
  publishedLike?: InputMaybe<Scalars['Boolean']>;
  publishedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  publishedLt?: InputMaybe<Scalars['Boolean']>;
  publishedLte?: InputMaybe<Scalars['Boolean']>;
  publishedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Scalars['Int']>;
  typeIdAny?: InputMaybe<Scalars['Int']>;
  typeIdContain?: InputMaybe<Scalars['Int']>;
  typeIdEq?: InputMaybe<Scalars['Int']>;
  typeIdGt?: InputMaybe<Scalars['Int']>;
  typeIdGte?: InputMaybe<Scalars['Int']>;
  typeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  typeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  typeIdLike?: InputMaybe<Scalars['Int']>;
  typeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  typeIdLt?: InputMaybe<Scalars['Int']>;
  typeIdLte?: InputMaybe<Scalars['Int']>;
  typeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedByAny?: InputMaybe<Scalars['String']>;
  updatedByContain?: InputMaybe<Scalars['String']>;
  updatedByEq?: InputMaybe<Scalars['String']>;
  updatedByGt?: InputMaybe<Scalars['String']>;
  updatedByGte?: InputMaybe<Scalars['String']>;
  updatedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedByIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedByLike?: InputMaybe<Scalars['String']>;
  updatedByLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedByLt?: InputMaybe<Scalars['String']>;
  updatedByLte?: InputMaybe<Scalars['String']>;
  updatedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Int']>;
  weightAny?: InputMaybe<Scalars['Int']>;
  weightContain?: InputMaybe<Scalars['Int']>;
  weightEq?: InputMaybe<Scalars['Int']>;
  weightGt?: InputMaybe<Scalars['Int']>;
  weightGte?: InputMaybe<Scalars['Int']>;
  weightIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weightIsNull?: InputMaybe<Scalars['Boolean']>;
  weightLike?: InputMaybe<Scalars['Int']>;
  weightLikeNoCase?: InputMaybe<Scalars['Int']>;
  weightLt?: InputMaybe<Scalars['Int']>;
  weightLte?: InputMaybe<Scalars['Int']>;
  weightNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  writtenBy?: InputMaybe<Scalars['String']>;
  writtenByAny?: InputMaybe<Scalars['String']>;
  writtenByContain?: InputMaybe<Scalars['String']>;
  writtenByEq?: InputMaybe<Scalars['String']>;
  writtenByGt?: InputMaybe<Scalars['String']>;
  writtenByGte?: InputMaybe<Scalars['String']>;
  writtenByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  writtenByIsNull?: InputMaybe<Scalars['Boolean']>;
  writtenByLike?: InputMaybe<Scalars['String']>;
  writtenByLikeNoCase?: InputMaybe<Scalars['String']>;
  writtenByLt?: InputMaybe<Scalars['String']>;
  writtenByLte?: InputMaybe<Scalars['String']>;
  writtenByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLUsersProfileImageArgs = {
  access?: InputMaybe<Scalars['String']>;
  accessAny?: InputMaybe<Scalars['String']>;
  accessContain?: InputMaybe<Scalars['String']>;
  accessEq?: InputMaybe<Scalars['String']>;
  accessGt?: InputMaybe<Scalars['String']>;
  accessGte?: InputMaybe<Scalars['String']>;
  accessIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accessIsNull?: InputMaybe<Scalars['Boolean']>;
  accessLike?: InputMaybe<Scalars['String']>;
  accessLikeNoCase?: InputMaybe<Scalars['String']>;
  accessLt?: InputMaybe<Scalars['String']>;
  accessLte?: InputMaybe<Scalars['String']>;
  accessNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alt?: InputMaybe<Scalars['String']>;
  altAny?: InputMaybe<Scalars['String']>;
  altContain?: InputMaybe<Scalars['String']>;
  altEq?: InputMaybe<Scalars['String']>;
  altGt?: InputMaybe<Scalars['String']>;
  altGte?: InputMaybe<Scalars['String']>;
  altIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  altIsNull?: InputMaybe<Scalars['Boolean']>;
  altLike?: InputMaybe<Scalars['String']>;
  altLikeNoCase?: InputMaybe<Scalars['String']>;
  altLt?: InputMaybe<Scalars['String']>;
  altLte?: InputMaybe<Scalars['String']>;
  altNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caption?: InputMaybe<Scalars['String']>;
  captionAny?: InputMaybe<Scalars['String']>;
  captionContain?: InputMaybe<Scalars['String']>;
  captionEq?: InputMaybe<Scalars['String']>;
  captionGt?: InputMaybe<Scalars['String']>;
  captionGte?: InputMaybe<Scalars['String']>;
  captionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  captionIsNull?: InputMaybe<Scalars['Boolean']>;
  captionLike?: InputMaybe<Scalars['String']>;
  captionLikeNoCase?: InputMaybe<Scalars['String']>;
  captionLt?: InputMaybe<Scalars['String']>;
  captionLte?: InputMaybe<Scalars['String']>;
  captionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIdAny?: InputMaybe<Scalars['Int']>;
  categoryIdContain?: InputMaybe<Scalars['Int']>;
  categoryIdEq?: InputMaybe<Scalars['Int']>;
  categoryIdGt?: InputMaybe<Scalars['Int']>;
  categoryIdGte?: InputMaybe<Scalars['Int']>;
  categoryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  categoryIdLike?: InputMaybe<Scalars['Int']>;
  categoryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  categoryIdLt?: InputMaybe<Scalars['Int']>;
  categoryIdLte?: InputMaybe<Scalars['Int']>;
  categoryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  fullPath?: InputMaybe<Scalars['String']>;
  fullPathAny?: InputMaybe<Scalars['String']>;
  fullPathContain?: InputMaybe<Scalars['String']>;
  fullPathEq?: InputMaybe<Scalars['String']>;
  fullPathGt?: InputMaybe<Scalars['String']>;
  fullPathGte?: InputMaybe<Scalars['String']>;
  fullPathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullPathIsNull?: InputMaybe<Scalars['Boolean']>;
  fullPathLike?: InputMaybe<Scalars['String']>;
  fullPathLikeNoCase?: InputMaybe<Scalars['String']>;
  fullPathLt?: InputMaybe<Scalars['String']>;
  fullPathLte?: InputMaybe<Scalars['String']>;
  fullPathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mimeType?: InputMaybe<Scalars['String']>;
  mimeTypeAny?: InputMaybe<Scalars['String']>;
  mimeTypeContain?: InputMaybe<Scalars['String']>;
  mimeTypeEq?: InputMaybe<Scalars['String']>;
  mimeTypeGt?: InputMaybe<Scalars['String']>;
  mimeTypeGte?: InputMaybe<Scalars['String']>;
  mimeTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mimeTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  mimeTypeLike?: InputMaybe<Scalars['String']>;
  mimeTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  mimeTypeLt?: InputMaybe<Scalars['String']>;
  mimeTypeLte?: InputMaybe<Scalars['String']>;
  mimeTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAttachmentsPropertiesEnum>;
  originalName?: InputMaybe<Scalars['String']>;
  originalNameAny?: InputMaybe<Scalars['String']>;
  originalNameContain?: InputMaybe<Scalars['String']>;
  originalNameEq?: InputMaybe<Scalars['String']>;
  originalNameGt?: InputMaybe<Scalars['String']>;
  originalNameGte?: InputMaybe<Scalars['String']>;
  originalNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  originalNameIsNull?: InputMaybe<Scalars['Boolean']>;
  originalNameLike?: InputMaybe<Scalars['String']>;
  originalNameLikeNoCase?: InputMaybe<Scalars['String']>;
  originalNameLt?: InputMaybe<Scalars['String']>;
  originalNameLte?: InputMaybe<Scalars['String']>;
  originalNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  path?: InputMaybe<Scalars['String']>;
  pathAny?: InputMaybe<Scalars['String']>;
  pathContain?: InputMaybe<Scalars['String']>;
  pathEq?: InputMaybe<Scalars['String']>;
  pathGt?: InputMaybe<Scalars['String']>;
  pathGte?: InputMaybe<Scalars['String']>;
  pathIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pathIsNull?: InputMaybe<Scalars['Boolean']>;
  pathLike?: InputMaybe<Scalars['String']>;
  pathLikeNoCase?: InputMaybe<Scalars['String']>;
  pathLt?: InputMaybe<Scalars['String']>;
  pathLte?: InputMaybe<Scalars['String']>;
  pathNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  size?: InputMaybe<Scalars['Int']>;
  sizeAny?: InputMaybe<Scalars['Int']>;
  sizeContain?: InputMaybe<Scalars['Int']>;
  sizeEq?: InputMaybe<Scalars['Int']>;
  sizeGt?: InputMaybe<Scalars['Int']>;
  sizeGte?: InputMaybe<Scalars['Int']>;
  sizeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizeIsNull?: InputMaybe<Scalars['Boolean']>;
  sizeLike?: InputMaybe<Scalars['Int']>;
  sizeLikeNoCase?: InputMaybe<Scalars['Int']>;
  sizeLt?: InputMaybe<Scalars['Int']>;
  sizeLte?: InputMaybe<Scalars['Int']>;
  sizeNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLUsersRoleInfoArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUserRolesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUserRolesPropertiesEnum>;
  roleCodeName?: InputMaybe<Scalars['String']>;
  roleCodeNameAny?: InputMaybe<Scalars['String']>;
  roleCodeNameContain?: InputMaybe<Scalars['String']>;
  roleCodeNameEq?: InputMaybe<Scalars['String']>;
  roleCodeNameGt?: InputMaybe<Scalars['String']>;
  roleCodeNameGte?: InputMaybe<Scalars['String']>;
  roleCodeNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleCodeNameIsNull?: InputMaybe<Scalars['Boolean']>;
  roleCodeNameLike?: InputMaybe<Scalars['String']>;
  roleCodeNameLikeNoCase?: InputMaybe<Scalars['String']>;
  roleCodeNameLt?: InputMaybe<Scalars['String']>;
  roleCodeNameLte?: InputMaybe<Scalars['String']>;
  roleCodeNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleName?: InputMaybe<Scalars['String']>;
  roleNameAny?: InputMaybe<Scalars['String']>;
  roleNameContain?: InputMaybe<Scalars['String']>;
  roleNameEq?: InputMaybe<Scalars['String']>;
  roleNameGt?: InputMaybe<Scalars['String']>;
  roleNameGte?: InputMaybe<Scalars['String']>;
  roleNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleNameIsNull?: InputMaybe<Scalars['Boolean']>;
  roleNameLike?: InputMaybe<Scalars['String']>;
  roleNameLikeNoCase?: InputMaybe<Scalars['String']>;
  roleNameLt?: InputMaybe<Scalars['String']>;
  roleNameLte?: InputMaybe<Scalars['String']>;
  roleNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rolePolicies?: InputMaybe<Scalars['JSON']>;
  rolePoliciesAny?: InputMaybe<Scalars['JSON']>;
  rolePoliciesContain?: InputMaybe<Scalars['JSON']>;
  rolePoliciesEq?: InputMaybe<Scalars['JSON']>;
  rolePoliciesGt?: InputMaybe<Scalars['JSON']>;
  rolePoliciesGte?: InputMaybe<Scalars['JSON']>;
  rolePoliciesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  rolePoliciesIsNull?: InputMaybe<Scalars['Boolean']>;
  rolePoliciesLike?: InputMaybe<Scalars['JSON']>;
  rolePoliciesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  rolePoliciesLt?: InputMaybe<Scalars['JSON']>;
  rolePoliciesLte?: InputMaybe<Scalars['JSON']>;
  rolePoliciesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLUsersTeamArgs = {
  accessibleEntities?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesAny?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesContain?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesEq?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesGte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  accessibleEntitiesIsNull?: InputMaybe<Scalars['Boolean']>;
  accessibleEntitiesLike?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLt?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesLte?: InputMaybe<Scalars['JSON']>;
  accessibleEntitiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyAny?: InputMaybe<Scalars['String']>;
  apiKeyContain?: InputMaybe<Scalars['String']>;
  apiKeyEq?: InputMaybe<Scalars['String']>;
  apiKeyGt?: InputMaybe<Scalars['String']>;
  apiKeyGte?: InputMaybe<Scalars['String']>;
  apiKeyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiKeyIsNull?: InputMaybe<Scalars['Boolean']>;
  apiKeyLike?: InputMaybe<Scalars['String']>;
  apiKeyLikeNoCase?: InputMaybe<Scalars['String']>;
  apiKeyLt?: InputMaybe<Scalars['String']>;
  apiKeyLte?: InputMaybe<Scalars['String']>;
  apiKeyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecret?: InputMaybe<Scalars['String']>;
  apiSecretAny?: InputMaybe<Scalars['String']>;
  apiSecretContain?: InputMaybe<Scalars['String']>;
  apiSecretEq?: InputMaybe<Scalars['String']>;
  apiSecretGt?: InputMaybe<Scalars['String']>;
  apiSecretGte?: InputMaybe<Scalars['String']>;
  apiSecretIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apiSecretIsNull?: InputMaybe<Scalars['Boolean']>;
  apiSecretLike?: InputMaybe<Scalars['String']>;
  apiSecretLikeNoCase?: InputMaybe<Scalars['String']>;
  apiSecretLt?: InputMaybe<Scalars['String']>;
  apiSecretLte?: InputMaybe<Scalars['String']>;
  apiSecretNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bio?: InputMaybe<Scalars['String']>;
  bioAny?: InputMaybe<Scalars['String']>;
  bioContain?: InputMaybe<Scalars['String']>;
  bioEq?: InputMaybe<Scalars['String']>;
  bioGt?: InputMaybe<Scalars['String']>;
  bioGte?: InputMaybe<Scalars['String']>;
  bioIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bioIsNull?: InputMaybe<Scalars['Boolean']>;
  bioLike?: InputMaybe<Scalars['String']>;
  bioLikeNoCase?: InputMaybe<Scalars['String']>;
  bioLt?: InputMaybe<Scalars['String']>;
  bioLte?: InputMaybe<Scalars['String']>;
  bioNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterId?: InputMaybe<Scalars['String']>;
  callCenterIdAny?: InputMaybe<Scalars['String']>;
  callCenterIdContain?: InputMaybe<Scalars['String']>;
  callCenterIdEq?: InputMaybe<Scalars['String']>;
  callCenterIdGt?: InputMaybe<Scalars['String']>;
  callCenterIdGte?: InputMaybe<Scalars['String']>;
  callCenterIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  callCenterIdIsNull?: InputMaybe<Scalars['Boolean']>;
  callCenterIdLike?: InputMaybe<Scalars['String']>;
  callCenterIdLikeNoCase?: InputMaybe<Scalars['String']>;
  callCenterIdLt?: InputMaybe<Scalars['String']>;
  callCenterIdLte?: InputMaybe<Scalars['String']>;
  callCenterIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryIdAny?: InputMaybe<Scalars['Int']>;
  countryIdContain?: InputMaybe<Scalars['Int']>;
  countryIdEq?: InputMaybe<Scalars['Int']>;
  countryIdGt?: InputMaybe<Scalars['Int']>;
  countryIdGte?: InputMaybe<Scalars['Int']>;
  countryIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countryIdIsNull?: InputMaybe<Scalars['Boolean']>;
  countryIdLike?: InputMaybe<Scalars['Int']>;
  countryIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  countryIdLt?: InputMaybe<Scalars['Int']>;
  countryIdLte?: InputMaybe<Scalars['Int']>;
  countryIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerId?: InputMaybe<Scalars['String']>;
  directManagerIdAny?: InputMaybe<Scalars['String']>;
  directManagerIdContain?: InputMaybe<Scalars['String']>;
  directManagerIdEq?: InputMaybe<Scalars['String']>;
  directManagerIdGt?: InputMaybe<Scalars['String']>;
  directManagerIdGte?: InputMaybe<Scalars['String']>;
  directManagerIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directManagerIdIsNull?: InputMaybe<Scalars['Boolean']>;
  directManagerIdLike?: InputMaybe<Scalars['String']>;
  directManagerIdLikeNoCase?: InputMaybe<Scalars['String']>;
  directManagerIdLt?: InputMaybe<Scalars['String']>;
  directManagerIdLte?: InputMaybe<Scalars['String']>;
  directManagerIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailAny?: InputMaybe<Scalars['String']>;
  emailConfirmToken?: InputMaybe<Scalars['String']>;
  emailConfirmTokenAny?: InputMaybe<Scalars['String']>;
  emailConfirmTokenContain?: InputMaybe<Scalars['String']>;
  emailConfirmTokenEq?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenGte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailConfirmTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  emailConfirmTokenLike?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLt?: InputMaybe<Scalars['String']>;
  emailConfirmTokenLte?: InputMaybe<Scalars['String']>;
  emailConfirmTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailContain?: InputMaybe<Scalars['String']>;
  emailEq?: InputMaybe<Scalars['String']>;
  emailGt?: InputMaybe<Scalars['String']>;
  emailGte?: InputMaybe<Scalars['String']>;
  emailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailIsNull?: InputMaybe<Scalars['Boolean']>;
  emailLike?: InputMaybe<Scalars['String']>;
  emailLikeNoCase?: InputMaybe<Scalars['String']>;
  emailLt?: InputMaybe<Scalars['String']>;
  emailLte?: InputMaybe<Scalars['String']>;
  emailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubToken?: InputMaybe<Scalars['String']>;
  githubTokenAny?: InputMaybe<Scalars['String']>;
  githubTokenContain?: InputMaybe<Scalars['String']>;
  githubTokenEq?: InputMaybe<Scalars['String']>;
  githubTokenGt?: InputMaybe<Scalars['String']>;
  githubTokenGte?: InputMaybe<Scalars['String']>;
  githubTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  githubTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  githubTokenLike?: InputMaybe<Scalars['String']>;
  githubTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  githubTokenLt?: InputMaybe<Scalars['String']>;
  githubTokenLte?: InputMaybe<Scalars['String']>;
  githubTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistration?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationAny?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationContain?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationEq?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationGte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isConfirmedRegistrationIsNull?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLike?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLt?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationLte?: InputMaybe<Scalars['Boolean']>;
  isConfirmedRegistrationNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  isVerifiedAny?: InputMaybe<Scalars['Boolean']>;
  isVerifiedContain?: InputMaybe<Scalars['Boolean']>;
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedGte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isVerifiedIsNull?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLike?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLt?: InputMaybe<Scalars['Boolean']>;
  isVerifiedLte?: InputMaybe<Scalars['Boolean']>;
  isVerifiedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessions?: InputMaybe<Scalars['Int']>;
  maxSessionsAny?: InputMaybe<Scalars['Int']>;
  maxSessionsContain?: InputMaybe<Scalars['Int']>;
  maxSessionsEq?: InputMaybe<Scalars['Int']>;
  maxSessionsGt?: InputMaybe<Scalars['Int']>;
  maxSessionsGte?: InputMaybe<Scalars['Int']>;
  maxSessionsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxSessionsIsNull?: InputMaybe<Scalars['Boolean']>;
  maxSessionsLike?: InputMaybe<Scalars['Int']>;
  maxSessionsLikeNoCase?: InputMaybe<Scalars['Int']>;
  maxSessionsLt?: InputMaybe<Scalars['Int']>;
  maxSessionsLte?: InputMaybe<Scalars['Int']>;
  maxSessionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  mobileNumberAny?: InputMaybe<Scalars['String']>;
  mobileNumberContain?: InputMaybe<Scalars['String']>;
  mobileNumberEq?: InputMaybe<Scalars['String']>;
  mobileNumberGt?: InputMaybe<Scalars['String']>;
  mobileNumberGte?: InputMaybe<Scalars['String']>;
  mobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  mobileNumberLike?: InputMaybe<Scalars['String']>;
  mobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  mobileNumberLt?: InputMaybe<Scalars['String']>;
  mobileNumberLte?: InputMaybe<Scalars['String']>;
  mobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmail?: InputMaybe<Scalars['String']>;
  newEmailAny?: InputMaybe<Scalars['String']>;
  newEmailContain?: InputMaybe<Scalars['String']>;
  newEmailEq?: InputMaybe<Scalars['String']>;
  newEmailGt?: InputMaybe<Scalars['String']>;
  newEmailGte?: InputMaybe<Scalars['String']>;
  newEmailIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newEmailIsNull?: InputMaybe<Scalars['Boolean']>;
  newEmailLike?: InputMaybe<Scalars['String']>;
  newEmailLikeNoCase?: InputMaybe<Scalars['String']>;
  newEmailLt?: InputMaybe<Scalars['String']>;
  newEmailLte?: InputMaybe<Scalars['String']>;
  newEmailNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumber?: InputMaybe<Scalars['String']>;
  newMobileNumberAny?: InputMaybe<Scalars['String']>;
  newMobileNumberContain?: InputMaybe<Scalars['String']>;
  newMobileNumberEq?: InputMaybe<Scalars['String']>;
  newMobileNumberGt?: InputMaybe<Scalars['String']>;
  newMobileNumberGte?: InputMaybe<Scalars['String']>;
  newMobileNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newMobileNumberIsNull?: InputMaybe<Scalars['Boolean']>;
  newMobileNumberLike?: InputMaybe<Scalars['String']>;
  newMobileNumberLikeNoCase?: InputMaybe<Scalars['String']>;
  newMobileNumberLt?: InputMaybe<Scalars['String']>;
  newMobileNumberLte?: InputMaybe<Scalars['String']>;
  newMobileNumberNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nickname?: InputMaybe<Scalars['String']>;
  nicknameAny?: InputMaybe<Scalars['String']>;
  nicknameContain?: InputMaybe<Scalars['String']>;
  nicknameEq?: InputMaybe<Scalars['String']>;
  nicknameGt?: InputMaybe<Scalars['String']>;
  nicknameGte?: InputMaybe<Scalars['String']>;
  nicknameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameLike?: InputMaybe<Scalars['String']>;
  nicknameLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameLt?: InputMaybe<Scalars['String']>;
  nicknameLte?: InputMaybe<Scalars['String']>;
  nicknameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlug?: InputMaybe<Scalars['String']>;
  nicknameSlugAny?: InputMaybe<Scalars['String']>;
  nicknameSlugContain?: InputMaybe<Scalars['String']>;
  nicknameSlugEq?: InputMaybe<Scalars['String']>;
  nicknameSlugGt?: InputMaybe<Scalars['String']>;
  nicknameSlugGte?: InputMaybe<Scalars['String']>;
  nicknameSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nicknameSlugIsNull?: InputMaybe<Scalars['Boolean']>;
  nicknameSlugLike?: InputMaybe<Scalars['String']>;
  nicknameSlugLikeNoCase?: InputMaybe<Scalars['String']>;
  nicknameSlugLt?: InputMaybe<Scalars['String']>;
  nicknameSlugLte?: InputMaybe<Scalars['String']>;
  nicknameSlugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUsersPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUsersPropertiesEnum>;
  passwordHash?: InputMaybe<Scalars['String']>;
  passwordHashAny?: InputMaybe<Scalars['String']>;
  passwordHashContain?: InputMaybe<Scalars['String']>;
  passwordHashEq?: InputMaybe<Scalars['String']>;
  passwordHashGt?: InputMaybe<Scalars['String']>;
  passwordHashGte?: InputMaybe<Scalars['String']>;
  passwordHashIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passwordHashIsNull?: InputMaybe<Scalars['Boolean']>;
  passwordHashLike?: InputMaybe<Scalars['String']>;
  passwordHashLikeNoCase?: InputMaybe<Scalars['String']>;
  passwordHashLt?: InputMaybe<Scalars['String']>;
  passwordHashLte?: InputMaybe<Scalars['String']>;
  passwordHashNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  policies?: InputMaybe<Scalars['JSON']>;
  policiesAny?: InputMaybe<Scalars['JSON']>;
  policiesContain?: InputMaybe<Scalars['JSON']>;
  policiesEq?: InputMaybe<Scalars['JSON']>;
  policiesGt?: InputMaybe<Scalars['JSON']>;
  policiesGte?: InputMaybe<Scalars['JSON']>;
  policiesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  policiesIsNull?: InputMaybe<Scalars['Boolean']>;
  policiesLike?: InputMaybe<Scalars['JSON']>;
  policiesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  policiesLt?: InputMaybe<Scalars['JSON']>;
  policiesLte?: InputMaybe<Scalars['JSON']>;
  policiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  position?: InputMaybe<Scalars['String']>;
  positionAny?: InputMaybe<Scalars['String']>;
  positionContain?: InputMaybe<Scalars['String']>;
  positionEq?: InputMaybe<Scalars['String']>;
  positionGt?: InputMaybe<Scalars['String']>;
  positionGte?: InputMaybe<Scalars['String']>;
  positionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positionIsNull?: InputMaybe<Scalars['Boolean']>;
  positionLike?: InputMaybe<Scalars['String']>;
  positionLikeNoCase?: InputMaybe<Scalars['String']>;
  positionLt?: InputMaybe<Scalars['String']>;
  positionLte?: InputMaybe<Scalars['String']>;
  positionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredLanguageAny?: InputMaybe<Scalars['String']>;
  preferredLanguageContain?: InputMaybe<Scalars['String']>;
  preferredLanguageEq?: InputMaybe<Scalars['String']>;
  preferredLanguageGt?: InputMaybe<Scalars['String']>;
  preferredLanguageGte?: InputMaybe<Scalars['String']>;
  preferredLanguageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredLanguageIsNull?: InputMaybe<Scalars['Boolean']>;
  preferredLanguageLike?: InputMaybe<Scalars['String']>;
  preferredLanguageLikeNoCase?: InputMaybe<Scalars['String']>;
  preferredLanguageLt?: InputMaybe<Scalars['String']>;
  preferredLanguageLte?: InputMaybe<Scalars['String']>;
  preferredLanguageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageId?: InputMaybe<Scalars['String']>;
  profileImageIdAny?: InputMaybe<Scalars['String']>;
  profileImageIdContain?: InputMaybe<Scalars['String']>;
  profileImageIdEq?: InputMaybe<Scalars['String']>;
  profileImageIdGt?: InputMaybe<Scalars['String']>;
  profileImageIdGte?: InputMaybe<Scalars['String']>;
  profileImageIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageIdIsNull?: InputMaybe<Scalars['Boolean']>;
  profileImageIdLike?: InputMaybe<Scalars['String']>;
  profileImageIdLikeNoCase?: InputMaybe<Scalars['String']>;
  profileImageIdLt?: InputMaybe<Scalars['String']>;
  profileImageIdLte?: InputMaybe<Scalars['String']>;
  profileImageIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCode?: InputMaybe<Scalars['String']>;
  resetPasswordCodeAny?: InputMaybe<Scalars['String']>;
  resetPasswordCodeContain?: InputMaybe<Scalars['String']>;
  resetPasswordCodeEq?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeGte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordCodeLike?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLt?: InputMaybe<Scalars['String']>;
  resetPasswordCodeLte?: InputMaybe<Scalars['String']>;
  resetPasswordCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTP?: InputMaybe<Scalars['String']>;
  resetPasswordOTPAny?: InputMaybe<Scalars['String']>;
  resetPasswordOTPContain?: InputMaybe<Scalars['String']>;
  resetPasswordOTPEq?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPGte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordOTPIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordOTPLike?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLt?: InputMaybe<Scalars['String']>;
  resetPasswordOTPLte?: InputMaybe<Scalars['String']>;
  resetPasswordOTPNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  resetPasswordTokenAny?: InputMaybe<Scalars['String']>;
  resetPasswordTokenContain?: InputMaybe<Scalars['String']>;
  resetPasswordTokenEq?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenGte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resetPasswordTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  resetPasswordTokenLike?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLt?: InputMaybe<Scalars['String']>;
  resetPasswordTokenLte?: InputMaybe<Scalars['String']>;
  resetPasswordTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  role?: InputMaybe<Scalars['String']>;
  roleAny?: InputMaybe<Scalars['String']>;
  roleContain?: InputMaybe<Scalars['String']>;
  roleEq?: InputMaybe<Scalars['String']>;
  roleGt?: InputMaybe<Scalars['String']>;
  roleGte?: InputMaybe<Scalars['String']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleIsNull?: InputMaybe<Scalars['Boolean']>;
  roleLike?: InputMaybe<Scalars['String']>;
  roleLikeNoCase?: InputMaybe<Scalars['String']>;
  roleLt?: InputMaybe<Scalars['String']>;
  roleLte?: InputMaybe<Scalars['String']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackId?: InputMaybe<Scalars['String']>;
  slackIdAny?: InputMaybe<Scalars['String']>;
  slackIdContain?: InputMaybe<Scalars['String']>;
  slackIdEq?: InputMaybe<Scalars['String']>;
  slackIdGt?: InputMaybe<Scalars['String']>;
  slackIdGte?: InputMaybe<Scalars['String']>;
  slackIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slackIdIsNull?: InputMaybe<Scalars['Boolean']>;
  slackIdLike?: InputMaybe<Scalars['String']>;
  slackIdLikeNoCase?: InputMaybe<Scalars['String']>;
  slackIdLt?: InputMaybe<Scalars['String']>;
  slackIdLte?: InputMaybe<Scalars['String']>;
  slackIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceAny?: InputMaybe<Scalars['String']>;
  sourceContain?: InputMaybe<Scalars['String']>;
  sourceEq?: InputMaybe<Scalars['String']>;
  sourceGt?: InputMaybe<Scalars['String']>;
  sourceGte?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIdAny?: InputMaybe<Scalars['String']>;
  sourceIdContain?: InputMaybe<Scalars['String']>;
  sourceIdEq?: InputMaybe<Scalars['String']>;
  sourceIdGt?: InputMaybe<Scalars['String']>;
  sourceIdGte?: InputMaybe<Scalars['String']>;
  sourceIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceIdLike?: InputMaybe<Scalars['String']>;
  sourceIdLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceIdLt?: InputMaybe<Scalars['String']>;
  sourceIdLte?: InputMaybe<Scalars['String']>;
  sourceIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceIsNull?: InputMaybe<Scalars['Boolean']>;
  sourceLike?: InputMaybe<Scalars['String']>;
  sourceLikeNoCase?: InputMaybe<Scalars['String']>;
  sourceLt?: InputMaybe<Scalars['String']>;
  sourceLte?: InputMaybe<Scalars['String']>;
  sourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateToken?: InputMaybe<Scalars['String']>;
  updateTokenAny?: InputMaybe<Scalars['String']>;
  updateTokenContain?: InputMaybe<Scalars['String']>;
  updateTokenEq?: InputMaybe<Scalars['String']>;
  updateTokenGt?: InputMaybe<Scalars['String']>;
  updateTokenGte?: InputMaybe<Scalars['String']>;
  updateTokenIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateTokenIsNull?: InputMaybe<Scalars['Boolean']>;
  updateTokenLike?: InputMaybe<Scalars['String']>;
  updateTokenLikeNoCase?: InputMaybe<Scalars['String']>;
  updateTokenLt?: InputMaybe<Scalars['String']>;
  updateTokenLte?: InputMaybe<Scalars['String']>;
  updateTokenNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCode?: InputMaybe<Scalars['String']>;
  verifyCodeAny?: InputMaybe<Scalars['String']>;
  verifyCodeContain?: InputMaybe<Scalars['String']>;
  verifyCodeEq?: InputMaybe<Scalars['String']>;
  verifyCodeGt?: InputMaybe<Scalars['String']>;
  verifyCodeGte?: InputMaybe<Scalars['String']>;
  verifyCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verifyCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  verifyCodeLike?: InputMaybe<Scalars['String']>;
  verifyCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  verifyCodeLt?: InputMaybe<Scalars['String']>;
  verifyCodeLte?: InputMaybe<Scalars['String']>;
  verifyCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLUsersTrafficSourcesArgs = {
  accountId?: InputMaybe<Scalars['Int']>;
  accountIdAny?: InputMaybe<Scalars['Int']>;
  accountIdContain?: InputMaybe<Scalars['Int']>;
  accountIdEq?: InputMaybe<Scalars['Int']>;
  accountIdGt?: InputMaybe<Scalars['Int']>;
  accountIdGte?: InputMaybe<Scalars['Int']>;
  accountIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  accountIdIsNull?: InputMaybe<Scalars['Boolean']>;
  accountIdLike?: InputMaybe<Scalars['Int']>;
  accountIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  accountIdLt?: InputMaybe<Scalars['Int']>;
  accountIdLte?: InputMaybe<Scalars['Int']>;
  accountIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  excludeFromDailyPL?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLAny?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLContain?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLEq?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLGt?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLGte?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  excludeFromDailyPLIsNull?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLike?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLt?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLte?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  networkId?: InputMaybe<Scalars['Int']>;
  networkIdAny?: InputMaybe<Scalars['Int']>;
  networkIdContain?: InputMaybe<Scalars['Int']>;
  networkIdEq?: InputMaybe<Scalars['Int']>;
  networkIdGt?: InputMaybe<Scalars['Int']>;
  networkIdGte?: InputMaybe<Scalars['Int']>;
  networkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  networkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  networkIdLike?: InputMaybe<Scalars['Int']>;
  networkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  networkIdLt?: InputMaybe<Scalars['Int']>;
  networkIdLte?: InputMaybe<Scalars['Int']>;
  networkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTrafficSourceMapPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTrafficSourceMapPropertiesEnum>;
  trafficSource?: InputMaybe<Scalars['String']>;
  trafficSourceAny?: InputMaybe<Scalars['String']>;
  trafficSourceContain?: InputMaybe<Scalars['String']>;
  trafficSourceEq?: InputMaybe<Scalars['String']>;
  trafficSourceGt?: InputMaybe<Scalars['String']>;
  trafficSourceGte?: InputMaybe<Scalars['String']>;
  trafficSourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficSourceIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficSourceLike?: InputMaybe<Scalars['String']>;
  trafficSourceLikeNoCase?: InputMaybe<Scalars['String']>;
  trafficSourceLt?: InputMaybe<Scalars['String']>;
  trafficSourceLte?: InputMaybe<Scalars['String']>;
  trafficSourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficTypeId?: InputMaybe<Scalars['Int']>;
  trafficTypeIdAny?: InputMaybe<Scalars['Int']>;
  trafficTypeIdContain?: InputMaybe<Scalars['Int']>;
  trafficTypeIdEq?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  trafficTypeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficTypeIdLike?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLUsersUserRoleArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLUserRolesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLUserRolesPropertiesEnum>;
  roleCodeName?: InputMaybe<Scalars['String']>;
  roleCodeNameAny?: InputMaybe<Scalars['String']>;
  roleCodeNameContain?: InputMaybe<Scalars['String']>;
  roleCodeNameEq?: InputMaybe<Scalars['String']>;
  roleCodeNameGt?: InputMaybe<Scalars['String']>;
  roleCodeNameGte?: InputMaybe<Scalars['String']>;
  roleCodeNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleCodeNameIsNull?: InputMaybe<Scalars['Boolean']>;
  roleCodeNameLike?: InputMaybe<Scalars['String']>;
  roleCodeNameLikeNoCase?: InputMaybe<Scalars['String']>;
  roleCodeNameLt?: InputMaybe<Scalars['String']>;
  roleCodeNameLte?: InputMaybe<Scalars['String']>;
  roleCodeNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleName?: InputMaybe<Scalars['String']>;
  roleNameAny?: InputMaybe<Scalars['String']>;
  roleNameContain?: InputMaybe<Scalars['String']>;
  roleNameEq?: InputMaybe<Scalars['String']>;
  roleNameGt?: InputMaybe<Scalars['String']>;
  roleNameGte?: InputMaybe<Scalars['String']>;
  roleNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleNameIsNull?: InputMaybe<Scalars['Boolean']>;
  roleNameLike?: InputMaybe<Scalars['String']>;
  roleNameLikeNoCase?: InputMaybe<Scalars['String']>;
  roleNameLt?: InputMaybe<Scalars['String']>;
  roleNameLte?: InputMaybe<Scalars['String']>;
  roleNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rolePolicies?: InputMaybe<Scalars['JSON']>;
  rolePoliciesAny?: InputMaybe<Scalars['JSON']>;
  rolePoliciesContain?: InputMaybe<Scalars['JSON']>;
  rolePoliciesEq?: InputMaybe<Scalars['JSON']>;
  rolePoliciesGt?: InputMaybe<Scalars['JSON']>;
  rolePoliciesGte?: InputMaybe<Scalars['JSON']>;
  rolePoliciesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  rolePoliciesIsNull?: InputMaybe<Scalars['Boolean']>;
  rolePoliciesLike?: InputMaybe<Scalars['JSON']>;
  rolePoliciesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  rolePoliciesLt?: InputMaybe<Scalars['JSON']>;
  rolePoliciesLte?: InputMaybe<Scalars['JSON']>;
  rolePoliciesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLUsersPropertiesEnum {
  AccessibleEntities = 'accessibleEntities',
  ApiKey = 'apiKey',
  ApiSecret = 'apiSecret',
  Bio = 'bio',
  CallCenterId = 'callCenterId',
  CountryId = 'countryId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  DirectManagerId = 'directManagerId',
  Email = 'email',
  EmailConfirmToken = 'emailConfirmToken',
  GithubToken = 'githubToken',
  Id = 'id',
  IsActive = 'isActive',
  IsConfirmedRegistration = 'isConfirmedRegistration',
  IsDeleted = 'isDeleted',
  IsVerified = 'isVerified',
  MaxSessions = 'maxSessions',
  MobileNumber = 'mobileNumber',
  Name = 'name',
  NewEmail = 'newEmail',
  NewMobileNumber = 'newMobileNumber',
  Nickname = 'nickname',
  NicknameSlug = 'nicknameSlug',
  PasswordHash = 'passwordHash',
  Policies = 'policies',
  Position = 'position',
  PreferredLanguage = 'preferredLanguage',
  ProfileImageId = 'profileImageId',
  ResetPasswordCode = 'resetPasswordCode',
  ResetPasswordOtp = 'resetPasswordOTP',
  ResetPasswordToken = 'resetPasswordToken',
  Role = 'role',
  SlackId = 'slackId',
  Source = 'source',
  SourceId = 'sourceId',
  UpdateToken = 'updateToken',
  UpdatedAt = 'updatedAt',
  VerifyCode = 'verifyCode'
}

export type GQLVariations = {
  __typename?: 'Variations';
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  translations?: Maybe<Array<Maybe<GQLTranslations>>>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};


export type GQLVariationsTranslationsArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdByAny?: InputMaybe<Scalars['String']>;
  createdByContain?: InputMaybe<Scalars['String']>;
  createdByEq?: InputMaybe<Scalars['String']>;
  createdByGt?: InputMaybe<Scalars['String']>;
  createdByGte?: InputMaybe<Scalars['String']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdByIsNull?: InputMaybe<Scalars['Boolean']>;
  createdByLike?: InputMaybe<Scalars['String']>;
  createdByLikeNoCase?: InputMaybe<Scalars['String']>;
  createdByLt?: InputMaybe<Scalars['String']>;
  createdByLte?: InputMaybe<Scalars['String']>;
  createdByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  key?: InputMaybe<Scalars['String']>;
  keyAny?: InputMaybe<Scalars['String']>;
  keyContain?: InputMaybe<Scalars['String']>;
  keyEq?: InputMaybe<Scalars['String']>;
  keyGt?: InputMaybe<Scalars['String']>;
  keyGte?: InputMaybe<Scalars['String']>;
  keyIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyIsNull?: InputMaybe<Scalars['Boolean']>;
  keyLike?: InputMaybe<Scalars['String']>;
  keyLikeNoCase?: InputMaybe<Scalars['String']>;
  keyLt?: InputMaybe<Scalars['String']>;
  keyLte?: InputMaybe<Scalars['String']>;
  keyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelIdAny?: InputMaybe<Scalars['Int']>;
  modelIdContain?: InputMaybe<Scalars['Int']>;
  modelIdEq?: InputMaybe<Scalars['Int']>;
  modelIdGt?: InputMaybe<Scalars['Int']>;
  modelIdGte?: InputMaybe<Scalars['Int']>;
  modelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelIdIsNull?: InputMaybe<Scalars['Boolean']>;
  modelIdLike?: InputMaybe<Scalars['Int']>;
  modelIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  modelIdLt?: InputMaybe<Scalars['Int']>;
  modelIdLte?: InputMaybe<Scalars['Int']>;
  modelIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modelType?: InputMaybe<Scalars['String']>;
  modelTypeAny?: InputMaybe<Scalars['String']>;
  modelTypeContain?: InputMaybe<Scalars['String']>;
  modelTypeEq?: InputMaybe<Scalars['String']>;
  modelTypeGt?: InputMaybe<Scalars['String']>;
  modelTypeGte?: InputMaybe<Scalars['String']>;
  modelTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelTypeIsNull?: InputMaybe<Scalars['Boolean']>;
  modelTypeLike?: InputMaybe<Scalars['String']>;
  modelTypeLikeNoCase?: InputMaybe<Scalars['String']>;
  modelTypeLt?: InputMaybe<Scalars['String']>;
  modelTypeLte?: InputMaybe<Scalars['String']>;
  modelTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTranslationsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTranslationsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['JSON']>;
  valueAny?: InputMaybe<Scalars['JSON']>;
  valueContain?: InputMaybe<Scalars['JSON']>;
  valueEq?: InputMaybe<Scalars['JSON']>;
  valueGt?: InputMaybe<Scalars['JSON']>;
  valueGte?: InputMaybe<Scalars['JSON']>;
  valueIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  valueIsNull?: InputMaybe<Scalars['Boolean']>;
  valueLike?: InputMaybe<Scalars['JSON']>;
  valueLikeNoCase?: InputMaybe<Scalars['JSON']>;
  valueLt?: InputMaybe<Scalars['JSON']>;
  valueLte?: InputMaybe<Scalars['JSON']>;
  valueNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export enum GQLVariationsPropertiesEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Id = 'id',
  IsDeleted = 'isDeleted',
  Label = 'label',
  Order = 'order',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy',
  Value = 'value'
}

export type GQLVisitors = {
  __typename?: 'Visitors';
  adCampaign?: Maybe<Scalars['String']>;
  adDevice?: Maybe<Scalars['String']>;
  adGroup?: Maybe<Scalars['String']>;
  adKeyword?: Maybe<Scalars['String']>;
  adMedium?: Maybe<Scalars['String']>;
  adTrafficSource?: Maybe<Scalars['String']>;
  browser?: Maybe<Scalars['String']>;
  browserCode?: Maybe<Scalars['String']>;
  browserVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  domain?: Maybe<GQLDomains>;
  domainId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<GQLIpAddresses>;
  ipAddressId?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  leads?: Maybe<Array<Maybe<GQLLeads>>>;
  os?: Maybe<Scalars['String']>;
  osCode?: Maybe<Scalars['String']>;
  osVersion?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  referrer?: Maybe<Scalars['String']>;
  trafficSourceMap?: Maybe<GQLTrafficSourceMap>;
  ua?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  visitorIpAddress?: Maybe<GQLIpAddresses>;
  visits?: Maybe<Array<Maybe<GQLVisits>>>;
};


export type GQLVisitorsDomainArgs = {
  allowedLanguages?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesAny?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesContain?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesEq?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesGte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  allowedLanguagesIsNull?: InputMaybe<Scalars['Boolean']>;
  allowedLanguagesLike?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLt?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesLte?: InputMaybe<Scalars['JSON']>;
  allowedLanguagesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  analyticsCodeId?: InputMaybe<Scalars['String']>;
  analyticsCodeIdAny?: InputMaybe<Scalars['String']>;
  analyticsCodeIdContain?: InputMaybe<Scalars['String']>;
  analyticsCodeIdEq?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdGte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  analyticsCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  analyticsCodeIdLike?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLt?: InputMaybe<Scalars['String']>;
  analyticsCodeIdLte?: InputMaybe<Scalars['String']>;
  analyticsCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cacheSettings?: InputMaybe<Scalars['JSON']>;
  cacheSettingsAny?: InputMaybe<Scalars['JSON']>;
  cacheSettingsContain?: InputMaybe<Scalars['JSON']>;
  cacheSettingsEq?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsGte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  cacheSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  cacheSettingsLike?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLt?: InputMaybe<Scalars['JSON']>;
  cacheSettingsLte?: InputMaybe<Scalars['JSON']>;
  cacheSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  clickyCodeId?: InputMaybe<Scalars['String']>;
  clickyCodeIdAny?: InputMaybe<Scalars['String']>;
  clickyCodeIdContain?: InputMaybe<Scalars['String']>;
  clickyCodeIdEq?: InputMaybe<Scalars['String']>;
  clickyCodeIdGt?: InputMaybe<Scalars['String']>;
  clickyCodeIdGte?: InputMaybe<Scalars['String']>;
  clickyCodeIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clickyCodeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  clickyCodeIdLike?: InputMaybe<Scalars['String']>;
  clickyCodeIdLikeNoCase?: InputMaybe<Scalars['String']>;
  clickyCodeIdLt?: InputMaybe<Scalars['String']>;
  clickyCodeIdLte?: InputMaybe<Scalars['String']>;
  clickyCodeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  config?: InputMaybe<Scalars['JSON']>;
  configAny?: InputMaybe<Scalars['JSON']>;
  configContain?: InputMaybe<Scalars['JSON']>;
  configEq?: InputMaybe<Scalars['JSON']>;
  configGt?: InputMaybe<Scalars['JSON']>;
  configGte?: InputMaybe<Scalars['JSON']>;
  configIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  configIsNull?: InputMaybe<Scalars['Boolean']>;
  configLike?: InputMaybe<Scalars['JSON']>;
  configLikeNoCase?: InputMaybe<Scalars['JSON']>;
  configLt?: InputMaybe<Scalars['JSON']>;
  configLte?: InputMaybe<Scalars['JSON']>;
  configNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  enableChatWidget?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetAny?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetContain?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetEq?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetGte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableChatWidgetIsNull?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLike?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLt?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetLte?: InputMaybe<Scalars['Boolean']>;
  enableChatWidgetNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaId?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdAny?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdContain?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdEq?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdGte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableJornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLike?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLt?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdLte?: InputMaybe<Scalars['Boolean']>;
  enableJornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedForm?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormAny?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormContain?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormEq?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormGte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  enableTrustedFormIsNull?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLike?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLt?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormLte?: InputMaybe<Scalars['Boolean']>;
  enableTrustedFormNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  facebookConversionAPISettings?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsAny?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsContain?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsEq?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsGte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookConversionAPISettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookConversionAPISettingsLike?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLt?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsLte?: InputMaybe<Scalars['JSON']>;
  facebookConversionAPISettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  facebookSiteVerificationCode?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  facebookSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  facebookSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fallbackSettings?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsAny?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsContain?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsEq?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsGte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  fallbackSettingsIsNull?: InputMaybe<Scalars['Boolean']>;
  fallbackSettingsLike?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLt?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsLte?: InputMaybe<Scalars['JSON']>;
  fallbackSettingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  faviconId?: InputMaybe<Scalars['String']>;
  faviconIdAny?: InputMaybe<Scalars['String']>;
  faviconIdContain?: InputMaybe<Scalars['String']>;
  faviconIdEq?: InputMaybe<Scalars['String']>;
  faviconIdGt?: InputMaybe<Scalars['String']>;
  faviconIdGte?: InputMaybe<Scalars['String']>;
  faviconIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  faviconIdIsNull?: InputMaybe<Scalars['Boolean']>;
  faviconIdLike?: InputMaybe<Scalars['String']>;
  faviconIdLikeNoCase?: InputMaybe<Scalars['String']>;
  faviconIdLt?: InputMaybe<Scalars['String']>;
  faviconIdLte?: InputMaybe<Scalars['String']>;
  faviconIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCode?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeAny?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeContain?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeEq?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeGte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleSiteVerificationCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  googleSiteVerificationCodeLike?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLt?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeLte?: InputMaybe<Scalars['String']>;
  googleSiteVerificationCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmId?: InputMaybe<Scalars['String']>;
  gtmIdAny?: InputMaybe<Scalars['String']>;
  gtmIdContain?: InputMaybe<Scalars['String']>;
  gtmIdEq?: InputMaybe<Scalars['String']>;
  gtmIdGt?: InputMaybe<Scalars['String']>;
  gtmIdGte?: InputMaybe<Scalars['String']>;
  gtmIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gtmIdIsNull?: InputMaybe<Scalars['Boolean']>;
  gtmIdLike?: InputMaybe<Scalars['String']>;
  gtmIdLikeNoCase?: InputMaybe<Scalars['String']>;
  gtmIdLt?: InputMaybe<Scalars['String']>;
  gtmIdLte?: InputMaybe<Scalars['String']>;
  gtmIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  holdingRules?: InputMaybe<Scalars['JSON']>;
  holdingRulesAny?: InputMaybe<Scalars['JSON']>;
  holdingRulesContain?: InputMaybe<Scalars['JSON']>;
  holdingRulesEq?: InputMaybe<Scalars['JSON']>;
  holdingRulesGt?: InputMaybe<Scalars['JSON']>;
  holdingRulesGte?: InputMaybe<Scalars['JSON']>;
  holdingRulesIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  holdingRulesIsNull?: InputMaybe<Scalars['Boolean']>;
  holdingRulesLike?: InputMaybe<Scalars['JSON']>;
  holdingRulesLikeNoCase?: InputMaybe<Scalars['JSON']>;
  holdingRulesLt?: InputMaybe<Scalars['JSON']>;
  holdingRulesLte?: InputMaybe<Scalars['JSON']>;
  holdingRulesNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabled?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledAny?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledContain?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledEq?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledGte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isInspectorEnabledIsNull?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLike?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLt?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledLte?: InputMaybe<Scalars['Boolean']>;
  isInspectorEnabledNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoId?: InputMaybe<Scalars['String']>;
  logoIdAny?: InputMaybe<Scalars['String']>;
  logoIdContain?: InputMaybe<Scalars['String']>;
  logoIdEq?: InputMaybe<Scalars['String']>;
  logoIdGt?: InputMaybe<Scalars['String']>;
  logoIdGte?: InputMaybe<Scalars['String']>;
  logoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  logoIdLike?: InputMaybe<Scalars['String']>;
  logoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  logoIdLt?: InputMaybe<Scalars['String']>;
  logoIdLte?: InputMaybe<Scalars['String']>;
  logoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceName?: InputMaybe<Scalars['String']>;
  niceNameAny?: InputMaybe<Scalars['String']>;
  niceNameContain?: InputMaybe<Scalars['String']>;
  niceNameEq?: InputMaybe<Scalars['String']>;
  niceNameGt?: InputMaybe<Scalars['String']>;
  niceNameGte?: InputMaybe<Scalars['String']>;
  niceNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  niceNameIsNull?: InputMaybe<Scalars['Boolean']>;
  niceNameLike?: InputMaybe<Scalars['String']>;
  niceNameLikeNoCase?: InputMaybe<Scalars['String']>;
  niceNameLt?: InputMaybe<Scalars['String']>;
  niceNameLte?: InputMaybe<Scalars['String']>;
  niceNameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLDomainsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLDomainsPropertiesEnum>;
  otpVerificationCriteria?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaAny?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaContain?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaEq?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaGte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  otpVerificationCriteriaIsNull?: InputMaybe<Scalars['Boolean']>;
  otpVerificationCriteriaLike?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLikeNoCase?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLt?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaLte?: InputMaybe<Scalars['JSON']>;
  otpVerificationCriteriaNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfig?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigAny?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigContain?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigEq?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigGte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  recaptchaConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  recaptchaConfigLike?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLt?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigLte?: InputMaybe<Scalars['JSON']>;
  recaptchaConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  secondaryLogoId?: InputMaybe<Scalars['String']>;
  secondaryLogoIdAny?: InputMaybe<Scalars['String']>;
  secondaryLogoIdContain?: InputMaybe<Scalars['String']>;
  secondaryLogoIdEq?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdGte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondaryLogoIdIsNull?: InputMaybe<Scalars['Boolean']>;
  secondaryLogoIdLike?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLikeNoCase?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLt?: InputMaybe<Scalars['String']>;
  secondaryLogoIdLte?: InputMaybe<Scalars['String']>;
  secondaryLogoIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sendNotifications?: InputMaybe<Scalars['JSON']>;
  sendNotificationsAny?: InputMaybe<Scalars['JSON']>;
  sendNotificationsContain?: InputMaybe<Scalars['JSON']>;
  sendNotificationsEq?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsGte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  sendNotificationsIsNull?: InputMaybe<Scalars['Boolean']>;
  sendNotificationsLike?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLt?: InputMaybe<Scalars['JSON']>;
  sendNotificationsLte?: InputMaybe<Scalars['JSON']>;
  sendNotificationsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settings?: InputMaybe<Scalars['JSON']>;
  settingsAny?: InputMaybe<Scalars['JSON']>;
  settingsContain?: InputMaybe<Scalars['JSON']>;
  settingsEq?: InputMaybe<Scalars['JSON']>;
  settingsGt?: InputMaybe<Scalars['JSON']>;
  settingsGte?: InputMaybe<Scalars['JSON']>;
  settingsIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  settingsIsNull?: InputMaybe<Scalars['Boolean']>;
  settingsLike?: InputMaybe<Scalars['JSON']>;
  settingsLikeNoCase?: InputMaybe<Scalars['JSON']>;
  settingsLt?: InputMaybe<Scalars['JSON']>;
  settingsLte?: InputMaybe<Scalars['JSON']>;
  settingsNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  slogan?: InputMaybe<Scalars['String']>;
  sloganAny?: InputMaybe<Scalars['String']>;
  sloganContain?: InputMaybe<Scalars['String']>;
  sloganEq?: InputMaybe<Scalars['String']>;
  sloganGt?: InputMaybe<Scalars['String']>;
  sloganGte?: InputMaybe<Scalars['String']>;
  sloganIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sloganIsNull?: InputMaybe<Scalars['Boolean']>;
  sloganLike?: InputMaybe<Scalars['String']>;
  sloganLikeNoCase?: InputMaybe<Scalars['String']>;
  sloganLt?: InputMaybe<Scalars['String']>;
  sloganLte?: InputMaybe<Scalars['String']>;
  sloganNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateConfig?: InputMaybe<Scalars['JSON']>;
  templateConfigAny?: InputMaybe<Scalars['JSON']>;
  templateConfigContain?: InputMaybe<Scalars['JSON']>;
  templateConfigEq?: InputMaybe<Scalars['JSON']>;
  templateConfigGt?: InputMaybe<Scalars['JSON']>;
  templateConfigGte?: InputMaybe<Scalars['JSON']>;
  templateConfigIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  templateConfigIsNull?: InputMaybe<Scalars['Boolean']>;
  templateConfigLike?: InputMaybe<Scalars['JSON']>;
  templateConfigLikeNoCase?: InputMaybe<Scalars['JSON']>;
  templateConfigLt?: InputMaybe<Scalars['JSON']>;
  templateConfigLte?: InputMaybe<Scalars['JSON']>;
  templateConfigNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  title?: InputMaybe<Scalars['String']>;
  titleAny?: InputMaybe<Scalars['String']>;
  titleContain?: InputMaybe<Scalars['String']>;
  titleEq?: InputMaybe<Scalars['String']>;
  titleGt?: InputMaybe<Scalars['String']>;
  titleGte?: InputMaybe<Scalars['String']>;
  titleIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIsNull?: InputMaybe<Scalars['Boolean']>;
  titleLike?: InputMaybe<Scalars['String']>;
  titleLikeNoCase?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLte?: InputMaybe<Scalars['String']>;
  titleNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixel?: InputMaybe<Scalars['String']>;
  twitterPixelAny?: InputMaybe<Scalars['String']>;
  twitterPixelContain?: InputMaybe<Scalars['String']>;
  twitterPixelEq?: InputMaybe<Scalars['String']>;
  twitterPixelGt?: InputMaybe<Scalars['String']>;
  twitterPixelGte?: InputMaybe<Scalars['String']>;
  twitterPixelIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterPixelIsNull?: InputMaybe<Scalars['Boolean']>;
  twitterPixelLike?: InputMaybe<Scalars['String']>;
  twitterPixelLikeNoCase?: InputMaybe<Scalars['String']>;
  twitterPixelLt?: InputMaybe<Scalars['String']>;
  twitterPixelLte?: InputMaybe<Scalars['String']>;
  twitterPixelNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLVisitorsIpAddressArgs = {
  bannedAt?: InputMaybe<Scalars['String']>;
  bannedAtAny?: InputMaybe<Scalars['String']>;
  bannedAtContain?: InputMaybe<Scalars['String']>;
  bannedAtEq?: InputMaybe<Scalars['String']>;
  bannedAtGt?: InputMaybe<Scalars['String']>;
  bannedAtGte?: InputMaybe<Scalars['String']>;
  bannedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bannedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  bannedAtLike?: InputMaybe<Scalars['String']>;
  bannedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  bannedAtLt?: InputMaybe<Scalars['String']>;
  bannedAtLte?: InputMaybe<Scalars['String']>;
  bannedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<Scalars['String']>;
  cityAny?: InputMaybe<Scalars['String']>;
  cityContain?: InputMaybe<Scalars['String']>;
  cityEq?: InputMaybe<Scalars['String']>;
  cityGt?: InputMaybe<Scalars['String']>;
  cityGte?: InputMaybe<Scalars['String']>;
  cityIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityIsNull?: InputMaybe<Scalars['Boolean']>;
  cityLike?: InputMaybe<Scalars['String']>;
  cityLikeNoCase?: InputMaybe<Scalars['String']>;
  cityLt?: InputMaybe<Scalars['String']>;
  cityLte?: InputMaybe<Scalars['String']>;
  cityNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  continent?: InputMaybe<Scalars['String']>;
  continentAny?: InputMaybe<Scalars['String']>;
  continentCode?: InputMaybe<Scalars['String']>;
  continentCodeAny?: InputMaybe<Scalars['String']>;
  continentCodeContain?: InputMaybe<Scalars['String']>;
  continentCodeEq?: InputMaybe<Scalars['String']>;
  continentCodeGt?: InputMaybe<Scalars['String']>;
  continentCodeGte?: InputMaybe<Scalars['String']>;
  continentCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  continentCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  continentCodeLike?: InputMaybe<Scalars['String']>;
  continentCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  continentCodeLt?: InputMaybe<Scalars['String']>;
  continentCodeLte?: InputMaybe<Scalars['String']>;
  continentCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  continentContain?: InputMaybe<Scalars['String']>;
  continentEq?: InputMaybe<Scalars['String']>;
  continentGt?: InputMaybe<Scalars['String']>;
  continentGte?: InputMaybe<Scalars['String']>;
  continentIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  continentIsNull?: InputMaybe<Scalars['Boolean']>;
  continentLike?: InputMaybe<Scalars['String']>;
  continentLikeNoCase?: InputMaybe<Scalars['String']>;
  continentLt?: InputMaybe<Scalars['String']>;
  continentLte?: InputMaybe<Scalars['String']>;
  continentNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  country?: InputMaybe<Scalars['String']>;
  countryAny?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  countryCodeAny?: InputMaybe<Scalars['String']>;
  countryCodeContain?: InputMaybe<Scalars['String']>;
  countryCodeEq?: InputMaybe<Scalars['String']>;
  countryCodeGt?: InputMaybe<Scalars['String']>;
  countryCodeGte?: InputMaybe<Scalars['String']>;
  countryCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  countryCodeLike?: InputMaybe<Scalars['String']>;
  countryCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  countryCodeLt?: InputMaybe<Scalars['String']>;
  countryCodeLte?: InputMaybe<Scalars['String']>;
  countryCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryContain?: InputMaybe<Scalars['String']>;
  countryEq?: InputMaybe<Scalars['String']>;
  countryGt?: InputMaybe<Scalars['String']>;
  countryGte?: InputMaybe<Scalars['String']>;
  countryIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryIsNull?: InputMaybe<Scalars['Boolean']>;
  countryLike?: InputMaybe<Scalars['String']>;
  countryLikeNoCase?: InputMaybe<Scalars['String']>;
  countryLt?: InputMaybe<Scalars['String']>;
  countryLte?: InputMaybe<Scalars['String']>;
  countryNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  expireAt?: InputMaybe<Scalars['String']>;
  expireAtAny?: InputMaybe<Scalars['String']>;
  expireAtContain?: InputMaybe<Scalars['String']>;
  expireAtEq?: InputMaybe<Scalars['String']>;
  expireAtGt?: InputMaybe<Scalars['String']>;
  expireAtGte?: InputMaybe<Scalars['String']>;
  expireAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  expireAtIsNull?: InputMaybe<Scalars['Boolean']>;
  expireAtLike?: InputMaybe<Scalars['String']>;
  expireAtLikeNoCase?: InputMaybe<Scalars['String']>;
  expireAtLt?: InputMaybe<Scalars['String']>;
  expireAtLte?: InputMaybe<Scalars['String']>;
  expireAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ip?: InputMaybe<Scalars['String']>;
  ipAny?: InputMaybe<Scalars['String']>;
  ipContain?: InputMaybe<Scalars['String']>;
  ipEq?: InputMaybe<Scalars['String']>;
  ipGt?: InputMaybe<Scalars['String']>;
  ipGte?: InputMaybe<Scalars['String']>;
  ipIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ipIsNull?: InputMaybe<Scalars['Boolean']>;
  ipLike?: InputMaybe<Scalars['String']>;
  ipLikeNoCase?: InputMaybe<Scalars['String']>;
  ipLt?: InputMaybe<Scalars['String']>;
  ipLte?: InputMaybe<Scalars['String']>;
  ipNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBanned?: InputMaybe<Scalars['Boolean']>;
  isBannedAny?: InputMaybe<Scalars['Boolean']>;
  isBannedContain?: InputMaybe<Scalars['Boolean']>;
  isBannedEq?: InputMaybe<Scalars['Boolean']>;
  isBannedGt?: InputMaybe<Scalars['Boolean']>;
  isBannedGte?: InputMaybe<Scalars['Boolean']>;
  isBannedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBannedIsNull?: InputMaybe<Scalars['Boolean']>;
  isBannedLike?: InputMaybe<Scalars['Boolean']>;
  isBannedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBannedLt?: InputMaybe<Scalars['Boolean']>;
  isBannedLte?: InputMaybe<Scalars['Boolean']>;
  isBannedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isp?: InputMaybe<Scalars['String']>;
  ispAny?: InputMaybe<Scalars['String']>;
  ispContain?: InputMaybe<Scalars['String']>;
  ispEq?: InputMaybe<Scalars['String']>;
  ispGt?: InputMaybe<Scalars['String']>;
  ispGte?: InputMaybe<Scalars['String']>;
  ispIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ispIsNull?: InputMaybe<Scalars['Boolean']>;
  ispLike?: InputMaybe<Scalars['String']>;
  ispLikeNoCase?: InputMaybe<Scalars['String']>;
  ispLt?: InputMaybe<Scalars['String']>;
  ispLte?: InputMaybe<Scalars['String']>;
  ispNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  latitude?: InputMaybe<Scalars['String']>;
  latitudeAny?: InputMaybe<Scalars['String']>;
  latitudeContain?: InputMaybe<Scalars['String']>;
  latitudeEq?: InputMaybe<Scalars['String']>;
  latitudeGt?: InputMaybe<Scalars['String']>;
  latitudeGte?: InputMaybe<Scalars['String']>;
  latitudeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  latitudeIsNull?: InputMaybe<Scalars['Boolean']>;
  latitudeLike?: InputMaybe<Scalars['String']>;
  latitudeLikeNoCase?: InputMaybe<Scalars['String']>;
  latitudeLt?: InputMaybe<Scalars['String']>;
  latitudeLte?: InputMaybe<Scalars['String']>;
  latitudeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  longitude?: InputMaybe<Scalars['String']>;
  longitudeAny?: InputMaybe<Scalars['String']>;
  longitudeContain?: InputMaybe<Scalars['String']>;
  longitudeEq?: InputMaybe<Scalars['String']>;
  longitudeGt?: InputMaybe<Scalars['String']>;
  longitudeGte?: InputMaybe<Scalars['String']>;
  longitudeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  longitudeIsNull?: InputMaybe<Scalars['Boolean']>;
  longitudeLike?: InputMaybe<Scalars['String']>;
  longitudeLikeNoCase?: InputMaybe<Scalars['String']>;
  longitudeLt?: InputMaybe<Scalars['String']>;
  longitudeLte?: InputMaybe<Scalars['String']>;
  longitudeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLIpAddressesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLIpAddressesPropertiesEnum>;
  postalCode?: InputMaybe<Scalars['String']>;
  postalCodeAny?: InputMaybe<Scalars['String']>;
  postalCodeContain?: InputMaybe<Scalars['String']>;
  postalCodeEq?: InputMaybe<Scalars['String']>;
  postalCodeGt?: InputMaybe<Scalars['String']>;
  postalCodeGte?: InputMaybe<Scalars['String']>;
  postalCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  postalCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  postalCodeLike?: InputMaybe<Scalars['String']>;
  postalCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  postalCodeLt?: InputMaybe<Scalars['String']>;
  postalCodeLte?: InputMaybe<Scalars['String']>;
  postalCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  provider?: InputMaybe<Scalars['String']>;
  providerAny?: InputMaybe<Scalars['String']>;
  providerContain?: InputMaybe<Scalars['String']>;
  providerEq?: InputMaybe<Scalars['String']>;
  providerGt?: InputMaybe<Scalars['String']>;
  providerGte?: InputMaybe<Scalars['String']>;
  providerIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  providerIsNull?: InputMaybe<Scalars['Boolean']>;
  providerLike?: InputMaybe<Scalars['String']>;
  providerLikeNoCase?: InputMaybe<Scalars['String']>;
  providerLt?: InputMaybe<Scalars['String']>;
  providerLte?: InputMaybe<Scalars['String']>;
  providerNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  state?: InputMaybe<Scalars['String']>;
  stateAny?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
  stateCodeAny?: InputMaybe<Scalars['String']>;
  stateCodeContain?: InputMaybe<Scalars['String']>;
  stateCodeEq?: InputMaybe<Scalars['String']>;
  stateCodeGt?: InputMaybe<Scalars['String']>;
  stateCodeGte?: InputMaybe<Scalars['String']>;
  stateCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  stateCodeLike?: InputMaybe<Scalars['String']>;
  stateCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  stateCodeLt?: InputMaybe<Scalars['String']>;
  stateCodeLte?: InputMaybe<Scalars['String']>;
  stateCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateContain?: InputMaybe<Scalars['String']>;
  stateEq?: InputMaybe<Scalars['String']>;
  stateGt?: InputMaybe<Scalars['String']>;
  stateGte?: InputMaybe<Scalars['String']>;
  stateIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateIsNull?: InputMaybe<Scalars['Boolean']>;
  stateLike?: InputMaybe<Scalars['String']>;
  stateLikeNoCase?: InputMaybe<Scalars['String']>;
  stateLt?: InputMaybe<Scalars['String']>;
  stateLte?: InputMaybe<Scalars['String']>;
  stateNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLVisitorsLeadsArgs = {
  advertisingNetworkId?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdAny?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdContain?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdEq?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdGt?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdGte?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  advertisingNetworkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  advertisingNetworkIdLike?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdLt?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdLte?: InputMaybe<Scalars['Int']>;
  advertisingNetworkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainFormId?: InputMaybe<Scalars['Int']>;
  domainFormIdAny?: InputMaybe<Scalars['Int']>;
  domainFormIdContain?: InputMaybe<Scalars['Int']>;
  domainFormIdEq?: InputMaybe<Scalars['Int']>;
  domainFormIdGt?: InputMaybe<Scalars['Int']>;
  domainFormIdGte?: InputMaybe<Scalars['Int']>;
  domainFormIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainFormIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainFormIdLike?: InputMaybe<Scalars['Int']>;
  domainFormIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainFormIdLt?: InputMaybe<Scalars['Int']>;
  domainFormIdLte?: InputMaybe<Scalars['Int']>;
  domainFormIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  feedback?: InputMaybe<Scalars['JSON']>;
  feedbackAny?: InputMaybe<Scalars['JSON']>;
  feedbackContain?: InputMaybe<Scalars['JSON']>;
  feedbackEq?: InputMaybe<Scalars['JSON']>;
  feedbackGt?: InputMaybe<Scalars['JSON']>;
  feedbackGte?: InputMaybe<Scalars['JSON']>;
  feedbackIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  feedbackIsNull?: InputMaybe<Scalars['Boolean']>;
  feedbackLike?: InputMaybe<Scalars['JSON']>;
  feedbackLikeNoCase?: InputMaybe<Scalars['JSON']>;
  feedbackLt?: InputMaybe<Scalars['JSON']>;
  feedbackLte?: InputMaybe<Scalars['JSON']>;
  feedbackNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  hasAliasCalls?: InputMaybe<Scalars['String']>;
  hasAliasCallsAny?: InputMaybe<Scalars['String']>;
  hasAliasCallsContain?: InputMaybe<Scalars['String']>;
  hasAliasCallsEq?: InputMaybe<Scalars['String']>;
  hasAliasCallsGt?: InputMaybe<Scalars['String']>;
  hasAliasCallsGte?: InputMaybe<Scalars['String']>;
  hasAliasCallsIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hasAliasCallsIsNull?: InputMaybe<Scalars['Boolean']>;
  hasAliasCallsLike?: InputMaybe<Scalars['String']>;
  hasAliasCallsLikeNoCase?: InputMaybe<Scalars['String']>;
  hasAliasCallsLt?: InputMaybe<Scalars['String']>;
  hasAliasCallsLte?: InputMaybe<Scalars['String']>;
  hasAliasCallsNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOptedOut?: InputMaybe<Scalars['Boolean']>;
  isOptedOutAny?: InputMaybe<Scalars['Boolean']>;
  isOptedOutContain?: InputMaybe<Scalars['Boolean']>;
  isOptedOutEq?: InputMaybe<Scalars['Boolean']>;
  isOptedOutGt?: InputMaybe<Scalars['Boolean']>;
  isOptedOutGte?: InputMaybe<Scalars['Boolean']>;
  isOptedOutIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isOptedOutIsNull?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLike?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLt?: InputMaybe<Scalars['Boolean']>;
  isOptedOutLte?: InputMaybe<Scalars['Boolean']>;
  isOptedOutNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  jornayaId?: InputMaybe<Scalars['String']>;
  jornayaIdAny?: InputMaybe<Scalars['String']>;
  jornayaIdContain?: InputMaybe<Scalars['String']>;
  jornayaIdEq?: InputMaybe<Scalars['String']>;
  jornayaIdGt?: InputMaybe<Scalars['String']>;
  jornayaIdGte?: InputMaybe<Scalars['String']>;
  jornayaIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  jornayaIdIsNull?: InputMaybe<Scalars['Boolean']>;
  jornayaIdLike?: InputMaybe<Scalars['String']>;
  jornayaIdLikeNoCase?: InputMaybe<Scalars['String']>;
  jornayaIdLt?: InputMaybe<Scalars['String']>;
  jornayaIdLte?: InputMaybe<Scalars['String']>;
  jornayaIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  modifiedAt?: InputMaybe<Scalars['String']>;
  modifiedAtAny?: InputMaybe<Scalars['String']>;
  modifiedAtContain?: InputMaybe<Scalars['String']>;
  modifiedAtEq?: InputMaybe<Scalars['String']>;
  modifiedAtGt?: InputMaybe<Scalars['String']>;
  modifiedAtGte?: InputMaybe<Scalars['String']>;
  modifiedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedAtLike?: InputMaybe<Scalars['String']>;
  modifiedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedAtLt?: InputMaybe<Scalars['String']>;
  modifiedAtLte?: InputMaybe<Scalars['String']>;
  modifiedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  modifiedByAny?: InputMaybe<Scalars['String']>;
  modifiedByContain?: InputMaybe<Scalars['String']>;
  modifiedByEq?: InputMaybe<Scalars['String']>;
  modifiedByGt?: InputMaybe<Scalars['String']>;
  modifiedByGte?: InputMaybe<Scalars['String']>;
  modifiedByIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifiedByIsNull?: InputMaybe<Scalars['Boolean']>;
  modifiedByLike?: InputMaybe<Scalars['String']>;
  modifiedByLikeNoCase?: InputMaybe<Scalars['String']>;
  modifiedByLt?: InputMaybe<Scalars['String']>;
  modifiedByLte?: InputMaybe<Scalars['String']>;
  modifiedByNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLLeadsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLLeadsPropertiesEnum>;
  piiId?: InputMaybe<Scalars['Int']>;
  piiIdAny?: InputMaybe<Scalars['Int']>;
  piiIdContain?: InputMaybe<Scalars['Int']>;
  piiIdEq?: InputMaybe<Scalars['Int']>;
  piiIdGt?: InputMaybe<Scalars['Int']>;
  piiIdGte?: InputMaybe<Scalars['Int']>;
  piiIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  piiIdIsNull?: InputMaybe<Scalars['Boolean']>;
  piiIdLike?: InputMaybe<Scalars['Int']>;
  piiIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  piiIdLt?: InputMaybe<Scalars['Int']>;
  piiIdLte?: InputMaybe<Scalars['Int']>;
  piiIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sales?: InputMaybe<Scalars['String']>;
  salesAny?: InputMaybe<Scalars['String']>;
  salesContain?: InputMaybe<Scalars['String']>;
  salesEq?: InputMaybe<Scalars['String']>;
  salesGt?: InputMaybe<Scalars['String']>;
  salesGte?: InputMaybe<Scalars['String']>;
  salesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  salesIsNull?: InputMaybe<Scalars['Boolean']>;
  salesLike?: InputMaybe<Scalars['String']>;
  salesLikeNoCase?: InputMaybe<Scalars['String']>;
  salesLt?: InputMaybe<Scalars['String']>;
  salesLte?: InputMaybe<Scalars['String']>;
  salesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Scalars['String']>;
  statusAny?: InputMaybe<Scalars['String']>;
  statusContain?: InputMaybe<Scalars['String']>;
  statusEq?: InputMaybe<Scalars['String']>;
  statusGt?: InputMaybe<Scalars['String']>;
  statusGte?: InputMaybe<Scalars['String']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statusIsNull?: InputMaybe<Scalars['Boolean']>;
  statusLike?: InputMaybe<Scalars['String']>;
  statusLikeNoCase?: InputMaybe<Scalars['String']>;
  statusLt?: InputMaybe<Scalars['String']>;
  statusLte?: InputMaybe<Scalars['String']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  submissionStatus?: InputMaybe<Scalars['String']>;
  submissionStatusAny?: InputMaybe<Scalars['String']>;
  submissionStatusContain?: InputMaybe<Scalars['String']>;
  submissionStatusEq?: InputMaybe<Scalars['String']>;
  submissionStatusGt?: InputMaybe<Scalars['String']>;
  submissionStatusGte?: InputMaybe<Scalars['String']>;
  submissionStatusIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  submissionStatusIsNull?: InputMaybe<Scalars['Boolean']>;
  submissionStatusLike?: InputMaybe<Scalars['String']>;
  submissionStatusLikeNoCase?: InputMaybe<Scalars['String']>;
  submissionStatusLt?: InputMaybe<Scalars['String']>;
  submissionStatusLte?: InputMaybe<Scalars['String']>;
  submissionStatusNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficSource?: InputMaybe<Scalars['String']>;
  trafficSourceAny?: InputMaybe<Scalars['String']>;
  trafficSourceContain?: InputMaybe<Scalars['String']>;
  trafficSourceEq?: InputMaybe<Scalars['String']>;
  trafficSourceGt?: InputMaybe<Scalars['String']>;
  trafficSourceGte?: InputMaybe<Scalars['String']>;
  trafficSourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficSourceIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficSourceLike?: InputMaybe<Scalars['String']>;
  trafficSourceLikeNoCase?: InputMaybe<Scalars['String']>;
  trafficSourceLt?: InputMaybe<Scalars['String']>;
  trafficSourceLte?: InputMaybe<Scalars['String']>;
  trafficSourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficTypeId?: InputMaybe<Scalars['Int']>;
  trafficTypeIdAny?: InputMaybe<Scalars['Int']>;
  trafficTypeIdContain?: InputMaybe<Scalars['Int']>;
  trafficTypeIdEq?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  trafficTypeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficTypeIdLike?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  trustedFormCertificateClaimed?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedAny?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedContain?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedEq?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedGt?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedGte?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  trustedFormCertificateClaimedIsNull?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLike?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLt?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedLte?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateClaimedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  trustedFormCertificateUrl?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlAny?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlContain?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlEq?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlGt?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlGte?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trustedFormCertificateUrlIsNull?: InputMaybe<Scalars['Boolean']>;
  trustedFormCertificateUrlLike?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlLikeNoCase?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlLt?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlLte?: InputMaybe<Scalars['String']>;
  trustedFormCertificateUrlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeAny?: InputMaybe<Scalars['String']>;
  typeContain?: InputMaybe<Scalars['String']>;
  typeEq?: InputMaybe<Scalars['String']>;
  typeGt?: InputMaybe<Scalars['String']>;
  typeGte?: InputMaybe<Scalars['String']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIsNull?: InputMaybe<Scalars['Boolean']>;
  typeLike?: InputMaybe<Scalars['String']>;
  typeLikeNoCase?: InputMaybe<Scalars['String']>;
  typeLt?: InputMaybe<Scalars['String']>;
  typeLte?: InputMaybe<Scalars['String']>;
  typeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uuid?: InputMaybe<Scalars['String']>;
  uuidAny?: InputMaybe<Scalars['String']>;
  uuidContain?: InputMaybe<Scalars['String']>;
  uuidEq?: InputMaybe<Scalars['String']>;
  uuidGt?: InputMaybe<Scalars['String']>;
  uuidGte?: InputMaybe<Scalars['String']>;
  uuidIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uuidIsNull?: InputMaybe<Scalars['Boolean']>;
  uuidLike?: InputMaybe<Scalars['String']>;
  uuidLikeNoCase?: InputMaybe<Scalars['String']>;
  uuidLt?: InputMaybe<Scalars['String']>;
  uuidLte?: InputMaybe<Scalars['String']>;
  uuidNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitData?: InputMaybe<Scalars['JSON']>;
  visitDataAny?: InputMaybe<Scalars['JSON']>;
  visitDataContain?: InputMaybe<Scalars['JSON']>;
  visitDataEq?: InputMaybe<Scalars['JSON']>;
  visitDataGt?: InputMaybe<Scalars['JSON']>;
  visitDataGte?: InputMaybe<Scalars['JSON']>;
  visitDataIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  visitDataIsNull?: InputMaybe<Scalars['Boolean']>;
  visitDataLike?: InputMaybe<Scalars['JSON']>;
  visitDataLikeNoCase?: InputMaybe<Scalars['JSON']>;
  visitDataLt?: InputMaybe<Scalars['JSON']>;
  visitDataLte?: InputMaybe<Scalars['JSON']>;
  visitDataNotIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  visitId?: InputMaybe<Scalars['String']>;
  visitIdAny?: InputMaybe<Scalars['String']>;
  visitIdContain?: InputMaybe<Scalars['String']>;
  visitIdEq?: InputMaybe<Scalars['String']>;
  visitIdGt?: InputMaybe<Scalars['String']>;
  visitIdGte?: InputMaybe<Scalars['String']>;
  visitIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitIdIsNull?: InputMaybe<Scalars['Boolean']>;
  visitIdLike?: InputMaybe<Scalars['String']>;
  visitIdLikeNoCase?: InputMaybe<Scalars['String']>;
  visitIdLt?: InputMaybe<Scalars['String']>;
  visitIdLte?: InputMaybe<Scalars['String']>;
  visitIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitorId?: InputMaybe<Scalars['String']>;
  visitorIdAny?: InputMaybe<Scalars['String']>;
  visitorIdContain?: InputMaybe<Scalars['String']>;
  visitorIdEq?: InputMaybe<Scalars['String']>;
  visitorIdGt?: InputMaybe<Scalars['String']>;
  visitorIdGte?: InputMaybe<Scalars['String']>;
  visitorIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitorIdIsNull?: InputMaybe<Scalars['Boolean']>;
  visitorIdLike?: InputMaybe<Scalars['String']>;
  visitorIdLikeNoCase?: InputMaybe<Scalars['String']>;
  visitorIdLt?: InputMaybe<Scalars['String']>;
  visitorIdLte?: InputMaybe<Scalars['String']>;
  visitorIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLVisitorsTrafficSourceMapArgs = {
  accountId?: InputMaybe<Scalars['Int']>;
  accountIdAny?: InputMaybe<Scalars['Int']>;
  accountIdContain?: InputMaybe<Scalars['Int']>;
  accountIdEq?: InputMaybe<Scalars['Int']>;
  accountIdGt?: InputMaybe<Scalars['Int']>;
  accountIdGte?: InputMaybe<Scalars['Int']>;
  accountIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  accountIdIsNull?: InputMaybe<Scalars['Boolean']>;
  accountIdLike?: InputMaybe<Scalars['Int']>;
  accountIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  accountIdLt?: InputMaybe<Scalars['Int']>;
  accountIdLte?: InputMaybe<Scalars['Int']>;
  accountIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  excludeFromDailyPL?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLAny?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLContain?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLEq?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLGt?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLGte?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  excludeFromDailyPLIsNull?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLike?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLt?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLLte?: InputMaybe<Scalars['Boolean']>;
  excludeFromDailyPLNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  networkId?: InputMaybe<Scalars['Int']>;
  networkIdAny?: InputMaybe<Scalars['Int']>;
  networkIdContain?: InputMaybe<Scalars['Int']>;
  networkIdEq?: InputMaybe<Scalars['Int']>;
  networkIdGt?: InputMaybe<Scalars['Int']>;
  networkIdGte?: InputMaybe<Scalars['Int']>;
  networkIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  networkIdIsNull?: InputMaybe<Scalars['Boolean']>;
  networkIdLike?: InputMaybe<Scalars['Int']>;
  networkIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  networkIdLt?: InputMaybe<Scalars['Int']>;
  networkIdLte?: InputMaybe<Scalars['Int']>;
  networkIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTrafficSourceMapPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTrafficSourceMapPropertiesEnum>;
  trafficSource?: InputMaybe<Scalars['String']>;
  trafficSourceAny?: InputMaybe<Scalars['String']>;
  trafficSourceContain?: InputMaybe<Scalars['String']>;
  trafficSourceEq?: InputMaybe<Scalars['String']>;
  trafficSourceGt?: InputMaybe<Scalars['String']>;
  trafficSourceGte?: InputMaybe<Scalars['String']>;
  trafficSourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficSourceIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficSourceLike?: InputMaybe<Scalars['String']>;
  trafficSourceLikeNoCase?: InputMaybe<Scalars['String']>;
  trafficSourceLt?: InputMaybe<Scalars['String']>;
  trafficSourceLte?: InputMaybe<Scalars['String']>;
  trafficSourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trafficTypeId?: InputMaybe<Scalars['Int']>;
  trafficTypeIdAny?: InputMaybe<Scalars['Int']>;
  trafficTypeIdContain?: InputMaybe<Scalars['Int']>;
  trafficTypeIdEq?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdGte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  trafficTypeIdIsNull?: InputMaybe<Scalars['Boolean']>;
  trafficTypeIdLike?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLt?: InputMaybe<Scalars['Int']>;
  trafficTypeIdLte?: InputMaybe<Scalars['Int']>;
  trafficTypeIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userIdAny?: InputMaybe<Scalars['String']>;
  userIdContain?: InputMaybe<Scalars['String']>;
  userIdEq?: InputMaybe<Scalars['String']>;
  userIdGt?: InputMaybe<Scalars['String']>;
  userIdGte?: InputMaybe<Scalars['String']>;
  userIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIdLike?: InputMaybe<Scalars['String']>;
  userIdLikeNoCase?: InputMaybe<Scalars['String']>;
  userIdLt?: InputMaybe<Scalars['String']>;
  userIdLte?: InputMaybe<Scalars['String']>;
  userIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLVisitorsVisitorIpAddressArgs = {
  bannedAt?: InputMaybe<Scalars['String']>;
  bannedAtAny?: InputMaybe<Scalars['String']>;
  bannedAtContain?: InputMaybe<Scalars['String']>;
  bannedAtEq?: InputMaybe<Scalars['String']>;
  bannedAtGt?: InputMaybe<Scalars['String']>;
  bannedAtGte?: InputMaybe<Scalars['String']>;
  bannedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bannedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  bannedAtLike?: InputMaybe<Scalars['String']>;
  bannedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  bannedAtLt?: InputMaybe<Scalars['String']>;
  bannedAtLte?: InputMaybe<Scalars['String']>;
  bannedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<Scalars['String']>;
  cityAny?: InputMaybe<Scalars['String']>;
  cityContain?: InputMaybe<Scalars['String']>;
  cityEq?: InputMaybe<Scalars['String']>;
  cityGt?: InputMaybe<Scalars['String']>;
  cityGte?: InputMaybe<Scalars['String']>;
  cityIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityIsNull?: InputMaybe<Scalars['Boolean']>;
  cityLike?: InputMaybe<Scalars['String']>;
  cityLikeNoCase?: InputMaybe<Scalars['String']>;
  cityLt?: InputMaybe<Scalars['String']>;
  cityLte?: InputMaybe<Scalars['String']>;
  cityNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  continent?: InputMaybe<Scalars['String']>;
  continentAny?: InputMaybe<Scalars['String']>;
  continentCode?: InputMaybe<Scalars['String']>;
  continentCodeAny?: InputMaybe<Scalars['String']>;
  continentCodeContain?: InputMaybe<Scalars['String']>;
  continentCodeEq?: InputMaybe<Scalars['String']>;
  continentCodeGt?: InputMaybe<Scalars['String']>;
  continentCodeGte?: InputMaybe<Scalars['String']>;
  continentCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  continentCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  continentCodeLike?: InputMaybe<Scalars['String']>;
  continentCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  continentCodeLt?: InputMaybe<Scalars['String']>;
  continentCodeLte?: InputMaybe<Scalars['String']>;
  continentCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  continentContain?: InputMaybe<Scalars['String']>;
  continentEq?: InputMaybe<Scalars['String']>;
  continentGt?: InputMaybe<Scalars['String']>;
  continentGte?: InputMaybe<Scalars['String']>;
  continentIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  continentIsNull?: InputMaybe<Scalars['Boolean']>;
  continentLike?: InputMaybe<Scalars['String']>;
  continentLikeNoCase?: InputMaybe<Scalars['String']>;
  continentLt?: InputMaybe<Scalars['String']>;
  continentLte?: InputMaybe<Scalars['String']>;
  continentNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  country?: InputMaybe<Scalars['String']>;
  countryAny?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  countryCodeAny?: InputMaybe<Scalars['String']>;
  countryCodeContain?: InputMaybe<Scalars['String']>;
  countryCodeEq?: InputMaybe<Scalars['String']>;
  countryCodeGt?: InputMaybe<Scalars['String']>;
  countryCodeGte?: InputMaybe<Scalars['String']>;
  countryCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  countryCodeLike?: InputMaybe<Scalars['String']>;
  countryCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  countryCodeLt?: InputMaybe<Scalars['String']>;
  countryCodeLte?: InputMaybe<Scalars['String']>;
  countryCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryContain?: InputMaybe<Scalars['String']>;
  countryEq?: InputMaybe<Scalars['String']>;
  countryGt?: InputMaybe<Scalars['String']>;
  countryGte?: InputMaybe<Scalars['String']>;
  countryIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryIsNull?: InputMaybe<Scalars['Boolean']>;
  countryLike?: InputMaybe<Scalars['String']>;
  countryLikeNoCase?: InputMaybe<Scalars['String']>;
  countryLt?: InputMaybe<Scalars['String']>;
  countryLte?: InputMaybe<Scalars['String']>;
  countryNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  expireAt?: InputMaybe<Scalars['String']>;
  expireAtAny?: InputMaybe<Scalars['String']>;
  expireAtContain?: InputMaybe<Scalars['String']>;
  expireAtEq?: InputMaybe<Scalars['String']>;
  expireAtGt?: InputMaybe<Scalars['String']>;
  expireAtGte?: InputMaybe<Scalars['String']>;
  expireAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  expireAtIsNull?: InputMaybe<Scalars['Boolean']>;
  expireAtLike?: InputMaybe<Scalars['String']>;
  expireAtLikeNoCase?: InputMaybe<Scalars['String']>;
  expireAtLt?: InputMaybe<Scalars['String']>;
  expireAtLte?: InputMaybe<Scalars['String']>;
  expireAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ip?: InputMaybe<Scalars['String']>;
  ipAny?: InputMaybe<Scalars['String']>;
  ipContain?: InputMaybe<Scalars['String']>;
  ipEq?: InputMaybe<Scalars['String']>;
  ipGt?: InputMaybe<Scalars['String']>;
  ipGte?: InputMaybe<Scalars['String']>;
  ipIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ipIsNull?: InputMaybe<Scalars['Boolean']>;
  ipLike?: InputMaybe<Scalars['String']>;
  ipLikeNoCase?: InputMaybe<Scalars['String']>;
  ipLt?: InputMaybe<Scalars['String']>;
  ipLte?: InputMaybe<Scalars['String']>;
  ipNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBanned?: InputMaybe<Scalars['Boolean']>;
  isBannedAny?: InputMaybe<Scalars['Boolean']>;
  isBannedContain?: InputMaybe<Scalars['Boolean']>;
  isBannedEq?: InputMaybe<Scalars['Boolean']>;
  isBannedGt?: InputMaybe<Scalars['Boolean']>;
  isBannedGte?: InputMaybe<Scalars['Boolean']>;
  isBannedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isBannedIsNull?: InputMaybe<Scalars['Boolean']>;
  isBannedLike?: InputMaybe<Scalars['Boolean']>;
  isBannedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isBannedLt?: InputMaybe<Scalars['Boolean']>;
  isBannedLte?: InputMaybe<Scalars['Boolean']>;
  isBannedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isp?: InputMaybe<Scalars['String']>;
  ispAny?: InputMaybe<Scalars['String']>;
  ispContain?: InputMaybe<Scalars['String']>;
  ispEq?: InputMaybe<Scalars['String']>;
  ispGt?: InputMaybe<Scalars['String']>;
  ispGte?: InputMaybe<Scalars['String']>;
  ispIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ispIsNull?: InputMaybe<Scalars['Boolean']>;
  ispLike?: InputMaybe<Scalars['String']>;
  ispLikeNoCase?: InputMaybe<Scalars['String']>;
  ispLt?: InputMaybe<Scalars['String']>;
  ispLte?: InputMaybe<Scalars['String']>;
  ispNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  latitude?: InputMaybe<Scalars['String']>;
  latitudeAny?: InputMaybe<Scalars['String']>;
  latitudeContain?: InputMaybe<Scalars['String']>;
  latitudeEq?: InputMaybe<Scalars['String']>;
  latitudeGt?: InputMaybe<Scalars['String']>;
  latitudeGte?: InputMaybe<Scalars['String']>;
  latitudeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  latitudeIsNull?: InputMaybe<Scalars['Boolean']>;
  latitudeLike?: InputMaybe<Scalars['String']>;
  latitudeLikeNoCase?: InputMaybe<Scalars['String']>;
  latitudeLt?: InputMaybe<Scalars['String']>;
  latitudeLte?: InputMaybe<Scalars['String']>;
  latitudeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  longitude?: InputMaybe<Scalars['String']>;
  longitudeAny?: InputMaybe<Scalars['String']>;
  longitudeContain?: InputMaybe<Scalars['String']>;
  longitudeEq?: InputMaybe<Scalars['String']>;
  longitudeGt?: InputMaybe<Scalars['String']>;
  longitudeGte?: InputMaybe<Scalars['String']>;
  longitudeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  longitudeIsNull?: InputMaybe<Scalars['Boolean']>;
  longitudeLike?: InputMaybe<Scalars['String']>;
  longitudeLikeNoCase?: InputMaybe<Scalars['String']>;
  longitudeLt?: InputMaybe<Scalars['String']>;
  longitudeLte?: InputMaybe<Scalars['String']>;
  longitudeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLIpAddressesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLIpAddressesPropertiesEnum>;
  postalCode?: InputMaybe<Scalars['String']>;
  postalCodeAny?: InputMaybe<Scalars['String']>;
  postalCodeContain?: InputMaybe<Scalars['String']>;
  postalCodeEq?: InputMaybe<Scalars['String']>;
  postalCodeGt?: InputMaybe<Scalars['String']>;
  postalCodeGte?: InputMaybe<Scalars['String']>;
  postalCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  postalCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  postalCodeLike?: InputMaybe<Scalars['String']>;
  postalCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  postalCodeLt?: InputMaybe<Scalars['String']>;
  postalCodeLte?: InputMaybe<Scalars['String']>;
  postalCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  provider?: InputMaybe<Scalars['String']>;
  providerAny?: InputMaybe<Scalars['String']>;
  providerContain?: InputMaybe<Scalars['String']>;
  providerEq?: InputMaybe<Scalars['String']>;
  providerGt?: InputMaybe<Scalars['String']>;
  providerGte?: InputMaybe<Scalars['String']>;
  providerIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  providerIsNull?: InputMaybe<Scalars['Boolean']>;
  providerLike?: InputMaybe<Scalars['String']>;
  providerLikeNoCase?: InputMaybe<Scalars['String']>;
  providerLt?: InputMaybe<Scalars['String']>;
  providerLte?: InputMaybe<Scalars['String']>;
  providerNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  state?: InputMaybe<Scalars['String']>;
  stateAny?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
  stateCodeAny?: InputMaybe<Scalars['String']>;
  stateCodeContain?: InputMaybe<Scalars['String']>;
  stateCodeEq?: InputMaybe<Scalars['String']>;
  stateCodeGt?: InputMaybe<Scalars['String']>;
  stateCodeGte?: InputMaybe<Scalars['String']>;
  stateCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  stateCodeLike?: InputMaybe<Scalars['String']>;
  stateCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  stateCodeLt?: InputMaybe<Scalars['String']>;
  stateCodeLte?: InputMaybe<Scalars['String']>;
  stateCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateContain?: InputMaybe<Scalars['String']>;
  stateEq?: InputMaybe<Scalars['String']>;
  stateGt?: InputMaybe<Scalars['String']>;
  stateGte?: InputMaybe<Scalars['String']>;
  stateIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateIsNull?: InputMaybe<Scalars['Boolean']>;
  stateLike?: InputMaybe<Scalars['String']>;
  stateLikeNoCase?: InputMaybe<Scalars['String']>;
  stateLt?: InputMaybe<Scalars['String']>;
  stateLte?: InputMaybe<Scalars['String']>;
  stateNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLVisitorsVisitsArgs = {
  adCampaign?: InputMaybe<Scalars['String']>;
  adCampaignAny?: InputMaybe<Scalars['String']>;
  adCampaignContain?: InputMaybe<Scalars['String']>;
  adCampaignEq?: InputMaybe<Scalars['String']>;
  adCampaignGt?: InputMaybe<Scalars['String']>;
  adCampaignGte?: InputMaybe<Scalars['String']>;
  adCampaignIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adCampaignIsNull?: InputMaybe<Scalars['Boolean']>;
  adCampaignLike?: InputMaybe<Scalars['String']>;
  adCampaignLikeNoCase?: InputMaybe<Scalars['String']>;
  adCampaignLt?: InputMaybe<Scalars['String']>;
  adCampaignLte?: InputMaybe<Scalars['String']>;
  adCampaignNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adDevice?: InputMaybe<Scalars['String']>;
  adDeviceAny?: InputMaybe<Scalars['String']>;
  adDeviceContain?: InputMaybe<Scalars['String']>;
  adDeviceEq?: InputMaybe<Scalars['String']>;
  adDeviceGt?: InputMaybe<Scalars['String']>;
  adDeviceGte?: InputMaybe<Scalars['String']>;
  adDeviceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adDeviceIsNull?: InputMaybe<Scalars['Boolean']>;
  adDeviceLike?: InputMaybe<Scalars['String']>;
  adDeviceLikeNoCase?: InputMaybe<Scalars['String']>;
  adDeviceLt?: InputMaybe<Scalars['String']>;
  adDeviceLte?: InputMaybe<Scalars['String']>;
  adDeviceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adGroup?: InputMaybe<Scalars['String']>;
  adGroupAny?: InputMaybe<Scalars['String']>;
  adGroupContain?: InputMaybe<Scalars['String']>;
  adGroupEq?: InputMaybe<Scalars['String']>;
  adGroupGt?: InputMaybe<Scalars['String']>;
  adGroupGte?: InputMaybe<Scalars['String']>;
  adGroupIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adGroupIsNull?: InputMaybe<Scalars['Boolean']>;
  adGroupLike?: InputMaybe<Scalars['String']>;
  adGroupLikeNoCase?: InputMaybe<Scalars['String']>;
  adGroupLt?: InputMaybe<Scalars['String']>;
  adGroupLte?: InputMaybe<Scalars['String']>;
  adGroupNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adKeyword?: InputMaybe<Scalars['String']>;
  adKeywordAny?: InputMaybe<Scalars['String']>;
  adKeywordContain?: InputMaybe<Scalars['String']>;
  adKeywordEq?: InputMaybe<Scalars['String']>;
  adKeywordGt?: InputMaybe<Scalars['String']>;
  adKeywordGte?: InputMaybe<Scalars['String']>;
  adKeywordIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adKeywordIsNull?: InputMaybe<Scalars['Boolean']>;
  adKeywordLike?: InputMaybe<Scalars['String']>;
  adKeywordLikeNoCase?: InputMaybe<Scalars['String']>;
  adKeywordLt?: InputMaybe<Scalars['String']>;
  adKeywordLte?: InputMaybe<Scalars['String']>;
  adKeywordNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adMedium?: InputMaybe<Scalars['String']>;
  adMediumAny?: InputMaybe<Scalars['String']>;
  adMediumContain?: InputMaybe<Scalars['String']>;
  adMediumEq?: InputMaybe<Scalars['String']>;
  adMediumGt?: InputMaybe<Scalars['String']>;
  adMediumGte?: InputMaybe<Scalars['String']>;
  adMediumIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adMediumIsNull?: InputMaybe<Scalars['Boolean']>;
  adMediumLike?: InputMaybe<Scalars['String']>;
  adMediumLikeNoCase?: InputMaybe<Scalars['String']>;
  adMediumLt?: InputMaybe<Scalars['String']>;
  adMediumLte?: InputMaybe<Scalars['String']>;
  adMediumNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adTrafficSource?: InputMaybe<Scalars['String']>;
  adTrafficSourceAny?: InputMaybe<Scalars['String']>;
  adTrafficSourceContain?: InputMaybe<Scalars['String']>;
  adTrafficSourceEq?: InputMaybe<Scalars['String']>;
  adTrafficSourceGt?: InputMaybe<Scalars['String']>;
  adTrafficSourceGte?: InputMaybe<Scalars['String']>;
  adTrafficSourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adTrafficSourceIsNull?: InputMaybe<Scalars['Boolean']>;
  adTrafficSourceLike?: InputMaybe<Scalars['String']>;
  adTrafficSourceLikeNoCase?: InputMaybe<Scalars['String']>;
  adTrafficSourceLt?: InputMaybe<Scalars['String']>;
  adTrafficSourceLte?: InputMaybe<Scalars['String']>;
  adTrafficSourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  expireAt?: InputMaybe<Scalars['String']>;
  expireAtAny?: InputMaybe<Scalars['String']>;
  expireAtContain?: InputMaybe<Scalars['String']>;
  expireAtEq?: InputMaybe<Scalars['String']>;
  expireAtGt?: InputMaybe<Scalars['String']>;
  expireAtGte?: InputMaybe<Scalars['String']>;
  expireAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  expireAtIsNull?: InputMaybe<Scalars['Boolean']>;
  expireAtLike?: InputMaybe<Scalars['String']>;
  expireAtLikeNoCase?: InputMaybe<Scalars['String']>;
  expireAtLt?: InputMaybe<Scalars['String']>;
  expireAtLte?: InputMaybe<Scalars['String']>;
  expireAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLVisitsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLVisitsPropertiesEnum>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  urlAny?: InputMaybe<Scalars['String']>;
  urlContain?: InputMaybe<Scalars['String']>;
  urlEq?: InputMaybe<Scalars['String']>;
  urlGt?: InputMaybe<Scalars['String']>;
  urlGte?: InputMaybe<Scalars['String']>;
  urlIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlIsNull?: InputMaybe<Scalars['Boolean']>;
  urlLike?: InputMaybe<Scalars['String']>;
  urlLikeNoCase?: InputMaybe<Scalars['String']>;
  urlLt?: InputMaybe<Scalars['String']>;
  urlLte?: InputMaybe<Scalars['String']>;
  urlNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitorId?: InputMaybe<Scalars['String']>;
  visitorIdAny?: InputMaybe<Scalars['String']>;
  visitorIdContain?: InputMaybe<Scalars['String']>;
  visitorIdEq?: InputMaybe<Scalars['String']>;
  visitorIdGt?: InputMaybe<Scalars['String']>;
  visitorIdGte?: InputMaybe<Scalars['String']>;
  visitorIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitorIdIsNull?: InputMaybe<Scalars['Boolean']>;
  visitorIdLike?: InputMaybe<Scalars['String']>;
  visitorIdLikeNoCase?: InputMaybe<Scalars['String']>;
  visitorIdLt?: InputMaybe<Scalars['String']>;
  visitorIdLte?: InputMaybe<Scalars['String']>;
  visitorIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLVisitorsPropertiesEnum {
  AdCampaign = 'adCampaign',
  AdDevice = 'adDevice',
  AdGroup = 'adGroup',
  AdKeyword = 'adKeyword',
  AdMedium = 'adMedium',
  AdTrafficSource = 'adTrafficSource',
  Browser = 'browser',
  BrowserCode = 'browserCode',
  BrowserVersion = 'browserVersion',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  DomainId = 'domainId',
  Id = 'id',
  IpAddressId = 'ipAddressId',
  IsDeleted = 'isDeleted',
  Language = 'language',
  Os = 'os',
  OsCode = 'osCode',
  OsVersion = 'osVersion',
  Platform = 'platform',
  Referrer = 'referrer',
  Ua = 'ua',
  UpdatedAt = 'updatedAt'
}

export type GQLVisits = {
  __typename?: 'Visits';
  adCampaign?: Maybe<Scalars['String']>;
  adDevice?: Maybe<Scalars['String']>;
  adGroup?: Maybe<Scalars['String']>;
  adKeyword?: Maybe<Scalars['String']>;
  adMedium?: Maybe<Scalars['String']>;
  adTrafficSource?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  expireAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  trafficNetwork?: Maybe<GQLAdvertisingNetworks>;
  trafficType?: Maybe<GQLTrafficTypes>;
  updatedAt?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  visitor?: Maybe<GQLVisitors>;
  visitorId?: Maybe<Scalars['String']>;
};


export type GQLVisitsTrafficNetworkArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLAdvertisingNetworksPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLAdvertisingNetworksPropertiesEnum>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLVisitsTrafficTypeArgs = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAny?: InputMaybe<Scalars['String']>;
  descriptionContain?: InputMaybe<Scalars['String']>;
  descriptionEq?: InputMaybe<Scalars['String']>;
  descriptionGt?: InputMaybe<Scalars['String']>;
  descriptionGte?: InputMaybe<Scalars['String']>;
  descriptionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>;
  descriptionLike?: InputMaybe<Scalars['String']>;
  descriptionLikeNoCase?: InputMaybe<Scalars['String']>;
  descriptionLt?: InputMaybe<Scalars['String']>;
  descriptionLte?: InputMaybe<Scalars['String']>;
  descriptionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  idAny?: InputMaybe<Scalars['Int']>;
  idContain?: InputMaybe<Scalars['Int']>;
  idEq?: InputMaybe<Scalars['Int']>;
  idGt?: InputMaybe<Scalars['Int']>;
  idGte?: InputMaybe<Scalars['Int']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['Int']>;
  idLikeNoCase?: InputMaybe<Scalars['Int']>;
  idLt?: InputMaybe<Scalars['Int']>;
  idLte?: InputMaybe<Scalars['Int']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveAny?: InputMaybe<Scalars['Boolean']>;
  isActiveContain?: InputMaybe<Scalars['Boolean']>;
  isActiveEq?: InputMaybe<Scalars['Boolean']>;
  isActiveGt?: InputMaybe<Scalars['Boolean']>;
  isActiveGte?: InputMaybe<Scalars['Boolean']>;
  isActiveIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isActiveIsNull?: InputMaybe<Scalars['Boolean']>;
  isActiveLike?: InputMaybe<Scalars['Boolean']>;
  isActiveLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isActiveLt?: InputMaybe<Scalars['Boolean']>;
  isActiveLte?: InputMaybe<Scalars['Boolean']>;
  isActiveNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  nameAny?: InputMaybe<Scalars['String']>;
  nameContain?: InputMaybe<Scalars['String']>;
  nameEq?: InputMaybe<Scalars['String']>;
  nameGt?: InputMaybe<Scalars['String']>;
  nameGte?: InputMaybe<Scalars['String']>;
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nameIsNull?: InputMaybe<Scalars['Boolean']>;
  nameLike?: InputMaybe<Scalars['String']>;
  nameLikeNoCase?: InputMaybe<Scalars['String']>;
  nameLt?: InputMaybe<Scalars['String']>;
  nameLte?: InputMaybe<Scalars['String']>;
  nameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLTrafficTypesPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLTrafficTypesPropertiesEnum>;
  slug?: InputMaybe<Scalars['String']>;
  slugAny?: InputMaybe<Scalars['String']>;
  slugContain?: InputMaybe<Scalars['String']>;
  slugEq?: InputMaybe<Scalars['String']>;
  slugGt?: InputMaybe<Scalars['String']>;
  slugGte?: InputMaybe<Scalars['String']>;
  slugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slugIsNull?: InputMaybe<Scalars['Boolean']>;
  slugLike?: InputMaybe<Scalars['String']>;
  slugLikeNoCase?: InputMaybe<Scalars['String']>;
  slugLt?: InputMaybe<Scalars['String']>;
  slugLte?: InputMaybe<Scalars['String']>;
  slugNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GQLVisitsVisitorArgs = {
  adCampaign?: InputMaybe<Scalars['String']>;
  adCampaignAny?: InputMaybe<Scalars['String']>;
  adCampaignContain?: InputMaybe<Scalars['String']>;
  adCampaignEq?: InputMaybe<Scalars['String']>;
  adCampaignGt?: InputMaybe<Scalars['String']>;
  adCampaignGte?: InputMaybe<Scalars['String']>;
  adCampaignIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adCampaignIsNull?: InputMaybe<Scalars['Boolean']>;
  adCampaignLike?: InputMaybe<Scalars['String']>;
  adCampaignLikeNoCase?: InputMaybe<Scalars['String']>;
  adCampaignLt?: InputMaybe<Scalars['String']>;
  adCampaignLte?: InputMaybe<Scalars['String']>;
  adCampaignNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adDevice?: InputMaybe<Scalars['String']>;
  adDeviceAny?: InputMaybe<Scalars['String']>;
  adDeviceContain?: InputMaybe<Scalars['String']>;
  adDeviceEq?: InputMaybe<Scalars['String']>;
  adDeviceGt?: InputMaybe<Scalars['String']>;
  adDeviceGte?: InputMaybe<Scalars['String']>;
  adDeviceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adDeviceIsNull?: InputMaybe<Scalars['Boolean']>;
  adDeviceLike?: InputMaybe<Scalars['String']>;
  adDeviceLikeNoCase?: InputMaybe<Scalars['String']>;
  adDeviceLt?: InputMaybe<Scalars['String']>;
  adDeviceLte?: InputMaybe<Scalars['String']>;
  adDeviceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adGroup?: InputMaybe<Scalars['String']>;
  adGroupAny?: InputMaybe<Scalars['String']>;
  adGroupContain?: InputMaybe<Scalars['String']>;
  adGroupEq?: InputMaybe<Scalars['String']>;
  adGroupGt?: InputMaybe<Scalars['String']>;
  adGroupGte?: InputMaybe<Scalars['String']>;
  adGroupIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adGroupIsNull?: InputMaybe<Scalars['Boolean']>;
  adGroupLike?: InputMaybe<Scalars['String']>;
  adGroupLikeNoCase?: InputMaybe<Scalars['String']>;
  adGroupLt?: InputMaybe<Scalars['String']>;
  adGroupLte?: InputMaybe<Scalars['String']>;
  adGroupNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adKeyword?: InputMaybe<Scalars['String']>;
  adKeywordAny?: InputMaybe<Scalars['String']>;
  adKeywordContain?: InputMaybe<Scalars['String']>;
  adKeywordEq?: InputMaybe<Scalars['String']>;
  adKeywordGt?: InputMaybe<Scalars['String']>;
  adKeywordGte?: InputMaybe<Scalars['String']>;
  adKeywordIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adKeywordIsNull?: InputMaybe<Scalars['Boolean']>;
  adKeywordLike?: InputMaybe<Scalars['String']>;
  adKeywordLikeNoCase?: InputMaybe<Scalars['String']>;
  adKeywordLt?: InputMaybe<Scalars['String']>;
  adKeywordLte?: InputMaybe<Scalars['String']>;
  adKeywordNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adMedium?: InputMaybe<Scalars['String']>;
  adMediumAny?: InputMaybe<Scalars['String']>;
  adMediumContain?: InputMaybe<Scalars['String']>;
  adMediumEq?: InputMaybe<Scalars['String']>;
  adMediumGt?: InputMaybe<Scalars['String']>;
  adMediumGte?: InputMaybe<Scalars['String']>;
  adMediumIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adMediumIsNull?: InputMaybe<Scalars['Boolean']>;
  adMediumLike?: InputMaybe<Scalars['String']>;
  adMediumLikeNoCase?: InputMaybe<Scalars['String']>;
  adMediumLt?: InputMaybe<Scalars['String']>;
  adMediumLte?: InputMaybe<Scalars['String']>;
  adMediumNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adTrafficSource?: InputMaybe<Scalars['String']>;
  adTrafficSourceAny?: InputMaybe<Scalars['String']>;
  adTrafficSourceContain?: InputMaybe<Scalars['String']>;
  adTrafficSourceEq?: InputMaybe<Scalars['String']>;
  adTrafficSourceGt?: InputMaybe<Scalars['String']>;
  adTrafficSourceGte?: InputMaybe<Scalars['String']>;
  adTrafficSourceIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  adTrafficSourceIsNull?: InputMaybe<Scalars['Boolean']>;
  adTrafficSourceLike?: InputMaybe<Scalars['String']>;
  adTrafficSourceLikeNoCase?: InputMaybe<Scalars['String']>;
  adTrafficSourceLt?: InputMaybe<Scalars['String']>;
  adTrafficSourceLte?: InputMaybe<Scalars['String']>;
  adTrafficSourceNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browser?: InputMaybe<Scalars['String']>;
  browserAny?: InputMaybe<Scalars['String']>;
  browserCode?: InputMaybe<Scalars['String']>;
  browserCodeAny?: InputMaybe<Scalars['String']>;
  browserCodeContain?: InputMaybe<Scalars['String']>;
  browserCodeEq?: InputMaybe<Scalars['String']>;
  browserCodeGt?: InputMaybe<Scalars['String']>;
  browserCodeGte?: InputMaybe<Scalars['String']>;
  browserCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  browserCodeLike?: InputMaybe<Scalars['String']>;
  browserCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  browserCodeLt?: InputMaybe<Scalars['String']>;
  browserCodeLte?: InputMaybe<Scalars['String']>;
  browserCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserContain?: InputMaybe<Scalars['String']>;
  browserEq?: InputMaybe<Scalars['String']>;
  browserGt?: InputMaybe<Scalars['String']>;
  browserGte?: InputMaybe<Scalars['String']>;
  browserIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserIsNull?: InputMaybe<Scalars['Boolean']>;
  browserLike?: InputMaybe<Scalars['String']>;
  browserLikeNoCase?: InputMaybe<Scalars['String']>;
  browserLt?: InputMaybe<Scalars['String']>;
  browserLte?: InputMaybe<Scalars['String']>;
  browserNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserVersion?: InputMaybe<Scalars['String']>;
  browserVersionAny?: InputMaybe<Scalars['String']>;
  browserVersionContain?: InputMaybe<Scalars['String']>;
  browserVersionEq?: InputMaybe<Scalars['String']>;
  browserVersionGt?: InputMaybe<Scalars['String']>;
  browserVersionGte?: InputMaybe<Scalars['String']>;
  browserVersionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  browserVersionIsNull?: InputMaybe<Scalars['Boolean']>;
  browserVersionLike?: InputMaybe<Scalars['String']>;
  browserVersionLikeNoCase?: InputMaybe<Scalars['String']>;
  browserVersionLt?: InputMaybe<Scalars['String']>;
  browserVersionLte?: InputMaybe<Scalars['String']>;
  browserVersionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  createdAtAny?: InputMaybe<Scalars['String']>;
  createdAtContain?: InputMaybe<Scalars['String']>;
  createdAtEq?: InputMaybe<Scalars['String']>;
  createdAtGt?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['String']>;
  createdAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>;
  createdAtLike?: InputMaybe<Scalars['String']>;
  createdAtLikeNoCase?: InputMaybe<Scalars['String']>;
  createdAtLt?: InputMaybe<Scalars['String']>;
  createdAtLte?: InputMaybe<Scalars['String']>;
  createdAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAt?: InputMaybe<Scalars['String']>;
  deletedAtAny?: InputMaybe<Scalars['String']>;
  deletedAtContain?: InputMaybe<Scalars['String']>;
  deletedAtEq?: InputMaybe<Scalars['String']>;
  deletedAtGt?: InputMaybe<Scalars['String']>;
  deletedAtGte?: InputMaybe<Scalars['String']>;
  deletedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deletedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  deletedAtLike?: InputMaybe<Scalars['String']>;
  deletedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  deletedAtLt?: InputMaybe<Scalars['String']>;
  deletedAtLte?: InputMaybe<Scalars['String']>;
  deletedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinct?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
  domainIdAny?: InputMaybe<Scalars['Int']>;
  domainIdContain?: InputMaybe<Scalars['Int']>;
  domainIdEq?: InputMaybe<Scalars['Int']>;
  domainIdGt?: InputMaybe<Scalars['Int']>;
  domainIdGte?: InputMaybe<Scalars['Int']>;
  domainIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  domainIdIsNull?: InputMaybe<Scalars['Boolean']>;
  domainIdLike?: InputMaybe<Scalars['Int']>;
  domainIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  domainIdLt?: InputMaybe<Scalars['Int']>;
  domainIdLte?: InputMaybe<Scalars['Int']>;
  domainIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['String']>;
  idAny?: InputMaybe<Scalars['String']>;
  idContain?: InputMaybe<Scalars['String']>;
  idEq?: InputMaybe<Scalars['String']>;
  idGt?: InputMaybe<Scalars['String']>;
  idGte?: InputMaybe<Scalars['String']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  idIsNull?: InputMaybe<Scalars['Boolean']>;
  idLike?: InputMaybe<Scalars['String']>;
  idLikeNoCase?: InputMaybe<Scalars['String']>;
  idLt?: InputMaybe<Scalars['String']>;
  idLte?: InputMaybe<Scalars['String']>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ipAddressId?: InputMaybe<Scalars['Int']>;
  ipAddressIdAny?: InputMaybe<Scalars['Int']>;
  ipAddressIdContain?: InputMaybe<Scalars['Int']>;
  ipAddressIdEq?: InputMaybe<Scalars['Int']>;
  ipAddressIdGt?: InputMaybe<Scalars['Int']>;
  ipAddressIdGte?: InputMaybe<Scalars['Int']>;
  ipAddressIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ipAddressIdIsNull?: InputMaybe<Scalars['Boolean']>;
  ipAddressIdLike?: InputMaybe<Scalars['Int']>;
  ipAddressIdLikeNoCase?: InputMaybe<Scalars['Int']>;
  ipAddressIdLt?: InputMaybe<Scalars['Int']>;
  ipAddressIdLte?: InputMaybe<Scalars['Int']>;
  ipAddressIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDeletedAny?: InputMaybe<Scalars['Boolean']>;
  isDeletedContain?: InputMaybe<Scalars['Boolean']>;
  isDeletedEq?: InputMaybe<Scalars['Boolean']>;
  isDeletedGt?: InputMaybe<Scalars['Boolean']>;
  isDeletedGte?: InputMaybe<Scalars['Boolean']>;
  isDeletedIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeletedIsNull?: InputMaybe<Scalars['Boolean']>;
  isDeletedLike?: InputMaybe<Scalars['Boolean']>;
  isDeletedLikeNoCase?: InputMaybe<Scalars['Boolean']>;
  isDeletedLt?: InputMaybe<Scalars['Boolean']>;
  isDeletedLte?: InputMaybe<Scalars['Boolean']>;
  isDeletedNotIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  language?: InputMaybe<Scalars['String']>;
  languageAny?: InputMaybe<Scalars['String']>;
  languageContain?: InputMaybe<Scalars['String']>;
  languageEq?: InputMaybe<Scalars['String']>;
  languageGt?: InputMaybe<Scalars['String']>;
  languageGte?: InputMaybe<Scalars['String']>;
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languageIsNull?: InputMaybe<Scalars['Boolean']>;
  languageLike?: InputMaybe<Scalars['String']>;
  languageLikeNoCase?: InputMaybe<Scalars['String']>;
  languageLt?: InputMaybe<Scalars['String']>;
  languageLte?: InputMaybe<Scalars['String']>;
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderBy?: InputMaybe<GQLVisitorsPropertiesEnum>;
  orderByDesc?: InputMaybe<GQLVisitorsPropertiesEnum>;
  os?: InputMaybe<Scalars['String']>;
  osAny?: InputMaybe<Scalars['String']>;
  osCode?: InputMaybe<Scalars['String']>;
  osCodeAny?: InputMaybe<Scalars['String']>;
  osCodeContain?: InputMaybe<Scalars['String']>;
  osCodeEq?: InputMaybe<Scalars['String']>;
  osCodeGt?: InputMaybe<Scalars['String']>;
  osCodeGte?: InputMaybe<Scalars['String']>;
  osCodeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osCodeIsNull?: InputMaybe<Scalars['Boolean']>;
  osCodeLike?: InputMaybe<Scalars['String']>;
  osCodeLikeNoCase?: InputMaybe<Scalars['String']>;
  osCodeLt?: InputMaybe<Scalars['String']>;
  osCodeLte?: InputMaybe<Scalars['String']>;
  osCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osContain?: InputMaybe<Scalars['String']>;
  osEq?: InputMaybe<Scalars['String']>;
  osGt?: InputMaybe<Scalars['String']>;
  osGte?: InputMaybe<Scalars['String']>;
  osIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osIsNull?: InputMaybe<Scalars['Boolean']>;
  osLike?: InputMaybe<Scalars['String']>;
  osLikeNoCase?: InputMaybe<Scalars['String']>;
  osLt?: InputMaybe<Scalars['String']>;
  osLte?: InputMaybe<Scalars['String']>;
  osNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osVersion?: InputMaybe<Scalars['String']>;
  osVersionAny?: InputMaybe<Scalars['String']>;
  osVersionContain?: InputMaybe<Scalars['String']>;
  osVersionEq?: InputMaybe<Scalars['String']>;
  osVersionGt?: InputMaybe<Scalars['String']>;
  osVersionGte?: InputMaybe<Scalars['String']>;
  osVersionIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  osVersionIsNull?: InputMaybe<Scalars['Boolean']>;
  osVersionLike?: InputMaybe<Scalars['String']>;
  osVersionLikeNoCase?: InputMaybe<Scalars['String']>;
  osVersionLt?: InputMaybe<Scalars['String']>;
  osVersionLte?: InputMaybe<Scalars['String']>;
  osVersionNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  platform?: InputMaybe<Scalars['String']>;
  platformAny?: InputMaybe<Scalars['String']>;
  platformContain?: InputMaybe<Scalars['String']>;
  platformEq?: InputMaybe<Scalars['String']>;
  platformGt?: InputMaybe<Scalars['String']>;
  platformGte?: InputMaybe<Scalars['String']>;
  platformIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  platformIsNull?: InputMaybe<Scalars['Boolean']>;
  platformLike?: InputMaybe<Scalars['String']>;
  platformLikeNoCase?: InputMaybe<Scalars['String']>;
  platformLt?: InputMaybe<Scalars['String']>;
  platformLte?: InputMaybe<Scalars['String']>;
  platformNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  referrer?: InputMaybe<Scalars['String']>;
  referrerAny?: InputMaybe<Scalars['String']>;
  referrerContain?: InputMaybe<Scalars['String']>;
  referrerEq?: InputMaybe<Scalars['String']>;
  referrerGt?: InputMaybe<Scalars['String']>;
  referrerGte?: InputMaybe<Scalars['String']>;
  referrerIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  referrerIsNull?: InputMaybe<Scalars['Boolean']>;
  referrerLike?: InputMaybe<Scalars['String']>;
  referrerLikeNoCase?: InputMaybe<Scalars['String']>;
  referrerLt?: InputMaybe<Scalars['String']>;
  referrerLte?: InputMaybe<Scalars['String']>;
  referrerNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ua?: InputMaybe<Scalars['String']>;
  uaAny?: InputMaybe<Scalars['String']>;
  uaContain?: InputMaybe<Scalars['String']>;
  uaEq?: InputMaybe<Scalars['String']>;
  uaGt?: InputMaybe<Scalars['String']>;
  uaGte?: InputMaybe<Scalars['String']>;
  uaIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uaIsNull?: InputMaybe<Scalars['Boolean']>;
  uaLike?: InputMaybe<Scalars['String']>;
  uaLikeNoCase?: InputMaybe<Scalars['String']>;
  uaLt?: InputMaybe<Scalars['String']>;
  uaLte?: InputMaybe<Scalars['String']>;
  uaNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedAtAny?: InputMaybe<Scalars['String']>;
  updatedAtContain?: InputMaybe<Scalars['String']>;
  updatedAtEq?: InputMaybe<Scalars['String']>;
  updatedAtGt?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['String']>;
  updatedAtIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>;
  updatedAtLike?: InputMaybe<Scalars['String']>;
  updatedAtLikeNoCase?: InputMaybe<Scalars['String']>;
  updatedAtLt?: InputMaybe<Scalars['String']>;
  updatedAtLte?: InputMaybe<Scalars['String']>;
  updatedAtNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum GQLVisitsPropertiesEnum {
  AdCampaign = 'adCampaign',
  AdDevice = 'adDevice',
  AdGroup = 'adGroup',
  AdKeyword = 'adKeyword',
  AdMedium = 'adMedium',
  AdTrafficSource = 'adTrafficSource',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  ExpireAt = 'expireAt',
  Id = 'id',
  IsDeleted = 'isDeleted',
  UpdatedAt = 'updatedAt',
  Url = 'url',
  VisitorId = 'visitorId'
}

export type GQLTopVendorsQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLTopVendorsQuery = { __typename?: 'Query', domain?: { __typename?: 'Domains', categories?: Array<{ __typename?: 'Categories', id?: number | null, name?: string | null, slug?: string | null, label?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, offers?: Array<{ __typename?: 'Offers', id?: number | null, name?: string | null, slug?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, logo?: { __typename?: 'Attachments', fullPath?: string | null } | null } | null> | null } | null> | null } | null };

export type GQLAllCallCenterQueryVariables = Exact<{
  offerId?: InputMaybe<Scalars['Int']>;
  ts?: InputMaybe<Scalars['String']>;
}>;


export type GQLAllCallCenterQuery = { __typename?: 'Query', allCallCenter?: Array<{ __typename?: 'CallCenter', offerId?: number | null, categoryId?: number | null, categorySlug?: string | null, phoneNumber?: string | null, ts?: string | null } | null> | null };

export type GQLAllCategoriesQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLAllCategoriesQuery = { __typename?: 'Query', domain?: { __typename?: 'Domains', categories?: Array<{ __typename?: 'Categories', id?: number | null, parentId?: number | null, title?: string | null, name?: string | null, slug?: string | null, isPublished?: boolean | null, TCPAMessage?: string | null, label?: string | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, image?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null } | null, categoryChilds?: Array<{ __typename?: 'Categories', id?: number | null, slug?: string | null, parentId?: number | null } | null> | null, mainImage?: { __typename?: 'Attachments', fullPath?: string | null, path?: string | null } | null, icon?: { __typename?: 'Attachments', id?: string | null, fullPath?: string | null, path?: string | null } | null, offers?: Array<{ __typename?: 'Offers', id?: number | null, title?: string | null, name?: string | null, slug?: string | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, defaultAffiliateLink?: { __typename?: 'AffiliateLinks', link?: string | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, logo?: { __typename?: 'Attachments', fullPath?: string | null } | null } | null> | null } | null> | null } | null };

export type GQLAllCategoriesCategorySlugQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLAllCategoriesCategorySlugQuery = { __typename?: 'Query', domain?: { __typename?: 'Domains', categories?: Array<{ __typename?: 'Categories', id?: number | null, parentId?: number | null, title?: string | null, name?: string | null, slug?: string | null, label?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, posts?: Array<{ __typename?: 'Posts', id?: number | null, title?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, image?: { __typename?: 'Attachments', fullPath?: string | null, path?: string | null } | null, url?: { __typename?: 'Urls', url?: string | null } | null } | null> | null } | null> | null } | null };

export type GQLAllCategoriesSiteMapQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLAllCategoriesSiteMapQuery = { __typename?: 'Query', allCategories?: Array<{ __typename?: 'Categories', id?: number | null, parentId?: number | null, title?: string | null, label?: string | null, name?: string | null, slug?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, offers?: Array<{ __typename?: 'Offers', id?: number | null, title?: string | null, name?: string | null, slug?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null } | null> | null };

export type GQLAllCategoriesSlugsQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLAllCategoriesSlugsQuery = { __typename?: 'Query', domain?: { __typename?: 'Domains', categories?: Array<{ __typename?: 'Categories', id?: number | null, parentId?: number | null, title?: string | null, name?: string | null, slug?: string | null, isPublished?: boolean | null, label?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null } | null };

export type GQLAllDkisQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLAllDkisQuery = { __typename?: 'Query', allDkis?: Array<{ __typename?: 'Dkis', type?: string | null, name?: string | null } | null> | null };

export type GQLAllPostsQueryVariables = Exact<{
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  domainId?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
}>;


export type GQLAllPostsQuery = { __typename?: 'Query', allPosts?: Array<{ __typename?: 'Posts', id?: number | null, domainId?: number | null, categoryId?: number | null, title?: string | null, imageId?: string | null, featured?: boolean | null, published?: boolean | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, image?: { __typename?: 'Attachments', fullPath?: string | null, path?: string | null } | null, url?: { __typename?: 'Urls', id?: number | null, modelId?: string | null, title?: string | null, language?: string | null, isActive?: boolean | null, url?: string | null } | null } | null> | null };

export type GQLAllPostsSiteMapQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Scalars['String']>;
}>;


export type GQLAllPostsSiteMapQuery = { __typename?: 'Query', allPosts?: Array<{ __typename?: 'Posts', id?: number | null, title?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, url?: { __typename?: 'Urls', language?: string | null, url?: string | null } | null } | null> | null };

export type GQLAllTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLAllTagsQuery = { __typename?: 'Query', allTags?: Array<{ __typename?: 'Tags', slug?: string | null, name?: string | null } | null> | null };

export type GQLAllUrlsQueryVariables = Exact<{
  model?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['String']>;
}>;


export type GQLAllUrlsQuery = { __typename?: 'Query', allUrls?: Array<{ __typename?: 'Urls', model?: string | null, modelId?: string | null, isMain?: boolean | null, language?: string | null, title?: string | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null, redirectionStatusCode?: number | null } | null } | null> | null };

export type GQLAllVariationsQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']>;
  orderByDesc?: InputMaybe<GQLVariationsPropertiesEnum>;
}>;


export type GQLAllVariationsQuery = { __typename?: 'Query', allVariations?: Array<{ __typename?: 'Variations', id?: number | null, label?: string | null, value?: string | null } | null> | null };

export type GQLCategoriesForHomePageQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLCategoriesForHomePageQuery = { __typename?: 'Query', domain?: { __typename?: 'Domains', categories?: Array<{ __typename?: 'Categories', id?: number | null, title?: string | null, slug?: string | null, name?: string | null, label?: string | null, parentId?: number | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, icon?: { __typename?: 'Attachments', id?: string | null, fullPath?: string | null, path?: string | null } | null, offers?: Array<{ __typename?: 'Offers', id?: number | null, title?: string | null, name?: string | null, slug?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type GQLGetCategoriesPageDomainOffersQueryVariables = Exact<{
  language: Scalars['String'];
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLGetCategoriesPageDomainOffersQuery = { __typename?: 'Query', allDomainOffers?: Array<{ __typename?: 'DomainOffers', categoryId?: number | null, offers?: Array<{ __typename?: 'Offers', name?: string | null, summaryTitle?: string | null, title?: string | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null> | null } | null> | null };

export type GQLAllDomainFormsQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLAllDomainFormsQuery = { __typename?: 'Query', allDomainForms?: Array<{ __typename?: 'DomainForms', id?: number | null, categoryId?: number | null, category?: { __typename?: 'Categories', id?: number | null, label?: string | null, name?: string | null, slug?: string | null, TCPAMessage?: string | null, isOneToOneConsent?: boolean | null } | null } | null> | null };

export type GQLCategoryAndOfferDropDownQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
  language: Scalars['String'];
}>;


export type GQLCategoryAndOfferDropDownQuery = { __typename?: 'Query', domain?: { __typename?: 'Domains', categories?: Array<{ __typename?: 'Categories', id?: number | null, name?: string | null, slug?: string | null, label?: string | null, parentId?: number | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, offers?: Array<{ __typename?: 'Offers', id?: number | null, title?: string | null, name?: string | null, slug?: string | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, logo?: { __typename?: 'Attachments', fullPath?: string | null } | null } | null> | null } | null> | null } | null };

export type GQLGetCategoryByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  language: Scalars['String'];
}>;


export type GQLGetCategoryByIdQuery = { __typename?: 'Query', category?: { __typename?: 'Categories', id?: number | null, name?: string | null, label?: string | null, title?: string | null, TCPAMessage?: string | null, isPublished?: boolean | null, languages?: any | null, slug?: string | null, slugAlias?: string | null, isOneToOneConsent?: boolean | null, headline?: string | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, attributes?: Array<{ __typename?: 'CategoryAttributes', type?: string | null, weight?: number | null, name?: string | null, attributesGroup?: { __typename?: 'CategoryAttributesGroups', id?: number | null, slug?: string | null, order?: number | null, name?: string | null, isActive?: boolean | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, metatags?: Array<{ __typename?: 'Metatags', key?: string | null, value?: string | null } | null> | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, mainImage?: { __typename?: 'Attachments', fullPath?: string | null } | null } | null };

export type GQLCategoryBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  language: Scalars['String'];
}>;


export type GQLCategoryBySlugQuery = { __typename?: 'Query', category?: { __typename?: 'Categories', id?: number | null, name?: string | null, label?: string | null, title?: string | null, subtitle?: string | null, description?: string | null, TCPAMessage?: string | null, isPublished?: boolean | null, slug?: string | null, slugAlias?: string | null, headline?: string | null, overview?: string | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, metatags?: Array<{ __typename?: 'Metatags', key?: string | null, value?: string | null } | null> | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, attributes?: Array<{ __typename?: 'CategoryAttributes', type?: string | null, weight?: number | null, value?: any | null, id?: number | null, comparison?: boolean | null, name?: string | null, hidden?: boolean | null, group?: string | null, groupSlug?: string | null, forceComparisonsDisplay?: boolean | null, attributesGroup?: { __typename?: 'CategoryAttributesGroups', id?: number | null, slug?: string | null, order?: number | null, name?: string | null, isActive?: boolean | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, mainImage?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null } | null, image?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null } | null } | null };

export type GQLCategoryBySlugAliasQueryVariables = Exact<{
  slugAlias?: InputMaybe<Scalars['String']>;
  language: Scalars['String'];
}>;


export type GQLCategoryBySlugAliasQuery = { __typename?: 'Query', category?: { __typename?: 'Categories', id?: number | null, name?: string | null, label?: string | null, title?: string | null, subtitle?: string | null, description?: string | null, TCPAMessage?: string | null, isPublished?: boolean | null, slug?: string | null, slugAlias?: string | null, headline?: string | null, overview?: string | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, metatags?: Array<{ __typename?: 'Metatags', key?: string | null, value?: string | null } | null> | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, attributes?: Array<{ __typename?: 'CategoryAttributes', weight?: number | null, value?: any | null, id?: number | null, comparison?: boolean | null, name?: string | null, hidden?: boolean | null, group?: string | null, groupSlug?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, mainImage?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null } | null, image?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null } | null } | null };

export type GQLCategoryBySlugPaginationQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  domainId?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Scalars['String']>;
}>;


export type GQLCategoryBySlugPaginationQuery = { __typename?: 'Query', category?: { __typename?: 'Categories', id?: number | null, name?: string | null, title?: string | null, slug?: string | null, languages?: any | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, posts?: Array<{ __typename?: 'Posts', id?: number | null, domainId?: number | null, title?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, image?: { __typename?: 'Attachments', fullPath?: string | null } | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null> | null } | null };

export type GQLCategoryPostsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  published?: InputMaybe<Scalars['Boolean']>;
  domainId?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Scalars['String']>;
}>;


export type GQLCategoryPostsQuery = { __typename?: 'Query', category?: { __typename?: 'Categories', id?: number | null, name?: string | null, title?: string | null, slug?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, posts?: Array<{ __typename?: 'Posts', id?: number | null, title?: string | null, image?: { __typename?: 'Attachments', fullPath?: string | null, path?: string | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null> | null } | null };

export type GQLCategoryPostsByCategoryIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  published?: InputMaybe<Scalars['Boolean']>;
  domainId?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Scalars['String']>;
  typeId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLCategoryPostsByCategoryIdQuery = { __typename?: 'Query', category?: { __typename?: 'Categories', posts?: Array<{ __typename?: 'Posts', id?: number | null, title?: string | null, image?: { __typename?: 'Attachments', fullPath?: string | null, path?: string | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null> | null } | null };

export type GQLComparisonMetaQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
}>;


export type GQLComparisonMetaQuery = { __typename?: 'Query', url?: { __typename?: 'Urls', title?: string | null, meta?: any | null } | null };

export type GQLCrossSellingDomainFormQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  categoryId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLCrossSellingDomainFormQuery = { __typename?: 'Query', domain?: { __typename?: 'Domains', domainCategories?: Array<{ __typename?: 'DomainCategories', crossSellingDomainFormId?: number | null } | null> | null } | null };

export type GQLFeaturedPostsHomePageQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLFeaturedPostsHomePageQuery = { __typename?: 'Query', allPosts?: Array<{ __typename?: 'Posts', id?: number | null, title?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, image?: { __typename?: 'Attachments', fullPath?: string | null } | null, url?: { __typename?: 'Urls', url?: string | null, isMain?: boolean | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null> | null };

export type GQLCategoryByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLCategoryByIdQuery = { __typename?: 'Query', domainForm?: { __typename?: 'DomainForms', id?: number | null, form?: { __typename?: 'Forms', id?: number | null, stepToSendingData?: number | null, title?: string | null, description?: string | null, stepToFetchBuyers?: number | null, successMessage?: string | null, errorMessage?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, steps?: Array<{ __typename?: 'Steps', id?: number | null, title?: string | null, description?: string | null, order?: number | null, adminTitle?: string | null, buttonText?: string | null, includeTCPAMessage?: boolean | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, fields?: Array<{ __typename?: 'StepFields', id?: number | null, fieldId?: number | null, order?: number | null, stepId?: number | null, label?: string | null, isRequired?: boolean | null, placeholder?: string | null, note?: string | null, autocomplete?: string | null, defaultValue?: string | null, pattern?: string | null, mask?: string | null, title?: string | null, niceName?: string | null, meta?: any | null, dataDependency?: any | null, conditionalLogic?: any | null, errorMessage?: string | null, minValue?: any | null, maxValue?: any | null, defaultValues?: any | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, origin?: { __typename?: 'Fields', codeName?: string | null, fieldType?: string | null, validationType?: string | null, id?: number | null, label?: string | null, placeholder?: string | null, note?: string | null, autocomplete?: string | null, defaultValue?: string | null, pattern?: string | null, mask?: string | null, title?: string | null, niceName?: string | null, meta?: any | null, dataDependency?: any | null, errorMessage?: string | null, minValue?: any | null, maxValue?: any | null, defaultValues?: any | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null } | null> | null } | null> | null } | null } | null };

export type GQLGetTextBlocksByPositionQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  domainId?: InputMaybe<Scalars['Int']>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GQLGetTextBlocksByPositionQuery = { __typename?: 'Query', allCustomTextBlocksPositions?: Array<{ __typename?: 'CustomTextBlocksPositions', textBlocks?: Array<{ __typename?: 'TextBlocks', position?: string | null, text?: string | null } | null> | null } | null> | null };

export type GQLGetTopVendorsQueryVariables = Exact<{
  language: Scalars['String'];
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLGetTopVendorsQuery = { __typename?: 'Query', allDomainOffers?: Array<{ __typename?: 'DomainOffers', categoryId?: number | null, offers?: Array<{ __typename?: 'Offers', slug?: string | null, logo?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null } | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null> | null } | null> | null };

export type GQLLastArticlesPerBlogQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLLastArticlesPerBlogQuery = { __typename?: 'Query', allPosts?: Array<{ __typename?: 'Posts', id?: number | null, domainId?: number | null, categoryId?: number | null, title?: string | null, excerpt?: string | null, body?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, image?: { __typename?: 'Attachments', fullPath?: string | null, path?: string | null } | null, url?: { __typename?: 'Urls', id?: number | null, modelId?: string | null, title?: string | null, language?: string | null, isActive?: boolean | null, url?: string | null } | null } | null> | null };

export type GQLLookupsByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  language: Scalars['String'];
}>;


export type GQLLookupsByIdsQuery = { __typename?: 'Query', allLookups?: Array<{ __typename?: 'Lookups', label?: string | null, id?: number | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null };

export type GQLCategoryQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
}>;


export type GQLCategoryQuery = { __typename?: 'Query', category?: { __typename?: 'Categories', offers?: Array<{ __typename?: 'Offers', id?: number | null, title?: string | null, displayUrl?: string | null, description?: string | null, isActive?: boolean | null, slug?: string | null, defaultAffiliateLinkId?: number | null, defaultAffiliateLink?: { __typename?: 'AffiliateLinks', link?: string | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, features?: Array<{ __typename?: 'OfferFeatures', id?: number | null, type?: string | null, description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, workingHours?: { __typename?: 'OfferSchedules', id?: number | null, isActive?: boolean | null, timeZone?: string | null, schedule?: any | null } | null, attributes?: Array<{ __typename?: 'CategoryAttributesValues', value?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, baseAttribute?: { __typename?: 'CategoryAttributes', name?: string | null, hidden?: boolean | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null } | null> | null, logo?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null } | null } | null> | null } | null };

export type GQLOfferByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  language: Scalars['String'];
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLOfferByIdQuery = { __typename?: 'Query', offer?: { __typename?: 'Offers', id?: number | null, title?: string | null, featuresListTitle?: string | null, languages?: any | null, updatedAt?: string | null, createdAt?: string | null, quickOverview?: string | null, description?: string | null, displayUrl?: string | null, logoId?: string | null, imageId?: string | null, score?: number | null, name?: string | null, subTitle?: string | null, overview?: string | null, body?: string | null, userId?: string | null, slug?: string | null, defaultAffiliateLinkId?: number | null, domains?: Array<{ __typename?: 'Domains', domainOffers?: Array<{ __typename?: 'DomainOffers', offerId?: number | null, domainId?: number | null, placements?: any | null } | null> | null } | null> | null, defaultAffiliateLink?: { __typename?: 'AffiliateLinks', link?: string | null } | null, categories?: Array<{ __typename?: 'Categories', id?: number | null } | null> | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, topics?: Array<{ __typename?: 'Posts', title?: string | null, image?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null, alt?: string | null } | null, url?: { __typename?: 'Urls', url?: string | null } | null, urls?: Array<{ __typename?: 'Urls', url?: string | null, language?: string | null } | null> | null } | null> | null, metatags?: Array<{ __typename?: 'Metatags', key?: string | null, value?: string | null } | null> | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, faqs?: Array<{ __typename?: 'Faqs', id?: number | null, question?: string | null, answer?: string | null } | null> | null, workingHours?: { __typename?: 'OfferSchedules', id?: number | null, isActive?: boolean | null, timeZone?: string | null, schedule?: any | null } | null, attributes?: Array<{ __typename?: 'CategoryAttributesValues', value?: string | null, id?: number | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, baseAttribute?: { __typename?: 'CategoryAttributes', weight?: number | null, comparison?: boolean | null, name?: string | null, hidden?: boolean | null, group?: string | null, groupSlug?: string | null, forceComparisonsDisplay?: boolean | null, type?: string | null, categoryId?: number | null, attributesGroup?: { __typename?: 'CategoryAttributesGroups', id?: number | null, slug?: string | null, order?: number | null, name?: string | null, isActive?: boolean | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null } | null> | null, mainImage?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null, caption?: string | null, alt?: string | null } | null, features?: Array<{ __typename?: 'OfferFeatures', id?: number | null, type?: string | null, description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, pros?: Array<{ __typename?: 'OfferFeatures', id?: number | null, type?: string | null, description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, cons?: Array<{ __typename?: 'OfferFeatures', id?: number | null, type?: string | null, description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, logo?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null, alt?: string | null } | null, image?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null, alt?: string | null } | null, writerUser?: { __typename?: 'Users', nickname?: string | null, nicknameSlug?: string | null, bio?: string | null, position?: string | null } | null, editorUser?: { __typename?: 'Users', nickname?: string | null, nicknameSlug?: string | null } | null } | null };

export type GQLOfferBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  language: Scalars['String'];
}>;


export type GQLOfferBySlugQuery = { __typename?: 'Query', offer?: { __typename?: 'Offers', id?: number | null, title?: string | null, featuresListTitle?: string | null, description?: string | null, displayUrl?: string | null, logoId?: string | null, imageId?: string | null, score?: number | null, name?: string | null, subTitle?: string | null, overview?: string | null, body?: string | null, userId?: string | null, slug?: string | null, defaultAffiliateLinkId?: number | null, defaultAffiliateLink?: { __typename?: 'AffiliateLinks', link?: string | null } | null, metatags?: Array<{ __typename?: 'Metatags', key?: string | null, value?: string | null } | null> | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, faqs?: Array<{ __typename?: 'Faqs', id?: number | null, question?: string | null, answer?: string | null } | null> | null, workingHours?: { __typename?: 'OfferSchedules', id?: number | null, isActive?: boolean | null, timeZone?: string | null, schedule?: any | null } | null, attributes?: Array<{ __typename?: 'CategoryAttributesValues', value?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, baseAttribute?: { __typename?: 'CategoryAttributes', comparison?: boolean | null, name?: string | null, hidden?: boolean | null, forceComparisonsDisplay?: boolean | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null } | null> | null, mainImage?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null } | null, features?: Array<{ __typename?: 'OfferFeatures', id?: number | null, type?: string | null, description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, pros?: Array<{ __typename?: 'OfferFeatures', id?: number | null, type?: string | null, description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, cons?: Array<{ __typename?: 'OfferFeatures', id?: number | null, type?: string | null, description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, logo?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null } | null, image?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null } | null } | null };

export type GQLGetOverviewDomainOffersQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['Int']>;
  language: Scalars['String'];
  domainId?: InputMaybe<Scalars['Int']>;
  slugs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GQLGetOverviewDomainOffersQuery = { __typename?: 'Query', allDomainOffers?: Array<{ __typename?: 'DomainOffers', offers?: Array<{ __typename?: 'Offers', id?: number | null, languages?: any | null, quickOverview?: string | null, name?: string | null, weight?: number | null, slug?: string | null, slugAlias?: string | null, categories?: Array<{ __typename?: 'Categories', id?: number | null, name?: string | null, title?: string | null } | null> | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, defaultAffiliateLink?: { __typename?: 'AffiliateLinks', link?: string | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, attributes?: Array<{ __typename?: 'CategoryAttributesValues', value?: string | null, id?: number | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, baseAttribute?: { __typename?: 'CategoryAttributes', weight?: number | null, comparison?: boolean | null, name?: string | null, groupSlug?: string | null, forceComparisonsDisplay?: boolean | null, type?: string | null, attributesGroup?: { __typename?: 'CategoryAttributesGroups', id?: number | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null } | null> | null, features?: Array<{ __typename?: 'OfferFeatures', description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, pros?: Array<{ __typename?: 'OfferFeatures', description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, cons?: Array<{ __typename?: 'OfferFeatures', description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, logo?: { __typename?: 'Attachments', fullPath?: string | null } | null } | null> | null } | null> | null };

export type GQLCategoriesGetAllCategoriesQueryQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLCategoriesGetAllCategoriesQueryQuery = { __typename?: 'Query', domain?: { __typename?: 'Domains', categories?: Array<{ __typename?: 'Categories', id?: number | null, parentId?: number | null, title?: string | null, name?: string | null, slug?: string | null, label?: string | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, categoryChilds?: Array<{ __typename?: 'Categories', id?: number | null, slug?: string | null, parentId?: number | null, title?: string | null, name?: string | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null> | null } | null> | null } | null };

export type GQLArticlesGetCategoryByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  language: Scalars['String'];
}>;


export type GQLArticlesGetCategoryByIdQuery = { __typename?: 'Query', category?: { __typename?: 'Categories', id?: number | null, name?: string | null, label?: string | null, slug?: string | null, languages?: any | null, isOneToOneConsent?: boolean | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, metatags?: Array<{ __typename?: 'Metatags', key?: string | null, value?: string | null } | null> | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null };

export type GQLGetArticlesDomainOffersQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['Int']>;
  language: Scalars['String'];
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLGetArticlesDomainOffersQuery = { __typename?: 'Query', allDomainOffers?: Array<{ __typename?: 'DomainOffers', placements?: any | null, offers?: Array<{ __typename?: 'Offers', id?: number | null, slug?: string | null, title?: string | null, logo?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null } | null, features?: Array<{ __typename?: 'OfferFeatures', id?: number | null, type?: string | null, description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null } | null> | null };

export type GQLTotalArticlesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
  domainId?: InputMaybe<Scalars['Int']>;
  typeId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLTotalArticlesQuery = { __typename?: 'Query', category?: { __typename?: 'Categories', posts?: Array<{ __typename?: 'Posts', id?: number | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null } | null };

export type GQLGetBestOverallDomainOffersQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['Int']>;
  language: Scalars['String'];
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLGetBestOverallDomainOffersQuery = { __typename?: 'Query', allDomainOffers?: Array<{ __typename?: 'DomainOffers', placements?: any | null, offers?: Array<{ __typename?: 'Offers', id?: number | null, languages?: any | null, title?: string | null, featuresListTitle?: string | null, description?: string | null, name?: string | null, slug?: string | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, attributes?: Array<{ __typename?: 'CategoryAttributesValues', value?: string | null, id?: number | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, baseAttribute?: { __typename?: 'CategoryAttributes', weight?: number | null, comparison?: boolean | null, name?: string | null, hidden?: boolean | null, group?: string | null, categoryId?: number | null, groupSlug?: string | null, forceComparisonsDisplay?: boolean | null, attributesGroup?: { __typename?: 'CategoryAttributesGroups', id?: number | null, slug?: string | null, order?: number | null, name?: string | null, isActive?: boolean | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null } | null> | null, features?: Array<{ __typename?: 'OfferFeatures', id?: number | null, type?: string | null, description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, logo?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null } | null } | null> | null } | null> | null };

export type GQLBestOverallGetCategoryByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  language: Scalars['String'];
}>;


export type GQLBestOverallGetCategoryByIdQuery = { __typename?: 'Query', category?: { __typename?: 'Categories', id?: number | null, name?: string | null, label?: string | null, slug?: string | null, languages?: any | null, TCPAMessage?: string | null, isOneToOneConsent?: boolean | null, textBlocks?: Array<{ __typename?: 'TextBlocks', position?: string | null, text?: string | null } | null> | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, metatags?: Array<{ __typename?: 'Metatags', key?: string | null, value?: string | null } | null> | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, mainImage?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null } | null } | null };

export type GQLCategoryOffersQueryQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['Int']>;
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLCategoryOffersQueryQuery = { __typename?: 'Query', allDomainOffers?: Array<{ __typename?: 'DomainOffers', offers?: Array<{ __typename?: 'Offers', slug?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, logo?: { __typename?: 'Attachments', fullPath?: string | null } | null } | null> | null } | null> | null };

export type GQLCompareGetCategoryByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  language: Scalars['String'];
}>;


export type GQLCompareGetCategoryByIdQuery = { __typename?: 'Query', category?: { __typename?: 'Categories', id?: number | null, name?: string | null, label?: string | null, slug?: string | null, languages?: any | null, TCPAMessage?: string | null, textBlocks?: Array<{ __typename?: 'TextBlocks', position?: string | null, text?: string | null } | null> | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, mainImage?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null } | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, metatags?: Array<{ __typename?: 'Metatags', key?: string | null, value?: string | null } | null> | null, attributes?: Array<{ __typename?: 'CategoryAttributes', attributesGroup?: { __typename?: 'CategoryAttributesGroups', name?: string | null, slug?: string | null, order?: number | null, isActive?: boolean | null, id?: number | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null } | null };

export type GQLGetCompareDomainOffersQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['Int']>;
  language: Scalars['String'];
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLGetCompareDomainOffersQuery = { __typename?: 'Query', allDomainOffers?: Array<{ __typename?: 'DomainOffers', placements?: any | null, offers?: Array<{ __typename?: 'Offers', id?: number | null, slug?: string | null, title?: string | null, features?: Array<{ __typename?: 'OfferFeatures', id?: number | null, type?: string | null, description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, logo?: { __typename?: 'Attachments', id?: string | null, path?: string | null, fullPath?: string | null } | null } | null> | null } | null> | null };

export type GQLOverviewGetCategoryByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  language: Scalars['String'];
}>;


export type GQLOverviewGetCategoryByIdQuery = { __typename?: 'Query', category?: { __typename?: 'Categories', id?: number | null, name?: string | null, label?: string | null, isOneToOneConsent?: boolean | null, title?: string | null, overview?: string | null, subtitle?: string | null, description?: string | null, languages?: any | null, TCPAMessage?: string | null, slug?: string | null, faqs?: Array<{ __typename?: 'Faqs', id?: number | null, question?: string | null, answer?: string | null } | null> | null, topics?: Array<{ __typename?: 'Posts', id?: number | null, title?: string | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null> | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, metatags?: Array<{ __typename?: 'Metatags', key?: string | null, value?: string | null } | null> | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, mainImage?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null } | null } | null };

export type GQLGetOffersByCategoryIdQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['Int']>;
  domainId?: InputMaybe<Scalars['Int']>;
  language: Scalars['String'];
}>;


export type GQLGetOffersByCategoryIdQuery = { __typename?: 'Query', allDomainOffers?: Array<{ __typename?: 'DomainOffers', placements?: any | null, weight?: number | null, offers?: Array<{ __typename?: 'Offers', title?: string | null, subTitle?: string | null, summaryDescription?: string | null, summaryTitle?: string | null, name?: string | null, slug?: string | null, mainImage?: { __typename?: 'Attachments', fullPath?: string | null } | null, logo?: { __typename?: 'Attachments', fullPath?: string | null } | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, defaultAffiliateLink?: { __typename?: 'AffiliateLinks', link?: string | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, features?: Array<{ __typename?: 'OfferFeatures', id?: number | null, type?: string | null, description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, attributes?: Array<{ __typename?: 'CategoryAttributesValues', value?: string | null, id?: number | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, baseAttribute?: { __typename?: 'CategoryAttributes', weight?: number | null, comparison?: boolean | null, name?: string | null, hidden?: boolean | null, group?: string | null, groupSlug?: string | null, forceComparisonsDisplay?: boolean | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null } | null> | null, pros?: Array<{ __typename?: 'OfferFeatures', description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, cons?: Array<{ __typename?: 'OfferFeatures', description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null } | null> | null } | null> | null };

export type GQLOverviewGetTextBlocksByPositionQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  domainId?: InputMaybe<Scalars['Int']>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GQLOverviewGetTextBlocksByPositionQuery = { __typename?: 'Query', allCustomTextBlocksPositions?: Array<{ __typename?: 'CustomTextBlocksPositions', textBlocks?: Array<{ __typename?: 'TextBlocks', position?: string | null, text?: string | null } | null> | null } | null> | null };

export type GQLGetRecentPostsByCategoryQueryVariables = Exact<{
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  domainId?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
  categoryId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLGetRecentPostsByCategoryQuery = { __typename?: 'Query', allPosts?: Array<{ __typename?: 'Posts', title?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, url?: { __typename?: 'Urls', url?: string | null, isMain?: boolean | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null> | null };

export type GQLGetTop3BuyersQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['Int']>;
  language: Scalars['String'];
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLGetTop3BuyersQuery = { __typename?: 'Query', allDomainOffers?: Array<{ __typename?: 'DomainOffers', offers?: Array<{ __typename?: 'Offers', name?: string | null, weight?: number | null, slug?: string | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, defaultAffiliateLink?: { __typename?: 'AffiliateLinks', link?: string | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, logo?: { __typename?: 'Attachments', fullPath?: string | null } | null } | null> | null } | null> | null };

export type GQLAllNewsQueryVariables = Exact<{
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  domainId?: InputMaybe<Scalars['Int']>;
  typeId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLAllNewsQuery = { __typename?: 'Query', allPosts?: Array<{ __typename?: 'Posts', id?: number | null, title?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, image?: { __typename?: 'Attachments', fullPath?: string | null } | null, tags?: Array<{ __typename?: 'Tags', name?: string | null } | null> | null, url?: { __typename?: 'Urls', id?: number | null, title?: string | null, language?: string | null, isActive?: boolean | null, url?: string | null, isMain?: boolean | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null> | null };

export type GQLFeaturedNewsQueryQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLFeaturedNewsQueryQuery = { __typename?: 'Query', allPosts?: Array<{ __typename?: 'Posts', id?: number | null, domainId?: number | null, title?: string | null, excerpt?: string | null, body?: string | null, createdAt?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, image?: { __typename?: 'Attachments', fullPath?: string | null, path?: string | null } | null, tags?: Array<{ __typename?: 'Tags', name?: string | null } | null> | null, url?: { __typename?: 'Urls', id?: number | null, modelId?: string | null, title?: string | null, language?: string | null, isActive?: boolean | null, url?: string | null, isMain?: boolean | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, category?: { __typename?: 'Categories', title?: string | null, name?: string | null } | null } | null> | null };

export type GQLMissedNewsQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLMissedNewsQuery = { __typename?: 'Query', allPosts?: Array<{ __typename?: 'Posts', title?: string | null, image?: { __typename?: 'Attachments', fullPath?: string | null, path?: string | null } | null, url?: { __typename?: 'Urls', isActive?: boolean | null, url?: string | null, isMain?: boolean | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, tags?: Array<{ __typename?: 'Tags', name?: string | null } | null> | null } | null> | null };

export type GQLNewsByTagsQueryQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLNewsByTagsQueryQuery = { __typename?: 'Query', allPosts?: Array<{ __typename?: 'Posts', title?: string | null, createdAt?: string | null, image?: { __typename?: 'Attachments', fullPath?: string | null, path?: string | null } | null, url?: { __typename?: 'Urls', isActive?: boolean | null, url?: string | null, isMain?: boolean | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, tags?: Array<{ __typename?: 'Tags', name?: string | null } | null> | null } | null> | null };

export type GQLTagsOptionsQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  typeId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLTagsOptionsQuery = { __typename?: 'Query', allTags?: Array<{ __typename?: 'Tags', id?: number | null, name?: string | null, slug?: string | null, posts?: Array<{ __typename?: 'Posts', id?: number | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null } | null> | null };

export type GQLTotalAllNewsQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
  typeId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLTotalAllNewsQuery = { __typename?: 'Query', allPosts?: Array<{ __typename?: 'Posts', translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null };

export type GQLTotalNewsByTagsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLTotalNewsByTagsQuery = { __typename?: 'Query', tag?: { __typename?: 'Tags', id?: number | null, name?: string | null, posts?: Array<{ __typename?: 'Posts', id?: number | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null } | null };

export type GQLTrendingNewsQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLTrendingNewsQuery = { __typename?: 'Query', allPosts?: Array<{ __typename?: 'Posts', title?: string | null, image?: { __typename?: 'Attachments', fullPath?: string | null, path?: string | null } | null, url?: { __typename?: 'Urls', isActive?: boolean | null, url?: string | null, isMain?: boolean | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, tags?: Array<{ __typename?: 'Tags', name?: string | null } | null> | null } | null> | null };

export type GQLPostGetCategoryByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  language: Scalars['String'];
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  domainId?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
}>;


export type GQLPostGetCategoryByIdQuery = { __typename?: 'Query', category?: { __typename?: 'Categories', id?: number | null, name?: string | null, label?: string | null, slug?: string | null, TCPAMessage?: string | null, isOneToOneConsent?: boolean | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, posts?: Array<{ __typename?: 'Posts', title?: string | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null> | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null };

export type GQLGetPostByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLGetPostByIdQuery = { __typename?: 'Query', post?: { __typename?: 'Posts', excerpt?: string | null, title?: string | null, body?: string | null, categoryId?: number | null, createdAt?: string | null, updatedAt?: string | null, publishedAt?: string | null, related?: Array<{ __typename?: 'Posts', title?: string | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null> | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, image?: { __typename?: 'Attachments', fullPath?: string | null, caption?: string | null, alt?: string | null } | null, tags?: Array<{ __typename?: 'Tags', id?: number | null, name?: string | null, slug?: string | null, isPublished?: boolean | null } | null> | null, urls?: Array<{ __typename?: 'Urls', isMain?: boolean | null, language?: string | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null> | null, url?: { __typename?: 'Urls', isMain?: boolean | null, language?: string | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, metatags?: Array<{ __typename?: 'Metatags', key?: string | null, value?: string | null } | null> | null, writerUser?: { __typename?: 'Users', nickname?: string | null, nicknameSlug?: string | null, bio?: string | null, position?: string | null } | null, editorUser?: { __typename?: 'Users', nickname?: string | null, nicknameSlug?: string | null } | null } | null };

export type GQLGetFormFusionThankYouOffersQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['Int']>;
  language: Scalars['String'];
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLGetFormFusionThankYouOffersQuery = { __typename?: 'Query', allDomainOffers?: Array<{ __typename?: 'DomainOffers', placements?: any | null, offers?: Array<{ __typename?: 'Offers', title?: string | null, id?: number | null, name?: string | null, slug?: string | null, attributes?: Array<{ __typename?: 'CategoryAttributesValues', value?: string | null, id?: number | null, hiddenAttributes?: { __typename?: 'CategoryAttributes', value?: any | null, name?: string | null } | null, baseAttribute?: { __typename?: 'CategoryAttributes', name?: string | null, value?: any | null, hidden?: boolean | null, type?: string | null } | null } | null> | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, logo?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null } | null, workingHours?: { __typename?: 'OfferSchedules', id?: number | null, isActive?: boolean | null, timeZone?: string | null, schedule?: any | null } | null } | null> | null } | null> | null };

export type GQLGetAllUrlsQueryVariables = Exact<{
  model?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['String']>;
}>;


export type GQLGetAllUrlsQuery = { __typename?: 'Query', allUrls?: Array<{ __typename?: 'Urls', model?: string | null, modelId?: string | null, isMain?: boolean | null, language?: string | null, title?: string | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null, redirectionStatusCode?: number | null } | null } | null> | null };

export type GQLGetDomainInfoQueryVariables = Exact<{
  language: Scalars['String'];
}>;


export type GQLGetDomainInfoQuery = { __typename?: 'Query', domain?: { __typename?: 'Domains', id?: number | null, name?: string | null, title?: string | null, description?: string | null, gtmId?: string | null, type?: string | null, isActive?: boolean | null, userId?: string | null, niceName?: string | null, isInspectorEnabled?: boolean | null, enableJornayaId?: boolean | null, enableTrustedForm?: boolean | null, clickyCodeId?: string | null, twitterPixel?: string | null, allTranslations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null } | null> | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, metatags?: Array<{ __typename?: 'DomainMetatags', key?: string | null, value?: string | null } | null> | null, menus?: Array<{ __typename?: 'Menus', id?: number | null, name?: string | null, slug?: string | null, links?: Array<{ __typename?: 'MenuItems', id?: number | null, title?: string | null, link?: string | null, parentId?: number | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type GQLGetExitModalOffersQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['Int']>;
  language: Scalars['String'];
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLGetExitModalOffersQuery = { __typename?: 'Query', allDomainOffers?: Array<{ __typename?: 'DomainOffers', placements?: any | null, offers?: Array<{ __typename?: 'Offers', title?: string | null, slug?: string | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, logo?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null } | null, features?: Array<{ __typename?: 'OfferFeatures', id?: number | null, type?: string | null, description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null } | null> | null } | null> | null };

export type GQLDomainQueryVariables = Exact<{
  language?: InputMaybe<Scalars['String']>;
}>;


export type GQLDomainQuery = { __typename?: 'Query', allTranslations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null } | null> | null };

export type GQLSitemapGetAllDomainCategoriesQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLSitemapGetAllDomainCategoriesQuery = { __typename?: 'Query', allDomainCategories?: Array<{ __typename?: 'DomainCategories', category?: { __typename?: 'Categories', id?: number | null, parentId?: number | null, title?: string | null, label?: string | null, name?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null } | null> | null };

export type GQLSitemapGetAllDomainOffersQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLSitemapGetAllDomainOffersQuery = { __typename?: 'Query', allDomainOffers?: Array<{ __typename?: 'DomainOffers', offers?: Array<{ __typename?: 'Offers', id?: number | null, title?: string | null, name?: string | null, slug?: string | null, categories?: Array<{ __typename?: 'Categories', id?: number | null } | null> | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null } | null> | null };

export type GQLVendorCompareGetDomainOffersQueryVariables = Exact<{
  offerId?: InputMaybe<Scalars['Int']>;
  domainId?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
}>;


export type GQLVendorCompareGetDomainOffersQuery = { __typename?: 'Query', domainOffer?: { __typename?: 'DomainOffers', offers?: Array<{ __typename?: 'Offers', name?: string | null, title?: string | null, id?: number | null, slug?: string | null, overview?: string | null, quickOverview?: string | null, languages?: any | null, metatags?: Array<{ __typename?: 'Metatags', key?: string | null, value?: string | null } | null> | null, pros?: Array<{ __typename?: 'OfferFeatures', id?: number | null, type?: string | null, description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, cons?: Array<{ __typename?: 'OfferFeatures', id?: number | null, type?: string | null, description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, attributes?: Array<{ __typename?: 'CategoryAttributesValues', value?: string | null, id?: number | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, baseAttribute?: { __typename?: 'CategoryAttributes', weight?: number | null, comparison?: boolean | null, name?: string | null, hidden?: boolean | null, group?: string | null, groupSlug?: string | null, forceComparisonsDisplay?: boolean | null, type?: string | null, categoryId?: number | null, attributesGroup?: { __typename?: 'CategoryAttributesGroups', id?: number | null, slug?: string | null, order?: number | null, name?: string | null, isActive?: boolean | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null } | null> | null, mainImage?: { __typename?: 'Attachments', path?: string | null, fullPath?: string | null } | null, faqs?: Array<{ __typename?: 'Faqs', id?: number | null, question?: string | null, answer?: string | null } | null> | null, features?: Array<{ __typename?: 'OfferFeatures', id?: number | null, type?: string | null, description?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, logo?: { __typename?: 'Attachments', id?: string | null, path?: string | null, fullPath?: string | null } | null, categories?: Array<{ __typename?: 'Categories', name?: string | null, label?: string | null, id?: number | null, languages?: any | null, TCPAMessage?: string | null, attributes?: Array<{ __typename?: 'CategoryAttributes', type?: string | null, weight?: number | null, value?: any | null, id?: number | null, comparison?: boolean | null, name?: string | null, hidden?: boolean | null, group?: string | null, groupSlug?: string | null, forceComparisonsDisplay?: boolean | null, attributesGroup?: { __typename?: 'CategoryAttributesGroups', id?: number | null, slug?: string | null, order?: number | null, name?: string | null, isActive?: boolean | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null> | null } | null> | null } | null };

export type GQLVendorCompareGetVendorsToCompareQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
  categoryId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLVendorCompareGetVendorsToCompareQuery = { __typename?: 'Query', allDomainOffers?: Array<{ __typename?: 'DomainOffers', offers?: Array<{ __typename?: 'Offers', slug?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, logo?: { __typename?: 'Attachments', fullPath?: string | null } | null } | null> | null } | null> | null };

export type GQLReviewGetCategoryByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  language: Scalars['String'];
}>;


export type GQLReviewGetCategoryByIdQuery = { __typename?: 'Query', category?: { __typename?: 'Categories', id?: number | null, name?: string | null, label?: string | null, slug?: string | null, languages?: any | null, isOneToOneConsent?: boolean | null, TCPAMessage?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null };

export type GQLGetReviewDomainOffersQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['Int']>;
  domainId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLGetReviewDomainOffersQuery = { __typename?: 'Query', allDomainOffers?: Array<{ __typename?: 'DomainOffers', offers?: Array<{ __typename?: 'Offers', slug?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, logo?: { __typename?: 'Attachments', fullPath?: string | null } | null } | null> | null } | null> | null };

export type GQLAllPostsWritersQueryVariables = Exact<{
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  domainId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
}>;


export type GQLAllPostsWritersQuery = { __typename?: 'Query', allPosts?: Array<{ __typename?: 'Posts', id?: number | null, title?: string | null, createdAt?: string | null, updatedAt?: string | null, type?: { __typename?: 'Lookups', label?: string | null } | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, image?: { __typename?: 'Attachments', fullPath?: string | null } | null, tags?: Array<{ __typename?: 'Tags', name?: string | null } | null> | null, url?: { __typename?: 'Urls', id?: number | null, title?: string | null, language?: string | null, isActive?: boolean | null, url?: string | null, isMain?: boolean | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null> | null };

export type GQLTotalAllWritersPostsQueryVariables = Exact<{
  domainId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
}>;


export type GQLTotalAllWritersPostsQuery = { __typename?: 'Query', allPosts?: Array<{ __typename?: 'Posts', translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null };

export type GQLUserBySlugQueryVariables = Exact<{
  nicknameSlug?: InputMaybe<Scalars['String']>;
}>;


export type GQLUserBySlugQuery = { __typename?: 'Query', user?: { __typename?: 'Users', id?: string | null, name?: string | null, nickname?: string | null, nicknameSlug?: string | null, position?: string | null, bio?: string | null } | null };

export type GQLPostByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type GQLPostByIdQuery = { __typename?: 'Query', post?: { __typename?: 'Posts', excerpt?: string | null, title?: string | null, body?: string | null, categoryId?: number | null, languages?: any | null, createdAt?: string | null, updatedAt?: string | null, publishedAt?: string | null, related?: Array<{ __typename?: 'Posts', title?: string | null, url?: { __typename?: 'Urls', isMain?: boolean | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null> | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, image?: { __typename?: 'Attachments', id?: string | null, path?: string | null, fullPath?: string | null, caption?: string | null } | null, tags?: Array<{ __typename?: 'Tags', id?: number | null, name?: string | null, slug?: string | null, isPublished?: boolean | null } | null> | null, urls?: Array<{ __typename?: 'Urls', isMain?: boolean | null, language?: string | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null> | null, url?: { __typename?: 'Urls', isMain?: boolean | null, language?: string | null, url?: string | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null, metatags?: Array<{ __typename?: 'Metatags', key?: string | null, value?: string | null } | null> | null, writerUser?: { __typename?: 'Users', id?: string | null, name?: string | null, nickname?: string | null, nicknameSlug?: string | null, bio?: string | null, position?: string | null } | null, editorUser?: { __typename?: 'Users', id?: string | null, name?: string | null, nickname?: string | null, nicknameSlug?: string | null, bio?: string | null, position?: string | null } | null } | null };

export type GQLRecentPostsByCategoryQueryVariables = Exact<{
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  domainId?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
  categoryId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLRecentPostsByCategoryQuery = { __typename?: 'Query', allPosts?: Array<{ __typename?: 'Posts', id?: number | null, domainId?: number | null, categoryId?: number | null, title?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, url?: { __typename?: 'Urls', id?: number | null, modelId?: string | null, title?: string | null, language?: string | null, isActive?: boolean | null, url?: string | null, isMain?: boolean | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null> | null };

export type GQLTagBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  offset?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  domainId?: InputMaybe<Scalars['Int']>;
  typeId?: InputMaybe<Scalars['Int']>;
}>;


export type GQLTagBySlugQuery = { __typename?: 'Query', tag?: { __typename?: 'Tags', id?: number | null, name?: string | null, posts?: Array<{ __typename?: 'Posts', id?: number | null, title?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null, image?: { __typename?: 'Attachments', fullPath?: string | null } | null, tags?: Array<{ __typename?: 'Tags', name?: string | null } | null> | null, url?: { __typename?: 'Urls', id?: number | null, title?: string | null, language?: string | null, isActive?: boolean | null, url?: string | null, isMain?: boolean | null, main?: { __typename?: 'Urls', url?: string | null } | null } | null } | null> | null } | null };

export type GQLTextBlocksQueryVariables = Exact<{
  offers?: InputMaybe<Scalars['JSON']>;
}>;


export type GQLTextBlocksQuery = { __typename?: 'Query', allTextBlocks?: Array<{ __typename?: 'TextBlocks', text?: string | null, translations?: Array<{ __typename?: 'Translations', key?: string | null, value?: any | null, language?: string | null } | null> | null } | null> | null };


export const TopVendorsDocument = `
    query topVendors($domainId: Int) {
  domain(id: $domainId) {
    categories(limit: 100, orderBy: createdAt, isPublished: true, isDeleted: false) {
      id
      name
      slug
      label
      translations {
        key
        value
        language
      }
      offers(isActive: true, isDeleted: false, bodyIsNull: false) {
        id
        name
        slug
        translations {
          key
          value
          language
        }
        logo {
          fullPath
        }
      }
    }
  }
}
    `;
export const useTopVendorsQuery = <
      TData = GQLTopVendorsQuery,
      TError = unknown
    >(
      variables?: GQLTopVendorsQueryVariables,
      options?: UseQueryOptions<GQLTopVendorsQuery, TError, TData>
    ) =>
    useQuery<GQLTopVendorsQuery, TError, TData>(
      variables === undefined ? ['topVendors'] : ['topVendors', variables],
      fetchData<GQLTopVendorsQuery, GQLTopVendorsQueryVariables>(TopVendorsDocument, variables),
      options
    );
export const AllCallCenterDocument = `
    query allCallCenter($offerId: Int, $ts: String) {
  allCallCenter(offerId: $offerId, ts: $ts) {
    offerId
    categoryId
    categorySlug
    phoneNumber
    ts
  }
}
    `;
export const useAllCallCenterQuery = <
      TData = GQLAllCallCenterQuery,
      TError = unknown
    >(
      variables?: GQLAllCallCenterQueryVariables,
      options?: UseQueryOptions<GQLAllCallCenterQuery, TError, TData>
    ) =>
    useQuery<GQLAllCallCenterQuery, TError, TData>(
      variables === undefined ? ['allCallCenter'] : ['allCallCenter', variables],
      fetchData<GQLAllCallCenterQuery, GQLAllCallCenterQueryVariables>(AllCallCenterDocument, variables),
      options
    );
export const AllCategoriesDocument = `
    query allCategories($domainId: Int) {
  domain(id: $domainId) {
    categories(limit: 100, orderBy: createdAt, isPublished: true, isDeleted: false) {
      id
      parentId
      title
      name
      slug
      isPublished
      TCPAMessage
      label
      url(isActive: true, isDeleted: false) {
        isMain
        main {
          url
        }
        url
      }
      translations {
        key
        value
        language
      }
      image {
        path
        fullPath
      }
      categoryChilds {
        id
        slug
        parentId
      }
      mainImage {
        fullPath
        path
      }
      icon {
        id
        fullPath
        path
      }
      offers(isActive: true, isDeleted: false, bodyIsNull: false, orderByDesc: weight) {
        id
        title
        name
        slug
        url(isActive: true, isDeleted: false) {
          isMain
          main {
            url
          }
          url
        }
        defaultAffiliateLink {
          link
        }
        translations {
          key
          value
          language
        }
        logo {
          fullPath
        }
      }
    }
  }
}
    `;
export const useAllCategoriesQuery = <
      TData = GQLAllCategoriesQuery,
      TError = unknown
    >(
      variables?: GQLAllCategoriesQueryVariables,
      options?: UseQueryOptions<GQLAllCategoriesQuery, TError, TData>
    ) =>
    useQuery<GQLAllCategoriesQuery, TError, TData>(
      variables === undefined ? ['allCategories'] : ['allCategories', variables],
      fetchData<GQLAllCategoriesQuery, GQLAllCategoriesQueryVariables>(AllCategoriesDocument, variables),
      options
    );
export const AllCategoriesCategorySlugDocument = `
    query allCategoriesCategorySlug($domainId: Int) {
  domain(id: $domainId) {
    categories(isPublished: true, isDeleted: false) {
      id
      parentId
      title
      name
      slug
      label
      translations {
        key
        value
        language
      }
      posts(published: true, orderByDesc: createdAt, isDeleted: false) {
        id
        title
        translations {
          key
          value
          language
        }
        image {
          fullPath
          path
        }
        url {
          url
        }
      }
    }
  }
}
    `;
export const useAllCategoriesCategorySlugQuery = <
      TData = GQLAllCategoriesCategorySlugQuery,
      TError = unknown
    >(
      variables?: GQLAllCategoriesCategorySlugQueryVariables,
      options?: UseQueryOptions<GQLAllCategoriesCategorySlugQuery, TError, TData>
    ) =>
    useQuery<GQLAllCategoriesCategorySlugQuery, TError, TData>(
      variables === undefined ? ['allCategoriesCategorySlug'] : ['allCategoriesCategorySlug', variables],
      fetchData<GQLAllCategoriesCategorySlugQuery, GQLAllCategoriesCategorySlugQueryVariables>(AllCategoriesCategorySlugDocument, variables),
      options
    );
export const AllCategoriesSiteMapDocument = `
    query allCategoriesSiteMap {
  allCategories(isPublished: true, isDeleted: false) {
    id
    parentId
    title
    label
    translations {
      key
      value
      language
    }
    url(isActive: true, isDeleted: false) {
      isMain
      main {
        url
      }
      url
    }
    name
    slug
    offers(isActive: true, isDeleted: false, bodyIsNull: false) {
      id
      title
      name
      slug
      translations {
        key
        value
        language
      }
    }
  }
}
    `;
export const useAllCategoriesSiteMapQuery = <
      TData = GQLAllCategoriesSiteMapQuery,
      TError = unknown
    >(
      variables?: GQLAllCategoriesSiteMapQueryVariables,
      options?: UseQueryOptions<GQLAllCategoriesSiteMapQuery, TError, TData>
    ) =>
    useQuery<GQLAllCategoriesSiteMapQuery, TError, TData>(
      variables === undefined ? ['allCategoriesSiteMap'] : ['allCategoriesSiteMap', variables],
      fetchData<GQLAllCategoriesSiteMapQuery, GQLAllCategoriesSiteMapQueryVariables>(AllCategoriesSiteMapDocument, variables),
      options
    );
export const AllCategoriesSlugsDocument = `
    query allCategoriesSlugs($domainId: Int) {
  domain(id: $domainId) {
    categories(
      limit: 100
      orderBy: createdAt
      isPublished: true
      isDeleted: false
      parentIdIsNull: false
    ) {
      id
      parentId
      title
      name
      slug
      isPublished
      label
      translations {
        key
        value
        language
      }
    }
  }
}
    `;
export const useAllCategoriesSlugsQuery = <
      TData = GQLAllCategoriesSlugsQuery,
      TError = unknown
    >(
      variables?: GQLAllCategoriesSlugsQueryVariables,
      options?: UseQueryOptions<GQLAllCategoriesSlugsQuery, TError, TData>
    ) =>
    useQuery<GQLAllCategoriesSlugsQuery, TError, TData>(
      variables === undefined ? ['allCategoriesSlugs'] : ['allCategoriesSlugs', variables],
      fetchData<GQLAllCategoriesSlugsQuery, GQLAllCategoriesSlugsQueryVariables>(AllCategoriesSlugsDocument, variables),
      options
    );
export const AllDkisDocument = `
    query allDkis {
  allDkis(isActive: true, type: "allowed") {
    type
    name
  }
}
    `;
export const useAllDkisQuery = <
      TData = GQLAllDkisQuery,
      TError = unknown
    >(
      variables?: GQLAllDkisQueryVariables,
      options?: UseQueryOptions<GQLAllDkisQuery, TError, TData>
    ) =>
    useQuery<GQLAllDkisQuery, TError, TData>(
      variables === undefined ? ['allDkis'] : ['allDkis', variables],
      fetchData<GQLAllDkisQuery, GQLAllDkisQueryVariables>(AllDkisDocument, variables),
      options
    );
export const AllPostsDocument = `
    query allPosts($limit: [Int], $offset: [Int], $domainId: Int, $published: Boolean) {
  allPosts(
    limit: $limit
    offset: $offset
    published: $published
    isDeleted: false
    orderByDesc: createdAt
    domainId: $domainId
  ) {
    id
    domainId
    categoryId
    title
    imageId
    featured
    published
    translations {
      key
      value
      language
    }
    image {
      fullPath
      path
    }
    url {
      id
      modelId
      title
      language
      isActive
      url
    }
  }
}
    `;
export const useAllPostsQuery = <
      TData = GQLAllPostsQuery,
      TError = unknown
    >(
      variables?: GQLAllPostsQueryVariables,
      options?: UseQueryOptions<GQLAllPostsQuery, TError, TData>
    ) =>
    useQuery<GQLAllPostsQuery, TError, TData>(
      variables === undefined ? ['allPosts'] : ['allPosts', variables],
      fetchData<GQLAllPostsQuery, GQLAllPostsQueryVariables>(AllPostsDocument, variables),
      options
    );
export const AllPostsSiteMapDocument = `
    query allPostsSiteMap($domainId: Int, $language: String) {
  allPosts(
    published: true
    isDeleted: false
    orderByDesc: createdAt
    domainId: $domainId
    categoryIdIsNull: false
  ) {
    id
    title
    translations {
      key
      value
      language
    }
    url(language: $language, isMain: true) {
      language
      url
    }
  }
}
    `;
export const useAllPostsSiteMapQuery = <
      TData = GQLAllPostsSiteMapQuery,
      TError = unknown
    >(
      variables?: GQLAllPostsSiteMapQueryVariables,
      options?: UseQueryOptions<GQLAllPostsSiteMapQuery, TError, TData>
    ) =>
    useQuery<GQLAllPostsSiteMapQuery, TError, TData>(
      variables === undefined ? ['allPostsSiteMap'] : ['allPostsSiteMap', variables],
      fetchData<GQLAllPostsSiteMapQuery, GQLAllPostsSiteMapQueryVariables>(AllPostsSiteMapDocument, variables),
      options
    );
export const AllTagsDocument = `
    query allTags {
  allTags {
    slug
    name
  }
}
    `;
export const useAllTagsQuery = <
      TData = GQLAllTagsQuery,
      TError = unknown
    >(
      variables?: GQLAllTagsQueryVariables,
      options?: UseQueryOptions<GQLAllTagsQuery, TError, TData>
    ) =>
    useQuery<GQLAllTagsQuery, TError, TData>(
      variables === undefined ? ['allTags'] : ['allTags', variables],
      fetchData<GQLAllTagsQuery, GQLAllTagsQueryVariables>(AllTagsDocument, variables),
      options
    );
export const AllUrlsDocument = `
    query allUrls($model: String, $modelId: String) {
  allUrls(model: $model, modelId: $modelId, isDeleted: false, isActive: true) {
    model
    modelId
    isMain
    language
    title
    url
    main {
      url
      redirectionStatusCode
    }
  }
}
    `;
export const useAllUrlsQuery = <
      TData = GQLAllUrlsQuery,
      TError = unknown
    >(
      variables?: GQLAllUrlsQueryVariables,
      options?: UseQueryOptions<GQLAllUrlsQuery, TError, TData>
    ) =>
    useQuery<GQLAllUrlsQuery, TError, TData>(
      variables === undefined ? ['allUrls'] : ['allUrls', variables],
      fetchData<GQLAllUrlsQuery, GQLAllUrlsQueryVariables>(AllUrlsDocument, variables),
      options
    );
export const AllVariationsDocument = `
    query allVariations($type: String, $orderByDesc: VariationsPropertiesEnum) {
  allVariations(type: $type, orderByDesc: $orderByDesc, isDeleted: false) {
    id
    label
    value
  }
}
    `;
export const useAllVariationsQuery = <
      TData = GQLAllVariationsQuery,
      TError = unknown
    >(
      variables?: GQLAllVariationsQueryVariables,
      options?: UseQueryOptions<GQLAllVariationsQuery, TError, TData>
    ) =>
    useQuery<GQLAllVariationsQuery, TError, TData>(
      variables === undefined ? ['allVariations'] : ['allVariations', variables],
      fetchData<GQLAllVariationsQuery, GQLAllVariationsQueryVariables>(AllVariationsDocument, variables),
      options
    );
export const CategoriesForHomePageDocument = `
    query categoriesForHomePage($domainId: Int) {
  domain(id: $domainId) {
    categories(limit: 100, orderBy: createdAt, isPublished: true, isDeleted: false) {
      id
      title
      slug
      name
      label
      parentId
      translations {
        key
        value
        language
      }
      icon {
        id
        fullPath
        path
      }
      offers(isActive: true, isDeleted: false, bodyIsNull: false) {
        id
        title
        name
        slug
        translations {
          key
          value
          language
        }
      }
    }
  }
}
    `;
export const useCategoriesForHomePageQuery = <
      TData = GQLCategoriesForHomePageQuery,
      TError = unknown
    >(
      variables?: GQLCategoriesForHomePageQueryVariables,
      options?: UseQueryOptions<GQLCategoriesForHomePageQuery, TError, TData>
    ) =>
    useQuery<GQLCategoriesForHomePageQuery, TError, TData>(
      variables === undefined ? ['categoriesForHomePage'] : ['categoriesForHomePage', variables],
      fetchData<GQLCategoriesForHomePageQuery, GQLCategoriesForHomePageQueryVariables>(CategoriesForHomePageDocument, variables),
      options
    );
export const GetCategoriesPageDomainOffersDocument = `
    query getCategoriesPageDomainOffers($language: String!, $domainId: Int) {
  allDomainOffers(domainId: $domainId, orderByDesc: weight) {
    categoryId
    offers(isDeleted: false, isActive: true) {
      name
      summaryTitle
      title
      url(isActive: true, isDeleted: false, languageEq: $language) {
        main {
          url
        }
        isMain
        url
      }
    }
  }
}
    `;
export const useGetCategoriesPageDomainOffersQuery = <
      TData = GQLGetCategoriesPageDomainOffersQuery,
      TError = unknown
    >(
      variables: GQLGetCategoriesPageDomainOffersQueryVariables,
      options?: UseQueryOptions<GQLGetCategoriesPageDomainOffersQuery, TError, TData>
    ) =>
    useQuery<GQLGetCategoriesPageDomainOffersQuery, TError, TData>(
      ['getCategoriesPageDomainOffers', variables],
      fetchData<GQLGetCategoriesPageDomainOffersQuery, GQLGetCategoriesPageDomainOffersQueryVariables>(GetCategoriesPageDomainOffersDocument, variables),
      options
    );
export const AllDomainFormsDocument = `
    query allDomainForms($domainId: Int) {
  allDomainForms(
    domainId: $domainId
    isDeleted: false
    isActive: true
    orderBy: formId
  ) {
    id
    categoryId
    category {
      id
      label
      name
      slug
      TCPAMessage
      isOneToOneConsent
    }
  }
}
    `;
export const useAllDomainFormsQuery = <
      TData = GQLAllDomainFormsQuery,
      TError = unknown
    >(
      variables?: GQLAllDomainFormsQueryVariables,
      options?: UseQueryOptions<GQLAllDomainFormsQuery, TError, TData>
    ) =>
    useQuery<GQLAllDomainFormsQuery, TError, TData>(
      variables === undefined ? ['allDomainForms'] : ['allDomainForms', variables],
      fetchData<GQLAllDomainFormsQuery, GQLAllDomainFormsQueryVariables>(AllDomainFormsDocument, variables),
      options
    );
export const CategoryAndOfferDropDownDocument = `
    query categoryAndOfferDropDown($domainId: Int, $language: String!) {
  domain(id: $domainId) {
    categories(limit: 100, orderBy: createdAt, isPublished: true, isDeleted: false) {
      id
      name
      slug
      label
      parentId
      url(isActive: true, isDeleted: false, languageEq: $language) {
        isMain
        main {
          url
        }
        url
      }
      translations {
        key
        value
        language
      }
      offers(orderByDesc: weight, isActive: true, isDeleted: false, bodyIsNull: false) {
        id
        title
        name
        slug
        url(isActive: true, isDeleted: false) {
          isMain
          main {
            url
          }
          url
        }
        translations {
          key
          value
          language
        }
        logo {
          fullPath
        }
      }
    }
  }
}
    `;
export const useCategoryAndOfferDropDownQuery = <
      TData = GQLCategoryAndOfferDropDownQuery,
      TError = unknown
    >(
      variables: GQLCategoryAndOfferDropDownQueryVariables,
      options?: UseQueryOptions<GQLCategoryAndOfferDropDownQuery, TError, TData>
    ) =>
    useQuery<GQLCategoryAndOfferDropDownQuery, TError, TData>(
      ['categoryAndOfferDropDown', variables],
      fetchData<GQLCategoryAndOfferDropDownQuery, GQLCategoryAndOfferDropDownQueryVariables>(CategoryAndOfferDropDownDocument, variables),
      options
    );
export const GetCategoryByIdDocument = `
    query getCategoryById($id: Int, $language: String!) {
  category(id: $id, isDeleted: false) {
    id
    name
    label
    title
    TCPAMessage
    isPublished
    languages
    slug
    slugAlias
    isOneToOneConsent
    url(isActive: true, isDeleted: false, languageEq: $language) {
      isMain
      main {
        url
      }
      url
    }
    attributes(hidden: false, orderByDesc: weight, isDeleted: false) {
      type
      weight
      name
      attributesGroup {
        id
        slug
        order
        name
        isActive
      }
      translations {
        key
        value
        language
      }
    }
    headline
    metatags {
      key
      value
    }
    translations {
      key
      value
      language
    }
    mainImage {
      fullPath
    }
  }
}
    `;
export const useGetCategoryByIdQuery = <
      TData = GQLGetCategoryByIdQuery,
      TError = unknown
    >(
      variables: GQLGetCategoryByIdQueryVariables,
      options?: UseQueryOptions<GQLGetCategoryByIdQuery, TError, TData>
    ) =>
    useQuery<GQLGetCategoryByIdQuery, TError, TData>(
      ['getCategoryById', variables],
      fetchData<GQLGetCategoryByIdQuery, GQLGetCategoryByIdQueryVariables>(GetCategoryByIdDocument, variables),
      options
    );
export const CategoryBySlugDocument = `
    query categoryBySlug($slug: String, $language: String!) {
  category(slug: $slug, isDeleted: false) {
    id
    name
    label
    title
    subtitle
    description
    TCPAMessage
    isPublished
    slug
    slugAlias
    headline
    overview
    url(isActive: true, isDeleted: false, languageEq: $language) {
      isMain
      main {
        url
      }
      url
    }
    metatags {
      key
      value
    }
    translations {
      key
      value
      language
    }
    attributes(hidden: false, orderByDesc: weight, isDeleted: false) {
      type
      weight
      value
      id
      comparison
      name
      hidden
      group
      groupSlug
      forceComparisonsDisplay
      attributesGroup {
        id
        slug
        order
        name
        isActive
      }
      translations {
        key
        value
        language
      }
    }
    mainImage {
      path
      fullPath
    }
    image {
      path
      fullPath
    }
  }
}
    `;
export const useCategoryBySlugQuery = <
      TData = GQLCategoryBySlugQuery,
      TError = unknown
    >(
      variables: GQLCategoryBySlugQueryVariables,
      options?: UseQueryOptions<GQLCategoryBySlugQuery, TError, TData>
    ) =>
    useQuery<GQLCategoryBySlugQuery, TError, TData>(
      ['categoryBySlug', variables],
      fetchData<GQLCategoryBySlugQuery, GQLCategoryBySlugQueryVariables>(CategoryBySlugDocument, variables),
      options
    );
export const CategoryBySlugAliasDocument = `
    query categoryBySlugAlias($slugAlias: String, $language: String!) {
  category(slugAlias: $slugAlias, isDeleted: false) {
    id
    name
    label
    title
    subtitle
    description
    TCPAMessage
    isPublished
    slug
    slugAlias
    headline
    overview
    url(isActive: true, isDeleted: false, languageEq: $language) {
      isMain
      main {
        url
      }
      url
    }
    metatags {
      key
      value
    }
    translations {
      key
      value
      language
    }
    attributes(comparison: true, orderByDesc: weight, isDeleted: false) {
      weight
      value
      id
      comparison
      name
      hidden
      group
      groupSlug
      translations {
        key
        value
        language
      }
    }
    mainImage {
      path
      fullPath
    }
    image {
      path
      fullPath
    }
  }
}
    `;
export const useCategoryBySlugAliasQuery = <
      TData = GQLCategoryBySlugAliasQuery,
      TError = unknown
    >(
      variables: GQLCategoryBySlugAliasQueryVariables,
      options?: UseQueryOptions<GQLCategoryBySlugAliasQuery, TError, TData>
    ) =>
    useQuery<GQLCategoryBySlugAliasQuery, TError, TData>(
      ['categoryBySlugAlias', variables],
      fetchData<GQLCategoryBySlugAliasQuery, GQLCategoryBySlugAliasQueryVariables>(CategoryBySlugAliasDocument, variables),
      options
    );
export const CategoryBySlugPaginationDocument = `
    query categoryBySlugPagination($slug: String, $offset: [Int], $limit: [Int], $domainId: Int, $language: String) {
  category(slug: $slug) {
    id
    name
    title
    slug
    languages
    translations {
      key
      value
      language
    }
    url(isActive: true, isDeleted: false, languageEq: $language) {
      isMain
      main {
        url
      }
      url
    }
    posts(
      limit: $limit
      offset: $offset
      published: true
      orderByDesc: createdAt
      isDeleted: false
      domainId: $domainId
      typeId: 2295
    ) {
      id
      domainId
      title
      translations {
        key
        value
        language
      }
      image {
        fullPath
      }
      url(isActive: true, isDeleted: false, languageEq: $language) {
        isMain
        main {
          url
        }
        url
      }
    }
  }
}
    `;
export const useCategoryBySlugPaginationQuery = <
      TData = GQLCategoryBySlugPaginationQuery,
      TError = unknown
    >(
      variables?: GQLCategoryBySlugPaginationQueryVariables,
      options?: UseQueryOptions<GQLCategoryBySlugPaginationQuery, TError, TData>
    ) =>
    useQuery<GQLCategoryBySlugPaginationQuery, TError, TData>(
      variables === undefined ? ['categoryBySlugPagination'] : ['categoryBySlugPagination', variables],
      fetchData<GQLCategoryBySlugPaginationQuery, GQLCategoryBySlugPaginationQueryVariables>(CategoryBySlugPaginationDocument, variables),
      options
    );
export const CategoryPostsDocument = `
    query categoryPosts($slug: String, $limit: [Int], $offset: [Int], $published: Boolean, $domainId: Int, $language: String) {
  category(slug: $slug) {
    id
    name
    title
    slug
    translations {
      key
      value
      language
    }
    posts(
      limit: $limit
      offset: $offset
      published: $published
      orderByDesc: createdAt
      domainId: $domainId
      isDeleted: false
    ) {
      id
      title
      image {
        fullPath
        path
      }
      translations {
        key
        value
        language
      }
      url(isActive: true, isDeleted: false, languageEq: $language) {
        isMain
        main {
          url
        }
        url
      }
    }
  }
}
    `;
export const useCategoryPostsQuery = <
      TData = GQLCategoryPostsQuery,
      TError = unknown
    >(
      variables?: GQLCategoryPostsQueryVariables,
      options?: UseQueryOptions<GQLCategoryPostsQuery, TError, TData>
    ) =>
    useQuery<GQLCategoryPostsQuery, TError, TData>(
      variables === undefined ? ['categoryPosts'] : ['categoryPosts', variables],
      fetchData<GQLCategoryPostsQuery, GQLCategoryPostsQueryVariables>(CategoryPostsDocument, variables),
      options
    );
export const CategoryPostsByCategoryIdDocument = `
    query categoryPostsByCategoryId($id: Int, $limit: [Int], $offset: [Int], $published: Boolean, $domainId: Int, $language: String, $typeId: Int) {
  category(id: $id) {
    posts(
      limit: $limit
      offset: $offset
      published: $published
      orderByDesc: createdAt
      domainId: $domainId
      isDeleted: false
      typeId: $typeId
    ) {
      id
      title
      image {
        fullPath
        path
      }
      translations {
        key
        value
        language
      }
      url(isActive: true, isDeleted: false, languageEq: $language) {
        isMain
        main {
          url
        }
        url
      }
    }
  }
}
    `;
export const useCategoryPostsByCategoryIdQuery = <
      TData = GQLCategoryPostsByCategoryIdQuery,
      TError = unknown
    >(
      variables?: GQLCategoryPostsByCategoryIdQueryVariables,
      options?: UseQueryOptions<GQLCategoryPostsByCategoryIdQuery, TError, TData>
    ) =>
    useQuery<GQLCategoryPostsByCategoryIdQuery, TError, TData>(
      variables === undefined ? ['categoryPostsByCategoryId'] : ['categoryPostsByCategoryId', variables],
      fetchData<GQLCategoryPostsByCategoryIdQuery, GQLCategoryPostsByCategoryIdQueryVariables>(CategoryPostsByCategoryIdDocument, variables),
      options
    );
export const ComparisonMetaDocument = `
    query comparisonMeta($url: String) {
  url(url: $url) {
    title
    meta
  }
}
    `;
export const useComparisonMetaQuery = <
      TData = GQLComparisonMetaQuery,
      TError = unknown
    >(
      variables?: GQLComparisonMetaQueryVariables,
      options?: UseQueryOptions<GQLComparisonMetaQuery, TError, TData>
    ) =>
    useQuery<GQLComparisonMetaQuery, TError, TData>(
      variables === undefined ? ['comparisonMeta'] : ['comparisonMeta', variables],
      fetchData<GQLComparisonMetaQuery, GQLComparisonMetaQueryVariables>(ComparisonMetaDocument, variables),
      options
    );
export const CrossSellingDomainFormDocument = `
    query crossSellingDomainForm($id: Int, $categoryId: Int) {
  domain(id: $id) {
    domainCategories(categoryId: $categoryId) {
      crossSellingDomainFormId
    }
  }
}
    `;
export const useCrossSellingDomainFormQuery = <
      TData = GQLCrossSellingDomainFormQuery,
      TError = unknown
    >(
      variables?: GQLCrossSellingDomainFormQueryVariables,
      options?: UseQueryOptions<GQLCrossSellingDomainFormQuery, TError, TData>
    ) =>
    useQuery<GQLCrossSellingDomainFormQuery, TError, TData>(
      variables === undefined ? ['crossSellingDomainForm'] : ['crossSellingDomainForm', variables],
      fetchData<GQLCrossSellingDomainFormQuery, GQLCrossSellingDomainFormQueryVariables>(CrossSellingDomainFormDocument, variables),
      options
    );
export const FeaturedPostsHomePageDocument = `
    query featuredPostsHomePage($domainId: Int) {
  allPosts(
    limit: 6
    offset: 0
    featured: true
    published: true
    isDeleted: false
    typeId: 2295
    orderByDesc: createdAt
    domainId: $domainId
  ) {
    id
    title
    translations {
      key
      value
      language
    }
    image {
      fullPath
    }
    url {
      url
      isMain
      main {
        url
      }
    }
  }
}
    `;
export const useFeaturedPostsHomePageQuery = <
      TData = GQLFeaturedPostsHomePageQuery,
      TError = unknown
    >(
      variables?: GQLFeaturedPostsHomePageQueryVariables,
      options?: UseQueryOptions<GQLFeaturedPostsHomePageQuery, TError, TData>
    ) =>
    useQuery<GQLFeaturedPostsHomePageQuery, TError, TData>(
      variables === undefined ? ['featuredPostsHomePage'] : ['featuredPostsHomePage', variables],
      fetchData<GQLFeaturedPostsHomePageQuery, GQLFeaturedPostsHomePageQueryVariables>(FeaturedPostsHomePageDocument, variables),
      options
    );
export const CategoryByIdDocument = `
    query categoryById($id: Int, $domainId: Int) {
  domainForm(
    domainId: $domainId
    categoryId: $id
    isDeleted: false
    isActive: true
    orderBy: formId
  ) {
    id
    form(isVariant: false) {
      id
      stepToSendingData
      title
      description
      stepToFetchBuyers
      successMessage
      errorMessage
      translations {
        key
        value
        language
      }
      steps {
        id
        title
        description
        order
        adminTitle
        buttonText
        includeTCPAMessage
        translations {
          key
          value
          language
        }
        fields {
          id
          fieldId
          translations {
            key
            value
            language
          }
          order
          stepId
          order
          label
          isRequired
          placeholder
          note
          autocomplete
          defaultValue
          pattern
          mask
          title
          niceName
          meta
          dataDependency
          conditionalLogic
          errorMessage
          minValue
          maxValue
          defaultValues
          origin {
            codeName
            fieldType
            validationType
            id
            label
            placeholder
            note
            autocomplete
            defaultValue
            translations {
              key
              value
              language
            }
            pattern
            mask
            title
            niceName
            meta
            dataDependency
            errorMessage
            minValue
            maxValue
            defaultValues
          }
        }
      }
    }
  }
}
    `;
export const useCategoryByIdQuery = <
      TData = GQLCategoryByIdQuery,
      TError = unknown
    >(
      variables?: GQLCategoryByIdQueryVariables,
      options?: UseQueryOptions<GQLCategoryByIdQuery, TError, TData>
    ) =>
    useQuery<GQLCategoryByIdQuery, TError, TData>(
      variables === undefined ? ['categoryById'] : ['categoryById', variables],
      fetchData<GQLCategoryByIdQuery, GQLCategoryByIdQueryVariables>(CategoryByIdDocument, variables),
      options
    );
export const GetTextBlocksByPositionDocument = `
    query getTextBlocksByPosition($id: Int, $domainId: Int, $positions: [String]) {
  allCustomTextBlocksPositions(isActive: true, positionIn: $positions) {
    textBlocks(
      categoryId: $id
      isDeleted: false
      isActive: true
      domainId: $domainId
    ) {
      position
      text
    }
  }
}
    `;
export const useGetTextBlocksByPositionQuery = <
      TData = GQLGetTextBlocksByPositionQuery,
      TError = unknown
    >(
      variables?: GQLGetTextBlocksByPositionQueryVariables,
      options?: UseQueryOptions<GQLGetTextBlocksByPositionQuery, TError, TData>
    ) =>
    useQuery<GQLGetTextBlocksByPositionQuery, TError, TData>(
      variables === undefined ? ['getTextBlocksByPosition'] : ['getTextBlocksByPosition', variables],
      fetchData<GQLGetTextBlocksByPositionQuery, GQLGetTextBlocksByPositionQueryVariables>(GetTextBlocksByPositionDocument, variables),
      options
    );
export const GetTopVendorsDocument = `
    query getTopVendors($language: String!, $domainId: Int) {
  allDomainOffers(domainId: $domainId) {
    categoryId
    offers(orderByDesc: weight, isDeleted: false, isActive: true) {
      slug
      logo {
        path
        fullPath
      }
      url(isActive: true, isDeleted: false, languageEq: $language) {
        main {
          url
        }
        isMain
        url
      }
    }
  }
}
    `;
export const useGetTopVendorsQuery = <
      TData = GQLGetTopVendorsQuery,
      TError = unknown
    >(
      variables: GQLGetTopVendorsQueryVariables,
      options?: UseQueryOptions<GQLGetTopVendorsQuery, TError, TData>
    ) =>
    useQuery<GQLGetTopVendorsQuery, TError, TData>(
      ['getTopVendors', variables],
      fetchData<GQLGetTopVendorsQuery, GQLGetTopVendorsQueryVariables>(GetTopVendorsDocument, variables),
      options
    );
export const LastArticlesPerBlogDocument = `
    query lastArticlesPerBlog($domainId: Int) {
  allPosts(
    limit: 4
    offset: 0
    published: true
    isDeleted: false
    typeId: 2295
    orderByDesc: createdAt
    domainId: $domainId
  ) {
    id
    domainId
    categoryId
    title
    excerpt
    body
    translations {
      key
      value
      language
    }
    image {
      fullPath
      path
    }
    url {
      id
      modelId
      title
      language
      isActive
      url
    }
  }
}
    `;
export const useLastArticlesPerBlogQuery = <
      TData = GQLLastArticlesPerBlogQuery,
      TError = unknown
    >(
      variables?: GQLLastArticlesPerBlogQueryVariables,
      options?: UseQueryOptions<GQLLastArticlesPerBlogQuery, TError, TData>
    ) =>
    useQuery<GQLLastArticlesPerBlogQuery, TError, TData>(
      variables === undefined ? ['lastArticlesPerBlog'] : ['lastArticlesPerBlog', variables],
      fetchData<GQLLastArticlesPerBlogQuery, GQLLastArticlesPerBlogQueryVariables>(LastArticlesPerBlogDocument, variables),
      options
    );
export const LookupsByIdsDocument = `
    query lookupsByIds($ids: [Int], $language: String!) {
  allLookups(idIn: $ids) {
    label
    id
    translations(languageEq: $language) {
      key
      value
      language
    }
  }
}
    `;
export const useLookupsByIdsQuery = <
      TData = GQLLookupsByIdsQuery,
      TError = unknown
    >(
      variables: GQLLookupsByIdsQueryVariables,
      options?: UseQueryOptions<GQLLookupsByIdsQuery, TError, TData>
    ) =>
    useQuery<GQLLookupsByIdsQuery, TError, TData>(
      ['lookupsByIds', variables],
      fetchData<GQLLookupsByIdsQuery, GQLLookupsByIdsQueryVariables>(LookupsByIdsDocument, variables),
      options
    );
export const CategoryDocument = `
    query category($slug: String, $id: Int) {
  category(slug: $slug) {
    offers(isActive: true, isDeleted: false, bodyIsNull: false) {
      id
      title
      displayUrl
      description
      defaultAffiliateLink {
        link
      }
      translations {
        key
        value
        language
      }
      features(type: "selling-point") {
        id
        type
        description
        translations {
          key
          value
          language
        }
      }
      workingHours {
        id
        isActive
        timeZone
        schedule
      }
      attributes(isDeleted: false) {
        value
        translations {
          key
          value
          language
        }
        baseAttribute(categoryId: $id, isDeleted: false) {
          name
          hidden
          translations {
            key
            value
            language
          }
        }
      }
      isActive
      slug
      defaultAffiliateLinkId
      logo {
        path
        fullPath
      }
    }
  }
}
    `;
export const useCategoryQuery = <
      TData = GQLCategoryQuery,
      TError = unknown
    >(
      variables?: GQLCategoryQueryVariables,
      options?: UseQueryOptions<GQLCategoryQuery, TError, TData>
    ) =>
    useQuery<GQLCategoryQuery, TError, TData>(
      variables === undefined ? ['category'] : ['category', variables],
      fetchData<GQLCategoryQuery, GQLCategoryQueryVariables>(CategoryDocument, variables),
      options
    );
export const OfferByIdDocument = `
    query offerById($id: Int, $language: String!, $domainId: Int) {
  offer(id: $id, isDeleted: false, isActive: true, bodyIsNull: false) {
    id
    title
    featuresListTitle
    languages
    updatedAt
    createdAt
    domains(id: $domainId) {
      domainOffers(offerId: $id) {
        offerId
        domainId
        placements
      }
    }
    quickOverview
    defaultAffiliateLink {
      link
    }
    description
    displayUrl
    logoId
    categories {
      id
    }
    url(isActive: true, isDeleted: false) {
      isMain
      main {
        url
      }
      url
    }
    topics(domainId: $domainId) {
      title
      image {
        path
        fullPath
        alt
      }
      url {
        url
      }
      urls {
        url
        language
      }
    }
    imageId
    score
    name
    subTitle
    overview
    metatags {
      key
      value
    }
    translations {
      key
      value
      language
    }
    body
    faqs(languageEq: $language, isDeleted: false) {
      id
      question
      answer
    }
    workingHours {
      id
      isActive
      timeZone
      schedule
    }
    attributes(isDeleted: false) {
      value
      id
      translations {
        key
        value
        language
      }
      baseAttribute {
        weight
        comparison
        name
        hidden
        group
        groupSlug
        forceComparisonsDisplay
        type
        categoryId
        attributesGroup {
          id
          slug
          order
          name
          isActive
        }
        translations {
          key
          value
          language
        }
      }
    }
    mainImage {
      path
      fullPath
      caption
      alt
    }
    userId
    slug
    defaultAffiliateLinkId
    features(languageEq: $language) {
      id
      type
      description
      translations {
        key
        value
        language
      }
    }
    pros(languageEq: $language) {
      id
      type
      description
      translations {
        key
        value
        language
      }
    }
    cons(languageEq: $language) {
      id
      type
      description
      translations {
        key
        value
        language
      }
    }
    logo {
      path
      fullPath
      alt
    }
    image {
      path
      fullPath
      alt
    }
    writerUser {
      nickname
      nicknameSlug
      bio
      position
    }
    editorUser {
      nickname
      nicknameSlug
    }
  }
}
    `;
export const useOfferByIdQuery = <
      TData = GQLOfferByIdQuery,
      TError = unknown
    >(
      variables: GQLOfferByIdQueryVariables,
      options?: UseQueryOptions<GQLOfferByIdQuery, TError, TData>
    ) =>
    useQuery<GQLOfferByIdQuery, TError, TData>(
      ['offerById', variables],
      fetchData<GQLOfferByIdQuery, GQLOfferByIdQueryVariables>(OfferByIdDocument, variables),
      options
    );
export const OfferBySlugDocument = `
    query offerBySlug($slug: String, $language: String!) {
  offer(slug: $slug, isDeleted: false, isActive: true, bodyIsNull: false) {
    id
    title
    featuresListTitle
    defaultAffiliateLink {
      link
    }
    description
    displayUrl
    logoId
    imageId
    score
    name
    subTitle
    overview
    metatags {
      key
      value
    }
    translations {
      key
      value
      language
    }
    body
    faqs(languageEq: $language, isDeleted: false) {
      id
      question
      answer
    }
    workingHours {
      id
      isActive
      timeZone
      schedule
    }
    attributes(isDeleted: false) {
      value
      translations {
        key
        value
        language
      }
      baseAttribute {
        comparison
        name
        hidden
        forceComparisonsDisplay
        translations {
          key
          value
          language
        }
      }
    }
    mainImage {
      path
      fullPath
    }
    userId
    slug
    defaultAffiliateLinkId
    features(languageEq: $language) {
      id
      type
      description
      translations {
        key
        value
        language
      }
    }
    pros(languageEq: $language) {
      id
      type
      description
      translations {
        key
        value
        language
      }
    }
    cons(languageEq: $language) {
      id
      type
      description
      translations {
        key
        value
        language
      }
    }
    logo {
      path
      fullPath
    }
    image {
      path
      fullPath
    }
  }
}
    `;
export const useOfferBySlugQuery = <
      TData = GQLOfferBySlugQuery,
      TError = unknown
    >(
      variables: GQLOfferBySlugQueryVariables,
      options?: UseQueryOptions<GQLOfferBySlugQuery, TError, TData>
    ) =>
    useQuery<GQLOfferBySlugQuery, TError, TData>(
      ['offerBySlug', variables],
      fetchData<GQLOfferBySlugQuery, GQLOfferBySlugQueryVariables>(OfferBySlugDocument, variables),
      options
    );
export const GetOverviewDomainOffersDocument = `
    query getOverviewDomainOffers($categoryId: Int, $language: String!, $domainId: Int, $slugs: [String!]) {
  allDomainOffers(domainId: $domainId, categoryId: $categoryId) {
    offers(orderByDesc: weight, isDeleted: false, isActive: true, slugIn: $slugs) {
      id
      languages
      categories {
        id
        name
        title
      }
      quickOverview
      name
      weight
      slug
      slugAlias
      url(isActive: true, isDeleted: false, languageEq: $language) {
        isMain
        main {
          url
        }
        url
      }
      defaultAffiliateLink {
        link
      }
      translations {
        key
        value
        language
      }
      attributes(isDeleted: false) {
        value
        id
        translations {
          key
          value
          language
        }
        baseAttribute(categoryId: $categoryId) {
          weight
          comparison
          name
          groupSlug
          forceComparisonsDisplay
          type
          attributesGroup {
            id
          }
          translations {
            key
            value
            language
          }
        }
      }
      features(languageEq: $language) {
        description
        translations {
          key
          value
          language
        }
      }
      pros(languageEq: $language) {
        description
        translations {
          key
          value
          language
        }
      }
      cons(languageEq: $language) {
        description
        translations {
          key
          value
          language
        }
      }
      logo {
        fullPath
      }
    }
  }
}
    `;
export const useGetOverviewDomainOffersQuery = <
      TData = GQLGetOverviewDomainOffersQuery,
      TError = unknown
    >(
      variables: GQLGetOverviewDomainOffersQueryVariables,
      options?: UseQueryOptions<GQLGetOverviewDomainOffersQuery, TError, TData>
    ) =>
    useQuery<GQLGetOverviewDomainOffersQuery, TError, TData>(
      ['getOverviewDomainOffers', variables],
      fetchData<GQLGetOverviewDomainOffersQuery, GQLGetOverviewDomainOffersQueryVariables>(GetOverviewDomainOffersDocument, variables),
      options
    );
export const CategoriesGetAllCategoriesQueryDocument = `
    query categoriesGetAllCategoriesQuery($domainId: Int) {
  domain(id: $domainId) {
    categories(limit: 100, orderBy: createdAt, isPublished: true, isDeleted: false) {
      id
      parentId
      title
      name
      slug
      label
      url(isActive: true, isDeleted: false) {
        isMain
        main {
          url
        }
        url
      }
      translations {
        key
        value
        language
      }
      categoryChilds {
        id
        slug
        parentId
        title
        name
        url {
          isMain
          url
          main {
            url
          }
        }
      }
    }
  }
}
    `;
export const useCategoriesGetAllCategoriesQueryQuery = <
      TData = GQLCategoriesGetAllCategoriesQueryQuery,
      TError = unknown
    >(
      variables?: GQLCategoriesGetAllCategoriesQueryQueryVariables,
      options?: UseQueryOptions<GQLCategoriesGetAllCategoriesQueryQuery, TError, TData>
    ) =>
    useQuery<GQLCategoriesGetAllCategoriesQueryQuery, TError, TData>(
      variables === undefined ? ['categoriesGetAllCategoriesQuery'] : ['categoriesGetAllCategoriesQuery', variables],
      fetchData<GQLCategoriesGetAllCategoriesQueryQuery, GQLCategoriesGetAllCategoriesQueryQueryVariables>(CategoriesGetAllCategoriesQueryDocument, variables),
      options
    );
export const ArticlesGetCategoryByIdDocument = `
    query articlesGetCategoryById($id: Int, $language: String!) {
  category(id: $id, isDeleted: false) {
    id
    name
    label
    slug
    languages
    isOneToOneConsent
    url(isActive: true, isDeleted: false, languageEq: $language) {
      isMain
      main {
        url
      }
      url
    }
    metatags {
      key
      value
    }
    translations {
      key
      value
      language
    }
  }
}
    `;
export const useArticlesGetCategoryByIdQuery = <
      TData = GQLArticlesGetCategoryByIdQuery,
      TError = unknown
    >(
      variables: GQLArticlesGetCategoryByIdQueryVariables,
      options?: UseQueryOptions<GQLArticlesGetCategoryByIdQuery, TError, TData>
    ) =>
    useQuery<GQLArticlesGetCategoryByIdQuery, TError, TData>(
      ['articlesGetCategoryById', variables],
      fetchData<GQLArticlesGetCategoryByIdQuery, GQLArticlesGetCategoryByIdQueryVariables>(ArticlesGetCategoryByIdDocument, variables),
      options
    );
export const GetArticlesDomainOffersDocument = `
    query getArticlesDomainOffers($categoryId: Int, $language: String!, $domainId: Int) {
  allDomainOffers(domainId: $domainId, categoryId: $categoryId) {
    placements
    offers(orderByDesc: weight, isDeleted: false, isActive: true) {
      id
      slug
      title
      logo {
        path
        fullPath
      }
      features(languageEq: $language) {
        id
        type
        description
        translations {
          key
          value
          language
        }
      }
      url(isActive: true, isDeleted: false, languageEq: $language) {
        isMain
        main {
          url
        }
        url
      }
      translations {
        key
        value
        language
      }
    }
  }
}
    `;
export const useGetArticlesDomainOffersQuery = <
      TData = GQLGetArticlesDomainOffersQuery,
      TError = unknown
    >(
      variables: GQLGetArticlesDomainOffersQueryVariables,
      options?: UseQueryOptions<GQLGetArticlesDomainOffersQuery, TError, TData>
    ) =>
    useQuery<GQLGetArticlesDomainOffersQuery, TError, TData>(
      ['getArticlesDomainOffers', variables],
      fetchData<GQLGetArticlesDomainOffersQuery, GQLGetArticlesDomainOffersQueryVariables>(GetArticlesDomainOffersDocument, variables),
      options
    );
export const TotalArticlesDocument = `
    query totalArticles($id: Int, $published: Boolean, $domainId: Int, $typeId: Int) {
  category(id: $id) {
    posts(
      published: $published
      orderByDesc: createdAt
      domainId: $domainId
      isDeleted: false
      typeId: $typeId
    ) {
      id
      translations {
        key
        value
        language
      }
    }
  }
}
    `;
export const useTotalArticlesQuery = <
      TData = GQLTotalArticlesQuery,
      TError = unknown
    >(
      variables?: GQLTotalArticlesQueryVariables,
      options?: UseQueryOptions<GQLTotalArticlesQuery, TError, TData>
    ) =>
    useQuery<GQLTotalArticlesQuery, TError, TData>(
      variables === undefined ? ['totalArticles'] : ['totalArticles', variables],
      fetchData<GQLTotalArticlesQuery, GQLTotalArticlesQueryVariables>(TotalArticlesDocument, variables),
      options
    );
export const GetBestOverallDomainOffersDocument = `
    query getBestOverallDomainOffers($categoryId: Int, $language: String!, $domainId: Int) {
  allDomainOffers(
    domainId: $domainId
    categoryId: $categoryId
    orderByDesc: weight
  ) {
    placements
    offers(isDeleted: false, isActive: true) {
      id
      languages
      title
      featuresListTitle
      description
      name
      slug
      url(isActive: true, isDeleted: false, languageEq: $language) {
        isMain
        main {
          url
        }
        url
      }
      translations {
        key
        value
        language
      }
      attributes(isDeleted: false) {
        value
        id
        translations {
          key
          value
          language
        }
        baseAttribute {
          weight
          comparison
          name
          hidden
          group
          categoryId
          groupSlug
          forceComparisonsDisplay
          attributesGroup {
            id
            slug
            order
            name
            isActive
          }
          translations {
            key
            value
            language
          }
        }
      }
      features(languageEq: $language) {
        id
        type
        description
        translations {
          key
          value
          language
        }
      }
      logo {
        path
        fullPath
      }
    }
  }
}
    `;
export const useGetBestOverallDomainOffersQuery = <
      TData = GQLGetBestOverallDomainOffersQuery,
      TError = unknown
    >(
      variables: GQLGetBestOverallDomainOffersQueryVariables,
      options?: UseQueryOptions<GQLGetBestOverallDomainOffersQuery, TError, TData>
    ) =>
    useQuery<GQLGetBestOverallDomainOffersQuery, TError, TData>(
      ['getBestOverallDomainOffers', variables],
      fetchData<GQLGetBestOverallDomainOffersQuery, GQLGetBestOverallDomainOffersQueryVariables>(GetBestOverallDomainOffersDocument, variables),
      options
    );
export const BestOverallGetCategoryByIdDocument = `
    query bestOverallGetCategoryById($id: Int, $language: String!) {
  category(id: $id, isDeleted: false) {
    id
    name
    label
    slug
    languages
    TCPAMessage
    isOneToOneConsent
    textBlocks(isActive: true) {
      position
      text
    }
    url(isActive: true, isDeleted: false, languageEq: $language) {
      isMain
      main {
        url
      }
      url
    }
    metatags {
      key
      value
    }
    translations {
      key
      value
      language
    }
    mainImage {
      path
      fullPath
    }
  }
}
    `;
export const useBestOverallGetCategoryByIdQuery = <
      TData = GQLBestOverallGetCategoryByIdQuery,
      TError = unknown
    >(
      variables: GQLBestOverallGetCategoryByIdQueryVariables,
      options?: UseQueryOptions<GQLBestOverallGetCategoryByIdQuery, TError, TData>
    ) =>
    useQuery<GQLBestOverallGetCategoryByIdQuery, TError, TData>(
      ['bestOverallGetCategoryById', variables],
      fetchData<GQLBestOverallGetCategoryByIdQuery, GQLBestOverallGetCategoryByIdQueryVariables>(BestOverallGetCategoryByIdDocument, variables),
      options
    );
export const CategoryOffersQueryDocument = `
    query categoryOffersQuery($categoryId: Int, $domainId: Int) {
  allDomainOffers(domainId: $domainId, categoryId: $categoryId) {
    offers(orderByDesc: weight, isDeleted: false, isActive: true) {
      slug
      translations {
        key
        value
        language
      }
      logo {
        fullPath
      }
    }
  }
}
    `;
export const useCategoryOffersQueryQuery = <
      TData = GQLCategoryOffersQueryQuery,
      TError = unknown
    >(
      variables?: GQLCategoryOffersQueryQueryVariables,
      options?: UseQueryOptions<GQLCategoryOffersQueryQuery, TError, TData>
    ) =>
    useQuery<GQLCategoryOffersQueryQuery, TError, TData>(
      variables === undefined ? ['categoryOffersQuery'] : ['categoryOffersQuery', variables],
      fetchData<GQLCategoryOffersQueryQuery, GQLCategoryOffersQueryQueryVariables>(CategoryOffersQueryDocument, variables),
      options
    );
export const CompareGetCategoryByIdDocument = `
    query compareGetCategoryById($id: Int, $language: String!) {
  category(id: $id, isDeleted: false) {
    id
    name
    label
    slug
    languages
    TCPAMessage
    textBlocks(isActive: true) {
      position
      text
    }
    translations {
      key
      value
      language
    }
    mainImage {
      path
      fullPath
    }
    url(isActive: true, isDeleted: false, languageEq: $language) {
      isMain
      main {
        url
      }
      url
    }
    metatags {
      key
      value
    }
    attributes(isDeleted: false, groupIsNull: false) {
      attributesGroup(isActive: true) {
        name
        slug
        order
        isActive
        id
      }
      translations {
        key
        value
        language
      }
    }
  }
}
    `;
export const useCompareGetCategoryByIdQuery = <
      TData = GQLCompareGetCategoryByIdQuery,
      TError = unknown
    >(
      variables: GQLCompareGetCategoryByIdQueryVariables,
      options?: UseQueryOptions<GQLCompareGetCategoryByIdQuery, TError, TData>
    ) =>
    useQuery<GQLCompareGetCategoryByIdQuery, TError, TData>(
      ['compareGetCategoryById', variables],
      fetchData<GQLCompareGetCategoryByIdQuery, GQLCompareGetCategoryByIdQueryVariables>(CompareGetCategoryByIdDocument, variables),
      options
    );
export const GetCompareDomainOffersDocument = `
    query getCompareDomainOffers($categoryId: Int, $language: String!, $domainId: Int) {
  allDomainOffers(
    domainId: $domainId
    categoryId: $categoryId
    orderByDesc: weight
  ) {
    placements
    offers(isDeleted: false, isActive: true) {
      id
      slug
      title
      features(languageEq: $language) {
        id
        type
        description
        translations {
          key
          value
          language
        }
      }
      url(isActive: true, isDeleted: false, languageEq: $language) {
        isMain
        main {
          url
        }
        url
      }
      translations {
        key
        value
        language
      }
      logo {
        id
        path
        fullPath
      }
    }
  }
}
    `;
export const useGetCompareDomainOffersQuery = <
      TData = GQLGetCompareDomainOffersQuery,
      TError = unknown
    >(
      variables: GQLGetCompareDomainOffersQueryVariables,
      options?: UseQueryOptions<GQLGetCompareDomainOffersQuery, TError, TData>
    ) =>
    useQuery<GQLGetCompareDomainOffersQuery, TError, TData>(
      ['getCompareDomainOffers', variables],
      fetchData<GQLGetCompareDomainOffersQuery, GQLGetCompareDomainOffersQueryVariables>(GetCompareDomainOffersDocument, variables),
      options
    );
export const OverviewGetCategoryByIdDocument = `
    query overviewGetCategoryById($id: Int, $language: String!) {
  category(id: $id, isDeleted: false) {
    id
    name
    label
    isOneToOneConsent
    title
    overview
    subtitle
    description
    languages
    TCPAMessage
    slug
    isOneToOneConsent
    faqs(languageEq: $language, isDeleted: false) {
      id
      question
      answer
    }
    topics(isDeleted: false) {
      id
      url {
        main {
          url
        }
        isMain
        url
      }
      title
    }
    url(isActive: true, isDeleted: false, languageEq: $language) {
      isMain
      main {
        url
      }
      url
    }
    metatags {
      key
      value
    }
    translations {
      key
      value
      language
    }
    mainImage {
      path
      fullPath
    }
  }
}
    `;
export const useOverviewGetCategoryByIdQuery = <
      TData = GQLOverviewGetCategoryByIdQuery,
      TError = unknown
    >(
      variables: GQLOverviewGetCategoryByIdQueryVariables,
      options?: UseQueryOptions<GQLOverviewGetCategoryByIdQuery, TError, TData>
    ) =>
    useQuery<GQLOverviewGetCategoryByIdQuery, TError, TData>(
      ['overviewGetCategoryById', variables],
      fetchData<GQLOverviewGetCategoryByIdQuery, GQLOverviewGetCategoryByIdQueryVariables>(OverviewGetCategoryByIdDocument, variables),
      options
    );
export const GetOffersByCategoryIdDocument = `
    query getOffersByCategoryId($categoryId: Int, $domainId: Int, $language: String!) {
  allDomainOffers(
    categoryId: $categoryId
    domainId: $domainId
    orderByDesc: weight
  ) {
    placements
    weight
    offers(isDeleted: false, isActive: true, bodyIsNull: false) {
      title
      mainImage {
        fullPath
      }
      logo {
        fullPath
      }
      subTitle
      summaryDescription
      summaryTitle
      name
      slug
      url(isActive: true, isDeleted: false, languageEq: $language) {
        isMain
        main {
          url
        }
        url
      }
      defaultAffiliateLink {
        link
      }
      translations {
        key
        value
        language
      }
      features(languageEq: $language) {
        id
        type
        description
        translations {
          key
          value
          language
        }
      }
      attributes(isDeleted: false) {
        value
        id
        translations {
          key
          value
          language
        }
        baseAttribute(hidden: false, forceComparisonsDisplay: false, comparison: false) {
          weight
          comparison
          name
          hidden
          group
          groupSlug
          forceComparisonsDisplay
          translations {
            key
            value
            language
          }
        }
      }
      pros(languageEq: $language) {
        description
        translations {
          key
          value
          language
        }
      }
      cons(languageEq: $language) {
        description
        translations {
          key
          value
          language
        }
      }
    }
  }
}
    `;
export const useGetOffersByCategoryIdQuery = <
      TData = GQLGetOffersByCategoryIdQuery,
      TError = unknown
    >(
      variables: GQLGetOffersByCategoryIdQueryVariables,
      options?: UseQueryOptions<GQLGetOffersByCategoryIdQuery, TError, TData>
    ) =>
    useQuery<GQLGetOffersByCategoryIdQuery, TError, TData>(
      ['getOffersByCategoryId', variables],
      fetchData<GQLGetOffersByCategoryIdQuery, GQLGetOffersByCategoryIdQueryVariables>(GetOffersByCategoryIdDocument, variables),
      options
    );
export const OverviewGetTextBlocksByPositionDocument = `
    query overviewGetTextBlocksByPosition($id: Int, $domainId: Int, $positions: [String]) {
  allCustomTextBlocksPositions(
    isActive: true
    positionIn: $positions
    isDeleted: false
  ) {
    textBlocks(
      categoryId: $id
      isDeleted: false
      isActive: true
      domainId: $domainId
    ) {
      position
      text
    }
  }
}
    `;
export const useOverviewGetTextBlocksByPositionQuery = <
      TData = GQLOverviewGetTextBlocksByPositionQuery,
      TError = unknown
    >(
      variables?: GQLOverviewGetTextBlocksByPositionQueryVariables,
      options?: UseQueryOptions<GQLOverviewGetTextBlocksByPositionQuery, TError, TData>
    ) =>
    useQuery<GQLOverviewGetTextBlocksByPositionQuery, TError, TData>(
      variables === undefined ? ['overviewGetTextBlocksByPosition'] : ['overviewGetTextBlocksByPosition', variables],
      fetchData<GQLOverviewGetTextBlocksByPositionQuery, GQLOverviewGetTextBlocksByPositionQueryVariables>(OverviewGetTextBlocksByPositionDocument, variables),
      options
    );
export const GetRecentPostsByCategoryDocument = `
    query getRecentPostsByCategory($limit: [Int], $offset: [Int], $domainId: Int, $published: Boolean, $categoryId: Int) {
  allPosts(
    limit: $limit
    offset: $offset
    categoryId: $categoryId
    published: $published
    isDeleted: false
    orderByDesc: createdAt
    domainId: $domainId
  ) {
    title
    translations {
      key
      value
      language
    }
    url {
      url
      isMain
      main {
        url
      }
    }
  }
}
    `;
export const useGetRecentPostsByCategoryQuery = <
      TData = GQLGetRecentPostsByCategoryQuery,
      TError = unknown
    >(
      variables?: GQLGetRecentPostsByCategoryQueryVariables,
      options?: UseQueryOptions<GQLGetRecentPostsByCategoryQuery, TError, TData>
    ) =>
    useQuery<GQLGetRecentPostsByCategoryQuery, TError, TData>(
      variables === undefined ? ['getRecentPostsByCategory'] : ['getRecentPostsByCategory', variables],
      fetchData<GQLGetRecentPostsByCategoryQuery, GQLGetRecentPostsByCategoryQueryVariables>(GetRecentPostsByCategoryDocument, variables),
      options
    );
export const GetTop3BuyersDocument = `
    query getTop3Buyers($categoryId: Int, $language: String!, $domainId: Int) {
  allDomainOffers(
    domainId: $domainId
    categoryId: $categoryId
    orderByDesc: weight
    limit: 3
  ) {
    offers(isDeleted: false, isActive: true) {
      name
      weight
      slug
      url(isActive: true, isDeleted: false, languageEq: $language) {
        isMain
        main {
          url
        }
        url
      }
      defaultAffiliateLink {
        link
      }
      translations {
        key
        value
        language
      }
      logo {
        fullPath
      }
    }
  }
}
    `;
export const useGetTop3BuyersQuery = <
      TData = GQLGetTop3BuyersQuery,
      TError = unknown
    >(
      variables: GQLGetTop3BuyersQueryVariables,
      options?: UseQueryOptions<GQLGetTop3BuyersQuery, TError, TData>
    ) =>
    useQuery<GQLGetTop3BuyersQuery, TError, TData>(
      ['getTop3Buyers', variables],
      fetchData<GQLGetTop3BuyersQuery, GQLGetTop3BuyersQueryVariables>(GetTop3BuyersDocument, variables),
      options
    );
export const AllNewsDocument = `
    query allNews($limit: [Int], $offset: [Int], $domainId: Int, $typeId: Int) {
  allPosts(
    limit: $limit
    offset: $offset
    typeId: $typeId
    published: true
    isDeleted: false
    domainId: $domainId
    orderByDesc: createdAt
  ) {
    id
    title
    translations {
      key
      value
      language
    }
    image {
      fullPath
    }
    tags {
      name
    }
    url {
      id
      title
      language
      isActive
      url
      isMain
      main {
        url
      }
    }
  }
}
    `;
export const useAllNewsQuery = <
      TData = GQLAllNewsQuery,
      TError = unknown
    >(
      variables?: GQLAllNewsQueryVariables,
      options?: UseQueryOptions<GQLAllNewsQuery, TError, TData>
    ) =>
    useQuery<GQLAllNewsQuery, TError, TData>(
      variables === undefined ? ['allNews'] : ['allNews', variables],
      fetchData<GQLAllNewsQuery, GQLAllNewsQueryVariables>(AllNewsDocument, variables),
      options
    );
export const FeaturedNewsQueryDocument = `
    query featuredNewsQuery($domainId: Int) {
  allPosts(
    limit: 6
    offset: 0
    published: true
    isDeleted: false
    typeId: 2296
    orderByDesc: createdAt
    domainId: $domainId
  ) {
    id
    domainId
    title
    excerpt
    body
    translations {
      key
      value
      language
    }
    image {
      fullPath
      path
    }
    tags {
      name
    }
    url {
      id
      modelId
      title
      language
      isActive
      url
      isMain
      main {
        url
      }
    }
    category {
      title
      name
    }
    createdAt
  }
}
    `;
export const useFeaturedNewsQueryQuery = <
      TData = GQLFeaturedNewsQueryQuery,
      TError = unknown
    >(
      variables?: GQLFeaturedNewsQueryQueryVariables,
      options?: UseQueryOptions<GQLFeaturedNewsQueryQuery, TError, TData>
    ) =>
    useQuery<GQLFeaturedNewsQueryQuery, TError, TData>(
      variables === undefined ? ['featuredNewsQuery'] : ['featuredNewsQuery', variables],
      fetchData<GQLFeaturedNewsQueryQuery, GQLFeaturedNewsQueryQueryVariables>(FeaturedNewsQueryDocument, variables),
      options
    );
export const MissedNewsDocument = `
    query missedNews($domainId: Int) {
  allPosts(
    limit: 6
    offset: 54
    published: true
    isDeleted: false
    typeId: 2296
    orderByDesc: createdAt
    domainId: $domainId
  ) {
    title
    image {
      fullPath
      path
    }
    url {
      isActive
      url
      isMain
      main {
        url
      }
    }
    tags {
      name
    }
  }
}
    `;
export const useMissedNewsQuery = <
      TData = GQLMissedNewsQuery,
      TError = unknown
    >(
      variables?: GQLMissedNewsQueryVariables,
      options?: UseQueryOptions<GQLMissedNewsQuery, TError, TData>
    ) =>
    useQuery<GQLMissedNewsQuery, TError, TData>(
      variables === undefined ? ['missedNews'] : ['missedNews', variables],
      fetchData<GQLMissedNewsQuery, GQLMissedNewsQueryVariables>(MissedNewsDocument, variables),
      options
    );
export const NewsByTagsQueryDocument = `
    query newsByTagsQuery($domainId: Int) {
  allPosts(
    limit: 200
    offset: 6
    published: true
    isDeleted: false
    typeId: 2296
    orderByDesc: createdAt
    domainId: $domainId
  ) {
    title
    createdAt
    image {
      fullPath
      path
    }
    url {
      isActive
      url
      isMain
      main {
        url
      }
    }
    tags {
      name
    }
  }
}
    `;
export const useNewsByTagsQueryQuery = <
      TData = GQLNewsByTagsQueryQuery,
      TError = unknown
    >(
      variables?: GQLNewsByTagsQueryQueryVariables,
      options?: UseQueryOptions<GQLNewsByTagsQueryQuery, TError, TData>
    ) =>
    useQuery<GQLNewsByTagsQueryQuery, TError, TData>(
      variables === undefined ? ['newsByTagsQuery'] : ['newsByTagsQuery', variables],
      fetchData<GQLNewsByTagsQueryQuery, GQLNewsByTagsQueryQueryVariables>(NewsByTagsQueryDocument, variables),
      options
    );
export const TagsOptionsDocument = `
    query tagsOptions($domainId: Int, $type: String, $typeId: Int) {
  allTags(isDeleted: false, type: $type) {
    id
    name
    slug
    posts(
      typeId: $typeId
      published: true
      isDeleted: false
      domainId: $domainId
      orderByDesc: createdAt
    ) {
      id
      translations {
        key
        value
        language
      }
    }
  }
}
    `;
export const useTagsOptionsQuery = <
      TData = GQLTagsOptionsQuery,
      TError = unknown
    >(
      variables?: GQLTagsOptionsQueryVariables,
      options?: UseQueryOptions<GQLTagsOptionsQuery, TError, TData>
    ) =>
    useQuery<GQLTagsOptionsQuery, TError, TData>(
      variables === undefined ? ['tagsOptions'] : ['tagsOptions', variables],
      fetchData<GQLTagsOptionsQuery, GQLTagsOptionsQueryVariables>(TagsOptionsDocument, variables),
      options
    );
export const TotalAllNewsDocument = `
    query totalAllNews($domainId: Int, $typeId: Int) {
  allPosts(
    typeId: $typeId
    published: true
    isDeleted: false
    domainId: $domainId
    orderByDesc: createdAt
  ) {
    translations {
      key
      value
      language
    }
  }
}
    `;
export const useTotalAllNewsQuery = <
      TData = GQLTotalAllNewsQuery,
      TError = unknown
    >(
      variables?: GQLTotalAllNewsQueryVariables,
      options?: UseQueryOptions<GQLTotalAllNewsQuery, TError, TData>
    ) =>
    useQuery<GQLTotalAllNewsQuery, TError, TData>(
      variables === undefined ? ['totalAllNews'] : ['totalAllNews', variables],
      fetchData<GQLTotalAllNewsQuery, GQLTotalAllNewsQueryVariables>(TotalAllNewsDocument, variables),
      options
    );
export const TotalNewsByTagsDocument = `
    query totalNewsByTags($slug: String, $domainId: Int) {
  tag(slug: $slug, isDeleted: false, type: "post") {
    id
    name
    posts(
      typeId: 2296
      published: true
      isDeleted: false
      domainId: $domainId
      orderByDesc: id
    ) {
      id
      translations {
        key
        value
        language
      }
    }
  }
}
    `;
export const useTotalNewsByTagsQuery = <
      TData = GQLTotalNewsByTagsQuery,
      TError = unknown
    >(
      variables?: GQLTotalNewsByTagsQueryVariables,
      options?: UseQueryOptions<GQLTotalNewsByTagsQuery, TError, TData>
    ) =>
    useQuery<GQLTotalNewsByTagsQuery, TError, TData>(
      variables === undefined ? ['totalNewsByTags'] : ['totalNewsByTags', variables],
      fetchData<GQLTotalNewsByTagsQuery, GQLTotalNewsByTagsQueryVariables>(TotalNewsByTagsDocument, variables),
      options
    );
export const TrendingNewsDocument = `
    query trendingNews($domainId: Int) {
  allPosts(
    limit: 6
    offset: 46
    published: true
    isDeleted: false
    typeId: 2296
    featured: true
    orderByDesc: createdAt
    domainId: $domainId
  ) {
    title
    image {
      fullPath
      path
    }
    url {
      isActive
      url
      isMain
      main {
        url
      }
    }
    tags {
      name
    }
  }
}
    `;
export const useTrendingNewsQuery = <
      TData = GQLTrendingNewsQuery,
      TError = unknown
    >(
      variables?: GQLTrendingNewsQueryVariables,
      options?: UseQueryOptions<GQLTrendingNewsQuery, TError, TData>
    ) =>
    useQuery<GQLTrendingNewsQuery, TError, TData>(
      variables === undefined ? ['trendingNews'] : ['trendingNews', variables],
      fetchData<GQLTrendingNewsQuery, GQLTrendingNewsQueryVariables>(TrendingNewsDocument, variables),
      options
    );
export const PostGetCategoryByIdDocument = `
    query postGetCategoryById($id: Int, $language: String!, $limit: [Int], $offset: [Int], $domainId: Int, $published: Boolean) {
  category(id: $id, isDeleted: false) {
    id
    name
    label
    slug
    TCPAMessage
    isOneToOneConsent
    translations {
      key
      value
      language
    }
    posts(
      limit: $limit
      offset: $offset
      categoryId: $id
      published: $published
      isDeleted: false
      orderByDesc: createdAt
      domainId: $domainId
    ) {
      title
      url {
        isMain
        main {
          url
        }
        url
      }
    }
    url(isActive: true, isDeleted: false, languageEq: $language) {
      isMain
      main {
        url
      }
      url
    }
  }
}
    `;
export const usePostGetCategoryByIdQuery = <
      TData = GQLPostGetCategoryByIdQuery,
      TError = unknown
    >(
      variables: GQLPostGetCategoryByIdQueryVariables,
      options?: UseQueryOptions<GQLPostGetCategoryByIdQuery, TError, TData>
    ) =>
    useQuery<GQLPostGetCategoryByIdQuery, TError, TData>(
      ['postGetCategoryById', variables],
      fetchData<GQLPostGetCategoryByIdQuery, GQLPostGetCategoryByIdQueryVariables>(PostGetCategoryByIdDocument, variables),
      options
    );
export const GetPostByIdDocument = `
    query getPostById($id: Int, $domainId: Int) {
  post(id: $id, published: true, domainId: $domainId) {
    excerpt
    title
    body
    categoryId
    createdAt
    updatedAt
    publishedAt
    related {
      title
      url {
        isMain
        main {
          url
        }
        url
      }
    }
    translations {
      key
      value
      language
    }
    image {
      fullPath
      caption
      alt
    }
    tags {
      id
      name
      slug
      isPublished
    }
    urls {
      isMain
      language
      main {
        url
      }
      url
    }
    url {
      isMain
      language
      main {
        url
      }
      url
    }
    metatags {
      key
      value
    }
    writerUser {
      nickname
      nicknameSlug
      bio
      position
    }
    editorUser {
      nickname
      nicknameSlug
    }
  }
}
    `;
export const useGetPostByIdQuery = <
      TData = GQLGetPostByIdQuery,
      TError = unknown
    >(
      variables?: GQLGetPostByIdQueryVariables,
      options?: UseQueryOptions<GQLGetPostByIdQuery, TError, TData>
    ) =>
    useQuery<GQLGetPostByIdQuery, TError, TData>(
      variables === undefined ? ['getPostById'] : ['getPostById', variables],
      fetchData<GQLGetPostByIdQuery, GQLGetPostByIdQueryVariables>(GetPostByIdDocument, variables),
      options
    );
export const GetFormFusionThankYouOffersDocument = `
    query getFormFusionThankYouOffers($categoryId: Int, $language: String!, $domainId: Int) {
  allDomainOffers(
    domainId: $domainId
    categoryId: $categoryId
    orderByDesc: weight
  ) {
    placements
    offers(isDeleted: false, isActive: true) {
      title
      id
      name
      slug
      attributes(isDeleted: false) {
        value
        id
        hiddenAttributes {
          value
          name
        }
        baseAttribute {
          name
          value
          hidden
          type
        }
      }
      url(isActive: true, isDeleted: false, languageEq: $language) {
        isMain
        main {
          url
        }
        url
      }
      logo {
        path
        fullPath
      }
      workingHours {
        id
        isActive
        timeZone
        schedule
      }
    }
  }
}
    `;
export const useGetFormFusionThankYouOffersQuery = <
      TData = GQLGetFormFusionThankYouOffersQuery,
      TError = unknown
    >(
      variables: GQLGetFormFusionThankYouOffersQueryVariables,
      options?: UseQueryOptions<GQLGetFormFusionThankYouOffersQuery, TError, TData>
    ) =>
    useQuery<GQLGetFormFusionThankYouOffersQuery, TError, TData>(
      ['getFormFusionThankYouOffers', variables],
      fetchData<GQLGetFormFusionThankYouOffersQuery, GQLGetFormFusionThankYouOffersQueryVariables>(GetFormFusionThankYouOffersDocument, variables),
      options
    );
export const GetAllUrlsDocument = `
    query getAllUrls($model: String, $modelId: String) {
  allUrls(model: $model, modelId: $modelId, isDeleted: false, isActive: true) {
    model
    modelId
    isMain
    language
    title
    url
    main {
      url
      redirectionStatusCode
    }
  }
}
    `;
export const useGetAllUrlsQuery = <
      TData = GQLGetAllUrlsQuery,
      TError = unknown
    >(
      variables?: GQLGetAllUrlsQueryVariables,
      options?: UseQueryOptions<GQLGetAllUrlsQuery, TError, TData>
    ) =>
    useQuery<GQLGetAllUrlsQuery, TError, TData>(
      variables === undefined ? ['getAllUrls'] : ['getAllUrls', variables],
      fetchData<GQLGetAllUrlsQuery, GQLGetAllUrlsQueryVariables>(GetAllUrlsDocument, variables),
      options
    );
export const GetDomainInfoDocument = `
    query getDomainInfo($language: String!) {
  domain(name: "several.com", isDeleted: false, isActive: true) {
    id
    name
    title
    description
    gtmId
    type
    isActive
    userId
    niceName
    isInspectorEnabled
    enableJornayaId
    enableTrustedForm
    clickyCodeId
    twitterPixel
    allTranslations(language: $language) {
      key
      value
    }
    translations {
      key
      value
      language
    }
    metatags {
      key
      value
    }
    menus {
      id
      name
      slug
      links(orderBy: order) {
        id
        title
        link
        parentId
        translations {
          key
          value
          language
        }
      }
    }
  }
}
    `;
export const useGetDomainInfoQuery = <
      TData = GQLGetDomainInfoQuery,
      TError = unknown
    >(
      variables: GQLGetDomainInfoQueryVariables,
      options?: UseQueryOptions<GQLGetDomainInfoQuery, TError, TData>
    ) =>
    useQuery<GQLGetDomainInfoQuery, TError, TData>(
      ['getDomainInfo', variables],
      fetchData<GQLGetDomainInfoQuery, GQLGetDomainInfoQueryVariables>(GetDomainInfoDocument, variables),
      options
    );
export const GetExitModalOffersDocument = `
    query getExitModalOffers($categoryId: Int, $language: String!, $domainId: Int) {
  allDomainOffers(
    domainId: $domainId
    categoryId: $categoryId
    orderByDesc: weight
  ) {
    placements
    offers(isDeleted: false, isActive: true) {
      title
      slug
      url(isActive: true, isDeleted: false, languageEq: $language) {
        isMain
        main {
          url
        }
        url
      }
      translations {
        key
        value
        language
      }
      logo {
        path
        fullPath
      }
      features(languageEq: $language) {
        id
        type
        description
        translations {
          key
          value
          language
        }
      }
    }
  }
}
    `;
export const useGetExitModalOffersQuery = <
      TData = GQLGetExitModalOffersQuery,
      TError = unknown
    >(
      variables: GQLGetExitModalOffersQueryVariables,
      options?: UseQueryOptions<GQLGetExitModalOffersQuery, TError, TData>
    ) =>
    useQuery<GQLGetExitModalOffersQuery, TError, TData>(
      ['getExitModalOffers', variables],
      fetchData<GQLGetExitModalOffersQuery, GQLGetExitModalOffersQueryVariables>(GetExitModalOffersDocument, variables),
      options
    );
export const DomainDocument = `
    query domain($language: String) {
  allTranslations(language: $language) {
    key
    value
  }
}
    `;
export const useDomainQuery = <
      TData = GQLDomainQuery,
      TError = unknown
    >(
      variables?: GQLDomainQueryVariables,
      options?: UseQueryOptions<GQLDomainQuery, TError, TData>
    ) =>
    useQuery<GQLDomainQuery, TError, TData>(
      variables === undefined ? ['domain'] : ['domain', variables],
      fetchData<GQLDomainQuery, GQLDomainQueryVariables>(DomainDocument, variables),
      options
    );
export const SitemapGetAllDomainCategoriesDocument = `
    query sitemapGetAllDomainCategories($domainId: Int) {
  allDomainCategories(domainId: $domainId) {
    category(isPublished: true, isDeleted: false, parentIdIsNull: false) {
      id
      parentId
      title
      label
      name
      translations {
        key
        value
        language
      }
      url(isActive: true, isDeleted: false) {
        isMain
        main {
          url
        }
        url
      }
    }
  }
}
    `;
export const useSitemapGetAllDomainCategoriesQuery = <
      TData = GQLSitemapGetAllDomainCategoriesQuery,
      TError = unknown
    >(
      variables?: GQLSitemapGetAllDomainCategoriesQueryVariables,
      options?: UseQueryOptions<GQLSitemapGetAllDomainCategoriesQuery, TError, TData>
    ) =>
    useQuery<GQLSitemapGetAllDomainCategoriesQuery, TError, TData>(
      variables === undefined ? ['sitemapGetAllDomainCategories'] : ['sitemapGetAllDomainCategories', variables],
      fetchData<GQLSitemapGetAllDomainCategoriesQuery, GQLSitemapGetAllDomainCategoriesQueryVariables>(SitemapGetAllDomainCategoriesDocument, variables),
      options
    );
export const SitemapGetAllDomainOffersDocument = `
    query sitemapGetAllDomainOffers($domainId: Int) {
  allDomainOffers(domainId: $domainId) {
    offers(isActive: true, isDeleted: false) {
      id
      title
      name
      categories {
        id
      }
      url(isActive: true, isDeleted: false) {
        isMain
        main {
          url
        }
        url
      }
      slug
      translations {
        key
        value
        language
      }
    }
  }
}
    `;
export const useSitemapGetAllDomainOffersQuery = <
      TData = GQLSitemapGetAllDomainOffersQuery,
      TError = unknown
    >(
      variables?: GQLSitemapGetAllDomainOffersQueryVariables,
      options?: UseQueryOptions<GQLSitemapGetAllDomainOffersQuery, TError, TData>
    ) =>
    useQuery<GQLSitemapGetAllDomainOffersQuery, TError, TData>(
      variables === undefined ? ['sitemapGetAllDomainOffers'] : ['sitemapGetAllDomainOffers', variables],
      fetchData<GQLSitemapGetAllDomainOffersQuery, GQLSitemapGetAllDomainOffersQueryVariables>(SitemapGetAllDomainOffersDocument, variables),
      options
    );
export const VendorCompareGetDomainOffersDocument = `
    query vendorCompareGetDomainOffers($offerId: Int, $domainId: Int, $locale: String) {
  domainOffer(domainId: $domainId, offerId: $offerId, isDeleted: false) {
    offers(id: $offerId) {
      name
      title
      id
      slug
      overview
      quickOverview
      languages
      metatags {
        key
        value
      }
      pros(languageEq: $locale) {
        id
        type
        description
        translations {
          key
          value
          language
        }
      }
      cons(languageEq: $locale) {
        id
        type
        description
        translations {
          key
          value
          language
        }
      }
      attributes(isDeleted: false) {
        value
        id
        translations {
          key
          value
          language
        }
        baseAttribute {
          weight
          comparison
          name
          hidden
          group
          groupSlug
          forceComparisonsDisplay
          type
          categoryId
          attributesGroup {
            id
            slug
            order
            name
            isActive
          }
          translations {
            key
            value
            language
          }
        }
      }
      mainImage {
        path
        fullPath
      }
      faqs(languageEq: $locale, isDeleted: false) {
        id
        question
        answer
      }
      features(languageEq: $locale) {
        id
        type
        description
        translations {
          key
          value
          language
        }
      }
      url(isActive: true, isDeleted: false, languageEq: $locale) {
        isMain
        main {
          url
        }
        url
      }
      translations {
        key
        value
        language
      }
      logo {
        id
        path
        fullPath
      }
      categories {
        name
        label
        id
        languages
        TCPAMessage
        attributes(hidden: false, orderByDesc: weight, isDeleted: false) {
          type
          weight
          value
          id
          comparison
          name
          hidden
          group
          groupSlug
          forceComparisonsDisplay
          attributesGroup {
            id
            slug
            order
            name
            isActive
          }
          translations {
            key
            value
            language
          }
        }
        url(isActive: true, isDeleted: false, languageEq: $locale) {
          isMain
          main {
            url
          }
          url
        }
      }
    }
  }
}
    `;
export const useVendorCompareGetDomainOffersQuery = <
      TData = GQLVendorCompareGetDomainOffersQuery,
      TError = unknown
    >(
      variables?: GQLVendorCompareGetDomainOffersQueryVariables,
      options?: UseQueryOptions<GQLVendorCompareGetDomainOffersQuery, TError, TData>
    ) =>
    useQuery<GQLVendorCompareGetDomainOffersQuery, TError, TData>(
      variables === undefined ? ['vendorCompareGetDomainOffers'] : ['vendorCompareGetDomainOffers', variables],
      fetchData<GQLVendorCompareGetDomainOffersQuery, GQLVendorCompareGetDomainOffersQueryVariables>(VendorCompareGetDomainOffersDocument, variables),
      options
    );
export const VendorCompareGetVendorsToCompareDocument = `
    query vendorCompareGetVendorsToCompare($domainId: Int, $categoryId: Int) {
  allDomainOffers(domainId: $domainId, categoryId: $categoryId) {
    offers(orderByDesc: weight, isDeleted: false, isActive: true) {
      slug
      translations {
        key
        value
        language
      }
      logo {
        fullPath
      }
    }
  }
}
    `;
export const useVendorCompareGetVendorsToCompareQuery = <
      TData = GQLVendorCompareGetVendorsToCompareQuery,
      TError = unknown
    >(
      variables?: GQLVendorCompareGetVendorsToCompareQueryVariables,
      options?: UseQueryOptions<GQLVendorCompareGetVendorsToCompareQuery, TError, TData>
    ) =>
    useQuery<GQLVendorCompareGetVendorsToCompareQuery, TError, TData>(
      variables === undefined ? ['vendorCompareGetVendorsToCompare'] : ['vendorCompareGetVendorsToCompare', variables],
      fetchData<GQLVendorCompareGetVendorsToCompareQuery, GQLVendorCompareGetVendorsToCompareQueryVariables>(VendorCompareGetVendorsToCompareDocument, variables),
      options
    );
export const ReviewGetCategoryByIdDocument = `
    query reviewGetCategoryById($id: Int, $language: String!) {
  category(id: $id, isDeleted: false) {
    id
    name
    label
    slug
    languages
    isOneToOneConsent
    translations {
      key
      value
      language
    }
    TCPAMessage
    url(isActive: true, isDeleted: false, languageEq: $language) {
      isMain
      main {
        url
      }
      url
    }
  }
}
    `;
export const useReviewGetCategoryByIdQuery = <
      TData = GQLReviewGetCategoryByIdQuery,
      TError = unknown
    >(
      variables: GQLReviewGetCategoryByIdQueryVariables,
      options?: UseQueryOptions<GQLReviewGetCategoryByIdQuery, TError, TData>
    ) =>
    useQuery<GQLReviewGetCategoryByIdQuery, TError, TData>(
      ['reviewGetCategoryById', variables],
      fetchData<GQLReviewGetCategoryByIdQuery, GQLReviewGetCategoryByIdQueryVariables>(ReviewGetCategoryByIdDocument, variables),
      options
    );
export const GetReviewDomainOffersDocument = `
    query getReviewDomainOffers($categoryId: Int, $domainId: Int) {
  allDomainOffers(domainId: $domainId, categoryId: $categoryId) {
    offers(orderByDesc: weight, isDeleted: false, isActive: true) {
      slug
      translations {
        key
        value
        language
      }
      logo {
        fullPath
      }
    }
  }
}
    `;
export const useGetReviewDomainOffersQuery = <
      TData = GQLGetReviewDomainOffersQuery,
      TError = unknown
    >(
      variables?: GQLGetReviewDomainOffersQueryVariables,
      options?: UseQueryOptions<GQLGetReviewDomainOffersQuery, TError, TData>
    ) =>
    useQuery<GQLGetReviewDomainOffersQuery, TError, TData>(
      variables === undefined ? ['getReviewDomainOffers'] : ['getReviewDomainOffers', variables],
      fetchData<GQLGetReviewDomainOffersQuery, GQLGetReviewDomainOffersQueryVariables>(GetReviewDomainOffersDocument, variables),
      options
    );
export const AllPostsWritersDocument = `
    query allPostsWriters($limit: [Int], $offset: [Int], $domainId: Int, $userId: String) {
  allPosts(
    limit: $limit
    offset: $offset
    published: true
    isDeleted: false
    domainId: $domainId
    writtenBy: $userId
    orderByDesc: updatedAt
  ) {
    id
    title
    type {
      label
    }
    createdAt
    updatedAt
    translations {
      key
      value
      language
    }
    image {
      fullPath
    }
    tags {
      name
    }
    url {
      id
      title
      language
      isActive
      url
      isMain
      main {
        url
      }
    }
  }
}
    `;
export const useAllPostsWritersQuery = <
      TData = GQLAllPostsWritersQuery,
      TError = unknown
    >(
      variables?: GQLAllPostsWritersQueryVariables,
      options?: UseQueryOptions<GQLAllPostsWritersQuery, TError, TData>
    ) =>
    useQuery<GQLAllPostsWritersQuery, TError, TData>(
      variables === undefined ? ['allPostsWriters'] : ['allPostsWriters', variables],
      fetchData<GQLAllPostsWritersQuery, GQLAllPostsWritersQueryVariables>(AllPostsWritersDocument, variables),
      options
    );
export const TotalAllWritersPostsDocument = `
    query totalAllWritersPosts($domainId: Int, $userId: String) {
  allPosts(
    published: true
    isDeleted: false
    domainId: $domainId
    orderByDesc: createdAt
    writtenBy: $userId
  ) {
    translations {
      key
      value
      language
    }
  }
}
    `;
export const useTotalAllWritersPostsQuery = <
      TData = GQLTotalAllWritersPostsQuery,
      TError = unknown
    >(
      variables?: GQLTotalAllWritersPostsQueryVariables,
      options?: UseQueryOptions<GQLTotalAllWritersPostsQuery, TError, TData>
    ) =>
    useQuery<GQLTotalAllWritersPostsQuery, TError, TData>(
      variables === undefined ? ['totalAllWritersPosts'] : ['totalAllWritersPosts', variables],
      fetchData<GQLTotalAllWritersPostsQuery, GQLTotalAllWritersPostsQueryVariables>(TotalAllWritersPostsDocument, variables),
      options
    );
export const UserBySlugDocument = `
    query userBySlug($nicknameSlug: String) {
  user(nicknameSlug: $nicknameSlug) {
    id
    name
    nickname
    nicknameSlug
    position
    bio
  }
}
    `;
export const useUserBySlugQuery = <
      TData = GQLUserBySlugQuery,
      TError = unknown
    >(
      variables?: GQLUserBySlugQueryVariables,
      options?: UseQueryOptions<GQLUserBySlugQuery, TError, TData>
    ) =>
    useQuery<GQLUserBySlugQuery, TError, TData>(
      variables === undefined ? ['userBySlug'] : ['userBySlug', variables],
      fetchData<GQLUserBySlugQuery, GQLUserBySlugQueryVariables>(UserBySlugDocument, variables),
      options
    );
export const PostByIdDocument = `
    query PostById($id: Int) {
  post(id: $id) {
    excerpt
    title
    body
    categoryId
    languages
    createdAt
    updatedAt
    publishedAt
    related {
      title
      url {
        isMain
        main {
          url
        }
        url
      }
    }
    translations {
      key
      value
      language
    }
    image {
      id
      path
      fullPath
      caption
    }
    tags {
      id
      name
      slug
      isPublished
    }
    urls {
      isMain
      language
      main {
        url
      }
      url
    }
    url {
      isMain
      language
      main {
        url
      }
      url
    }
    metatags {
      key
      value
    }
    writerUser {
      id
      name
      nickname
      nicknameSlug
      bio
      position
    }
    editorUser {
      id
      name
      nickname
      nicknameSlug
      bio
      position
    }
  }
}
    `;
export const usePostByIdQuery = <
      TData = GQLPostByIdQuery,
      TError = unknown
    >(
      variables?: GQLPostByIdQueryVariables,
      options?: UseQueryOptions<GQLPostByIdQuery, TError, TData>
    ) =>
    useQuery<GQLPostByIdQuery, TError, TData>(
      variables === undefined ? ['PostById'] : ['PostById', variables],
      fetchData<GQLPostByIdQuery, GQLPostByIdQueryVariables>(PostByIdDocument, variables),
      options
    );
export const RecentPostsByCategoryDocument = `
    query recentPostsByCategory($limit: [Int], $offset: [Int], $domainId: Int, $published: Boolean, $categoryId: Int) {
  allPosts(
    limit: $limit
    offset: $offset
    categoryId: $categoryId
    published: $published
    isDeleted: false
    orderByDesc: createdAt
    domainId: $domainId
  ) {
    id
    domainId
    categoryId
    title
    translations {
      key
      value
      language
    }
    url {
      id
      modelId
      title
      language
      isActive
      url
      isMain
      main {
        url
      }
    }
  }
}
    `;
export const useRecentPostsByCategoryQuery = <
      TData = GQLRecentPostsByCategoryQuery,
      TError = unknown
    >(
      variables?: GQLRecentPostsByCategoryQueryVariables,
      options?: UseQueryOptions<GQLRecentPostsByCategoryQuery, TError, TData>
    ) =>
    useQuery<GQLRecentPostsByCategoryQuery, TError, TData>(
      variables === undefined ? ['recentPostsByCategory'] : ['recentPostsByCategory', variables],
      fetchData<GQLRecentPostsByCategoryQuery, GQLRecentPostsByCategoryQueryVariables>(RecentPostsByCategoryDocument, variables),
      options
    );
export const TagBySlugDocument = `
    query tagBySlug($slug: String, $limit: [Int], $offset: [Int], $domainId: Int, $typeId: Int) {
  tag(slug: $slug, isDeleted: false, type: "post") {
    id
    name
    posts(
      limit: $limit
      offset: $offset
      typeId: $typeId
      published: true
      isDeleted: false
      domainId: $domainId
      orderByDesc: createdAt
    ) {
      id
      title
      translations {
        key
        value
        language
      }
      image {
        fullPath
      }
      tags {
        name
      }
      url {
        id
        title
        language
        isActive
        url
        isMain
        main {
          url
        }
      }
    }
  }
}
    `;
export const useTagBySlugQuery = <
      TData = GQLTagBySlugQuery,
      TError = unknown
    >(
      variables?: GQLTagBySlugQueryVariables,
      options?: UseQueryOptions<GQLTagBySlugQuery, TError, TData>
    ) =>
    useQuery<GQLTagBySlugQuery, TError, TData>(
      variables === undefined ? ['tagBySlug'] : ['tagBySlug', variables],
      fetchData<GQLTagBySlugQuery, GQLTagBySlugQueryVariables>(TagBySlugDocument, variables),
      options
    );
export const TextBlocksDocument = `
    query textBlocks($offers: JSON) {
  allTextBlocks(offerIds: $offers, isDeleted: false) {
    text
    translations {
      key
      value
      language
    }
  }
}
    `;
export const useTextBlocksQuery = <
      TData = GQLTextBlocksQuery,
      TError = unknown
    >(
      variables?: GQLTextBlocksQueryVariables,
      options?: UseQueryOptions<GQLTextBlocksQuery, TError, TData>
    ) =>
    useQuery<GQLTextBlocksQuery, TError, TData>(
      variables === undefined ? ['textBlocks'] : ['textBlocks', variables],
      fetchData<GQLTextBlocksQuery, GQLTextBlocksQueryVariables>(TextBlocksDocument, variables),
      options
    );